(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8upap", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);

var $7eDcu = parcelRequire("7eDcu");

var $ibaza = parcelRequire("ibaza");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $7eDcu.isBrowserBundle)() && Object.prototype.toString.call(typeof $ibaza !== 'undefined' ? $ibaza : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, 'process');
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("7eDcu", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $54483f9c35a67705$export$2928c40372e623c0);
$parcel$export(module.exports, "getSDKSource", () => $54483f9c35a67705$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $54483f9c35a67705$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $54483f9c35a67705$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = 'browser';
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ''; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3c1734dacb01657$var$process.cwd = function() {
    return '/';
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $64f3c3749eafb7b0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $4e20afe4f778c343$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $4e20afe4f778c343$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $4e20afe4f778c343$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $4e20afe4f778c343$var$isGlobalObj(window) || typeof self == 'object' && $4e20afe4f778c343$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $4e20afe4f778c343$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $4e20afe4f778c343$export$256479dc0cea61c4() {
    return $4e20afe4f778c343$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $4e20afe4f778c343$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $4e20afe4f778c343$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}


/** Prefix for logging strings */ const $54d1043b2228e29f$var$PREFIX = 'Sentry Logger ';
const $54d1043b2228e29f$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $54d1043b2228e29f$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $54d1043b2228e29f$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($54d1043b2228e29f$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $54d1043b2228e29f$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $54d1043b2228e29f$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $64f3c3749eafb7b0$export$16a28057038b10ef) $54d1043b2228e29f$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $54d1043b2228e29f$export$cda52e2a8927a2ca(()=>{
                (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).console[name](`${$54d1043b2228e29f$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $54d1043b2228e29f$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $54d1043b2228e29f$export$af88d00dbe7f521 = $54d1043b2228e29f$var$makeLogger();


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $935d737b44cdff44$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $9596c1ede1884e50$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $9596c1ede1884e50$export$7740643b9eeaf0c4() {
    return Date.now() / $9596c1ede1884e50$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $9596c1ede1884e50$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $9596c1ede1884e50$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $9596c1ede1884e50$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $9596c1ede1884e50$export$ee52dced521e3e18 = $9596c1ede1884e50$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $9596c1ede1884e50$export$c5907b5a8838db13 = $9596c1ede1884e50$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $9596c1ede1884e50$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $9596c1ede1884e50$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $9596c1ede1884e50$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $9596c1ede1884e50$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $9596c1ede1884e50$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $9596c1ede1884e50$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

// eslint-disable-next-line @typescript-eslint/unbound-method
const $4431a087fbf663bd$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$e6127cc7fe7395c3(wat) {
    switch($4431a087fbf663bd$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $4431a087fbf663bd$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$var$isBuiltin(wat, className) {
    return $4431a087fbf663bd$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$9f9636d330b71954(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$ef9e2056653f0c8e(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$12e869b2a583f783(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$844ec244b1367d54(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$c3825b437cbdea5c(wat) {
    return wat === null || $4431a087fbf663bd$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$53b83ca8eaab0383(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $4431a087fbf663bd$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $4431a087fbf663bd$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$49841c62b9eff15(wat) {
    return $4431a087fbf663bd$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $4431a087fbf663bd$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$bc2894c7158efbac(wat) {
    return $4431a087fbf663bd$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4431a087fbf663bd$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}



// eslint-disable-next-line deprecation/deprecation
const $a9dceb93bbd7f017$var$WINDOW = (0, $4e20afe4f778c343$export$256479dc0cea61c4)();
const $a9dceb93bbd7f017$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a9dceb93bbd7f017$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $a9dceb93bbd7f017$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $a9dceb93bbd7f017$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a9dceb93bbd7f017$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($a9dceb93bbd7f017$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $4431a087fbf663bd$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $a9dceb93bbd7f017$export$1cfafeee2987818b() {
    try {
        return $a9dceb93bbd7f017$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a9dceb93bbd7f017$export$c660c1f3ab49225c(selector) {
    if ($a9dceb93bbd7f017$var$WINDOW.document && $a9dceb93bbd7f017$var$WINDOW.document.querySelector) return $a9dceb93bbd7f017$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $a9dceb93bbd7f017$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$a9dceb93bbd7f017$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $e6e4baebb92dff28$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $e6e4baebb92dff28$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e6e4baebb92dff28$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $4431a087fbf663bd$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $e6e4baebb92dff28$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $4431a087fbf663bd$export$844ec244b1367d54)(value)) return false;
    if ((0, $4431a087fbf663bd$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $4431a087fbf663bd$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $e6e4baebb92dff28$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$e6e4baebb92dff28$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $89b84fdfd1cfae9c$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $89b84fdfd1cfae9c$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $89b84fdfd1cfae9c$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $64f3c3749eafb7b0$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $89b84fdfd1cfae9c$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $89b84fdfd1cfae9c$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $89b84fdfd1cfae9c$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $89b84fdfd1cfae9c$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $89b84fdfd1cfae9c$export$62ff257738bf57f5(value) {
    if ((0, $4431a087fbf663bd$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$89b84fdfd1cfae9c$var$getOwnProperties(value)
    };
    else if ((0, $4431a087fbf663bd$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $89b84fdfd1cfae9c$var$serializeEventTarget(value.target),
            currentTarget: $89b84fdfd1cfae9c$var$serializeEventTarget(value.currentTarget),
            ...$89b84fdfd1cfae9c$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $4431a087fbf663bd$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $89b84fdfd1cfae9c$var$serializeEventTarget(target) {
    try {
        return (0, $4431a087fbf663bd$export$45a5e7f76e0caa8d)(target) ? (0, $a9dceb93bbd7f017$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $89b84fdfd1cfae9c$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $89b84fdfd1cfae9c$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($89b84fdfd1cfae9c$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $e6e4baebb92dff28$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $e6e4baebb92dff28$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $89b84fdfd1cfae9c$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $89b84fdfd1cfae9c$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $89b84fdfd1cfae9c$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($89b84fdfd1cfae9c$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $89b84fdfd1cfae9c$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($89b84fdfd1cfae9c$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $89b84fdfd1cfae9c$var$isPojo(input) {
    if (!(0, $4431a087fbf663bd$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $89b84fdfd1cfae9c$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $4431a087fbf663bd$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $0820bb2e6cc9979f$export$19f53698e68b2496() {
    const gbl = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $0820bb2e6cc9979f$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $0820bb2e6cc9979f$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $0820bb2e6cc9979f$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $0820bb2e6cc9979f$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $0820bb2e6cc9979f$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $0820bb2e6cc9979f$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $0820bb2e6cc9979f$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $0820bb2e6cc9979f$export$d364f2020ab30578(input) {
    const match = input.match($0820bb2e6cc9979f$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $0820bb2e6cc9979f$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $e6e4baebb92dff28$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $e6e4baebb92dff28$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $e6e4baebb92dff28$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $0820bb2e6cc9979f$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $89b84fdfd1cfae9c$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $0820bb2e6cc9979f$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $68ed1fdd5bcea908$export$849dbeeeda01ae98 = 'production';





/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $d300f9ef2197f7c0$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($d300f9ef2197f7c0$var$States || ($d300f9ef2197f7c0$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $d300f9ef2197f7c0$export$1fda8aa4d135f8aa(value) {
    return new $d300f9ef2197f7c0$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $d300f9ef2197f7c0$export$78e43115b553f358(reason) {
    return new $d300f9ef2197f7c0$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $d300f9ef2197f7c0$export$6f292d4960313241 {
    constructor(executor){
        $d300f9ef2197f7c0$export$6f292d4960313241.prototype.__init.call(this);
        $d300f9ef2197f7c0$export$6f292d4960313241.prototype.__init2.call(this);
        $d300f9ef2197f7c0$export$6f292d4960313241.prototype.__init3.call(this);
        $d300f9ef2197f7c0$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $d300f9ef2197f7c0$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $d300f9ef2197f7c0$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $d300f9ef2197f7c0$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($d300f9ef2197f7c0$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($d300f9ef2197f7c0$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $d300f9ef2197f7c0$var$States.PENDING) return;
            if ((0, $4431a087fbf663bd$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $d300f9ef2197f7c0$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $d300f9ef2197f7c0$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $d300f9ef2197f7c0$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $f67cb60f8b7520b8$export$3c4238858b85e8ac() {
    return (0, $4e20afe4f778c343$export$7e223ec222791509)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $f67cb60f8b7520b8$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $f67cb60f8b7520b8$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $f67cb60f8b7520b8$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $d300f9ef2197f7c0$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $935d737b44cdff44$export$16a28057038b10ef) && processor.id && result === null && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $4431a087fbf663bd$export$f5b060c2914b97c8)(result)) result.then((final)=>$f67cb60f8b7520b8$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $f67cb60f8b7520b8$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $68d2f9a36f0e7f5b$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $9596c1ede1884e50$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $0820bb2e6cc9979f$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$68d2f9a36f0e7f5b$var$sessionToJSON(session)
    };
    if (context) $68d2f9a36f0e7f5b$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $68d2f9a36f0e7f5b$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $9596c1ede1884e50$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $0820bb2e6cc9979f$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $68d2f9a36f0e7f5b$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $68d2f9a36f0e7f5b$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $68d2f9a36f0e7f5b$var$sessionToJSON(session) {
    return (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}











/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $651d1743a990a360$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $a75eb0382444770c$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $a75eb0382444770c$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $a75eb0382444770c$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $4e39c8ebcb5dcbe2$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $4e39c8ebcb5dcbe2$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $4e39c8ebcb5dcbe2$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $4e39c8ebcb5dcbe2$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $4e39c8ebcb5dcbe2$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($4e39c8ebcb5dcbe2$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $4e39c8ebcb5dcbe2$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $4e39c8ebcb5dcbe2$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $4e39c8ebcb5dcbe2$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $4e39c8ebcb5dcbe2$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $4e39c8ebcb5dcbe2$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($4e39c8ebcb5dcbe2$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($4e39c8ebcb5dcbe2$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $4e39c8ebcb5dcbe2$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $4e39c8ebcb5dcbe2$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $4e39c8ebcb5dcbe2$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $4e39c8ebcb5dcbe2$var$defaultFunctionName;
        return fn.name || $4e39c8ebcb5dcbe2$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $4e39c8ebcb5dcbe2$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $4e39c8ebcb5dcbe2$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $a75eb0382444770c$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e1a46ce691765a57$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $e1a46ce691765a57$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $e1a46ce691765a57$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $e1a46ce691765a57$export$a3295358bff77e(object, depth);
    if ($e1a46ce691765a57$var$jsonSize(normalized) > maxSize) return $e1a46ce691765a57$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $e1a46ce691765a57$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $651d1743a990a360$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $4431a087fbf663bd$export$c9f5652083b8129d)(value)) return value;
    const stringified = $e1a46ce691765a57$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $e1a46ce691765a57$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $89b84fdfd1cfae9c$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $e1a46ce691765a57$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $e1a46ce691765a57$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $4431a087fbf663bd$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $4431a087fbf663bd$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $4e39c8ebcb5dcbe2$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $e1a46ce691765a57$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $e1a46ce691765a57$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $e1a46ce691765a57$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e1a46ce691765a57$var$jsonSize(value) {
    return $e1a46ce691765a57$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $e1a46ce691765a57$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}









const $7118b85cc7face33$export$9ca9946bd449ac06 = 'baggage';
const $7118b85cc7face33$export$6e69537d67fa20f = 'sentry-';
const $7118b85cc7face33$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $7118b85cc7face33$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $7118b85cc7face33$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $4431a087fbf663bd$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $7118b85cc7face33$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $7118b85cc7face33$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($7118b85cc7face33$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($7118b85cc7face33$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $7118b85cc7face33$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$7118b85cc7face33$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $7118b85cc7face33$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $7118b85cc7face33$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $7118b85cc7face33$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $7118b85cc7face33$export$bdd844ddb2def819) {
            (0, $64f3c3749eafb7b0$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $fec4413c5c229d86$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $fec4413c5c229d86$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($fec4413c5c229d86$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $fec4413c5c229d86$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $fec4413c5c229d86$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $7118b85cc7face33$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $0820bb2e6cc9979f$export$19f53698e68b2496)(),
            spanId: (0, $0820bb2e6cc9979f$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $0820bb2e6cc9979f$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $0820bb2e6cc9979f$export$19f53698e68b2496)().substring(16),
            spanId: (0, $0820bb2e6cc9979f$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $fec4413c5c229d86$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $fec4413c5c229d86$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $7118b85cc7face33$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $0820bb2e6cc9979f$export$19f53698e68b2496)(),
        spanId: (0, $0820bb2e6cc9979f$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $0820bb2e6cc9979f$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $0820bb2e6cc9979f$export$19f53698e68b2496)().substring(16),
        spanId: (0, $0820bb2e6cc9979f$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $fec4413c5c229d86$export$f35d907436da45cf(traceId = (0, $0820bb2e6cc9979f$export$19f53698e68b2496)(), spanId = (0, $0820bb2e6cc9979f$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $43985f001f6f055c$export$208d5b368507fb8b = 0x0;
const $43985f001f6f055c$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $43985f001f6f055c$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $43985f001f6f055c$export$92d8c23565496537(span);
    return (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $43985f001f6f055c$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $43985f001f6f055c$export$5caecac1caaf3a71(span);
    return (0, $fec4413c5c229d86$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $43985f001f6f055c$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $43985f001f6f055c$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $43985f001f6f055c$var$ensureTimestampInSeconds(input.getTime());
    return (0, $9596c1ede1884e50$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $43985f001f6f055c$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $43985f001f6f055c$export$92d8c23565496537(span) {
    if ($43985f001f6f055c$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $43985f001f6f055c$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $43985f001f6f055c$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $43985f001f6f055c$export$eb571cd9b5d98de8);
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $c16ffd4bab406a01$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $0820bb2e6cc9979f$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $9596c1ede1884e50$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $c16ffd4bab406a01$var$applyClientOptions(prepared, options);
    $c16ffd4bab406a01$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $c16ffd4bab406a01$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $c16ffd4bab406a01$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $0820bb2e6cc9979f$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $fea1758a069db795$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $67eff3964b7008cc$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $67eff3964b7008cc$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $67eff3964b7008cc$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $f67cb60f8b7520b8$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $f67cb60f8b7520b8$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $c16ffd4bab406a01$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $c16ffd4bab406a01$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $c16ffd4bab406a01$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $68ed1fdd5bcea908$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $e6e4baebb92dff28$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $e6e4baebb92dff28$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $e6e4baebb92dff28$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $c16ffd4bab406a01$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $c16ffd4bab406a01$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $c16ffd4bab406a01$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $c16ffd4bab406a01$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $c16ffd4bab406a01$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $c16ffd4bab406a01$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $c16ffd4bab406a01$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $e1a46ce691765a57$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $e1a46ce691765a57$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $e1a46ce691765a57$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $e1a46ce691765a57$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $e1a46ce691765a57$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $43985f001f6f055c$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $e1a46ce691765a57$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $c16ffd4bab406a01$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $fea1758a069db795$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $c16ffd4bab406a01$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($c16ffd4bab406a01$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($c16ffd4bab406a01$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $c16ffd4bab406a01$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $fea1758a069db795$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $c16ffd4bab406a01$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $c16ffd4bab406a01$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$c16ffd4bab406a01$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $2dfa7d22514dae4c$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().captureException(exception, (0, $c16ffd4bab406a01$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $2dfa7d22514dae4c$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $2dfa7d22514dae4c$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $2dfa7d22514dae4c$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $2dfa7d22514dae4c$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $2dfa7d22514dae4c$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $2dfa7d22514dae4c$export$9a4fed82c350c2bd(callback) {
    return (0, $c4ea612155b0bcfa$export$70d775fb1f267027)(()=>{
        return callback((0, $c4ea612155b0bcfa$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $2dfa7d22514dae4c$export$e57ac09b143d92a2(span, callback) {
    return $2dfa7d22514dae4c$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $2dfa7d22514dae4c$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $2dfa7d22514dae4c$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $2dfa7d22514dae4c$export$c7be4b0125a10cba();
    const client = $2dfa7d22514dae4c$export$6bb76d6eba7e258c();
    if (!client) (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $0820bb2e6cc9979f$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $2dfa7d22514dae4c$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $2dfa7d22514dae4c$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $9596c1ede1884e50$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $2dfa7d22514dae4c$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $9596c1ede1884e50$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $4431a087fbf663bd$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $2dfa7d22514dae4c$export$4909b86c8034bf73(timeout) {
    const client = $2dfa7d22514dae4c$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $2dfa7d22514dae4c$export$8360e631d277ea4d(timeout) {
    const client = $2dfa7d22514dae4c$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $2dfa7d22514dae4c$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $2dfa7d22514dae4c$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $2dfa7d22514dae4c$export$3f95c6f800b78024() {
    return !!$2dfa7d22514dae4c$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $2dfa7d22514dae4c$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $2dfa7d22514dae4c$export$c0d84948cecf78d8(context) {
    const client = $2dfa7d22514dae4c$export$6bb76d6eba7e258c();
    const isolationScope = (0, $c4ea612155b0bcfa$export$68f3af03034c9e90)();
    const currentScope = $2dfa7d22514dae4c$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $68ed1fdd5bcea908$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $68d2f9a36f0e7f5b$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $68d2f9a36f0e7f5b$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $2dfa7d22514dae4c$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $2dfa7d22514dae4c$export$17a5be43989a0bc1() {
    const isolationScope = (0, $c4ea612155b0bcfa$export$68f3af03034c9e90)();
    const currentScope = $2dfa7d22514dae4c$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $68d2f9a36f0e7f5b$export$56521d9ba90f62ee)(session);
    $2dfa7d22514dae4c$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $2dfa7d22514dae4c$var$_sendSessionUpdate() {
    const isolationScope = (0, $c4ea612155b0bcfa$export$68f3af03034c9e90)();
    const currentScope = $2dfa7d22514dae4c$export$c7be4b0125a10cba();
    const client = $2dfa7d22514dae4c$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $2dfa7d22514dae4c$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $2dfa7d22514dae4c$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $2dfa7d22514dae4c$var$_sendSessionUpdate();
}


/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $fdbabc346cde48ce$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}



/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $da440eefa7483dd5$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)({
        environment: options.environment || (0, $68ed1fdd5bcea908$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $da440eefa7483dd5$export$a117f995597e25df(span) {
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $da440eefa7483dd5$export$366bad00d6815eed((0, $43985f001f6f055c$export$92d8c23565496537)(span).trace_id || '', client, (0, $2dfa7d22514dae4c$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $fdbabc346cde48ce$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $43985f001f6f055c$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $43985f001f6f055c$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $67eff3964b7008cc$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $67eff3964b7008cc$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $67eff3964b7008cc$var$applySpanToEvent(event, span);
    $67eff3964b7008cc$var$applyFingerprintToEvent(event, fingerprint);
    $67eff3964b7008cc$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $67eff3964b7008cc$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $67eff3964b7008cc$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $67eff3964b7008cc$export$b1a120a2871faa46(data, 'extra', extra);
    $67eff3964b7008cc$export$b1a120a2871faa46(data, 'tags', tags);
    $67eff3964b7008cc$export$b1a120a2871faa46(data, 'user', user);
    $67eff3964b7008cc$export$b1a120a2871faa46(data, 'contexts', contexts);
    $67eff3964b7008cc$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $67eff3964b7008cc$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $67eff3964b7008cc$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $67eff3964b7008cc$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $67eff3964b7008cc$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $67eff3964b7008cc$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $43985f001f6f055c$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $fdbabc346cde48ce$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $da440eefa7483dd5$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $43985f001f6f055c$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $67eff3964b7008cc$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $0820bb2e6cc9979f$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $fea1758a069db795$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $fea1758a069db795$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $fea1758a069db795$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $fea1758a069db795$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $fea1758a069db795$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $fea1758a069db795$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $68d2f9a36f0e7f5b$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $fea1758a069db795$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $4431a087fbf663bd$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $fea1758a069db795$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $fea1758a069db795$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $9596c1ede1884e50$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $67eff3964b7008cc$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $f67cb60f8b7520b8$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $f67cb60f8b7520b8$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $0820bb2e6cc9979f$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $0820bb2e6cc9979f$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $0820bb2e6cc9979f$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $fea1758a069db795$export$aa55d5ab8e05984f() {
    if (!$fea1758a069db795$var$globalScope) $fea1758a069db795$var$globalScope = new $fea1758a069db795$export$775b6bb06e53a214();
    return $fea1758a069db795$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $fea1758a069db795$export$c83048efd17527d6(scope) {
    $fea1758a069db795$var$globalScope = scope;
}
function $fea1758a069db795$var$generatePropagationContext() {
    return {
        traceId: (0, $0820bb2e6cc9979f$export$19f53698e68b2496)(),
        spanId: (0, $0820bb2e6cc9979f$export$19f53698e68b2496)().substring(16)
    };
}



const $8663cc950bc5605c$export$31499a9cd224b78c = '7.120.3';


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $c4ea612155b0bcfa$export$24a86ef7798177e4 = parseFloat((0, $8663cc950bc5605c$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $c4ea612155b0bcfa$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $c4ea612155b0bcfa$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $c4ea612155b0bcfa$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $fea1758a069db795$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $fea1758a069db795$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $4431a087fbf663bd$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $0820bb2e6cc9979f$export$19f53698e68b2496)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $0820bb2e6cc9979f$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $0820bb2e6cc9979f$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $c4ea612155b0bcfa$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $9596c1ede1884e50$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $54d1043b2228e29f$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $c4ea612155b0bcfa$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $c4ea612155b0bcfa$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $935d737b44cdff44$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $68d2f9a36f0e7f5b$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $68ed1fdd5bcea908$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $68d2f9a36f0e7f5b$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $68d2f9a36f0e7f5b$export$531818e825e774db)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $c4ea612155b0bcfa$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $c4ea612155b0bcfa$export$19eade501500c6c1() {
    (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $4e20afe4f778c343$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $c4ea612155b0bcfa$export$4188a14ad302d1bc(hub) {
    const registry = $c4ea612155b0bcfa$export$19eade501500c6c1();
    const oldHub = $c4ea612155b0bcfa$export$bfa8a924a84a76b7(registry);
    $c4ea612155b0bcfa$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $c4ea612155b0bcfa$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $c4ea612155b0bcfa$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $c4ea612155b0bcfa$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $c4ea612155b0bcfa$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $c4ea612155b0bcfa$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $c4ea612155b0bcfa$var$getGlobalHub(registry = $c4ea612155b0bcfa$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$c4ea612155b0bcfa$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $c4ea612155b0bcfa$export$bfa8a924a84a76b7(registry).isOlderThan($c4ea612155b0bcfa$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $c4ea612155b0bcfa$export$849f05434e95d2f2(registry, new $c4ea612155b0bcfa$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $c4ea612155b0bcfa$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $c4ea612155b0bcfa$export$236689a79f5aa020(carrier, parent = $c4ea612155b0bcfa$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$c4ea612155b0bcfa$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $c4ea612155b0bcfa$export$bfa8a924a84a76b7(carrier).isOlderThan($c4ea612155b0bcfa$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $c4ea612155b0bcfa$export$849f05434e95d2f2(carrier, new $c4ea612155b0bcfa$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $c4ea612155b0bcfa$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $c4ea612155b0bcfa$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $c4ea612155b0bcfa$export$70d775fb1f267027(callback, options = {}) {
    const registry = $c4ea612155b0bcfa$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $c4ea612155b0bcfa$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $c4ea612155b0bcfa$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $4e20afe4f778c343$export$7e223ec222791509)('hub', ()=>new $c4ea612155b0bcfa$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $c4ea612155b0bcfa$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}







// We keep the handlers globally
const $f5968277b08509e3$var$handlers = {};
const $f5968277b08509e3$var$instrumented = {};
/** Add a handler function. */ function $f5968277b08509e3$export$a4e09611e30da72e(type, handler) {
    $f5968277b08509e3$var$handlers[type] = $f5968277b08509e3$var$handlers[type] || [];
    $f5968277b08509e3$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $f5968277b08509e3$export$b17eab759a1cb5fe() {
    Object.keys($f5968277b08509e3$var$handlers).forEach((key)=>{
        $f5968277b08509e3$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $f5968277b08509e3$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$f5968277b08509e3$var$instrumented[type]) {
        instrumentFn();
        $f5968277b08509e3$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $f5968277b08509e3$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $f5968277b08509e3$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $64f3c3749eafb7b0$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $4e39c8ebcb5dcbe2$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


let $b401474715fe56c0$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $b401474715fe56c0$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $f5968277b08509e3$export$a4e09611e30da72e)(type, handler);
    (0, $f5968277b08509e3$export$e18d6c5462c01368)(type, $b401474715fe56c0$var$instrumentError);
}
function $b401474715fe56c0$var$instrumentError() {
    $b401474715fe56c0$var$_oldOnErrorHandler = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).onerror;
    (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $f5968277b08509e3$export$b18c893e424d3127)('error', handlerData);
        if ($b401474715fe56c0$var$_oldOnErrorHandler && !$b401474715fe56c0$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $b401474715fe56c0$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $3c7bd95e794e060c$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3c7bd95e794e060c$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $f5968277b08509e3$export$a4e09611e30da72e)(type, handler);
    (0, $f5968277b08509e3$export$e18d6c5462c01368)(type, $3c7bd95e794e060c$var$instrumentUnhandledRejection);
}
function $3c7bd95e794e060c$var$instrumentUnhandledRejection() {
    $3c7bd95e794e060c$var$_oldOnUnhandledRejectionHandler = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $f5968277b08509e3$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($3c7bd95e794e060c$var$_oldOnUnhandledRejectionHandler && !$3c7bd95e794e060c$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $3c7bd95e794e060c$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $ec5c60089c625009$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $ec5c60089c625009$export$8e9a29865c0a1226 = (0, $fec4413c5c229d86$export$8e9a29865c0a1226);


let $26543c4661b2770c$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $26543c4661b2770c$export$637857c1d87b640c() {
    if ($26543c4661b2770c$var$errorsInstrumented) return;
    $26543c4661b2770c$var$errorsInstrumented = true;
    (0, $b401474715fe56c0$export$55b5c3ba2194f0c6)($26543c4661b2770c$var$errorCallback);
    (0, $3c7bd95e794e060c$export$8bf4fc6858821a4e)($26543c4661b2770c$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $26543c4661b2770c$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $ec5c60089c625009$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = 'internal_error';
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$26543c4661b2770c$var$errorCallback.tag = 'sentry_tracingErrorCallback';




















/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $6cc095a8dfcad8ad$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $6cc095a8dfcad8ad$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $6cc095a8dfcad8ad$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $4431a087fbf663bd$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $27fce64c83dee28f$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $3606f142dfccb1dc$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)();
    const scope = (0, $2dfa7d22514dae4c$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $3606f142dfccb1dc$var$normalizeContext(context);
    const activeSpan = $3606f142dfccb1dc$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $6cc095a8dfcad8ad$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus('internal_error');
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $3606f142dfccb1dc$export$a1bd95187356f372(context, callback) {
    const spanContext = $3606f142dfccb1dc$var$normalizeContext(context);
    return (0, $c4ea612155b0bcfa$export$70d775fb1f267027)(()=>{
        return (0, $2dfa7d22514dae4c$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $3606f142dfccb1dc$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $6cc095a8dfcad8ad$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $43985f001f6f055c$export$92d8c23565496537)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $3606f142dfccb1dc$export$cb9e396e6b90b703 = $3606f142dfccb1dc$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $3606f142dfccb1dc$export$c10292ad04b92aea(context, callback) {
    const spanContext = $3606f142dfccb1dc$var$normalizeContext(context);
    return (0, $c4ea612155b0bcfa$export$70d775fb1f267027)(()=>{
        return (0, $2dfa7d22514dae4c$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $3606f142dfccb1dc$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $6cc095a8dfcad8ad$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $43985f001f6f055c$export$92d8c23565496537)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $3606f142dfccb1dc$export$63dbba021a6b4047(context) {
    if (!(0, $27fce64c83dee28f$export$5008da00b1b6dee6)()) return undefined;
    const spanContext = $3606f142dfccb1dc$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)();
    const parentSpan = context.scope ? context.scope.getSpan() : $3606f142dfccb1dc$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $2dfa7d22514dae4c$export$c7be4b0125a10cba)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $3606f142dfccb1dc$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $3606f142dfccb1dc$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $2dfa7d22514dae4c$export$c7be4b0125a10cba)().getSpan();
}
const $3606f142dfccb1dc$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $2dfa7d22514dae4c$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $fec4413c5c229d86$export$ca5c066532785b6e)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $935d737b44cdff44$export$16a28057038b10ef) && traceparentData) (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $c4ea612155b0bcfa$export$70d775fb1f267027)(()=>{
        return callback(transactionContext);
    });
};
function $3606f142dfccb1dc$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $27fce64c83dee28f$export$5008da00b1b6dee6)()) return undefined;
    const isolationScope = (0, $c4ea612155b0bcfa$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $da440eefa7483dd5$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $43985f001f6f055c$export$5caecac1caaf3a71)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $3606f142dfccb1dc$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $3606f142dfccb1dc$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $43985f001f6f055c$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $3606f142dfccb1dc$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $3606f142dfccb1dc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
function $3606f142dfccb1dc$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $89b84fdfd1cfae9c$export$e73679ffaf56810e)(span, $3606f142dfccb1dc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $89b84fdfd1cfae9c$export$e73679ffaf56810e)(span, $3606f142dfccb1dc$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $3606f142dfccb1dc$export$c08fbc656a245d03(span) {
    return {
        scope: span[$3606f142dfccb1dc$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$3606f142dfccb1dc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $27961ce52b7be41f$var$SPAN_METRIC_SUMMARY;
function $27961ce52b7be41f$var$getMetricStorageForSpan(span) {
    return $27961ce52b7be41f$var$SPAN_METRIC_SUMMARY ? $27961ce52b7be41f$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $27961ce52b7be41f$export$2e7205e45c58797d(span) {
    const storage = $27961ce52b7be41f$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $27961ce52b7be41f$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $3606f142dfccb1dc$export$1be426a8e585c83e)();
    if (span) {
        const storage = $27961ce52b7be41f$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$27961ce52b7be41f$var$SPAN_METRIC_SUMMARY) $27961ce52b7be41f$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $27961ce52b7be41f$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $2296c04c99eaa4ca$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $2296c04c99eaa4ca$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $2296c04c99eaa4ca$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $2296c04c99eaa4ca$export$cca8dd30f57f805e = 'sentry.origin';
/**
 * The id of the profile that this span occured in.
 */ const $2296c04c99eaa4ca$export$1efec95406bbe327 = 'profile_id';




/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $71514f5fada0e3ce$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = 'ok';
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = 'deadline_exceeded';
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = 'unauthenticated';
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = 'permission_denied';
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = 'not_found';
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = 'resource_exhausted';
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = 'invalid_argument';
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = 'unimplemented';
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = 'unavailable';
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = 'internal_error';
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = 'unknown_error';
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = 'cancelled';
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = 'already_exists';
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = 'failed_precondition';
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = 'aborted';
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = 'out_of_range';
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = 'data_loss';
    SpanStatus["DataLoss"] = DataLoss;
})($71514f5fada0e3ce$export$beb8e6a823e89c5d || ($71514f5fada0e3ce$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $71514f5fada0e3ce$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $71514f5fada0e3ce$export$ac65c70d78fcdb55 = $71514f5fada0e3ce$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $71514f5fada0e3ce$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag('http.status_code', String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData('http.response.status_code', httpStatus);
    const spanStatus = $71514f5fada0e3ce$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== 'unknown_error') span.setStatus(spanStatus);
}


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $8f015c96e068ddf8$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $8f015c96e068ddf8$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $0820bb2e6cc9979f$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $0820bb2e6cc9979f$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $9596c1ede1884e50$export$ee52dced521e3e18)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || 'sentry';
        this._attributes = {};
        this.setAttributes({
            [(0, $2296c04c99eaa4ca$export$cca8dd30f57f805e)]: spanContext.origin || 'manual',
            [(0, $2296c04c99eaa4ca$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || '';
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $2296c04c99eaa4ca$export$1a413bd9a88fdb09];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $2296c04c99eaa4ca$export$1a413bd9a88fdb09), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $2296c04c99eaa4ca$export$cca8dd30f57f805e];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $2296c04c99eaa4ca$export$cca8dd30f57f805e), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $43985f001f6f055c$export$eb571cd9b5d98de8) : (0, $43985f001f6f055c$export$208d5b368507fb8b)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $8f015c96e068ddf8$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $fdbabc346cde48ce$export$c4c6a79b1260ca1b)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $935d737b44cdff44$export$16a28057038b10ef) && rootSpan) {
            const opStr = spanContext && spanContext.op || '< unknown op >';
            const nameStr = (0, $43985f001f6f055c$export$92d8c23565496537)(childSpan).description || '< unknown name >';
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $71514f5fada0e3ce$export$2ad6630ec8164254)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === 'ok';
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $fdbabc346cde48ce$export$c4c6a79b1260ca1b)(this);
        if ((0, $935d737b44cdff44$export$16a28057038b10ef) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(logMessage.replace('Starting', 'Finishing'));
        }
        this._endTime = (0, $43985f001f6f055c$export$3f7581298f56c6d7)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $43985f001f6f055c$export$7e9f8ae9e4a328ab)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $43985f001f6f055c$export$46c6fbd1d265ebf0)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $2296c04c99eaa4ca$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $2296c04c99eaa4ca$export$cca8dd30f57f805e],
            _metrics_summary: (0, $27961ce52b7be41f$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $2296c04c99eaa4ca$export$1efec95406bbe327],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}











/** JSDoc */ class $cb7f9a312d79f6b4$export$febc5573c75cefb0 extends (0, $8f015c96e068ddf8$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || '';
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: 'custom',
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $2296c04c99eaa4ca$export$d7a7d984b0791405] && {
                source: this._attributes[0, $2296c04c99eaa4ca$export$d7a7d984b0791405]
            },
            ...this._attributes[0, $2296c04c99eaa4ca$export$ccfe0a40627cc34b] && {
                sampleRate: this._attributes[0, $2296c04c99eaa4ca$export$ccfe0a40627cc34b]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = 'custom') {
        this._name = name;
        this.setAttribute((0, $2296c04c99eaa4ca$export$d7a7d984b0791405), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $8f015c96e068ddf8$export$10c95c129cd0d4fe)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = '') {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $43985f001f6f055c$export$3f7581298f56c6d7)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || '';
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $da440eefa7483dd5$export$a117f995597e25df)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts['profile'] !== undefined) return this._contexts['profile'].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit('finishTransaction', this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $43985f001f6f055c$export$92d8c23565496537)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $43985f001f6f055c$export$92d8c23565496537)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $3606f142dfccb1dc$export$c08fbc656a245d03)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $43985f001f6f055c$export$46c6fbd1d265ebf0)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $da440eefa7483dd5$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $27961ce52b7be41f$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}


const $e819112de2b9f6c6$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $e819112de2b9f6c6$var$FINISH_REASON_TAG = 'finishReason';
const $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ class $e819112de2b9f6c6$export$370d6113c18ba86c extends (0, $8f015c96e068ddf8$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $43985f001f6f055c$export$92d8c23565496537)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $e819112de2b9f6c6$export$b279e6bd7040371f extends (0, $cb7f9a312d79f6b4$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $e819112de2b9f6c6$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $e819112de2b9f6c6$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $e819112de2b9f6c6$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus('deadline_exceeded');
                this._finishReason = $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $43985f001f6f055c$export$3f7581298f56c6d7)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === 'ui.action.click') this.setAttribute($e819112de2b9f6c6$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $935d737b44cdff44$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
            (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $43985f001f6f055c$export$92d8c23565496537)(span).timestamp) {
                    span.setStatus('cancelled');
                    span.end(endTimestampInS);
                    (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $43985f001f6f055c$export$92d8c23565496537)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $935d737b44cdff44$export$16a28057038b10ef) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Tracing] flushing IdleTransaction');
        } else (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $e819112de2b9f6c6$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Tracing] Received finish signal for idle transaction.');
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $9596c1ede1884e50$export$ee52dced521e3e18)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Tracing] Transaction finished because of no change for 3 heart beats');
                this.setStatus('deadline_exceeded');
                this._finishReason = $e819112de2b9f6c6$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}







/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $0e85ac4609e3131b$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $27fce64c83dee28f$export$5008da00b1b6dee6)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $2296c04c99eaa4ca$export$ccfe0a40627cc34b), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $2296c04c99eaa4ca$export$ccfe0a40627cc34b), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $2296c04c99eaa4ca$export$ccfe0a40627cc34b), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $2296c04c99eaa4ca$export$ccfe0a40627cc34b), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$0e85ac4609e3131b$export$2603c8d332a51c42(sampleRate)) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $935d737b44cdff44$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
    (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $43985f001f6f055c$export$92d8c23565496537)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $0e85ac4609e3131b$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $4431a087fbf663bd$export$c9f5652083b8129d)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}



/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $9cef8812405bf153$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        'sentry-trace': (0, $43985f001f6f055c$export$7e9f8ae9e4a328ab)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $9cef8812405bf153$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || 'sentry';
    const transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $cb7f9a312d79f6b4$export$febc5573c75cefb0)(transactionContext, this);
    transaction = (0, $0e85ac4609e3131b$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $9cef8812405bf153$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $e819112de2b9f6c6$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $0e85ac4609e3131b$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $9cef8812405bf153$export$653d0ef2bad9cdf9() {
    const carrier = (0, $c4ea612155b0bcfa$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $9cef8812405bf153$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $9cef8812405bf153$var$traceHeaders;
    (0, $26543c4661b2770c$export$637857c1d87b640c)();
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $c19fecb3210bca7d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






const $8afec3b77151cb8f$export$56d8a8a25bd48b81 = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $8e74d225bb62d30f$export$6f18f55521af71a1() {
    if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document) (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $ec5c60089c625009$export$a7feb32fdd923295)();
        if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = 'cancelled';
            const { op: op, status: status } = (0, $43985f001f6f055c$export$92d8c23565496537)(activeTransaction);
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.end();
        }
    });
    else (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}




const $7b7513317f3aade6$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $7f95c1862b128b5f$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d99d2cd5a5818608$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(const key in timing)if (key !== 'navigationStart' && key !== 'toJSON') // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $d99d2cd5a5818608$export$6431553786c94949 = ()=>{
    if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $d99d2cd5a5818608$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2c0acaa1cee7fc15$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $d99d2cd5a5818608$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b148181b8a6a8e84$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $d99d2cd5a5818608$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document && (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.prerendering || (0, $2c0acaa1cee7fc15$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $7f95c1862b128b5f$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $878bc14767ac8952$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7b22b521e987c1c9$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $616a74ac103e3781$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $b148181b8a6a8e84$export$3c29b44508a0612b)('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $878bc14767ac8952$export$d1203567a167490e)('layout-shift', handleEntries);
    if (po) {
        report = (0, $7b7513317f3aade6$export$17679dccdd551979)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $7b22b521e987c1c9$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $5e601800040eecc5$var$firstHiddenTime = -1;
const $5e601800040eecc5$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document && (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.visibilityState) $5e601800040eecc5$var$firstHiddenTime = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && !(0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $5e601800040eecc5$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $7b22b521e987c1c9$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $5e601800040eecc5$var$firstHiddenTime = timeStamp;
    }, true);
};
const $5e601800040eecc5$export$443f86b2c77012c4 = ()=>{
    if ($5e601800040eecc5$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $5e601800040eecc5$var$initHiddenTime();
        $5e601800040eecc5$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $5e601800040eecc5$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $43ca0f91ec0f5996$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $5e601800040eecc5$export$443f86b2c77012c4)();
    const metric = (0, $b148181b8a6a8e84$export$3c29b44508a0612b)('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $878bc14767ac8952$export$d1203567a167490e)('first-input', handleEntries);
    report = (0, $7b7513317f3aade6$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $7b22b521e987c1c9$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $0e3737a4cba67521$var$interactionCountEstimate = 0;
let $0e3737a4cba67521$var$minKnownInteractionId = Infinity;
let $0e3737a4cba67521$var$maxKnownInteractionId = 0;
const $0e3737a4cba67521$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $0e3737a4cba67521$var$minKnownInteractionId = Math.min($0e3737a4cba67521$var$minKnownInteractionId, e.interactionId);
            $0e3737a4cba67521$var$maxKnownInteractionId = Math.max($0e3737a4cba67521$var$maxKnownInteractionId, e.interactionId);
            $0e3737a4cba67521$var$interactionCountEstimate = $0e3737a4cba67521$var$maxKnownInteractionId ? ($0e3737a4cba67521$var$maxKnownInteractionId - $0e3737a4cba67521$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $0e3737a4cba67521$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $0e3737a4cba67521$export$8a962f2683a476d1 = ()=>{
    return $0e3737a4cba67521$var$po ? $0e3737a4cba67521$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $0e3737a4cba67521$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $0e3737a4cba67521$var$po) return;
    $0e3737a4cba67521$var$po = (0, $878bc14767ac8952$export$d1203567a167490e)('event', $0e3737a4cba67521$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $3ccc30bc8061eb73$var$getInteractionCountForNavigation = ()=>{
    return (0, $0e3737a4cba67521$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $3ccc30bc8061eb73$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $3ccc30bc8061eb73$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $3ccc30bc8061eb73$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $3ccc30bc8061eb73$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $3ccc30bc8061eb73$var$longestInteractionList[$3ccc30bc8061eb73$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $3ccc30bc8061eb73$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $3ccc30bc8061eb73$var$longestInteractionList.length < $3ccc30bc8061eb73$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $3ccc30bc8061eb73$var$longestInteractionMap[interaction.id] = interaction;
            $3ccc30bc8061eb73$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $3ccc30bc8061eb73$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $3ccc30bc8061eb73$var$longestInteractionList.splice($3ccc30bc8061eb73$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $3ccc30bc8061eb73$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $3ccc30bc8061eb73$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($3ccc30bc8061eb73$var$longestInteractionList.length - 1, Math.floor($3ccc30bc8061eb73$var$getInteractionCountForNavigation() / 50));
    return $3ccc30bc8061eb73$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $3ccc30bc8061eb73$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $0e3737a4cba67521$export$67d90cda6b78a2eb)();
    const metric = (0, $b148181b8a6a8e84$export$3c29b44508a0612b)('INP');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $3ccc30bc8061eb73$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === 'first-input') {
                const noMatchingEntry = !$3ccc30bc8061eb73$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $3ccc30bc8061eb73$var$processEntry(entry);
            }
        });
        const inp = $3ccc30bc8061eb73$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $878bc14767ac8952$export$d1203567a167490e)('event', handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $7b7513317f3aade6$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: 'first-input',
            buffered: true
        });
        (0, $7b22b521e987c1c9$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $3ccc30bc8061eb73$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $89b7eb81e7eb2d1b$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $89b7eb81e7eb2d1b$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $5e601800040eecc5$export$443f86b2c77012c4)();
    const metric = (0, $b148181b8a6a8e84$export$3c29b44508a0612b)('LCP');
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $2c0acaa1cee7fc15$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $878bc14767ac8952$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $7b7513317f3aade6$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$89b7eb81e7eb2d1b$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $89b7eb81e7eb2d1b$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach((type)=>{
            if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $7b22b521e987c1c9$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $3e42606ce4686bc2$var$whenReady = (callback)=>{
    if (!(0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document) return;
    if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.prerendering) addEventListener('prerenderingchange', ()=>$3e42606ce4686bc2$var$whenReady(callback), true);
    else if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.readyState !== 'complete') addEventListener('load', ()=>$3e42606ce4686bc2$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $3e42606ce4686bc2$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $b148181b8a6a8e84$export$3c29b44508a0612b)('TTFB');
    const report = (0, $7b7513317f3aade6$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $3e42606ce4686bc2$var$whenReady(()=>{
        const navEntry = (0, $d99d2cd5a5818608$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $2c0acaa1cee7fc15$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $962fbd100584c218$var$handlers = {};
const $962fbd100584c218$var$instrumented = {};
let $962fbd100584c218$var$_previousCls;
let $962fbd100584c218$var$_previousFid;
let $962fbd100584c218$var$_previousLcp;
let $962fbd100584c218$var$_previousTtfb;
let $962fbd100584c218$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $962fbd100584c218$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $962fbd100584c218$var$addMetricObserver('cls', callback, $962fbd100584c218$var$instrumentCls, $962fbd100584c218$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $962fbd100584c218$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $962fbd100584c218$var$addMetricObserver('lcp', callback, $962fbd100584c218$var$instrumentLcp, $962fbd100584c218$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $962fbd100584c218$export$699d9529c099a797(callback) {
    return $962fbd100584c218$var$addMetricObserver('ttfb', callback, $962fbd100584c218$var$instrumentTtfb, $962fbd100584c218$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $962fbd100584c218$export$2707d7471c0b918f(callback) {
    return $962fbd100584c218$var$addMetricObserver('fid', callback, $962fbd100584c218$var$instrumentFid, $962fbd100584c218$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $962fbd100584c218$export$da3b76aa2022cbd7(callback) {
    return $962fbd100584c218$var$addMetricObserver('inp', callback, $962fbd100584c218$var$instrumentInp, $962fbd100584c218$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $962fbd100584c218$export$69816c1a049f8db6(type, callback) {
    $962fbd100584c218$var$addHandler(type, callback);
    if (!$962fbd100584c218$var$instrumented[type]) {
        $962fbd100584c218$var$instrumentPerformanceObserver(type);
        $962fbd100584c218$var$instrumented[type] = true;
    }
    return $962fbd100584c218$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $962fbd100584c218$var$triggerHandlers(type, data) {
    const typeHandlers = $962fbd100584c218$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $4e39c8ebcb5dcbe2$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $962fbd100584c218$var$instrumentCls() {
    return (0, $616a74ac103e3781$export$a7873055838e5ad8)((metric)=>{
        $962fbd100584c218$var$triggerHandlers('cls', {
            metric: metric
        });
        $962fbd100584c218$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $962fbd100584c218$var$instrumentFid() {
    return (0, $43ca0f91ec0f5996$export$39705a25c49af873)((metric)=>{
        $962fbd100584c218$var$triggerHandlers('fid', {
            metric: metric
        });
        $962fbd100584c218$var$_previousFid = metric;
    });
}
function $962fbd100584c218$var$instrumentLcp() {
    return (0, $89b7eb81e7eb2d1b$export$947b1626ab8d5632)((metric)=>{
        $962fbd100584c218$var$triggerHandlers('lcp', {
            metric: metric
        });
        $962fbd100584c218$var$_previousLcp = metric;
    });
}
function $962fbd100584c218$var$instrumentTtfb() {
    return (0, $3e42606ce4686bc2$export$33a01e6c5f2c7e33)((metric)=>{
        $962fbd100584c218$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $962fbd100584c218$var$_previousTtfb = metric;
    });
}
function $962fbd100584c218$var$instrumentInp() {
    return (0, $3ccc30bc8061eb73$export$7df4b36ecaed99e1)((metric)=>{
        $962fbd100584c218$var$triggerHandlers('inp', {
            metric: metric
        });
        $962fbd100584c218$var$_previousInp = metric;
    });
}
function $962fbd100584c218$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $962fbd100584c218$var$addHandler(type, callback);
    let stopListening;
    if (!$962fbd100584c218$var$instrumented[type]) {
        stopListening = instrumentFn();
        $962fbd100584c218$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $962fbd100584c218$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $962fbd100584c218$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $878bc14767ac8952$export$d1203567a167490e)(type, (entries)=>{
        $962fbd100584c218$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $962fbd100584c218$var$addHandler(type, handler) {
    $962fbd100584c218$var$handlers[type] = $962fbd100584c218$var$handlers[type] || [];
    $962fbd100584c218$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $962fbd100584c218$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $962fbd100584c218$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}




/** Regular expression used to parse a Dsn. */ const $0aaaa6c30c5fe7e9$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $0aaaa6c30c5fe7e9$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $0aaaa6c30c5fe7e9$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $0aaaa6c30c5fe7e9$export$b892860177f70a30(str) {
    const match = $0aaaa6c30c5fe7e9$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $54d1043b2228e29f$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $0aaaa6c30c5fe7e9$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $0aaaa6c30c5fe7e9$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $0aaaa6c30c5fe7e9$var$validateDsn(dsn) {
    if (!(0, $64f3c3749eafb7b0$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$0aaaa6c30c5fe7e9$var$isValidProtocol(protocol)) {
        (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $0aaaa6c30c5fe7e9$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $0aaaa6c30c5fe7e9$export$b892860177f70a30(from) : $0aaaa6c30c5fe7e9$var$dsnFromComponents(from);
    if (!components || !$0aaaa6c30c5fe7e9$var$validateDsn(components)) return undefined;
    return components;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $e49341fc8a37f226$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $e49341fc8a37f226$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $e49341fc8a37f226$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $e49341fc8a37f226$export$604a45d95a155e2b(envelope, types) {
    return $e49341fc8a37f226$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $e49341fc8a37f226$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $e49341fc8a37f226$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $e49341fc8a37f226$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $e49341fc8a37f226$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $e1a46ce691765a57$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $e49341fc8a37f226$var$concatBuffers(parts);
}
function $e49341fc8a37f226$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $e49341fc8a37f226$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $e49341fc8a37f226$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $e49341fc8a37f226$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $e49341fc8a37f226$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $e49341fc8a37f226$export$b11169581eeaf237(type) {
    return $e49341fc8a37f226$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $e49341fc8a37f226$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $e49341fc8a37f226$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}


/**
 * Create envelope from Span item.
 */ function $c464b67ae647da57$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(dsn);
    const items = spans.map($c464b67ae647da57$var$createSpanItem);
    return (0, $e49341fc8a37f226$export$f93f7f385160c44e)(headers, items);
}
function $c464b67ae647da57$var$createSpanItem(span) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        span
    ];
}


/**
 * Adds a measurement to the current active transaction.
 */ function $e8a7046dd5e8a784$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $ec5c60089c625009$export$a7feb32fdd923295)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $7da207ca9fea49e7$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $7da207ca9fea49e7$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $7da207ca9fea49e7$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $7da207ca9fea49e7$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}






/**
 * Checks if a given value is a valid measurement value.
 */ function $33db85a956902625$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $33db85a956902625$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $0508804b2b05ab07$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $0508804b2b05ab07$var$msToSec(time) {
    return time / 1000;
}
function $0508804b2b05ab07$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81) && (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).addEventListener && (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance;
}
let $0508804b2b05ab07$var$_performanceCursor = 0;
let $0508804b2b05ab07$var$_measurements = {};
let $0508804b2b05ab07$var$_lcpEntry;
let $0508804b2b05ab07$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $0508804b2b05ab07$export$7c69f0412d101b88() {
    const performance = $0508804b2b05ab07$var$getBrowserPerformanceAPI();
    if (performance && (0, $9596c1ede1884e50$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        const fidCallback = $0508804b2b05ab07$var$_trackFID();
        const clsCallback = $0508804b2b05ab07$var$_trackCLS();
        const lcpCallback = $0508804b2b05ab07$var$_trackLCP();
        const ttfbCallback = $0508804b2b05ab07$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $0508804b2b05ab07$export$f396d19077034ad2() {
    (0, $962fbd100584c218$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $ec5c60089c625009$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $0508804b2b05ab07$var$msToSec((0, $9596c1ede1884e50$export$baf075a948ffc0bf) + entry.startTime);
            const duration = $0508804b2b05ab07$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: 'Main UI thread blocked',
                op: 'ui.long-task',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $0508804b2b05ab07$export$e27543e0976315e4() {
    (0, $962fbd100584c218$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $ec5c60089c625009$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === 'click') {
                const startTime = $0508804b2b05ab07$var$msToSec((0, $9596c1ede1884e50$export$baf075a948ffc0bf) + entry.startTime);
                const duration = $0508804b2b05ab07$var$msToSec(entry.duration);
                const span = {
                    description: (0, $a9dceb93bbd7f017$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: 'auto.ui.browser.metrics',
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $a9dceb93bbd7f017$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) span.attributes = {
                    'ui.component_name': componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $0508804b2b05ab07$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $0508804b2b05ab07$var$getBrowserPerformanceAPI();
    if (performance && (0, $9596c1ede1884e50$export$baf075a948ffc0bf)) {
        const inpCallback = $0508804b2b05ab07$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $0508804b2b05ab07$var$_trackCLS() {
    return (0, $962fbd100584c218$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Measurements] Adding CLS');
        $0508804b2b05ab07$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $0508804b2b05ab07$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $0508804b2b05ab07$var$_trackLCP() {
    return (0, $962fbd100584c218$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Measurements] Adding LCP');
        $0508804b2b05ab07$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $0508804b2b05ab07$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $0508804b2b05ab07$var$_trackFID() {
    return (0, $962fbd100584c218$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $0508804b2b05ab07$var$msToSec((0, $9596c1ede1884e50$export$baf075a948ffc0bf));
        const startTime = $0508804b2b05ab07$var$msToSec(entry.startTime);
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Measurements] Adding FID');
        $0508804b2b05ab07$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $0508804b2b05ab07$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $0508804b2b05ab07$var$_trackTtfb() {
    return (0, $962fbd100584c218$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Measurements] Adding TTFB');
        $0508804b2b05ab07$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
const $0508804b2b05ab07$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $0508804b2b05ab07$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $962fbd100584c218$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $0508804b2b05ab07$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
        if (!entry || !client) return;
        const interactionType = $0508804b2b05ab07$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $0508804b2b05ab07$var$msToSec((0, $9596c1ede1884e50$export$baf075a948ffc0bf) + entry.startTime);
        const duration = $0508804b2b05ab07$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $8f015c96e068ddf8$export$5f1714a13ed34c01)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $a9dceb93bbd7f017$export$5647df6b7814ac86)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== '' ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: 'millisecond'
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $0508804b2b05ab07$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $c464b67ae647da57$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('Error while sending interaction:', reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $0508804b2b05ab07$export$5f8fa6b3467a7443(transaction) {
    const performance = $0508804b2b05ab07$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).performance.getEntries || !(0, $9596c1ede1884e50$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = $0508804b2b05ab07$var$msToSec((0, $9596c1ede1884e50$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $43985f001f6f055c$export$92d8c23565496537)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($0508804b2b05ab07$var$_performanceCursor).forEach((entry)=>{
        const startTime = $0508804b2b05ab07$var$msToSec(entry.startTime);
        const duration = $0508804b2b05ab07$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $0508804b2b05ab07$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $0508804b2b05ab07$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $5e601800040eecc5$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Measurements] Adding FP');
                        $0508804b2b05ab07$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Measurements] Adding FCP');
                        $0508804b2b05ab07$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                $0508804b2b05ab07$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $0508804b2b05ab07$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $0508804b2b05ab07$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $0508804b2b05ab07$var$_addTtfbRequestTimeToMeasurements($0508804b2b05ab07$var$_measurements);
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$0508804b2b05ab07$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $0508804b2b05ab07$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $0508804b2b05ab07$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $0508804b2b05ab07$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $0508804b2b05ab07$var$_measurements['mark.fid'];
        if (fidMark && $0508804b2b05ab07$var$_measurements['fid']) {
            // create span for FID
            (0, $33db85a956902625$export$8bd469e1f37aa721)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $0508804b2b05ab07$var$msToSec($0508804b2b05ab07$var$_measurements['fid'].value),
                op: 'ui.action',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $0508804b2b05ab07$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $0508804b2b05ab07$var$_measurements)) delete $0508804b2b05ab07$var$_measurements.cls;
        Object.keys($0508804b2b05ab07$var$_measurements).forEach((measurementName)=>{
            (0, $e8a7046dd5e8a784$export$7cc31b475d33a706)(measurementName, $0508804b2b05ab07$var$_measurements[measurementName].value, $0508804b2b05ab07$var$_measurements[measurementName].unit);
        });
        $0508804b2b05ab07$var$_tagMetricInfo(transaction);
    }
    $0508804b2b05ab07$var$_lcpEntry = undefined;
    $0508804b2b05ab07$var$_clsEntry = undefined;
    $0508804b2b05ab07$var$_measurements = {};
}
/** Create measure related spans */ function $0508804b2b05ab07$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $33db85a956902625$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: 'auto.resource.browser.metrics',
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0508804b2b05ab07$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $0508804b2b05ab07$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $0508804b2b05ab07$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $0508804b2b05ab07$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $0508804b2b05ab07$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $0508804b2b05ab07$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $0508804b2b05ab07$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $33db85a956902625$export$8bd469e1f37aa721)(transaction, {
        op: 'browser',
        origin: 'auto.browser.browser.metrics',
        description: description || event,
        startTimestamp: timeOrigin + $0508804b2b05ab07$var$msToSec(start),
        endTimestamp: timeOrigin + $0508804b2b05ab07$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0508804b2b05ab07$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $33db85a956902625$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'request',
            startTimestamp: timeOrigin + $0508804b2b05ab07$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $0508804b2b05ab07$var$msToSec(entry.responseEnd)
        });
        (0, $33db85a956902625$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'response',
            startTimestamp: timeOrigin + $0508804b2b05ab07$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $0508804b2b05ab07$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $0508804b2b05ab07$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $0508804b2b05ab07$var$setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
    $0508804b2b05ab07$var$setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
    $0508804b2b05ab07$var$setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data['server.address'] = parsedUrl.host;
    data['url.same_origin'] = resourceUrl.includes((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $33db85a956902625$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location.origin, ''),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        origin: 'auto.resource.browser.metrics',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $0508804b2b05ab07$var$_trackNavigator(transaction) {
    const navigator = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('connectionType', connection.type);
        if ((0, $33db85a956902625$export$27169ccae1b439e3)(connection.rtt)) $0508804b2b05ab07$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $33db85a956902625$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $33db85a956902625$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $0508804b2b05ab07$var$_tagMetricInfo(transaction) {
    if ($0508804b2b05ab07$var$_lcpEntry) {
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($0508804b2b05ab07$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.element', (0, $a9dceb93bbd7f017$export$5647df6b7814ac86)($0508804b2b05ab07$var$_lcpEntry.element));
        if ($0508804b2b05ab07$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.id', $0508804b2b05ab07$var$_lcpEntry.id);
        if ($0508804b2b05ab07$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.url', $0508804b2b05ab07$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.size', $0508804b2b05ab07$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($0508804b2b05ab07$var$_clsEntry && $0508804b2b05ab07$var$_clsEntry.sources) {
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Measurements] Adding CLS Data');
        $0508804b2b05ab07$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $a9dceb93bbd7f017$export$5647df6b7814ac86)(source.node)));
    }
}
function $0508804b2b05ab07$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $0508804b2b05ab07$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $0508804b2b05ab07$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $d99d2cd5a5818608$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Measurements] Adding TTFB Request Time');
        _measurements['ttfb.requestTime'] = {
            value: responseStart - requestStart,
            unit: 'millisecond'
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $0508804b2b05ab07$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $27fce64c83dee28f$export$5008da00b1b6dee6)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $0e85ac4609e3131b$export$2603c8d332a51c42)(sampleRate)) {
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Tracing] Discarding interaction span because of invalid sample rate.');
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}







// eslint-disable-next-line deprecation/deprecation
const $66e623382a10017c$var$WINDOW = (0, $4e20afe4f778c343$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $66e623382a10017c$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $66e623382a10017c$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $66e623382a10017c$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $66e623382a10017c$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $66e623382a10017c$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $66e623382a10017c$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $66e623382a10017c$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$66e623382a10017c$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($66e623382a10017c$export$18cf36ed71d733e7($66e623382a10017c$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $66e623382a10017c$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $66e623382a10017c$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $64f3c3749eafb7b0$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $66e623382a10017c$export$531055a6c684a70a() {
    return 'ReportingObserver' in $66e623382a10017c$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $66e623382a10017c$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$66e623382a10017c$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}




/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f72b9d1319ab84b6$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $f5968277b08509e3$export$a4e09611e30da72e)(type, handler);
    (0, $f5968277b08509e3$export$e18d6c5462c01368)(type, $f72b9d1319ab84b6$var$instrumentFetch);
}
function $f72b9d1319ab84b6$var$instrumentFetch() {
    if (!(0, $66e623382a10017c$export$c82d238e23c40b21)()) return;
    (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)((0, $4e20afe4f778c343$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $f72b9d1319ab84b6$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $f5968277b08509e3$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $4e20afe4f778c343$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $f5968277b08509e3$export$b18c893e424d3127)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $f5968277b08509e3$export$b18c893e424d3127)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $f72b9d1319ab84b6$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $f72b9d1319ab84b6$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($f72b9d1319ab84b6$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $f72b9d1319ab84b6$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $f72b9d1319ab84b6$var$getUrlFromResource(url),
            method: $f72b9d1319ab84b6$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $f72b9d1319ab84b6$var$getUrlFromResource(arg),
        method: $f72b9d1319ab84b6$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}





const $bc641309b3f67a9f$var$WINDOW = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1);
const $bc641309b3f67a9f$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $bc641309b3f67a9f$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $f5968277b08509e3$export$a4e09611e30da72e)(type, handler);
    (0, $f5968277b08509e3$export$e18d6c5462c01368)(type, $bc641309b3f67a9f$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $bc641309b3f67a9f$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$bc641309b3f67a9f$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $4431a087fbf663bd$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $bc641309b3f67a9f$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$bc641309b3f67a9f$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$bc641309b3f67a9f$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $f5968277b08509e3$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$bc641309b3f67a9f$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $4431a087fbf663bd$export$844ec244b1367d54)(header) && (0, $4431a087fbf663bd$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$bc641309b3f67a9f$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $f5968277b08509e3$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $bc641309b3f67a9f$var$parseUrl(url) {
    if ((0, $4431a087fbf663bd$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}




/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $fcf10fbbd8b206ce$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!(0, $27fce64c83dee28f$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $fcf10fbbd8b206ce$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $2dfa7d22514dae4c$export$c7be4b0125a10cba)();
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $fcf10fbbd8b206ce$var$getFullURL(url);
    const host = fullUrl ? (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $3606f142dfccb1dc$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host,
            [(0, $2296c04c99eaa4ca$export$cca8dd30f57f805e)]: spanOrigin
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $fcf10fbbd8b206ce$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $fcf10fbbd8b206ce$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $c4ea612155b0bcfa$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $43985f001f6f055c$export$7e9f8ae9e4a328ab)(span) : (0, $fec4413c5c229d86$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $7118b85cc7face33$export$56766feef403f365)(dsc || (span ? (0, $da440eefa7483dd5$export$a117f995597e25df)(span) : (0, $da440eefa7483dd5$export$366bad00d6815eed)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== 'undefined' && (0, $4431a087fbf663bd$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $4431a087fbf663bd$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $7118b85cc7face33$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $7118b85cc7face33$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
function $fcf10fbbd8b206ce$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $fcf10fbbd8b206ce$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $71514f5fada0e3ce$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus('internal_error');
    span.end();
}




/* eslint-disable max-lines */ const $f8f18e67dc9a164f$export$15bd0305d05ad07b = [
    'localhost',
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $f8f18e67dc9a164f$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $f8f18e67dc9a164f$export$15bd0305d05ad07b,
    tracePropagationTargets: $f8f18e67dc9a164f$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $f8f18e67dc9a164f$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $f8f18e67dc9a164f$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $f8f18e67dc9a164f$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$f8f18e67dc9a164f$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $f72b9d1319ab84b6$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $fcf10fbbd8b206ce$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $f8f18e67dc9a164f$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                'http.url': fullUrl,
                'server.address': host
            });
        }
        if (enableHTTPTimings && createdSpan) $f8f18e67dc9a164f$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $bc641309b3f67a9f$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $f8f18e67dc9a164f$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $f8f18e67dc9a164f$var$addHTTPTimings(createdSpan);
    });
}
function $f8f18e67dc9a164f$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $f8f18e67dc9a164f$var$addHTTPTimings(span) {
    const { url: url } = (0, $43985f001f6f055c$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $962fbd100584c218$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($f8f18e67dc9a164f$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $f8f18e67dc9a164f$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $f8f18e67dc9a164f$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $f8f18e67dc9a164f$var$getAbsoluteTime(time = 0) {
    return (((0, $9596c1ede1884e50$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $f8f18e67dc9a164f$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $f8f18e67dc9a164f$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $9596c1ede1884e50$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $f8f18e67dc9a164f$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $f8f18e67dc9a164f$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $e6e4baebb92dff28$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $f8f18e67dc9a164f$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $f8f18e67dc9a164f$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $bc641309b3f67a9f$export$55b6bb1e45c6cf59];
    if (!(0, $27fce64c83dee28f$export$5008da00b1b6dee6)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $71514f5fada0e3ce$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $2dfa7d22514dae4c$export$c7be4b0125a10cba)();
    const isolationScope = (0, $c4ea612155b0bcfa$export$68f3af03034c9e90)();
    const fullUrl = $f8f18e67dc9a164f$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $3606f142dfccb1dc$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host,
            [(0, $2296c04c99eaa4ca$export$cca8dd30f57f805e)]: 'auto.http.browser'
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $43985f001f6f055c$export$7e9f8ae9e4a328ab)(span) : (0, $fec4413c5c229d86$export$f35d907436da45cf)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $7118b85cc7face33$export$56766feef403f365)(dsc || (span ? (0, $da440eefa7483dd5$export$a117f995597e25df)(span) : (0, $da440eefa7483dd5$export$366bad00d6815eed)(traceId, client, scope)));
        $f8f18e67dc9a164f$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $f8f18e67dc9a164f$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $7118b85cc7face33$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $f8f18e67dc9a164f$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $ff8778bf2763efe5$var$WINDOW = (0, $4e20afe4f778c343$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $ff8778bf2763efe5$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $ff8778bf2763efe5$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $ff8778bf2763efe5$var$WINDOW && !!$ff8778bf2763efe5$var$WINDOW.history.pushState && !!$ff8778bf2763efe5$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $3d019c6a05cabdc5$var$WINDOW = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1);
let $3d019c6a05cabdc5$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3d019c6a05cabdc5$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $f5968277b08509e3$export$a4e09611e30da72e)(type, handler);
    (0, $f5968277b08509e3$export$e18d6c5462c01368)(type, $3d019c6a05cabdc5$var$instrumentHistory);
}
function $3d019c6a05cabdc5$var$instrumentHistory() {
    if (!(0, $ff8778bf2763efe5$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $3d019c6a05cabdc5$var$WINDOW.onpopstate;
    $3d019c6a05cabdc5$var$WINDOW.onpopstate = function(...args) {
        const to = $3d019c6a05cabdc5$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $3d019c6a05cabdc5$var$lastHref;
        $3d019c6a05cabdc5$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $f5968277b08509e3$export$b18c893e424d3127)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $3d019c6a05cabdc5$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $3d019c6a05cabdc5$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $f5968277b08509e3$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)($3d019c6a05cabdc5$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)($3d019c6a05cabdc5$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}




/**
 * Default function implementing pageload and navigation transactions
 */ function $115a0d458d4b2d87$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $8afec3b77151cb8f$export$56d8a8a25bd48b81) || !(0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location) {
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    let startingUrl = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $9596c1ede1884e50$export$baf075a948ffc0bf) ? (0, $9596c1ede1884e50$export$baf075a948ffc0bf) / 1000 : undefined,
        op: 'pageload',
        origin: 'auto.pageload.browser',
        metadata: {
            source: 'url'
        }
    });
    if (startTransactionOnLocationChange) (0, $3d019c6a05cabdc5$export$3f18c56c58114e75)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).location.pathname,
                op: 'navigation',
                origin: 'auto.navigation.browser',
                metadata: {
                    source: 'url'
                }
            });
        }
    });
}



const $bec676217ef4cd96$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $bec676217ef4cd96$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $e819112de2b9f6c6$export$809a2b7987fd5306),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $115a0d458d4b2d87$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $f8f18e67dc9a164f$export$cc17fb3c0bc95cd7)
};
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $bec676217ef4cd96$var$MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class $bec676217ef4cd96$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(_options){
        this.name = $bec676217ef4cd96$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $9cef8812405bf153$export$653d0ef2bad9cdf9)();
        if (0, $c19fecb3210bca7d$export$16a28057038b10ef) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$bec676217ef4cd96$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $0508804b2b05ab07$export$7c69f0412d101b88)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, $0508804b2b05ab07$export$f17d06681a4744a3)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, $0508804b2b05ab07$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $0508804b2b05ab07$export$e27543e0976315e4)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $c19fecb3210bca7d$export$16a28057038b10ef) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $8e74d225bb62d30f$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        if (this.options.enableInp) this._registerInpInteractionListener();
        (0, $f8f18e67dc9a164f$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === 'pageload';
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $bec676217ef4cd96$export$f147b32b03c9cf11('sentry-trace') : '';
            const baggage = isPageloadTransaction ? $bec676217ef4cd96$export$f147b32b03c9cf11('baggage') : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $fec4413c5c229d86$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        this._latestRoute.name = finalContext.name;
        this._latestRoute.context = finalContext;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $9cef8812405bf153$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document) {
                (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.addEventListener('readystatechange', ()=>{
                    if ([
                        'interactive',
                        'complete'
                    ].includes((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
                });
                if ([
                    'interactive',
                    'complete'
                ].includes((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $0508804b2b05ab07$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = 'ui.action.click';
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $ec5c60089c625009$export$a7feb32fdd923295)();
            if (currentTransaction && currentTransaction.op && [
                'navigation',
                'pageload'
            ].includes(currentTransaction.op)) {
                (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason('interactionInterrupted');
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRoute.name) {
                (0, $c19fecb3210bca7d$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $8afec3b77151cb8f$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRoute.name,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $2296c04c99eaa4ca$export$d7a7d984b0791405)]: this._latestRoute.context ? $bec676217ef4cd96$var$getSource(this._latestRoute.context) : 'url'
                }
            };
            inflightInteractionTransaction = (0, $9cef8812405bf153$export$479dbd817e392a4f)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            'click'
        ].forEach((type)=>{
            if ((0, $8afec3b77151cb8f$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ _registerInpInteractionListener() {
        const handleEntries = ({ entries: entries })=>{
            const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
            // We need to get the replay, user, and activeTransaction from the current scope
            // so that we can associate replay id, profile id, and a user display to the span
            const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
            const replayId = replay !== undefined ? replay.getReplayId() : undefined;
            // eslint-disable-next-line deprecation/deprecation
            const activeTransaction = (0, $ec5c60089c625009$export$a7feb32fdd923295)();
            const currentScope = (0, $2dfa7d22514dae4c$export$c7be4b0125a10cba)();
            const user = currentScope !== undefined ? currentScope.getUser() : undefined;
            entries.forEach((entry)=>{
                if ($bec676217ef4cd96$var$isPerformanceEventTiming(entry)) {
                    const interactionId = entry.interactionId;
                    if (interactionId === undefined) return;
                    const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
                    const duration = entry.duration;
                    const startTime = entry.startTime;
                    const keys = Object.keys(this._interactionIdToRouteNameMapping);
                    const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                        return this._interactionIdToRouteNameMapping[a].duration < this._interactionIdToRouteNameMapping[b].duration ? a : b;
                    }) : undefined;
                    // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                    // This is also checked in the web-vitals library.
                    if (entry.entryType === 'first-input') {
                        const matchingEntry = keys.map((key)=>this._interactionIdToRouteNameMapping[key]).some((interaction)=>{
                            return interaction.duration === duration && interaction.startTime === startTime;
                        });
                        if (matchingEntry) return;
                    }
                    // Interactions with an id of 0 and are not first-input are not valid.
                    if (!interactionId) return;
                    // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                    if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                    else if (keys.length < $bec676217ef4cd96$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                        // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                        const routeName = this._latestRoute.name;
                        const parentContext = this._latestRoute.context;
                        if (routeName && parentContext) {
                            if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= $bec676217ef4cd96$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete this._interactionIdToRouteNameMapping[minInteractionId];
                            this._interactionIdToRouteNameMapping[interactionId] = {
                                routeName: routeName,
                                duration: duration,
                                parentContext: parentContext,
                                user: user,
                                activeTransaction: activeTransaction,
                                replayId: replayId,
                                startTime: startTime
                            };
                        }
                    }
                }
            });
        };
        (0, $962fbd100584c218$export$69816c1a049f8db6)('event', handleEntries);
        (0, $962fbd100584c218$export$69816c1a049f8db6)('first-input', handleEntries);
    }
}
/** Returns the value of a meta tag */ function $bec676217ef4cd96$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $a9dceb93bbd7f017$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
function $bec676217ef4cd96$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $2296c04c99eaa4ca$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $2296c04c99eaa4ca$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function $bec676217ef4cd96$var$isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}


var $8upap = parcelRequire("8upap");

/**
 * Returns true if we are in the browser.
 */ function $a3b7b49346b363b5$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, $8upap.isNodeEnv)() || $a3b7b49346b363b5$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $a3b7b49346b363b5$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).process !== undefined && (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).process.type === 'renderer');
}



/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $ed6d689869770b05$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $ed6d689869770b05$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $e49341fc8a37f226$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $e49341fc8a37f226$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $ed6d689869770b05$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $e49341fc8a37f226$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $ed6d689869770b05$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $e49341fc8a37f226$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $e49341fc8a37f226$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}


// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and feedback packages
const $cbc62a81a802c1f1$var$WINDOW = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1);
const $cbc62a81a802c1f1$var$LIGHT_BACKGROUND = '#ffffff';
const $cbc62a81a802c1f1$var$INHERIT = 'inherit';
const $cbc62a81a802c1f1$var$SUBMIT_COLOR = 'rgba(108, 95, 199, 1)';
const $cbc62a81a802c1f1$var$LIGHT_THEME = {
    fontFamily: "system-ui, 'Helvetica Neue', Arial, sans-serif",
    fontSize: '14px',
    background: $cbc62a81a802c1f1$var$LIGHT_BACKGROUND,
    backgroundHover: '#f6f6f7',
    foreground: '#2b2233',
    border: '1.5px solid rgba(41, 35, 47, 0.13)',
    borderRadius: '25px',
    boxShadow: '0px 4px 24px 0px rgba(43, 34, 51, 0.12)',
    success: '#268d75',
    error: '#df3338',
    submitBackground: 'rgba(88, 74, 192, 1)',
    submitBackgroundHover: $cbc62a81a802c1f1$var$SUBMIT_COLOR,
    submitBorder: $cbc62a81a802c1f1$var$SUBMIT_COLOR,
    submitOutlineFocus: '#29232f',
    submitForeground: $cbc62a81a802c1f1$var$LIGHT_BACKGROUND,
    submitForegroundHover: $cbc62a81a802c1f1$var$LIGHT_BACKGROUND,
    cancelBackground: 'transparent',
    cancelBackgroundHover: 'var(--background-hover)',
    cancelBorder: 'var(--border)',
    cancelOutlineFocus: 'var(--input-outline-focus)',
    cancelForeground: 'var(--foreground)',
    cancelForegroundHover: 'var(--foreground)',
    inputBackground: $cbc62a81a802c1f1$var$INHERIT,
    inputForeground: $cbc62a81a802c1f1$var$INHERIT,
    inputBorder: 'var(--border)',
    inputOutlineFocus: $cbc62a81a802c1f1$var$SUBMIT_COLOR,
    formBorderRadius: '20px',
    formContentBorderRadius: '6px'
};
const $cbc62a81a802c1f1$var$DEFAULT_THEME = {
    light: $cbc62a81a802c1f1$var$LIGHT_THEME,
    dark: {
        ...$cbc62a81a802c1f1$var$LIGHT_THEME,
        background: '#29232f',
        backgroundHover: '#352f3b',
        foreground: '#ebe6ef',
        border: '1.5px solid rgba(235, 230, 239, 0.15)',
        success: '#2da98c',
        error: '#f55459'
    }
};
const $cbc62a81a802c1f1$var$ACTOR_LABEL = 'Report a Bug';
const $cbc62a81a802c1f1$var$CANCEL_BUTTON_LABEL = 'Cancel';
const $cbc62a81a802c1f1$var$SUBMIT_BUTTON_LABEL = 'Send Bug Report';
const $cbc62a81a802c1f1$var$FORM_TITLE = 'Report a Bug';
const $cbc62a81a802c1f1$var$EMAIL_PLACEHOLDER = 'your.email@example.org';
const $cbc62a81a802c1f1$var$EMAIL_LABEL = 'Email';
const $cbc62a81a802c1f1$var$MESSAGE_PLACEHOLDER = "What's the bug? What did you expect?";
const $cbc62a81a802c1f1$var$MESSAGE_LABEL = 'Description';
const $cbc62a81a802c1f1$var$NAME_PLACEHOLDER = 'Your Name';
const $cbc62a81a802c1f1$var$NAME_LABEL = 'Name';
const $cbc62a81a802c1f1$var$IS_REQUIRED_LABEL = '(required)';
const $cbc62a81a802c1f1$var$SUCCESS_MESSAGE_TEXT = 'Thank you for your report!';
const $cbc62a81a802c1f1$var$FEEDBACK_WIDGET_SOURCE = 'widget';
const $cbc62a81a802c1f1$var$FEEDBACK_API_SOURCE = 'api';
/**
 * Prepare a feedback event & enrich it with the SDK metadata.
 */ async function $cbc62a81a802c1f1$var$prepareFeedbackEvent({ client: client, scope: scope, event: event }) {
    const eventHint = {};
    if (client.emit) client.emit('preprocessEvent', event, eventHint);
    const preparedEvent = await (0, $c16ffd4bab406a01$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $c4ea612155b0bcfa$export$68f3af03034c9e90)());
    if (preparedEvent === null) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent('event_processor', 'feedback', event);
        return null;
    }
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || 'javascript';
    return preparedEvent;
}
/**
 * Send feedback using transport
 */ async function $cbc62a81a802c1f1$var$sendFeedbackRequest({ feedback: { message: message, email: email, name: name, source: source, url: url } }, { includeReplay: includeReplay = true } = {}) {
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn) return;
    const baseEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source
            }
        },
        type: 'feedback'
    };
    return (0, $2dfa7d22514dae4c$export$ec58d9285c204497)(async (scope)=>{
        // No use for breadcrumbs in feedback
        scope.clearBreadcrumbs();
        if ([
            $cbc62a81a802c1f1$var$FEEDBACK_API_SOURCE,
            $cbc62a81a802c1f1$var$FEEDBACK_WIDGET_SOURCE
        ].includes(String(source))) scope.setLevel('info');
        const feedbackEvent = await $cbc62a81a802c1f1$var$prepareFeedbackEvent({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            scope: scope,
            client: client,
            event: baseEvent
        });
        if (!feedbackEvent) return;
        if (client.emit) client.emit('beforeSendFeedback', feedbackEvent, {
            includeReplay: Boolean(includeReplay)
        });
        const envelope = (0, $ed6d689869770b05$export$c31057337a18010f)(feedbackEvent, dsn, client.getOptions()._metadata, client.getOptions().tunnel);
        let response;
        try {
            response = await transport.send(envelope);
        } catch (err) {
            const error = new Error('Unable to send Feedback');
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
        if (!response) return;
        // Require valid status codes, otherwise can assume feedback was not sent successfully
        if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new Error('Unable to send Feedback');
        return response;
    });
}
/*
 * For reference, the fully built event looks something like this:
 * {
 *     "type": "feedback",
 *     "event_id": "d2132d31b39445f1938d7e21b6bf0ec4",
 *     "timestamp": 1597977777.6189718,
 *     "dist": "1.12",
 *     "platform": "javascript",
 *     "environment": "production",
 *     "release": 42,
 *     "tags": {"transaction": "/organizations/:orgId/performance/:eventSlug/"},
 *     "sdk": {"name": "name", "version": "version"},
 *     "user": {
 *         "id": "123",
 *         "username": "user",
 *         "email": "user@site.com",
 *         "ip_address": "192.168.11.12",
 *     },
 *     "request": {
 *         "url": None,
 *         "headers": {
 *             "user-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.5 Safari/605.1.15"
 *         },
 *     },
 *     "contexts": {
 *         "feedback": {
 *             "message": "test message",
 *             "contact_email": "test@example.com",
 *             "type": "feedback",
 *         },
 *         "trace": {
 *             "trace_id": "4C79F60C11214EB38604F4AE0781BFB2",
 *             "span_id": "FA90FDEAD5F74052",
 *             "type": "trace",
 *         },
 *         "replay": {
 *             "replay_id": "e2d42047b1c5431c8cba85ee2a8ab25d",
 *         },
 *     },
 *   }
 */ /**
 * Public API to send a Feedback item to Sentry
 */ function $cbc62a81a802c1f1$export$a65d69dd22caceda({ name: name, email: email, message: message, source: source = $cbc62a81a802c1f1$var$FEEDBACK_API_SOURCE, url: url = (0, $a9dceb93bbd7f017$export$1cfafeee2987818b)() }, options = {}) {
    if (!message) throw new Error('Unable to submit feedback with empty message');
    return $cbc62a81a802c1f1$var$sendFeedbackRequest({
        feedback: {
            name: name,
            email: email,
            message: message,
            url: url,
            source: source
        }
    }, options);
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $cbc62a81a802c1f1$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
/**
 * Quick and dirty deep merge for the Feedback integration options
 */ function $cbc62a81a802c1f1$var$mergeOptions(defaultOptions, optionOverrides) {
    return {
        ...defaultOptions,
        ...optionOverrides,
        themeDark: {
            ...defaultOptions.themeDark,
            ...optionOverrides.themeDark
        },
        themeLight: {
            ...defaultOptions.themeLight,
            ...optionOverrides.themeLight
        }
    };
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function $cbc62a81a802c1f1$var$createActorStyles(d) {
    const style = d.createElement('style');
    style.textContent = `
.widget__actor {
  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);
  z-index: var(--z-index);

  line-height: 16px;

  display: flex;
  align-items: center;
  gap: 8px;

  border-radius: var(--border-radius);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  padding: 16px;
  text-decoration: none;
  z-index: 9000;

  color: var(--foreground);
  background-color: var(--background);
  border: var(--border);
  box-shadow: var(--box-shadow);
  opacity: 1;
  transition: opacity 0.1s ease-in-out;
}

.widget__actor:hover {
  background-color: var(--background-hover);
}

.widget__actor svg {
  width: 16px;
  height: 16px;
}

.widget__actor--hidden {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}

.widget__actor__text {
}

@media (max-width: 600px) {
  .widget__actor__text {
    display: none;
  }
}

.feedback-icon path {
  fill: var(--foreground);
}
`;
    return style;
}
/**
 * Creates <style> element for widget dialog
 */ function $cbc62a81a802c1f1$var$createDialogStyles(d) {
    const style = d.createElement('style');
    style.textContent = `
.dialog {
  line-height: 25px;
  background-color: rgba(0, 0, 0, 0.05);
  border: none;
  position: fixed;
  inset: 0;
  z-index: 10000;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.dialog:not([open]) {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}
.dialog:not([open]) .dialog__content {
  transform: translate(0, -16px) scale(0.98);
}

.dialog__content {
  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);

  border: var(--border);
  border-radius: var(--form-border-radius);
  background-color: var(--background);
  color: var(--foreground);

  width: 320px;
  max-width: 100%;
  max-height: calc(100% - 2rem);
  display: flex;
  flex-direction: column;
  box-shadow: var(--box-shadow);
  transition: transform 0.2s ease-in-out;
  transform: translate(0, 0) scale(1);
}

.dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 600;
  padding: 24px 24px 0 24px;
  margin: 0;
  margin-bottom: 16px;
}

.brand-link {
  display: inline-flex;
}

.error {
  color: var(--error);
  margin-bottom: 16px;
}

.form {
  display: grid;
  overflow: auto;
  flex-direction: column;
  gap: 16px;
  padding: 0 24px 24px;
}

.form__error-container {
  color: var(--error);
}

.form__error-container--hidden {
  display: none;
}

.form__label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0px;
}

.form__label__text {
  display: grid;
  gap: 4px;
  align-items: center;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
}

.form__label__text--required {
  font-size: 0.85em;
}

.form__input {
  line-height: inherit;
  background-color: var(--input-background);
  box-sizing: border-box;
  border: var(--input-border);
  border-radius: var(--form-content-border-radius);
  color: var(--input-foreground);
  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 500;
  padding: 6px 12px;
}

.form__input::placeholder {
  color: var(--input-foreground);
  opacity: 0.65;
}

.form__input:focus-visible {
  outline: 1px auto var(--input-outline-focus);
}

.form__input--textarea {
  font-family: inherit;
  resize: vertical;
}

.btn-group {
  display: grid;
  gap: 8px;
  margin-top: 8px;
}

.btn {
  line-height: inherit;
  border: var(--cancel-border);
  border-radius: var(--form-content-border-radius);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  padding: 6px 16px;
}
.btn[disabled] {
  opacity: 0.6;
  pointer-events: none;
}

.btn--primary {
  background-color: var(--submit-background);
  border-color: var(--submit-border);
  color: var(--submit-foreground);
}
.btn--primary:hover {
  background-color: var(--submit-background-hover);
  color: var(--submit-foreground-hover);
}
.btn--primary:focus-visible {
  outline: 1px auto var(--submit-outline-focus);
}

.btn--default {
  background-color: var(--cancel-background);
  color: var(--cancel-foreground);
  font-weight: 500;
}
.btn--default:hover {
  background-color: var(--cancel-background-hover);
  color: var(--cancel-foreground-hover);
}
.btn--default:focus-visible {
  outline: 1px auto var(--cancel-outline-focus);
}

.success-message {
  background-color: var(--background);
  border: var(--border);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  font-weight: 600;
  color: var(--success);
  padding: 12px 24px;
  line-height: 25px;
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  gap: 6px;
  cursor: default;
}

.success-icon path {
  fill: var(--success);
}
`;
    return style;
}
function $cbc62a81a802c1f1$var$getThemedCssVariables(theme) {
    return `
  --background: ${theme.background};
  --background-hover: ${theme.backgroundHover};
  --foreground: ${theme.foreground};
  --error: ${theme.error};
  --success: ${theme.success};
  --border: ${theme.border};
  --border-radius: ${theme.borderRadius};
  --box-shadow: ${theme.boxShadow};

  --submit-background: ${theme.submitBackground};
  --submit-background-hover: ${theme.submitBackgroundHover};
  --submit-border: ${theme.submitBorder};
  --submit-outline-focus: ${theme.submitOutlineFocus};
  --submit-foreground: ${theme.submitForeground};
  --submit-foreground-hover: ${theme.submitForegroundHover};

  --cancel-background: ${theme.cancelBackground};
  --cancel-background-hover: ${theme.cancelBackgroundHover};
  --cancel-border: ${theme.cancelBorder};
  --cancel-outline-focus: ${theme.cancelOutlineFocus};
  --cancel-foreground: ${theme.cancelForeground};
  --cancel-foreground-hover: ${theme.cancelForegroundHover};

  --input-background: ${theme.inputBackground};
  --input-foreground: ${theme.inputForeground};
  --input-border: ${theme.inputBorder};
  --input-outline-focus: ${theme.inputOutlineFocus};

  --form-border-radius: ${theme.formBorderRadius};
  --form-content-border-radius: ${theme.formContentBorderRadius};
  `;
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function $cbc62a81a802c1f1$var$createMainStyles(d, colorScheme, themes) {
    const style = d.createElement('style');
    style.textContent = `
:host {
  --bottom: 1rem;
  --right: 1rem;
  --top: auto;
  --left: auto;
  --z-index: 100000;
  --font-family: ${themes.light.fontFamily};
  --font-size: ${themes.light.fontSize};

  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);
  z-index: var(--z-index);

  font-family: var(--font-family);
  font-size: var(--font-size);

  ${$cbc62a81a802c1f1$var$getThemedCssVariables(colorScheme === 'dark' ? themes.dark : themes.light)}
}

${colorScheme === 'system' ? `
@media (prefers-color-scheme: dark) {
  :host {
    ${$cbc62a81a802c1f1$var$getThemedCssVariables(themes.dark)}
  }
}` : ''}
}`;
    return style;
}
/**
 * Creates shadow host
 */ function $cbc62a81a802c1f1$var$createShadowHost({ id: id, colorScheme: colorScheme, themeDark: themeDark, themeLight: themeLight }) {
    try {
        const doc = $cbc62a81a802c1f1$var$WINDOW.document;
        // Create the host
        const host = doc.createElement('div');
        host.id = id;
        // Create the shadow root
        const shadow = host.attachShadow({
            mode: 'open'
        });
        shadow.appendChild($cbc62a81a802c1f1$var$createMainStyles(doc, colorScheme, {
            dark: themeDark,
            light: themeLight
        }));
        shadow.appendChild($cbc62a81a802c1f1$var$createDialogStyles(doc));
        return {
            shadow: shadow,
            host: host
        };
    } catch (e) {
        // Shadow DOM probably not supported
        (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Feedback] Browser does not support shadow DOM API');
        throw new Error('Browser does not support shadow DOM API.');
    }
}
/**
 * Handles UI behavior of dialog when feedback is submitted, calls
 * `sendFeedback` to send feedback.
 */ async function $cbc62a81a802c1f1$var$handleFeedbackSubmit(dialog, feedback, options) {
    if (!dialog) // Not sure when this would happen
    return;
    const showFetchError = ()=>{
        if (!dialog) return;
        dialog.showError('There was a problem submitting feedback, please wait and try again.');
    };
    dialog.hideError();
    try {
        const resp = await $cbc62a81a802c1f1$export$a65d69dd22caceda({
            ...feedback,
            source: $cbc62a81a802c1f1$var$FEEDBACK_WIDGET_SOURCE
        }, options);
        // Success!
        return resp;
    } catch (err) {
        $cbc62a81a802c1f1$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(err);
        showFetchError();
    }
}
/**
 * Helper function to set a dict of attributes on element (w/ specified namespace)
 */ function $cbc62a81a802c1f1$var$setAttributesNS(el, attributes) {
    Object.entries(attributes).forEach(([key, val])=>{
        el.setAttributeNS(null, key, val);
    });
    return el;
}
const $cbc62a81a802c1f1$var$SIZE = 20;
const $cbc62a81a802c1f1$var$XMLNS$2 = 'http://www.w3.org/2000/svg';
/**
 * Feedback Icon
 */ function $cbc62a81a802c1f1$var$Icon() {
    const createElementNS = (tagName)=>$cbc62a81a802c1f1$var$WINDOW.document.createElementNS($cbc62a81a802c1f1$var$XMLNS$2, tagName);
    const svg = $cbc62a81a802c1f1$var$setAttributesNS(createElementNS('svg'), {
        class: 'feedback-icon',
        width: `${$cbc62a81a802c1f1$var$SIZE}`,
        height: `${$cbc62a81a802c1f1$var$SIZE}`,
        viewBox: `0 0 ${$cbc62a81a802c1f1$var$SIZE} ${$cbc62a81a802c1f1$var$SIZE}`,
        fill: 'none'
    });
    const g = $cbc62a81a802c1f1$var$setAttributesNS(createElementNS('g'), {
        clipPath: 'url(#clip0_57_80)'
    });
    const path = $cbc62a81a802c1f1$var$setAttributesNS(createElementNS('path'), {
        ['fill-rule']: 'evenodd',
        ['clip-rule']: 'evenodd',
        d: 'M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z'
    });
    svg.appendChild(g).appendChild(path);
    const speakerDefs = createElementNS('defs');
    const speakerClipPathDef = $cbc62a81a802c1f1$var$setAttributesNS(createElementNS('clipPath'), {
        id: 'clip0_57_80'
    });
    const speakerRect = $cbc62a81a802c1f1$var$setAttributesNS(createElementNS('rect'), {
        width: `${$cbc62a81a802c1f1$var$SIZE}`,
        height: `${$cbc62a81a802c1f1$var$SIZE}`,
        fill: 'white'
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Helper function to create an element. Could be used as a JSX factory
 * (i.e. React-like syntax).
 */ function $cbc62a81a802c1f1$var$createElement(tagName, attributes, ...children) {
    const doc = $cbc62a81a802c1f1$var$WINDOW.document;
    const element = doc.createElement(tagName);
    if (attributes) Object.entries(attributes).forEach(([attribute, attributeValue])=>{
        if (attribute === 'className' && typeof attributeValue === 'string') // JSX does not allow class as a valid name
        element.setAttribute('class', attributeValue);
        else if (typeof attributeValue === 'boolean' && attributeValue) element.setAttribute(attribute, '');
        else if (typeof attributeValue === 'string') element.setAttribute(attribute, attributeValue);
        else if (attribute.startsWith('on') && typeof attributeValue === 'function') element.addEventListener(attribute.substring(2).toLowerCase(), attributeValue);
    });
    for (const child of children)$cbc62a81a802c1f1$var$appendChild(element, child);
    return element;
}
function $cbc62a81a802c1f1$var$appendChild(parent, child) {
    const doc = $cbc62a81a802c1f1$var$WINDOW.document;
    if (typeof child === 'undefined' || child === null) return;
    if (Array.isArray(child)) for (const value of child)$cbc62a81a802c1f1$var$appendChild(parent, value);
    else if (child === false) ;
    else if (typeof child === 'string') parent.appendChild(doc.createTextNode(child));
    else if (child instanceof Node) parent.appendChild(child);
    else parent.appendChild(doc.createTextNode(String(child)));
}
/**
 *
 */ function $cbc62a81a802c1f1$var$Actor({ buttonLabel: buttonLabel, onClick: onClick }) {
    function _handleClick(e) {
        onClick && onClick(e);
    }
    const el = $cbc62a81a802c1f1$var$createElement('button', {
        type: 'button',
        className: 'widget__actor',
        ['aria-label']: buttonLabel,
        ['aria-hidden']: 'false'
    }, $cbc62a81a802c1f1$var$Icon().el, buttonLabel ? $cbc62a81a802c1f1$var$createElement('span', {
        className: 'widget__actor__text'
    }, buttonLabel) : null);
    el.addEventListener('click', _handleClick);
    return {
        get el () {
            return el;
        },
        show: ()=>{
            el.classList.remove('widget__actor--hidden');
            el.setAttribute('aria-hidden', 'false');
        },
        hide: ()=>{
            el.classList.add('widget__actor--hidden');
            el.setAttribute('aria-hidden', 'true');
        }
    };
}
/**
 *
 */ function $cbc62a81a802c1f1$var$SubmitButton({ label: label }) {
    const el = $cbc62a81a802c1f1$var$createElement('button', {
        type: 'submit',
        className: 'btn btn--primary',
        ['aria-label']: label
    }, label);
    return {
        el: el
    };
}
function $cbc62a81a802c1f1$var$retrieveStringValue(formData, key) {
    const value = formData.get(key);
    if (typeof value === 'string') return value.trim();
    return '';
}
/**
 * Creates the form element
 */ function $cbc62a81a802c1f1$var$Form({ nameLabel: nameLabel, namePlaceholder: namePlaceholder, emailLabel: emailLabel, emailPlaceholder: emailPlaceholder, messageLabel: messageLabel, messagePlaceholder: messagePlaceholder, isRequiredLabel: isRequiredLabel, cancelButtonLabel: cancelButtonLabel, submitButtonLabel: submitButtonLabel, showName: showName, showEmail: showEmail, isNameRequired: isNameRequired, isEmailRequired: isEmailRequired, defaultName: defaultName, defaultEmail: defaultEmail, onCancel: onCancel, onSubmit: onSubmit }) {
    const { el: submitEl } = $cbc62a81a802c1f1$var$SubmitButton({
        label: submitButtonLabel
    });
    function handleSubmit(e) {
        e.preventDefault();
        if (!(e.target instanceof HTMLFormElement)) return;
        try {
            if (onSubmit) {
                const formData = new FormData(e.target);
                const feedback = {
                    name: $cbc62a81a802c1f1$var$retrieveStringValue(formData, 'name'),
                    email: $cbc62a81a802c1f1$var$retrieveStringValue(formData, 'email'),
                    message: $cbc62a81a802c1f1$var$retrieveStringValue(formData, 'message')
                };
                onSubmit(feedback);
            }
        } catch (e2) {
        // pass
        }
    }
    const errorEl = $cbc62a81a802c1f1$var$createElement('div', {
        className: 'form__error-container form__error-container--hidden',
        ['aria-hidden']: 'true'
    });
    function showError(message) {
        errorEl.textContent = message;
        errorEl.classList.remove('form__error-container--hidden');
        errorEl.setAttribute('aria-hidden', 'false');
    }
    function hideError() {
        errorEl.textContent = '';
        errorEl.classList.add('form__error-container--hidden');
        errorEl.setAttribute('aria-hidden', 'true');
    }
    const nameEl = $cbc62a81a802c1f1$var$createElement('input', {
        id: 'name',
        type: showName ? 'text' : 'hidden',
        ['aria-hidden']: showName ? 'false' : 'true',
        name: 'name',
        required: isNameRequired,
        className: 'form__input',
        placeholder: namePlaceholder,
        value: defaultName
    });
    const emailEl = $cbc62a81a802c1f1$var$createElement('input', {
        id: 'email',
        type: showEmail ? 'text' : 'hidden',
        ['aria-hidden']: showEmail ? 'false' : 'true',
        name: 'email',
        required: isEmailRequired,
        className: 'form__input',
        placeholder: emailPlaceholder,
        value: defaultEmail
    });
    const messageEl = $cbc62a81a802c1f1$var$createElement('textarea', {
        id: 'message',
        autoFocus: 'true',
        rows: '5',
        name: 'message',
        required: true,
        className: 'form__input form__input--textarea',
        placeholder: messagePlaceholder
    });
    const cancelEl = $cbc62a81a802c1f1$var$createElement('button', {
        type: 'button',
        className: 'btn btn--default',
        ['aria-label']: cancelButtonLabel,
        onClick: (e)=>{
            onCancel && onCancel(e);
        }
    }, cancelButtonLabel);
    const formEl = $cbc62a81a802c1f1$var$createElement('form', {
        className: 'form',
        onSubmit: handleSubmit
    }, [
        errorEl,
        showName && $cbc62a81a802c1f1$var$createElement('label', {
            htmlFor: 'name',
            className: 'form__label'
        }, [
            $cbc62a81a802c1f1$var$createElement('span', {
                className: 'form__label__text'
            }, nameLabel, isNameRequired && $cbc62a81a802c1f1$var$createElement('span', {
                className: 'form__label__text--required'
            }, ` ${isRequiredLabel}`)),
            nameEl
        ]),
        !showName && nameEl,
        showEmail && $cbc62a81a802c1f1$var$createElement('label', {
            htmlFor: 'email',
            className: 'form__label'
        }, [
            $cbc62a81a802c1f1$var$createElement('span', {
                className: 'form__label__text'
            }, emailLabel, isEmailRequired && $cbc62a81a802c1f1$var$createElement('span', {
                className: 'form__label__text--required'
            }, ` ${isRequiredLabel}`)),
            emailEl
        ]),
        !showEmail && emailEl,
        $cbc62a81a802c1f1$var$createElement('label', {
            htmlFor: 'message',
            className: 'form__label'
        }, [
            $cbc62a81a802c1f1$var$createElement('span', {
                className: 'form__label__text'
            }, messageLabel, $cbc62a81a802c1f1$var$createElement('span', {
                className: 'form__label__text--required'
            }, ` ${isRequiredLabel}`)),
            messageEl
        ]),
        $cbc62a81a802c1f1$var$createElement('div', {
            className: 'btn-group'
        }, [
            submitEl,
            cancelEl
        ])
    ]);
    return {
        get el () {
            return formEl;
        },
        showError: showError,
        hideError: hideError
    };
}
const $cbc62a81a802c1f1$var$XMLNS$1 = 'http://www.w3.org/2000/svg';
/**
 * Sentry Logo
 */ function $cbc62a81a802c1f1$var$Logo({ colorScheme: colorScheme }) {
    const createElementNS = (tagName)=>$cbc62a81a802c1f1$var$WINDOW.document.createElementNS($cbc62a81a802c1f1$var$XMLNS$1, tagName);
    const svg = $cbc62a81a802c1f1$var$setAttributesNS(createElementNS('svg'), {
        class: 'sentry-logo',
        width: '32',
        height: '30',
        viewBox: '0 0 72 66',
        fill: 'none'
    });
    const path = $cbc62a81a802c1f1$var$setAttributesNS(createElementNS('path'), {
        transform: 'translate(11, 11)',
        d: 'M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z'
    });
    svg.append(path);
    const defs = createElementNS('defs');
    const style = createElementNS('style');
    style.textContent = `
    path {
      fill: ${colorScheme === 'dark' ? '#fff' : '#362d59'};
    }`;
    if (colorScheme === 'system') style.textContent += `
    @media (prefers-color-scheme: dark) {
      path: {
        fill: '#fff';
      }
    }
    `;
    defs.append(style);
    svg.append(defs);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Feedback dialog component that has the form
 */ function $cbc62a81a802c1f1$var$Dialog({ formTitle: formTitle, showBranding: showBranding, showName: showName, showEmail: showEmail, isNameRequired: isNameRequired, isEmailRequired: isEmailRequired, colorScheme: colorScheme, defaultName: defaultName, defaultEmail: defaultEmail, onClosed: onClosed, onCancel: onCancel, onSubmit: onSubmit, ...textLabels }) {
    let el = null;
    /**
   * Handles when the dialog is clicked. In our case, the dialog is the
   * semi-transparent bg behind the form. We want clicks outside of the form to
   * hide the form.
   */ function handleDialogClick() {
        close();
        // Only this should trigger `onClose`, we don't want the `close()` method to
        // trigger it, otherwise it can cause cycles.
        onClosed && onClosed();
    }
    /**
   * Close the dialog
   */ function close() {
        if (el) el.open = false;
    }
    /**
   * Opens the dialog
   */ function open() {
        if (el) el.open = true;
    }
    /**
   * Check if dialog is currently opened
   */ function checkIsOpen() {
        return el && el.open === true || false;
    }
    const { el: formEl, showError: showError, hideError: hideError } = $cbc62a81a802c1f1$var$Form({
        showEmail: showEmail,
        showName: showName,
        isEmailRequired: isEmailRequired,
        isNameRequired: isNameRequired,
        defaultName: defaultName,
        defaultEmail: defaultEmail,
        onSubmit: onSubmit,
        onCancel: onCancel,
        ...textLabels
    });
    el = $cbc62a81a802c1f1$var$createElement('dialog', {
        className: 'dialog',
        open: true,
        onClick: handleDialogClick
    }, $cbc62a81a802c1f1$var$createElement('div', {
        className: 'dialog__content',
        onClick: (e)=>{
            // Stop event propagation so clicks on content modal do not propagate to dialog (which will close dialog)
            e.stopPropagation();
        }
    }, $cbc62a81a802c1f1$var$createElement('h2', {
        className: 'dialog__header'
    }, formTitle, showBranding && $cbc62a81a802c1f1$var$createElement('a', {
        className: 'brand-link',
        target: '_blank',
        href: 'https://sentry.io/welcome/',
        title: 'Powered by Sentry',
        rel: 'noopener noreferrer'
    }, $cbc62a81a802c1f1$var$Logo({
        colorScheme: colorScheme
    }).el)), formEl));
    return {
        get el () {
            return el;
        },
        showError: showError,
        hideError: hideError,
        open: open,
        close: close,
        checkIsOpen: checkIsOpen
    };
}
const $cbc62a81a802c1f1$var$WIDTH = 16;
const $cbc62a81a802c1f1$var$HEIGHT = 17;
const $cbc62a81a802c1f1$var$XMLNS = 'http://www.w3.org/2000/svg';
/**
 * Success Icon (checkmark)
 */ function $cbc62a81a802c1f1$var$SuccessIcon() {
    const createElementNS = (tagName)=>$cbc62a81a802c1f1$var$WINDOW.document.createElementNS($cbc62a81a802c1f1$var$XMLNS, tagName);
    const svg = $cbc62a81a802c1f1$var$setAttributesNS(createElementNS('svg'), {
        class: 'success-icon',
        width: `${$cbc62a81a802c1f1$var$WIDTH}`,
        height: `${$cbc62a81a802c1f1$var$HEIGHT}`,
        viewBox: `0 0 ${$cbc62a81a802c1f1$var$WIDTH} ${$cbc62a81a802c1f1$var$HEIGHT}`,
        fill: 'none'
    });
    const g = $cbc62a81a802c1f1$var$setAttributesNS(createElementNS('g'), {
        clipPath: 'url(#clip0_57_156)'
    });
    const path2 = $cbc62a81a802c1f1$var$setAttributesNS(createElementNS('path'), {
        ['fill-rule']: 'evenodd',
        ['clip-rule']: 'evenodd',
        d: 'M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z'
    });
    const path = $cbc62a81a802c1f1$var$setAttributesNS(createElementNS('path'), {
        d: 'M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z'
    });
    svg.appendChild(g).append(path, path2);
    const speakerDefs = createElementNS('defs');
    const speakerClipPathDef = $cbc62a81a802c1f1$var$setAttributesNS(createElementNS('clipPath'), {
        id: 'clip0_57_156'
    });
    const speakerRect = $cbc62a81a802c1f1$var$setAttributesNS(createElementNS('rect'), {
        width: `${$cbc62a81a802c1f1$var$WIDTH}`,
        height: `${$cbc62a81a802c1f1$var$WIDTH}`,
        fill: 'white',
        transform: 'translate(0 0.5)'
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Feedback dialog component that has the form
 */ function $cbc62a81a802c1f1$var$SuccessMessage({ message: message, onRemove: onRemove }) {
    function remove() {
        if (!el) return;
        el.remove();
        onRemove && onRemove();
    }
    const el = $cbc62a81a802c1f1$var$createElement('div', {
        className: 'success-message',
        onClick: remove
    }, $cbc62a81a802c1f1$var$SuccessIcon().el, message);
    return {
        el: el,
        remove: remove
    };
}
/**
 * Creates a new widget. Returns public methods that control widget behavior.
 */ function $cbc62a81a802c1f1$var$createWidget({ shadow: shadow, options: { shouldCreateActor: shouldCreateActor = true, ...options }, attachTo: attachTo }) {
    let actor;
    let dialog;
    let isDialogOpen = false;
    /**
   * Show the success message for 5 seconds
   */ function showSuccessMessage() {
        if (!shadow) return;
        try {
            const success = $cbc62a81a802c1f1$var$SuccessMessage({
                message: options.successMessageText,
                onRemove: ()=>{
                    if (timeoutId) clearTimeout(timeoutId);
                    showActor();
                }
            });
            if (!success.el) throw new Error('Unable to show success message');
            shadow.appendChild(success.el);
            const timeoutId = setTimeout(()=>{
                if (success) success.remove();
            }, 5000);
        } catch (err) {
            // TODO: error handling
            (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(err);
        }
    }
    /**
   * Handler for when the feedback form is completed by the user. This will
   * create and send the feedback message as an event.
   */ async function _handleFeedbackSubmit(feedback) {
        if (!dialog) return;
        // Simple validation for now, just check for non-empty required fields
        const emptyField = [];
        if (options.isNameRequired && !feedback.name) emptyField.push(options.nameLabel);
        if (options.isEmailRequired && !feedback.email) emptyField.push(options.emailLabel);
        if (!feedback.message) emptyField.push(options.messageLabel);
        if (emptyField.length > 0) {
            dialog.showError(`Please enter in the following required fields: ${emptyField.join(', ')}`);
            return;
        }
        const result = await $cbc62a81a802c1f1$var$handleFeedbackSubmit(dialog, feedback);
        // Error submitting feedback
        if (!result) {
            if (options.onSubmitError) options.onSubmitError();
            return;
        }
        // Success
        removeDialog();
        showSuccessMessage();
        if (options.onSubmitSuccess) options.onSubmitSuccess();
    }
    /**
   * Internal handler when dialog is opened
   */ function handleOpenDialog() {
        // Flush replay if integration exists
        const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
        const replay = client && client.getIntegrationByName && client.getIntegrationByName('Replay');
        if (!replay) return;
        replay.flush().catch((err)=>{
            $cbc62a81a802c1f1$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(err);
        });
    }
    /**
   * Displays the default actor
   */ function showActor() {
        actor && actor.show();
    }
    /**
   * Hides the default actor
   */ function hideActor() {
        actor && actor.hide();
    }
    /**
   * Removes the default actor element
   */ function removeActor() {
        actor && actor.el && actor.el.remove();
    }
    /**
   *
   */ function openDialog() {
        try {
            if (dialog) {
                dialog.open();
                isDialogOpen = true;
                if (options.onFormOpen) options.onFormOpen();
                handleOpenDialog();
                return;
            }
            const userKey = options.useSentryUser;
            const scope = (0, $2dfa7d22514dae4c$export$c7be4b0125a10cba)();
            const user = scope && scope.getUser();
            dialog = $cbc62a81a802c1f1$var$Dialog({
                colorScheme: options.colorScheme,
                showBranding: options.showBranding,
                showName: options.showName || options.isNameRequired,
                showEmail: options.showEmail || options.isEmailRequired,
                isNameRequired: options.isNameRequired,
                isEmailRequired: options.isEmailRequired,
                formTitle: options.formTitle,
                cancelButtonLabel: options.cancelButtonLabel,
                submitButtonLabel: options.submitButtonLabel,
                emailLabel: options.emailLabel,
                emailPlaceholder: options.emailPlaceholder,
                messageLabel: options.messageLabel,
                messagePlaceholder: options.messagePlaceholder,
                nameLabel: options.nameLabel,
                namePlaceholder: options.namePlaceholder,
                isRequiredLabel: options.isRequiredLabel,
                defaultName: userKey && user && user[userKey.name] || '',
                defaultEmail: userKey && user && user[userKey.email] || '',
                onClosed: ()=>{
                    showActor();
                    isDialogOpen = false;
                    if (options.onFormClose) options.onFormClose();
                },
                onCancel: ()=>{
                    closeDialog();
                    showActor();
                },
                onSubmit: _handleFeedbackSubmit
            });
            if (!dialog.el) throw new Error('Unable to open Feedback dialog');
            shadow.appendChild(dialog.el);
            // Hides the default actor whenever dialog is opened
            hideActor();
            if (options.onFormOpen) options.onFormOpen();
            handleOpenDialog();
        } catch (err) {
            // TODO: Error handling?
            (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(err);
        }
    }
    /**
   * Closes the dialog
   */ function closeDialog() {
        if (dialog) {
            dialog.close();
            isDialogOpen = false;
            if (options.onFormClose) options.onFormClose();
        }
    }
    /**
   * Removes the dialog element from DOM
   */ function removeDialog() {
        if (dialog) {
            closeDialog();
            const dialogEl = dialog.el;
            dialogEl && dialogEl.remove();
            dialog = undefined;
        }
    }
    /**
   *
   */ function handleActorClick() {
        // Open dialog
        if (!isDialogOpen) openDialog();
        // Hide actor button
        hideActor();
    }
    if (attachTo) attachTo.addEventListener('click', handleActorClick);
    else if (shouldCreateActor) {
        actor = $cbc62a81a802c1f1$var$Actor({
            buttonLabel: options.buttonLabel,
            onClick: handleActorClick
        });
        actor.el && shadow.appendChild(actor.el);
    }
    return {
        get actor () {
            return actor;
        },
        get dialog () {
            return dialog;
        },
        showActor: showActor,
        hideActor: hideActor,
        removeActor: removeActor,
        openDialog: openDialog,
        closeDialog: closeDialog,
        removeDialog: removeDialog
    };
}
const $cbc62a81a802c1f1$var$doc = $cbc62a81a802c1f1$var$WINDOW.document;
const $cbc62a81a802c1f1$export$b3f80fd9e808d6d7 = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $cbc62a81a802c1f1$export$175e500a48a60fd2(options);
};
/**
 * Feedback integration. When added as an integration to the SDK, it will
 * inject a button in the bottom-right corner of the window that opens a
 * feedback modal when clicked.
 *
 * @deprecated Use `feedbackIntegration()` instead.
 */ class $cbc62a81a802c1f1$export$175e500a48a60fd2 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Feedback';
    }
    /**
   * @inheritDoc
   */ /**
   * Feedback configuration options
   */ /**
   * Reference to widget element that is created when autoInject is true
   */ /**
   * List of all widgets that are created from the integration
   */ /**
   * Reference to the host element where widget is inserted
   */ /**
   * Refernce to Shadow DOM root
   */ /**
   * Tracks if actor styles have ever been inserted into shadow DOM
   */ constructor({ autoInject: autoInject = true, id: id = 'sentry-feedback', isEmailRequired: isEmailRequired = false, isNameRequired: isNameRequired = false, showBranding: showBranding = true, showEmail: showEmail = true, showName: showName = true, useSentryUser: useSentryUser = {
        email: 'email',
        name: 'username'
    }, themeDark: themeDark, themeLight: themeLight, colorScheme: colorScheme = 'system', buttonLabel: buttonLabel = $cbc62a81a802c1f1$var$ACTOR_LABEL, cancelButtonLabel: cancelButtonLabel = $cbc62a81a802c1f1$var$CANCEL_BUTTON_LABEL, submitButtonLabel: submitButtonLabel = $cbc62a81a802c1f1$var$SUBMIT_BUTTON_LABEL, formTitle: formTitle = $cbc62a81a802c1f1$var$FORM_TITLE, emailPlaceholder: emailPlaceholder = $cbc62a81a802c1f1$var$EMAIL_PLACEHOLDER, emailLabel: emailLabel = $cbc62a81a802c1f1$var$EMAIL_LABEL, messagePlaceholder: messagePlaceholder = $cbc62a81a802c1f1$var$MESSAGE_PLACEHOLDER, messageLabel: messageLabel = $cbc62a81a802c1f1$var$MESSAGE_LABEL, namePlaceholder: namePlaceholder = $cbc62a81a802c1f1$var$NAME_PLACEHOLDER, nameLabel: nameLabel = $cbc62a81a802c1f1$var$NAME_LABEL, isRequiredLabel: isRequiredLabel = $cbc62a81a802c1f1$var$IS_REQUIRED_LABEL, successMessageText: successMessageText = $cbc62a81a802c1f1$var$SUCCESS_MESSAGE_TEXT, onFormClose: onFormClose, onFormOpen: onFormOpen, onSubmitError: onSubmitError, onSubmitSuccess: onSubmitSuccess } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $cbc62a81a802c1f1$export$175e500a48a60fd2.id;
        // tsc fails if these are not initialized explicitly constructor, e.g. can't call `_initialize()`
        this._host = null;
        this._shadow = null;
        this._widget = null;
        this._widgets = new Set();
        this._hasInsertedActorStyles = false;
        this.options = {
            autoInject: autoInject,
            showBranding: showBranding,
            id: id,
            isEmailRequired: isEmailRequired,
            isNameRequired: isNameRequired,
            showEmail: showEmail,
            showName: showName,
            useSentryUser: useSentryUser,
            colorScheme: colorScheme,
            themeDark: {
                ...$cbc62a81a802c1f1$var$DEFAULT_THEME.dark,
                ...themeDark
            },
            themeLight: {
                ...$cbc62a81a802c1f1$var$DEFAULT_THEME.light,
                ...themeLight
            },
            buttonLabel: buttonLabel,
            cancelButtonLabel: cancelButtonLabel,
            submitButtonLabel: submitButtonLabel,
            formTitle: formTitle,
            emailLabel: emailLabel,
            emailPlaceholder: emailPlaceholder,
            messageLabel: messageLabel,
            messagePlaceholder: messagePlaceholder,
            nameLabel: nameLabel,
            namePlaceholder: namePlaceholder,
            isRequiredLabel: isRequiredLabel,
            successMessageText: successMessageText,
            onFormClose: onFormClose,
            onFormOpen: onFormOpen,
            onSubmitError: onSubmitError,
            onSubmitSuccess: onSubmitSuccess
        };
    }
    /**
   * Setup and initialize feedback container
   */ setupOnce() {
        if (!(0, $a3b7b49346b363b5$export$4e09c449d6c407f7)()) return;
        try {
            this._cleanupWidgetIfExists();
            const { autoInject: autoInject } = this.options;
            if (!autoInject) // Nothing to do here
            return;
            this._createWidget(this.options);
        } catch (err) {
            $cbc62a81a802c1f1$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(err);
        }
    }
    /**
   * Allows user to open the dialog box. Creates a new widget if
   * `autoInject` was false, otherwise re-uses the default widget that was
   * created during initialization of the integration.
   */ openDialog() {
        if (!this._widget) this._createWidget({
            ...this.options,
            shouldCreateActor: false
        });
        if (!this._widget) return;
        this._widget.openDialog();
    }
    /**
   * Closes the dialog for the default widget, if it exists
   */ closeDialog() {
        if (!this._widget) // Nothing to do if widget does not exist
        return;
        this._widget.closeDialog();
    }
    /**
   * Adds click listener to attached element to open a feedback dialog
   */ attachTo(el, optionOverrides) {
        try {
            const options = $cbc62a81a802c1f1$var$mergeOptions(this.options, optionOverrides || {});
            return this._ensureShadowHost(options, ({ shadow: shadow })=>{
                const targetEl = typeof el === 'string' ? $cbc62a81a802c1f1$var$doc.querySelector(el) : typeof el.addEventListener === 'function' ? el : null;
                if (!targetEl) {
                    $cbc62a81a802c1f1$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('[Feedback] Unable to attach to target element');
                    return null;
                }
                const widget = $cbc62a81a802c1f1$var$createWidget({
                    shadow: shadow,
                    options: options,
                    attachTo: targetEl
                });
                this._widgets.add(widget);
                if (!this._widget) this._widget = widget;
                return widget;
            });
        } catch (err) {
            $cbc62a81a802c1f1$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(err);
            return null;
        }
    }
    /**
   * Creates a new widget. Accepts partial options to override any options passed to constructor.
   */ createWidget(optionOverrides) {
        try {
            return this._createWidget($cbc62a81a802c1f1$var$mergeOptions(this.options, optionOverrides || {}));
        } catch (err) {
            $cbc62a81a802c1f1$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(err);
            return null;
        }
    }
    /**
   * Removes a single widget
   */ removeWidget(widget) {
        if (!widget) return false;
        try {
            if (this._widgets.has(widget)) {
                widget.removeActor();
                widget.removeDialog();
                this._widgets.delete(widget);
                if (this._widget === widget) // TODO: is more clean-up needed? e.g. call remove()
                this._widget = null;
                return true;
            }
        } catch (err) {
            $cbc62a81a802c1f1$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(err);
        }
        return false;
    }
    /**
   * Returns the default (first-created) widget
   */ getWidget() {
        return this._widget;
    }
    /**
   * Removes the Feedback integration (including host, shadow DOM, and all widgets)
   */ remove() {
        if (this._host) this._host.remove();
        this._initialize();
    }
    /**
   * Initializes values of protected properties
   */ _initialize() {
        this._host = null;
        this._shadow = null;
        this._widget = null;
        this._widgets = new Set();
        this._hasInsertedActorStyles = false;
    }
    /**
   * Clean-up the widget if it already exists in the DOM. This shouldn't happen
   * in prod, but can happen in development with hot module reloading.
   */ _cleanupWidgetIfExists() {
        if (this._host) this.remove();
        const existingFeedback = $cbc62a81a802c1f1$var$doc.querySelector(`#${this.options.id}`);
        if (existingFeedback) existingFeedback.remove();
    }
    /**
   * Creates a new widget, after ensuring shadow DOM exists
   */ _createWidget(options) {
        return this._ensureShadowHost(options, ({ shadow: shadow })=>{
            const widget = $cbc62a81a802c1f1$var$createWidget({
                shadow: shadow,
                options: options
            });
            if (!this._hasInsertedActorStyles && widget.actor) {
                shadow.appendChild($cbc62a81a802c1f1$var$createActorStyles($cbc62a81a802c1f1$var$doc));
                this._hasInsertedActorStyles = true;
            }
            this._widgets.add(widget);
            if (!this._widget) this._widget = widget;
            return widget;
        });
    }
    /**
   * Ensures that shadow DOM exists and is added to the DOM
   */ _ensureShadowHost(options, cb) {
        let needsAppendHost = false;
        // Don't create if it already exists
        if (!this._shadow || !this._host) {
            const { id: id, colorScheme: colorScheme, themeLight: themeLight, themeDark: themeDark } = options;
            const { shadow: shadow, host: host } = $cbc62a81a802c1f1$var$createShadowHost({
                id: id,
                colorScheme: colorScheme,
                themeLight: themeLight,
                themeDark: themeDark
            });
            this._shadow = shadow;
            this._host = host;
            needsAppendHost = true;
        }
        // set data attribute on host for different themes
        this._host.dataset.sentryFeedbackColorscheme = options.colorScheme;
        const result = cb({
            shadow: this._shadow,
            host: this._host
        });
        if (needsAppendHost) $cbc62a81a802c1f1$var$doc.body.appendChild(this._host);
        return result;
    }
}
$cbc62a81a802c1f1$export$175e500a48a60fd2.__initStatic();








const $73f29a8c00de1619$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $73f29a8c00de1619$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $73f29a8c00de1619$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $0820bb2e6cc9979f$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $73f29a8c00de1619$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $73f29a8c00de1619$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $73f29a8c00de1619$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $73f29a8c00de1619$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $73f29a8c00de1619$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $73f29a8c00de1619$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($73f29a8c00de1619$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $f67cb60f8b7520b8$export$8e4e25f54d456511), (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c));
        $73f29a8c00de1619$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $73f29a8c00de1619$export$2d8f5188773bcddd(integration) {
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $73f29a8c00de1619$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $73f29a8c00de1619$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $73f29a8c00de1619$export$2323046b9414659f(fn) {
    return fn;
}


let $009f5c88bbd2ff13$var$originalFunctionToString;
const $009f5c88bbd2ff13$var$INTEGRATION_NAME = 'FunctionToString';
const $009f5c88bbd2ff13$var$SETUP_CLIENTS = new WeakMap();
const $009f5c88bbd2ff13$var$_functionToStringIntegration = ()=>{
    return {
        name: $009f5c88bbd2ff13$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $009f5c88bbd2ff13$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $89b84fdfd1cfae9c$export$e6cc1e135e2092e5)(this);
                    const context = $009f5c88bbd2ff13$var$SETUP_CLIENTS.has((0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $009f5c88bbd2ff13$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $009f5c88bbd2ff13$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $009f5c88bbd2ff13$export$7918117e9202e4fb = (0, $73f29a8c00de1619$export$2323046b9414659f)($009f5c88bbd2ff13$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $009f5c88bbd2ff13$export$da4704525c20ae79 = (0, $73f29a8c00de1619$export$afa219bf23651160)($009f5c88bbd2ff13$var$INTEGRATION_NAME, $009f5c88bbd2ff13$export$7918117e9202e4fb);


const $da298c0570fc4a2c$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $da298c0570fc4a2c$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $da298c0570fc4a2c$var$_getIngestEndpoint(dsn) {
    return `${$da298c0570fc4a2c$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $da298c0570fc4a2c$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $89b84fdfd1cfae9c$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $da298c0570fc4a2c$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $da298c0570fc4a2c$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$da298c0570fc4a2c$var$_getIngestEndpoint(dsn)}?${$da298c0570fc4a2c$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $da298c0570fc4a2c$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $0aaaa6c30c5fe7e9$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$da298c0570fc4a2c$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $7074340826553a9d$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $7074340826553a9d$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $7074340826553a9d$var$INTEGRATION_NAME = 'InboundFilters';
const $7074340826553a9d$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $7074340826553a9d$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $7074340826553a9d$var$_mergeOptions(options, clientOptions);
            return $7074340826553a9d$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $7074340826553a9d$export$cb3c5c2ceb9818ba = (0, $73f29a8c00de1619$export$2323046b9414659f)($7074340826553a9d$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $7074340826553a9d$export$2ffbb5359dcc6be4 = (0, $73f29a8c00de1619$export$afa219bf23651160)($7074340826553a9d$var$INTEGRATION_NAME, $7074340826553a9d$export$cb3c5c2ceb9818ba);
function $7074340826553a9d$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $7074340826553a9d$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $7074340826553a9d$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $7074340826553a9d$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $7074340826553a9d$var$_isSentryError(event)) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $0820bb2e6cc9979f$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($7074340826553a9d$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $0820bb2e6cc9979f$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($7074340826553a9d$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $0820bb2e6cc9979f$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($7074340826553a9d$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $0820bb2e6cc9979f$export$4157119e2b157127)(event)}.\nUrl: ${$7074340826553a9d$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$7074340826553a9d$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $0820bb2e6cc9979f$export$4157119e2b157127)(event)}.\nUrl: ${$7074340826553a9d$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $7074340826553a9d$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $7074340826553a9d$var$_getPossibleEventMessages(event).some((message)=>(0, $e6e4baebb92dff28$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $7074340826553a9d$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $e6e4baebb92dff28$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $7074340826553a9d$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $7074340826553a9d$var$_getEventFilterUrl(event);
    return !url ? false : (0, $e6e4baebb92dff28$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $7074340826553a9d$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $7074340826553a9d$var$_getEventFilterUrl(event);
    return !url ? true : (0, $e6e4baebb92dff28$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $7074340826553a9d$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $935d737b44cdff44$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $0820bb2e6cc9979f$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $7074340826553a9d$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $7074340826553a9d$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $7074340826553a9d$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $7074340826553a9d$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $0820bb2e6cc9979f$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $ec20e29fc539f943$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $935d737b44cdff44$export$16a28057038b10ef) (0, $54d1043b2228e29f$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $54d1043b2228e29f$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $2dfa7d22514dae4c$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $ec20e29fc539f943$export$ecb76f41d43c0e43(client);
    $ec20e29fc539f943$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $ec20e29fc539f943$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $ec20e29fc539f943$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}




/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $5a854423af031358$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $8663cc950bc5605c$export$31499a9cd224b78c)
            })),
        version: (0, $8663cc950bc5605c$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/** An error emitted by Sentry SDKs and related utilities. */ class $c6fd45cff0488a2d$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}










/**
 * Generate bucket key from metric properties.
 */ function $37de77f77bb4f32a$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $37de77f77bb4f32a$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $37de77f77bb4f32a$export$66decd709db01dc8(metricBucketItems) {
    let out = '';
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(',')}` : '';
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $37de77f77bb4f32a$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $37de77f77bb4f32a$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $37de77f77bb4f32a$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
const $37de77f77bb4f32a$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        '\\u{7c}'
    ],
    [
        ',',
        '\\u{2c}'
    ]
];
function $37de77f77bb4f32a$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $37de77f77bb4f32a$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $37de77f77bb4f32a$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $37de77f77bb4f32a$var$getCharOrReplacement(char), '');
}
/**
 * Sanitizes tags.
 */ function $37de77f77bb4f32a$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $37de77f77bb4f32a$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $37de77f77bb4f32a$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $c01a5628f602ed21$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(dsn);
    const item = $c01a5628f602ed21$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $e49341fc8a37f226$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $c01a5628f602ed21$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $37de77f77bb4f32a$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $640fc7d84f5323a0$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $640fc7d84f5323a0$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $0aaaa6c30c5fe7e9$export$128827c3562ec0cb)(options.dsn);
        else (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $da298c0570fc4a2c$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $0820bb2e6cc9979f$export$6de4ffac6a2f1098)(exception)) {
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log($640fc7d84f5323a0$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $4431a087fbf663bd$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $4431a087fbf663bd$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $0820bb2e6cc9979f$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log($640fc7d84f5323a0$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $68d2f9a36f0e7f5b$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $d300f9ef2197f7c0$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $73f29a8c00de1619$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $73f29a8c00de1619$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $ed6d689869770b05$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $e49341fc8a37f226$export$d650323442802f6f)(env, (0, $e49341fc8a37f226$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $ed6d689869770b05$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $c01a5628f602ed21$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $73f29a8c00de1619$export$51abed9797baa598)(this, integrations);
        (0, $73f29a8c00de1619$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $68d2f9a36f0e7f5b$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $d300f9ef2197f7c0$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $c4ea612155b0bcfa$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        return (0, $c16ffd4bab406a01$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $da440eefa7483dd5$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $935d737b44cdff44$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $640fc7d84f5323a0$var$isTransactionEvent(event);
        const isError = $640fc7d84f5323a0$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $d300f9ef2197f7c0$export$78e43115b553f358)(new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $640fc7d84f5323a0$var$processBeforeSend(options, prepared, hint);
            return $640fc7d84f5323a0$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('Error while sending event:', reason);
        });
        else (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $640fc7d84f5323a0$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $4431a087fbf663bd$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $4431a087fbf663bd$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $4431a087fbf663bd$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $640fc7d84f5323a0$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($640fc7d84f5323a0$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($640fc7d84f5323a0$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $640fc7d84f5323a0$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $640fc7d84f5323a0$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $640fc7d84f5323a0$export$9aac0b9f77928fbf(callback) {
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $6aa03ff1f717d06a$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $9596c1ede1884e50$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $e49341fc8a37f226$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $7eDcu = parcelRequire("7eDcu");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $01ed1ffdc00026d9$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $36956b5a37b0d668$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $36956b5a37b0d668$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $36956b5a37b0d668$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $36956b5a37b0d668$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $4431a087fbf663bd$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $36956b5a37b0d668$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $e1a46ce691765a57$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $36956b5a37b0d668$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $36956b5a37b0d668$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $36956b5a37b0d668$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $36956b5a37b0d668$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $36956b5a37b0d668$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $36956b5a37b0d668$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $36956b5a37b0d668$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($36956b5a37b0d668$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $36956b5a37b0d668$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $36956b5a37b0d668$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $36956b5a37b0d668$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $0820bb2e6cc9979f$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $d300f9ef2197f7c0$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $36956b5a37b0d668$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $36956b5a37b0d668$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $d300f9ef2197f7c0$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $36956b5a37b0d668$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $4431a087fbf663bd$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $36956b5a37b0d668$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $4431a087fbf663bd$export$ef9e2056653f0c8e)(exception) || (0, $4431a087fbf663bd$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $36956b5a37b0d668$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $4431a087fbf663bd$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $36956b5a37b0d668$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $0820bb2e6cc9979f$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $4431a087fbf663bd$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $36956b5a37b0d668$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $4431a087fbf663bd$export$53b83ca8eaab0383)(exception) || (0, $4431a087fbf663bd$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $36956b5a37b0d668$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $0820bb2e6cc9979f$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $36956b5a37b0d668$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $0820bb2e6cc9979f$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $0820bb2e6cc9979f$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $36956b5a37b0d668$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $36956b5a37b0d668$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $4431a087fbf663bd$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $36956b5a37b0d668$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $89b84fdfd1cfae9c$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $4431a087fbf663bd$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $4431a087fbf663bd$export$9671ea99bd126ace)(exception)) {
        const className = $36956b5a37b0d668$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $36956b5a37b0d668$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}





const $b69ee834d2d8bdf6$export$56d8a8a25bd48b81 = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1);
let $b69ee834d2d8bdf6$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $b69ee834d2d8bdf6$export$b79738ab10c590b2() {
    return $b69ee834d2d8bdf6$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $b69ee834d2d8bdf6$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $b69ee834d2d8bdf6$var$ignoreOnError++;
    setTimeout(()=>{
        $b69ee834d2d8bdf6$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $b69ee834d2d8bdf6$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $89b84fdfd1cfae9c$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$b69ee834d2d8bdf6$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $b69ee834d2d8bdf6$export$1265a142ff5ba165();
            (0, $2dfa7d22514dae4c$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $0820bb2e6cc9979f$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $0820bb2e6cc9979f$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $2dfa7d22514dae4c$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $89b84fdfd1cfae9c$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $89b84fdfd1cfae9c$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $23d98c5976bbbe60$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $23d98c5976bbbe60$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $e49341fc8a37f226$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $23d98c5976bbbe60$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $7b33da84303847bc$export$1df9218a526d318d extends (0, $640fc7d84f5323a0$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $7eDcu.getSDKSource)();
        (0, $5a854423af031358$export$b9f95b027256052c)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document) (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $36956b5a37b0d668$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $36956b5a37b0d668$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $23d98c5976bbbe60$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $6aa03ff1f717d06a$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $0aaaa6c30c5fe7e9$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









const $5ebfc0024cb31bca$var$WINDOW = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1);
const $5ebfc0024cb31bca$var$DEBOUNCE_DURATION = 1000;
let $5ebfc0024cb31bca$var$debounceTimerID;
let $5ebfc0024cb31bca$var$lastCapturedEventType;
let $5ebfc0024cb31bca$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5ebfc0024cb31bca$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $f5968277b08509e3$export$a4e09611e30da72e)(type, handler);
    (0, $f5968277b08509e3$export$e18d6c5462c01368)(type, $5ebfc0024cb31bca$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $5ebfc0024cb31bca$export$3014bbf0af0e1d4a() {
    if (!$5ebfc0024cb31bca$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $f5968277b08509e3$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $5ebfc0024cb31bca$var$makeDOMEventHandler(triggerDOMHandler, true);
    $5ebfc0024cb31bca$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $5ebfc0024cb31bca$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $5ebfc0024cb31bca$var$WINDOW[target] && $5ebfc0024cb31bca$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $5ebfc0024cb31bca$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $5ebfc0024cb31bca$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $5ebfc0024cb31bca$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $5ebfc0024cb31bca$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $5ebfc0024cb31bca$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $5ebfc0024cb31bca$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $5ebfc0024cb31bca$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($5ebfc0024cb31bca$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $89b84fdfd1cfae9c$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $89b84fdfd1cfae9c$export$e73679ffaf56810e)(target, '_sentryId', (0, $0820bb2e6cc9979f$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$5ebfc0024cb31bca$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $5ebfc0024cb31bca$var$lastCapturedEventType = event.type;
            $5ebfc0024cb31bca$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($5ebfc0024cb31bca$var$debounceTimerID);
        $5ebfc0024cb31bca$var$debounceTimerID = $5ebfc0024cb31bca$var$WINDOW.setTimeout(()=>{
            $5ebfc0024cb31bca$var$lastCapturedEventTargetId = undefined;
            $5ebfc0024cb31bca$var$lastCapturedEventType = undefined;
        }, $5ebfc0024cb31bca$var$DEBOUNCE_DURATION);
    };
}
function $5ebfc0024cb31bca$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f7aa85832e3a3d95$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $f5968277b08509e3$export$a4e09611e30da72e)(type, handler);
    (0, $f5968277b08509e3$export$e18d6c5462c01368)(type, $f7aa85832e3a3d95$var$instrumentConsole);
}
function $f7aa85832e3a3d95$var$instrumentConsole() {
    if (!('console' in (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1))) return;
    (0, $54d1043b2228e29f$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).console)) return;
        (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)((0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $54d1043b2228e29f$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $f5968277b08509e3$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $54d1043b2228e29f$export$77c4ce905194557b)[level];
                log && log.apply((0, $4e20afe4f778c343$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $c5b6d9b7617d0f9a$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $c5b6d9b7617d0f9a$export$e01cef29b4327697(level) {
    return $c5b6d9b7617d0f9a$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $c5b6d9b7617d0f9a$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $c5b6d9b7617d0f9a$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $355f8d9981d566ef$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $355f8d9981d566ef$var$INTEGRATION_NAME = 'Breadcrumbs';
const $355f8d9981d566ef$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $355f8d9981d566ef$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $f7aa85832e3a3d95$export$1d6e0d073f9e6723)($355f8d9981d566ef$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $5ebfc0024cb31bca$export$5aeffd3db2cf9df7)($355f8d9981d566ef$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $bc641309b3f67a9f$export$26ace48dd54c9aea)($355f8d9981d566ef$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $f72b9d1319ab84b6$export$f75d3c772c923df0)($355f8d9981d566ef$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $3d019c6a05cabdc5$export$3f18c56c58114e75)($355f8d9981d566ef$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $355f8d9981d566ef$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $355f8d9981d566ef$export$c079d904b326663a = (0, $73f29a8c00de1619$export$2323046b9414659f)($355f8d9981d566ef$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $355f8d9981d566ef$export$2dc68d50d56fbbd = (0, $73f29a8c00de1619$export$afa219bf23651160)($355f8d9981d566ef$var$INTEGRATION_NAME, $355f8d9981d566ef$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $355f8d9981d566ef$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)() !== client) return;
        (0, $2dfa7d22514dae4c$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $0820bb2e6cc9979f$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $355f8d9981d566ef$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $355f8d9981d566ef$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$355f8d9981d566ef$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$355f8d9981d566ef$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $355f8d9981d566ef$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $355f8d9981d566ef$var$_isEvent(event) ? event.target : event;
            target = (0, $a9dceb93bbd7f017$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $a9dceb93bbd7f017$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $2dfa7d22514dae4c$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $355f8d9981d566ef$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $c5b6d9b7617d0f9a$export$d771ef054122c30a)(handlerData.level),
            message: (0, $e6e4baebb92dff28$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $e6e4baebb92dff28$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $2dfa7d22514dae4c$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $355f8d9981d566ef$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $bc641309b3f67a9f$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $2dfa7d22514dae4c$export$efda9a273d7a036d)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $355f8d9981d566ef$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $2dfa7d22514dae4c$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $2dfa7d22514dae4c$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $355f8d9981d566ef$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $7da207ca9fea49e7$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $2dfa7d22514dae4c$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $355f8d9981d566ef$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $64a102a9031d7a8b$var$INTEGRATION_NAME = 'Dedupe';
const $64a102a9031d7a8b$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $64a102a9031d7a8b$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($64a102a9031d7a8b$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $64a102a9031d7a8b$export$6d39aa44cd0c7567 = (0, $73f29a8c00de1619$export$2323046b9414659f)($64a102a9031d7a8b$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $64a102a9031d7a8b$export$688d98c249d31ad3 = (0, $73f29a8c00de1619$export$afa219bf23651160)($64a102a9031d7a8b$var$INTEGRATION_NAME, $64a102a9031d7a8b$export$6d39aa44cd0c7567);
function $64a102a9031d7a8b$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($64a102a9031d7a8b$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($64a102a9031d7a8b$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $64a102a9031d7a8b$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$64a102a9031d7a8b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$64a102a9031d7a8b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $64a102a9031d7a8b$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $64a102a9031d7a8b$var$_getExceptionFromEvent(previousEvent);
    const currentException = $64a102a9031d7a8b$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$64a102a9031d7a8b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$64a102a9031d7a8b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $64a102a9031d7a8b$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $64a102a9031d7a8b$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $64a102a9031d7a8b$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $64a102a9031d7a8b$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $64a102a9031d7a8b$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $64a102a9031d7a8b$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}







/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $ed3134e690fd7f16$var$INTEGRATION_NAME = 'GlobalHandlers';
const $ed3134e690fd7f16$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $ed3134e690fd7f16$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $ed3134e690fd7f16$var$_installGlobalOnErrorHandler(client);
                $ed3134e690fd7f16$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $ed3134e690fd7f16$var$_installGlobalOnUnhandledRejectionHandler(client);
                $ed3134e690fd7f16$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $ed3134e690fd7f16$export$66acc70e8cf2b71a = (0, $73f29a8c00de1619$export$2323046b9414659f)($ed3134e690fd7f16$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ed3134e690fd7f16$export$204155decbc90e5a = (0, $73f29a8c00de1619$export$afa219bf23651160)($ed3134e690fd7f16$var$INTEGRATION_NAME, $ed3134e690fd7f16$export$66acc70e8cf2b71a);
function $ed3134e690fd7f16$var$_installGlobalOnErrorHandler(client) {
    (0, $b401474715fe56c0$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ed3134e690fd7f16$var$getOptions();
        if ((0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)() !== client || (0, $b69ee834d2d8bdf6$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $4431a087fbf663bd$export$844ec244b1367d54)(msg) ? $ed3134e690fd7f16$var$_eventFromIncompleteOnError(msg, url, line, column) : $ed3134e690fd7f16$var$_enhanceEventWithInitialFrame((0, $36956b5a37b0d668$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $2dfa7d22514dae4c$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $ed3134e690fd7f16$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $3c7bd95e794e060c$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ed3134e690fd7f16$var$getOptions();
        if ((0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)() !== client || (0, $b69ee834d2d8bdf6$export$b79738ab10c590b2)()) return;
        const error = $ed3134e690fd7f16$var$_getUnhandledRejectionError(e);
        const event = (0, $4431a087fbf663bd$export$c3825b437cbdea5c)(error) ? $ed3134e690fd7f16$var$_eventFromRejectionWithPrimitive(error) : (0, $36956b5a37b0d668$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $2dfa7d22514dae4c$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $ed3134e690fd7f16$var$_getUnhandledRejectionError(error) {
    if ((0, $4431a087fbf663bd$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $ed3134e690fd7f16$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ed3134e690fd7f16$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $4431a087fbf663bd$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $ed3134e690fd7f16$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ed3134e690fd7f16$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $4431a087fbf663bd$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $a9dceb93bbd7f017$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $ed3134e690fd7f16$var$globalHandlerLog(type) {
    (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $ed3134e690fd7f16$var$getOptions() {
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $2dac98dc53011638$var$INTEGRATION_NAME = 'HttpContext';
const $2dac98dc53011638$var$_httpContextIntegration = ()=>{
    return {
        name: $2dac98dc53011638$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).navigator && !(0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).location && !(0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).location && (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $2dac98dc53011638$export$1378794447170364 = (0, $73f29a8c00de1619$export$2323046b9414659f)($2dac98dc53011638$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $2dac98dc53011638$export$5d2ee9a544b09a94 = (0, $73f29a8c00de1619$export$afa219bf23651160)($2dac98dc53011638$var$INTEGRATION_NAME, $2dac98dc53011638$export$1378794447170364);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $bd661dbf8877f50f$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $4431a087fbf663bd$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $bd661dbf8877f50f$var$truncateAggregateExceptions($bd661dbf8877f50f$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $bd661dbf8877f50f$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $4431a087fbf663bd$export$49034edbe6b62415)(error[key], Error)) {
        $bd661dbf8877f50f$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $bd661dbf8877f50f$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $bd661dbf8877f50f$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $4431a087fbf663bd$export$49034edbe6b62415)(childError, Error)) {
            $bd661dbf8877f50f$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $bd661dbf8877f50f$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $bd661dbf8877f50f$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $bd661dbf8877f50f$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $bd661dbf8877f50f$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $bd661dbf8877f50f$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $e6e4baebb92dff28$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $06bb7854fa0f7190$var$DEFAULT_KEY = 'cause';
const $06bb7854fa0f7190$var$DEFAULT_LIMIT = 5;
const $06bb7854fa0f7190$var$INTEGRATION_NAME = 'LinkedErrors';
const $06bb7854fa0f7190$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $06bb7854fa0f7190$var$DEFAULT_LIMIT;
    const key = options.key || $06bb7854fa0f7190$var$DEFAULT_KEY;
    return {
        name: $06bb7854fa0f7190$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $bd661dbf8877f50f$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $36956b5a37b0d668$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $06bb7854fa0f7190$export$ebabb00eb7f3a395 = (0, $73f29a8c00de1619$export$2323046b9414659f)($06bb7854fa0f7190$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $06bb7854fa0f7190$export$8d1e60aaf616fb4f = (0, $73f29a8c00de1619$export$afa219bf23651160)($06bb7854fa0f7190$var$INTEGRATION_NAME, $06bb7854fa0f7190$export$ebabb00eb7f3a395);





const $82c2736be09e13bf$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $82c2736be09e13bf$var$INTEGRATION_NAME = 'TryCatch';
const $82c2736be09e13bf$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $82c2736be09e13bf$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81), 'setTimeout', $82c2736be09e13bf$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81), 'setInterval', $82c2736be09e13bf$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81), 'requestAnimationFrame', $82c2736be09e13bf$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81)) (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $82c2736be09e13bf$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $82c2736be09e13bf$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($82c2736be09e13bf$var$_wrapEventTarget);
            }
        }
    };
};
const $82c2736be09e13bf$export$59bfe9f1c76150e = (0, $73f29a8c00de1619$export$2323046b9414659f)($82c2736be09e13bf$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $82c2736be09e13bf$export$f1a018517668e6d3 = (0, $73f29a8c00de1619$export$afa219bf23651160)($82c2736be09e13bf$var$INTEGRATION_NAME, $82c2736be09e13bf$export$59bfe9f1c76150e);
function $82c2736be09e13bf$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $4e39c8ebcb5dcbe2$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $82c2736be09e13bf$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $4e39c8ebcb5dcbe2$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $82c2736be09e13bf$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $4e39c8ebcb5dcbe2$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $89b84fdfd1cfae9c$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $4e39c8ebcb5dcbe2$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $82c2736be09e13bf$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $4e39c8ebcb5dcbe2$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $4e39c8ebcb5dcbe2$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION = '?';
const $8b14e65fd7f0660b$var$OPERA10_PRIORITY = 10;
const $8b14e65fd7f0660b$var$OPERA11_PRIORITY = 20;
const $8b14e65fd7f0660b$var$CHROME_PRIORITY = 30;
const $8b14e65fd7f0660b$var$WINJS_PRIORITY = 40;
const $8b14e65fd7f0660b$var$GECKO_PRIORITY = 50;
function $8b14e65fd7f0660b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $8b14e65fd7f0660b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $8b14e65fd7f0660b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $8b14e65fd7f0660b$var$chromeStackParserFn = (line)=>{
    const parts = $8b14e65fd7f0660b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $8b14e65fd7f0660b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $8b14e65fd7f0660b$var$extractSafariExtensionDetails(parts[1] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION, parts[2]);
        return $8b14e65fd7f0660b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $8b14e65fd7f0660b$export$263a749fff749872 = [
    $8b14e65fd7f0660b$var$CHROME_PRIORITY,
    $8b14e65fd7f0660b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $8b14e65fd7f0660b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $8b14e65fd7f0660b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $8b14e65fd7f0660b$var$gecko = (line)=>{
    const parts = $8b14e65fd7f0660b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $8b14e65fd7f0660b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION;
        [func, filename] = $8b14e65fd7f0660b$var$extractSafariExtensionDetails(func, filename);
        return $8b14e65fd7f0660b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $8b14e65fd7f0660b$export$cdba47a5dd2804d = [
    $8b14e65fd7f0660b$var$GECKO_PRIORITY,
    $8b14e65fd7f0660b$var$gecko
];
const $8b14e65fd7f0660b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $8b14e65fd7f0660b$var$winjs = (line)=>{
    const parts = $8b14e65fd7f0660b$var$winjsRegex.exec(line);
    return parts ? $8b14e65fd7f0660b$var$createFrame(parts[2], parts[1] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $8b14e65fd7f0660b$export$179460296da408e8 = [
    $8b14e65fd7f0660b$var$WINJS_PRIORITY,
    $8b14e65fd7f0660b$var$winjs
];
const $8b14e65fd7f0660b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $8b14e65fd7f0660b$var$opera10 = (line)=>{
    const parts = $8b14e65fd7f0660b$var$opera10Regex.exec(line);
    return parts ? $8b14e65fd7f0660b$var$createFrame(parts[2], parts[3] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $8b14e65fd7f0660b$export$f892b52c880ffc7a = [
    $8b14e65fd7f0660b$var$OPERA10_PRIORITY,
    $8b14e65fd7f0660b$var$opera10
];
const $8b14e65fd7f0660b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $8b14e65fd7f0660b$var$opera11 = (line)=>{
    const parts = $8b14e65fd7f0660b$var$opera11Regex.exec(line);
    return parts ? $8b14e65fd7f0660b$var$createFrame(parts[5], parts[3] || parts[4] || $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $8b14e65fd7f0660b$export$af11af13f09fb0dc = [
    $8b14e65fd7f0660b$var$OPERA11_PRIORITY,
    $8b14e65fd7f0660b$var$opera11
];
const $8b14e65fd7f0660b$export$7197c0fe6554c079 = [
    $8b14e65fd7f0660b$export$263a749fff749872,
    $8b14e65fd7f0660b$export$cdba47a5dd2804d,
    $8b14e65fd7f0660b$export$179460296da408e8
];
const $8b14e65fd7f0660b$export$2b2b997d81bf3907 = (0, $4e39c8ebcb5dcbe2$export$a5739666fb2d03d4)(...$8b14e65fd7f0660b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $8b14e65fd7f0660b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $8b14e65fd7f0660b$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $d8edbed396e0ce87$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $d8edbed396e0ce87$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $d8edbed396e0ce87$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $d8edbed396e0ce87$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $d8edbed396e0ce87$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $d8edbed396e0ce87$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $d8edbed396e0ce87$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $d8edbed396e0ce87$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $89d0dcf1088279a8$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $d300f9ef2197f7c0$export$78e43115b553f358)(new (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $d300f9ef2197f7c0$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $d300f9ef2197f7c0$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $e5443b9a37f1db5b$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $e5443b9a37f1db5b$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $89d0dcf1088279a8$export$85a4f67f852183e6)(options.bufferSize || $e5443b9a37f1db5b$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $e49341fc8a37f226$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $e49341fc8a37f226$export$b11169581eeaf237)(type);
            if ((0, $d8edbed396e0ce87$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $e5443b9a37f1db5b$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $d300f9ef2197f7c0$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $e49341fc8a37f226$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $e49341fc8a37f226$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $e5443b9a37f1db5b$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $e49341fc8a37f226$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $e49341fc8a37f226$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $d8edbed396e0ce87$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $c6fd45cff0488a2d$export$5949942ba2a7c0e2)) {
                (0, $935d737b44cdff44$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $d300f9ef2197f7c0$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $e5443b9a37f1db5b$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $89ea36f69881f583$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $89ea36f69881f583$export$8be2119ce08e3379() {
    if ($89ea36f69881f583$var$cachedFetchImpl) return $89ea36f69881f583$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $66e623382a10017c$export$18cf36ed71d733e7)((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).fetch)) return $89ea36f69881f583$var$cachedFetchImpl = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).fetch.bind((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81));
    const document = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $89ea36f69881f583$var$cachedFetchImpl = fetchImpl.bind((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $89ea36f69881f583$export$d499686d2dd738c6() {
    $89ea36f69881f583$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $99d026d71c642708$export$b2311068c46d7cc8(options, nativeFetch = (0, $89ea36f69881f583$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $89ea36f69881f583$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $d300f9ef2197f7c0$export$78e43115b553f358)(e);
        }
    }
    return (0, $e5443b9a37f1db5b$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $ca2901e77e0aacab$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $ca2901e77e0aacab$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $d300f9ef2197f7c0$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $ca2901e77e0aacab$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $e5443b9a37f1db5b$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $3892e5b7960d5b8e$export$5ef831fccfce35e5 = [
    (0, $7074340826553a9d$export$cb3c5c2ceb9818ba)(),
    (0, $009f5c88bbd2ff13$export$7918117e9202e4fb)(),
    (0, $82c2736be09e13bf$export$59bfe9f1c76150e)(),
    (0, $355f8d9981d566ef$export$c079d904b326663a)(),
    (0, $ed3134e690fd7f16$export$66acc70e8cf2b71a)(),
    (0, $06bb7854fa0f7190$export$ebabb00eb7f3a395)(),
    (0, $64a102a9031d7a8b$export$6d39aa44cd0c7567)(),
    (0, $2dac98dc53011638$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $3892e5b7960d5b8e$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$3892e5b7960d5b8e$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $3892e5b7960d5b8e$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $3892e5b7960d5b8e$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $4e39c8ebcb5dcbe2$export$1d5cf88b347146d4)(options.stackParser || (0, $8b14e65fd7f0660b$export$2b2b997d81bf3907)),
        integrations: (0, $73f29a8c00de1619$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $66e623382a10017c$export$edf3cb81fd7d2a3e)() ? (0, $99d026d71c642708$export$b2311068c46d7cc8) : (0, $ca2901e77e0aacab$export$5e1441cee30d5a39))
    };
    (0, $ec20e29fc539f943$export$5333c3f1c58d9bc1)((0, $7b33da84303847bc$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $3892e5b7960d5b8e$var$startSessionTracking();
}
const $3892e5b7960d5b8e$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $c4ea612155b0bcfa$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document) {
        (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $da298c0570fc4a2c$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document.head || (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $3892e5b7960d5b8e$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $3892e5b7960d5b8e$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3892e5b7960d5b8e$export$4997ffc0176396a6(fn) {
    return (0, $b69ee834d2d8bdf6$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $3892e5b7960d5b8e$var$startSessionTracking() {
    if (typeof (0, $b69ee834d2d8bdf6$export$56d8a8a25bd48b81).document === 'undefined') {
        (0, $01ed1ffdc00026d9$export$16a28057038b10ef) && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $2dfa7d22514dae4c$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $2dfa7d22514dae4c$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $3d019c6a05cabdc5$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $2dfa7d22514dae4c$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $2dfa7d22514dae4c$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $3892e5b7960d5b8e$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $544cd44fd65bbdfa$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
function $05579b125d50bf43$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $05579b125d50bf43$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $05579b125d50bf43$var$checkDsn(url, dsn) || $05579b125d50bf43$var$checkTunnel(url, tunnel);
}
function $05579b125d50bf43$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $05579b125d50bf43$var$removeTrailingSlash(url) === $05579b125d50bf43$var$removeTrailingSlash(tunnel);
}
function $05579b125d50bf43$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $05579b125d50bf43$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function $05579b125d50bf43$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $a768bc6f321b7e3d$var$WINDOW = (0, $4e20afe4f778c343$export$f1a6cdb1459e81d1);
const $a768bc6f321b7e3d$var$REPLAY_SESSION_KEY = 'sentryReplaySession';
const $a768bc6f321b7e3d$var$REPLAY_EVENT_NAME = 'replay_event';
const $a768bc6f321b7e3d$var$UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';
// The idle limit for a session after which recording is paused.
const $a768bc6f321b7e3d$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $a768bc6f321b7e3d$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $a768bc6f321b7e3d$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $a768bc6f321b7e3d$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $a768bc6f321b7e3d$var$BUFFER_CHECKOUT_TIME = 60000;
const $a768bc6f321b7e3d$var$RETRY_BASE_INTERVAL = 5000;
const $a768bc6f321b7e3d$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $a768bc6f321b7e3d$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $a768bc6f321b7e3d$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $a768bc6f321b7e3d$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $a768bc6f321b7e3d$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $a768bc6f321b7e3d$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $a768bc6f321b7e3d$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $a768bc6f321b7e3d$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $a768bc6f321b7e3d$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $a768bc6f321b7e3d$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $a768bc6f321b7e3d$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $a768bc6f321b7e3d$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($a768bc6f321b7e3d$var$NodeType$1 || ($a768bc6f321b7e3d$var$NodeType$1 = {}));
function $a768bc6f321b7e3d$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $a768bc6f321b7e3d$var$isShadowRoot(n) {
    const host = $a768bc6f321b7e3d$var$_optionalChain$5([
        n,
        'optionalAccess',
        (_)=>_.host
    ]);
    return Boolean($a768bc6f321b7e3d$var$_optionalChain$5([
        host,
        'optionalAccess',
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $a768bc6f321b7e3d$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === '[object ShadowRoot]';
}
function $a768bc6f321b7e3d$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(' background-clip: text;') && !cssText.includes(' -webkit-background-clip: text;')) cssText = cssText.replace(' background-clip: text;', ' -webkit-background-clip: text; background-clip: text;');
    return cssText;
}
function $a768bc6f321b7e3d$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        '@import',
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === '') statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(' ') + ';';
}
function $a768bc6f321b7e3d$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $a768bc6f321b7e3d$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $a768bc6f321b7e3d$var$stringifyRule).join('')) : null;
    } catch (error) {
        return null;
    }
}
function $a768bc6f321b7e3d$var$stringifyRule(rule) {
    let importStringified;
    if ($a768bc6f321b7e3d$var$isCSSImportRule(rule)) try {
        importStringified = $a768bc6f321b7e3d$var$stringifyStylesheet(rule.styleSheet) || $a768bc6f321b7e3d$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($a768bc6f321b7e3d$var$isCSSStyleRule(rule) && rule.selectorText.includes(':')) return $a768bc6f321b7e3d$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $a768bc6f321b7e3d$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, '$1\\$2');
}
function $a768bc6f321b7e3d$var$isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function $a768bc6f321b7e3d$var$isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
class $a768bc6f321b7e3d$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $a768bc6f321b7e3d$var$_optionalChain$5([
            this,
            'access',
            (_3)=>_3.getMeta,
            'call',
            (_4)=>_4(n),
            'optionalAccess',
            (_5)=>_5.id
        ]);
        return $a768bc6f321b7e3d$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $a768bc6f321b7e3d$var$createMirror() {
    return new $a768bc6f321b7e3d$var$Mirror();
}
function $a768bc6f321b7e3d$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === 'OPTION') tagName = 'SELECT';
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === 'password' || tagName === 'INPUT' && !type && maskInputOptions['text']);
}
function $a768bc6f321b7e3d$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || '';
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return '*'.repeat(text.length);
}
function $a768bc6f321b7e3d$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $a768bc6f321b7e3d$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $a768bc6f321b7e3d$var$ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function $a768bc6f321b7e3d$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $a768bc6f321b7e3d$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$a768bc6f321b7e3d$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $a768bc6f321b7e3d$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute('data-rr-is-password') ? 'password' : type ? $a768bc6f321b7e3d$var$toLowerCase(type) : null;
}
function $a768bc6f321b7e3d$var$getInputValue(el, tagName, type) {
    if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) return el.getAttribute('value') || '';
    return el.value;
}
let $a768bc6f321b7e3d$var$_id = 1;
const $a768bc6f321b7e3d$var$tagNameRegex = new RegExp('[^a-z0-9-_:]');
const $a768bc6f321b7e3d$var$IGNORED_NODE = -2;
function $a768bc6f321b7e3d$var$genId() {
    return $a768bc6f321b7e3d$var$_id++;
}
function $a768bc6f321b7e3d$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return 'form';
    const processedTagName = $a768bc6f321b7e3d$var$toLowerCase(element.tagName);
    if ($a768bc6f321b7e3d$var$tagNameRegex.test(processedTagName)) return 'div';
    return processedTagName;
}
function $a768bc6f321b7e3d$var$extractOrigin(url) {
    let origin = '';
    if (url.indexOf('//') > -1) origin = url.split('/').slice(0, 3).join('/');
    else origin = url.split('/')[0];
    origin = origin.split('?')[0];
    return origin;
}
let $a768bc6f321b7e3d$var$canvasService;
let $a768bc6f321b7e3d$var$canvasCtx;
const $a768bc6f321b7e3d$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $a768bc6f321b7e3d$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $a768bc6f321b7e3d$var$URL_WWW_MATCH = /^www\..*/i;
const $a768bc6f321b7e3d$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $a768bc6f321b7e3d$var$absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace($a768bc6f321b7e3d$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || '';
        if (!filePath) return origin;
        if ($a768bc6f321b7e3d$var$URL_PROTOCOL_MATCH.test(filePath) || $a768bc6f321b7e3d$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($a768bc6f321b7e3d$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === '/') return `url(${maybeQuote}${$a768bc6f321b7e3d$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split('/');
        const parts = filePath.split('/');
        stack.pop();
        for (const part of parts){
            if (part === '.') continue;
            else if (part === '..') stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
    });
}
const $a768bc6f321b7e3d$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $a768bc6f321b7e3d$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $a768bc6f321b7e3d$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    const output = [];
    while(true){
        collectCharacters($a768bc6f321b7e3d$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($a768bc6f321b7e3d$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = $a768bc6f321b7e3d$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = '';
            url = $a768bc6f321b7e3d$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === '(') inParens = true;
                } else if (c === ')') inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function $a768bc6f321b7e3d$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') return attributeValue;
    const a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function $a768bc6f321b7e3d$var$isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function $a768bc6f321b7e3d$var$getHref() {
    const a = document.createElement('a');
    a.href = '';
    return a.href;
}
function $a768bc6f321b7e3d$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === 'src' || name === 'href' && !(tagName === 'use' && value[0] === '#')) return $a768bc6f321b7e3d$var$absoluteToDoc(doc, value);
    else if (name === 'xlink:href' && value[0] !== '#') return $a768bc6f321b7e3d$var$absoluteToDoc(doc, value);
    else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) return $a768bc6f321b7e3d$var$absoluteToDoc(doc, value);
    else if (name === 'srcset') return $a768bc6f321b7e3d$var$getAbsoluteSrcsetString(doc, value);
    else if (name === 'style') return $a768bc6f321b7e3d$var$absoluteToStylesheet(value, $a768bc6f321b7e3d$var$getHref());
    else if (tagName === 'object' && name === 'data') return $a768bc6f321b7e3d$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === 'function') return maskAttributeFn(name, value, element);
    return value;
}
function $a768bc6f321b7e3d$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === 'video' || tagName === 'audio') && name === 'autoplay';
}
function $a768bc6f321b7e3d$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === 'string') {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $a768bc6f321b7e3d$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $a768bc6f321b7e3d$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $a768bc6f321b7e3d$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $a768bc6f321b7e3d$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === 'string') {
                    if (el.matches(`.${className}`)) return true;
                } else if ($a768bc6f321b7e3d$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $a768bc6f321b7e3d$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === 'INPUT') {
            const autocomplete = el.getAttribute('autocomplete');
            const disallowedAutocompleteValues = [
                'current-password',
                'new-password',
                'cc-number',
                'cc-exp',
                'cc-exp-month',
                'cc-exp-year',
                'cc-csc'
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $a768bc6f321b7e3d$var$distanceToMatch(el, $a768bc6f321b7e3d$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $a768bc6f321b7e3d$var$distanceToMatch(el, $a768bc6f321b7e3d$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $a768bc6f321b7e3d$var$distanceToMatch(el, $a768bc6f321b7e3d$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $a768bc6f321b7e3d$var$distanceToMatch(el, $a768bc6f321b7e3d$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $a768bc6f321b7e3d$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = 'about:blank';
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
        setTimeout(listener, 0);
        return iframeEl.addEventListener('load', listener);
    }
    iframeEl.addEventListener('load', listener);
}
function $a768bc6f321b7e3d$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener('load', ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $a768bc6f321b7e3d$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $a768bc6f321b7e3d$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') return {
                type: $a768bc6f321b7e3d$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $a768bc6f321b7e3d$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $a768bc6f321b7e3d$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $a768bc6f321b7e3d$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $a768bc6f321b7e3d$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $a768bc6f321b7e3d$var$NodeType$1.CDATA,
                textContent: '',
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $a768bc6f321b7e3d$var$NodeType$1.Comment,
                textContent: n.textContent || '',
                rootId: rootId
            };
        default:
            return false;
    }
}
function $a768bc6f321b7e3d$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $a768bc6f321b7e3d$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === 'STYLE' ? true : undefined;
    const isScript = parentTagName === 'SCRIPT' ? true : undefined;
    const isTextarea = parentTagName === 'TEXTAREA' ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($a768bc6f321b7e3d$var$_optionalChain$5([
                n,
                'access',
                (_6)=>_6.parentNode,
                'access',
                (_7)=>_7.sheet,
                'optionalAccess',
                (_8)=>_8.cssRules
            ])) textContent = $a768bc6f321b7e3d$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $a768bc6f321b7e3d$var$absoluteToStylesheet(textContent, $a768bc6f321b7e3d$var$getHref());
    }
    if (isScript) textContent = 'SCRIPT_PLACEHOLDER';
    const forceMask = $a768bc6f321b7e3d$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, '*');
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, '*');
    if (parentTagName === 'OPTION' && textContent) {
        const isInputMasked = $a768bc6f321b7e3d$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $a768bc6f321b7e3d$var$maskInputValue({
            isMasked: $a768bc6f321b7e3d$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $a768bc6f321b7e3d$var$NodeType$1.Text,
        textContent: textContent || '',
        isStyle: isStyle,
        rootId: rootId
    };
}
function $a768bc6f321b7e3d$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $a768bc6f321b7e3d$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $a768bc6f321b7e3d$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$a768bc6f321b7e3d$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $a768bc6f321b7e3d$var$transformAttribute(doc, tagName, $a768bc6f321b7e3d$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === 'link' && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $a768bc6f321b7e3d$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $a768bc6f321b7e3d$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
        const cssText = $a768bc6f321b7e3d$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $a768bc6f321b7e3d$var$absoluteToStylesheet(cssText, $a768bc6f321b7e3d$var$getHref());
    }
    if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'option') {
        const el = n;
        const type = $a768bc6f321b7e3d$var$getInputType(el);
        const value = $a768bc6f321b7e3d$var$getInputValue(el, $a768bc6f321b7e3d$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== 'submit' && type !== 'button' && value) {
            const forceMask = $a768bc6f321b7e3d$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $a768bc6f321b7e3d$var$shouldMaskInput({
                type: type,
                tagName: $a768bc6f321b7e3d$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $a768bc6f321b7e3d$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === 'option') {
        if (n.selected && !maskInputOptions['select']) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === 'canvas' && recordCanvas) {
        if (n.__context === '2d') {
            if (!$a768bc6f321b7e3d$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!('__context' in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement('canvas');
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === 'img' && inlineImages) {
        if (!$a768bc6f321b7e3d$var$canvasService) {
            $a768bc6f321b7e3d$var$canvasService = doc.createElement('canvas');
            $a768bc6f321b7e3d$var$canvasCtx = $a768bc6f321b7e3d$var$canvasService.getContext('2d');
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = 'anonymous';
        const recordInlineImage = ()=>{
            image.removeEventListener('load', recordInlineImage);
            try {
                $a768bc6f321b7e3d$var$canvasService.width = image.naturalWidth;
                $a768bc6f321b7e3d$var$canvasService.height = image.naturalHeight;
                $a768bc6f321b7e3d$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $a768bc6f321b7e3d$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute('crossorigin');
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener('load', recordInlineImage);
    }
    if (tagName === 'audio' || tagName === 'video') {
        attributes.rr_mediaState = n.paused ? 'paused' : 'played';
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $a768bc6f321b7e3d$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $a768bc6f321b7e3d$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $a768bc6f321b7e3d$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return '';
    else return maybeAttr.toLowerCase();
}
function $a768bc6f321b7e3d$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $a768bc6f321b7e3d$var$NodeType$1.Comment) return true;
    else if (sn.type === $a768bc6f321b7e3d$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') && sn.attributes.as === 'script' || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && sn.attributes.href.endsWith('.js'))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && ($a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'application-name' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.rel) === 'icon' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) return true;
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords && $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'pinterest')) return true;
            else if (slimDOMOptions.headMetaRobots && ($a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'robots' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'googlebot' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'bingbot')) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'author' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'generator' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'framework' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'publisher' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'progid' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'google-site-verification' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'yandex-verification' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'csrf-token' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'p:domain_verify' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'verify-v1' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'verification' || $a768bc6f321b7e3d$var$lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) return true;
        }
    }
    return false;
}
function $a768bc6f321b7e3d$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $a768bc6f321b7e3d$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($a768bc6f321b7e3d$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $a768bc6f321b7e3d$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) id = $a768bc6f321b7e3d$var$IGNORED_NODE;
    else id = $a768bc6f321b7e3d$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $a768bc6f321b7e3d$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $a768bc6f321b7e3d$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $a768bc6f321b7e3d$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $a768bc6f321b7e3d$var$NodeType$1.Document || serializedNode.type === $a768bc6f321b7e3d$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $a768bc6f321b7e3d$var$NodeType$1.Element && serializedNode.tagName === 'head') preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $a768bc6f321b7e3d$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($a768bc6f321b7e3d$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $a768bc6f321b7e3d$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $a768bc6f321b7e3d$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $a768bc6f321b7e3d$var$isShadowRoot(n.parentNode) && $a768bc6f321b7e3d$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $a768bc6f321b7e3d$var$NodeType$1.Element && serializedNode.tagName === 'iframe') $a768bc6f321b7e3d$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $a768bc6f321b7e3d$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $a768bc6f321b7e3d$var$NodeType$1.Element && serializedNode.tagName === 'link' && serializedNode.attributes.rel === 'stylesheet') $a768bc6f321b7e3d$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $a768bc6f321b7e3d$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $a768bc6f321b7e3d$var$snapshot(n, options) {
    const { mirror: mirror = new $a768bc6f321b7e3d$var$Mirror(), blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = 'rr-mask', unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === 'all',
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $a768bc6f321b7e3d$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $a768bc6f321b7e3d$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $a768bc6f321b7e3d$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $a768bc6f321b7e3d$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $a768bc6f321b7e3d$var$_mirror = {
    map: {},
    getId () {
        console.error($a768bc6f321b7e3d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($a768bc6f321b7e3d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($a768bc6f321b7e3d$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($a768bc6f321b7e3d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($a768bc6f321b7e3d$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) $a768bc6f321b7e3d$var$_mirror = new Proxy($a768bc6f321b7e3d$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === 'map') console.error($a768bc6f321b7e3d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $a768bc6f321b7e3d$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $a768bc6f321b7e3d$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $a768bc6f321b7e3d$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $a768bc6f321b7e3d$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $a768bc6f321b7e3d$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$a768bc6f321b7e3d$var$hookSetter(target, key, original || {}, true);
}
function $a768bc6f321b7e3d$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $a768bc6f321b7e3d$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $a768bc6f321b7e3d$var$nowTimestamp = ()=>new Date().getTime();
function $a768bc6f321b7e3d$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $a768bc6f321b7e3d$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_)=>_.documentElement,
            'access',
            (_2)=>_2.scrollLeft
        ]) || $a768bc6f321b7e3d$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_3)=>_3.body,
            'optionalAccess',
            (_4)=>_4.parentElement,
            'optionalAccess',
            (_5)=>_5.scrollLeft
        ]) || $a768bc6f321b7e3d$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_6)=>_6.body,
            'optionalAccess',
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $a768bc6f321b7e3d$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_8)=>_8.documentElement,
            'access',
            (_9)=>_9.scrollTop
        ]) || $a768bc6f321b7e3d$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_10)=>_10.body,
            'optionalAccess',
            (_11)=>_11.parentElement,
            'optionalAccess',
            (_12)=>_12.scrollTop
        ]) || $a768bc6f321b7e3d$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_13)=>_13.body,
            'optionalAccess',
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $a768bc6f321b7e3d$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $a768bc6f321b7e3d$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $a768bc6f321b7e3d$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $a768bc6f321b7e3d$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $a768bc6f321b7e3d$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $a768bc6f321b7e3d$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $a768bc6f321b7e3d$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $a768bc6f321b7e3d$var$distanceToMatch(el, $a768bc6f321b7e3d$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $a768bc6f321b7e3d$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $a768bc6f321b7e3d$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $a768bc6f321b7e3d$var$IGNORED_NODE;
}
function $a768bc6f321b7e3d$var$isAncestorRemoved(target, mirror) {
    if ($a768bc6f321b7e3d$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $a768bc6f321b7e3d$var$isAncestorRemoved(target.parentNode, mirror);
}
function $a768bc6f321b7e3d$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $a768bc6f321b7e3d$var$polyfill(win = window) {
    if ('NodeList' in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError('1 argument is required');
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $a768bc6f321b7e3d$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}
function $a768bc6f321b7e3d$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === 'LINK' && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute('rel') === 'stylesheet' && mirror.getMeta(n));
}
function $a768bc6f321b7e3d$var$hasShadowRoot(n) {
    return Boolean($a768bc6f321b7e3d$var$_optionalChain$4([
        n,
        'optionalAccess',
        (_18)=>_18.shadowRoot
    ]));
}
class $a768bc6f321b7e3d$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $544cd44fd65bbdfa$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $a768bc6f321b7e3d$var$getShadowHost(n) {
    let shadowHost = null;
    if ($a768bc6f321b7e3d$var$_optionalChain$4([
        n,
        'access',
        (_19)=>_19.getRootNode,
        'optionalCall',
        (_20)=>_20(),
        'optionalAccess',
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $a768bc6f321b7e3d$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $a768bc6f321b7e3d$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $a768bc6f321b7e3d$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $a768bc6f321b7e3d$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $a768bc6f321b7e3d$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $a768bc6f321b7e3d$var$shadowHostInDom(n);
}
const $a768bc6f321b7e3d$var$cachedImplementations = {};
function $a768bc6f321b7e3d$var$getImplementation(name) {
    const cached = $a768bc6f321b7e3d$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === 'function') try {
        const sandbox = document1.createElement('iframe');
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $a768bc6f321b7e3d$var$cachedImplementations[name] = impl.bind(window);
}
function $a768bc6f321b7e3d$var$onRequestAnimationFrame(...rest) {
    return $a768bc6f321b7e3d$var$getImplementation('requestAnimationFrame')(...rest);
}
function $a768bc6f321b7e3d$var$setTimeout$1(...rest) {
    return $a768bc6f321b7e3d$var$getImplementation('setTimeout')(...rest);
}
function $a768bc6f321b7e3d$var$clearTimeout$1(...rest) {
    return $a768bc6f321b7e3d$var$getImplementation('clearTimeout')(...rest);
}
var $a768bc6f321b7e3d$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($a768bc6f321b7e3d$var$EventType || {});
var $a768bc6f321b7e3d$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($a768bc6f321b7e3d$var$IncrementalSource || {});
var $a768bc6f321b7e3d$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($a768bc6f321b7e3d$var$MouseInteractions || {});
var $a768bc6f321b7e3d$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($a768bc6f321b7e3d$var$PointerTypes || {});
function $a768bc6f321b7e3d$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $a768bc6f321b7e3d$var$isNodeInLinkedList(n) {
    return '__ln' in n;
}
class $a768bc6f321b7e3d$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error('Position outside of list range');
        let current = this.head;
        for(let index = 0; index < position; index++)current = $a768bc6f321b7e3d$var$_optionalChain$3([
            current,
            'optionalAccess',
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $a768bc6f321b7e3d$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $a768bc6f321b7e3d$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $a768bc6f321b7e3d$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $a768bc6f321b7e3d$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $a768bc6f321b7e3d$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $a768bc6f321b7e3d$var$IGNORED_NODE;
                while(nextId === $a768bc6f321b7e3d$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$a768bc6f321b7e3d$var$inDom(n)) return;
                const parentId = $a768bc6f321b7e3d$var$isShadowRoot(n.parentNode) ? this.mirror.getId($a768bc6f321b7e3d$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $a768bc6f321b7e3d$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($a768bc6f321b7e3d$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($a768bc6f321b7e3d$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($a768bc6f321b7e3d$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($a768bc6f321b7e3d$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$a768bc6f321b7e3d$var$isAncestorInSet(this.droppedSet, n) && !$a768bc6f321b7e3d$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($a768bc6f321b7e3d$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === 'string') {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split('var(').length === attributes.style.split('var(').length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($a768bc6f321b7e3d$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case 'characterData':
                    {
                        const value = m.target.textContent;
                        if (!$a768bc6f321b7e3d$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $a768bc6f321b7e3d$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $a768bc6f321b7e3d$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, '*') : value,
                            node: m.target
                        });
                        break;
                    }
                case 'attributes':
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === 'value') {
                            const type = $a768bc6f321b7e3d$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $a768bc6f321b7e3d$var$getInputValue(target, tagName, type);
                            const isInputMasked = $a768bc6f321b7e3d$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $a768bc6f321b7e3d$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $a768bc6f321b7e3d$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($a768bc6f321b7e3d$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === 'IFRAME' && attributeName === 'src' && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = 'rr_src';
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') target.setAttribute('data-rr-is-password', 'true');
                        if (!$a768bc6f321b7e3d$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $a768bc6f321b7e3d$var$transformAttribute(this.doc, $a768bc6f321b7e3d$var$toLowerCase(target.tagName), $a768bc6f321b7e3d$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === 'style') {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement('span');
                                if (m.oldValue) old.setAttribute('style', m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === '') item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === '') item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case 'childList':
                    if ($a768bc6f321b7e3d$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $a768bc6f321b7e3d$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($a768bc6f321b7e3d$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $a768bc6f321b7e3d$var$isIgnored(n, this.mirror) || !$a768bc6f321b7e3d$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $a768bc6f321b7e3d$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($a768bc6f321b7e3d$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$a768bc6f321b7e3d$var$moveKey(nodeId, parentId)]) $a768bc6f321b7e3d$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $a768bc6f321b7e3d$var$isShadowRoot(m.target) && $a768bc6f321b7e3d$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($a768bc6f321b7e3d$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$a768bc6f321b7e3d$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$a768bc6f321b7e3d$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($a768bc6f321b7e3d$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'unblockSelector',
            'maskAllText',
            'maskTextClass',
            'unmaskTextClass',
            'maskTextSelector',
            'unmaskTextSelector',
            'inlineStylesheet',
            'maskInputOptions',
            'maskAttributeFn',
            'maskTextFn',
            'maskInputFn',
            'keepIframeSrcFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'dataURLOptions',
            'doc',
            'mirror',
            'iframeManager',
            'stylesheetManager',
            'shadowDomManager',
            'canvasManager',
            'processedNodeManager'
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $a768bc6f321b7e3d$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$a768bc6f321b7e3d$var$deepDelete(addsSet, childN));
}
function $a768bc6f321b7e3d$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $a768bc6f321b7e3d$var$_isParentRemoved(removes, n, mirror);
}
function $a768bc6f321b7e3d$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $a768bc6f321b7e3d$var$_isParentRemoved(removes, parentNode, mirror);
}
function $a768bc6f321b7e3d$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $a768bc6f321b7e3d$var$_isAncestorInSet(set, n);
}
function $a768bc6f321b7e3d$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $a768bc6f321b7e3d$var$_isAncestorInSet(set, parentNode);
}
let $a768bc6f321b7e3d$var$errorHandler;
function $a768bc6f321b7e3d$var$registerErrorHandler(handler) {
    $a768bc6f321b7e3d$var$errorHandler = handler;
}
function $a768bc6f321b7e3d$var$unregisterErrorHandler() {
    $a768bc6f321b7e3d$var$errorHandler = undefined;
}
const $a768bc6f321b7e3d$var$callbackWrapper = (cb)=>{
    if (!$a768bc6f321b7e3d$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($a768bc6f321b7e3d$var$errorHandler && $a768bc6f321b7e3d$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $a768bc6f321b7e3d$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $a768bc6f321b7e3d$var$mutationBuffers = [];
function $a768bc6f321b7e3d$var$getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ('path' in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $a768bc6f321b7e3d$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $a768bc6f321b7e3d$var$MutationBuffer();
    $a768bc6f321b7e3d$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $a768bc6f321b7e3d$var$_optionalChain$2([
        window,
        'optionalAccess',
        (_)=>_.Zone,
        'optionalAccess',
        (_2)=>_2.__symbol__,
        'optionalCall',
        (_3)=>_3('MutationObserver')
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($a768bc6f321b7e3d$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $a768bc6f321b7e3d$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $a768bc6f321b7e3d$var$throttle$1($a768bc6f321b7e3d$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $a768bc6f321b7e3d$var$callbackWrapper($a768bc6f321b7e3d$var$throttle$1($a768bc6f321b7e3d$var$callbackWrapper((evt)=>{
        const target = $a768bc6f321b7e3d$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $a768bc6f321b7e3d$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $a768bc6f321b7e3d$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $a768bc6f321b7e3d$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? $a768bc6f321b7e3d$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $a768bc6f321b7e3d$var$IncrementalSource.MouseMove : $a768bc6f321b7e3d$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $a768bc6f321b7e3d$var$on('mousemove', updatePosition, doc),
        $a768bc6f321b7e3d$var$on('touchmove', updatePosition, doc),
        $a768bc6f321b7e3d$var$on('drag', updatePosition, doc)
    ];
    return $a768bc6f321b7e3d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $a768bc6f321b7e3d$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $a768bc6f321b7e3d$var$getEventTarget(event);
            if ($a768bc6f321b7e3d$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ('pointerType' in event) {
                switch(event.pointerType){
                    case 'mouse':
                        pointerType = $a768bc6f321b7e3d$var$PointerTypes.Mouse;
                        break;
                    case 'touch':
                        pointerType = $a768bc6f321b7e3d$var$PointerTypes.Touch;
                        break;
                    case 'pen':
                        pointerType = $a768bc6f321b7e3d$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $a768bc6f321b7e3d$var$PointerTypes.Touch) {
                    if ($a768bc6f321b7e3d$var$MouseInteractions[eventKey] === $a768bc6f321b7e3d$var$MouseInteractions.MouseDown) thisEventKey = 'TouchStart';
                    else if ($a768bc6f321b7e3d$var$MouseInteractions[eventKey] === $a768bc6f321b7e3d$var$MouseInteractions.MouseUp) thisEventKey = 'TouchEnd';
                } else $a768bc6f321b7e3d$var$PointerTypes.Pen;
            } else if ($a768bc6f321b7e3d$var$legacy_isTouchEvent(event)) pointerType = $a768bc6f321b7e3d$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith('Touch') && pointerType === $a768bc6f321b7e3d$var$PointerTypes.Touch || thisEventKey.startsWith('Mouse') && pointerType === $a768bc6f321b7e3d$var$PointerTypes.Mouse) pointerType = null;
            } else if ($a768bc6f321b7e3d$var$MouseInteractions[eventKey] === $a768bc6f321b7e3d$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $a768bc6f321b7e3d$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $a768bc6f321b7e3d$var$callbackWrapper(mouseInteractionCb)({
                type: $a768bc6f321b7e3d$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($a768bc6f321b7e3d$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $a768bc6f321b7e3d$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($a768bc6f321b7e3d$var$MouseInteractions[eventKey]){
            case $a768bc6f321b7e3d$var$MouseInteractions.MouseDown:
            case $a768bc6f321b7e3d$var$MouseInteractions.MouseUp:
                eventName = eventName.replace('mouse', 'pointer');
                break;
            case $a768bc6f321b7e3d$var$MouseInteractions.TouchStart:
            case $a768bc6f321b7e3d$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($a768bc6f321b7e3d$var$on(eventName, handler, doc));
    });
    return $a768bc6f321b7e3d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $a768bc6f321b7e3d$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $a768bc6f321b7e3d$var$callbackWrapper($a768bc6f321b7e3d$var$throttle$1($a768bc6f321b7e3d$var$callbackWrapper((evt)=>{
        const target = $a768bc6f321b7e3d$var$getEventTarget(evt);
        if (!target || $a768bc6f321b7e3d$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $a768bc6f321b7e3d$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $a768bc6f321b7e3d$var$on('scroll', updatePosition, doc);
}
function $a768bc6f321b7e3d$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $a768bc6f321b7e3d$var$callbackWrapper($a768bc6f321b7e3d$var$throttle$1($a768bc6f321b7e3d$var$callbackWrapper(()=>{
        const height = $a768bc6f321b7e3d$var$getWindowHeight();
        const width = $a768bc6f321b7e3d$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $a768bc6f321b7e3d$var$on('resize', updateDimension, win);
}
const $a768bc6f321b7e3d$var$INPUT_TAGS = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
const $a768bc6f321b7e3d$var$lastInputValueMap = new WeakMap();
function $a768bc6f321b7e3d$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $a768bc6f321b7e3d$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $a768bc6f321b7e3d$var$toUpperCase(target.tagName);
        if (tagName === 'OPTION') target = target.parentElement;
        if (!target || !tagName || $a768bc6f321b7e3d$var$INPUT_TAGS.indexOf(tagName) < 0 || $a768bc6f321b7e3d$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $a768bc6f321b7e3d$var$getInputType(target);
        let text = $a768bc6f321b7e3d$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $a768bc6f321b7e3d$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $a768bc6f321b7e3d$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === 'radio' || type === 'checkbox') isChecked = target.checked;
        text = $a768bc6f321b7e3d$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === 'radio' && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $a768bc6f321b7e3d$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $a768bc6f321b7e3d$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $a768bc6f321b7e3d$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $a768bc6f321b7e3d$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $a768bc6f321b7e3d$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === 'last' ? [
        'change'
    ] : [
        'input',
        'change'
    ];
    const handlers = events.map((eventName)=>$a768bc6f321b7e3d$var$on(eventName, $a768bc6f321b7e3d$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            'checked'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'selectedIndex'
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            'selected'
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$a768bc6f321b7e3d$var$hookSetter(p[0], p[1], {
            set () {
                $a768bc6f321b7e3d$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $a768bc6f321b7e3d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $a768bc6f321b7e3d$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($a768bc6f321b7e3d$var$hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || $a768bc6f321b7e3d$var$hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || $a768bc6f321b7e3d$var$hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || $a768bc6f321b7e3d$var$hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $a768bc6f321b7e3d$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $a768bc6f321b7e3d$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $a768bc6f321b7e3d$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $a768bc6f321b7e3d$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $a768bc6f321b7e3d$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $a768bc6f321b7e3d$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $a768bc6f321b7e3d$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $a768bc6f321b7e3d$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $a768bc6f321b7e3d$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $a768bc6f321b7e3d$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($a768bc6f321b7e3d$var$canMonkeyPatchNestedCSSRule('CSSGroupingRule')) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($a768bc6f321b7e3d$var$canMonkeyPatchNestedCSSRule('CSSMediaRule')) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($a768bc6f321b7e3d$var$canMonkeyPatchNestedCSSRule('CSSConditionRule')) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($a768bc6f321b7e3d$var$canMonkeyPatchNestedCSSRule('CSSSupportsRule')) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $a768bc6f321b7e3d$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $a768bc6f321b7e3d$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$a768bc6f321b7e3d$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $a768bc6f321b7e3d$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $a768bc6f321b7e3d$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$a768bc6f321b7e3d$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $a768bc6f321b7e3d$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $a768bc6f321b7e3d$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === '#document') hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === '#document' ? $a768bc6f321b7e3d$var$_optionalChain$2([
        host,
        'access',
        (_4)=>_4.defaultView,
        'optionalAccess',
        (_5)=>_5.Document
    ]) : $a768bc6f321b7e3d$var$_optionalChain$2([
        host,
        'access',
        (_6)=>_6.ownerDocument,
        'optionalAccess',
        (_7)=>_7.defaultView,
        'optionalAccess',
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $a768bc6f321b7e3d$var$_optionalChain$2([
        patchTarget,
        'optionalAccess',
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($a768bc6f321b7e3d$var$_optionalChain$2([
        patchTarget,
        'optionalAccess',
        (_10)=>_10.prototype
    ]), 'adoptedStyleSheets') : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, 'adoptedStyleSheets', {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $a768bc6f321b7e3d$var$_optionalChain$2([
                originalPropertyDescriptor,
                'access',
                (_11)=>_11.get,
                'optionalAccess',
                (_12)=>_12.call,
                'call',
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $a768bc6f321b7e3d$var$_optionalChain$2([
                originalPropertyDescriptor,
                'access',
                (_14)=>_14.set,
                'optionalAccess',
                (_15)=>_15.call,
                'call',
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $a768bc6f321b7e3d$var$callbackWrapper(()=>{
        Object.defineProperty(host, 'adoptedStyleSheets', {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $a768bc6f321b7e3d$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $a768bc6f321b7e3d$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $a768bc6f321b7e3d$var$getIdAndStyleId($a768bc6f321b7e3d$var$_optionalChain$2([
                thisArg,
                'access',
                (_17)=>_17.parentRule,
                'optionalAccess',
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $a768bc6f321b7e3d$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $a768bc6f321b7e3d$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $a768bc6f321b7e3d$var$getIdAndStyleId($a768bc6f321b7e3d$var$_optionalChain$2([
                thisArg,
                'access',
                (_19)=>_19.parentRule,
                'optionalAccess',
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $a768bc6f321b7e3d$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $a768bc6f321b7e3d$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $a768bc6f321b7e3d$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $a768bc6f321b7e3d$var$callbackWrapper((type)=>$a768bc6f321b7e3d$var$throttle$1($a768bc6f321b7e3d$var$callbackWrapper((event)=>{
            const target = $a768bc6f321b7e3d$var$getEventTarget(event);
            if (!target || $a768bc6f321b7e3d$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $a768bc6f321b7e3d$var$on('play', handler(0), doc),
        $a768bc6f321b7e3d$var$on('pause', handler(1), doc),
        $a768bc6f321b7e3d$var$on('seeked', handler(2), doc),
        $a768bc6f321b7e3d$var$on('volumechange', handler(3), doc),
        $a768bc6f321b7e3d$var$on('ratechange', handler(4), doc)
    ];
    return $a768bc6f321b7e3d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $a768bc6f321b7e3d$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== 'string',
            descriptors: descriptors,
            fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $a768bc6f321b7e3d$var$patch(doc.fonts, 'add', function(original) {
        return function(fontFace) {
            $a768bc6f321b7e3d$var$setTimeout$1($a768bc6f321b7e3d$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $a768bc6f321b7e3d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $a768bc6f321b7e3d$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $a768bc6f321b7e3d$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $a768bc6f321b7e3d$var$_optionalChain$2([
            selection,
            'optionalAccess',
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $a768bc6f321b7e3d$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $a768bc6f321b7e3d$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $a768bc6f321b7e3d$var$on('selectionchange', updateSelection);
}
function $a768bc6f321b7e3d$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $a768bc6f321b7e3d$var$patch(win.customElements, 'define', function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $a768bc6f321b7e3d$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $a768bc6f321b7e3d$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $a768bc6f321b7e3d$var$initMoveObserver(o);
    const mouseInteractionHandler = $a768bc6f321b7e3d$var$initMouseInteractionObserver(o);
    const scrollHandler = $a768bc6f321b7e3d$var$initScrollObserver(o);
    const viewportResizeHandler = $a768bc6f321b7e3d$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $a768bc6f321b7e3d$var$initInputObserver(o);
    const mediaInteractionHandler = $a768bc6f321b7e3d$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $a768bc6f321b7e3d$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $a768bc6f321b7e3d$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $a768bc6f321b7e3d$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $a768bc6f321b7e3d$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $a768bc6f321b7e3d$var$initSelectionObserver(o);
    const customElementObserver = $a768bc6f321b7e3d$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $a768bc6f321b7e3d$var$callbackWrapper(()=>{
        $a768bc6f321b7e3d$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $a768bc6f321b7e3d$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function $a768bc6f321b7e3d$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}
class $a768bc6f321b7e3d$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== 'number') return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $a768bc6f321b7e3d$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $a768bc6f321b7e3d$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $a768bc6f321b7e3d$var$CrossOriginIframeMirror($a768bc6f321b7e3d$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $a768bc6f321b7e3d$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $a768bc6f321b7e3d$var$CrossOriginIframeMirror($a768bc6f321b7e3d$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $a768bc6f321b7e3d$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener('message', this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $a768bc6f321b7e3d$var$_optionalChain$1([
            this,
            'access',
            (_)=>_.loadListener,
            'optionalCall',
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== 'rrweb' || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $a768bc6f321b7e3d$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $a768bc6f321b7e3d$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $a768bc6f321b7e3d$var$EventType.Meta:
            case $a768bc6f321b7e3d$var$EventType.Load:
            case $a768bc6f321b7e3d$var$EventType.DomContentLoaded:
                return false;
            case $a768bc6f321b7e3d$var$EventType.Plugin:
                return e;
            case $a768bc6f321b7e3d$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    'id',
                    'parentId',
                    'previousId',
                    'nextId'
                ]);
                return e;
            case $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $a768bc6f321b7e3d$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'nextId',
                                'previousId'
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'id'
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $a768bc6f321b7e3d$var$IncrementalSource.Drag:
                    case $a768bc6f321b7e3d$var$IncrementalSource.TouchMove:
                    case $a768bc6f321b7e3d$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $a768bc6f321b7e3d$var$IncrementalSource.ViewportResize:
                        return false;
                    case $a768bc6f321b7e3d$var$IncrementalSource.MediaInteraction:
                    case $a768bc6f321b7e3d$var$IncrementalSource.MouseInteraction:
                    case $a768bc6f321b7e3d$var$IncrementalSource.Scroll:
                    case $a768bc6f321b7e3d$var$IncrementalSource.CanvasMutation:
                    case $a768bc6f321b7e3d$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        return e;
                    case $a768bc6f321b7e3d$var$IncrementalSource.StyleSheetRule:
                    case $a768bc6f321b7e3d$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleId'
                        ]);
                        return e;
                    case $a768bc6f321b7e3d$var$IncrementalSource.Font:
                        return e;
                    case $a768bc6f321b7e3d$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                'start',
                                'end'
                            ]);
                        });
                        return e;
                    case $a768bc6f321b7e3d$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleIds'
                        ]);
                        $a768bc6f321b7e3d$var$_optionalChain$1([
                            e,
                            'access',
                            (_3)=>_3.data,
                            'access',
                            (_4)=>_4.styles,
                            'optionalAccess',
                            (_5)=>_5.forEach,
                            'call',
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        'styleId'
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number') continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            'id',
            'rootId'
        ]);
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $a768bc6f321b7e3d$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $a768bc6f321b7e3d$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $a768bc6f321b7e3d$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$a768bc6f321b7e3d$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $a768bc6f321b7e3d$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($a768bc6f321b7e3d$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $a768bc6f321b7e3d$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($a768bc6f321b7e3d$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($a768bc6f321b7e3d$var$patch(element.prototype, 'attachShadow', function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $a768bc6f321b7e3d$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class $a768bc6f321b7e3d$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $a768bc6f321b7e3d$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $a768bc6f321b7e3d$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ('_cssText' in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $a768bc6f321b7e3d$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $a768bc6f321b7e3d$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $a768bc6f321b7e3d$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
let $a768bc6f321b7e3d$var$wrappedEmit;
let $a768bc6f321b7e3d$var$_takeFullSnapshot;
const $a768bc6f321b7e3d$var$mirror = $a768bc6f321b7e3d$var$createMirror();
function $a768bc6f321b7e3d$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = 'rr-ignore', ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = 'rr-mask', unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === 'DOMContentLoaded' ? options.recordAfter : 'load', userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $a768bc6f321b7e3d$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error('emit function is required');
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $a768bc6f321b7e3d$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === 'all',
        headMetaDescKeywords: _slimDOMOptions === 'all'
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $a768bc6f321b7e3d$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $a768bc6f321b7e3d$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $a768bc6f321b7e3d$var$nowTimestamp();
        if ((0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
            $a768bc6f321b7e3d$var$mutationBuffers,
            'access',
            (_)=>_[0],
            'optionalAccess',
            (_2)=>_2.isFrozen,
            'call',
            (_3)=>_3()
        ]) && e.type !== $a768bc6f321b7e3d$var$EventType.FullSnapshot && !(e.type === $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot && e.data.source === $a768bc6f321b7e3d$var$IncrementalSource.Mutation)) $a768bc6f321b7e3d$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
            emit,
            'optionalCall',
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: 'rrweb',
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, '*');
        }
        if (e.type === $a768bc6f321b7e3d$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $a768bc6f321b7e3d$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $a768bc6f321b7e3d$var$wrappedEmit({
            type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
            data: {
                source: $a768bc6f321b7e3d$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$a768bc6f321b7e3d$var$wrappedEmit({
            type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
            data: {
                source: $a768bc6f321b7e3d$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$a768bc6f321b7e3d$var$wrappedEmit({
            type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
            data: {
                source: $a768bc6f321b7e3d$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$a768bc6f321b7e3d$var$wrappedEmit({
            type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
            data: {
                source: $a768bc6f321b7e3d$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $a768bc6f321b7e3d$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === 'boolean' && __RRWEB_EXCLUDE_IFRAME__ ? new $a768bc6f321b7e3d$var$IframeManagerNoop() : new $a768bc6f321b7e3d$var$IframeManager({
        mirror: $a768bc6f321b7e3d$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $a768bc6f321b7e3d$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $a768bc6f321b7e3d$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $a768bc6f321b7e3d$var$ProcessedNodeManager();
    const canvasManager = $a768bc6f321b7e3d$var$_getCanvasManager(getCanvasManager, {
        mirror: $a768bc6f321b7e3d$var$mirror,
        win: window,
        mutationCb: (p)=>$a768bc6f321b7e3d$var$wrappedEmit({
                type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
                data: {
                    source: $a768bc6f321b7e3d$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling['canvas'],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === 'boolean' && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $a768bc6f321b7e3d$var$ShadowDomManagerNoop() : new $a768bc6f321b7e3d$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $a768bc6f321b7e3d$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        $a768bc6f321b7e3d$var$wrappedEmit({
            type: $a768bc6f321b7e3d$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $a768bc6f321b7e3d$var$getWindowWidth(),
                height: $a768bc6f321b7e3d$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $a768bc6f321b7e3d$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $a768bc6f321b7e3d$var$snapshot(document, {
            mirror: $a768bc6f321b7e3d$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($a768bc6f321b7e3d$var$isSerializedIframe(n, $a768bc6f321b7e3d$var$mirror)) iframeManager.addIframe(n);
                if ($a768bc6f321b7e3d$var$isSerializedStylesheet(n, $a768bc6f321b7e3d$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($a768bc6f321b7e3d$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn('Failed to snapshot the document');
        $a768bc6f321b7e3d$var$wrappedEmit({
            type: $a768bc6f321b7e3d$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $a768bc6f321b7e3d$var$getWindowScroll(window)
            }
        });
        $a768bc6f321b7e3d$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $a768bc6f321b7e3d$var$mirror.getId(document));
    };
    $a768bc6f321b7e3d$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $a768bc6f321b7e3d$var$callbackWrapper($a768bc6f321b7e3d$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$a768bc6f321b7e3d$var$wrappedEmit({
                        type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$a768bc6f321b7e3d$var$wrappedEmit({
                        type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $a768bc6f321b7e3d$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$a768bc6f321b7e3d$var$wrappedEmit({
                        type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $a768bc6f321b7e3d$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$a768bc6f321b7e3d$var$wrappedEmit({
                        type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $a768bc6f321b7e3d$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$a768bc6f321b7e3d$var$wrappedEmit({
                        type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $a768bc6f321b7e3d$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$a768bc6f321b7e3d$var$wrappedEmit({
                        type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $a768bc6f321b7e3d$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$a768bc6f321b7e3d$var$wrappedEmit({
                        type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $a768bc6f321b7e3d$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$a768bc6f321b7e3d$var$wrappedEmit({
                        type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $a768bc6f321b7e3d$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $a768bc6f321b7e3d$var$wrappedEmit({
                        type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $a768bc6f321b7e3d$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $a768bc6f321b7e3d$var$wrappedEmit({
                        type: $a768bc6f321b7e3d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $a768bc6f321b7e3d$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $a768bc6f321b7e3d$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $d2c4c8c9cb5cb6b8$export$3cc482e6b02f32f7)([
                    plugins,
                    'optionalAccess',
                    (_5)=>_5.filter,
                    'call',
                    (_6)=>_6((p)=>p.observer),
                    'optionalAccess',
                    (_7)=>_7.map,
                    'call',
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$a768bc6f321b7e3d$var$wrappedEmit({
                                        type: $a768bc6f321b7e3d$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === 'interactive' || document.readyState === 'complete') init();
        else {
            handlers.push($a768bc6f321b7e3d$var$on('DOMContentLoaded', ()=>{
                $a768bc6f321b7e3d$var$wrappedEmit({
                    type: $a768bc6f321b7e3d$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === 'DOMContentLoaded') init();
            }));
            handlers.push($a768bc6f321b7e3d$var$on('load', ()=>{
                $a768bc6f321b7e3d$var$wrappedEmit({
                    type: $a768bc6f321b7e3d$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === 'load') init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $a768bc6f321b7e3d$var$_takeFullSnapshot = undefined;
            $a768bc6f321b7e3d$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $a768bc6f321b7e3d$var$takeFullSnapshot(isCheckout) {
    if (!$a768bc6f321b7e3d$var$_takeFullSnapshot) throw new Error('please take full snapshot after start recording');
    $a768bc6f321b7e3d$var$_takeFullSnapshot(isCheckout);
}
$a768bc6f321b7e3d$var$record.mirror = $a768bc6f321b7e3d$var$mirror;
$a768bc6f321b7e3d$var$record.takeFullSnapshot = $a768bc6f321b7e3d$var$takeFullSnapshot;
function $a768bc6f321b7e3d$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $a768bc6f321b7e3d$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn('Unable to initialize CanvasManager');
        return new $a768bc6f321b7e3d$var$CanvasManagerNoop();
    }
}
const $a768bc6f321b7e3d$var$ReplayEventTypeIncrementalSnapshot = 3;
const $a768bc6f321b7e3d$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $a768bc6f321b7e3d$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $a768bc6f321b7e3d$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $a768bc6f321b7e3d$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === 'sentry.transaction') return;
    if ([
        'ui.click',
        'ui.input'
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $a768bc6f321b7e3d$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: 'breadcrumb',
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $e1a46ce691765a57$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === 'console';
    });
}
const $a768bc6f321b7e3d$var$INTERACTIVE_SELECTOR = 'button,a';
/** Get the closest interactive parent element, or else return the given element. */ function $a768bc6f321b7e3d$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($a768bc6f321b7e3d$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $a768bc6f321b7e3d$var$getClickTargetNode(event) {
    const target = $a768bc6f321b7e3d$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $a768bc6f321b7e3d$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $a768bc6f321b7e3d$var$getTargetNode(event) {
    if ($a768bc6f321b7e3d$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $a768bc6f321b7e3d$var$isEventWithTarget(event) {
    return typeof event === 'object' && !!event && 'target' in event;
}
let $a768bc6f321b7e3d$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $a768bc6f321b7e3d$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$a768bc6f321b7e3d$var$handlers) {
        $a768bc6f321b7e3d$var$handlers = [];
        $a768bc6f321b7e3d$var$monkeyPatchWindowOpen();
    }
    $a768bc6f321b7e3d$var$handlers.push(cb);
    return ()=>{
        const pos = $a768bc6f321b7e3d$var$handlers ? $a768bc6f321b7e3d$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $a768bc6f321b7e3d$var$handlers.splice(pos, 1);
    };
}
function $a768bc6f321b7e3d$var$monkeyPatchWindowOpen() {
    (0, $89b84fdfd1cfae9c$export$9563e054e6f787fb)($a768bc6f321b7e3d$var$WINDOW, 'open', function(originalWindowOpen) {
        return function(...args) {
            if ($a768bc6f321b7e3d$var$handlers) try {
                $a768bc6f321b7e3d$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($a768bc6f321b7e3d$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $a768bc6f321b7e3d$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $a768bc6f321b7e3d$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $a768bc6f321b7e3d$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $a768bc6f321b7e3d$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $a768bc6f321b7e3d$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($a768bc6f321b7e3d$var$ignoreElement(node, this._ignoreSelector) || !$a768bc6f321b7e3d$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $a768bc6f321b7e3d$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $a768bc6f321b7e3d$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $a768bc6f321b7e3d$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $a768bc6f321b7e3d$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $a768bc6f321b7e3d$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.slowClickDetected',
                data: {
                    ...clickBreadcrumb.data,
                    url: $a768bc6f321b7e3d$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.multiClick',
                data: {
                    ...clickBreadcrumb.data,
                    url: $a768bc6f321b7e3d$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $a768bc6f321b7e3d$var$SLOW_CLICK_TAGS = [
    'A',
    'BUTTON',
    'INPUT'
];
/** exported for tests only */ function $a768bc6f321b7e3d$var$ignoreElement(node, ignoreSelector) {
    if (!$a768bc6f321b7e3d$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === 'INPUT' && ![
        'submit',
        'button'
    ].includes(node.getAttribute('type') || '')) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $a768bc6f321b7e3d$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $a768bc6f321b7e3d$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $a768bc6f321b7e3d$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$a768bc6f321b7e3d$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $a768bc6f321b7e3d$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $a768bc6f321b7e3d$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($a768bc6f321b7e3d$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $a768bc6f321b7e3d$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $a768bc6f321b7e3d$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $a768bc6f321b7e3d$var$isIncrementalEvent(event) {
    return event.type === $a768bc6f321b7e3d$var$ReplayEventTypeIncrementalSnapshot;
}
function $a768bc6f321b7e3d$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $a768bc6f321b7e3d$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $a768bc6f321b7e3d$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: 'default',
        ...breadcrumb
    };
}
var $a768bc6f321b7e3d$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($a768bc6f321b7e3d$var$NodeType || ($a768bc6f321b7e3d$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $a768bc6f321b7e3d$var$ATTRIBUTES_TO_RECORD = new Set([
    'id',
    'class',
    'aria-label',
    'role',
    'name',
    'alt',
    'title',
    'data-test-id',
    'data-testid',
    'disabled',
    'aria-disabled',
    'data-sentry-component'
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $a768bc6f321b7e3d$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($a768bc6f321b7e3d$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === 'data-testid' || key === 'data-test-id') normalizedKey = 'testId';
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $a768bc6f321b7e3d$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $a768bc6f321b7e3d$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === 'click';
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $a768bc6f321b7e3d$var$handleClick(replay.clickDetector, result, $a768bc6f321b7e3d$var$getClickTargetNode(handlerData.event));
        $a768bc6f321b7e3d$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $a768bc6f321b7e3d$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $a768bc6f321b7e3d$var$record.mirror.getId(target);
    const node = nodeId && $a768bc6f321b7e3d$var$record.mirror.getNode(nodeId);
    const meta = node && $a768bc6f321b7e3d$var$record.mirror.getMeta(node);
    const element = meta && $a768bc6f321b7e3d$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $a768bc6f321b7e3d$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(''),
                attributes: $a768bc6f321b7e3d$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $a768bc6f321b7e3d$var$handleDom(handlerData) {
    const { target: target, message: message } = $a768bc6f321b7e3d$var$getDomTarget(handlerData);
    return $a768bc6f321b7e3d$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$a768bc6f321b7e3d$var$getBaseDomBreadcrumb(target, message)
    });
}
function $a768bc6f321b7e3d$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === 'click';
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $a768bc6f321b7e3d$var$getClickTargetNode(handlerData.event) : $a768bc6f321b7e3d$var$getTargetNode(handlerData.event);
        message = (0, $a9dceb93bbd7f017$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || '<unknown>';
    } catch (e) {
        message = '<unknown>';
    }
    return {
        target: target,
        message: message
    };
}
function $a768bc6f321b7e3d$var$isElement(node) {
    return node.type === $a768bc6f321b7e3d$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $a768bc6f321b7e3d$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $a768bc6f321b7e3d$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $a768bc6f321b7e3d$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $a768bc6f321b7e3d$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $a768bc6f321b7e3d$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $a9dceb93bbd7f017$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || '<unknown>';
    const baseBreadcrumb = $a768bc6f321b7e3d$var$getBaseDomBreadcrumb(target, message);
    return $a768bc6f321b7e3d$var$createBreadcrumb({
        category: 'ui.keyDown',
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $a768bc6f321b7e3d$var$isInputElement(target) {
    return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $a768bc6f321b7e3d$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $a768bc6f321b7e3d$var$createResourceEntry,
    paint: $a768bc6f321b7e3d$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $a768bc6f321b7e3d$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $a768bc6f321b7e3d$var$createPerformanceEntries(entries) {
    return entries.map($a768bc6f321b7e3d$var$createPerformanceEntry).filter(Boolean);
}
function $a768bc6f321b7e3d$var$createPerformanceEntry(entry) {
    if (!$a768bc6f321b7e3d$var$ENTRY_TYPES[entry.entryType]) return null;
    return $a768bc6f321b7e3d$var$ENTRY_TYPES[entry.entryType](entry);
}
function $a768bc6f321b7e3d$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $9596c1ede1884e50$export$baf075a948ffc0bf) || $a768bc6f321b7e3d$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $a768bc6f321b7e3d$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $a768bc6f321b7e3d$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $a768bc6f321b7e3d$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $a768bc6f321b7e3d$var$getAbsoluteTime(startTime),
        end: $a768bc6f321b7e3d$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $a768bc6f321b7e3d$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        'fetch',
        'xmlhttprequest'
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $a768bc6f321b7e3d$var$getAbsoluteTime(startTime),
        end: $a768bc6f321b7e3d$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $a768bc6f321b7e3d$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $a768bc6f321b7e3d$var$getAbsoluteTime(value);
    const data = {
        type: 'largest-contentful-paint',
        name: 'largest-contentful-paint',
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $a768bc6f321b7e3d$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $a768bc6f321b7e3d$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        'navigation',
        'paint',
        'resource'
    ].forEach((type)=>{
        clearCallbacks.push((0, $962fbd100584c218$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $962fbd100584c218$export$3fd4b53331200102)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($a768bc6f321b7e3d$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a768bc6f321b7e3d$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
const $a768bc6f321b7e3d$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $a768bc6f321b7e3d$var$e() {
    const e = new Blob([
        $a768bc6f321b7e3d$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $a768bc6f321b7e3d$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$a768bc6f321b7e3d$var$DEBUG_BUILD) return;
    (0, $54d1043b2228e29f$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) $a768bc6f321b7e3d$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $a768bc6f321b7e3d$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$a768bc6f321b7e3d$var$DEBUG_BUILD) return;
    (0, $54d1043b2228e29f$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $a768bc6f321b7e3d$var$addLogBreadcrumb(message);
    }, 0);
}
function $a768bc6f321b7e3d$var$addLogBreadcrumb(message) {
    (0, $2dfa7d22514dae4c$export$efda9a273d7a036d)({
        category: 'console',
        data: {
            logger: 'replay'
        },
        level: 'info',
        message: message
    }, {
        level: 'info'
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $a768bc6f321b7e3d$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$a768bc6f321b7e3d$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $a768bc6f321b7e3d$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return 'sync';
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $a768bc6f321b7e3d$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $a768bc6f321b7e3d$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $a768bc6f321b7e3d$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $a768bc6f321b7e3d$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener('message', ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener('error', (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $a768bc6f321b7e3d$var$logInfo('[Replay] Destroying compression worker');
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener('message', listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('[Replay]', response.response);
                    reject(new Error('Error in compression worker'));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener('message', listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $a768bc6f321b7e3d$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $a768bc6f321b7e3d$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return 'worker';
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $a768bc6f321b7e3d$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $a768bc6f321b7e3d$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $a768bc6f321b7e3d$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage('clear').then(null, (e)=>{
            $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage('addEvent', data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage('finish');
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $a768bc6f321b7e3d$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $a768bc6f321b7e3d$var$EventBufferArray();
        this._compression = new $a768bc6f321b7e3d$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $a768bc6f321b7e3d$var$logInfo('[Replay] Failed to load the compression worker, falling back to simple buffer');
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Replay] Failed to add events when switching buffers.', error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $a768bc6f321b7e3d$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $a768bc6f321b7e3d$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $a768bc6f321b7e3d$var$logInfo('[Replay] Using simple buffer');
    return new $a768bc6f321b7e3d$var$EventBufferArray();
}
function $a768bc6f321b7e3d$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $a768bc6f321b7e3d$var$_getWorkerUrl();
        if (!workerUrl) return;
        $a768bc6f321b7e3d$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ''}`);
        const worker = new Worker(workerUrl);
        return new $a768bc6f321b7e3d$var$EventBufferProxy(worker);
    } catch (error) {
        $a768bc6f321b7e3d$var$logInfo('[Replay] Failed to create compression worker');
    // Fall back to use simple event buffer array
    }
}
function $a768bc6f321b7e3d$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === 'undefined' || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $a768bc6f321b7e3d$var$e();
    return '';
}
/** If sessionStorage is available. */ function $a768bc6f321b7e3d$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return 'sessionStorage' in $a768bc6f321b7e3d$var$WINDOW && !!$a768bc6f321b7e3d$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $a768bc6f321b7e3d$var$clearSession(replay) {
    $a768bc6f321b7e3d$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $a768bc6f321b7e3d$var$deleteSession() {
    if (!$a768bc6f321b7e3d$var$hasSessionStorage()) return;
    try {
        $a768bc6f321b7e3d$var$WINDOW.sessionStorage.removeItem($a768bc6f321b7e3d$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $a768bc6f321b7e3d$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $a768bc6f321b7e3d$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $0820bb2e6cc9979f$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $a768bc6f321b7e3d$var$saveSession(session) {
    if (!$a768bc6f321b7e3d$var$hasSessionStorage()) return;
    try {
        $a768bc6f321b7e3d$var$WINDOW.sessionStorage.setItem($a768bc6f321b7e3d$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $a768bc6f321b7e3d$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $a768bc6f321b7e3d$var$isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $a768bc6f321b7e3d$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $a768bc6f321b7e3d$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $a768bc6f321b7e3d$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $a768bc6f321b7e3d$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $a768bc6f321b7e3d$var$fetchSession(traceInternals) {
    if (!$a768bc6f321b7e3d$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $a768bc6f321b7e3d$var$WINDOW.sessionStorage.getItem($a768bc6f321b7e3d$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $a768bc6f321b7e3d$var$logInfoNextTick('[Replay] Loading existing session', traceInternals);
        return $a768bc6f321b7e3d$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $a768bc6f321b7e3d$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $a768bc6f321b7e3d$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $a768bc6f321b7e3d$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $a768bc6f321b7e3d$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $a768bc6f321b7e3d$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$a768bc6f321b7e3d$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === 'buffer' && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $a768bc6f321b7e3d$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $a768bc6f321b7e3d$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $a768bc6f321b7e3d$var$logInfoNextTick('[Replay] Creating new session', traceInternals);
        return $a768bc6f321b7e3d$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$a768bc6f321b7e3d$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $a768bc6f321b7e3d$var$logInfoNextTick('[Replay] Session in sessionStorage is expired, creating new one...');
    return $a768bc6f321b7e3d$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $a768bc6f321b7e3d$var$isCustomEvent(event) {
    return event.type === $a768bc6f321b7e3d$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $a768bc6f321b7e3d$var$addEventSync(replay, event, isCheckout) {
    if (!$a768bc6f321b7e3d$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $a768bc6f321b7e3d$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $a768bc6f321b7e3d$var$addEvent(replay, event, isCheckout) {
    if (!$a768bc6f321b7e3d$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $a768bc6f321b7e3d$var$_addEvent(replay, event, isCheckout);
}
async function $a768bc6f321b7e3d$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === 'buffer') replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $a768bc6f321b7e3d$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $a768bc6f321b7e3d$var$EventBufferSizeExceededError ? 'addEventSizeExceeded' : 'addEvent';
        $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent('internal_sdk_error', 'replay');
    }
}
/** Exported only for tests. */ function $a768bc6f321b7e3d$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $a768bc6f321b7e3d$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $a768bc6f321b7e3d$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $a768bc6f321b7e3d$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === 'function' && $a768bc6f321b7e3d$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...', error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $a768bc6f321b7e3d$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $a768bc6f321b7e3d$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** If the event is an replay event */ function $a768bc6f321b7e3d$var$isReplayEvent(event) {
    return event.type === 'replay_event';
}
/** If the event is a feedback event */ function $a768bc6f321b7e3d$var$isFeedbackEvent(event) {
    return event.type === 'feedback';
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $a768bc6f321b7e3d$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $a768bc6f321b7e3d$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$a768bc6f321b7e3d$var$isErrorEvent(event) && !$a768bc6f321b7e3d$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($a768bc6f321b7e3d$var$isTransactionEvent(event)) {
            $a768bc6f321b7e3d$var$handleTransactionEvent(replay, event);
            return;
        }
        $a768bc6f321b7e3d$var$handleErrorEvent(replay, event);
    };
}
function $a768bc6f321b7e3d$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $a768bc6f321b7e3d$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== 'buffer' || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === 'function' && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function $a768bc6f321b7e3d$var$isBaseTransportSend() {
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $a768bc6f321b7e3d$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$a768bc6f321b7e3d$var$isErrorEvent(event)) return;
        $a768bc6f321b7e3d$var$handleHydrationError(replay, event);
    };
}
function $a768bc6f321b7e3d$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== 'string') return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $a768bc6f321b7e3d$var$createBreadcrumb({
            category: 'replay.hydrate-error'
        });
        $a768bc6f321b7e3d$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $a768bc6f321b7e3d$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $a768bc6f321b7e3d$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $a768bc6f321b7e3d$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: 'breadcrumb',
                payload: {
                    timestamp: event.timestamp,
                    type: 'default',
                    category: 'sentry.feedback',
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $a768bc6f321b7e3d$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== 'buffer') return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $a768bc6f321b7e3d$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $a768bc6f321b7e3d$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $a768bc6f321b7e3d$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $a768bc6f321b7e3d$var$handleAfterSendEvent(replay) : undefined;
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($a768bc6f321b7e3d$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$a768bc6f321b7e3d$var$isErrorEvent(event) && !$a768bc6f321b7e3d$var$isTransactionEvent(event) && !$a768bc6f321b7e3d$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($a768bc6f321b7e3d$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $a768bc6f321b7e3d$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($a768bc6f321b7e3d$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).log('[Replay] Ignoring error from rrweb internals', event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $a768bc6f321b7e3d$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: 'Replay'
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $a768bc6f321b7e3d$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $a768bc6f321b7e3d$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: 'performanceSpan',
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === 'string' ? Promise.resolve(null) : response;
    });
}
function $a768bc6f321b7e3d$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: 'navigation.push',
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $a768bc6f321b7e3d$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $a768bc6f321b7e3d$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $a768bc6f321b7e3d$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $a768bc6f321b7e3d$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($a768bc6f321b7e3d$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $05579b125d50bf43$export$d92e61f5600202af)(url, (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $a768bc6f321b7e3d$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($a768bc6f321b7e3d$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $a768bc6f321b7e3d$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $a768bc6f321b7e3d$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: 'resource.fetch',
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function $a768bc6f321b7e3d$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $a768bc6f321b7e3d$var$handleFetch(handlerData);
        $a768bc6f321b7e3d$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $a768bc6f321b7e3d$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $bc641309b3f67a9f$export$55b6bb1e45c6cf59];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: 'resource.xhr',
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function $a768bc6f321b7e3d$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $a768bc6f321b7e3d$var$handleXhr(handlerData);
        $a768bc6f321b7e3d$var$addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function $a768bc6f321b7e3d$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === 'string') return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $a768bc6f321b7e3d$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $a768bc6f321b7e3d$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $a768bc6f321b7e3d$var$getBodyString(body) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $a768bc6f321b7e3d$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Replay] Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).info('[Replay] Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
/** Merge a warning into an existing network request/response. */ function $a768bc6f321b7e3d$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $a768bc6f321b7e3d$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $a768bc6f321b7e3d$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                'URL_SKIPPED'
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $a768bc6f321b7e3d$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $a768bc6f321b7e3d$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $a768bc6f321b7e3d$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $a768bc6f321b7e3d$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $a768bc6f321b7e3d$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== 'string') return {
        body: body
    };
    const exceedsSizeLimit = body.length > $a768bc6f321b7e3d$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $a768bc6f321b7e3d$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $a768bc6f321b7e3d$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                'MAYBE_JSON_TRUNCATED'
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                'TEXT_TRUNCATED'
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $a768bc6f321b7e3d$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === '[' && last === ']' || first === '{' && last === '}';
}
/** Match an URL against a list of strings/Regex. */ function $a768bc6f321b7e3d$var$urlMatches(url, urls) {
    const fullUrl = $a768bc6f321b7e3d$var$getFullUrl(url);
    return (0, $e6e4baebb92dff28$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $a768bc6f321b7e3d$var$getFullUrl(url, baseURI = $a768bc6f321b7e3d$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith($a768bc6f321b7e3d$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith('/') && fullUrl.endsWith('/')) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $a768bc6f321b7e3d$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $a768bc6f321b7e3d$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $a768bc6f321b7e3d$var$makeNetworkReplayBreadcrumb('resource.fetch', data);
        $a768bc6f321b7e3d$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('[Replay] Failed to capture fetch breadcrumb', error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $a768bc6f321b7e3d$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = input ? $a768bc6f321b7e3d$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $a768bc6f321b7e3d$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $a768bc6f321b7e3d$var$parseContentLengthHeader(response.headers.get('content-length')) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $a768bc6f321b7e3d$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $a768bc6f321b7e3d$var$urlMatches(url, options.networkDetailAllowUrls) && !$a768bc6f321b7e3d$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $a768bc6f321b7e3d$var$_getRequestInfo(options, hint.input, requestBodySize) : $a768bc6f321b7e3d$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $a768bc6f321b7e3d$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $a768bc6f321b7e3d$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $a768bc6f321b7e3d$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $a768bc6f321b7e3d$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $a768bc6f321b7e3d$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $a768bc6f321b7e3d$var$getBodyString(requestBody);
    const data = $a768bc6f321b7e3d$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $a768bc6f321b7e3d$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $a768bc6f321b7e3d$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $a768bc6f321b7e3d$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $a768bc6f321b7e3d$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $a768bc6f321b7e3d$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $a768bc6f321b7e3d$var$_parseFetchResponseBody(response);
    const result = $a768bc6f321b7e3d$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        textEncoder: textEncoder,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $a768bc6f321b7e3d$var$mergeWarning(result, warning);
    return result;
}
function $a768bc6f321b7e3d$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $a768bc6f321b7e3d$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $a768bc6f321b7e3d$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $a768bc6f321b7e3d$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $a768bc6f321b7e3d$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Replay] Failed to serialize response body', error);
        // fallback
        return $a768bc6f321b7e3d$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $a768bc6f321b7e3d$var$_parseFetchResponseBody(response) {
    const res = $a768bc6f321b7e3d$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        'BODY_PARSE_ERROR'
    ];
    try {
        const text = await $a768bc6f321b7e3d$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Replay] Failed to get text body from response', error);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
}
function $a768bc6f321b7e3d$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') return undefined;
    return fetchArgs[1].body;
}
function $a768bc6f321b7e3d$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $a768bc6f321b7e3d$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') return $a768bc6f321b7e3d$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $a768bc6f321b7e3d$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $a768bc6f321b7e3d$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $a768bc6f321b7e3d$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $a768bc6f321b7e3d$var$getAllowedHeaders(headers, allowedHeaders);
}
function $a768bc6f321b7e3d$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Replay] Failed to clone response body', error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $a768bc6f321b7e3d$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error('Timeout while trying to read response body')), 500);
        $a768bc6f321b7e3d$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $a768bc6f321b7e3d$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $a768bc6f321b7e3d$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $a768bc6f321b7e3d$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $a768bc6f321b7e3d$var$makeNetworkReplayBreadcrumb('resource.xhr', data);
        $a768bc6f321b7e3d$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('[Replay] Failed to capture xhr breadcrumb', error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $a768bc6f321b7e3d$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $a768bc6f321b7e3d$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader('content-length') ? $a768bc6f321b7e3d$var$parseContentLengthHeader(xhr.getResponseHeader('content-length')) : $a768bc6f321b7e3d$var$_getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $a768bc6f321b7e3d$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$a768bc6f321b7e3d$var$urlMatches(url, options.networkDetailAllowUrls) || $a768bc6f321b7e3d$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $a768bc6f321b7e3d$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $a768bc6f321b7e3d$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $bc641309b3f67a9f$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $a768bc6f321b7e3d$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $a768bc6f321b7e3d$var$getAllowedHeaders($a768bc6f321b7e3d$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $a768bc6f321b7e3d$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $a768bc6f321b7e3d$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $a768bc6f321b7e3d$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $a768bc6f321b7e3d$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $a768bc6f321b7e3d$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $a768bc6f321b7e3d$var$mergeWarning(response, responseWarning) : response
    };
}
function $a768bc6f321b7e3d$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $a768bc6f321b7e3d$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $a768bc6f321b7e3d$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Replay] Failed to get xhr response body', ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $a768bc6f321b7e3d$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === 'json' && body && typeof body === 'object') return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Replay] Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).info('[Replay] Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
function $a768bc6f321b7e3d$var$_getBodySize(body, responseType, textEncoder) {
    try {
        const bodyStr = responseType === 'json' && body && typeof body === 'object' ? JSON.stringify(body) : body;
        return $a768bc6f321b7e3d$var$getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $a768bc6f321b7e3d$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on('beforeAddBreadcrumb', (breadcrumb, hint)=>$a768bc6f321b7e3d$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $f72b9d1319ab84b6$export$f75d3c772c923df0)($a768bc6f321b7e3d$var$handleFetchSpanListener(replay));
            (0, $bc641309b3f67a9f$export$26ace48dd54c9aea)($a768bc6f321b7e3d$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $a768bc6f321b7e3d$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($a768bc6f321b7e3d$var$_isXhrBreadcrumb(breadcrumb) && $a768bc6f321b7e3d$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $a768bc6f321b7e3d$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $a768bc6f321b7e3d$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($a768bc6f321b7e3d$var$_isFetchBreadcrumb(breadcrumb) && $a768bc6f321b7e3d$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $a768bc6f321b7e3d$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $a768bc6f321b7e3d$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('Error when enriching network breadcrumb');
    }
}
function $a768bc6f321b7e3d$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'xhr';
}
function $a768bc6f321b7e3d$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'fetch';
}
function $a768bc6f321b7e3d$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $a768bc6f321b7e3d$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $a768bc6f321b7e3d$var$_LAST_BREADCRUMB = null;
function $a768bc6f321b7e3d$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $a768bc6f321b7e3d$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $a768bc6f321b7e3d$var$handleScope(scope);
        if (!result) return;
        $a768bc6f321b7e3d$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $a768bc6f321b7e3d$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($a768bc6f321b7e3d$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $a768bc6f321b7e3d$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$a768bc6f321b7e3d$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        'fetch',
        'xhr',
        'sentry.event',
        'sentry.transaction'
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith('ui.')) return null;
    if (newBreadcrumb.category === 'console') return $a768bc6f321b7e3d$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $a768bc6f321b7e3d$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $a768bc6f321b7e3d$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $a768bc6f321b7e3d$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === 'string') {
            if (arg.length > $a768bc6f321b7e3d$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $a768bc6f321b7e3d$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === 'object') try {
            const normalizedArg = (0, $e1a46ce691765a57$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $a768bc6f321b7e3d$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $a768bc6f321b7e3d$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $a768bc6f321b7e3d$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        'CONSOLE_ARG_TRUNCATED'
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $a768bc6f321b7e3d$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $2dfa7d22514dae4c$export$c7be4b0125a10cba)();
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    scope.addScopeListener($a768bc6f321b7e3d$var$handleScopeListener(replay));
    (0, $5ebfc0024cb31bca$export$5aeffd3db2cf9df7)($a768bc6f321b7e3d$var$handleDomListener(replay));
    (0, $3d019c6a05cabdc5$export$3f18c56c58114e75)($a768bc6f321b7e3d$var$handleHistorySpanListener(replay));
    $a768bc6f321b7e3d$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $a768bc6f321b7e3d$var$handleGlobalEventListener(replay, !$a768bc6f321b7e3d$var$hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, $640fc7d84f5323a0$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($a768bc6f321b7e3d$var$hasHooks(client)) {
        client.on('beforeSendEvent', $a768bc6f321b7e3d$var$handleBeforeSendEvent(replay));
        client.on('afterSendEvent', $a768bc6f321b7e3d$var$handleAfterSendEvent(replay));
        client.on('createDsc', (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on('startTransaction', (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on('finishTransaction', (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on('beforeSendFeedback', (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a768bc6f321b7e3d$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $a768bc6f321b7e3d$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($a768bc6f321b7e3d$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $a768bc6f321b7e3d$var$createMemoryEntry($a768bc6f321b7e3d$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $a768bc6f321b7e3d$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: 'memory',
        name: 'memory',
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $a768bc6f321b7e3d$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $a768bc6f321b7e3d$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).warn('[Replay] Received replay event after session expired.');
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $a768bc6f321b7e3d$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === 'buffer' && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$a768bc6f321b7e3d$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $a768bc6f321b7e3d$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === 'buffer' && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $a768bc6f321b7e3d$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $a768bc6f321b7e3d$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === 'session') // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $a768bc6f321b7e3d$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $a768bc6f321b7e3d$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: 'options',
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $a768bc6f321b7e3d$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $a768bc6f321b7e3d$var$addEventSync(replay, $a768bc6f321b7e3d$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $a768bc6f321b7e3d$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $e49341fc8a37f226$export$f93f7f385160c44e)((0, $e49341fc8a37f226$export$92b6093782fe661b)(replayEvent, (0, $e49341fc8a37f226$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: 'replay_event'
            },
            replayEvent
        ],
        [
            {
                type: 'replay_recording',
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $a768bc6f321b7e3d$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === 'string') payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $a768bc6f321b7e3d$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === 'object' && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    if (client.emit) client.emit('preprocessEvent', event, eventHint);
    const preparedEvent = await (0, $c16ffd4bab406a01$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $c4ea612155b0bcfa$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || 'javascript';
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || 'sentry.javascript.unknown',
        version: version || '0.0.0'
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $a768bc6f321b7e3d$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $a768bc6f321b7e3d$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    const scope = (0, $2dfa7d22514dae4c$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $a768bc6f321b7e3d$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $a768bc6f321b7e3d$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent('event_processor', 'replay', baseEvent);
        $a768bc6f321b7e3d$var$logInfo('An event processor returned `null`, will not send event.');
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $a768bc6f321b7e3d$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($a768bc6f321b7e3d$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new $a768bc6f321b7e3d$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $d8edbed396e0ce87$export$699aff705e0d49d4)({}, response);
    if ((0, $d8edbed396e0ce87$export$6c91fec22056810a)(rateLimits, 'replay')) throw new $a768bc6f321b7e3d$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $a768bc6f321b7e3d$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $a768bc6f321b7e3d$var$RateLimitError extends Error {
    constructor(rateLimits){
        super('Rate limit hit');
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $a768bc6f321b7e3d$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $a768bc6f321b7e3d$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $a768bc6f321b7e3d$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $a768bc6f321b7e3d$var$TransportStatusCodeError || err instanceof $a768bc6f321b7e3d$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $2dfa7d22514dae4c$export$2f04de43fe27971a)('Replays', {
            _retryCount: retryConfig.count
        });
        if ($a768bc6f321b7e3d$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $2dfa7d22514dae4c$export$f5282963edea4a68)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $a768bc6f321b7e3d$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$a768bc6f321b7e3d$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $a768bc6f321b7e3d$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $a768bc6f321b7e3d$var$THROTTLED = '__THROTTLED';
const $a768bc6f321b7e3d$var$SKIPPED = '__SKIPPED';
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a768bc6f321b7e3d$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $a768bc6f321b7e3d$var$SKIPPED : $a768bc6f321b7e3d$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $a768bc6f321b7e3d$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $a768bc6f321b7e3d$var$ReplayContainer.prototype.__init.call(this);
        $a768bc6f321b7e3d$var$ReplayContainer.prototype.__init2.call(this);
        $a768bc6f321b7e3d$var$ReplayContainer.prototype.__init3.call(this);
        $a768bc6f321b7e3d$var$ReplayContainer.prototype.__init4.call(this);
        $a768bc6f321b7e3d$var$ReplayContainer.prototype.__init5.call(this);
        $a768bc6f321b7e3d$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = 'session';
        this.timeouts = {
            sessionIdlePause: $a768bc6f321b7e3d$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $a768bc6f321b7e3d$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ''
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $a768bc6f321b7e3d$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $a768bc6f321b7e3d$var$throttle((event, isCheckout)=>$a768bc6f321b7e3d$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($a768bc6f321b7e3d$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $a768bc6f321b7e3d$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : ''
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $a768bc6f321b7e3d$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error('Unable to initialize and create session'));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === 'buffer' && this.session.segmentId === 0 ? 'buffer' : 'session';
        $a768bc6f321b7e3d$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === 'session') throw new Error('Replay recording is already in progress');
        if (this._isEnabled && this.recordingMode === 'buffer') throw new Error('Replay buffering is in progress, call `flush()` to save the replay');
        $a768bc6f321b7e3d$var$logInfoNextTick('[Replay] Starting replay in session mode', this._options._experiments.traceInternals);
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $a768bc6f321b7e3d$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error('Replay recording is already in progress');
        $a768bc6f321b7e3d$var$logInfoNextTick('[Replay] Starting replay in buffer mode', this._options._experiments.traceInternals);
        const session = $a768bc6f321b7e3d$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = 'buffer';
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $a768bc6f321b7e3d$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === 'buffer' && {
                    checkoutEveryNms: $a768bc6f321b7e3d$var$BUFFER_CHECKOUT_TIME
                },
                emit: $a768bc6f321b7e3d$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $a768bc6f321b7e3d$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ''}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $a768bc6f321b7e3d$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $a768bc6f321b7e3d$var$logInfo('[Replay] Pausing replay', this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $a768bc6f321b7e3d$var$logInfo('[Replay] Resuming replay', this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === 'session') return this.flushImmediate();
        const activityTime = Date.now();
        $a768bc6f321b7e3d$var$logInfo('[Replay] Converting buffer to session', this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === 'session') return;
        // Re-start recording in session-mode
        this.recordingMode = 'session';
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === 'buffer') return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === 'buffer') return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $a768bc6f321b7e3d$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === 'session') {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$a768bc6f321b7e3d$var$WINDOW.location.pathname}${$a768bc6f321b7e3d$var$WINDOW.location.hash}${$a768bc6f321b7e3d$var$WINDOW.location.search}`;
        const url = `${$a768bc6f321b7e3d$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $a768bc6f321b7e3d$var$THROTTLED) {
            const breadcrumb = $a768bc6f321b7e3d$var$createBreadcrumb({
                category: 'replay.throttled'
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$a768bc6f321b7e3d$var$addEventSync(this, {
                    type: $a768bc6f321b7e3d$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: 'breadcrumb',
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        // eslint-disable-next-line deprecation/deprecation
        const lastTransaction = this.lastTransaction || (0, $2dfa7d22514dae4c$export$c7be4b0125a10cba)().getTransaction();
        const attributes = lastTransaction && (0, $43985f001f6f055c$export$92d8c23565496537)(lastTransaction).data || {};
        const source = attributes[0, $2296c04c99eaa4ca$export$d7a7d984b0791405];
        if (!lastTransaction || !source || ![
            'route',
            'custom'
        ].includes(source)) return undefined;
        return (0, $43985f001f6f055c$export$92d8c23565496537)(lastTransaction).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $a768bc6f321b7e3d$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('[Replay]', error);
        if ($a768bc6f321b7e3d$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $2dfa7d22514dae4c$export$f5282963edea4a68)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $a768bc6f321b7e3d$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($a768bc6f321b7e3d$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: 'refresh session'
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $a768bc6f321b7e3d$var$WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
            $a768bc6f321b7e3d$var$WINDOW.addEventListener('blur', this._handleWindowBlur);
            $a768bc6f321b7e3d$var$WINDOW.addEventListener('focus', this._handleWindowFocus);
            $a768bc6f321b7e3d$var$WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $a768bc6f321b7e3d$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $a768bc6f321b7e3d$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $a768bc6f321b7e3d$var$WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
            $a768bc6f321b7e3d$var$WINDOW.removeEventListener('blur', this._handleWindowBlur);
            $a768bc6f321b7e3d$var$WINDOW.removeEventListener('focus', this._handleWindowFocus);
            $a768bc6f321b7e3d$var$WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($a768bc6f321b7e3d$var$WINDOW.document.visibilityState === 'visible') this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $a768bc6f321b7e3d$var$createBreadcrumb({
                category: 'ui.blur'
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $a768bc6f321b7e3d$var$createBreadcrumb({
                category: 'ui.focus'
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $a768bc6f321b7e3d$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $a768bc6f321b7e3d$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $a768bc6f321b7e3d$var$logInfo('[Replay] Document has become active, but session has expired');
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $a768bc6f321b7e3d$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: 'breadcrumb',
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $a768bc6f321b7e3d$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($a768bc6f321b7e3d$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('[Replay] No session or eventBuffer found to flush.');
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $a768bc6f321b7e3d$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error('Session is too long, not sending replay');
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $a768bc6f321b7e3d$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: 'sendReplay'
            });
            const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
            if (client) client.recordDroppedEvent('send_error', 'replay');
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error('[Replay] Attempting to finish replay event after session expired.');
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $a768bc6f321b7e3d$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? 'short' : 'long'}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $a768bc6f321b7e3d$var$logInfo('[Replay] Flushing initial segment without checkout.', this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $a768bc6f321b7e3d$var$DEBUG_BUILD && (0, $54d1043b2228e29f$export$af88d00dbe7f521).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $a768bc6f321b7e3d$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $a768bc6f321b7e3d$var$createBreadcrumb({
                    category: 'replay.mutations',
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: 'mutationLimit',
                    forceFlush: this.recordingMode === 'session'
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $a768bc6f321b7e3d$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === 'string' ? deprecatedSelectorOption.split(',') : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== 'undefined') {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === 'string') allSelectors.push(`.${deprecatedClassOption}`);
        (0, $54d1043b2228e29f$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.');
        });
    }
    return allSelectors.join(',');
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $a768bc6f321b7e3d$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $a768bc6f321b7e3d$var$getOption(mask, [
        '.sentry-mask',
        '[data-sentry-mask]'
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $a768bc6f321b7e3d$var$getOption(unmask, [
        '.sentry-unmask',
        '[data-sentry-unmask]'
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $a768bc6f321b7e3d$var$getOption(block, [
            '.sentry-block',
            '[data-sentry-block]',
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $a768bc6f321b7e3d$var$getOption(unblock, [
            '.sentry-unblock',
            '[data-sentry-unblock]'
        ]),
        ignoreSelector: $a768bc6f321b7e3d$var$getOption(ignore, [
            '.sentry-ignore',
            '[data-sentry-ignore]',
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $a768bc6f321b7e3d$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === 'value' && el.tagName === 'INPUT' && [
        'submit',
        'button'
    ].includes(el.getAttribute('type') || '')) return value.replace(/[\S]/g, '*');
    return value;
}
const $a768bc6f321b7e3d$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $a768bc6f321b7e3d$var$DEFAULT_NETWORK_HEADERS = [
    'content-length',
    'content-type',
    'accept'
];
let $a768bc6f321b7e3d$var$_initialized = false;
const $a768bc6f321b7e3d$export$2832a2ae028f5e28 = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $a768bc6f321b7e3d$export$6b59b88de1ff9cb7(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ class $a768bc6f321b7e3d$export$6b59b88de1ff9cb7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Replay';
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $a768bc6f321b7e3d$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $a768bc6f321b7e3d$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $a768bc6f321b7e3d$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $a768bc6f321b7e3d$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        'title',
        'placeholder'
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $a768bc6f321b7e3d$export$6b59b88de1ff9cb7.id;
        const privacyOptions = $a768bc6f321b7e3d$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            ignoreClass: ignoreClass
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$a768bc6f321b7e3d$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: 'all',
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $a768bc6f321b7e3d$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $a768bc6f321b7e3d$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $a768bc6f321b7e3d$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $a768bc6f321b7e3d$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === 'number') {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === 'number') {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $a768bc6f321b7e3d$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$a768bc6f321b7e3d$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $a3b7b49346b363b5$export$4e09c449d6c407f7)()) throw new Error('Multiple Sentry Session Replay instances are not supported');
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $a768bc6f321b7e3d$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $a768bc6f321b7e3d$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $a3b7b49346b363b5$export$4e09c449d6c407f7)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === 'session'
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $a768bc6f321b7e3d$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $a768bc6f321b7e3d$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
            const canvasIntegration = client.getIntegrationByName('ReplayCanvas');
            if (!canvasIntegration) return;
            this._replay['_canvas'] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$a768bc6f321b7e3d$export$6b59b88de1ff9cb7.__initStatic();
/** Parse Replay-related options from SDK options */ function $a768bc6f321b7e3d$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $89b84fdfd1cfae9c$export$d25f2688db1bb433)(initialOptions)
    };
    if (!opt) {
        (0, $54d1043b2228e29f$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('SDK client is not available.');
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, $54d1043b2228e29f$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    });
    if (typeof opt.replaysSessionSampleRate === 'number') finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === 'number') finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $a768bc6f321b7e3d$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$a768bc6f321b7e3d$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function $a768bc6f321b7e3d$export$81cc0d0f72285d1() {
    const client = (0, $2dfa7d22514dae4c$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName && client.getIntegrationByName('Replay');
}
// eslint-disable-next-line deprecation/deprecation
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $a768bc6f321b7e3d$export$b28310b2f161456b = $a768bc6f321b7e3d$export$81cc0d0f72285d1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $a768bc6f321b7e3d$export$d7706faf7ab354bf = $a768bc6f321b7e3d$export$2832a2ae028f5e28;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ // eslint-disable-next-line deprecation/deprecation
class $a768bc6f321b7e3d$export$a35c789ed37ee0f7 extends $a768bc6f321b7e3d$export$6b59b88de1ff9cb7 {
}





var $1db749c92da399da$var$__defProp = Object.defineProperty;
var $1db749c92da399da$var$__defProps = Object.defineProperties;
var $1db749c92da399da$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $1db749c92da399da$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $1db749c92da399da$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1db749c92da399da$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1db749c92da399da$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1db749c92da399da$var$__knownSymbol = (name, symbol)=>(symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var $1db749c92da399da$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $1db749c92da399da$var$__defNormalProp = (obj, key, value)=>key in obj ? $1db749c92da399da$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1db749c92da399da$export$7de063a7aa429f6c = (a, b)=>{
    for(var prop in b || (b = {}))if ($1db749c92da399da$var$__hasOwnProp.call(b, prop)) $1db749c92da399da$var$__defNormalProp(a, prop, b[prop]);
    if ($1db749c92da399da$var$__getOwnPropSymbols) {
        for (var prop of $1db749c92da399da$var$__getOwnPropSymbols(b))if ($1db749c92da399da$var$__propIsEnum.call(b, prop)) $1db749c92da399da$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $1db749c92da399da$export$f4da8f157c1253f7 = (a, b)=>$1db749c92da399da$var$__defProps(a, $1db749c92da399da$var$__getOwnPropDescs(b));
var $1db749c92da399da$export$85c93885f16e8446 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $1db749c92da399da$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $1db749c92da399da$var$__defProp(target, key, result);
    return result;
};
var $1db749c92da399da$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $1db749c92da399da$var$__typeError("Cannot " + msg);
var $1db749c92da399da$export$18a094aefa070634 = (obj, member, getter)=>($1db749c92da399da$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $1db749c92da399da$export$addf369becd23283 = (obj, member, value)=>member.has(obj) ? $1db749c92da399da$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $1db749c92da399da$export$42432efe6614d3b4 = (obj, member, value, setter)=>($1db749c92da399da$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $1db749c92da399da$var$__await = function(promise, isYieldStar) {
    this[0] = promise;
    this[1] = isYieldStar;
};
var $1db749c92da399da$export$5590fd18e5672c2 = (value)=>{
    var obj = value[$1db749c92da399da$var$__knownSymbol("asyncIterator")], isAwait = false, method, it = {};
    if (obj == null) {
        obj = value[$1db749c92da399da$var$__knownSymbol("iterator")]();
        method = (k)=>it[k] = (x)=>obj[k](x);
    } else {
        obj = obj.call(value);
        method = (k)=>it[k] = (v)=>{
                if (isAwait) {
                    isAwait = false;
                    if (k === "throw") throw v;
                    return v;
                }
                isAwait = true;
                return {
                    done: false,
                    value: new $1db749c92da399da$var$__await(new Promise((resolve)=>{
                        var x = obj[k](v);
                        if (!(x instanceof Object)) $1db749c92da399da$var$__typeError("Object expected");
                        resolve(x);
                    }), 1)
                };
            };
    }
    return it[$1db749c92da399da$var$__knownSymbol("iterator")] = ()=>it, method("next"), "throw" in obj ? method("throw") : it.throw = (x)=>{
        throw x;
    }, "return" in obj && method("return"), it;
};


// src/internal/form.ts
var $6aba7ae81ba45aa2$export$61a522b559454891 = /* @__PURE__ */ new WeakMap();
var $6aba7ae81ba45aa2$var$reportValidityOverloads = /* @__PURE__ */ new WeakMap();
var $6aba7ae81ba45aa2$var$checkValidityOverloads = /* @__PURE__ */ new WeakMap();
var $6aba7ae81ba45aa2$var$userInteractedControls = /* @__PURE__ */ new WeakSet();
var $6aba7ae81ba45aa2$var$interactions = /* @__PURE__ */ new WeakMap();
var $6aba7ae81ba45aa2$export$43da334182d34ab4 = class {
    constructor(host, options){
        this.handleFormData = (event)=>{
            const disabled = this.options.disabled(this.host);
            const name = this.options.name(this.host);
            const value = this.options.value(this.host);
            const isButton = this.host.tagName.toLowerCase() === "sl-button";
            if (this.host.isConnected && !disabled && !isButton && typeof name === "string" && name.length > 0 && typeof value !== "undefined") {
                if (Array.isArray(value)) value.forEach((val)=>{
                    event.formData.append(name, val.toString());
                });
                else event.formData.append(name, value.toString());
            }
        };
        this.handleFormSubmit = (event)=>{
            var _a;
            const disabled = this.options.disabled(this.host);
            const reportValidity = this.options.reportValidity;
            if (this.form && !this.form.noValidate) (_a = $6aba7ae81ba45aa2$export$61a522b559454891.get(this.form)) == null || _a.forEach((control)=>{
                this.setUserInteracted(control, true);
            });
            if (this.form && !this.form.noValidate && !disabled && !reportValidity(this.host)) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        };
        this.handleFormReset = ()=>{
            this.options.setValue(this.host, this.options.defaultValue(this.host));
            this.setUserInteracted(this.host, false);
            $6aba7ae81ba45aa2$var$interactions.set(this.host, []);
        };
        this.handleInteraction = (event)=>{
            const emittedEvents = $6aba7ae81ba45aa2$var$interactions.get(this.host);
            if (!emittedEvents.includes(event.type)) emittedEvents.push(event.type);
            if (emittedEvents.length === this.options.assumeInteractionOn.length) this.setUserInteracted(this.host, true);
        };
        this.checkFormValidity = ()=>{
            if (this.form && !this.form.noValidate) {
                const elements = this.form.querySelectorAll("*");
                for (const element of elements)if (typeof element.checkValidity === "function") {
                    if (!element.checkValidity()) return false;
                }
            }
            return true;
        };
        this.reportFormValidity = ()=>{
            if (this.form && !this.form.noValidate) {
                const elements = this.form.querySelectorAll("*");
                for (const element of elements)if (typeof element.reportValidity === "function") {
                    if (!element.reportValidity()) return false;
                }
            }
            return true;
        };
        (this.host = host).addController(this);
        this.options = (0, $1db749c92da399da$export$7de063a7aa429f6c)({
            form: (input)=>{
                const formId = input.form;
                if (formId) {
                    const root = input.getRootNode();
                    const form = root.querySelector(`#${formId}`);
                    if (form) return form;
                }
                return input.closest("form");
            },
            name: (input)=>input.name,
            value: (input)=>input.value,
            defaultValue: (input)=>input.defaultValue,
            disabled: (input)=>{
                var _a;
                return (_a = input.disabled) != null ? _a : false;
            },
            reportValidity: (input)=>typeof input.reportValidity === "function" ? input.reportValidity() : true,
            checkValidity: (input)=>typeof input.checkValidity === "function" ? input.checkValidity() : true,
            setValue: (input, value)=>input.value = value,
            assumeInteractionOn: [
                "sl-input"
            ]
        }, options);
    }
    hostConnected() {
        const form = this.options.form(this.host);
        if (form) this.attachForm(form);
        $6aba7ae81ba45aa2$var$interactions.set(this.host, []);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.addEventListener(event, this.handleInteraction);
        });
    }
    hostDisconnected() {
        this.detachForm();
        $6aba7ae81ba45aa2$var$interactions.delete(this.host);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.removeEventListener(event, this.handleInteraction);
        });
    }
    hostUpdated() {
        const form = this.options.form(this.host);
        if (!form) this.detachForm();
        if (form && this.form !== form) {
            this.detachForm();
            this.attachForm(form);
        }
        if (this.host.hasUpdated) this.setValidity(this.host.validity.valid);
    }
    attachForm(form) {
        if (form) {
            this.form = form;
            if ($6aba7ae81ba45aa2$export$61a522b559454891.has(this.form)) $6aba7ae81ba45aa2$export$61a522b559454891.get(this.form).add(this.host);
            else $6aba7ae81ba45aa2$export$61a522b559454891.set(this.form, /* @__PURE__ */ new Set([
                this.host
            ]));
            this.form.addEventListener("formdata", this.handleFormData);
            this.form.addEventListener("submit", this.handleFormSubmit);
            this.form.addEventListener("reset", this.handleFormReset);
            if (!$6aba7ae81ba45aa2$var$reportValidityOverloads.has(this.form)) {
                $6aba7ae81ba45aa2$var$reportValidityOverloads.set(this.form, this.form.reportValidity);
                this.form.reportValidity = ()=>this.reportFormValidity();
            }
            if (!$6aba7ae81ba45aa2$var$checkValidityOverloads.has(this.form)) {
                $6aba7ae81ba45aa2$var$checkValidityOverloads.set(this.form, this.form.checkValidity);
                this.form.checkValidity = ()=>this.checkFormValidity();
            }
        } else this.form = void 0;
    }
    detachForm() {
        if (!this.form) return;
        const formCollection = $6aba7ae81ba45aa2$export$61a522b559454891.get(this.form);
        if (!formCollection) return;
        formCollection.delete(this.host);
        if (formCollection.size <= 0) {
            this.form.removeEventListener("formdata", this.handleFormData);
            this.form.removeEventListener("submit", this.handleFormSubmit);
            this.form.removeEventListener("reset", this.handleFormReset);
            if ($6aba7ae81ba45aa2$var$reportValidityOverloads.has(this.form)) {
                this.form.reportValidity = $6aba7ae81ba45aa2$var$reportValidityOverloads.get(this.form);
                $6aba7ae81ba45aa2$var$reportValidityOverloads.delete(this.form);
            }
            if ($6aba7ae81ba45aa2$var$checkValidityOverloads.has(this.form)) {
                this.form.checkValidity = $6aba7ae81ba45aa2$var$checkValidityOverloads.get(this.form);
                $6aba7ae81ba45aa2$var$checkValidityOverloads.delete(this.form);
            }
            this.form = void 0;
        }
    }
    setUserInteracted(el, hasInteracted) {
        if (hasInteracted) $6aba7ae81ba45aa2$var$userInteractedControls.add(el);
        else $6aba7ae81ba45aa2$var$userInteractedControls.delete(el);
        el.requestUpdate();
    }
    doAction(type, submitter) {
        if (this.form) {
            const button = document.createElement("button");
            button.type = type;
            button.style.position = "absolute";
            button.style.width = "0";
            button.style.height = "0";
            button.style.clipPath = "inset(50%)";
            button.style.overflow = "hidden";
            button.style.whiteSpace = "nowrap";
            if (submitter) {
                button.name = submitter.name;
                button.value = submitter.value;
                [
                    "formaction",
                    "formenctype",
                    "formmethod",
                    "formnovalidate",
                    "formtarget"
                ].forEach((attr)=>{
                    if (submitter.hasAttribute(attr)) button.setAttribute(attr, submitter.getAttribute(attr));
                });
            }
            this.form.append(button);
            button.click();
            button.remove();
        }
    }
    /** Returns the associated `<form>` element, if one exists. */ getForm() {
        var _a;
        return (_a = this.form) != null ? _a : null;
    }
    /** Resets the form, restoring all the control to their default value */ reset(submitter) {
        this.doAction("reset", submitter);
    }
    /** Submits the form, triggering validation and form data injection. */ submit(submitter) {
        this.doAction("submit", submitter);
    }
    /**
   * Synchronously sets the form control's validity. Call this when you know the future validity but need to update
   * the host element immediately, i.e. before Lit updates the component in the next update.
   */ setValidity(isValid) {
        const host = this.host;
        const hasInteracted = Boolean($6aba7ae81ba45aa2$var$userInteractedControls.has(host));
        const required = Boolean(host.required);
        host.toggleAttribute("data-required", required);
        host.toggleAttribute("data-optional", !required);
        host.toggleAttribute("data-invalid", !isValid);
        host.toggleAttribute("data-valid", isValid);
        host.toggleAttribute("data-user-invalid", !isValid && hasInteracted);
        host.toggleAttribute("data-user-valid", isValid && hasInteracted);
    }
    /**
   * Updates the form control's validity based on the current value of `host.validity.valid`. Call this when anything
   * that affects constraint validation changes so the component receives the correct validity states.
   */ updateValidity() {
        const host = this.host;
        this.setValidity(host.validity.valid);
    }
    /**
   * Dispatches a non-bubbling, cancelable custom event of type `sl-invalid`.
   * If the `sl-invalid` event will be cancelled then the original `invalid`
   * event (which may have been passed as argument) will also be cancelled.
   * If no original `invalid` event has been passed then the `sl-invalid`
   * event will be cancelled before being dispatched.
   */ emitInvalidEvent(originalInvalidEvent) {
        const slInvalidEvent = new CustomEvent("sl-invalid", {
            bubbles: false,
            composed: false,
            cancelable: true,
            detail: {}
        });
        if (!originalInvalidEvent) slInvalidEvent.preventDefault();
        if (!this.host.dispatchEvent(slInvalidEvent)) originalInvalidEvent == null || originalInvalidEvent.preventDefault();
    }
};
var $6aba7ae81ba45aa2$export$6c5960ddf0f5ff89 = Object.freeze({
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valid: true,
    valueMissing: false
});
var $6aba7ae81ba45aa2$export$bd584164a4d1886c = Object.freeze((0, $1db749c92da399da$export$f4da8f157c1253f7)((0, $1db749c92da399da$export$7de063a7aa429f6c)({}, $6aba7ae81ba45aa2$export$6c5960ddf0f5ff89), {
    valid: false,
    valueMissing: true
}));
var $6aba7ae81ba45aa2$export$d17679f2bc5863d4 = Object.freeze((0, $1db749c92da399da$export$f4da8f157c1253f7)((0, $1db749c92da399da$export$7de063a7aa429f6c)({}, $6aba7ae81ba45aa2$export$6c5960ddf0f5ff89), {
    valid: false,
    customError: true
}));


// src/utilities/form.ts
function $56f8b77c345019f6$export$dfdc1655ccc5b9cb(form) {
    const formData = new FormData(form);
    const object = {};
    formData.forEach((value, key)=>{
        if (Reflect.has(object, key)) {
            const entry = object[key];
            if (Array.isArray(entry)) entry.push(value);
            else object[key] = [
                object[key],
                value
            ];
        } else object[key] = value;
    });
    return object;
}
function $56f8b77c345019f6$export$2742a3285d55034(form) {
    const rootNode = form.getRootNode();
    const allNodes = [
        ...rootNode.querySelectorAll("*")
    ];
    const formControls = [
        ...form.elements
    ];
    const collection = (0, $6aba7ae81ba45aa2$export$61a522b559454891).get(form);
    const shoelaceFormControls = collection ? Array.from(collection) : [];
    return [
        ...formControls,
        ...shoelaceFormControls
    ].sort((a, b)=>{
        if (allNodes.indexOf(a) < allNodes.indexOf(b)) return -1;
        if (allNodes.indexOf(a) > allNodes.indexOf(b)) return 1;
        return 0;
    });
}




// src/components/visually-hidden/visually-hidden.styles.ts
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d166a5a387251cdc$var$t = globalThis, $d166a5a387251cdc$export$b4d10f6001c083c2 = $d166a5a387251cdc$var$t.ShadowRoot && (void 0 === $d166a5a387251cdc$var$t.ShadyCSS || $d166a5a387251cdc$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $d166a5a387251cdc$var$s = Symbol(), $d166a5a387251cdc$var$o = new WeakMap;
class $d166a5a387251cdc$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $d166a5a387251cdc$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($d166a5a387251cdc$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $d166a5a387251cdc$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $d166a5a387251cdc$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $d166a5a387251cdc$export$8d80f9cac07cdb3 = (t)=>new $d166a5a387251cdc$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $d166a5a387251cdc$var$s), $d166a5a387251cdc$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $d166a5a387251cdc$export$505d1e8739bad805(o, t, $d166a5a387251cdc$var$s);
}, $d166a5a387251cdc$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($d166a5a387251cdc$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $d166a5a387251cdc$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $d166a5a387251cdc$export$ee69dfd951e24778 = $d166a5a387251cdc$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $d166a5a387251cdc$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $7ece5e2ccb4fd0d9$var$i, defineProperty: $7ece5e2ccb4fd0d9$var$e, getOwnPropertyDescriptor: $7ece5e2ccb4fd0d9$var$r, getOwnPropertyNames: $7ece5e2ccb4fd0d9$var$h, getOwnPropertySymbols: $7ece5e2ccb4fd0d9$var$o, getPrototypeOf: $7ece5e2ccb4fd0d9$var$n } = Object, $7ece5e2ccb4fd0d9$var$a = globalThis, $7ece5e2ccb4fd0d9$var$c = $7ece5e2ccb4fd0d9$var$a.trustedTypes, $7ece5e2ccb4fd0d9$var$l = $7ece5e2ccb4fd0d9$var$c ? $7ece5e2ccb4fd0d9$var$c.emptyScript : "", $7ece5e2ccb4fd0d9$var$p = $7ece5e2ccb4fd0d9$var$a.reactiveElementPolyfillSupport, $7ece5e2ccb4fd0d9$var$d = (t, s)=>t, $7ece5e2ccb4fd0d9$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $7ece5e2ccb4fd0d9$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $7ece5e2ccb4fd0d9$export$53a6892c50694894 = (t, s)=>!$7ece5e2ccb4fd0d9$var$i(t, s), $7ece5e2ccb4fd0d9$var$y = {
    attribute: !0,
    type: String,
    converter: $7ece5e2ccb4fd0d9$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $7ece5e2ccb4fd0d9$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $7ece5e2ccb4fd0d9$var$a.litPropertyMetadata ??= new WeakMap;
class $7ece5e2ccb4fd0d9$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $7ece5e2ccb4fd0d9$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $7ece5e2ccb4fd0d9$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $7ece5e2ccb4fd0d9$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $7ece5e2ccb4fd0d9$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($7ece5e2ccb4fd0d9$var$d("elementProperties"))) return;
        const t = $7ece5e2ccb4fd0d9$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($7ece5e2ccb4fd0d9$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($7ece5e2ccb4fd0d9$var$d("properties"))) {
            const t = this.properties, s = [
                ...$7ece5e2ccb4fd0d9$var$h(t),
                ...$7ece5e2ccb4fd0d9$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $d166a5a387251cdc$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $d166a5a387251cdc$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $d166a5a387251cdc$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $7ece5e2ccb4fd0d9$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $7ece5e2ccb4fd0d9$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $7ece5e2ccb4fd0d9$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$7ece5e2ccb4fd0d9$export$c7c07a37856565d.elementStyles = [], $7ece5e2ccb4fd0d9$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $7ece5e2ccb4fd0d9$export$c7c07a37856565d[$7ece5e2ccb4fd0d9$var$d("elementProperties")] = new Map, $7ece5e2ccb4fd0d9$export$c7c07a37856565d[$7ece5e2ccb4fd0d9$var$d("finalized")] = new Map, $7ece5e2ccb4fd0d9$var$p?.({
    ReactiveElement: $7ece5e2ccb4fd0d9$export$c7c07a37856565d
}), ($7ece5e2ccb4fd0d9$var$a.reactiveElementVersions ??= []).push("2.0.4");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d2b76d366be0d5ac$var$t = globalThis, $d2b76d366be0d5ac$var$i = $d2b76d366be0d5ac$var$t.trustedTypes, $d2b76d366be0d5ac$var$s = $d2b76d366be0d5ac$var$i ? $d2b76d366be0d5ac$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $d2b76d366be0d5ac$var$e = "$lit$", $d2b76d366be0d5ac$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $d2b76d366be0d5ac$var$o = "?" + $d2b76d366be0d5ac$var$h, $d2b76d366be0d5ac$var$n = `<${$d2b76d366be0d5ac$var$o}>`, $d2b76d366be0d5ac$var$r = document, $d2b76d366be0d5ac$var$l = ()=>$d2b76d366be0d5ac$var$r.createComment(""), $d2b76d366be0d5ac$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $d2b76d366be0d5ac$var$a = Array.isArray, $d2b76d366be0d5ac$var$u = (t)=>$d2b76d366be0d5ac$var$a(t) || "function" == typeof t?.[Symbol.iterator], $d2b76d366be0d5ac$var$d = "[ \t\n\f\r]", $d2b76d366be0d5ac$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $d2b76d366be0d5ac$var$v = /-->/g, $d2b76d366be0d5ac$var$_ = />/g, $d2b76d366be0d5ac$var$m = RegExp(`>|${$d2b76d366be0d5ac$var$d}(?:([^\\s"'>=/]+)(${$d2b76d366be0d5ac$var$d}*=${$d2b76d366be0d5ac$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $d2b76d366be0d5ac$var$p = /'/g, $d2b76d366be0d5ac$var$g = /"/g, $d2b76d366be0d5ac$var$$ = /^(?:script|style|textarea|title)$/i, $d2b76d366be0d5ac$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $d2b76d366be0d5ac$export$c0bb0b647f701bb5 = $d2b76d366be0d5ac$var$y(1), $d2b76d366be0d5ac$export$7ed1367e7fa1ad68 = $d2b76d366be0d5ac$var$y(2), $d2b76d366be0d5ac$export$47d5b44d225be5b4 = $d2b76d366be0d5ac$var$y(3), $d2b76d366be0d5ac$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $d2b76d366be0d5ac$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $d2b76d366be0d5ac$var$A = new WeakMap, $d2b76d366be0d5ac$var$C = $d2b76d366be0d5ac$var$r.createTreeWalker($d2b76d366be0d5ac$var$r, 129);
function $d2b76d366be0d5ac$var$P(t, i) {
    if (!$d2b76d366be0d5ac$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $d2b76d366be0d5ac$var$s ? $d2b76d366be0d5ac$var$s.createHTML(i) : i;
}
const $d2b76d366be0d5ac$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $d2b76d366be0d5ac$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $d2b76d366be0d5ac$var$f ? "!--" === u[1] ? c = $d2b76d366be0d5ac$var$v : void 0 !== u[1] ? c = $d2b76d366be0d5ac$var$_ : void 0 !== u[2] ? ($d2b76d366be0d5ac$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $d2b76d366be0d5ac$var$m) : void 0 !== u[3] && (c = $d2b76d366be0d5ac$var$m) : c === $d2b76d366be0d5ac$var$m ? ">" === u[0] ? (c = r ?? $d2b76d366be0d5ac$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $d2b76d366be0d5ac$var$m : '"' === u[3] ? $d2b76d366be0d5ac$var$g : $d2b76d366be0d5ac$var$p) : c === $d2b76d366be0d5ac$var$g || c === $d2b76d366be0d5ac$var$p ? c = $d2b76d366be0d5ac$var$m : c === $d2b76d366be0d5ac$var$v || c === $d2b76d366be0d5ac$var$_ ? c = $d2b76d366be0d5ac$var$f : (c = $d2b76d366be0d5ac$var$m, r = void 0);
        const x = c === $d2b76d366be0d5ac$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $d2b76d366be0d5ac$var$f ? s + $d2b76d366be0d5ac$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $d2b76d366be0d5ac$var$e + s.slice(d) + $d2b76d366be0d5ac$var$h + x) : s + $d2b76d366be0d5ac$var$h + (-2 === d ? i : x);
    }
    return [
        $d2b76d366be0d5ac$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $d2b76d366be0d5ac$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $d2b76d366be0d5ac$var$V(t, s);
        if (this.el = $d2b76d366be0d5ac$var$N.createElement(f, n), $d2b76d366be0d5ac$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $d2b76d366be0d5ac$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($d2b76d366be0d5ac$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($d2b76d366be0d5ac$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $d2b76d366be0d5ac$var$H : "?" === e[1] ? $d2b76d366be0d5ac$var$I : "@" === e[1] ? $d2b76d366be0d5ac$var$L : $d2b76d366be0d5ac$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($d2b76d366be0d5ac$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($d2b76d366be0d5ac$var$$.test(r.tagName)) {
                    const t = r.textContent.split($d2b76d366be0d5ac$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $d2b76d366be0d5ac$var$i ? $d2b76d366be0d5ac$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $d2b76d366be0d5ac$var$l()), $d2b76d366be0d5ac$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $d2b76d366be0d5ac$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $d2b76d366be0d5ac$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($d2b76d366be0d5ac$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $d2b76d366be0d5ac$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $d2b76d366be0d5ac$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $d2b76d366be0d5ac$var$S(t, i, s = t, e) {
    if (i === $d2b76d366be0d5ac$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $d2b76d366be0d5ac$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $d2b76d366be0d5ac$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $d2b76d366be0d5ac$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $d2b76d366be0d5ac$var$r).importNode(i, !0);
        $d2b76d366be0d5ac$var$C.currentNode = e;
        let h = $d2b76d366be0d5ac$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $d2b76d366be0d5ac$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $d2b76d366be0d5ac$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $d2b76d366be0d5ac$var$C.nextNode(), o++);
        }
        return $d2b76d366be0d5ac$var$C.currentNode = $d2b76d366be0d5ac$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $d2b76d366be0d5ac$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $d2b76d366be0d5ac$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $d2b76d366be0d5ac$var$S(this, t, i), $d2b76d366be0d5ac$var$c(t) ? t === $d2b76d366be0d5ac$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $d2b76d366be0d5ac$export$45b790e32b2810ee && this._$AR(), this._$AH = $d2b76d366be0d5ac$export$45b790e32b2810ee) : t !== this._$AH && t !== $d2b76d366be0d5ac$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $d2b76d366be0d5ac$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $d2b76d366be0d5ac$export$45b790e32b2810ee && $d2b76d366be0d5ac$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($d2b76d366be0d5ac$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $d2b76d366be0d5ac$var$N.createElement($d2b76d366be0d5ac$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $d2b76d366be0d5ac$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $d2b76d366be0d5ac$var$A.get(t.strings);
        return void 0 === i && $d2b76d366be0d5ac$var$A.set(t.strings, i = new $d2b76d366be0d5ac$var$N(t)), i;
    }
    k(t) {
        $d2b76d366be0d5ac$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $d2b76d366be0d5ac$var$R(this.O($d2b76d366be0d5ac$var$l()), this.O($d2b76d366be0d5ac$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $d2b76d366be0d5ac$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $d2b76d366be0d5ac$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $d2b76d366be0d5ac$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $d2b76d366be0d5ac$var$S(this, t, i, 0), o = !$d2b76d366be0d5ac$var$c(t) || t !== this._$AH && t !== $d2b76d366be0d5ac$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $d2b76d366be0d5ac$var$S(this, e[s + n], i, n), r === $d2b76d366be0d5ac$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$d2b76d366be0d5ac$var$c(r) || r !== this._$AH[n], r === $d2b76d366be0d5ac$export$45b790e32b2810ee ? t = $d2b76d366be0d5ac$export$45b790e32b2810ee : t !== $d2b76d366be0d5ac$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $d2b76d366be0d5ac$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $d2b76d366be0d5ac$var$H extends $d2b76d366be0d5ac$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $d2b76d366be0d5ac$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $d2b76d366be0d5ac$var$I extends $d2b76d366be0d5ac$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $d2b76d366be0d5ac$export$45b790e32b2810ee);
    }
}
class $d2b76d366be0d5ac$var$L extends $d2b76d366be0d5ac$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $d2b76d366be0d5ac$var$S(this, t, i, 0) ?? $d2b76d366be0d5ac$export$45b790e32b2810ee) === $d2b76d366be0d5ac$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $d2b76d366be0d5ac$export$45b790e32b2810ee && s !== $d2b76d366be0d5ac$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $d2b76d366be0d5ac$export$45b790e32b2810ee && (s === $d2b76d366be0d5ac$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $d2b76d366be0d5ac$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $d2b76d366be0d5ac$var$S(this, t);
    }
}
const $d2b76d366be0d5ac$export$8613d1ca9052b22e = {
    M: $d2b76d366be0d5ac$var$e,
    P: $d2b76d366be0d5ac$var$h,
    A: $d2b76d366be0d5ac$var$o,
    C: 1,
    L: $d2b76d366be0d5ac$var$V,
    R: $d2b76d366be0d5ac$var$M,
    D: $d2b76d366be0d5ac$var$u,
    V: $d2b76d366be0d5ac$var$S,
    I: $d2b76d366be0d5ac$var$R,
    H: $d2b76d366be0d5ac$var$k,
    N: $d2b76d366be0d5ac$var$I,
    U: $d2b76d366be0d5ac$var$L,
    B: $d2b76d366be0d5ac$var$H,
    F: $d2b76d366be0d5ac$var$z
}, $d2b76d366be0d5ac$var$j = $d2b76d366be0d5ac$var$t.litHtmlPolyfillSupport;
$d2b76d366be0d5ac$var$j?.($d2b76d366be0d5ac$var$N, $d2b76d366be0d5ac$var$R), ($d2b76d366be0d5ac$var$t.litHtmlVersions ??= []).push("3.2.1");
const $d2b76d366be0d5ac$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $d2b76d366be0d5ac$var$R(i.insertBefore($d2b76d366be0d5ac$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $70334511cd44bfe1$export$3f2f9f5909897157 extends (0, $7ece5e2ccb4fd0d9$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const s = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $d2b76d366be0d5ac$export$b3890eb0ae9dca99)(s, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $d2b76d366be0d5ac$export$9c068ae9cc5db4e8;
    }
}
$70334511cd44bfe1$export$3f2f9f5909897157._$litElement$ = !0, $70334511cd44bfe1$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $70334511cd44bfe1$export$3f2f9f5909897157
});
const $70334511cd44bfe1$var$i = globalThis.litElementPolyfillSupport;
$70334511cd44bfe1$var$i?.({
    LitElement: $70334511cd44bfe1$export$3f2f9f5909897157
});
const $70334511cd44bfe1$export$f5c524615a7708d6 = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.1");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $253ff3cbfdeb982b$export$6acf61af03e62db = !1;




var $fc002381b26c1b67$export$b0bec24721b5ba87 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host(:not(:focus-within)) {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    clip: rect(0 0 0 0) !important;
    clip-path: inset(50%) !important;
    border: none !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    padding: 0 !important;
  }
`;


// src/styles/component.styles.ts

var $50b558233c88797a$export$e1ac0a3ec62d1269 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $19b7d8ef59faf75b$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0af69cb729554da0$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $7ece5e2ccb4fd0d9$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $7ece5e2ccb4fd0d9$export$53a6892c50694894)
}, $0af69cb729554da0$export$8d623b1670eb40f4 = (t = $0af69cb729554da0$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $0af69cb729554da0$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $0af69cb729554da0$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $52a0cf48ef66e8b5$export$ca000e230c0caa3e(r) {
    return (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $8a317031349a1d0f$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ba6019c4242af4aa$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c78fd40b9201a956$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $ba6019c4242af4aa$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $ba6019c4242af4aa$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $c3145f6a4a0df4d3$var$e;
function $c3145f6a4a0df4d3$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $ba6019c4242af4aa$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($c3145f6a4a0df4d3$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $92e5fd8708ba43bd$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $ba6019c4242af4aa$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ce2fc3983f753e0d$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $ba6019c4242af4aa$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $60d06c2a8e25874a$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $ba6019c4242af4aa$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}




var $a29c472ac6b25bc6$var$_hasRecordedInitialProperties;
var $a29c472ac6b25bc6$export$6f25236e887097b = class extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    constructor(){
        super();
        (0, $1db749c92da399da$export$addf369becd23283)(this, $a29c472ac6b25bc6$var$_hasRecordedInitialProperties, false);
        // Store the constructor value of all `static properties = {}`
        this.initialReflectedProperties = /* @__PURE__ */ new Map();
        Object.entries(this.constructor.dependencies).forEach(([name, component])=>{
            this.constructor.define(name, component);
        });
    }
    emit(name, options) {
        const event = new CustomEvent(name, (0, $1db749c92da399da$export$7de063a7aa429f6c)({
            bubbles: true,
            cancelable: false,
            composed: true,
            detail: {}
        }, options));
        this.dispatchEvent(event);
        return event;
    }
    /* eslint-enable */ static define(name, elementConstructor = this, options = {}) {
        const currentlyRegisteredConstructor = customElements.get(name);
        if (!currentlyRegisteredConstructor) {
            try {
                customElements.define(name, elementConstructor, options);
            } catch (_err) {
                customElements.define(name, class extends elementConstructor {
                }, options);
            }
            return;
        }
        let newVersion = " (unknown version)";
        let existingVersion = newVersion;
        if ("version" in elementConstructor && elementConstructor.version) newVersion = " v" + elementConstructor.version;
        if ("version" in currentlyRegisteredConstructor && currentlyRegisteredConstructor.version) existingVersion = " v" + currentlyRegisteredConstructor.version;
        if (newVersion && existingVersion && newVersion === existingVersion) return;
        console.warn(`Attempted to register <${name}>${newVersion}, but <${name}>${existingVersion} has already been registered.`);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!(0, $1db749c92da399da$export$18a094aefa070634)(this, $a29c472ac6b25bc6$var$_hasRecordedInitialProperties)) {
            this.constructor.elementProperties.forEach((obj, prop)=>{
                if (obj.reflect && this[prop] != null) this.initialReflectedProperties.set(prop, this[prop]);
            });
            (0, $1db749c92da399da$export$42432efe6614d3b4)(this, $a29c472ac6b25bc6$var$_hasRecordedInitialProperties, true);
        }
        super.attributeChangedCallback(name, oldValue, newValue);
    }
    willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        this.initialReflectedProperties.forEach((value, prop)=>{
            if (changedProperties.has(prop) && this[prop] == null) this[prop] = value;
        });
    }
};
$a29c472ac6b25bc6$var$_hasRecordedInitialProperties = new WeakMap();
/* eslint-disable */ // @ts-expect-error This is auto-injected at build time.
$a29c472ac6b25bc6$export$6f25236e887097b.version = "2.20.0";
$a29c472ac6b25bc6$export$6f25236e887097b.dependencies = {};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $a29c472ac6b25bc6$export$6f25236e887097b.prototype, "dir", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $a29c472ac6b25bc6$export$6f25236e887097b.prototype, "lang", 2);



var $dfcc3ba37f2248e3$export$f73c78e34b41d070 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)` <slot></slot> `;
    }
};
$dfcc3ba37f2248e3$export$f73c78e34b41d070.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $fc002381b26c1b67$export$b0bec24721b5ba87)
];


// src/components/visually-hidden/visually-hidden.ts
var $cb75cef68c77ea80$export$d4497fa7e1f0cec3 = (0, $dfcc3ba37f2248e3$export$f73c78e34b41d070);
(0, $dfcc3ba37f2248e3$export$f73c78e34b41d070).define("sl-visually-hidden");


// src/components/tooltip/tooltip.styles.ts

var $5ca30cda42c71fd0$export$1c03bed7efcdda42 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --max-width: 20rem;
    --hide-delay: 0ms;
    --show-delay: 150ms;

    display: contents;
  }

  .tooltip {
    --arrow-size: var(--sl-tooltip-arrow-size);
    --arrow-color: var(--sl-tooltip-background-color);
  }

  .tooltip::part(popup) {
    z-index: var(--sl-z-index-tooltip);
  }

  .tooltip[placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .tooltip[placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .tooltip[placement^='left']::part(popup) {
    transform-origin: right;
  }

  .tooltip[placement^='right']::part(popup) {
    transform-origin: left;
  }

  .tooltip__body {
    display: block;
    width: max-content;
    max-width: var(--max-width);
    border-radius: var(--sl-tooltip-border-radius);
    background-color: var(--sl-tooltip-background-color);
    font-family: var(--sl-tooltip-font-family);
    font-size: var(--sl-tooltip-font-size);
    font-weight: var(--sl-tooltip-font-weight);
    line-height: var(--sl-tooltip-line-height);
    text-align: start;
    white-space: normal;
    color: var(--sl-tooltip-color);
    padding: var(--sl-tooltip-padding);
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
  }
`;


// src/components/popup/popup.styles.ts

var $5df229559c6425f5$export$51897b955cb6c203 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --arrow-color: var(--sl-color-neutral-1000);
    --arrow-size: 6px;

    /*
     * These properties are computed to account for the arrow's dimensions after being rotated 45º. The constant
     * 0.7071 is derived from sin(45), which is the diagonal size of the arrow's container after rotating.
     */
    --arrow-size-diagonal: calc(var(--arrow-size) * 0.7071);
    --arrow-padding-offset: calc(var(--arrow-size-diagonal) - var(--arrow-size));

    display: contents;
  }

  .popup {
    position: absolute;
    isolation: isolate;
    max-width: var(--auto-size-available-width, none);
    max-height: var(--auto-size-available-height, none);
  }

  .popup--fixed {
    position: fixed;
  }

  .popup:not(.popup--active) {
    display: none;
  }

  .popup__arrow {
    position: absolute;
    width: calc(var(--arrow-size-diagonal) * 2);
    height: calc(var(--arrow-size-diagonal) * 2);
    rotate: 45deg;
    background: var(--arrow-color);
    z-index: -1;
  }

  /* Hover bridge */
  .popup-hover-bridge:not(.popup-hover-bridge--visible) {
    display: none;
  }

  .popup-hover-bridge {
    position: fixed;
    z-index: calc(var(--sl-z-index-dropdown) - 1);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    clip-path: polygon(
      var(--hover-bridge-top-left-x, 0) var(--hover-bridge-top-left-y, 0),
      var(--hover-bridge-top-right-x, 0) var(--hover-bridge-top-right-y, 0),
      var(--hover-bridge-bottom-right-x, 0) var(--hover-bridge-bottom-right-y, 0),
      var(--hover-bridge-bottom-left-x, 0) var(--hover-bridge-bottom-left-y, 0)
    );
  }
`;


// src/translations/en.ts
const $dd5eecfdadcef4f0$var$connectedElements = new Set();
const $dd5eecfdadcef4f0$var$translations = new Map();
let $dd5eecfdadcef4f0$var$fallback;
let $dd5eecfdadcef4f0$var$documentDirection = 'ltr';
let $dd5eecfdadcef4f0$var$documentLanguage = 'en';
const $dd5eecfdadcef4f0$var$isClient = typeof MutationObserver !== "undefined" && typeof document !== "undefined" && typeof document.documentElement !== "undefined";
if ($dd5eecfdadcef4f0$var$isClient) {
    const documentElementObserver = new MutationObserver($dd5eecfdadcef4f0$export$722fbec263ad908a);
    $dd5eecfdadcef4f0$var$documentDirection = document.documentElement.dir || 'ltr';
    $dd5eecfdadcef4f0$var$documentLanguage = document.documentElement.lang || navigator.language;
    documentElementObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [
            'dir',
            'lang'
        ]
    });
}
function $dd5eecfdadcef4f0$export$2332cb3ce32cc839(...translation) {
    translation.map((t)=>{
        const code = t.$code.toLowerCase();
        if ($dd5eecfdadcef4f0$var$translations.has(code)) $dd5eecfdadcef4f0$var$translations.set(code, Object.assign(Object.assign({}, $dd5eecfdadcef4f0$var$translations.get(code)), t));
        else $dd5eecfdadcef4f0$var$translations.set(code, t);
        if (!$dd5eecfdadcef4f0$var$fallback) $dd5eecfdadcef4f0$var$fallback = t;
    });
    $dd5eecfdadcef4f0$export$722fbec263ad908a();
}
function $dd5eecfdadcef4f0$export$722fbec263ad908a() {
    if ($dd5eecfdadcef4f0$var$isClient) {
        $dd5eecfdadcef4f0$var$documentDirection = document.documentElement.dir || 'ltr';
        $dd5eecfdadcef4f0$var$documentLanguage = document.documentElement.lang || navigator.language;
    }
    [
        ...$dd5eecfdadcef4f0$var$connectedElements.keys()
    ].map((el)=>{
        if (typeof el.requestUpdate === 'function') el.requestUpdate();
    });
}
class $dd5eecfdadcef4f0$export$b1a2fed5bb41b893 {
    constructor(host){
        this.host = host;
        this.host.addController(this);
    }
    hostConnected() {
        $dd5eecfdadcef4f0$var$connectedElements.add(this.host);
    }
    hostDisconnected() {
        $dd5eecfdadcef4f0$var$connectedElements.delete(this.host);
    }
    dir() {
        return `${this.host.dir || $dd5eecfdadcef4f0$var$documentDirection}`.toLowerCase();
    }
    lang() {
        return `${this.host.lang || $dd5eecfdadcef4f0$var$documentLanguage}`.toLowerCase();
    }
    getTranslationData(lang) {
        var _a, _b;
        const locale = new Intl.Locale(lang.replace(/_/g, '-'));
        const language = locale === null || locale === void 0 ? void 0 : locale.language.toLowerCase();
        const region = (_b = (_a = locale === null || locale === void 0 ? void 0 : locale.region) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
        const primary = $dd5eecfdadcef4f0$var$translations.get(`${language}-${region}`);
        const secondary = $dd5eecfdadcef4f0$var$translations.get(language);
        return {
            locale: locale,
            language: language,
            region: region,
            primary: primary,
            secondary: secondary
        };
    }
    exists(key, options) {
        var _a;
        const { primary: primary, secondary: secondary } = this.getTranslationData((_a = options.lang) !== null && _a !== void 0 ? _a : this.lang());
        options = Object.assign({
            includeFallback: false
        }, options);
        if (primary && primary[key] || secondary && secondary[key] || options.includeFallback && $dd5eecfdadcef4f0$var$fallback && $dd5eecfdadcef4f0$var$fallback[key]) return true;
        return false;
    }
    term(key, ...args) {
        const { primary: primary, secondary: secondary } = this.getTranslationData(this.lang());
        let term;
        if (primary && primary[key]) term = primary[key];
        else if (secondary && secondary[key]) term = secondary[key];
        else if ($dd5eecfdadcef4f0$var$fallback && $dd5eecfdadcef4f0$var$fallback[key]) term = $dd5eecfdadcef4f0$var$fallback[key];
        else {
            console.error(`No translation found for: ${String(key)}`);
            return String(key);
        }
        if (typeof term === 'function') return term(...args);
        return term;
    }
    date(dateToFormat, options) {
        dateToFormat = new Date(dateToFormat);
        return new Intl.DateTimeFormat(this.lang(), options).format(dateToFormat);
    }
    number(numberToFormat, options) {
        numberToFormat = Number(numberToFormat);
        return isNaN(numberToFormat) ? '' : new Intl.NumberFormat(this.lang(), options).format(numberToFormat);
    }
    relativeTime(value, unit, options) {
        return new Intl.RelativeTimeFormat(this.lang(), options).format(value, unit);
    }
}


var $d34df61deee42da8$var$translation = {
    $code: "en",
    $name: "English",
    $dir: "ltr",
    carousel: "Carousel",
    clearEntry: "Clear entry",
    close: "Close",
    copied: "Copied",
    copy: "Copy",
    currentValue: "Current value",
    error: "Error",
    goToSlide: (slide, count)=>`Go to slide ${slide} of ${count}`,
    hidePassword: "Hide password",
    loading: "Loading",
    nextSlide: "Next slide",
    numOptionsSelected: (num)=>{
        if (num === 0) return "No options selected";
        if (num === 1) return "1 option selected";
        return `${num} options selected`;
    },
    previousSlide: "Previous slide",
    progress: "Progress",
    remove: "Remove",
    resize: "Resize",
    scrollToEnd: "Scroll to end",
    scrollToStart: "Scroll to start",
    selectAColorFromTheScreen: "Select a color from the screen",
    showPassword: "Show password",
    slideNum: (slide)=>`Slide ${slide}`,
    toggleColorFormat: "Toggle color format"
};
(0, $dd5eecfdadcef4f0$export$2332cb3ce32cc839)($d34df61deee42da8$var$translation);
var $d34df61deee42da8$export$802b895dc4aecf21 = $d34df61deee42da8$var$translation;



var $358d84668aa2b71f$export$b1a2fed5bb41b893 = class extends (0, $dd5eecfdadcef4f0$export$b1a2fed5bb41b893) {
};
(0, $dd5eecfdadcef4f0$export$2332cb3ce32cc839)((0, $d34df61deee42da8$export$802b895dc4aecf21));





/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $079b6c18061715d9$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $079b6c18061715d9$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $079b6c18061715d9$export$803cd8101b6c182b = /*#__PURE__*/ $079b6c18061715d9$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $079b6c18061715d9$export$27b07d8a310ed8b5[0], side + "-" + $079b6c18061715d9$export$27b07d8a310ed8b5[1]), []);
const $079b6c18061715d9$export$96ec731ed4dcb222 = Math.min;
const $079b6c18061715d9$export$8960430cfd85939f = Math.max;
const $079b6c18061715d9$export$2077e0241d6afd3c = Math.round;
const $079b6c18061715d9$export$a3fe094919f356fd = Math.floor;
const $079b6c18061715d9$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $079b6c18061715d9$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $079b6c18061715d9$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $079b6c18061715d9$export$7d15b64cf5a3a4c4(start, value, end) {
    return $079b6c18061715d9$export$8960430cfd85939f(start, $079b6c18061715d9$export$96ec731ed4dcb222(value, end));
}
function $079b6c18061715d9$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $079b6c18061715d9$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $079b6c18061715d9$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $079b6c18061715d9$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $079b6c18061715d9$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $079b6c18061715d9$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($079b6c18061715d9$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $079b6c18061715d9$export$2b57e0052a6d6d4c(placement) {
    return $079b6c18061715d9$export$8a000a963141ac32($079b6c18061715d9$export$f28e8f882010718a(placement));
}
function $079b6c18061715d9$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $079b6c18061715d9$export$f0989780f32bfcda(placement);
    const alignmentAxis = $079b6c18061715d9$export$2b57e0052a6d6d4c(placement);
    const length = $079b6c18061715d9$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $079b6c18061715d9$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $079b6c18061715d9$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $079b6c18061715d9$export$496432a3699e50b1(placement) {
    const oppositePlacement = $079b6c18061715d9$export$9c5e28bad23365fa(placement);
    return [
        $079b6c18061715d9$export$2b182c584985588b(placement),
        oppositePlacement,
        $079b6c18061715d9$export$2b182c584985588b(oppositePlacement)
    ];
}
function $079b6c18061715d9$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$079b6c18061715d9$var$oppositeAlignmentMap[alignment]);
}
function $079b6c18061715d9$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $079b6c18061715d9$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $079b6c18061715d9$export$f0989780f32bfcda(placement);
    let list = $079b6c18061715d9$var$getSideList($079b6c18061715d9$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($079b6c18061715d9$export$2b182c584985588b));
    }
    return list;
}
function $079b6c18061715d9$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$079b6c18061715d9$var$oppositeSideMap[side]);
}
function $079b6c18061715d9$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $079b6c18061715d9$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $079b6c18061715d9$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $079b6c18061715d9$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $078981e2e5df035a$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $079b6c18061715d9$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $079b6c18061715d9$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $079b6c18061715d9$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $079b6c18061715d9$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $079b6c18061715d9$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $078981e2e5df035a$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $078981e2e5df035a$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $078981e2e5df035a$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $078981e2e5df035a$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $079b6c18061715d9$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $079b6c18061715d9$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $079b6c18061715d9$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $079b6c18061715d9$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $078981e2e5df035a$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $079b6c18061715d9$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $079b6c18061715d9$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $079b6c18061715d9$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $079b6c18061715d9$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $079b6c18061715d9$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $079b6c18061715d9$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $079b6c18061715d9$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $079b6c18061715d9$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $078981e2e5df035a$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $079b6c18061715d9$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $079b6c18061715d9$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $079b6c18061715d9$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $079b6c18061715d9$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $079b6c18061715d9$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $078981e2e5df035a$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $079b6c18061715d9$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $079b6c18061715d9$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $079b6c18061715d9$export$803cd8101b6c182b) ? $078981e2e5df035a$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $079b6c18061715d9$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $079b6c18061715d9$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $079b6c18061715d9$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $079b6c18061715d9$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $078981e2e5df035a$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $079b6c18061715d9$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $079b6c18061715d9$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $079b6c18061715d9$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $079b6c18061715d9$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $079b6c18061715d9$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $079b6c18061715d9$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $079b6c18061715d9$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $079b6c18061715d9$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $079b6c18061715d9$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $078981e2e5df035a$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $078981e2e5df035a$var$isAnySideFullyClipped(overflow) {
    return (0, $079b6c18061715d9$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $078981e2e5df035a$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $079b6c18061715d9$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $078981e2e5df035a$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $078981e2e5df035a$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $078981e2e5df035a$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $078981e2e5df035a$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $078981e2e5df035a$var$getBoundingRect(rects) {
    const minX = (0, $079b6c18061715d9$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $079b6c18061715d9$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $079b6c18061715d9$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $079b6c18061715d9$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $078981e2e5df035a$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $079b6c18061715d9$export$ee05aea0aeecbad4)($078981e2e5df035a$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $078981e2e5df035a$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $079b6c18061715d9$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $078981e2e5df035a$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $079b6c18061715d9$export$ee05aea0aeecbad4)($078981e2e5df035a$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $079b6c18061715d9$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $079b6c18061715d9$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $079b6c18061715d9$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $079b6c18061715d9$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $079b6c18061715d9$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $079b6c18061715d9$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $078981e2e5df035a$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $079b6c18061715d9$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $079b6c18061715d9$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $079b6c18061715d9$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $079b6c18061715d9$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $078981e2e5df035a$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $078981e2e5df035a$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $078981e2e5df035a$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $079b6c18061715d9$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $079b6c18061715d9$export$f28e8f882010718a)((0, $079b6c18061715d9$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $079b6c18061715d9$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $079b6c18061715d9$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $079b6c18061715d9$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $078981e2e5df035a$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $079b6c18061715d9$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $079b6c18061715d9$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $079b6c18061715d9$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $079b6c18061715d9$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $079b6c18061715d9$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $078981e2e5df035a$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $079b6c18061715d9$export$fef61f332f2c0afc)(options, state);
            const overflow = await $078981e2e5df035a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $079b6c18061715d9$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $079b6c18061715d9$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $079b6c18061715d9$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $079b6c18061715d9$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $079b6c18061715d9$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $079b6c18061715d9$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $079b6c18061715d9$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $079b6c18061715d9$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $079b6c18061715d9$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $079b6c18061715d9$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $079b6c18061715d9$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $1301171352b69415$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $1301171352b69415$export$651544f548703224(node) {
    if ($1301171352b69415$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $1301171352b69415$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $1301171352b69415$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($1301171352b69415$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $1301171352b69415$export$8ee0fc9ee280b4ee(value) {
    if (!$1301171352b69415$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).Node;
}
function $1301171352b69415$export$45a5e7f76e0caa8d(value) {
    if (!$1301171352b69415$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).Element;
}
function $1301171352b69415$export$1b3bfaa9684536aa(value) {
    if (!$1301171352b69415$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).HTMLElement;
}
function $1301171352b69415$export$af51f0f06c0f328a(value) {
    if (!$1301171352b69415$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $1301171352b69415$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $1301171352b69415$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $1301171352b69415$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $1301171352b69415$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($1301171352b69415$export$651544f548703224(element));
}
function $1301171352b69415$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $1301171352b69415$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $1301171352b69415$export$78551043582a6a98();
    const css = $1301171352b69415$export$45a5e7f76e0caa8d(elementOrCss) ? $1301171352b69415$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $1301171352b69415$export$940d8225183e1404(element) {
    let currentNode = $1301171352b69415$export$4e12058fc4d51d56(element);
    while($1301171352b69415$export$1b3bfaa9684536aa(currentNode) && !$1301171352b69415$export$d1162fb0b6d4cd51(currentNode)){
        if ($1301171352b69415$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($1301171352b69415$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $1301171352b69415$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $1301171352b69415$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $1301171352b69415$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($1301171352b69415$export$651544f548703224(node));
}
function $1301171352b69415$export$3735103072e4a80(element) {
    return $1301171352b69415$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $1301171352b69415$export$dc8fc79fa2800137(element) {
    if ($1301171352b69415$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $1301171352b69415$export$4e12058fc4d51d56(node) {
    if ($1301171352b69415$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $1301171352b69415$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $1301171352b69415$export$e495491855dc5418(node);
    return $1301171352b69415$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $1301171352b69415$export$7cd01a57c8ca906c(node) {
    const parentNode = $1301171352b69415$export$4e12058fc4d51d56(node);
    if ($1301171352b69415$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($1301171352b69415$export$1b3bfaa9684536aa(parentNode) && $1301171352b69415$export$989e911fa9af580a(parentNode)) return parentNode;
    return $1301171352b69415$export$7cd01a57c8ca906c(parentNode);
}
function $1301171352b69415$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $1301171352b69415$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $1301171352b69415$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $1301171352b69415$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $1301171352b69415$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $1301171352b69415$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $1301171352b69415$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $1301171352b69415$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $60923e9f3f841413$var$getCssDimensions(element) {
    const css = (0, $1301171352b69415$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $1301171352b69415$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $079b6c18061715d9$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $079b6c18061715d9$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $60923e9f3f841413$var$unwrapElement(element) {
    return !(0, $1301171352b69415$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $60923e9f3f841413$var$getScale(element) {
    const domElement = $60923e9f3f841413$var$unwrapElement(element);
    if (!(0, $1301171352b69415$export$1b3bfaa9684536aa)(domElement)) return (0, $079b6c18061715d9$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $60923e9f3f841413$var$getCssDimensions(domElement);
    let x = ($ ? (0, $079b6c18061715d9$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $079b6c18061715d9$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $60923e9f3f841413$var$noOffsets = /*#__PURE__*/ (0, $079b6c18061715d9$export$a397704b5e280835)(0);
function $60923e9f3f841413$var$getVisualOffsets(element) {
    const win = (0, $1301171352b69415$export$38b2d434cce3ea22)(element);
    if (!(0, $1301171352b69415$export$78551043582a6a98)() || !win.visualViewport) return $60923e9f3f841413$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $60923e9f3f841413$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $1301171352b69415$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $60923e9f3f841413$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $60923e9f3f841413$var$unwrapElement(element);
    let scale = (0, $079b6c18061715d9$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $1301171352b69415$export$45a5e7f76e0caa8d)(offsetParent)) scale = $60923e9f3f841413$var$getScale(offsetParent);
        } else scale = $60923e9f3f841413$var$getScale(element);
    }
    const visualOffsets = $60923e9f3f841413$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $60923e9f3f841413$var$getVisualOffsets(domElement) : (0, $079b6c18061715d9$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $1301171352b69415$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $1301171352b69415$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $1301171352b69415$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $1301171352b69415$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $60923e9f3f841413$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $1301171352b69415$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $1301171352b69415$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $1301171352b69415$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $079b6c18061715d9$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $60923e9f3f841413$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $1301171352b69415$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $60923e9f3f841413$var$getBoundingClientRect((0, $1301171352b69415$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $60923e9f3f841413$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $60923e9f3f841413$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $60923e9f3f841413$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $1301171352b69415$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $1301171352b69415$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $079b6c18061715d9$export$a397704b5e280835)(1);
    const offsets = (0, $079b6c18061715d9$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $1301171352b69415$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1301171352b69415$export$651544f548703224)(offsetParent) !== 'body' || (0, $1301171352b69415$export$989e911fa9af580a)(documentElement)) scroll = (0, $1301171352b69415$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $1301171352b69415$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $60923e9f3f841413$var$getBoundingClientRect(offsetParent);
            scale = $60923e9f3f841413$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $60923e9f3f841413$var$getHTMLOffset(documentElement, scroll, true) : (0, $079b6c18061715d9$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $60923e9f3f841413$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $60923e9f3f841413$var$getDocumentRect(element) {
    const html = (0, $1301171352b69415$export$e495491855dc5418)(element);
    const scroll = (0, $1301171352b69415$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $079b6c18061715d9$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $079b6c18061715d9$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $60923e9f3f841413$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $1301171352b69415$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $079b6c18061715d9$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $60923e9f3f841413$var$getViewportRect(element, strategy) {
    const win = (0, $1301171352b69415$export$38b2d434cce3ea22)(element);
    const html = (0, $1301171352b69415$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $1301171352b69415$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $60923e9f3f841413$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $60923e9f3f841413$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $1301171352b69415$export$1b3bfaa9684536aa)(element) ? $60923e9f3f841413$var$getScale(element) : (0, $079b6c18061715d9$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $60923e9f3f841413$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $60923e9f3f841413$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $60923e9f3f841413$var$getDocumentRect((0, $1301171352b69415$export$e495491855dc5418)(element));
    else if ((0, $1301171352b69415$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $60923e9f3f841413$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $60923e9f3f841413$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $079b6c18061715d9$export$ee05aea0aeecbad4)(rect);
}
function $60923e9f3f841413$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $1301171352b69415$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $1301171352b69415$export$45a5e7f76e0caa8d)(parentNode) || (0, $1301171352b69415$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $1301171352b69415$export$3735103072e4a80)(parentNode).position === 'fixed' || $60923e9f3f841413$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $60923e9f3f841413$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $1301171352b69415$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $1301171352b69415$export$45a5e7f76e0caa8d)(el) && (0, $1301171352b69415$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $1301171352b69415$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $1301171352b69415$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $1301171352b69415$export$45a5e7f76e0caa8d)(currentNode) && !(0, $1301171352b69415$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $1301171352b69415$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $1301171352b69415$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $1301171352b69415$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $60923e9f3f841413$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $1301171352b69415$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $60923e9f3f841413$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $1301171352b69415$export$89e651af02346cd4)(element) ? [] : $60923e9f3f841413$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $60923e9f3f841413$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $079b6c18061715d9$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $079b6c18061715d9$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $079b6c18061715d9$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $079b6c18061715d9$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $60923e9f3f841413$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $60923e9f3f841413$var$getDimensions(element) {
    const { width: width, height: height } = $60923e9f3f841413$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $60923e9f3f841413$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $1301171352b69415$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $1301171352b69415$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $60923e9f3f841413$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $079b6c18061715d9$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1301171352b69415$export$651544f548703224)(offsetParent) !== 'body' || (0, $1301171352b69415$export$989e911fa9af580a)(documentElement)) scroll = (0, $1301171352b69415$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $60923e9f3f841413$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $60923e9f3f841413$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $60923e9f3f841413$var$getHTMLOffset(documentElement, scroll) : (0, $079b6c18061715d9$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $60923e9f3f841413$var$isStaticPositioned(element) {
    return (0, $1301171352b69415$export$3735103072e4a80)(element).position === 'static';
}
function $60923e9f3f841413$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $1301171352b69415$export$1b3bfaa9684536aa)(element) || (0, $1301171352b69415$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $1301171352b69415$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $60923e9f3f841413$var$getOffsetParent(element, polyfill) {
    const win = (0, $1301171352b69415$export$38b2d434cce3ea22)(element);
    if ((0, $1301171352b69415$export$89e651af02346cd4)(element)) return win;
    if (!(0, $1301171352b69415$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $1301171352b69415$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $1301171352b69415$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $1301171352b69415$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$60923e9f3f841413$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $1301171352b69415$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $60923e9f3f841413$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $1301171352b69415$export$71535ffaa902797f)(offsetParent) && $60923e9f3f841413$var$isStaticPositioned(offsetParent))offsetParent = $60923e9f3f841413$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $1301171352b69415$export$d1162fb0b6d4cd51)(offsetParent) && $60923e9f3f841413$var$isStaticPositioned(offsetParent) && !(0, $1301171352b69415$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $1301171352b69415$export$940d8225183e1404)(element) || win;
}
const $60923e9f3f841413$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $60923e9f3f841413$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $60923e9f3f841413$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $60923e9f3f841413$var$isRTL(element) {
    return (0, $1301171352b69415$export$3735103072e4a80)(element).direction === 'rtl';
}
const $60923e9f3f841413$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $60923e9f3f841413$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $1301171352b69415$export$e495491855dc5418,
    getClippingRect: $60923e9f3f841413$var$getClippingRect,
    getOffsetParent: $60923e9f3f841413$var$getOffsetParent,
    getElementRects: $60923e9f3f841413$var$getElementRects,
    getClientRects: $60923e9f3f841413$var$getClientRects,
    getDimensions: $60923e9f3f841413$var$getDimensions,
    getScale: $60923e9f3f841413$var$getScale,
    isElement: $1301171352b69415$export$45a5e7f76e0caa8d,
    isRTL: $60923e9f3f841413$var$isRTL
};
function $60923e9f3f841413$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $60923e9f3f841413$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $1301171352b69415$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $079b6c18061715d9$export$a3fe094919f356fd)(top);
        const insetRight = (0, $079b6c18061715d9$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $079b6c18061715d9$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $079b6c18061715d9$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $079b6c18061715d9$export$8960430cfd85939f)(0, (0, $079b6c18061715d9$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$60923e9f3f841413$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $60923e9f3f841413$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $60923e9f3f841413$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $1301171352b69415$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $1301171352b69415$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $60923e9f3f841413$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $60923e9f3f841413$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $60923e9f3f841413$var$getBoundingClientRect(reference);
        if (prevRefRect && !$60923e9f3f841413$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $60923e9f3f841413$export$37b6bde19b108ecc = (0, $078981e2e5df035a$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $60923e9f3f841413$export$cc800923e997bb8 = (0, $078981e2e5df035a$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $60923e9f3f841413$export$91fb6ecbd551914 = (0, $078981e2e5df035a$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $60923e9f3f841413$export$fba63a578e423eb = (0, $078981e2e5df035a$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $60923e9f3f841413$export$8a83211c878a3f1f = (0, $078981e2e5df035a$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $60923e9f3f841413$export$346677f925de839c = (0, $078981e2e5df035a$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $60923e9f3f841413$export$fe8985bb6374093c = (0, $078981e2e5df035a$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $60923e9f3f841413$export$f2120bbfa5450bd2 = (0, $078981e2e5df035a$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $60923e9f3f841413$export$18c8ad048e32c7d5 = (0, $078981e2e5df035a$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $60923e9f3f841413$export$7bf07e38f3dc4b69 = (0, $078981e2e5df035a$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $60923e9f3f841413$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $60923e9f3f841413$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $078981e2e5df035a$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $bfc08ae7c1bf655d$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $bfc08ae7c1bf655d$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $bfc08ae7c1bf655d$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4930586706e2a706$export$56cc687933817664 = (0, $bfc08ae7c1bf655d$export$99b43ad1ed32e735)(class extends (0, $bfc08ae7c1bf655d$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $bfc08ae7c1bf655d$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $d2b76d366be0d5ac$export$9c068ae9cc5db4e8;
    }
});






function $895fd265437b2cc0$export$759f2a42fd33dfde(element) {
    return $895fd265437b2cc0$var$offsetParentPolyfill(element);
}
function $895fd265437b2cc0$export$9051df5ff5b6ece8(element) {
    return $895fd265437b2cc0$var$offsetTopLeftPolyfill(element, 'offsetTop');
}
function $895fd265437b2cc0$export$4ad6bc00a859a01c(element) {
    return $895fd265437b2cc0$var$offsetTopLeftPolyfill(element, 'offsetLeft');
}
function $895fd265437b2cc0$var$flatTreeParent(element) {
    if (element.assignedSlot) return element.assignedSlot;
    if (element.parentNode instanceof ShadowRoot) return element.parentNode.host;
    return element.parentNode;
}
function $895fd265437b2cc0$var$ancestorTreeScopes(element) {
    const scopes = new Set();
    let currentScope = element.getRootNode();
    while(currentScope){
        scopes.add(currentScope);
        currentScope = currentScope.parentNode ? currentScope.parentNode.getRootNode() : null;
    }
    return scopes;
}
function $895fd265437b2cc0$var$offsetParentPolyfill(element) {
    // Do an initial walk to check for display:none ancestors.
    for(let ancestor = element; ancestor; ancestor = $895fd265437b2cc0$var$flatTreeParent(ancestor)){
        if (!(ancestor instanceof Element)) continue;
        if (getComputedStyle(ancestor).display === 'none') return null;
    }
    for(let ancestor = $895fd265437b2cc0$var$flatTreeParent(element); ancestor; ancestor = $895fd265437b2cc0$var$flatTreeParent(ancestor)){
        if (!(ancestor instanceof Element)) continue;
        const style = getComputedStyle(ancestor);
        // Display:contents nodes aren't in the layout tree, so they should be skipped.
        if (style.display === 'contents') continue;
        if (style.position !== 'static' || (0, $1301171352b69415$export$d6c4e8150c35fed1)(style)) return ancestor;
        if (ancestor.tagName === 'BODY') return ancestor;
    }
    return null;
}
function $895fd265437b2cc0$var$offsetTopLeftPolyfill(element, offsetTopOrLeft) {
    let value = element[offsetTopOrLeft];
    let nextOffsetParent = $895fd265437b2cc0$var$offsetParentPolyfill(element);
    const scopes = $895fd265437b2cc0$var$ancestorTreeScopes(element);
    while(nextOffsetParent && !scopes.has(nextOffsetParent.getRootNode())){
        value -= nextOffsetParent[offsetTopOrLeft];
        nextOffsetParent = $895fd265437b2cc0$var$offsetParentPolyfill(nextOffsetParent);
    }
    return value;
}



function $2cc723b992cc8b8e$var$isVirtualElement(e) {
    return e !== null && typeof e === "object" && "getBoundingClientRect" in e && ("contextElement" in e ? e instanceof Element : true);
}
var $2cc723b992cc8b8e$export$6fe469f0a31d1d6e = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.active = false;
        this.placement = "top";
        this.strategy = "absolute";
        this.distance = 0;
        this.skidding = 0;
        this.arrow = false;
        this.arrowPlacement = "anchor";
        this.arrowPadding = 10;
        this.flip = false;
        this.flipFallbackPlacements = "";
        this.flipFallbackStrategy = "best-fit";
        this.flipPadding = 0;
        this.shift = false;
        this.shiftPadding = 0;
        this.autoSizePadding = 0;
        this.hoverBridge = false;
        this.updateHoverBridge = ()=>{
            if (this.hoverBridge && this.anchorEl) {
                const anchorRect = this.anchorEl.getBoundingClientRect();
                const popupRect = this.popup.getBoundingClientRect();
                const isVertical = this.placement.includes("top") || this.placement.includes("bottom");
                let topLeftX = 0;
                let topLeftY = 0;
                let topRightX = 0;
                let topRightY = 0;
                let bottomLeftX = 0;
                let bottomLeftY = 0;
                let bottomRightX = 0;
                let bottomRightY = 0;
                if (isVertical) {
                    if (anchorRect.top < popupRect.top) {
                        topLeftX = anchorRect.left;
                        topLeftY = anchorRect.bottom;
                        topRightX = anchorRect.right;
                        topRightY = anchorRect.bottom;
                        bottomLeftX = popupRect.left;
                        bottomLeftY = popupRect.top;
                        bottomRightX = popupRect.right;
                        bottomRightY = popupRect.top;
                    } else {
                        topLeftX = popupRect.left;
                        topLeftY = popupRect.bottom;
                        topRightX = popupRect.right;
                        topRightY = popupRect.bottom;
                        bottomLeftX = anchorRect.left;
                        bottomLeftY = anchorRect.top;
                        bottomRightX = anchorRect.right;
                        bottomRightY = anchorRect.top;
                    }
                } else if (anchorRect.left < popupRect.left) {
                    topLeftX = anchorRect.right;
                    topLeftY = anchorRect.top;
                    topRightX = popupRect.left;
                    topRightY = popupRect.top;
                    bottomLeftX = anchorRect.right;
                    bottomLeftY = anchorRect.bottom;
                    bottomRightX = popupRect.left;
                    bottomRightY = popupRect.bottom;
                } else {
                    topLeftX = popupRect.right;
                    topLeftY = popupRect.top;
                    topRightX = anchorRect.left;
                    topRightY = anchorRect.top;
                    bottomLeftX = popupRect.right;
                    bottomLeftY = popupRect.bottom;
                    bottomRightX = anchorRect.left;
                    bottomRightY = anchorRect.bottom;
                }
                this.style.setProperty("--hover-bridge-top-left-x", `${topLeftX}px`);
                this.style.setProperty("--hover-bridge-top-left-y", `${topLeftY}px`);
                this.style.setProperty("--hover-bridge-top-right-x", `${topRightX}px`);
                this.style.setProperty("--hover-bridge-top-right-y", `${topRightY}px`);
                this.style.setProperty("--hover-bridge-bottom-left-x", `${bottomLeftX}px`);
                this.style.setProperty("--hover-bridge-bottom-left-y", `${bottomLeftY}px`);
                this.style.setProperty("--hover-bridge-bottom-right-x", `${bottomRightX}px`);
                this.style.setProperty("--hover-bridge-bottom-right-y", `${bottomRightY}px`);
            }
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.updateComplete;
        this.start();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.stop();
    }
    async updated(changedProps) {
        super.updated(changedProps);
        if (changedProps.has("active")) {
            if (this.active) this.start();
            else this.stop();
        }
        if (changedProps.has("anchor")) this.handleAnchorChange();
        if (this.active) {
            await this.updateComplete;
            this.reposition();
        }
    }
    async handleAnchorChange() {
        await this.stop();
        if (this.anchor && typeof this.anchor === "string") {
            const root = this.getRootNode();
            this.anchorEl = root.getElementById(this.anchor);
        } else if (this.anchor instanceof Element || $2cc723b992cc8b8e$var$isVirtualElement(this.anchor)) this.anchorEl = this.anchor;
        else this.anchorEl = this.querySelector('[slot="anchor"]');
        if (this.anchorEl instanceof HTMLSlotElement) this.anchorEl = this.anchorEl.assignedElements({
            flatten: true
        })[0];
        if (this.anchorEl && this.active) this.start();
    }
    start() {
        if (!this.anchorEl || !this.active) return;
        this.cleanup = (0, $60923e9f3f841413$export$deee3a793edee05f)(this.anchorEl, this.popup, ()=>{
            this.reposition();
        });
    }
    async stop() {
        return new Promise((resolve)=>{
            if (this.cleanup) {
                this.cleanup();
                this.cleanup = void 0;
                this.removeAttribute("data-current-placement");
                this.style.removeProperty("--auto-size-available-width");
                this.style.removeProperty("--auto-size-available-height");
                requestAnimationFrame(()=>resolve());
            } else resolve();
        });
    }
    /** Forces the popup to recalculate and reposition itself. */ reposition() {
        if (!this.active || !this.anchorEl) return;
        const middleware = [
            // The offset middleware goes first
            (0, $60923e9f3f841413$export$cc800923e997bb8)({
                mainAxis: this.distance,
                crossAxis: this.skidding
            })
        ];
        if (this.sync) middleware.push((0, $60923e9f3f841413$export$346677f925de839c)({
            apply: ({ rects: rects })=>{
                const syncWidth = this.sync === "width" || this.sync === "both";
                const syncHeight = this.sync === "height" || this.sync === "both";
                this.popup.style.width = syncWidth ? `${rects.reference.width}px` : "";
                this.popup.style.height = syncHeight ? `${rects.reference.height}px` : "";
            }
        }));
        else {
            this.popup.style.width = "";
            this.popup.style.height = "";
        }
        if (this.flip) middleware.push((0, $60923e9f3f841413$export$8a83211c878a3f1f)({
            boundary: this.flipBoundary,
            // @ts-expect-error - We're converting a string attribute to an array here
            fallbackPlacements: this.flipFallbackPlacements,
            fallbackStrategy: this.flipFallbackStrategy === "best-fit" ? "bestFit" : "initialPlacement",
            padding: this.flipPadding
        }));
        if (this.shift) middleware.push((0, $60923e9f3f841413$export$fba63a578e423eb)({
            boundary: this.shiftBoundary,
            padding: this.shiftPadding
        }));
        if (this.autoSize) middleware.push((0, $60923e9f3f841413$export$346677f925de839c)({
            boundary: this.autoSizeBoundary,
            padding: this.autoSizePadding,
            apply: ({ availableWidth: availableWidth, availableHeight: availableHeight })=>{
                if (this.autoSize === "vertical" || this.autoSize === "both") this.style.setProperty("--auto-size-available-height", `${availableHeight}px`);
                else this.style.removeProperty("--auto-size-available-height");
                if (this.autoSize === "horizontal" || this.autoSize === "both") this.style.setProperty("--auto-size-available-width", `${availableWidth}px`);
                else this.style.removeProperty("--auto-size-available-width");
            }
        }));
        else {
            this.style.removeProperty("--auto-size-available-width");
            this.style.removeProperty("--auto-size-available-height");
        }
        if (this.arrow) middleware.push((0, $60923e9f3f841413$export$f2120bbfa5450bd2)({
            element: this.arrowEl,
            padding: this.arrowPadding
        }));
        const getOffsetParent = this.strategy === "absolute" ? (element)=>(0, $60923e9f3f841413$export$722a64dea1b767dc).getOffsetParent(element, (0, $895fd265437b2cc0$export$759f2a42fd33dfde)) : (0, $60923e9f3f841413$export$722a64dea1b767dc).getOffsetParent;
        (0, $60923e9f3f841413$export$48a53dcb22e581d0)(this.anchorEl, this.popup, {
            placement: this.placement,
            middleware: middleware,
            strategy: this.strategy,
            platform: (0, $1db749c92da399da$export$f4da8f157c1253f7)((0, $1db749c92da399da$export$7de063a7aa429f6c)({}, (0, $60923e9f3f841413$export$722a64dea1b767dc)), {
                getOffsetParent: getOffsetParent
            })
        }).then(({ x: x, y: y, middlewareData: middlewareData, placement: placement })=>{
            const isRtl = this.localize.dir() === "rtl";
            const staticSide = {
                top: "bottom",
                right: "left",
                bottom: "top",
                left: "right"
            }[placement.split("-")[0]];
            this.setAttribute("data-current-placement", placement);
            Object.assign(this.popup.style, {
                left: `${x}px`,
                top: `${y}px`
            });
            if (this.arrow) {
                const arrowX = middlewareData.arrow.x;
                const arrowY = middlewareData.arrow.y;
                let top = "";
                let right = "";
                let bottom = "";
                let left = "";
                if (this.arrowPlacement === "start") {
                    const value = typeof arrowX === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    top = typeof arrowY === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    right = isRtl ? value : "";
                    left = isRtl ? "" : value;
                } else if (this.arrowPlacement === "end") {
                    const value = typeof arrowX === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    right = isRtl ? "" : value;
                    left = isRtl ? value : "";
                    bottom = typeof arrowY === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                } else if (this.arrowPlacement === "center") {
                    left = typeof arrowX === "number" ? `calc(50% - var(--arrow-size-diagonal))` : "";
                    top = typeof arrowY === "number" ? `calc(50% - var(--arrow-size-diagonal))` : "";
                } else {
                    left = typeof arrowX === "number" ? `${arrowX}px` : "";
                    top = typeof arrowY === "number" ? `${arrowY}px` : "";
                }
                Object.assign(this.arrowEl.style, {
                    top: top,
                    right: right,
                    bottom: bottom,
                    left: left,
                    [staticSide]: "calc(var(--arrow-size-diagonal) * -1)"
                });
            }
        });
        requestAnimationFrame(()=>this.updateHoverBridge());
        this.emit("sl-reposition");
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <slot name="anchor" @slotchange=${this.handleAnchorChange}></slot>

      <span
        part="hover-bridge"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "popup-hover-bridge": true,
            "popup-hover-bridge--visible": this.hoverBridge && this.active
        })}
      ></span>

      <div
        part="popup"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            popup: true,
            "popup--active": this.active,
            "popup--fixed": this.strategy === "fixed",
            "popup--has-arrow": this.arrow
        })}
      >
        <slot></slot>
        ${this.arrow ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`<div part="arrow" class="popup__arrow" role="presentation"></div>` : ""}
      </div>
    `;
    }
};
$2cc723b992cc8b8e$export$6fe469f0a31d1d6e.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $5df229559c6425f5$export$51897b955cb6c203)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".popup")
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "popup", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".popup__arrow")
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "arrowEl", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "anchor", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "active", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "placement", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "strategy", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "distance", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "skidding", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "arrow", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "arrow-placement"
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "arrowPlacement", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "arrow-padding",
        type: Number
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "arrowPadding", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "flip", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "flip-fallback-placements",
        converter: {
            fromAttribute: (value)=>{
                return value.split(" ").map((p)=>p.trim()).filter((p)=>p !== "");
            },
            toAttribute: (value)=>{
                return value.join(" ");
            }
        }
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "flipFallbackPlacements", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "flip-fallback-strategy"
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "flipFallbackStrategy", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Object
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "flipBoundary", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "flip-padding",
        type: Number
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "flipPadding", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "shift", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Object
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "shiftBoundary", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "shift-padding",
        type: Number
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "shiftPadding", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "auto-size"
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "autoSize", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "sync", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Object
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "autoSizeBoundary", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "auto-size-padding",
        type: Number
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "autoSizePadding", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "hover-bridge",
        type: Boolean
    })
], $2cc723b992cc8b8e$export$6fe469f0a31d1d6e.prototype, "hoverBridge", 2);



// src/utilities/animation-registry.ts
var $a1414451ad8be7a7$var$defaultAnimationRegistry = /* @__PURE__ */ new Map();
var $a1414451ad8be7a7$var$customAnimationRegistry = /* @__PURE__ */ new WeakMap();
function $a1414451ad8be7a7$var$ensureAnimation(animation) {
    return animation != null ? animation : {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}
function $a1414451ad8be7a7$var$getLogicalAnimation(animation, dir) {
    if (dir.toLowerCase() === "rtl") return {
        keyframes: animation.rtlKeyframes || animation.keyframes,
        options: animation.options
    };
    return animation;
}
function $a1414451ad8be7a7$export$6e92ecdbe15fda0b(animationName, animation) {
    $a1414451ad8be7a7$var$defaultAnimationRegistry.set(animationName, $a1414451ad8be7a7$var$ensureAnimation(animation));
}
function $a1414451ad8be7a7$export$ea45326d94a48a31(el, animationName, animation) {
    $a1414451ad8be7a7$var$customAnimationRegistry.set(el, (0, $1db749c92da399da$export$f4da8f157c1253f7)((0, $1db749c92da399da$export$7de063a7aa429f6c)({}, $a1414451ad8be7a7$var$customAnimationRegistry.get(el)), {
        [animationName]: $a1414451ad8be7a7$var$ensureAnimation(animation)
    }));
}
function $a1414451ad8be7a7$export$b1aed5dec0c2d368(el, animationName, options) {
    const customAnimation = $a1414451ad8be7a7$var$customAnimationRegistry.get(el);
    if (customAnimation == null ? void 0 : customAnimation[animationName]) return $a1414451ad8be7a7$var$getLogicalAnimation(customAnimation[animationName], options.dir);
    const defaultAnimation = $a1414451ad8be7a7$var$defaultAnimationRegistry.get(animationName);
    if (defaultAnimation) return $a1414451ad8be7a7$var$getLogicalAnimation(defaultAnimation, options.dir);
    return {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}


// src/internal/event.ts
function $b5a9418bcbe3f786$export$6608ab6fe9313967(el, eventName) {
    return new Promise((resolve)=>{
        function done(event) {
            if (event.target === el) {
                el.removeEventListener(eventName, done);
                resolve();
            }
        }
        el.addEventListener(eventName, done);
    });
}



// src/internal/animate.ts
function $41facc830b5907b7$export$3b755839a54e1bb0(el, keyframes, options) {
    return new Promise((resolve)=>{
        if ((options == null ? void 0 : options.duration) === Infinity) throw new Error("Promise-based animations must be finite.");
        const animation = el.animate(keyframes, (0, $1db749c92da399da$export$f4da8f157c1253f7)((0, $1db749c92da399da$export$7de063a7aa429f6c)({}, options), {
            duration: $41facc830b5907b7$export$ff7706047246b98b() ? 0 : options.duration
        }));
        animation.addEventListener("cancel", resolve, {
            once: true
        });
        animation.addEventListener("finish", resolve, {
            once: true
        });
    });
}
function $41facc830b5907b7$export$ecae829bb3747ea6(delay) {
    delay = delay.toString().toLowerCase();
    if (delay.indexOf("ms") > -1) return parseFloat(delay);
    if (delay.indexOf("s") > -1) return parseFloat(delay) * 1e3;
    return parseFloat(delay);
}
function $41facc830b5907b7$export$ff7706047246b98b() {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    return query.matches;
}
function $41facc830b5907b7$export$ad12f740028ccbea(el) {
    return Promise.all(el.getAnimations().map((animation)=>{
        return new Promise((resolve)=>{
            animation.cancel();
            requestAnimationFrame(resolve);
        });
    }));
}
function $41facc830b5907b7$export$783a9b5bf095072a(keyframes, calculatedHeight) {
    return keyframes.map((keyframe)=>(0, $1db749c92da399da$export$f4da8f157c1253f7)((0, $1db749c92da399da$export$7de063a7aa429f6c)({}, keyframe), {
            height: keyframe.height === "auto" ? `${calculatedHeight}px` : keyframe.height
        }));
}




// src/internal/watch.ts
function $d094534805de59fa$export$3db5d71bdb2d5499(propertyName, options) {
    const resolvedOptions = (0, $1db749c92da399da$export$7de063a7aa429f6c)({
        waitUntilFirstUpdate: false
    }, options);
    return (proto, decoratedFnName)=>{
        const { update: update } = proto;
        const watchedProperties = Array.isArray(propertyName) ? propertyName : [
            propertyName
        ];
        proto.update = function(changedProps) {
            watchedProperties.forEach((property)=>{
                const key = property;
                if (changedProps.has(key)) {
                    const oldValue = changedProps.get(key);
                    const newValue = this[key];
                    if (oldValue !== newValue) {
                        if (!resolvedOptions.waitUntilFirstUpdate || this.hasUpdated) this[decoratedFnName](oldValue, newValue);
                    }
                }
            });
            update.call(this, changedProps);
        };
    };
}








var $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super();
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.content = "";
        this.placement = "top";
        this.disabled = false;
        this.distance = 8;
        this.open = false;
        this.skidding = 0;
        this.trigger = "hover focus";
        this.hoist = false;
        this.handleBlur = ()=>{
            if (this.hasTrigger("focus")) this.hide();
        };
        this.handleClick = ()=>{
            if (this.hasTrigger("click")) {
                if (this.open) this.hide();
                else this.show();
            }
        };
        this.handleFocus = ()=>{
            if (this.hasTrigger("focus")) this.show();
        };
        this.handleDocumentKeyDown = (event)=>{
            if (event.key === "Escape") {
                event.stopPropagation();
                this.hide();
            }
        };
        this.handleMouseOver = ()=>{
            if (this.hasTrigger("hover")) {
                const delay = (0, $41facc830b5907b7$export$ecae829bb3747ea6)(getComputedStyle(this).getPropertyValue("--show-delay"));
                clearTimeout(this.hoverTimeout);
                this.hoverTimeout = window.setTimeout(()=>this.show(), delay);
            }
        };
        this.handleMouseOut = ()=>{
            if (this.hasTrigger("hover")) {
                const delay = (0, $41facc830b5907b7$export$ecae829bb3747ea6)(getComputedStyle(this).getPropertyValue("--hide-delay"));
                clearTimeout(this.hoverTimeout);
                this.hoverTimeout = window.setTimeout(()=>this.hide(), delay);
            }
        };
        this.addEventListener("blur", this.handleBlur, true);
        this.addEventListener("focus", this.handleFocus, true);
        this.addEventListener("click", this.handleClick);
        this.addEventListener("mouseover", this.handleMouseOver);
        this.addEventListener("mouseout", this.handleMouseOut);
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.closeWatcher) == null || _a.destroy();
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
    }
    firstUpdated() {
        this.body.hidden = !this.open;
        if (this.open) {
            this.popup.active = true;
            this.popup.reposition();
        }
    }
    hasTrigger(triggerType) {
        const triggers = this.trigger.split(" ");
        return triggers.includes(triggerType);
    }
    async handleOpenChange() {
        var _a, _b;
        if (this.open) {
            if (this.disabled) return;
            this.emit("sl-show");
            if ("CloseWatcher" in window) {
                (_a = this.closeWatcher) == null || _a.destroy();
                this.closeWatcher = new CloseWatcher();
                this.closeWatcher.onclose = ()=>{
                    this.hide();
                };
            } else document.addEventListener("keydown", this.handleDocumentKeyDown);
            await (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.body);
            this.body.hidden = false;
            this.popup.active = true;
            const { keyframes: keyframes, options: options } = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "tooltip.show", {
                dir: this.localize.dir()
            });
            await (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.popup.popup, keyframes, options);
            this.popup.reposition();
            this.emit("sl-after-show");
        } else {
            this.emit("sl-hide");
            (_b = this.closeWatcher) == null || _b.destroy();
            document.removeEventListener("keydown", this.handleDocumentKeyDown);
            await (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.body);
            const { keyframes: keyframes, options: options } = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "tooltip.hide", {
                dir: this.localize.dir()
            });
            await (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.popup.popup, keyframes, options);
            this.popup.active = false;
            this.body.hidden = true;
            this.emit("sl-after-hide");
        }
    }
    async handleOptionsChange() {
        if (this.hasUpdated) {
            await this.updateComplete;
            this.popup.reposition();
        }
    }
    handleDisabledChange() {
        if (this.disabled && this.open) this.hide();
    }
    /** Shows the tooltip. */ async show() {
        if (this.open) return void 0;
        this.open = true;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the tooltip */ async hide() {
        if (!this.open) return void 0;
        this.open = false;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    //
    // NOTE: Tooltip is a bit unique in that we're using aria-live instead of aria-labelledby to trick screen readers into
    // announcing the content. It works really well, but it violates an accessibility rule. We're also adding the
    // aria-describedby attribute to a slot, which is required by <sl-popup> to correctly locate the first assigned
    // element, otherwise positioning is incorrect.
    //
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <sl-popup
        part="base"
        exportparts="
          popup:base__popup,
          arrow:base__arrow
        "
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            tooltip: true,
            "tooltip--open": this.open
        })}
        placement=${this.placement}
        distance=${this.distance}
        skidding=${this.skidding}
        strategy=${this.hoist ? "fixed" : "absolute"}
        flip
        shift
        arrow
        hover-bridge
      >
        ${""}
        <slot slot="anchor" aria-describedby="tooltip"></slot>

        ${""}
        <div part="body" id="tooltip" class="tooltip__body" role="tooltip" aria-live=${this.open ? "polite" : "off"}>
          <slot name="content">${this.content}</slot>
        </div>
      </sl-popup>
    `;
    }
};
$bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $5ca30cda42c71fd0$export$1c03bed7efcdda42)
];
$bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.dependencies = {
    "sl-popup": (0, $2cc723b992cc8b8e$export$6fe469f0a31d1d6e)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("slot:not([name])")
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "defaultSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".tooltip__body")
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "body", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("sl-popup")
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "popup", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "content", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "placement", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "distance", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "open", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "skidding", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "trigger", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "hoist", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "handleOpenChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)([
        "content",
        "distance",
        "hoist",
        "placement",
        "skidding"
    ])
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "handleOptionsChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled")
], $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c.prototype, "handleDisabledChange", 1);
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("tooltip.show", {
    keyframes: [
        {
            opacity: 0,
            scale: 0.8
        },
        {
            opacity: 1,
            scale: 1
        }
    ],
    options: {
        duration: 150,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("tooltip.hide", {
    keyframes: [
        {
            opacity: 1,
            scale: 1
        },
        {
            opacity: 0,
            scale: 0.8
        }
    ],
    options: {
        duration: 150,
        easing: "ease"
    }
});


// src/components/tooltip/tooltip.ts
var $ab0a1349026bfb67$export$a83543e92aefe46a = (0, $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c);
(0, $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c).define("sl-tooltip");


// src/components/tree/tree.styles.ts

var $4ca725363a5f7833$export$a93abbea96ceefc7 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    /*
     * These are actually used by tree item, but we define them here so they can more easily be set and all tree items
     * stay consistent.
     */
    --indent-guide-color: var(--sl-color-neutral-200);
    --indent-guide-offset: 0;
    --indent-guide-style: solid;
    --indent-guide-width: 0;
    --indent-size: var(--sl-spacing-large);

    display: block;

    /*
     * Tree item indentation uses the "em" unit to increment its width on each level, so setting the font size to zero
     * here removes the indentation for all the nodes on the first level.
     */
    font-size: 0;
  }
`;


// src/components/tree-item/tree-item.styles.ts

var $4677ffbf7210d80a$export$78c19d3af5c7c006 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: block;
    outline: 0;
    z-index: 0;
  }

  :host(:focus) {
    outline: none;
  }

  slot:not([name])::slotted(sl-icon) {
    margin-inline-end: var(--sl-spacing-x-small);
  }

  .tree-item {
    position: relative;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    color: var(--sl-color-neutral-700);
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
  }

  .tree-item__checkbox {
    pointer-events: none;
  }

  .tree-item__expand-button,
  .tree-item__checkbox,
  .tree-item__label {
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    line-height: var(--sl-line-height-dense);
    letter-spacing: var(--sl-letter-spacing-normal);
  }

  .tree-item__checkbox::part(base) {
    display: flex;
    align-items: center;
  }

  .tree-item__indentation {
    display: block;
    width: 1em;
    flex-shrink: 0;
  }

  .tree-item__expand-button {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: content-box;
    color: var(--sl-color-neutral-500);
    padding: var(--sl-spacing-x-small);
    width: 1rem;
    height: 1rem;
    flex-shrink: 0;
    cursor: pointer;
  }

  .tree-item__expand-button {
    transition: var(--sl-transition-medium) rotate ease;
  }

  .tree-item--expanded .tree-item__expand-button {
    rotate: 90deg;
  }

  .tree-item--expanded.tree-item--rtl .tree-item__expand-button {
    rotate: -90deg;
  }

  .tree-item--expanded slot[name='expand-icon'],
  .tree-item:not(.tree-item--expanded) slot[name='collapse-icon'] {
    display: none;
  }

  .tree-item:not(.tree-item--has-expand-button) .tree-item__expand-icon-slot {
    display: none;
  }

  .tree-item__expand-button--visible {
    cursor: pointer;
  }

  .tree-item__item {
    display: flex;
    align-items: center;
    border-inline-start: solid 3px transparent;
  }

  .tree-item--disabled .tree-item__item {
    opacity: 0.5;
    outline: none;
    cursor: not-allowed;
  }

  :host(:focus-visible) .tree-item__item {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
    z-index: 2;
  }

  :host(:not([aria-disabled='true'])) .tree-item--selected .tree-item__item {
    background-color: var(--sl-color-neutral-100);
    border-inline-start-color: var(--sl-color-primary-600);
  }

  :host(:not([aria-disabled='true'])) .tree-item__expand-button {
    color: var(--sl-color-neutral-600);
  }

  .tree-item__label {
    display: flex;
    align-items: center;
    transition: var(--sl-transition-fast) color;
  }

  .tree-item__children {
    display: block;
    font-size: calc(1em + var(--indent-size, var(--sl-spacing-medium)));
  }

  /* Indentation lines */
  .tree-item__children {
    position: relative;
  }

  .tree-item__children::before {
    content: '';
    position: absolute;
    top: var(--indent-guide-offset);
    bottom: var(--indent-guide-offset);
    left: calc(1em - (var(--indent-guide-width) / 2) - 1px);
    border-inline-end: var(--indent-guide-width) var(--indent-guide-style) var(--indent-guide-color);
    z-index: 1;
  }

  .tree-item--rtl .tree-item__children::before {
    left: auto;
    right: 1em;
  }

  @media (forced-colors: active) {
    :host(:not([aria-disabled='true'])) .tree-item--selected .tree-item__item {
      outline: dashed 1px SelectedItem;
    }
  }
`;


// src/components/checkbox/checkbox.styles.ts

var $cfbe054539e073a6$export$d780863e08270d06 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
  }

  .checkbox {
    position: relative;
    display: inline-flex;
    align-items: flex-start;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    color: var(--sl-input-label-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .checkbox--small {
    --toggle-size: var(--sl-toggle-size-small);
    font-size: var(--sl-input-font-size-small);
  }

  .checkbox--medium {
    --toggle-size: var(--sl-toggle-size-medium);
    font-size: var(--sl-input-font-size-medium);
  }

  .checkbox--large {
    --toggle-size: var(--sl-toggle-size-large);
    font-size: var(--sl-input-font-size-large);
  }

  .checkbox__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--toggle-size);
    height: var(--toggle-size);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
    border-radius: 2px;
    background-color: var(--sl-input-background-color);
    color: var(--sl-color-neutral-0);
    transition:
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) background-color,
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) box-shadow;
  }

  .checkbox__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  .checkbox__checked-icon,
  .checkbox__indeterminate-icon {
    display: inline-flex;
    width: var(--toggle-size);
    height: var(--toggle-size);
  }

  /* Hover */
  .checkbox:not(.checkbox--checked):not(.checkbox--disabled) .checkbox__control:hover {
    border-color: var(--sl-input-border-color-hover);
    background-color: var(--sl-input-background-color-hover);
  }

  /* Focus */
  .checkbox:not(.checkbox--checked):not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Checked/indeterminate */
  .checkbox--checked .checkbox__control,
  .checkbox--indeterminate .checkbox__control {
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
  }

  /* Checked/indeterminate + hover */
  .checkbox.checkbox--checked:not(.checkbox--disabled) .checkbox__control:hover,
  .checkbox.checkbox--indeterminate:not(.checkbox--disabled) .checkbox__control:hover {
    border-color: var(--sl-color-primary-500);
    background-color: var(--sl-color-primary-500);
  }

  /* Checked/indeterminate + focus */
  .checkbox.checkbox--checked:not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control,
  .checkbox.checkbox--indeterminate:not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Disabled */
  .checkbox--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .checkbox__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    line-height: var(--toggle-size);
    margin-inline-start: 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }

  :host([required]) .checkbox__label::after {
    content: var(--sl-input-required-content);
    color: var(--sl-input-required-content-color);
    margin-inline-start: var(--sl-input-required-content-offset);
  }
`;


// src/internal/default-value.ts

var $66d37a8d1e916a65$export$1a01ae0705bafd37 = (propertyName = "value")=>(proto, key)=>{
        const ctor = proto.constructor;
        const attributeChangedCallback = ctor.prototype.attributeChangedCallback;
        ctor.prototype.attributeChangedCallback = function(name, old, value) {
            var _a;
            const options = ctor.getPropertyOptions(propertyName);
            const attributeName = typeof options.attribute === "string" ? options.attribute : propertyName;
            if (name === attributeName) {
                const converter = options.converter || (0, $7ece5e2ccb4fd0d9$export$7312b35fbf521afb);
                const fromAttribute = typeof converter === "function" ? converter : (_a = converter == null ? void 0 : converter.fromAttribute) != null ? _a : (0, $7ece5e2ccb4fd0d9$export$7312b35fbf521afb).fromAttribute;
                const newValue = fromAttribute(value, options.type);
                if (this[propertyName] !== newValue) this[key] = newValue;
            }
            attributeChangedCallback.call(this, name, old, value);
        };
    };


// src/styles/form-control.styles.ts

var $5650ed14ec96c2a3$export$e7c8528c268605e9 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  .form-control .form-control__label {
    display: none;
  }

  .form-control .form-control__help-text {
    display: none;
  }

  /* Label */
  .form-control--has-label .form-control__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    margin-bottom: var(--sl-spacing-3x-small);
  }

  .form-control--has-label.form-control--small .form-control__label {
    font-size: var(--sl-input-label-font-size-small);
  }

  .form-control--has-label.form-control--medium .form-control__label {
    font-size: var(--sl-input-label-font-size-medium);
  }

  .form-control--has-label.form-control--large .form-control__label {
    font-size: var(--sl-input-label-font-size-large);
  }

  :host([required]) .form-control--has-label .form-control__label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
    color: var(--sl-input-required-content-color);
  }

  /* Help text */
  .form-control--has-help-text .form-control__help-text {
    display: block;
    color: var(--sl-input-help-text-color);
    margin-top: var(--sl-spacing-3x-small);
  }

  .form-control--has-help-text.form-control--small .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-small);
  }

  .form-control--has-help-text.form-control--medium .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-medium);
  }

  .form-control--has-help-text.form-control--large .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-large);
  }

  .form-control--has-help-text.form-control--radio-group .form-control__help-text {
    margin-top: var(--sl-spacing-2x-small);
  }
`;



// src/internal/slot.ts
var $2bcc883cf9fdb597$export$34f6a5ffaa663541 = class {
    constructor(host, ...slotNames){
        this.slotNames = [];
        this.handleSlotChange = (event)=>{
            const slot = event.target;
            if (this.slotNames.includes("[default]") && !slot.name || slot.name && this.slotNames.includes(slot.name)) this.host.requestUpdate();
        };
        (this.host = host).addController(this);
        this.slotNames = slotNames;
    }
    hasDefaultSlot() {
        return [
            ...this.host.childNodes
        ].some((node)=>{
            if (node.nodeType === node.TEXT_NODE && node.textContent.trim() !== "") return true;
            if (node.nodeType === node.ELEMENT_NODE) {
                const el = node;
                const tagName = el.tagName.toLowerCase();
                if (tagName === "sl-visually-hidden") return false;
                if (!el.hasAttribute("slot")) return true;
            }
            return false;
        });
    }
    hasNamedSlot(name) {
        return this.host.querySelector(`:scope > [slot="${name}"]`) !== null;
    }
    test(slotName) {
        return slotName === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(slotName);
    }
    hostConnected() {
        this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
    }
    hostDisconnected() {
        this.host.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
    }
};
function $2bcc883cf9fdb597$export$132e79e4118a78e0(slot) {
    if (!slot) return "";
    const nodes = slot.assignedNodes({
        flatten: true
    });
    let text = "";
    [
        ...nodes
    ].forEach((node)=>{
        if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
    });
    return text;
}


// src/utilities/base-path.ts
var $c11f15102200e75f$var$basePath = "";
function $c11f15102200e75f$export$784ad41d332938c6(path) {
    $c11f15102200e75f$var$basePath = path;
}
function $c11f15102200e75f$export$9099264ed9b1c55a(subpath = "") {
    if (!$c11f15102200e75f$var$basePath) {
        const scripts = [
            ...document.getElementsByTagName("script")
        ];
        const configScript = scripts.find((script)=>script.hasAttribute("data-shoelace"));
        if (configScript) $c11f15102200e75f$export$784ad41d332938c6(configScript.getAttribute("data-shoelace"));
        else {
            const fallbackScript = scripts.find((s)=>{
                return /shoelace(\.min)?\.js($|\?)/.test(s.src) || /shoelace-autoloader(\.min)?\.js($|\?)/.test(s.src);
            });
            let path = "";
            if (fallbackScript) path = fallbackScript.getAttribute("src");
            $c11f15102200e75f$export$784ad41d332938c6(path.split("/").slice(0, -1).join("/"));
        }
    }
    return $c11f15102200e75f$var$basePath.replace(/\/$/, "") + (subpath ? `/${subpath.replace(/^\//, "")}` : ``);
}


// src/components/icon/library.default.ts
var $d89d41df8f2059b2$var$library = {
    name: "default",
    resolver: (name)=>(0, $c11f15102200e75f$export$9099264ed9b1c55a)(`assets/icons/${name}.svg`)
};
var $d89d41df8f2059b2$export$761783e099ce3526 = $d89d41df8f2059b2$var$library;


// src/components/icon/library.system.ts
var $21f6d237bd9f9c14$var$icons = {
    caret: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  `,
    check: `
    <svg part="checked-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor">
          <g transform="translate(3.428571, 3.428571)">
            <path d="M0,5.71428571 L3.42857143,9.14285714"></path>
            <path d="M9.14285714,0 L3.42857143,9.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "chevron-down": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    "chevron-left": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
    </svg>
  `,
    "chevron-right": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    copy: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z"/>
    </svg>
  `,
    eye: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
    </svg>
  `,
    "eye-slash": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
    </svg>
  `,
    eyedropper: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eyedropper" viewBox="0 0 16 16">
      <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-2-2zM2 12.707l7-7L10.293 7l-7 7H2v-1.293z"></path>
    </svg>
  `,
    "grip-vertical": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grip-vertical" viewBox="0 0 16 16">
      <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
    </svg>
  `,
    indeterminate: `
    <svg part="indeterminate-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor" stroke-width="2">
          <g transform="translate(2.285714, 6.857143)">
            <path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "person-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
    </svg>
  `,
    "play-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-fill" viewBox="0 0 16 16">
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path>
    </svg>
  `,
    "pause-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"></path>
    </svg>
  `,
    radio: `
    <svg part="checked-icon" class="radio__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="currentColor">
          <circle cx="8" cy="8" r="3.42857143"></circle>
        </g>
      </g>
    </svg>
  `,
    "star-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
    </svg>
  `,
    "x-lg": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  `,
    "x-circle-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
    </svg>
  `
};
var $21f6d237bd9f9c14$var$systemLibrary = {
    name: "system",
    resolver: (name)=>{
        if (name in $21f6d237bd9f9c14$var$icons) return `data:image/svg+xml,${encodeURIComponent($21f6d237bd9f9c14$var$icons[name])}`;
        return "";
    }
};
var $21f6d237bd9f9c14$export$3139252f9828970f = $21f6d237bd9f9c14$var$systemLibrary;


// src/components/icon/library.ts
var $1ffe53bea9aafe53$var$registry = [
    (0, $d89d41df8f2059b2$export$761783e099ce3526),
    (0, $21f6d237bd9f9c14$export$3139252f9828970f)
];
var $1ffe53bea9aafe53$var$watchedIcons = [];
function $1ffe53bea9aafe53$export$da63f424a7208010(icon) {
    $1ffe53bea9aafe53$var$watchedIcons.push(icon);
}
function $1ffe53bea9aafe53$export$9e46b25ecab82f0b(icon) {
    $1ffe53bea9aafe53$var$watchedIcons = $1ffe53bea9aafe53$var$watchedIcons.filter((el)=>el !== icon);
}
function $1ffe53bea9aafe53$export$be026de5111f322b(name) {
    return $1ffe53bea9aafe53$var$registry.find((lib)=>lib.name === name);
}
function $1ffe53bea9aafe53$export$a482e04ad60c9b11(name, options) {
    $1ffe53bea9aafe53$export$8faa256e94012669(name);
    $1ffe53bea9aafe53$var$registry.push({
        name: name,
        resolver: options.resolver,
        mutator: options.mutator,
        spriteSheet: options.spriteSheet
    });
    $1ffe53bea9aafe53$var$watchedIcons.forEach((icon)=>{
        if (icon.library === name) icon.setIcon();
    });
}
function $1ffe53bea9aafe53$export$8faa256e94012669(name) {
    $1ffe53bea9aafe53$var$registry = $1ffe53bea9aafe53$var$registry.filter((lib)=>lib.name !== name);
}


// src/components/icon/icon.styles.ts

var $4b5df94592095d3c$export$f0b0874d64866432 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    box-sizing: content-box !important;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;








/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $03728c7decb8678c$var$t } = (0, $d2b76d366be0d5ac$export$8613d1ca9052b22e), $03728c7decb8678c$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $03728c7decb8678c$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $03728c7decb8678c$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $03728c7decb8678c$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $03728c7decb8678c$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $03728c7decb8678c$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $03728c7decb8678c$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $03728c7decb8678c$var$s = ()=>document.createComment(""), $03728c7decb8678c$export$291b2338ad9b0b30 = (o, i, n)=>{
    const e = o._$AA.parentNode, l = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = e.insertBefore($03728c7decb8678c$var$s(), l), c = e.insertBefore($03728c7decb8678c$var$s(), l);
        n = new $03728c7decb8678c$var$t(i, c, o, o.options);
    } else {
        const t = n._$AB.nextSibling, i = n._$AM, c = i !== o;
        if (c) {
            let t;
            n._$AQ?.(o), n._$AM = o, void 0 !== n._$AP && (t = o._$AU) !== i._$AU && n._$AP(t);
        }
        if (t !== l || c) {
            let o = n._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                e.insertBefore(o, l), o = t;
            }
        }
    }
    return n;
}, $03728c7decb8678c$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $03728c7decb8678c$var$u = {}, $03728c7decb8678c$export$ea70d9dd5965b1c8 = (o, t = $03728c7decb8678c$var$u)=>o._$AH = t, $03728c7decb8678c$export$59e9bce518cde500 = (o)=>o._$AH, $03728c7decb8678c$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $03728c7decb8678c$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};





var $23ae34b1bd251d7a$var$CACHEABLE_ERROR = Symbol();
var $23ae34b1bd251d7a$var$RETRYABLE_ERROR = Symbol();
var $23ae34b1bd251d7a$var$parser;
var $23ae34b1bd251d7a$var$iconCache = /* @__PURE__ */ new Map();
var $23ae34b1bd251d7a$export$ef62a86bf282441 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.initialRender = false;
        this.svg = null;
        this.label = "";
        this.library = "default";
    }
    /** Given a URL, this function returns the resulting SVG element or an appropriate error symbol. */ async resolveIcon(url, library) {
        var _a;
        let fileData;
        if (library == null ? void 0 : library.spriteSheet) {
            this.svg = (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`<svg part="svg">
        <use part="use" href="${url}"></use>
      </svg>`;
            return this.svg;
        }
        try {
            fileData = await fetch(url, {
                mode: "cors"
            });
            if (!fileData.ok) return fileData.status === 410 ? $23ae34b1bd251d7a$var$CACHEABLE_ERROR : $23ae34b1bd251d7a$var$RETRYABLE_ERROR;
        } catch (e) {
            return $23ae34b1bd251d7a$var$RETRYABLE_ERROR;
        }
        try {
            const div = document.createElement("div");
            div.innerHTML = await fileData.text();
            const svg = div.firstElementChild;
            if (((_a = svg == null ? void 0 : svg.tagName) == null ? void 0 : _a.toLowerCase()) !== "svg") return $23ae34b1bd251d7a$var$CACHEABLE_ERROR;
            if (!$23ae34b1bd251d7a$var$parser) $23ae34b1bd251d7a$var$parser = new DOMParser();
            const doc = $23ae34b1bd251d7a$var$parser.parseFromString(svg.outerHTML, "text/html");
            const svgEl = doc.body.querySelector("svg");
            if (!svgEl) return $23ae34b1bd251d7a$var$CACHEABLE_ERROR;
            svgEl.part.add("svg");
            return document.adoptNode(svgEl);
        } catch (e) {
            return $23ae34b1bd251d7a$var$CACHEABLE_ERROR;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $1ffe53bea9aafe53$export$da63f424a7208010)(this);
    }
    firstUpdated() {
        this.initialRender = true;
        this.setIcon();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $1ffe53bea9aafe53$export$9e46b25ecab82f0b)(this);
    }
    getIconSource() {
        const library = (0, $1ffe53bea9aafe53$export$be026de5111f322b)(this.library);
        if (this.name && library) return {
            url: library.resolver(this.name),
            fromLibrary: true
        };
        return {
            url: this.src,
            fromLibrary: false
        };
    }
    handleLabelChange() {
        const hasLabel = typeof this.label === "string" && this.label.length > 0;
        if (hasLabel) {
            this.setAttribute("role", "img");
            this.setAttribute("aria-label", this.label);
            this.removeAttribute("aria-hidden");
        } else {
            this.removeAttribute("role");
            this.removeAttribute("aria-label");
            this.setAttribute("aria-hidden", "true");
        }
    }
    async setIcon() {
        var _a;
        const { url: url, fromLibrary: fromLibrary } = this.getIconSource();
        const library = fromLibrary ? (0, $1ffe53bea9aafe53$export$be026de5111f322b)(this.library) : void 0;
        if (!url) {
            this.svg = null;
            return;
        }
        let iconResolver = $23ae34b1bd251d7a$var$iconCache.get(url);
        if (!iconResolver) {
            iconResolver = this.resolveIcon(url, library);
            $23ae34b1bd251d7a$var$iconCache.set(url, iconResolver);
        }
        if (!this.initialRender) return;
        const svg = await iconResolver;
        if (svg === $23ae34b1bd251d7a$var$RETRYABLE_ERROR) $23ae34b1bd251d7a$var$iconCache.delete(url);
        if (url !== this.getIconSource().url) return;
        if ((0, $03728c7decb8678c$export$6b6d145ec2a44ca9)(svg)) {
            this.svg = svg;
            if (library) {
                await this.updateComplete;
                const shadowSVG = this.shadowRoot.querySelector("[part='svg']");
                if (typeof library.mutator === "function" && shadowSVG) library.mutator(shadowSVG);
            }
            return;
        }
        switch(svg){
            case $23ae34b1bd251d7a$var$RETRYABLE_ERROR:
            case $23ae34b1bd251d7a$var$CACHEABLE_ERROR:
                this.svg = null;
                this.emit("sl-error");
                break;
            default:
                this.svg = svg.cloneNode(true);
                (_a = library == null ? void 0 : library.mutator) == null || _a.call(library, this.svg);
                this.emit("sl-load");
        }
    }
    render() {
        return this.svg;
    }
};
$23ae34b1bd251d7a$export$ef62a86bf282441.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $4b5df94592095d3c$export$f0b0874d64866432)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $23ae34b1bd251d7a$export$ef62a86bf282441.prototype, "svg", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $23ae34b1bd251d7a$export$ef62a86bf282441.prototype, "name", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $23ae34b1bd251d7a$export$ef62a86bf282441.prototype, "src", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $23ae34b1bd251d7a$export$ef62a86bf282441.prototype, "label", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $23ae34b1bd251d7a$export$ef62a86bf282441.prototype, "library", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("label")
], $23ae34b1bd251d7a$export$ef62a86bf282441.prototype, "handleLabelChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)([
        "name",
        "src",
        "library"
    ])
], $23ae34b1bd251d7a$export$ef62a86bf282441.prototype, "setIcon", 1);









/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ad7ec410a329c066$export$f68dd208b5df064d = (o)=>o ?? (0, $d2b76d366be0d5ac$export$45b790e32b2810ee);







/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9cd948e30340d8e4$export$28cf49ad70f82d12 = (0, $bfc08ae7c1bf655d$export$99b43ad1ed32e735)(class extends (0, $bfc08ae7c1bf655d$export$befdefbdce210f91) {
    constructor(r){
        if (super(r), r.type !== (0, $bfc08ae7c1bf655d$export$9ba3b3f20a85bfa).PROPERTY && r.type !== (0, $bfc08ae7c1bf655d$export$9ba3b3f20a85bfa).ATTRIBUTE && r.type !== (0, $bfc08ae7c1bf655d$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
        if (!(0, $03728c7decb8678c$export$7f431ad0fff82fd9)(r)) throw Error("`live` bindings can only contain a single expression");
    }
    render(r) {
        return r;
    }
    update(i, [t]) {
        if (t === (0, $d2b76d366be0d5ac$export$9c068ae9cc5db4e8) || t === (0, $d2b76d366be0d5ac$export$45b790e32b2810ee)) return t;
        const o = i.element, l = i.name;
        if (i.type === (0, $bfc08ae7c1bf655d$export$9ba3b3f20a85bfa).PROPERTY) {
            if (t === o[l]) return 0, $d2b76d366be0d5ac$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $bfc08ae7c1bf655d$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) {
            if (!!t === o.hasAttribute(l)) return 0, $d2b76d366be0d5ac$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $bfc08ae7c1bf655d$export$9ba3b3f20a85bfa).ATTRIBUTE && o.getAttribute(l) === t + "") return 0, $d2b76d366be0d5ac$export$9c068ae9cc5db4e8;
        return (0, $03728c7decb8678c$export$ea70d9dd5965b1c8)(i), t;
    }
});





var $61e71b4204f92964$export$7f3be6aba957b8f2 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $6aba7ae81ba45aa2$export$43da334182d34ab4)(this, {
            value: (control)=>control.checked ? control.value || "on" : void 0,
            defaultValue: (control)=>control.defaultChecked,
            setValue: (control, checked)=>control.checked = checked
        });
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "help-text");
        this.hasFocus = false;
        this.title = "";
        this.name = "";
        this.size = "medium";
        this.disabled = false;
        this.checked = false;
        this.indeterminate = false;
        this.defaultChecked = false;
        this.form = "";
        this.required = false;
        this.helpText = "";
    }
    /** Gets the validity state object */ get validity() {
        return this.input.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.input.validationMessage;
    }
    firstUpdated() {
        this.formControlController.updateValidity();
    }
    handleClick() {
        this.checked = !this.checked;
        this.indeterminate = false;
        this.emit("sl-change");
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleInput() {
        this.emit("sl-input");
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleDisabledChange() {
        this.formControlController.setValidity(this.disabled);
    }
    handleStateChange() {
        this.input.checked = this.checked;
        this.input.indeterminate = this.indeterminate;
        this.formControlController.updateValidity();
    }
    /** Simulates a click on the checkbox. */ click() {
        this.input.click();
    }
    /** Sets focus on the checkbox. */ focus(options) {
        this.input.focus(options);
    }
    /** Removes focus from the checkbox. */ blur() {
        this.input.blur();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.input.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        return this.input.reportValidity();
    }
    /**
   * Sets a custom validation message. The value provided will be shown to the user when the form is submitted. To clear
   * the custom validation message, call this method with an empty string.
   */ setCustomValidity(message) {
        this.input.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    render() {
        const hasHelpTextSlot = this.hasSlotController.test("help-text");
        const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "form-control": true,
            "form-control--small": this.size === "small",
            "form-control--medium": this.size === "medium",
            "form-control--large": this.size === "large",
            "form-control--has-help-text": hasHelpText
        })}
      >
        <label
          part="base"
          class=${(0, $4930586706e2a706$export$56cc687933817664)({
            checkbox: true,
            "checkbox--checked": this.checked,
            "checkbox--disabled": this.disabled,
            "checkbox--focused": this.hasFocus,
            "checkbox--indeterminate": this.indeterminate,
            "checkbox--small": this.size === "small",
            "checkbox--medium": this.size === "medium",
            "checkbox--large": this.size === "large"
        })}
        >
          <input
            class="checkbox__input"
            type="checkbox"
            title=${this.title}
            name=${this.name}
            value=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.value)}
            .indeterminate=${(0, $9cd948e30340d8e4$export$28cf49ad70f82d12)(this.indeterminate)}
            .checked=${(0, $9cd948e30340d8e4$export$28cf49ad70f82d12)(this.checked)}
            .disabled=${this.disabled}
            .required=${this.required}
            aria-checked=${this.checked ? "true" : "false"}
            aria-describedby="help-text"
            @click=${this.handleClick}
            @input=${this.handleInput}
            @invalid=${this.handleInvalid}
            @blur=${this.handleBlur}
            @focus=${this.handleFocus}
          />

          <span
            part="control${this.checked ? " control--checked" : ""}${this.indeterminate ? " control--indeterminate" : ""}"
            class="checkbox__control"
          >
            ${this.checked ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                  <sl-icon part="checked-icon" class="checkbox__checked-icon" library="system" name="check"></sl-icon>
                ` : ""}
            ${!this.checked && this.indeterminate ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                  <sl-icon
                    part="indeterminate-icon"
                    class="checkbox__indeterminate-icon"
                    library="system"
                    name="indeterminate"
                  ></sl-icon>
                ` : ""}
          </span>

          <div part="label" class="checkbox__label">
            <slot></slot>
          </div>
        </label>

        <div
          aria-hidden=${hasHelpText ? "false" : "true"}
          class="form-control__help-text"
          id="help-text"
          part="form-control-help-text"
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
    }
};
$61e71b4204f92964$export$7f3be6aba957b8f2.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $5650ed14ec96c2a3$export$e7c8528c268605e9),
    (0, $cfbe054539e073a6$export$d780863e08270d06)
];
$61e71b4204f92964$export$7f3be6aba957b8f2.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)('input[type="checkbox"]')
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "input", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "hasFocus", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "title", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "name", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "size", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "checked", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "indeterminate", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $66d37a8d1e916a65$export$1a01ae0705bafd37)("checked")
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "defaultChecked", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "form", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "required", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "help-text"
    })
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "helpText", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "handleDisabledChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)([
        "checked",
        "indeterminate"
    ], {
        waitUntilFirstUpdate: true
    })
], $61e71b4204f92964$export$7f3be6aba957b8f2.prototype, "handleStateChange", 1);


// src/components/spinner/spinner.styles.ts

var $902e267f826627b1$export$6a9ed4d91972acb3 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --track-width: 2px;
    --track-color: rgb(128 128 128 / 25%);
    --indicator-color: var(--sl-color-primary-600);
    --speed: 2s;

    display: inline-flex;
    width: 1em;
    height: 1em;
    flex: none;
  }

  .spinner {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
  }

  .spinner__track,
  .spinner__indicator {
    fill: none;
    stroke-width: var(--track-width);
    r: calc(0.5em - var(--track-width) / 2);
    cx: 0.5em;
    cy: 0.5em;
    transform-origin: 50% 50%;
  }

  .spinner__track {
    stroke: var(--track-color);
    transform-origin: 0% 0%;
  }

  .spinner__indicator {
    stroke: var(--indicator-color);
    stroke-linecap: round;
    stroke-dasharray: 150% 75%;
    animation: spin var(--speed) linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
      stroke-dasharray: 0.05em, 3em;
    }

    50% {
      transform: rotate(450deg);
      stroke-dasharray: 1.375em, 1.375em;
    }

    100% {
      transform: rotate(1080deg);
      stroke-dasharray: 0.05em, 3em;
    }
  }
`;






var $b879e4c4815031db$export$4e45ce56e46d2b00 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <svg part="base" class="spinner" role="progressbar" aria-label=${this.localize.term("loading")}>
        <circle class="spinner__track"></circle>
        <circle class="spinner__indicator"></circle>
      </svg>
    `;
    }
};
$b879e4c4815031db$export$4e45ce56e46d2b00.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $902e267f826627b1$export$6a9ed4d91972acb3)
];














/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d1860b3f126bee34$export$a55877ca9db47377(n, r, t) {
    return n ? r(n) : t?.(n);
}




var $bf4f5a018c1ea1ce$var$_SlTreeItem = class _SlTreeItem extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.indeterminate = false;
        this.isLeaf = false;
        this.loading = false;
        this.selectable = false;
        this.expanded = false;
        this.selected = false;
        this.disabled = false;
        this.lazy = false;
    }
    static isTreeItem(node) {
        return node instanceof Element && node.getAttribute("role") === "treeitem";
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "treeitem");
        this.setAttribute("tabindex", "-1");
        if (this.isNestedItem()) this.slot = "children";
    }
    firstUpdated() {
        this.childrenContainer.hidden = !this.expanded;
        this.childrenContainer.style.height = this.expanded ? "auto" : "0";
        this.isLeaf = !this.lazy && this.getChildrenItems().length === 0;
        this.handleExpandedChange();
    }
    async animateCollapse() {
        this.emit("sl-collapse");
        await (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.childrenContainer);
        const { keyframes: keyframes, options: options } = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "tree-item.collapse", {
            dir: this.localize.dir()
        });
        await (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.childrenContainer, (0, $41facc830b5907b7$export$783a9b5bf095072a)(keyframes, this.childrenContainer.scrollHeight), options);
        this.childrenContainer.hidden = true;
        this.emit("sl-after-collapse");
    }
    // Checks whether the item is nested into an item
    isNestedItem() {
        const parent = this.parentElement;
        return !!parent && _SlTreeItem.isTreeItem(parent);
    }
    handleChildrenSlotChange() {
        this.loading = false;
        this.isLeaf = !this.lazy && this.getChildrenItems().length === 0;
    }
    willUpdate(changedProperties) {
        if (changedProperties.has("selected") && !changedProperties.has("indeterminate")) this.indeterminate = false;
    }
    async animateExpand() {
        this.emit("sl-expand");
        await (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.childrenContainer);
        this.childrenContainer.hidden = false;
        const { keyframes: keyframes, options: options } = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "tree-item.expand", {
            dir: this.localize.dir()
        });
        await (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.childrenContainer, (0, $41facc830b5907b7$export$783a9b5bf095072a)(keyframes, this.childrenContainer.scrollHeight), options);
        this.childrenContainer.style.height = "auto";
        this.emit("sl-after-expand");
    }
    handleLoadingChange() {
        this.setAttribute("aria-busy", this.loading ? "true" : "false");
        if (!this.loading) this.animateExpand();
    }
    handleDisabledChange() {
        this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
    }
    handleSelectedChange() {
        this.setAttribute("aria-selected", this.selected ? "true" : "false");
    }
    handleExpandedChange() {
        if (!this.isLeaf) this.setAttribute("aria-expanded", this.expanded ? "true" : "false");
        else this.removeAttribute("aria-expanded");
    }
    handleExpandAnimation() {
        if (this.expanded) {
            if (this.lazy) {
                this.loading = true;
                this.emit("sl-lazy-load");
            } else this.animateExpand();
        } else this.animateCollapse();
    }
    handleLazyChange() {
        this.emit("sl-lazy-change");
    }
    /** Gets all the nested tree items in this node. */ getChildrenItems({ includeDisabled: includeDisabled = true } = {}) {
        return this.childrenSlot ? [
            ...this.childrenSlot.assignedElements({
                flatten: true
            })
        ].filter((item)=>_SlTreeItem.isTreeItem(item) && (includeDisabled || !item.disabled)) : [];
    }
    render() {
        const isRtl = this.localize.dir() === "rtl";
        const showExpandButton = !this.loading && (!this.isLeaf || this.lazy);
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class="${(0, $4930586706e2a706$export$56cc687933817664)({
            "tree-item": true,
            "tree-item--expanded": this.expanded,
            "tree-item--selected": this.selected,
            "tree-item--disabled": this.disabled,
            "tree-item--leaf": this.isLeaf,
            "tree-item--has-expand-button": showExpandButton,
            "tree-item--rtl": this.localize.dir() === "rtl"
        })}"
      >
        <div
          class="tree-item__item"
          part="
            item
            ${this.disabled ? "item--disabled" : ""}
            ${this.expanded ? "item--expanded" : ""}
            ${this.indeterminate ? "item--indeterminate" : ""}
            ${this.selected ? "item--selected" : ""}
          "
        >
          <div class="tree-item__indentation" part="indentation"></div>

          <div
            part="expand-button"
            class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "tree-item__expand-button": true,
            "tree-item__expand-button--visible": showExpandButton
        })}
            aria-hidden="true"
          >
            ${(0, $d1860b3f126bee34$export$a55877ca9db47377)(this.loading, ()=>(0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)` <sl-spinner part="spinner" exportparts="base:spinner__base"></sl-spinner> `)}
            <slot class="tree-item__expand-icon-slot" name="expand-icon">
              <sl-icon library="system" name=${isRtl ? "chevron-left" : "chevron-right"}></sl-icon>
            </slot>
            <slot class="tree-item__expand-icon-slot" name="collapse-icon">
              <sl-icon library="system" name=${isRtl ? "chevron-left" : "chevron-right"}></sl-icon>
            </slot>
          </div>

          ${(0, $d1860b3f126bee34$export$a55877ca9db47377)(this.selectable, ()=>(0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <sl-checkbox
                part="checkbox"
                exportparts="
                    base:checkbox__base,
                    control:checkbox__control,
                    control--checked:checkbox__control--checked,
                    control--indeterminate:checkbox__control--indeterminate,
                    checked-icon:checkbox__checked-icon,
                    indeterminate-icon:checkbox__indeterminate-icon,
                    label:checkbox__label
                  "
                class="tree-item__checkbox"
                ?disabled="${this.disabled}"
                ?checked="${(0, $9cd948e30340d8e4$export$28cf49ad70f82d12)(this.selected)}"
                ?indeterminate="${this.indeterminate}"
                tabindex="-1"
              ></sl-checkbox>
            `)}

          <slot class="tree-item__label" part="label"></slot>
        </div>

        <div class="tree-item__children" part="children" role="group">
          <slot name="children" @slotchange="${this.handleChildrenSlotChange}"></slot>
        </div>
      </div>
    `;
    }
};
$bf4f5a018c1ea1ce$var$_SlTreeItem.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $4677ffbf7210d80a$export$78c19d3af5c7c006)
];
$bf4f5a018c1ea1ce$var$_SlTreeItem.dependencies = {
    "sl-checkbox": (0, $61e71b4204f92964$export$7f3be6aba957b8f2),
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441),
    "sl-spinner": (0, $b879e4c4815031db$export$4e45ce56e46d2b00)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "indeterminate", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "isLeaf", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "loading", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "selectable", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "expanded", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "selected", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "lazy", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("slot:not([name])")
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "defaultSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("slot[name=children]")
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "childrenSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".tree-item__item")
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "itemElement", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".tree-item__children")
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "childrenContainer", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".tree-item__expand-button slot")
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "expandButtonSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("loading", {
        waitUntilFirstUpdate: true
    })
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "handleLoadingChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled")
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "handleDisabledChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("selected")
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "handleSelectedChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("expanded", {
        waitUntilFirstUpdate: true
    })
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "handleExpandedChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("expanded", {
        waitUntilFirstUpdate: true
    })
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "handleExpandAnimation", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("lazy", {
        waitUntilFirstUpdate: true
    })
], $bf4f5a018c1ea1ce$var$_SlTreeItem.prototype, "handleLazyChange", 1);
var $bf4f5a018c1ea1ce$export$f8e1c3557b36f22f = $bf4f5a018c1ea1ce$var$_SlTreeItem;
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("tree-item.expand", {
    keyframes: [
        {
            height: "0",
            opacity: "0",
            overflow: "hidden"
        },
        {
            height: "auto",
            opacity: "1",
            overflow: "hidden"
        }
    ],
    options: {
        duration: 250,
        easing: "cubic-bezier(0.4, 0.0, 0.2, 1)"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("tree-item.collapse", {
    keyframes: [
        {
            height: "auto",
            opacity: "1",
            overflow: "hidden"
        },
        {
            height: "0",
            opacity: "0",
            overflow: "hidden"
        }
    ],
    options: {
        duration: 200,
        easing: "cubic-bezier(0.4, 0.0, 0.2, 1)"
    }
});


// src/internal/math.ts
function $271caa7bc1493813$export$7d15b64cf5a3a4c4(value, min, max) {
    const noNegativeZero = (n)=>Object.is(n, -0) ? 0 : n;
    if (value < min) return noNegativeZero(min);
    if (value > max) return noNegativeZero(max);
    return noNegativeZero(value);
}









function $085815f2a9105616$var$syncCheckboxes(changedTreeItem, initialSync = false) {
    function syncParentItem(treeItem) {
        const children = treeItem.getChildrenItems({
            includeDisabled: false
        });
        if (children.length) {
            const allChecked = children.every((item)=>item.selected);
            const allUnchecked = children.every((item)=>!item.selected && !item.indeterminate);
            treeItem.selected = allChecked;
            treeItem.indeterminate = !allChecked && !allUnchecked;
        }
    }
    function syncAncestors(treeItem) {
        const parentItem = treeItem.parentElement;
        if ((0, $bf4f5a018c1ea1ce$export$f8e1c3557b36f22f).isTreeItem(parentItem)) {
            syncParentItem(parentItem);
            syncAncestors(parentItem);
        }
    }
    function syncDescendants(treeItem) {
        for (const childItem of treeItem.getChildrenItems()){
            childItem.selected = initialSync ? treeItem.selected || childItem.selected : !childItem.disabled && treeItem.selected;
            syncDescendants(childItem);
        }
        if (initialSync) syncParentItem(treeItem);
    }
    syncDescendants(changedTreeItem);
    syncAncestors(changedTreeItem);
}
var $085815f2a9105616$export$482be9e3bd80dc5a = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super();
        this.selection = "single";
        this.clickTarget = null;
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        // Initializes new items by setting the `selectable` property and the expanded/collapsed icons if any
        this.initTreeItem = (item)=>{
            item.selectable = this.selection === "multiple";
            [
                "expand",
                "collapse"
            ].filter((status)=>!!this.querySelector(`[slot="${status}-icon"]`)).forEach((status)=>{
                const existingIcon = item.querySelector(`[slot="${status}-icon"]`);
                const expandButtonIcon = this.getExpandButtonIcon(status);
                if (!expandButtonIcon) return;
                if (existingIcon === null) item.append(expandButtonIcon);
                else if (existingIcon.hasAttribute("data-default")) existingIcon.replaceWith(expandButtonIcon);
            });
        };
        this.handleTreeChanged = (mutations)=>{
            for (const mutation of mutations){
                const addedNodes = [
                    ...mutation.addedNodes
                ].filter((0, $bf4f5a018c1ea1ce$export$f8e1c3557b36f22f).isTreeItem);
                const removedNodes = [
                    ...mutation.removedNodes
                ].filter((0, $bf4f5a018c1ea1ce$export$f8e1c3557b36f22f).isTreeItem);
                addedNodes.forEach(this.initTreeItem);
                if (this.lastFocusedItem && removedNodes.includes(this.lastFocusedItem)) this.lastFocusedItem = null;
            }
        };
        this.handleFocusOut = (event)=>{
            const relatedTarget = event.relatedTarget;
            if (!relatedTarget || !this.contains(relatedTarget)) this.tabIndex = 0;
        };
        this.handleFocusIn = (event)=>{
            const target = event.target;
            if (event.target === this) this.focusItem(this.lastFocusedItem || this.getAllTreeItems()[0]);
            if ((0, $bf4f5a018c1ea1ce$export$f8e1c3557b36f22f).isTreeItem(target) && !target.disabled) {
                if (this.lastFocusedItem) this.lastFocusedItem.tabIndex = -1;
                this.lastFocusedItem = target;
                this.tabIndex = -1;
                target.tabIndex = 0;
            }
        };
        this.addEventListener("focusin", this.handleFocusIn);
        this.addEventListener("focusout", this.handleFocusOut);
        this.addEventListener("sl-lazy-change", this.handleSlotChange);
    }
    async connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "tree");
        this.setAttribute("tabindex", "0");
        await this.updateComplete;
        this.mutationObserver = new MutationObserver(this.handleTreeChanged);
        this.mutationObserver.observe(this, {
            childList: true,
            subtree: true
        });
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.mutationObserver) == null || _a.disconnect();
    }
    // Generates a clone of the expand icon element to use for each tree item
    getExpandButtonIcon(status) {
        const slot = status === "expand" ? this.expandedIconSlot : this.collapsedIconSlot;
        const icon = slot.assignedElements({
            flatten: true
        })[0];
        if (icon) {
            const clone = icon.cloneNode(true);
            [
                clone,
                ...clone.querySelectorAll("[id]")
            ].forEach((el)=>el.removeAttribute("id"));
            clone.setAttribute("data-default", "");
            clone.slot = `${status}-icon`;
            return clone;
        }
        return null;
    }
    selectItem(selectedItem) {
        const previousSelection = [
            ...this.selectedItems
        ];
        if (this.selection === "multiple") {
            selectedItem.selected = !selectedItem.selected;
            if (selectedItem.lazy) selectedItem.expanded = true;
            $085815f2a9105616$var$syncCheckboxes(selectedItem);
        } else if (this.selection === "single" || selectedItem.isLeaf) {
            const items = this.getAllTreeItems();
            for (const item of items)item.selected = item === selectedItem;
        } else if (this.selection === "leaf") selectedItem.expanded = !selectedItem.expanded;
        const nextSelection = this.selectedItems;
        if (previousSelection.length !== nextSelection.length || nextSelection.some((item)=>!previousSelection.includes(item))) Promise.all(nextSelection.map((el)=>el.updateComplete)).then(()=>{
            this.emit("sl-selection-change", {
                detail: {
                    selection: nextSelection
                }
            });
        });
    }
    getAllTreeItems() {
        return [
            ...this.querySelectorAll("sl-tree-item")
        ];
    }
    focusItem(item) {
        item == null || item.focus();
    }
    handleKeyDown(event) {
        if (![
            "ArrowDown",
            "ArrowUp",
            "ArrowRight",
            "ArrowLeft",
            "Home",
            "End",
            "Enter",
            " "
        ].includes(event.key)) return;
        if (event.composedPath().some((el)=>{
            var _a;
            return [
                "input",
                "textarea"
            ].includes((_a = el == null ? void 0 : el.tagName) == null ? void 0 : _a.toLowerCase());
        })) return;
        const items = this.getFocusableItems();
        const isLtr = this.localize.dir() === "ltr";
        const isRtl = this.localize.dir() === "rtl";
        if (items.length > 0) {
            event.preventDefault();
            const activeItemIndex = items.findIndex((item)=>item.matches(":focus"));
            const activeItem = items[activeItemIndex];
            const focusItemAt = (index)=>{
                const item = items[(0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(index, 0, items.length - 1)];
                this.focusItem(item);
            };
            const toggleExpand = (expanded)=>{
                activeItem.expanded = expanded;
            };
            if (event.key === "ArrowDown") focusItemAt(activeItemIndex + 1);
            else if (event.key === "ArrowUp") focusItemAt(activeItemIndex - 1);
            else if (isLtr && event.key === "ArrowRight" || isRtl && event.key === "ArrowLeft") {
                if (!activeItem || activeItem.disabled || activeItem.expanded || activeItem.isLeaf && !activeItem.lazy) focusItemAt(activeItemIndex + 1);
                else toggleExpand(true);
            } else if (isLtr && event.key === "ArrowLeft" || isRtl && event.key === "ArrowRight") {
                if (!activeItem || activeItem.disabled || activeItem.isLeaf || !activeItem.expanded) focusItemAt(activeItemIndex - 1);
                else toggleExpand(false);
            } else if (event.key === "Home") focusItemAt(0);
            else if (event.key === "End") focusItemAt(items.length - 1);
            else if (event.key === "Enter" || event.key === " ") {
                if (!activeItem.disabled) this.selectItem(activeItem);
            }
        }
    }
    handleClick(event) {
        const target = event.target;
        const treeItem = target.closest("sl-tree-item");
        const isExpandButton = event.composedPath().some((el)=>{
            var _a;
            return (_a = el == null ? void 0 : el.classList) == null ? void 0 : _a.contains("tree-item__expand-button");
        });
        if (!treeItem || treeItem.disabled || target !== this.clickTarget) return;
        if (isExpandButton) treeItem.expanded = !treeItem.expanded;
        else this.selectItem(treeItem);
    }
    handleMouseDown(event) {
        this.clickTarget = event.target;
    }
    handleSlotChange() {
        const items = this.getAllTreeItems();
        items.forEach(this.initTreeItem);
    }
    async handleSelectionChange() {
        const isSelectionMultiple = this.selection === "multiple";
        const items = this.getAllTreeItems();
        this.setAttribute("aria-multiselectable", isSelectionMultiple ? "true" : "false");
        for (const item of items)item.selectable = isSelectionMultiple;
        if (isSelectionMultiple) {
            await this.updateComplete;
            [
                ...this.querySelectorAll(":scope > sl-tree-item")
            ].forEach((treeItem)=>$085815f2a9105616$var$syncCheckboxes(treeItem, true));
        }
    }
    /** @internal Returns the list of tree items that are selected in the tree. */ get selectedItems() {
        const items = this.getAllTreeItems();
        const isSelected = (item)=>item.selected;
        return items.filter(isSelected);
    }
    /** @internal Gets focusable tree items in the tree. */ getFocusableItems() {
        const items = this.getAllTreeItems();
        const collapsedItems = /* @__PURE__ */ new Set();
        return items.filter((item)=>{
            var _a;
            if (item.disabled) return false;
            const parent = (_a = item.parentElement) == null ? void 0 : _a.closest("[role=treeitem]");
            if (parent && (!parent.expanded || parent.loading || collapsedItems.has(parent))) collapsedItems.add(item);
            return !collapsedItems.has(item);
        });
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class="tree"
        @click=${this.handleClick}
        @keydown=${this.handleKeyDown}
        @mousedown=${this.handleMouseDown}
      >
        <slot @slotchange=${this.handleSlotChange}></slot>
        <span hidden aria-hidden="true"><slot name="expand-icon"></slot></span>
        <span hidden aria-hidden="true"><slot name="collapse-icon"></slot></span>
      </div>
    `;
    }
};
$085815f2a9105616$export$482be9e3bd80dc5a.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $4ca725363a5f7833$export$a93abbea96ceefc7)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("slot:not([name])")
], $085815f2a9105616$export$482be9e3bd80dc5a.prototype, "defaultSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("slot[name=expand-icon]")
], $085815f2a9105616$export$482be9e3bd80dc5a.prototype, "expandedIconSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("slot[name=collapse-icon]")
], $085815f2a9105616$export$482be9e3bd80dc5a.prototype, "collapsedIconSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $085815f2a9105616$export$482be9e3bd80dc5a.prototype, "selection", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("selection")
], $085815f2a9105616$export$482be9e3bd80dc5a.prototype, "handleSelectionChange", 1);


// src/components/tree/tree.ts
var $6d47e964b9d9d455$export$e9c75888e8978999 = (0, $085815f2a9105616$export$482be9e3bd80dc5a);
(0, $085815f2a9105616$export$482be9e3bd80dc5a).define("sl-tree");





// src/components/tree-item/tree-item.ts
var $534ed8c075ef128c$export$8431c05ea62c86e0 = (0, $bf4f5a018c1ea1ce$export$f8e1c3557b36f22f);
(0, $bf4f5a018c1ea1ce$export$f8e1c3557b36f22f).define("sl-tree-item");




// src/components/tab-panel/tab-panel.styles.ts

var $f387e60f524253a7$export$a6647793eeb8a0d5 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --padding: 0;

    display: none;
  }

  :host([active]) {
    display: block;
  }

  .tab-panel {
    display: block;
    padding: var(--padding);
  }
`;









var $0c48e59faca1f1a5$var$id = 0;
var $0c48e59faca1f1a5$export$bd2fdd7b93e88330 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.attrId = ++$0c48e59faca1f1a5$var$id;
        this.componentId = `sl-tab-panel-${this.attrId}`;
        this.name = "";
        this.active = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.id = this.id.length > 0 ? this.id : this.componentId;
        this.setAttribute("role", "tabpanel");
    }
    handleActiveChange() {
        this.setAttribute("aria-hidden", this.active ? "false" : "true");
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <slot
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "tab-panel": true,
            "tab-panel--active": this.active
        })}
      ></slot>
    `;
    }
};
$0c48e59faca1f1a5$export$bd2fdd7b93e88330.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $f387e60f524253a7$export$a6647793eeb8a0d5)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $0c48e59faca1f1a5$export$bd2fdd7b93e88330.prototype, "name", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $0c48e59faca1f1a5$export$bd2fdd7b93e88330.prototype, "active", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("active")
], $0c48e59faca1f1a5$export$bd2fdd7b93e88330.prototype, "handleActiveChange", 1);


// src/components/tab-panel/tab-panel.ts
var $a75763d19e117dba$export$1e1524a300d1fd38 = (0, $0c48e59faca1f1a5$export$bd2fdd7b93e88330);
(0, $0c48e59faca1f1a5$export$bd2fdd7b93e88330).define("sl-tab-panel");


// src/components/tag/tag.styles.ts

var $9ac978f6c10aaf2b$export$1e578902aad5c585 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
  }

  .tag {
    display: flex;
    align-items: center;
    border: solid 1px;
    line-height: 1;
    white-space: nowrap;
    user-select: none;
    -webkit-user-select: none;
  }

  .tag__remove::part(base) {
    color: inherit;
    padding: 0;
  }

  /*
   * Variant modifiers
   */

  .tag--primary {
    background-color: var(--sl-color-primary-50);
    border-color: var(--sl-color-primary-200);
    color: var(--sl-color-primary-800);
  }

  .tag--primary:active > sl-icon-button {
    color: var(--sl-color-primary-600);
  }

  .tag--success {
    background-color: var(--sl-color-success-50);
    border-color: var(--sl-color-success-200);
    color: var(--sl-color-success-800);
  }

  .tag--success:active > sl-icon-button {
    color: var(--sl-color-success-600);
  }

  .tag--neutral {
    background-color: var(--sl-color-neutral-50);
    border-color: var(--sl-color-neutral-200);
    color: var(--sl-color-neutral-800);
  }

  .tag--neutral:active > sl-icon-button {
    color: var(--sl-color-neutral-600);
  }

  .tag--warning {
    background-color: var(--sl-color-warning-50);
    border-color: var(--sl-color-warning-200);
    color: var(--sl-color-warning-800);
  }

  .tag--warning:active > sl-icon-button {
    color: var(--sl-color-warning-600);
  }

  .tag--danger {
    background-color: var(--sl-color-danger-50);
    border-color: var(--sl-color-danger-200);
    color: var(--sl-color-danger-800);
  }

  .tag--danger:active > sl-icon-button {
    color: var(--sl-color-danger-600);
  }

  /*
   * Size modifiers
   */

  .tag--small {
    font-size: var(--sl-button-font-size-small);
    height: calc(var(--sl-input-height-small) * 0.8);
    line-height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-small);
    padding: 0 var(--sl-spacing-x-small);
  }

  .tag--medium {
    font-size: var(--sl-button-font-size-medium);
    height: calc(var(--sl-input-height-medium) * 0.8);
    line-height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-medium);
    padding: 0 var(--sl-spacing-small);
  }

  .tag--large {
    font-size: var(--sl-button-font-size-large);
    height: calc(var(--sl-input-height-large) * 0.8);
    line-height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-large);
    padding: 0 var(--sl-spacing-medium);
  }

  .tag__remove {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  /*
   * Pill modifier
   */

  .tag--pill {
    border-radius: var(--sl-border-radius-pill);
  }
`;


// src/components/icon-button/icon-button.styles.ts

var $b89aa07ae19f9383$export$e7174f10cedebf49 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
    color: var(--sl-color-neutral-600);
  }

  .icon-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    font-size: inherit;
    color: inherit;
    padding: var(--sl-spacing-x-small);
    cursor: pointer;
    transition: var(--sl-transition-x-fast) color;
    -webkit-appearance: none;
  }

  .icon-button:hover:not(.icon-button--disabled),
  .icon-button:focus-visible:not(.icon-button--disabled) {
    color: var(--sl-color-primary-600);
  }

  .icon-button:active:not(.icon-button--disabled) {
    color: var(--sl-color-primary-700);
  }

  .icon-button:focus {
    outline: none;
  }

  .icon-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .icon-button__icon {
    pointer-events: none;
  }
`;








/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d4df2e78fcd0ab0d$var$a = Symbol.for(""), $d4df2e78fcd0ab0d$var$o = (t)=>{
    if (t?.r === $d4df2e78fcd0ab0d$var$a) return t?._$litStatic$;
}, $d4df2e78fcd0ab0d$export$4b395f4b8c9b548e = (t)=>({
        _$litStatic$: t,
        r: $d4df2e78fcd0ab0d$var$a
    }), $d4df2e78fcd0ab0d$export$c8ec6e1ec9fefcb0 = (t, ...r)=>({
        _$litStatic$: r.reduce((r, e, a)=>r + ((t)=>{
                if (void 0 !== t._$litStatic$) return t._$litStatic$;
                throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t}. Use 'unsafeStatic' to pass non-literal values, but\n            take care to ensure page security.`);
            })(e) + t[a + 1], t[0]),
        r: $d4df2e78fcd0ab0d$var$a
    }), $d4df2e78fcd0ab0d$var$l = new Map, $d4df2e78fcd0ab0d$export$878791788f808fc0 = (t)=>(r, ...e)=>{
        const a = e.length;
        let s, i;
        const n = [], u = [];
        let c, $ = 0, f = !1;
        for(; $ < a;){
            for(c = r[$]; $ < a && void 0 !== (i = e[$], s = $d4df2e78fcd0ab0d$var$o(i));)c += s + r[++$], f = !0;
            $ !== a && u.push(i), n.push(c), $++;
        }
        if ($ === a && n.push(r[a]), f) {
            const t = n.join("$$lit$$");
            void 0 === (r = $d4df2e78fcd0ab0d$var$l.get(t)) && (n.raw = n, $d4df2e78fcd0ab0d$var$l.set(t, r = n)), e = u;
        }
        return t(r, ...e);
    }, $d4df2e78fcd0ab0d$export$c0bb0b647f701bb5 = $d4df2e78fcd0ab0d$export$878791788f808fc0((0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)), $d4df2e78fcd0ab0d$export$7ed1367e7fa1ad68 = $d4df2e78fcd0ab0d$export$878791788f808fc0((0, $d2b76d366be0d5ac$export$7ed1367e7fa1ad68)), $d4df2e78fcd0ab0d$export$47d5b44d225be5b4 = $d4df2e78fcd0ab0d$export$878791788f808fc0((0, $d2b76d366be0d5ac$export$47d5b44d225be5b4));






var $271ffb72cdd1ec73$export$302c9d29315a4659 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasFocus = false;
        this.label = "";
        this.disabled = false;
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    /** Simulates a click on the icon button. */ click() {
        this.button.click();
    }
    /** Sets focus on the icon button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the icon button. */ blur() {
        this.button.blur();
    }
    render() {
        const isLink = this.href ? true : false;
        const tag = isLink ? (0, $d4df2e78fcd0ab0d$export$c8ec6e1ec9fefcb0)`a` : (0, $d4df2e78fcd0ab0d$export$c8ec6e1ec9fefcb0)`button`;
        return (0, $d4df2e78fcd0ab0d$export$c0bb0b647f701bb5)`
      <${tag}
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "icon-button": true,
            "icon-button--disabled": !isLink && this.disabled,
            "icon-button--focused": this.hasFocus
        })}
        ?disabled=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? void 0 : this.disabled)}
        type=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        href=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? this.href : void 0)}
        target=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? this.target : void 0)}
        download=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? this.download : void 0)}
        rel=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink && this.target ? "noreferrer noopener" : void 0)}
        role=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-label="${this.label}"
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
      >
        <sl-icon
          class="icon-button__icon"
          name=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.name)}
          library=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.library)}
          src=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.src)}
          aria-hidden="true"
        ></sl-icon>
      </${tag}>
    `;
    }
};
$271ffb72cdd1ec73$export$302c9d29315a4659.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $b89aa07ae19f9383$export$e7174f10cedebf49)
];
$271ffb72cdd1ec73$export$302c9d29315a4659.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".icon-button")
], $271ffb72cdd1ec73$export$302c9d29315a4659.prototype, "button", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $271ffb72cdd1ec73$export$302c9d29315a4659.prototype, "hasFocus", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $271ffb72cdd1ec73$export$302c9d29315a4659.prototype, "name", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $271ffb72cdd1ec73$export$302c9d29315a4659.prototype, "library", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $271ffb72cdd1ec73$export$302c9d29315a4659.prototype, "src", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $271ffb72cdd1ec73$export$302c9d29315a4659.prototype, "href", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $271ffb72cdd1ec73$export$302c9d29315a4659.prototype, "target", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $271ffb72cdd1ec73$export$302c9d29315a4659.prototype, "download", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $271ffb72cdd1ec73$export$302c9d29315a4659.prototype, "label", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $271ffb72cdd1ec73$export$302c9d29315a4659.prototype, "disabled", 2);









var $c09f028efc3817b7$export$357f67db97e5a412 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.variant = "neutral";
        this.size = "medium";
        this.pill = false;
        this.removable = false;
    }
    handleRemoveClick() {
        this.emit("sl-remove");
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <span
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            tag: true,
            // Types
            "tag--primary": this.variant === "primary",
            "tag--success": this.variant === "success",
            "tag--neutral": this.variant === "neutral",
            "tag--warning": this.variant === "warning",
            "tag--danger": this.variant === "danger",
            "tag--text": this.variant === "text",
            // Sizes
            "tag--small": this.size === "small",
            "tag--medium": this.size === "medium",
            "tag--large": this.size === "large",
            // Modifiers
            "tag--pill": this.pill,
            "tag--removable": this.removable
        })}
      >
        <slot part="content" class="tag__content"></slot>

        ${this.removable ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <sl-icon-button
                part="remove-button"
                exportparts="base:remove-button__base"
                name="x-lg"
                library="system"
                label=${this.localize.term("remove")}
                class="tag__remove"
                @click=${this.handleRemoveClick}
                tabindex="-1"
              ></sl-icon-button>
            ` : ""}
      </span>
    `;
    }
};
$c09f028efc3817b7$export$357f67db97e5a412.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $9ac978f6c10aaf2b$export$1e578902aad5c585)
];
$c09f028efc3817b7$export$357f67db97e5a412.dependencies = {
    "sl-icon-button": (0, $271ffb72cdd1ec73$export$302c9d29315a4659)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $c09f028efc3817b7$export$357f67db97e5a412.prototype, "variant", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $c09f028efc3817b7$export$357f67db97e5a412.prototype, "size", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c09f028efc3817b7$export$357f67db97e5a412.prototype, "pill", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $c09f028efc3817b7$export$357f67db97e5a412.prototype, "removable", 2);


// src/components/tag/tag.ts
var $1751423e13e70c79$export$f1565324f06d8675 = (0, $c09f028efc3817b7$export$357f67db97e5a412);
(0, $c09f028efc3817b7$export$357f67db97e5a412).define("sl-tag");


// src/components/textarea/textarea.styles.ts

var $3c9f39af55d9a9cb$export$884e7f8ce9b7053a = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  .textarea {
    display: grid;
    align-items: center;
    position: relative;
    width: 100%;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    line-height: var(--sl-line-height-normal);
    letter-spacing: var(--sl-input-letter-spacing);
    vertical-align: middle;
    transition:
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) border,
      var(--sl-transition-fast) box-shadow,
      var(--sl-transition-fast) background-color;
    cursor: text;
  }

  /* Standard textareas */
  .textarea--standard {
    background-color: var(--sl-input-background-color);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
  }

  .textarea--standard:hover:not(.textarea--disabled) {
    background-color: var(--sl-input-background-color-hover);
    border-color: var(--sl-input-border-color-hover);
  }
  .textarea--standard:hover:not(.textarea--disabled) .textarea__control {
    color: var(--sl-input-color-hover);
  }

  .textarea--standard.textarea--focused:not(.textarea--disabled) {
    background-color: var(--sl-input-background-color-focus);
    border-color: var(--sl-input-border-color-focus);
    color: var(--sl-input-color-focus);
    box-shadow: 0 0 0 var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
  }

  .textarea--standard.textarea--focused:not(.textarea--disabled) .textarea__control {
    color: var(--sl-input-color-focus);
  }

  .textarea--standard.textarea--disabled {
    background-color: var(--sl-input-background-color-disabled);
    border-color: var(--sl-input-border-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .textarea__control,
  .textarea__size-adjuster {
    grid-area: 1 / 1 / 2 / 2;
  }

  .textarea__size-adjuster {
    visibility: hidden;
    pointer-events: none;
    opacity: 0;
  }

  .textarea--standard.textarea--disabled .textarea__control {
    color: var(--sl-input-color-disabled);
  }

  .textarea--standard.textarea--disabled .textarea__control::placeholder {
    color: var(--sl-input-placeholder-color-disabled);
  }

  /* Filled textareas */
  .textarea--filled {
    border: none;
    background-color: var(--sl-input-filled-background-color);
    color: var(--sl-input-color);
  }

  .textarea--filled:hover:not(.textarea--disabled) {
    background-color: var(--sl-input-filled-background-color-hover);
  }

  .textarea--filled.textarea--focused:not(.textarea--disabled) {
    background-color: var(--sl-input-filled-background-color-focus);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .textarea--filled.textarea--disabled {
    background-color: var(--sl-input-filled-background-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .textarea__control {
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: 1.4;
    color: var(--sl-input-color);
    border: none;
    background: none;
    box-shadow: none;
    cursor: inherit;
    -webkit-appearance: none;
  }

  .textarea__control::-webkit-search-decoration,
  .textarea__control::-webkit-search-cancel-button,
  .textarea__control::-webkit-search-results-button,
  .textarea__control::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  .textarea__control::placeholder {
    color: var(--sl-input-placeholder-color);
    user-select: none;
    -webkit-user-select: none;
  }

  .textarea__control:focus {
    outline: none;
  }

  /*
   * Size modifiers
   */

  .textarea--small {
    border-radius: var(--sl-input-border-radius-small);
    font-size: var(--sl-input-font-size-small);
  }

  .textarea--small .textarea__control {
    padding: 0.5em var(--sl-input-spacing-small);
  }

  .textarea--medium {
    border-radius: var(--sl-input-border-radius-medium);
    font-size: var(--sl-input-font-size-medium);
  }

  .textarea--medium .textarea__control {
    padding: 0.5em var(--sl-input-spacing-medium);
  }

  .textarea--large {
    border-radius: var(--sl-input-border-radius-large);
    font-size: var(--sl-input-font-size-large);
  }

  .textarea--large .textarea__control {
    padding: 0.5em var(--sl-input-spacing-large);
  }

  /*
   * Resize types
   */

  .textarea--resize-none .textarea__control {
    resize: none;
  }

  .textarea--resize-vertical .textarea__control {
    resize: vertical;
  }

  .textarea--resize-auto .textarea__control {
    height: auto;
    resize: none;
    overflow-y: hidden;
  }
`;















var $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $6aba7ae81ba45aa2$export$43da334182d34ab4)(this, {
            assumeInteractionOn: [
                "sl-blur",
                "sl-input"
            ]
        });
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "help-text", "label");
        this.hasFocus = false;
        this.title = "";
        this.name = "";
        this.value = "";
        this.size = "medium";
        this.filled = false;
        this.label = "";
        this.helpText = "";
        this.placeholder = "";
        this.rows = 4;
        this.resize = "vertical";
        this.disabled = false;
        this.readonly = false;
        this.form = "";
        this.required = false;
        this.spellcheck = true;
        this.defaultValue = "";
    }
    /** Gets the validity state object */ get validity() {
        return this.input.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.input.validationMessage;
    }
    connectedCallback() {
        super.connectedCallback();
        this.resizeObserver = new ResizeObserver(()=>this.setTextareaHeight());
        this.updateComplete.then(()=>{
            this.setTextareaHeight();
            this.resizeObserver.observe(this.input);
        });
    }
    firstUpdated() {
        this.formControlController.updateValidity();
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        if (this.input) (_a = this.resizeObserver) == null || _a.unobserve(this.input);
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleChange() {
        this.value = this.input.value;
        this.setTextareaHeight();
        this.emit("sl-change");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleInput() {
        this.value = this.input.value;
        this.emit("sl-input");
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    setTextareaHeight() {
        if (this.resize === "auto") {
            this.sizeAdjuster.style.height = `${this.input.clientHeight}px`;
            this.input.style.height = "auto";
            this.input.style.height = `${this.input.scrollHeight}px`;
        } else this.input.style.height = "";
    }
    handleDisabledChange() {
        this.formControlController.setValidity(this.disabled);
    }
    handleRowsChange() {
        this.setTextareaHeight();
    }
    async handleValueChange() {
        await this.updateComplete;
        this.formControlController.updateValidity();
        this.setTextareaHeight();
    }
    /** Sets focus on the textarea. */ focus(options) {
        this.input.focus(options);
    }
    /** Removes focus from the textarea. */ blur() {
        this.input.blur();
    }
    /** Selects all the text in the textarea. */ select() {
        this.input.select();
    }
    /** Gets or sets the textarea's scroll position. */ scrollPosition(position) {
        if (position) {
            if (typeof position.top === "number") this.input.scrollTop = position.top;
            if (typeof position.left === "number") this.input.scrollLeft = position.left;
            return void 0;
        }
        return {
            top: this.input.scrollTop,
            left: this.input.scrollTop
        };
    }
    /** Sets the start and end positions of the text selection (0-based). */ setSelectionRange(selectionStart, selectionEnd, selectionDirection = "none") {
        this.input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
    }
    /** Replaces a range of text with a new string. */ setRangeText(replacement, start, end, selectMode = "preserve") {
        const selectionStart = start != null ? start : this.input.selectionStart;
        const selectionEnd = end != null ? end : this.input.selectionEnd;
        this.input.setRangeText(replacement, selectionStart, selectionEnd, selectMode);
        if (this.value !== this.input.value) {
            this.value = this.input.value;
            this.setTextareaHeight();
        }
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.input.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        return this.input.reportValidity();
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        this.input.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    render() {
        const hasLabelSlot = this.hasSlotController.test("label");
        const hasHelpTextSlot = this.hasSlotController.test("help-text");
        const hasLabel = this.label ? true : !!hasLabelSlot;
        const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="form-control"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "form-control": true,
            "form-control--small": this.size === "small",
            "form-control--medium": this.size === "medium",
            "form-control--large": this.size === "large",
            "form-control--has-label": hasLabel,
            "form-control--has-help-text": hasHelpText
        })}
      >
        <label
          part="form-control-label"
          class="form-control__label"
          for="input"
          aria-hidden=${hasLabel ? "false" : "true"}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <div
            part="base"
            class=${(0, $4930586706e2a706$export$56cc687933817664)({
            textarea: true,
            "textarea--small": this.size === "small",
            "textarea--medium": this.size === "medium",
            "textarea--large": this.size === "large",
            "textarea--standard": !this.filled,
            "textarea--filled": this.filled,
            "textarea--disabled": this.disabled,
            "textarea--focused": this.hasFocus,
            "textarea--empty": !this.value,
            "textarea--resize-none": this.resize === "none",
            "textarea--resize-vertical": this.resize === "vertical",
            "textarea--resize-auto": this.resize === "auto"
        })}
          >
            <textarea
              part="textarea"
              id="input"
              class="textarea__control"
              title=${this.title}
              name=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.name)}
              .value=${(0, $9cd948e30340d8e4$export$28cf49ad70f82d12)(this.value)}
              ?disabled=${this.disabled}
              ?readonly=${this.readonly}
              ?required=${this.required}
              placeholder=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.placeholder)}
              rows=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.rows)}
              minlength=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.minlength)}
              maxlength=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.maxlength)}
              autocapitalize=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.autocapitalize)}
              autocorrect=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.autocorrect)}
              ?autofocus=${this.autofocus}
              spellcheck=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.spellcheck)}
              enterkeyhint=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.enterkeyhint)}
              inputmode=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.inputmode)}
              aria-describedby="help-text"
              @change=${this.handleChange}
              @input=${this.handleInput}
              @invalid=${this.handleInvalid}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
            ></textarea>
            <!-- This "adjuster" exists to prevent layout shifting. https://github.com/shoelace-style/shoelace/issues/2180 -->
            <div part="textarea-adjuster" class="textarea__size-adjuster" ?hidden=${this.resize !== "auto"}></div>
          </div>
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${hasHelpText ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
    }
};
$fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $5650ed14ec96c2a3$export$e7c8528c268605e9),
    (0, $3c9f39af55d9a9cb$export$884e7f8ce9b7053a)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".textarea__control")
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "input", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".textarea__size-adjuster")
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "sizeAdjuster", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "hasFocus", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "title", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "name", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "size", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "filled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "label", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "help-text"
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "helpText", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "placeholder", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "rows", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "resize", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "readonly", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "form", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "required", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "minlength", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "maxlength", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "autocapitalize", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "autocorrect", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "autocomplete", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "autofocus", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "enterkeyhint", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        converter: {
            // Allow "true|false" attribute values but keep the property boolean
            fromAttribute: (value)=>!value || value === "false" ? false : true,
            toAttribute: (value)=>value ? "true" : "false"
        }
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "spellcheck", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "inputmode", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $66d37a8d1e916a65$export$1a01ae0705bafd37)()
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "defaultValue", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "handleDisabledChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("rows", {
        waitUntilFirstUpdate: true
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "handleRowsChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("value", {
        waitUntilFirstUpdate: true
    })
], $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e.prototype, "handleValueChange", 1);


// src/components/textarea/textarea.ts
var $c8be95ef4a3bb1ee$export$c4dd1ba18c3111fc = (0, $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e);
(0, $fef85c45c72cdcdb$export$93b8d6e5b0c01a7e).define("sl-textarea");




// src/components/tab/tab.styles.ts

var $d59b6180f0b748dc$export$b0b79ad2f92ac0e3 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
  }

  .tab {
    display: inline-flex;
    align-items: center;
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-small);
    font-weight: var(--sl-font-weight-semibold);
    border-radius: var(--sl-border-radius-medium);
    color: var(--sl-color-neutral-600);
    padding: var(--sl-spacing-medium) var(--sl-spacing-large);
    white-space: nowrap;
    user-select: none;
    -webkit-user-select: none;
    cursor: pointer;
    transition:
      var(--transition-speed) box-shadow,
      var(--transition-speed) color;
  }

  .tab:hover:not(.tab--disabled) {
    color: var(--sl-color-primary-600);
  }

  :host(:focus) {
    outline: transparent;
  }

  :host(:focus-visible) {
    color: var(--sl-color-primary-600);
    outline: var(--sl-focus-ring);
    outline-offset: calc(-1 * var(--sl-focus-ring-width) - var(--sl-focus-ring-offset));
  }

  .tab.tab--active:not(.tab--disabled) {
    color: var(--sl-color-primary-600);
  }

  .tab.tab--closable {
    padding-inline-end: var(--sl-spacing-small);
  }

  .tab.tab--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .tab__close-button {
    font-size: var(--sl-font-size-small);
    margin-inline-start: var(--sl-spacing-small);
  }

  .tab__close-button::part(base) {
    padding: var(--sl-spacing-3x-small);
  }

  @media (forced-colors: active) {
    .tab.tab--active:not(.tab--disabled) {
      outline: solid 1px transparent;
      outline-offset: -3px;
    }
  }
`;











var $7cd65cd240d4cede$var$id = 0;
var $7cd65cd240d4cede$export$c05cd287793a46a4 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.attrId = ++$7cd65cd240d4cede$var$id;
        this.componentId = `sl-tab-${this.attrId}`;
        this.panel = "";
        this.active = false;
        this.closable = false;
        this.disabled = false;
        this.tabIndex = 0;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "tab");
    }
    handleCloseClick(event) {
        event.stopPropagation();
        this.emit("sl-close");
    }
    handleActiveChange() {
        this.setAttribute("aria-selected", this.active ? "true" : "false");
    }
    handleDisabledChange() {
        this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
        if (this.disabled && !this.active) this.tabIndex = -1;
        else this.tabIndex = 0;
    }
    render() {
        this.id = this.id.length > 0 ? this.id : this.componentId;
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            tab: true,
            "tab--active": this.active,
            "tab--closable": this.closable,
            "tab--disabled": this.disabled
        })}
      >
        <slot></slot>
        ${this.closable ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <sl-icon-button
                part="close-button"
                exportparts="base:close-button__base"
                name="x-lg"
                library="system"
                label=${this.localize.term("close")}
                class="tab__close-button"
                @click=${this.handleCloseClick}
                tabindex="-1"
              ></sl-icon-button>
            ` : ""}
      </div>
    `;
    }
};
$7cd65cd240d4cede$export$c05cd287793a46a4.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $d59b6180f0b748dc$export$b0b79ad2f92ac0e3)
];
$7cd65cd240d4cede$export$c05cd287793a46a4.dependencies = {
    "sl-icon-button": (0, $271ffb72cdd1ec73$export$302c9d29315a4659)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".tab")
], $7cd65cd240d4cede$export$c05cd287793a46a4.prototype, "tab", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $7cd65cd240d4cede$export$c05cd287793a46a4.prototype, "panel", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $7cd65cd240d4cede$export$c05cd287793a46a4.prototype, "active", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $7cd65cd240d4cede$export$c05cd287793a46a4.prototype, "closable", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $7cd65cd240d4cede$export$c05cd287793a46a4.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $7cd65cd240d4cede$export$c05cd287793a46a4.prototype, "tabIndex", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("active")
], $7cd65cd240d4cede$export$c05cd287793a46a4.prototype, "handleActiveChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled")
], $7cd65cd240d4cede$export$c05cd287793a46a4.prototype, "handleDisabledChange", 1);


// src/components/tab/tab.ts
var $c3d00126c84abab1$export$937bc6071adf91f = (0, $7cd65cd240d4cede$export$c05cd287793a46a4);
(0, $7cd65cd240d4cede$export$c05cd287793a46a4).define("sl-tab");




// src/components/tab-group/tab-group.styles.ts

var $ece8aaf1f87ef859$export$a3b4c6f58c707229 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --indicator-color: var(--sl-color-primary-600);
    --track-color: var(--sl-color-neutral-200);
    --track-width: 2px;

    display: block;
  }

  .tab-group {
    display: flex;
    border-radius: 0;
  }

  .tab-group__tabs {
    display: flex;
    position: relative;
  }

  .tab-group__indicator {
    position: absolute;
    transition:
      var(--sl-transition-fast) translate ease,
      var(--sl-transition-fast) width ease;
  }

  .tab-group--has-scroll-controls .tab-group__nav-container {
    position: relative;
    padding: 0 var(--sl-spacing-x-large);
  }

  .tab-group--has-scroll-controls .tab-group__scroll-button--start--hidden,
  .tab-group--has-scroll-controls .tab-group__scroll-button--end--hidden {
    visibility: hidden;
  }

  .tab-group__body {
    display: block;
    overflow: auto;
  }

  .tab-group__scroll-button {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    width: var(--sl-spacing-x-large);
  }

  .tab-group__scroll-button--start {
    left: 0;
  }

  .tab-group__scroll-button--end {
    right: 0;
  }

  .tab-group--rtl .tab-group__scroll-button--start {
    left: auto;
    right: 0;
  }

  .tab-group--rtl .tab-group__scroll-button--end {
    left: 0;
    right: auto;
  }

  /*
   * Top
   */

  .tab-group--top {
    flex-direction: column;
  }

  .tab-group--top .tab-group__nav-container {
    order: 1;
  }

  .tab-group--top .tab-group__nav {
    display: flex;
    overflow-x: auto;

    /* Hide scrollbar in Firefox */
    scrollbar-width: none;
  }

  /* Hide scrollbar in Chrome/Safari */
  .tab-group--top .tab-group__nav::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  .tab-group--top .tab-group__tabs {
    flex: 1 1 auto;
    position: relative;
    flex-direction: row;
    border-bottom: solid var(--track-width) var(--track-color);
  }

  .tab-group--top .tab-group__indicator {
    bottom: calc(-1 * var(--track-width));
    border-bottom: solid var(--track-width) var(--indicator-color);
  }

  .tab-group--top .tab-group__body {
    order: 2;
  }

  .tab-group--top ::slotted(sl-tab-panel) {
    --padding: var(--sl-spacing-medium) 0;
  }

  /*
   * Bottom
   */

  .tab-group--bottom {
    flex-direction: column;
  }

  .tab-group--bottom .tab-group__nav-container {
    order: 2;
  }

  .tab-group--bottom .tab-group__nav {
    display: flex;
    overflow-x: auto;

    /* Hide scrollbar in Firefox */
    scrollbar-width: none;
  }

  /* Hide scrollbar in Chrome/Safari */
  .tab-group--bottom .tab-group__nav::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  .tab-group--bottom .tab-group__tabs {
    flex: 1 1 auto;
    position: relative;
    flex-direction: row;
    border-top: solid var(--track-width) var(--track-color);
  }

  .tab-group--bottom .tab-group__indicator {
    top: calc(-1 * var(--track-width));
    border-top: solid var(--track-width) var(--indicator-color);
  }

  .tab-group--bottom .tab-group__body {
    order: 1;
  }

  .tab-group--bottom ::slotted(sl-tab-panel) {
    --padding: var(--sl-spacing-medium) 0;
  }

  /*
   * Start
   */

  .tab-group--start {
    flex-direction: row;
  }

  .tab-group--start .tab-group__nav-container {
    order: 1;
  }

  .tab-group--start .tab-group__tabs {
    flex: 0 0 auto;
    flex-direction: column;
    border-inline-end: solid var(--track-width) var(--track-color);
  }

  .tab-group--start .tab-group__indicator {
    right: calc(-1 * var(--track-width));
    border-right: solid var(--track-width) var(--indicator-color);
  }

  .tab-group--start.tab-group--rtl .tab-group__indicator {
    right: auto;
    left: calc(-1 * var(--track-width));
  }

  .tab-group--start .tab-group__body {
    flex: 1 1 auto;
    order: 2;
  }

  .tab-group--start ::slotted(sl-tab-panel) {
    --padding: 0 var(--sl-spacing-medium);
  }

  /*
   * End
   */

  .tab-group--end {
    flex-direction: row;
  }

  .tab-group--end .tab-group__nav-container {
    order: 2;
  }

  .tab-group--end .tab-group__tabs {
    flex: 0 0 auto;
    flex-direction: column;
    border-left: solid var(--track-width) var(--track-color);
  }

  .tab-group--end .tab-group__indicator {
    left: calc(-1 * var(--track-width));
    border-inline-start: solid var(--track-width) var(--indicator-color);
  }

  .tab-group--end.tab-group--rtl .tab-group__indicator {
    right: calc(-1 * var(--track-width));
    left: auto;
  }

  .tab-group--end .tab-group__body {
    flex: 1 1 auto;
    order: 1;
  }

  .tab-group--end ::slotted(sl-tab-panel) {
    --padding: 0 var(--sl-spacing-medium);
  }
`;


// src/components/resize-observer/resize-observer.styles.ts

var $615aed31877d4d81$export$78ba9ab8f907c32d = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: contents;
  }
`;








var $dcfe5c7a146db538$export$18010baf851c8702 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.observedElements = [];
        this.disabled = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.resizeObserver = new ResizeObserver((entries)=>{
            this.emit("sl-resize", {
                detail: {
                    entries: entries
                }
            });
        });
        if (!this.disabled) this.startObserver();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.stopObserver();
    }
    handleSlotChange() {
        if (!this.disabled) this.startObserver();
    }
    startObserver() {
        const slot = this.shadowRoot.querySelector("slot");
        if (slot !== null) {
            const elements = slot.assignedElements({
                flatten: true
            });
            this.observedElements.forEach((el)=>this.resizeObserver.unobserve(el));
            this.observedElements = [];
            elements.forEach((el)=>{
                this.resizeObserver.observe(el);
                this.observedElements.push(el);
            });
        }
    }
    stopObserver() {
        this.resizeObserver.disconnect();
    }
    handleDisabledChange() {
        if (this.disabled) this.stopObserver();
        else this.startObserver();
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)` <slot @slotchange=${this.handleSlotChange}></slot> `;
    }
};
$dcfe5c7a146db538$export$18010baf851c8702.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $615aed31877d4d81$export$78ba9ab8f907c32d)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $dcfe5c7a146db538$export$18010baf851c8702.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $dcfe5c7a146db538$export$18010baf851c8702.prototype, "handleDisabledChange", 1);


// src/internal/offset.ts
function $50a04e78d1030c6e$var$getOffset(element, parent) {
    return {
        top: Math.round(element.getBoundingClientRect().top - parent.getBoundingClientRect().top),
        left: Math.round(element.getBoundingClientRect().left - parent.getBoundingClientRect().left)
    };
}
// src/internal/scroll.ts
var $50a04e78d1030c6e$var$locks = /* @__PURE__ */ new Set();
function $50a04e78d1030c6e$var$getScrollbarWidth() {
    const documentWidth = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}
function $50a04e78d1030c6e$var$getExistingBodyPadding() {
    const padding = Number(getComputedStyle(document.body).paddingRight.replace(/px/, ""));
    if (isNaN(padding) || !padding) return 0;
    return padding;
}
function $50a04e78d1030c6e$export$5f4bd35c67f2403d(lockingEl) {
    $50a04e78d1030c6e$var$locks.add(lockingEl);
    if (!document.documentElement.classList.contains("sl-scroll-lock")) {
        const scrollbarWidth = $50a04e78d1030c6e$var$getScrollbarWidth() + $50a04e78d1030c6e$var$getExistingBodyPadding();
        let scrollbarGutterProperty = getComputedStyle(document.documentElement).scrollbarGutter;
        if (!scrollbarGutterProperty || scrollbarGutterProperty === "auto") scrollbarGutterProperty = "stable";
        if (scrollbarWidth < 2) scrollbarGutterProperty = "";
        document.documentElement.style.setProperty("--sl-scroll-lock-gutter", scrollbarGutterProperty);
        document.documentElement.classList.add("sl-scroll-lock");
        document.documentElement.style.setProperty("--sl-scroll-lock-size", `${scrollbarWidth}px`);
    }
}
function $50a04e78d1030c6e$export$7475b4759872c980(lockingEl) {
    $50a04e78d1030c6e$var$locks.delete(lockingEl);
    if ($50a04e78d1030c6e$var$locks.size === 0) {
        document.documentElement.classList.remove("sl-scroll-lock");
        document.documentElement.style.removeProperty("--sl-scroll-lock-size");
    }
}
function $50a04e78d1030c6e$export$53a0910f038337bd(element, container, direction = "vertical", behavior = "smooth") {
    const offset = $50a04e78d1030c6e$var$getOffset(element, container);
    const offsetTop = offset.top + container.scrollTop;
    const offsetLeft = offset.left + container.scrollLeft;
    const minX = container.scrollLeft;
    const maxX = container.scrollLeft + container.offsetWidth;
    const minY = container.scrollTop;
    const maxY = container.scrollTop + container.offsetHeight;
    if (direction === "horizontal" || direction === "both") {
        if (offsetLeft < minX) container.scrollTo({
            left: offsetLeft,
            behavior: behavior
        });
        else if (offsetLeft + element.clientWidth > maxX) container.scrollTo({
            left: offsetLeft - container.offsetWidth + element.clientWidth,
            behavior: behavior
        });
    }
    if (direction === "vertical" || direction === "both") {
        if (offsetTop < minY) container.scrollTo({
            top: offsetTop,
            behavior: behavior
        });
        else if (offsetTop + element.clientHeight > maxY) container.scrollTo({
            top: offsetTop - container.offsetHeight + element.clientHeight,
            behavior: behavior
        });
    }
}











var $a06e33576a151be8$export$670f373286bdeda = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.tabs = [];
        this.focusableTabs = [];
        this.panels = [];
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.hasScrollControls = false;
        this.shouldHideScrollStartButton = false;
        this.shouldHideScrollEndButton = false;
        this.placement = "top";
        this.activation = "auto";
        this.noScrollControls = false;
        this.fixedScrollControls = false;
        /**
     * The reality of the browser means that we can't expect the scroll position to be exactly what we want it to be, so
     * we add one pixel of wiggle room to our calculations.
     */ this.scrollOffset = 1;
    }
    connectedCallback() {
        const whenAllDefined = Promise.all([
            customElements.whenDefined("sl-tab"),
            customElements.whenDefined("sl-tab-panel")
        ]);
        super.connectedCallback();
        this.resizeObserver = new ResizeObserver(()=>{
            this.repositionIndicator();
            this.updateScrollControls();
        });
        this.mutationObserver = new MutationObserver((mutations)=>{
            if (mutations.some((m)=>![
                    "aria-labelledby",
                    "aria-controls"
                ].includes(m.attributeName))) setTimeout(()=>this.setAriaLabels());
            if (mutations.some((m)=>m.attributeName === "disabled")) this.syncTabsAndPanels();
            else if (mutations.some((m)=>m.attributeName === "active")) {
                const tabs = mutations.filter((m)=>m.attributeName === "active" && m.target.tagName.toLowerCase() === "sl-tab").map((m)=>m.target);
                const newActiveTab = tabs.find((tab)=>tab.active);
                if (newActiveTab) this.setActiveTab(newActiveTab);
            }
        });
        this.updateComplete.then(()=>{
            this.syncTabsAndPanels();
            this.mutationObserver.observe(this, {
                attributes: true,
                childList: true,
                subtree: true
            });
            this.resizeObserver.observe(this.nav);
            whenAllDefined.then(()=>{
                const intersectionObserver = new IntersectionObserver((entries, observer)=>{
                    var _a;
                    if (entries[0].intersectionRatio > 0) {
                        this.setAriaLabels();
                        this.setActiveTab((_a = this.getActiveTab()) != null ? _a : this.tabs[0], {
                            emitEvents: false
                        });
                        observer.unobserve(entries[0].target);
                    }
                });
                intersectionObserver.observe(this.tabGroup);
            });
        });
    }
    disconnectedCallback() {
        var _a, _b;
        super.disconnectedCallback();
        (_a = this.mutationObserver) == null || _a.disconnect();
        if (this.nav) (_b = this.resizeObserver) == null || _b.unobserve(this.nav);
    }
    getAllTabs() {
        const slot = this.shadowRoot.querySelector('slot[name="nav"]');
        return slot.assignedElements();
    }
    getAllPanels() {
        return [
            ...this.body.assignedElements()
        ].filter((el)=>el.tagName.toLowerCase() === "sl-tab-panel");
    }
    getActiveTab() {
        return this.tabs.find((el)=>el.active);
    }
    handleClick(event) {
        const target = event.target;
        const tab = target.closest("sl-tab");
        const tabGroup = tab == null ? void 0 : tab.closest("sl-tab-group");
        if (tabGroup !== this) return;
        if (tab !== null) this.setActiveTab(tab, {
            scrollBehavior: "smooth"
        });
    }
    handleKeyDown(event) {
        const target = event.target;
        const tab = target.closest("sl-tab");
        const tabGroup = tab == null ? void 0 : tab.closest("sl-tab-group");
        if (tabGroup !== this) return;
        if ([
            "Enter",
            " "
        ].includes(event.key)) {
            if (tab !== null) {
                this.setActiveTab(tab, {
                    scrollBehavior: "smooth"
                });
                event.preventDefault();
            }
        }
        if ([
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Home",
            "End"
        ].includes(event.key)) {
            const activeEl = this.tabs.find((t)=>t.matches(":focus"));
            const isRtl = this.localize.dir() === "rtl";
            let nextTab = null;
            if ((activeEl == null ? void 0 : activeEl.tagName.toLowerCase()) === "sl-tab") {
                if (event.key === "Home") nextTab = this.focusableTabs[0];
                else if (event.key === "End") nextTab = this.focusableTabs[this.focusableTabs.length - 1];
                else if ([
                    "top",
                    "bottom"
                ].includes(this.placement) && event.key === (isRtl ? "ArrowRight" : "ArrowLeft") || [
                    "start",
                    "end"
                ].includes(this.placement) && event.key === "ArrowUp") {
                    const currentIndex = this.tabs.findIndex((el)=>el === activeEl);
                    nextTab = this.findNextFocusableTab(currentIndex, "backward");
                } else if ([
                    "top",
                    "bottom"
                ].includes(this.placement) && event.key === (isRtl ? "ArrowLeft" : "ArrowRight") || [
                    "start",
                    "end"
                ].includes(this.placement) && event.key === "ArrowDown") {
                    const currentIndex = this.tabs.findIndex((el)=>el === activeEl);
                    nextTab = this.findNextFocusableTab(currentIndex, "forward");
                }
                if (!nextTab) return;
                nextTab.tabIndex = 0;
                nextTab.focus({
                    preventScroll: true
                });
                if (this.activation === "auto") this.setActiveTab(nextTab, {
                    scrollBehavior: "smooth"
                });
                else this.tabs.forEach((tabEl)=>{
                    tabEl.tabIndex = tabEl === nextTab ? 0 : -1;
                });
                if ([
                    "top",
                    "bottom"
                ].includes(this.placement)) (0, $50a04e78d1030c6e$export$53a0910f038337bd)(nextTab, this.nav, "horizontal");
                event.preventDefault();
            }
        }
    }
    handleScrollToStart() {
        this.nav.scroll({
            left: this.localize.dir() === "rtl" ? this.nav.scrollLeft + this.nav.clientWidth : this.nav.scrollLeft - this.nav.clientWidth,
            behavior: "smooth"
        });
    }
    handleScrollToEnd() {
        this.nav.scroll({
            left: this.localize.dir() === "rtl" ? this.nav.scrollLeft - this.nav.clientWidth : this.nav.scrollLeft + this.nav.clientWidth,
            behavior: "smooth"
        });
    }
    setActiveTab(tab, options) {
        options = (0, $1db749c92da399da$export$7de063a7aa429f6c)({
            emitEvents: true,
            scrollBehavior: "auto"
        }, options);
        if (tab !== this.activeTab && !tab.disabled) {
            const previousTab = this.activeTab;
            this.activeTab = tab;
            this.tabs.forEach((el)=>{
                el.active = el === this.activeTab;
                el.tabIndex = el === this.activeTab ? 0 : -1;
            });
            this.panels.forEach((el)=>{
                var _a;
                return el.active = el.name === ((_a = this.activeTab) == null ? void 0 : _a.panel);
            });
            this.syncIndicator();
            if ([
                "top",
                "bottom"
            ].includes(this.placement)) (0, $50a04e78d1030c6e$export$53a0910f038337bd)(this.activeTab, this.nav, "horizontal", options.scrollBehavior);
            if (options.emitEvents) {
                if (previousTab) this.emit("sl-tab-hide", {
                    detail: {
                        name: previousTab.panel
                    }
                });
                this.emit("sl-tab-show", {
                    detail: {
                        name: this.activeTab.panel
                    }
                });
            }
        }
    }
    setAriaLabels() {
        this.tabs.forEach((tab)=>{
            const panel = this.panels.find((el)=>el.name === tab.panel);
            if (panel) {
                tab.setAttribute("aria-controls", panel.getAttribute("id"));
                panel.setAttribute("aria-labelledby", tab.getAttribute("id"));
            }
        });
    }
    repositionIndicator() {
        const currentTab = this.getActiveTab();
        if (!currentTab) return;
        const width = currentTab.clientWidth;
        const height = currentTab.clientHeight;
        const isRtl = this.localize.dir() === "rtl";
        const allTabs = this.getAllTabs();
        const precedingTabs = allTabs.slice(0, allTabs.indexOf(currentTab));
        const offset = precedingTabs.reduce((previous, current)=>({
                left: previous.left + current.clientWidth,
                top: previous.top + current.clientHeight
            }), {
            left: 0,
            top: 0
        });
        switch(this.placement){
            case "top":
            case "bottom":
                this.indicator.style.width = `${width}px`;
                this.indicator.style.height = "auto";
                this.indicator.style.translate = isRtl ? `${-1 * offset.left}px` : `${offset.left}px`;
                break;
            case "start":
            case "end":
                this.indicator.style.width = "auto";
                this.indicator.style.height = `${height}px`;
                this.indicator.style.translate = `0 ${offset.top}px`;
                break;
        }
    }
    // This stores tabs and panels so we can refer to a cache instead of calling querySelectorAll() multiple times.
    syncTabsAndPanels() {
        this.tabs = this.getAllTabs();
        this.focusableTabs = this.tabs.filter((el)=>!el.disabled);
        this.panels = this.getAllPanels();
        this.syncIndicator();
        this.updateComplete.then(()=>this.updateScrollControls());
    }
    findNextFocusableTab(currentIndex, direction) {
        let nextTab = null;
        const iterator = direction === "forward" ? 1 : -1;
        let nextIndex = currentIndex + iterator;
        while(currentIndex < this.tabs.length){
            nextTab = this.tabs[nextIndex] || null;
            if (nextTab === null) {
                if (direction === "forward") nextTab = this.focusableTabs[0];
                else nextTab = this.focusableTabs[this.focusableTabs.length - 1];
                break;
            }
            if (!nextTab.disabled) break;
            nextIndex += iterator;
        }
        return nextTab;
    }
    updateScrollButtons() {
        if (this.hasScrollControls && !this.fixedScrollControls) {
            this.shouldHideScrollStartButton = this.scrollFromStart() <= this.scrollOffset;
            this.shouldHideScrollEndButton = this.isScrolledToEnd();
        }
    }
    isScrolledToEnd() {
        return this.scrollFromStart() + this.nav.clientWidth >= this.nav.scrollWidth - this.scrollOffset;
    }
    scrollFromStart() {
        return this.localize.dir() === "rtl" ? -this.nav.scrollLeft : this.nav.scrollLeft;
    }
    updateScrollControls() {
        if (this.noScrollControls) this.hasScrollControls = false;
        else this.hasScrollControls = [
            "top",
            "bottom"
        ].includes(this.placement) && this.nav.scrollWidth > this.nav.clientWidth + 1;
        this.updateScrollButtons();
    }
    syncIndicator() {
        const tab = this.getActiveTab();
        if (tab) {
            this.indicator.style.display = "block";
            this.repositionIndicator();
        } else this.indicator.style.display = "none";
    }
    /** Shows the specified tab panel. */ show(panel) {
        const tab = this.tabs.find((el)=>el.panel === panel);
        if (tab) this.setActiveTab(tab, {
            scrollBehavior: "smooth"
        });
    }
    render() {
        const isRtl = this.localize.dir() === "rtl";
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "tab-group": true,
            "tab-group--top": this.placement === "top",
            "tab-group--bottom": this.placement === "bottom",
            "tab-group--start": this.placement === "start",
            "tab-group--end": this.placement === "end",
            "tab-group--rtl": this.localize.dir() === "rtl",
            "tab-group--has-scroll-controls": this.hasScrollControls
        })}
        @click=${this.handleClick}
        @keydown=${this.handleKeyDown}
      >
        <div class="tab-group__nav-container" part="nav">
          ${this.hasScrollControls ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                <sl-icon-button
                  part="scroll-button scroll-button--start"
                  exportparts="base:scroll-button__base"
                  class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "tab-group__scroll-button": true,
            "tab-group__scroll-button--start": true,
            "tab-group__scroll-button--start--hidden": this.shouldHideScrollStartButton
        })}
                  name=${isRtl ? "chevron-right" : "chevron-left"}
                  library="system"
                  tabindex="-1"
                  aria-hidden="true"
                  label=${this.localize.term("scrollToStart")}
                  @click=${this.handleScrollToStart}
                ></sl-icon-button>
              ` : ""}

          <div class="tab-group__nav" @scrollend=${this.updateScrollButtons}>
            <div part="tabs" class="tab-group__tabs" role="tablist">
              <div part="active-tab-indicator" class="tab-group__indicator"></div>
              <sl-resize-observer @sl-resize=${this.syncIndicator}>
                <slot name="nav" @slotchange=${this.syncTabsAndPanels}></slot>
              </sl-resize-observer>
            </div>
          </div>

          ${this.hasScrollControls ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                <sl-icon-button
                  part="scroll-button scroll-button--end"
                  exportparts="base:scroll-button__base"
                  class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "tab-group__scroll-button": true,
            "tab-group__scroll-button--end": true,
            "tab-group__scroll-button--end--hidden": this.shouldHideScrollEndButton
        })}
                  name=${isRtl ? "chevron-left" : "chevron-right"}
                  library="system"
                  tabindex="-1"
                  aria-hidden="true"
                  label=${this.localize.term("scrollToEnd")}
                  @click=${this.handleScrollToEnd}
                ></sl-icon-button>
              ` : ""}
        </div>

        <slot part="body" class="tab-group__body" @slotchange=${this.syncTabsAndPanels}></slot>
      </div>
    `;
    }
};
$a06e33576a151be8$export$670f373286bdeda.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $ece8aaf1f87ef859$export$a3b4c6f58c707229)
];
$a06e33576a151be8$export$670f373286bdeda.dependencies = {
    "sl-icon-button": (0, $271ffb72cdd1ec73$export$302c9d29315a4659),
    "sl-resize-observer": (0, $dcfe5c7a146db538$export$18010baf851c8702)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".tab-group")
], $a06e33576a151be8$export$670f373286bdeda.prototype, "tabGroup", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".tab-group__body")
], $a06e33576a151be8$export$670f373286bdeda.prototype, "body", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".tab-group__nav")
], $a06e33576a151be8$export$670f373286bdeda.prototype, "nav", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".tab-group__indicator")
], $a06e33576a151be8$export$670f373286bdeda.prototype, "indicator", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $a06e33576a151be8$export$670f373286bdeda.prototype, "hasScrollControls", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $a06e33576a151be8$export$670f373286bdeda.prototype, "shouldHideScrollStartButton", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $a06e33576a151be8$export$670f373286bdeda.prototype, "shouldHideScrollEndButton", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $a06e33576a151be8$export$670f373286bdeda.prototype, "placement", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $a06e33576a151be8$export$670f373286bdeda.prototype, "activation", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "no-scroll-controls",
        type: Boolean
    })
], $a06e33576a151be8$export$670f373286bdeda.prototype, "noScrollControls", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "fixed-scroll-controls",
        type: Boolean
    })
], $a06e33576a151be8$export$670f373286bdeda.prototype, "fixedScrollControls", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $8a317031349a1d0f$export$b2b799818fbabcf3)({
        passive: true
    })
], $a06e33576a151be8$export$670f373286bdeda.prototype, "updateScrollButtons", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("noScrollControls", {
        waitUntilFirstUpdate: true
    })
], $a06e33576a151be8$export$670f373286bdeda.prototype, "updateScrollControls", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("placement", {
        waitUntilFirstUpdate: true
    })
], $a06e33576a151be8$export$670f373286bdeda.prototype, "syncIndicator", 1);


// src/components/tab-group/tab-group.ts
var $1a2878703a6eeaa6$export$1be2209ab9b92119 = (0, $a06e33576a151be8$export$670f373286bdeda);
(0, $a06e33576a151be8$export$670f373286bdeda).define("sl-tab-group");







// src/components/spinner/spinner.ts
var $224c0e9ef41c74e8$export$b67103861f057d1a = (0, $b879e4c4815031db$export$4e45ce56e46d2b00);
(0, $b879e4c4815031db$export$4e45ce56e46d2b00).define("sl-spinner");


// src/components/split-panel/split-panel.styles.ts

var $4ae722111b0a237c$export$816617387019c26e = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --divider-width: 4px;
    --divider-hit-area: 12px;
    --min: 0%;
    --max: 100%;

    display: grid;
  }

  .start,
  .end {
    overflow: hidden;
  }

  .divider {
    flex: 0 0 var(--divider-width);
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    background-color: var(--sl-color-neutral-200);
    color: var(--sl-color-neutral-900);
    z-index: 1;
  }

  .divider:focus {
    outline: none;
  }

  :host(:not([disabled])) .divider:focus-visible {
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  :host([disabled]) .divider {
    cursor: not-allowed;
  }

  /* Horizontal */
  :host(:not([vertical], [disabled])) .divider {
    cursor: col-resize;
  }

  :host(:not([vertical])) .divider::after {
    display: flex;
    content: '';
    position: absolute;
    height: 100%;
    left: calc(var(--divider-hit-area) / -2 + var(--divider-width) / 2);
    width: var(--divider-hit-area);
  }

  /* Vertical */
  :host([vertical]) {
    flex-direction: column;
  }

  :host([vertical]:not([disabled])) .divider {
    cursor: row-resize;
  }

  :host([vertical]) .divider::after {
    content: '';
    position: absolute;
    width: 100%;
    top: calc(var(--divider-hit-area) / -2 + var(--divider-width) / 2);
    height: var(--divider-hit-area);
  }

  @media (forced-colors: active) {
    .divider {
      outline: solid 1px transparent;
    }
  }
`;


// src/internal/drag.ts
function $9c08d309b4f970a2$export$d7d5d435647ed5a0(container, options) {
    function move(pointerEvent) {
        const dims = container.getBoundingClientRect();
        const defaultView = container.ownerDocument.defaultView;
        const offsetX = dims.left + defaultView.scrollX;
        const offsetY = dims.top + defaultView.scrollY;
        const x = pointerEvent.pageX - offsetX;
        const y = pointerEvent.pageY - offsetY;
        if (options == null ? void 0 : options.onMove) options.onMove(x, y);
    }
    function stop() {
        document.removeEventListener("pointermove", move);
        document.removeEventListener("pointerup", stop);
        if (options == null ? void 0 : options.onStop) options.onStop();
    }
    document.addEventListener("pointermove", move, {
        passive: true
    });
    document.addEventListener("pointerup", stop);
    if ((options == null ? void 0 : options.initialEvent) instanceof PointerEvent) move(options.initialEvent);
}











var $a0a23d853996f388$export$d63f80a1b7e08b5b = ()=>null;
var $a0a23d853996f388$export$ff96385e40c30b59 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.isCollapsed = false;
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.positionBeforeCollapsing = 0;
        this.position = 50;
        this.vertical = false;
        this.disabled = false;
        // Returned when the property is queried, so that string 'snap's are preserved.
        this.snapValue = "";
        // Actually used for computing snap points. All string snaps are converted via `toSnapFunction`.
        this.snapFunction = $a0a23d853996f388$export$d63f80a1b7e08b5b;
        this.snapThreshold = 12;
    }
    /**
   * Converts a string containing either a series of fixed/repeated snap points (e.g. "repeat(20%)", "100px 200px 800px", or "10% 50% repeat(10px)") into a SnapFunction. `SnapFunction`s take in a `SnapFunctionOpts` and return the position that the split panel should snap to.
   *
   * @param snap - The snap string.
   * @returns a `SnapFunction` representing the snap string's logic.
   */ toSnapFunction(snap) {
        const snapPoints = snap.split(" ");
        return ({ pos: pos, size: size, snapThreshold: snapThreshold, isRtl: isRtl, vertical: vertical })=>{
            let newPos = pos;
            let minDistance = Number.POSITIVE_INFINITY;
            snapPoints.forEach((value)=>{
                let snapPoint;
                if (value.startsWith("repeat(")) {
                    const repeatVal = snap.substring(7, snap.length - 1);
                    const isPercent = repeatVal.endsWith("%");
                    const repeatNum = Number.parseFloat(repeatVal);
                    const snapIntervalPx = isPercent ? size * (repeatNum / 100) : repeatNum;
                    snapPoint = Math.round((isRtl && !vertical ? size - pos : pos) / snapIntervalPx) * snapIntervalPx;
                } else if (value.endsWith("%")) snapPoint = size * (Number.parseFloat(value) / 100);
                else snapPoint = Number.parseFloat(value);
                if (isRtl && !vertical) snapPoint = size - snapPoint;
                const distance = Math.abs(pos - snapPoint);
                if (distance <= snapThreshold && distance < minDistance) {
                    newPos = snapPoint;
                    minDistance = distance;
                }
            });
            return newPos;
        };
    }
    set snap(snap) {
        this.snapValue = snap != null ? snap : "";
        if (snap) this.snapFunction = typeof snap === "string" ? this.toSnapFunction(snap) : snap;
        else this.snapFunction = $a0a23d853996f388$export$d63f80a1b7e08b5b;
    }
    get snap() {
        return this.snapValue;
    }
    connectedCallback() {
        super.connectedCallback();
        this.resizeObserver = new ResizeObserver((entries)=>this.handleResize(entries));
        this.updateComplete.then(()=>this.resizeObserver.observe(this));
        this.detectSize();
        this.cachedPositionInPixels = this.percentageToPixels(this.position);
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.resizeObserver) == null || _a.unobserve(this);
    }
    detectSize() {
        const { width: width, height: height } = this.getBoundingClientRect();
        this.size = this.vertical ? height : width;
    }
    percentageToPixels(value) {
        return this.size * (value / 100);
    }
    pixelsToPercentage(value) {
        return value / this.size * 100;
    }
    handleDrag(event) {
        const isRtl = this.localize.dir() === "rtl";
        if (this.disabled) return;
        if (event.cancelable) event.preventDefault();
        (0, $9c08d309b4f970a2$export$d7d5d435647ed5a0)(this, {
            onMove: (x, y)=>{
                var _a;
                let newPositionInPixels = this.vertical ? y : x;
                if (this.primary === "end") newPositionInPixels = this.size - newPositionInPixels;
                newPositionInPixels = (_a = this.snapFunction({
                    pos: newPositionInPixels,
                    size: this.size,
                    snapThreshold: this.snapThreshold,
                    isRtl: isRtl,
                    vertical: this.vertical
                })) != null ? _a : newPositionInPixels;
                this.position = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(this.pixelsToPercentage(newPositionInPixels), 0, 100);
            },
            initialEvent: event
        });
    }
    handleKeyDown(event) {
        if (this.disabled) return;
        if ([
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Home",
            "End",
            "Enter"
        ].includes(event.key)) {
            let newPosition = this.position;
            const incr = (event.shiftKey ? 10 : 1) * (this.primary === "end" ? -1 : 1);
            event.preventDefault();
            if (event.key === "ArrowLeft" && !this.vertical || event.key === "ArrowUp" && this.vertical) newPosition -= incr;
            if (event.key === "ArrowRight" && !this.vertical || event.key === "ArrowDown" && this.vertical) newPosition += incr;
            if (event.key === "Home") newPosition = this.primary === "end" ? 100 : 0;
            if (event.key === "End") newPosition = this.primary === "end" ? 0 : 100;
            if (event.key === "Enter") {
                if (this.isCollapsed) {
                    newPosition = this.positionBeforeCollapsing;
                    this.isCollapsed = false;
                } else {
                    const positionBeforeCollapsing = this.position;
                    newPosition = 0;
                    requestAnimationFrame(()=>{
                        this.isCollapsed = true;
                        this.positionBeforeCollapsing = positionBeforeCollapsing;
                    });
                }
            }
            this.position = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(newPosition, 0, 100);
        }
    }
    handleResize(entries) {
        const { width: width, height: height } = entries[0].contentRect;
        this.size = this.vertical ? height : width;
        if (isNaN(this.cachedPositionInPixels) || this.position === Infinity) {
            this.cachedPositionInPixels = Number(this.getAttribute("position-in-pixels"));
            this.positionInPixels = Number(this.getAttribute("position-in-pixels"));
            this.position = this.pixelsToPercentage(this.positionInPixels);
        }
        if (this.primary) this.position = this.pixelsToPercentage(this.cachedPositionInPixels);
    }
    handlePositionChange() {
        this.cachedPositionInPixels = this.percentageToPixels(this.position);
        this.isCollapsed = false;
        this.positionBeforeCollapsing = 0;
        this.positionInPixels = this.percentageToPixels(this.position);
        this.emit("sl-reposition");
    }
    handlePositionInPixelsChange() {
        this.position = this.pixelsToPercentage(this.positionInPixels);
    }
    handleVerticalChange() {
        this.detectSize();
    }
    render() {
        const gridTemplate = this.vertical ? "gridTemplateRows" : "gridTemplateColumns";
        const gridTemplateAlt = this.vertical ? "gridTemplateColumns" : "gridTemplateRows";
        const isRtl = this.localize.dir() === "rtl";
        const primary = `
      clamp(
        0%,
        clamp(
          var(--min),
          ${this.position}% - var(--divider-width) / 2,
          var(--max)
        ),
        calc(100% - var(--divider-width))
      )
    `;
        const secondary = "auto";
        if (this.primary === "end") {
            if (isRtl && !this.vertical) this.style[gridTemplate] = `${primary} var(--divider-width) ${secondary}`;
            else this.style[gridTemplate] = `${secondary} var(--divider-width) ${primary}`;
        } else if (isRtl && !this.vertical) this.style[gridTemplate] = `${secondary} var(--divider-width) ${primary}`;
        else this.style[gridTemplate] = `${primary} var(--divider-width) ${secondary}`;
        this.style[gridTemplateAlt] = "";
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <slot name="start" part="panel start" class="start"></slot>

      <div
        part="divider"
        class="divider"
        tabindex=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.disabled ? void 0 : "0")}
        role="separator"
        aria-valuenow=${this.position}
        aria-valuemin="0"
        aria-valuemax="100"
        aria-label=${this.localize.term("resize")}
        @keydown=${this.handleKeyDown}
        @mousedown=${this.handleDrag}
        @touchstart=${this.handleDrag}
      >
        <slot name="divider"></slot>
      </div>

      <slot name="end" part="panel end" class="end"></slot>
    `;
    }
};
$a0a23d853996f388$export$ff96385e40c30b59.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $4ae722111b0a237c$export$816617387019c26e)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".divider")
], $a0a23d853996f388$export$ff96385e40c30b59.prototype, "divider", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $a0a23d853996f388$export$ff96385e40c30b59.prototype, "position", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "position-in-pixels",
        type: Number
    })
], $a0a23d853996f388$export$ff96385e40c30b59.prototype, "positionInPixels", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a0a23d853996f388$export$ff96385e40c30b59.prototype, "vertical", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a0a23d853996f388$export$ff96385e40c30b59.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $a0a23d853996f388$export$ff96385e40c30b59.prototype, "primary", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $a0a23d853996f388$export$ff96385e40c30b59.prototype, "snap", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number,
        attribute: "snap-threshold"
    })
], $a0a23d853996f388$export$ff96385e40c30b59.prototype, "snapThreshold", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("position")
], $a0a23d853996f388$export$ff96385e40c30b59.prototype, "handlePositionChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("positionInPixels")
], $a0a23d853996f388$export$ff96385e40c30b59.prototype, "handlePositionInPixelsChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("vertical")
], $a0a23d853996f388$export$ff96385e40c30b59.prototype, "handleVerticalChange", 1);


// src/components/split-panel/split-panel.ts
var $ca89a1aa0219cc69$export$44fff793c03942b6 = (0, $a0a23d853996f388$export$ff96385e40c30b59);
(0, $a0a23d853996f388$export$ff96385e40c30b59).define("sl-split-panel");




// src/components/switch/switch.styles.ts

var $ec110f7d215ad6b3$export$14e2900f6ef79e2b = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
  }

  :host([size='small']) {
    --height: var(--sl-toggle-size-small);
    --thumb-size: calc(var(--sl-toggle-size-small) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-small);
  }

  :host([size='medium']) {
    --height: var(--sl-toggle-size-medium);
    --thumb-size: calc(var(--sl-toggle-size-medium) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-medium);
  }

  :host([size='large']) {
    --height: var(--sl-toggle-size-large);
    --thumb-size: calc(var(--sl-toggle-size-large) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-large);
  }

  .switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    font-family: var(--sl-input-font-family);
    font-size: inherit;
    font-weight: var(--sl-input-font-weight);
    color: var(--sl-input-label-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .switch__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--width);
    height: var(--height);
    background-color: var(--sl-color-neutral-400);
    border: solid var(--sl-input-border-width) var(--sl-color-neutral-400);
    border-radius: var(--height);
    transition:
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) background-color;
  }

  .switch__control .switch__thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    background-color: var(--sl-color-neutral-0);
    border-radius: 50%;
    border: solid var(--sl-input-border-width) var(--sl-color-neutral-400);
    translate: calc((var(--width) - var(--height)) / -2);
    transition:
      var(--sl-transition-fast) translate ease,
      var(--sl-transition-fast) background-color,
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) box-shadow;
  }

  .switch__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  /* Hover */
  .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover {
    background-color: var(--sl-color-neutral-400);
    border-color: var(--sl-color-neutral-400);
  }

  .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-neutral-400);
  }

  /* Focus */
  .switch:not(.switch--checked):not(.switch--disabled) .switch__input:focus-visible ~ .switch__control {
    background-color: var(--sl-color-neutral-400);
    border-color: var(--sl-color-neutral-400);
  }

  .switch:not(.switch--checked):not(.switch--disabled) .switch__input:focus-visible ~ .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Checked */
  .switch--checked .switch__control {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch--checked .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    translate: calc((var(--width) - var(--height)) / 2);
  }

  /* Checked + hover */
  .switch.switch--checked:not(.switch--disabled) .switch__control:hover {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch.switch--checked:not(.switch--disabled) .switch__control:hover .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
  }

  /* Checked + focus */
  .switch.switch--checked:not(.switch--disabled) .switch__input:focus-visible ~ .switch__control {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch.switch--checked:not(.switch--disabled) .switch__input:focus-visible ~ .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Disabled */
  .switch--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .switch__label {
    display: inline-block;
    line-height: var(--height);
    margin-inline-start: 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }

  :host([required]) .switch__label::after {
    content: var(--sl-input-required-content);
    color: var(--sl-input-required-content-color);
    margin-inline-start: var(--sl-input-required-content-offset);
  }

  @media (forced-colors: active) {
    .switch.switch--checked:not(.switch--disabled) .switch__control:hover .switch__thumb,
    .switch--checked .switch__control .switch__thumb {
      background-color: ButtonText;
    }
  }
`;















var $8ff58c417f9ffca2$export$8d28b91bbbe13ef5 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $6aba7ae81ba45aa2$export$43da334182d34ab4)(this, {
            value: (control)=>control.checked ? control.value || "on" : void 0,
            defaultValue: (control)=>control.defaultChecked,
            setValue: (control, checked)=>control.checked = checked
        });
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "help-text");
        this.hasFocus = false;
        this.title = "";
        this.name = "";
        this.size = "medium";
        this.disabled = false;
        this.checked = false;
        this.defaultChecked = false;
        this.form = "";
        this.required = false;
        this.helpText = "";
    }
    /** Gets the validity state object */ get validity() {
        return this.input.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.input.validationMessage;
    }
    firstUpdated() {
        this.formControlController.updateValidity();
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleInput() {
        this.emit("sl-input");
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    handleClick() {
        this.checked = !this.checked;
        this.emit("sl-change");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleKeyDown(event) {
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            this.checked = false;
            this.emit("sl-change");
            this.emit("sl-input");
        }
        if (event.key === "ArrowRight") {
            event.preventDefault();
            this.checked = true;
            this.emit("sl-change");
            this.emit("sl-input");
        }
    }
    handleCheckedChange() {
        this.input.checked = this.checked;
        this.formControlController.updateValidity();
    }
    handleDisabledChange() {
        this.formControlController.setValidity(true);
    }
    /** Simulates a click on the switch. */ click() {
        this.input.click();
    }
    /** Sets focus on the switch. */ focus(options) {
        this.input.focus(options);
    }
    /** Removes focus from the switch. */ blur() {
        this.input.blur();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.input.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        return this.input.reportValidity();
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        this.input.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    render() {
        const hasHelpTextSlot = this.hasSlotController.test("help-text");
        const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "form-control": true,
            "form-control--small": this.size === "small",
            "form-control--medium": this.size === "medium",
            "form-control--large": this.size === "large",
            "form-control--has-help-text": hasHelpText
        })}
      >
        <label
          part="base"
          class=${(0, $4930586706e2a706$export$56cc687933817664)({
            switch: true,
            "switch--checked": this.checked,
            "switch--disabled": this.disabled,
            "switch--focused": this.hasFocus,
            "switch--small": this.size === "small",
            "switch--medium": this.size === "medium",
            "switch--large": this.size === "large"
        })}
        >
          <input
            class="switch__input"
            type="checkbox"
            title=${this.title}
            name=${this.name}
            value=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.value)}
            .checked=${(0, $9cd948e30340d8e4$export$28cf49ad70f82d12)(this.checked)}
            .disabled=${this.disabled}
            .required=${this.required}
            role="switch"
            aria-checked=${this.checked ? "true" : "false"}
            aria-describedby="help-text"
            @click=${this.handleClick}
            @input=${this.handleInput}
            @invalid=${this.handleInvalid}
            @blur=${this.handleBlur}
            @focus=${this.handleFocus}
            @keydown=${this.handleKeyDown}
          />

          <span part="control" class="switch__control">
            <span part="thumb" class="switch__thumb"></span>
          </span>

          <div part="label" class="switch__label">
            <slot></slot>
          </div>
        </label>

        <div
          aria-hidden=${hasHelpText ? "false" : "true"}
          class="form-control__help-text"
          id="help-text"
          part="form-control-help-text"
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
    }
};
$8ff58c417f9ffca2$export$8d28b91bbbe13ef5.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $5650ed14ec96c2a3$export$e7c8528c268605e9),
    (0, $ec110f7d215ad6b3$export$14e2900f6ef79e2b)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)('input[type="checkbox"]')
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "input", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "hasFocus", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "title", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "name", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "size", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "checked", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $66d37a8d1e916a65$export$1a01ae0705bafd37)("checked")
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "defaultChecked", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "form", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "required", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "help-text"
    })
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "helpText", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("checked", {
        waitUntilFirstUpdate: true
    })
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "handleCheckedChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $8ff58c417f9ffca2$export$8d28b91bbbe13ef5.prototype, "handleDisabledChange", 1);


// src/components/switch/switch.ts
var $ad1d751d4e6941fa$export$fc15fde3b71d3684 = (0, $8ff58c417f9ffca2$export$8d28b91bbbe13ef5);
(0, $8ff58c417f9ffca2$export$8d28b91bbbe13ef5).define("sl-switch");





// src/components/resize-observer/resize-observer.ts
var $f0c8d93007bab76f$export$eca24c9dad93d45d = (0, $dcfe5c7a146db538$export$18010baf851c8702);
(0, $dcfe5c7a146db538$export$18010baf851c8702).define("sl-resize-observer");



// src/components/select/select.styles.ts

var $4ffbf7f8d2208846$export$274f1404b977345b = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  /** The popup */
  .select {
    flex: 1 1 auto;
    display: inline-flex;
    width: 100%;
    position: relative;
    vertical-align: middle;
  }

  .select::part(popup) {
    z-index: var(--sl-z-index-dropdown);
  }

  .select[data-current-placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .select[data-current-placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  /* Combobox */
  .select__combobox {
    flex: 1;
    display: flex;
    width: 100%;
    min-width: 0;
    position: relative;
    align-items: center;
    justify-content: start;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    letter-spacing: var(--sl-input-letter-spacing);
    vertical-align: middle;
    overflow: hidden;
    cursor: pointer;
    transition:
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) border,
      var(--sl-transition-fast) box-shadow,
      var(--sl-transition-fast) background-color;
  }

  .select__display-input {
    position: relative;
    width: 100%;
    font: inherit;
    border: none;
    background: none;
    color: var(--sl-input-color);
    cursor: inherit;
    overflow: hidden;
    padding: 0;
    margin: 0;
    -webkit-appearance: none;
  }

  .select__display-input::placeholder {
    color: var(--sl-input-placeholder-color);
  }

  .select:not(.select--disabled):hover .select__display-input {
    color: var(--sl-input-color-hover);
  }

  .select__display-input:focus {
    outline: none;
  }

  /* Visually hide the display input when multiple is enabled */
  .select--multiple:not(.select--placeholder-visible) .select__display-input {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .select__value-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    opacity: 0;
    z-index: -1;
  }

  .select__tags {
    display: flex;
    flex: 1;
    align-items: center;
    flex-wrap: wrap;
    margin-inline-start: var(--sl-spacing-2x-small);
  }

  .select__tags::slotted(sl-tag) {
    cursor: pointer !important;
  }

  .select--disabled .select__tags,
  .select--disabled .select__tags::slotted(sl-tag) {
    cursor: not-allowed !important;
  }

  /* Standard selects */
  .select--standard .select__combobox {
    background-color: var(--sl-input-background-color);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
  }

  .select--standard.select--disabled .select__combobox {
    background-color: var(--sl-input-background-color-disabled);
    border-color: var(--sl-input-border-color-disabled);
    color: var(--sl-input-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
    outline: none;
  }

  .select--standard:not(.select--disabled).select--open .select__combobox,
  .select--standard:not(.select--disabled).select--focused .select__combobox {
    background-color: var(--sl-input-background-color-focus);
    border-color: var(--sl-input-border-color-focus);
    box-shadow: 0 0 0 var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
  }

  /* Filled selects */
  .select--filled .select__combobox {
    border: none;
    background-color: var(--sl-input-filled-background-color);
    color: var(--sl-input-color);
  }

  .select--filled:hover:not(.select--disabled) .select__combobox {
    background-color: var(--sl-input-filled-background-color-hover);
  }

  .select--filled.select--disabled .select__combobox {
    background-color: var(--sl-input-filled-background-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .select--filled:not(.select--disabled).select--open .select__combobox,
  .select--filled:not(.select--disabled).select--focused .select__combobox {
    background-color: var(--sl-input-filled-background-color-focus);
    outline: var(--sl-focus-ring);
  }

  /* Sizes */
  .select--small .select__combobox {
    border-radius: var(--sl-input-border-radius-small);
    font-size: var(--sl-input-font-size-small);
    min-height: var(--sl-input-height-small);
    padding-block: 0;
    padding-inline: var(--sl-input-spacing-small);
  }

  .select--small .select__clear {
    margin-inline-start: var(--sl-input-spacing-small);
  }

  .select--small .select__prefix::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-small);
  }

  .select--small.select--multiple:not(.select--placeholder-visible) .select__prefix::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-small);
  }

  .select--small.select--multiple:not(.select--placeholder-visible) .select__combobox {
    padding-block: 2px;
    padding-inline-start: 0;
  }

  .select--small .select__tags {
    gap: 2px;
  }

  .select--medium .select__combobox {
    border-radius: var(--sl-input-border-radius-medium);
    font-size: var(--sl-input-font-size-medium);
    min-height: var(--sl-input-height-medium);
    padding-block: 0;
    padding-inline: var(--sl-input-spacing-medium);
  }

  .select--medium .select__clear {
    margin-inline-start: var(--sl-input-spacing-medium);
  }

  .select--medium .select__prefix::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-medium);
  }

  .select--medium.select--multiple:not(.select--placeholder-visible) .select__prefix::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-medium);
  }

  .select--medium.select--multiple:not(.select--placeholder-visible) .select__combobox {
    padding-inline-start: 0;
    padding-block: 3px;
  }

  .select--medium .select__tags {
    gap: 3px;
  }

  .select--large .select__combobox {
    border-radius: var(--sl-input-border-radius-large);
    font-size: var(--sl-input-font-size-large);
    min-height: var(--sl-input-height-large);
    padding-block: 0;
    padding-inline: var(--sl-input-spacing-large);
  }

  .select--large .select__clear {
    margin-inline-start: var(--sl-input-spacing-large);
  }

  .select--large .select__prefix::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-large);
  }

  .select--large.select--multiple:not(.select--placeholder-visible) .select__prefix::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-large);
  }

  .select--large.select--multiple:not(.select--placeholder-visible) .select__combobox {
    padding-inline-start: 0;
    padding-block: 4px;
  }

  .select--large .select__tags {
    gap: 4px;
  }

  /* Pills */
  .select--pill.select--small .select__combobox {
    border-radius: var(--sl-input-height-small);
  }

  .select--pill.select--medium .select__combobox {
    border-radius: var(--sl-input-height-medium);
  }

  .select--pill.select--large .select__combobox {
    border-radius: var(--sl-input-height-large);
  }

  /* Prefix and Suffix */
  .select__prefix,
  .select__suffix {
    flex: 0;
    display: inline-flex;
    align-items: center;
    color: var(--sl-input-placeholder-color);
  }

  .select__suffix::slotted(*) {
    margin-inline-start: var(--sl-spacing-small);
  }

  /* Clear button */
  .select__clear {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    color: var(--sl-input-icon-color);
    border: none;
    background: none;
    padding: 0;
    transition: var(--sl-transition-fast) color;
    cursor: pointer;
  }

  .select__clear:hover {
    color: var(--sl-input-icon-color-hover);
  }

  .select__clear:focus {
    outline: none;
  }

  /* Expand icon */
  .select__expand-icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    transition: var(--sl-transition-medium) rotate ease;
    rotate: 0;
    margin-inline-start: var(--sl-spacing-small);
  }

  .select--open .select__expand-icon {
    rotate: -180deg;
  }

  /* Listbox */
  .select__listbox {
    display: block;
    position: relative;
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    box-shadow: var(--sl-shadow-large);
    background: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-radius: var(--sl-border-radius-medium);
    padding-block: var(--sl-spacing-x-small);
    padding-inline: 0;
    overflow: auto;
    overscroll-behavior: none;

    /* Make sure it adheres to the popup's auto size */
    max-width: var(--auto-size-available-width);
    max-height: var(--auto-size-available-height);
  }

  .select__listbox ::slotted(sl-divider) {
    --spacing: var(--sl-spacing-x-small);
  }

  .select__listbox ::slotted(small) {
    display: block;
    font-size: var(--sl-font-size-small);
    font-weight: var(--sl-font-weight-semibold);
    color: var(--sl-color-neutral-500);
    padding-block: var(--sl-spacing-2x-small);
    padding-inline: var(--sl-spacing-x-large);
  }
`;





















/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $e4968949aa3f9e55$export$3bebd1f0e3943985 extends (0, $bfc08ae7c1bf655d$export$befdefbdce210f91) {
    constructor(i){
        if (super(i), this.it = (0, $d2b76d366be0d5ac$export$45b790e32b2810ee), i.type !== (0, $bfc08ae7c1bf655d$export$9ba3b3f20a85bfa).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, $d2b76d366be0d5ac$export$45b790e32b2810ee) || null == r) return this._t = void 0, this.it = r;
        if (r === (0, $d2b76d366be0d5ac$export$9c068ae9cc5db4e8)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.it) return this._t;
        this.it = r;
        const s = [
            r
        ];
        return s.raw = s, this._t = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
}
$e4968949aa3f9e55$export$3bebd1f0e3943985.directiveName = "unsafeHTML", $e4968949aa3f9e55$export$3bebd1f0e3943985.resultType = 1;
const $e4968949aa3f9e55$export$b6e69390c23686fb = (0, $bfc08ae7c1bf655d$export$99b43ad1ed32e735)($e4968949aa3f9e55$export$3bebd1f0e3943985);




var $c674962284a4a10c$export$87fe1b79ce9ed4ba = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $6aba7ae81ba45aa2$export$43da334182d34ab4)(this, {
            assumeInteractionOn: [
                "sl-blur",
                "sl-input"
            ]
        });
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "help-text", "label");
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.typeToSelectString = "";
        this.hasFocus = false;
        this.displayLabel = "";
        this.selectedOptions = [];
        this.valueHasChanged = false;
        this.name = "";
        this._value = "";
        this.defaultValue = "";
        this.size = "medium";
        this.placeholder = "";
        this.multiple = false;
        this.maxOptionsVisible = 3;
        this.disabled = false;
        this.clearable = false;
        this.open = false;
        this.hoist = false;
        this.filled = false;
        this.pill = false;
        this.label = "";
        this.placement = "bottom";
        this.helpText = "";
        this.form = "";
        this.required = false;
        this.getTag = (option)=>{
            return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <sl-tag
        part="tag"
        exportparts="
              base:tag__base,
              content:tag__content,
              remove-button:tag__remove-button,
              remove-button__base:tag__remove-button__base
            "
        ?pill=${this.pill}
        size=${this.size}
        removable
        @sl-remove=${(event)=>this.handleTagRemove(event, option)}
      >
        ${option.getTextLabel()}
      </sl-tag>
    `;
        };
        this.handleDocumentFocusIn = (event)=>{
            const path = event.composedPath();
            if (this && !path.includes(this)) this.hide();
        };
        this.handleDocumentKeyDown = (event)=>{
            const target = event.target;
            const isClearButton = target.closest(".select__clear") !== null;
            const isIconButton = target.closest("sl-icon-button") !== null;
            if (isClearButton || isIconButton) return;
            if (event.key === "Escape" && this.open && !this.closeWatcher) {
                event.preventDefault();
                event.stopPropagation();
                this.hide();
                this.displayInput.focus({
                    preventScroll: true
                });
            }
            if (event.key === "Enter" || event.key === " " && this.typeToSelectString === "") {
                event.preventDefault();
                event.stopImmediatePropagation();
                if (!this.open) {
                    this.show();
                    return;
                }
                if (this.currentOption && !this.currentOption.disabled) {
                    this.valueHasChanged = true;
                    if (this.multiple) this.toggleOptionSelection(this.currentOption);
                    else this.setSelectedOptions(this.currentOption);
                    this.updateComplete.then(()=>{
                        this.emit("sl-input");
                        this.emit("sl-change");
                    });
                    if (!this.multiple) {
                        this.hide();
                        this.displayInput.focus({
                            preventScroll: true
                        });
                    }
                }
                return;
            }
            if ([
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End"
            ].includes(event.key)) {
                const allOptions = this.getAllOptions();
                const currentIndex = allOptions.indexOf(this.currentOption);
                let newIndex = Math.max(0, currentIndex);
                event.preventDefault();
                if (!this.open) {
                    this.show();
                    if (this.currentOption) return;
                }
                if (event.key === "ArrowDown") {
                    newIndex = currentIndex + 1;
                    if (newIndex > allOptions.length - 1) newIndex = 0;
                } else if (event.key === "ArrowUp") {
                    newIndex = currentIndex - 1;
                    if (newIndex < 0) newIndex = allOptions.length - 1;
                } else if (event.key === "Home") newIndex = 0;
                else if (event.key === "End") newIndex = allOptions.length - 1;
                this.setCurrentOption(allOptions[newIndex]);
            }
            if (event.key && event.key.length === 1 || event.key === "Backspace") {
                const allOptions = this.getAllOptions();
                if (event.metaKey || event.ctrlKey || event.altKey) return;
                if (!this.open) {
                    if (event.key === "Backspace") return;
                    this.show();
                }
                event.stopPropagation();
                event.preventDefault();
                clearTimeout(this.typeToSelectTimeout);
                this.typeToSelectTimeout = window.setTimeout(()=>this.typeToSelectString = "", 1e3);
                if (event.key === "Backspace") this.typeToSelectString = this.typeToSelectString.slice(0, -1);
                else this.typeToSelectString += event.key.toLowerCase();
                for (const option of allOptions){
                    const label = option.getTextLabel().toLowerCase();
                    if (label.startsWith(this.typeToSelectString)) {
                        this.setCurrentOption(option);
                        break;
                    }
                }
            }
        };
        this.handleDocumentMouseDown = (event)=>{
            const path = event.composedPath();
            if (this && !path.includes(this)) this.hide();
        };
    }
    get value() {
        return this._value;
    }
    set value(val) {
        if (this.multiple) val = Array.isArray(val) ? val : val.split(" ");
        else val = Array.isArray(val) ? val.join(" ") : val;
        if (this._value === val) return;
        this.valueHasChanged = true;
        this._value = val;
    }
    /** Gets the validity state object */ get validity() {
        return this.valueInput.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.valueInput.validationMessage;
    }
    connectedCallback() {
        super.connectedCallback();
        setTimeout(()=>{
            this.handleDefaultSlotChange();
        });
        this.open = false;
    }
    addOpenListeners() {
        var _a;
        document.addEventListener("focusin", this.handleDocumentFocusIn);
        document.addEventListener("keydown", this.handleDocumentKeyDown);
        document.addEventListener("mousedown", this.handleDocumentMouseDown);
        if (this.getRootNode() !== document) this.getRootNode().addEventListener("focusin", this.handleDocumentFocusIn);
        if ("CloseWatcher" in window) {
            (_a = this.closeWatcher) == null || _a.destroy();
            this.closeWatcher = new CloseWatcher();
            this.closeWatcher.onclose = ()=>{
                if (this.open) {
                    this.hide();
                    this.displayInput.focus({
                        preventScroll: true
                    });
                }
            };
        }
    }
    removeOpenListeners() {
        var _a;
        document.removeEventListener("focusin", this.handleDocumentFocusIn);
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
        document.removeEventListener("mousedown", this.handleDocumentMouseDown);
        if (this.getRootNode() !== document) this.getRootNode().removeEventListener("focusin", this.handleDocumentFocusIn);
        (_a = this.closeWatcher) == null || _a.destroy();
    }
    handleFocus() {
        this.hasFocus = true;
        this.displayInput.setSelectionRange(0, 0);
        this.emit("sl-focus");
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleLabelClick() {
        this.displayInput.focus();
    }
    handleComboboxMouseDown(event) {
        const path = event.composedPath();
        const isIconButton = path.some((el)=>el instanceof Element && el.tagName.toLowerCase() === "sl-icon-button");
        if (this.disabled || isIconButton) return;
        event.preventDefault();
        this.displayInput.focus({
            preventScroll: true
        });
        this.open = !this.open;
    }
    handleComboboxKeyDown(event) {
        if (event.key === "Tab") return;
        event.stopPropagation();
        this.handleDocumentKeyDown(event);
    }
    handleClearClick(event) {
        event.stopPropagation();
        this.valueHasChanged = true;
        if (this.value !== "") {
            this.setSelectedOptions([]);
            this.displayInput.focus({
                preventScroll: true
            });
            this.updateComplete.then(()=>{
                this.emit("sl-clear");
                this.emit("sl-input");
                this.emit("sl-change");
            });
        }
    }
    handleClearMouseDown(event) {
        event.stopPropagation();
        event.preventDefault();
    }
    handleOptionClick(event) {
        const target = event.target;
        const option = target.closest("sl-option");
        const oldValue = this.value;
        if (option && !option.disabled) {
            this.valueHasChanged = true;
            if (this.multiple) this.toggleOptionSelection(option);
            else this.setSelectedOptions(option);
            this.updateComplete.then(()=>this.displayInput.focus({
                    preventScroll: true
                }));
            if (this.value !== oldValue) this.updateComplete.then(()=>{
                this.emit("sl-input");
                this.emit("sl-change");
            });
            if (!this.multiple) {
                this.hide();
                this.displayInput.focus({
                    preventScroll: true
                });
            }
        }
    }
    /* @internal - used by options to update labels */ handleDefaultSlotChange() {
        if (!customElements.get("sl-option")) customElements.whenDefined("sl-option").then(()=>this.handleDefaultSlotChange());
        const allOptions = this.getAllOptions();
        const val = this.valueHasChanged ? this.value : this.defaultValue;
        const value = Array.isArray(val) ? val : [
            val
        ];
        const values = [];
        allOptions.forEach((option)=>values.push(option.value));
        this.setSelectedOptions(allOptions.filter((el)=>value.includes(el.value)));
    }
    handleTagRemove(event, option) {
        event.stopPropagation();
        this.valueHasChanged = true;
        if (!this.disabled) {
            this.toggleOptionSelection(option, false);
            this.updateComplete.then(()=>{
                this.emit("sl-input");
                this.emit("sl-change");
            });
        }
    }
    // Gets an array of all <sl-option> elements
    getAllOptions() {
        return [
            ...this.querySelectorAll("sl-option")
        ];
    }
    // Gets the first <sl-option> element
    getFirstOption() {
        return this.querySelector("sl-option");
    }
    // Sets the current option, which is the option the user is currently interacting with (e.g. via keyboard). Only one
    // option may be "current" at a time.
    setCurrentOption(option) {
        const allOptions = this.getAllOptions();
        allOptions.forEach((el)=>{
            el.current = false;
            el.tabIndex = -1;
        });
        if (option) {
            this.currentOption = option;
            option.current = true;
            option.tabIndex = 0;
            option.focus();
        }
    }
    // Sets the selected option(s)
    setSelectedOptions(option) {
        const allOptions = this.getAllOptions();
        const newSelectedOptions = Array.isArray(option) ? option : [
            option
        ];
        allOptions.forEach((el)=>el.selected = false);
        if (newSelectedOptions.length) newSelectedOptions.forEach((el)=>el.selected = true);
        this.selectionChanged();
    }
    // Toggles an option's selected state
    toggleOptionSelection(option, force) {
        if (force === true || force === false) option.selected = force;
        else option.selected = !option.selected;
        this.selectionChanged();
    }
    // This method must be called whenever the selection changes. It will update the selected options cache, the current
    // value, and the display value
    selectionChanged() {
        var _a, _b, _c;
        const options = this.getAllOptions();
        this.selectedOptions = options.filter((el)=>el.selected);
        const cachedValueHasChanged = this.valueHasChanged;
        if (this.multiple) {
            this.value = this.selectedOptions.map((el)=>el.value);
            if (this.placeholder && this.value.length === 0) this.displayLabel = "";
            else this.displayLabel = this.localize.term("numOptionsSelected", this.selectedOptions.length);
        } else {
            const selectedOption = this.selectedOptions[0];
            this.value = (_a = selectedOption == null ? void 0 : selectedOption.value) != null ? _a : "";
            this.displayLabel = (_c = (_b = selectedOption == null ? void 0 : selectedOption.getTextLabel) == null ? void 0 : _b.call(selectedOption)) != null ? _c : "";
        }
        this.valueHasChanged = cachedValueHasChanged;
        this.updateComplete.then(()=>{
            this.formControlController.updateValidity();
        });
    }
    get tags() {
        return this.selectedOptions.map((option, index)=>{
            if (index < this.maxOptionsVisible || this.maxOptionsVisible <= 0) {
                const tag = this.getTag(option, index);
                return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`<div @sl-remove=${(e)=>this.handleTagRemove(e, option)}>
          ${typeof tag === "string" ? (0, $e4968949aa3f9e55$export$b6e69390c23686fb)(tag) : tag}
        </div>`;
            } else if (index === this.maxOptionsVisible) return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`<sl-tag size=${this.size}>+${this.selectedOptions.length - index}</sl-tag>`;
            return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)``;
        });
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    handleDisabledChange() {
        if (this.disabled) {
            this.open = false;
            this.handleOpenChange();
        }
    }
    attributeChangedCallback(name, oldVal, newVal) {
        super.attributeChangedCallback(name, oldVal, newVal);
        if (name === "value") {
            const cachedValueHasChanged = this.valueHasChanged;
            this.value = this.defaultValue;
            this.valueHasChanged = cachedValueHasChanged;
        }
    }
    handleValueChange() {
        if (!this.valueHasChanged) {
            const cachedValueHasChanged = this.valueHasChanged;
            this.value = this.defaultValue;
            this.valueHasChanged = cachedValueHasChanged;
        }
        const allOptions = this.getAllOptions();
        const value = Array.isArray(this.value) ? this.value : [
            this.value
        ];
        this.setSelectedOptions(allOptions.filter((el)=>value.includes(el.value)));
    }
    async handleOpenChange() {
        if (this.open && !this.disabled) {
            this.setCurrentOption(this.selectedOptions[0] || this.getFirstOption());
            this.emit("sl-show");
            this.addOpenListeners();
            await (0, $41facc830b5907b7$export$ad12f740028ccbea)(this);
            this.listbox.hidden = false;
            this.popup.active = true;
            requestAnimationFrame(()=>{
                this.setCurrentOption(this.currentOption);
            });
            const { keyframes: keyframes, options: options } = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "select.show", {
                dir: this.localize.dir()
            });
            await (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.popup.popup, keyframes, options);
            if (this.currentOption) (0, $50a04e78d1030c6e$export$53a0910f038337bd)(this.currentOption, this.listbox, "vertical", "auto");
            this.emit("sl-after-show");
        } else {
            this.emit("sl-hide");
            this.removeOpenListeners();
            await (0, $41facc830b5907b7$export$ad12f740028ccbea)(this);
            const { keyframes: keyframes, options: options } = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "select.hide", {
                dir: this.localize.dir()
            });
            await (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.popup.popup, keyframes, options);
            this.listbox.hidden = true;
            this.popup.active = false;
            this.emit("sl-after-hide");
        }
    }
    /** Shows the listbox. */ async show() {
        if (this.open || this.disabled) {
            this.open = false;
            return void 0;
        }
        this.open = true;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the listbox. */ async hide() {
        if (!this.open || this.disabled) {
            this.open = false;
            return void 0;
        }
        this.open = false;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.valueInput.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        return this.valueInput.reportValidity();
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        this.valueInput.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    /** Sets focus on the control. */ focus(options) {
        this.displayInput.focus(options);
    }
    /** Removes focus from the control. */ blur() {
        this.displayInput.blur();
    }
    render() {
        const hasLabelSlot = this.hasSlotController.test("label");
        const hasHelpTextSlot = this.hasSlotController.test("help-text");
        const hasLabel = this.label ? true : !!hasLabelSlot;
        const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
        const hasClearIcon = this.clearable && !this.disabled && this.value.length > 0;
        const isPlaceholderVisible = this.placeholder && this.value && this.value.length <= 0;
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="form-control"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "form-control": true,
            "form-control--small": this.size === "small",
            "form-control--medium": this.size === "medium",
            "form-control--large": this.size === "large",
            "form-control--has-label": hasLabel,
            "form-control--has-help-text": hasHelpText
        })}
      >
        <label
          id="label"
          part="form-control-label"
          class="form-control__label"
          aria-hidden=${hasLabel ? "false" : "true"}
          @click=${this.handleLabelClick}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <sl-popup
            class=${(0, $4930586706e2a706$export$56cc687933817664)({
            select: true,
            "select--standard": true,
            "select--filled": this.filled,
            "select--pill": this.pill,
            "select--open": this.open,
            "select--disabled": this.disabled,
            "select--multiple": this.multiple,
            "select--focused": this.hasFocus,
            "select--placeholder-visible": isPlaceholderVisible,
            "select--top": this.placement === "top",
            "select--bottom": this.placement === "bottom",
            "select--small": this.size === "small",
            "select--medium": this.size === "medium",
            "select--large": this.size === "large"
        })}
            placement=${this.placement}
            strategy=${this.hoist ? "fixed" : "absolute"}
            flip
            shift
            sync="width"
            auto-size="vertical"
            auto-size-padding="10"
          >
            <div
              part="combobox"
              class="select__combobox"
              slot="anchor"
              @keydown=${this.handleComboboxKeyDown}
              @mousedown=${this.handleComboboxMouseDown}
            >
              <slot part="prefix" name="prefix" class="select__prefix"></slot>

              <input
                part="display-input"
                class="select__display-input"
                type="text"
                placeholder=${this.placeholder}
                .disabled=${this.disabled}
                .value=${this.displayLabel}
                autocomplete="off"
                spellcheck="false"
                autocapitalize="off"
                readonly
                aria-controls="listbox"
                aria-expanded=${this.open ? "true" : "false"}
                aria-haspopup="listbox"
                aria-labelledby="label"
                aria-disabled=${this.disabled ? "true" : "false"}
                aria-describedby="help-text"
                role="combobox"
                tabindex="0"
                @focus=${this.handleFocus}
                @blur=${this.handleBlur}
              />

              ${this.multiple ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`<div part="tags" class="select__tags">${this.tags}</div>` : ""}

              <input
                class="select__value-input"
                type="text"
                ?disabled=${this.disabled}
                ?required=${this.required}
                .value=${Array.isArray(this.value) ? this.value.join(", ") : this.value}
                tabindex="-1"
                aria-hidden="true"
                @focus=${()=>this.focus()}
                @invalid=${this.handleInvalid}
              />

              ${hasClearIcon ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                    <button
                      part="clear-button"
                      class="select__clear"
                      type="button"
                      aria-label=${this.localize.term("clearEntry")}
                      @mousedown=${this.handleClearMouseDown}
                      @click=${this.handleClearClick}
                      tabindex="-1"
                    >
                      <slot name="clear-icon">
                        <sl-icon name="x-circle-fill" library="system"></sl-icon>
                      </slot>
                    </button>
                  ` : ""}

              <slot name="suffix" part="suffix" class="select__suffix"></slot>

              <slot name="expand-icon" part="expand-icon" class="select__expand-icon">
                <sl-icon library="system" name="chevron-down"></sl-icon>
              </slot>
            </div>

            <div
              id="listbox"
              role="listbox"
              aria-expanded=${this.open ? "true" : "false"}
              aria-multiselectable=${this.multiple ? "true" : "false"}
              aria-labelledby="label"
              part="listbox"
              class="select__listbox"
              tabindex="-1"
              @mouseup=${this.handleOptionClick}
              @slotchange=${this.handleDefaultSlotChange}
            >
              <slot></slot>
            </div>
          </sl-popup>
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${hasHelpText ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
    }
};
$c674962284a4a10c$export$87fe1b79ce9ed4ba.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $5650ed14ec96c2a3$export$e7c8528c268605e9),
    (0, $4ffbf7f8d2208846$export$274f1404b977345b)
];
$c674962284a4a10c$export$87fe1b79ce9ed4ba.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441),
    "sl-popup": (0, $2cc723b992cc8b8e$export$6fe469f0a31d1d6e),
    "sl-tag": (0, $c09f028efc3817b7$export$357f67db97e5a412)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".select")
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "popup", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".select__combobox")
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "combobox", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".select__display-input")
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "displayInput", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".select__value-input")
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "valueInput", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".select__listbox")
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "listbox", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "hasFocus", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "displayLabel", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "currentOption", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "selectedOptions", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "valueHasChanged", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "name", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "value", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "value"
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "defaultValue", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "size", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "placeholder", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "multiple", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "max-options-visible",
        type: Number
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "maxOptionsVisible", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "clearable", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "open", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "hoist", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "filled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "pill", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "label", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "placement", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "help-text"
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "helpText", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "form", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "required", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "getTag", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "handleDisabledChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)([
        "defaultValue",
        "value"
    ], {
        waitUntilFirstUpdate: true
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "handleValueChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $c674962284a4a10c$export$87fe1b79ce9ed4ba.prototype, "handleOpenChange", 1);
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("select.show", {
    keyframes: [
        {
            opacity: 0,
            scale: 0.9
        },
        {
            opacity: 1,
            scale: 1
        }
    ],
    options: {
        duration: 100,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("select.hide", {
    keyframes: [
        {
            opacity: 1,
            scale: 1
        },
        {
            opacity: 0,
            scale: 0.9
        }
    ],
    options: {
        duration: 100,
        easing: "ease"
    }
});


// src/components/select/select.ts
var $7fae963eac9f4ce7$export$5f058b6414bc662f = (0, $c674962284a4a10c$export$87fe1b79ce9ed4ba);
(0, $c674962284a4a10c$export$87fe1b79ce9ed4ba).define("sl-select");






// src/components/skeleton/skeleton.styles.ts

var $c1170a9e830cecd4$export$629c2ffa31a95a0d = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --border-radius: var(--sl-border-radius-pill);
    --color: var(--sl-color-neutral-200);
    --sheen-color: var(--sl-color-neutral-300);

    display: block;
    position: relative;
  }

  .skeleton {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 1rem;
  }

  .skeleton__indicator {
    flex: 1 1 auto;
    background: var(--color);
    border-radius: var(--border-radius);
  }

  .skeleton--sheen .skeleton__indicator {
    background: linear-gradient(270deg, var(--sheen-color), var(--color), var(--color), var(--sheen-color));
    background-size: 400% 100%;
    animation: sheen 8s ease-in-out infinite;
  }

  .skeleton--pulse .skeleton__indicator {
    animation: pulse 2s ease-in-out 0.5s infinite;
  }

  /* Forced colors mode */
  @media (forced-colors: active) {
    :host {
      --color: GrayText;
    }
  }

  @keyframes sheen {
    0% {
      background-position: 200% 0;
    }
    to {
      background-position: -200% 0;
    }
  }

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
`;








var $4c212eaa44a20f3d$export$d3b5d44577dfd9a3 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.effect = "none";
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            skeleton: true,
            "skeleton--pulse": this.effect === "pulse",
            "skeleton--sheen": this.effect === "sheen"
        })}
      >
        <div part="indicator" class="skeleton__indicator"></div>
      </div>
    `;
    }
};
$4c212eaa44a20f3d$export$d3b5d44577dfd9a3.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $c1170a9e830cecd4$export$629c2ffa31a95a0d)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $4c212eaa44a20f3d$export$d3b5d44577dfd9a3.prototype, "effect", 2);


// src/components/skeleton/skeleton.ts
var $ff7b8cacf36a97ca$export$17027d85dfcb12a7 = (0, $4c212eaa44a20f3d$export$d3b5d44577dfd9a3);
(0, $4c212eaa44a20f3d$export$d3b5d44577dfd9a3).define("sl-skeleton");




// src/components/range/range.styles.ts

var $6dcf45d462b1eb5d$export$d46e4eabf3cc2fa1 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --thumb-size: 20px;
    --tooltip-offset: 10px;
    --track-color-active: var(--sl-color-neutral-200);
    --track-color-inactive: var(--sl-color-neutral-200);
    --track-active-offset: 0%;
    --track-height: 6px;

    display: block;
  }

  .range {
    position: relative;
  }

  .range__control {
    --percent: 0%;
    -webkit-appearance: none;
    border-radius: 3px;
    width: 100%;
    height: var(--track-height);
    background: transparent;
    line-height: var(--sl-input-height-medium);
    vertical-align: middle;
    margin: 0;

    background-image: linear-gradient(
      to right,
      var(--track-color-inactive) 0%,
      var(--track-color-inactive) min(var(--percent), var(--track-active-offset)),
      var(--track-color-active) min(var(--percent), var(--track-active-offset)),
      var(--track-color-active) max(var(--percent), var(--track-active-offset)),
      var(--track-color-inactive) max(var(--percent), var(--track-active-offset)),
      var(--track-color-inactive) 100%
    );
  }

  .range--rtl .range__control {
    background-image: linear-gradient(
      to left,
      var(--track-color-inactive) 0%,
      var(--track-color-inactive) min(var(--percent), var(--track-active-offset)),
      var(--track-color-active) min(var(--percent), var(--track-active-offset)),
      var(--track-color-active) max(var(--percent), var(--track-active-offset)),
      var(--track-color-inactive) max(var(--percent), var(--track-active-offset)),
      var(--track-color-inactive) 100%
    );
  }

  /* Webkit */
  .range__control::-webkit-slider-runnable-track {
    width: 100%;
    height: var(--track-height);
    border-radius: 3px;
    border: none;
  }

  .range__control::-webkit-slider-thumb {
    border: none;
    width: var(--thumb-size);
    height: var(--thumb-size);
    border-radius: 50%;
    background-color: var(--sl-color-primary-600);
    border: solid var(--sl-input-border-width) var(--sl-color-primary-600);
    -webkit-appearance: none;
    margin-top: calc(var(--thumb-size) / -2 + var(--track-height) / 2);
    cursor: pointer;
  }

  .range__control:enabled::-webkit-slider-thumb:hover {
    background-color: var(--sl-color-primary-500);
    border-color: var(--sl-color-primary-500);
  }

  .range__control:enabled:focus-visible::-webkit-slider-thumb {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .range__control:enabled::-webkit-slider-thumb:active {
    background-color: var(--sl-color-primary-500);
    border-color: var(--sl-color-primary-500);
    cursor: grabbing;
  }

  /* Firefox */
  .range__control::-moz-focus-outer {
    border: 0;
  }

  .range__control::-moz-range-progress {
    background-color: var(--track-color-active);
    border-radius: 3px;
    height: var(--track-height);
  }

  .range__control::-moz-range-track {
    width: 100%;
    height: var(--track-height);
    background-color: var(--track-color-inactive);
    border-radius: 3px;
    border: none;
  }

  .range__control::-moz-range-thumb {
    border: none;
    height: var(--thumb-size);
    width: var(--thumb-size);
    border-radius: 50%;
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    transition:
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) background-color,
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) box-shadow;
    cursor: pointer;
  }

  .range__control:enabled::-moz-range-thumb:hover {
    background-color: var(--sl-color-primary-500);
    border-color: var(--sl-color-primary-500);
  }

  .range__control:enabled:focus-visible::-moz-range-thumb {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .range__control:enabled::-moz-range-thumb:active {
    background-color: var(--sl-color-primary-500);
    border-color: var(--sl-color-primary-500);
    cursor: grabbing;
  }

  /* States */
  .range__control:focus-visible {
    outline: none;
  }

  .range__control:disabled {
    opacity: 0.5;
  }

  .range__control:disabled::-webkit-slider-thumb {
    cursor: not-allowed;
  }

  .range__control:disabled::-moz-range-thumb {
    cursor: not-allowed;
  }

  /* Tooltip output */
  .range__tooltip {
    position: absolute;
    z-index: var(--sl-z-index-tooltip);
    left: 0;
    border-radius: var(--sl-tooltip-border-radius);
    background-color: var(--sl-tooltip-background-color);
    font-family: var(--sl-tooltip-font-family);
    font-size: var(--sl-tooltip-font-size);
    font-weight: var(--sl-tooltip-font-weight);
    line-height: var(--sl-tooltip-line-height);
    color: var(--sl-tooltip-color);
    opacity: 0;
    padding: var(--sl-tooltip-padding);
    transition: var(--sl-transition-fast) opacity;
    pointer-events: none;
  }

  .range__tooltip:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    left: 50%;
    translate: calc(-1 * var(--sl-tooltip-arrow-size));
  }

  .range--tooltip-visible .range__tooltip {
    opacity: 1;
  }

  /* Tooltip on top */
  .range--tooltip-top .range__tooltip {
    top: calc(-1 * var(--thumb-size) - var(--tooltip-offset));
  }

  .range--tooltip-top .range__tooltip:after {
    border-top: var(--sl-tooltip-arrow-size) solid var(--sl-tooltip-background-color);
    border-left: var(--sl-tooltip-arrow-size) solid transparent;
    border-right: var(--sl-tooltip-arrow-size) solid transparent;
    top: 100%;
  }

  /* Tooltip on bottom */
  .range--tooltip-bottom .range__tooltip {
    bottom: calc(-1 * var(--thumb-size) - var(--tooltip-offset));
  }

  .range--tooltip-bottom .range__tooltip:after {
    border-bottom: var(--sl-tooltip-arrow-size) solid var(--sl-tooltip-background-color);
    border-left: var(--sl-tooltip-arrow-size) solid transparent;
    border-right: var(--sl-tooltip-arrow-size) solid transparent;
    bottom: 100%;
  }

  @media (forced-colors: active) {
    .range__control,
    .range__tooltip {
      border: solid 1px transparent;
    }

    .range__control::-webkit-slider-thumb {
      border: solid 1px transparent;
    }

    .range__control::-moz-range-thumb {
      border: solid 1px transparent;
    }

    .range__tooltip:after {
      display: none;
    }
  }
`;
















var $bec934d7a947bbee$export$1dbd104829d9e723 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $6aba7ae81ba45aa2$export$43da334182d34ab4)(this);
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "help-text", "label");
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.hasFocus = false;
        this.hasTooltip = false;
        this.title = "";
        this.name = "";
        this.value = 0;
        this.label = "";
        this.helpText = "";
        this.disabled = false;
        this.min = 0;
        this.max = 100;
        this.step = 1;
        this.tooltip = "top";
        this.tooltipFormatter = (value)=>value.toString();
        this.form = "";
        this.defaultValue = 0;
    }
    /** Gets the validity state object */ get validity() {
        return this.input.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.input.validationMessage;
    }
    connectedCallback() {
        super.connectedCallback();
        this.resizeObserver = new ResizeObserver(()=>this.syncRange());
        if (this.value < this.min) this.value = this.min;
        if (this.value > this.max) this.value = this.max;
        this.updateComplete.then(()=>{
            this.syncRange();
            this.resizeObserver.observe(this.input);
        });
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.resizeObserver) == null || _a.unobserve(this.input);
    }
    handleChange() {
        this.emit("sl-change");
    }
    handleInput() {
        this.value = parseFloat(this.input.value);
        this.emit("sl-input");
        this.syncRange();
    }
    handleBlur() {
        this.hasFocus = false;
        this.hasTooltip = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.hasTooltip = true;
        this.emit("sl-focus");
    }
    handleThumbDragStart() {
        this.hasTooltip = true;
    }
    handleThumbDragEnd() {
        this.hasTooltip = false;
    }
    syncProgress(percent) {
        this.input.style.setProperty("--percent", `${percent * 100}%`);
    }
    syncTooltip(percent) {
        if (this.output !== null) {
            const inputWidth = this.input.offsetWidth;
            const tooltipWidth = this.output.offsetWidth;
            const thumbSize = getComputedStyle(this.input).getPropertyValue("--thumb-size");
            const isRtl = this.localize.dir() === "rtl";
            const percentAsWidth = inputWidth * percent;
            if (isRtl) {
                const x = `${inputWidth - percentAsWidth}px + ${percent} * ${thumbSize}`;
                this.output.style.translate = `calc((${x} - ${tooltipWidth / 2}px - ${thumbSize} / 2))`;
            } else {
                const x = `${percentAsWidth}px - ${percent} * ${thumbSize}`;
                this.output.style.translate = `calc(${x} - ${tooltipWidth / 2}px + ${thumbSize} / 2)`;
            }
        }
    }
    handleValueChange() {
        this.formControlController.updateValidity();
        this.input.value = this.value.toString();
        this.value = parseFloat(this.input.value);
        this.syncRange();
    }
    handleDisabledChange() {
        this.formControlController.setValidity(this.disabled);
    }
    syncRange() {
        const percent = Math.max(0, (this.value - this.min) / (this.max - this.min));
        this.syncProgress(percent);
        if (this.tooltip !== "none" && this.hasTooltip) this.updateComplete.then(()=>this.syncTooltip(percent));
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    /** Sets focus on the range. */ focus(options) {
        this.input.focus(options);
    }
    /** Removes focus from the range. */ blur() {
        this.input.blur();
    }
    /** Increments the value of the range by the value of the step attribute. */ stepUp() {
        this.input.stepUp();
        if (this.value !== Number(this.input.value)) this.value = Number(this.input.value);
    }
    /** Decrements the value of the range by the value of the step attribute. */ stepDown() {
        this.input.stepDown();
        if (this.value !== Number(this.input.value)) this.value = Number(this.input.value);
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.input.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        return this.input.reportValidity();
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        this.input.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    render() {
        const hasLabelSlot = this.hasSlotController.test("label");
        const hasHelpTextSlot = this.hasSlotController.test("help-text");
        const hasLabel = this.label ? true : !!hasLabelSlot;
        const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="form-control"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "form-control": true,
            "form-control--medium": true,
            // range only has one size
            "form-control--has-label": hasLabel,
            "form-control--has-help-text": hasHelpText
        })}
      >
        <label
          part="form-control-label"
          class="form-control__label"
          for="input"
          aria-hidden=${hasLabel ? "false" : "true"}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <div
            part="base"
            class=${(0, $4930586706e2a706$export$56cc687933817664)({
            range: true,
            "range--disabled": this.disabled,
            "range--focused": this.hasFocus,
            "range--rtl": this.localize.dir() === "rtl",
            "range--tooltip-visible": this.hasTooltip,
            "range--tooltip-top": this.tooltip === "top",
            "range--tooltip-bottom": this.tooltip === "bottom"
        })}
            @mousedown=${this.handleThumbDragStart}
            @mouseup=${this.handleThumbDragEnd}
            @touchstart=${this.handleThumbDragStart}
            @touchend=${this.handleThumbDragEnd}
          >
            <input
              part="input"
              id="input"
              class="range__control"
              title=${this.title}
              type="range"
              name=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.name)}
              ?disabled=${this.disabled}
              min=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.min)}
              max=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.max)}
              step=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.step)}
              .value=${(0, $9cd948e30340d8e4$export$28cf49ad70f82d12)(this.value.toString())}
              aria-describedby="help-text"
              @change=${this.handleChange}
              @focus=${this.handleFocus}
              @input=${this.handleInput}
              @invalid=${this.handleInvalid}
              @blur=${this.handleBlur}
            />
            ${this.tooltip !== "none" && !this.disabled ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                  <output part="tooltip" class="range__tooltip">
                    ${typeof this.tooltipFormatter === "function" ? this.tooltipFormatter(this.value) : this.value}
                  </output>
                ` : ""}
          </div>
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${hasHelpText ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
    }
};
$bec934d7a947bbee$export$1dbd104829d9e723.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $5650ed14ec96c2a3$export$e7c8528c268605e9),
    (0, $6dcf45d462b1eb5d$export$d46e4eabf3cc2fa1)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".range__control")
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "input", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".range__tooltip")
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "output", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "hasFocus", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "hasTooltip", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "title", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "name", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "label", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "help-text"
    })
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "helpText", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "min", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "max", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "step", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "tooltip", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: false
    })
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "tooltipFormatter", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "form", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $66d37a8d1e916a65$export$1a01ae0705bafd37)()
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "defaultValue", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $8a317031349a1d0f$export$b2b799818fbabcf3)({
        passive: true
    })
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "handleThumbDragStart", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("value", {
        waitUntilFirstUpdate: true
    })
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "handleValueChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "handleDisabledChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("hasTooltip", {
        waitUntilFirstUpdate: true
    })
], $bec934d7a947bbee$export$1dbd104829d9e723.prototype, "syncRange", 1);


// src/components/range/range.ts
var $f5d2d4d156d34ff7$export$bea5b9f25fd9fb20 = (0, $bec934d7a947bbee$export$1dbd104829d9e723);
(0, $bec934d7a947bbee$export$1dbd104829d9e723).define("sl-range");


// src/components/rating/rating.styles.ts

var $7b22bea5e3760961$export$dfb61e759eafb626 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --symbol-color: var(--sl-color-neutral-300);
    --symbol-color-active: var(--sl-color-amber-500);
    --symbol-size: 1.2rem;
    --symbol-spacing: var(--sl-spacing-3x-small);

    display: inline-flex;
  }

  .rating {
    position: relative;
    display: inline-flex;
    border-radius: var(--sl-border-radius-medium);
    vertical-align: middle;
  }

  .rating:focus {
    outline: none;
  }

  .rating:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .rating__symbols {
    display: inline-flex;
    position: relative;
    font-size: var(--symbol-size);
    line-height: 0;
    color: var(--symbol-color);
    white-space: nowrap;
    cursor: pointer;
  }

  .rating__symbols > * {
    padding: var(--symbol-spacing);
  }

  .rating__symbol--active,
  .rating__partial--filled {
    color: var(--symbol-color-active);
  }

  .rating__partial-symbol-container {
    position: relative;
  }

  .rating__partial--filled {
    position: absolute;
    top: var(--symbol-spacing);
    left: var(--symbol-spacing);
  }

  .rating__symbol {
    transition: var(--sl-transition-fast) scale;
    pointer-events: none;
  }

  .rating__symbol--hover {
    scale: 1.2;
  }

  .rating--disabled .rating__symbols,
  .rating--readonly .rating__symbols {
    cursor: default;
  }

  .rating--disabled .rating__symbol--hover,
  .rating--readonly .rating__symbol--hover {
    scale: none;
  }

  .rating--disabled {
    opacity: 0.5;
  }

  .rating--disabled .rating__symbols {
    cursor: not-allowed;
  }

  /* Forced colors mode */
  @media (forced-colors: active) {
    .rating__symbol--active {
      color: SelectedItem;
    }
  }
`;














/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $75c977654b2136c5$var$n = "important", $75c977654b2136c5$var$i = " !" + $75c977654b2136c5$var$n, $75c977654b2136c5$export$1e5b4ce2fa884e6a = (0, $bfc08ae7c1bf655d$export$99b43ad1ed32e735)(class extends (0, $bfc08ae7c1bf655d$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $bfc08ae7c1bf655d$export$9ba3b3f20a85bfa).ATTRIBUTE || "style" !== t.name || t.strings?.length > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ft) return this.ft = new Set(Object.keys(r)), this.render(r);
        for (const t of this.ft)null == r[t] && (this.ft.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = null);
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ft.add(t);
                const r = "string" == typeof e && e.endsWith($75c977654b2136c5$var$i);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $75c977654b2136c5$var$n : "") : s[t] = e;
            }
        }
        return 0, $d2b76d366be0d5ac$export$9c068ae9cc5db4e8;
    }
});





var $887da8611980d178$export$d884b6fe0c91b9d5 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.hoverValue = 0;
        this.isHovering = false;
        this.label = "";
        this.value = 0;
        this.max = 5;
        this.precision = 1;
        this.readonly = false;
        this.disabled = false;
        this.getSymbol = ()=>'<sl-icon name="star-fill" library="system"></sl-icon>';
    }
    getValueFromMousePosition(event) {
        return this.getValueFromXCoordinate(event.clientX);
    }
    getValueFromTouchPosition(event) {
        return this.getValueFromXCoordinate(event.touches[0].clientX);
    }
    getValueFromXCoordinate(coordinate) {
        const isRtl = this.localize.dir() === "rtl";
        const { left: left, right: right, width: width } = this.rating.getBoundingClientRect();
        const value = isRtl ? this.roundToPrecision((right - coordinate) / width * this.max, this.precision) : this.roundToPrecision((coordinate - left) / width * this.max, this.precision);
        return (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(value, 0, this.max);
    }
    handleClick(event) {
        if (this.disabled) return;
        this.setValue(this.getValueFromMousePosition(event));
        this.emit("sl-change");
    }
    setValue(newValue) {
        if (this.disabled || this.readonly) return;
        this.value = newValue === this.value ? 0 : newValue;
        this.isHovering = false;
    }
    handleKeyDown(event) {
        const isLtr = this.localize.dir() === "ltr";
        const isRtl = this.localize.dir() === "rtl";
        const oldValue = this.value;
        if (this.disabled || this.readonly) return;
        if (event.key === "ArrowDown" || isLtr && event.key === "ArrowLeft" || isRtl && event.key === "ArrowRight") {
            const decrement = event.shiftKey ? 1 : this.precision;
            this.value = Math.max(0, this.value - decrement);
            event.preventDefault();
        }
        if (event.key === "ArrowUp" || isLtr && event.key === "ArrowRight" || isRtl && event.key === "ArrowLeft") {
            const increment = event.shiftKey ? 1 : this.precision;
            this.value = Math.min(this.max, this.value + increment);
            event.preventDefault();
        }
        if (event.key === "Home") {
            this.value = 0;
            event.preventDefault();
        }
        if (event.key === "End") {
            this.value = this.max;
            event.preventDefault();
        }
        if (this.value !== oldValue) this.emit("sl-change");
    }
    handleMouseEnter(event) {
        this.isHovering = true;
        this.hoverValue = this.getValueFromMousePosition(event);
    }
    handleMouseMove(event) {
        this.hoverValue = this.getValueFromMousePosition(event);
    }
    handleMouseLeave() {
        this.isHovering = false;
    }
    handleTouchStart(event) {
        this.isHovering = true;
        this.hoverValue = this.getValueFromTouchPosition(event);
        event.preventDefault();
    }
    handleTouchMove(event) {
        this.hoverValue = this.getValueFromTouchPosition(event);
    }
    handleTouchEnd(event) {
        this.isHovering = false;
        this.setValue(this.hoverValue);
        this.emit("sl-change");
        event.preventDefault();
    }
    roundToPrecision(numberToRound, precision = 0.5) {
        const multiplier = 1 / precision;
        return Math.ceil(numberToRound * multiplier) / multiplier;
    }
    handleHoverValueChange() {
        this.emit("sl-hover", {
            detail: {
                phase: "move",
                value: this.hoverValue
            }
        });
    }
    handleIsHoveringChange() {
        this.emit("sl-hover", {
            detail: {
                phase: this.isHovering ? "start" : "end",
                value: this.hoverValue
            }
        });
    }
    /** Sets focus on the rating. */ focus(options) {
        this.rating.focus(options);
    }
    /** Removes focus from the rating. */ blur() {
        this.rating.blur();
    }
    render() {
        const isRtl = this.localize.dir() === "rtl";
        const counter = Array.from(Array(this.max).keys());
        let displayValue = 0;
        if (this.disabled || this.readonly) displayValue = this.value;
        else displayValue = this.isHovering ? this.hoverValue : this.value;
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            rating: true,
            "rating--readonly": this.readonly,
            "rating--disabled": this.disabled,
            "rating--rtl": isRtl
        })}
        role="slider"
        aria-label=${this.label}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-readonly=${this.readonly ? "true" : "false"}
        aria-valuenow=${this.value}
        aria-valuemin=${0}
        aria-valuemax=${this.max}
        tabindex=${this.disabled || this.readonly ? "-1" : "0"}
        @click=${this.handleClick}
        @keydown=${this.handleKeyDown}
        @mouseenter=${this.handleMouseEnter}
        @touchstart=${this.handleTouchStart}
        @mouseleave=${this.handleMouseLeave}
        @touchend=${this.handleTouchEnd}
        @mousemove=${this.handleMouseMove}
        @touchmove=${this.handleTouchMove}
      >
        <span class="rating__symbols">
          ${counter.map((index)=>{
            if (displayValue > index && displayValue < index + 1) return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                <span
                  class=${(0, $4930586706e2a706$export$56cc687933817664)({
                rating__symbol: true,
                "rating__partial-symbol-container": true,
                "rating__symbol--hover": this.isHovering && Math.ceil(displayValue) === index + 1
            })}
                  role="presentation"
                >
                  <div
                    style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
                clipPath: isRtl ? `inset(0 ${(displayValue - index) * 100}% 0 0)` : `inset(0 0 0 ${(displayValue - index) * 100}%)`
            })}
                  >
                    ${(0, $e4968949aa3f9e55$export$b6e69390c23686fb)(this.getSymbol(index + 1))}
                  </div>
                  <div
                    class="rating__partial--filled"
                    style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
                clipPath: isRtl ? `inset(0 0 0 ${100 - (displayValue - index) * 100}%)` : `inset(0 ${100 - (displayValue - index) * 100}% 0 0)`
            })}
                  >
                    ${(0, $e4968949aa3f9e55$export$b6e69390c23686fb)(this.getSymbol(index + 1))}
                  </div>
                </span>
              `;
            return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <span
                class=${(0, $4930586706e2a706$export$56cc687933817664)({
                rating__symbol: true,
                "rating__symbol--hover": this.isHovering && Math.ceil(displayValue) === index + 1,
                "rating__symbol--active": displayValue >= index + 1
            })}
                role="presentation"
              >
                ${(0, $e4968949aa3f9e55$export$b6e69390c23686fb)(this.getSymbol(index + 1))}
              </span>
            `;
        })}
        </span>
      </div>
    `;
    }
};
$887da8611980d178$export$d884b6fe0c91b9d5.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $7b22bea5e3760961$export$dfb61e759eafb626)
];
$887da8611980d178$export$d884b6fe0c91b9d5.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".rating")
], $887da8611980d178$export$d884b6fe0c91b9d5.prototype, "rating", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $887da8611980d178$export$d884b6fe0c91b9d5.prototype, "hoverValue", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $887da8611980d178$export$d884b6fe0c91b9d5.prototype, "isHovering", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $887da8611980d178$export$d884b6fe0c91b9d5.prototype, "label", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $887da8611980d178$export$d884b6fe0c91b9d5.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $887da8611980d178$export$d884b6fe0c91b9d5.prototype, "max", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $887da8611980d178$export$d884b6fe0c91b9d5.prototype, "precision", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $887da8611980d178$export$d884b6fe0c91b9d5.prototype, "readonly", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $887da8611980d178$export$d884b6fe0c91b9d5.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $887da8611980d178$export$d884b6fe0c91b9d5.prototype, "getSymbol", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $8a317031349a1d0f$export$b2b799818fbabcf3)({
        passive: true
    })
], $887da8611980d178$export$d884b6fe0c91b9d5.prototype, "handleTouchMove", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("hoverValue")
], $887da8611980d178$export$d884b6fe0c91b9d5.prototype, "handleHoverValueChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("isHovering")
], $887da8611980d178$export$d884b6fe0c91b9d5.prototype, "handleIsHoveringChange", 1);


// src/components/rating/rating.ts
var $e7dc773c43c5ed10$export$51353f988cd783c2 = (0, $887da8611980d178$export$d884b6fe0c91b9d5);
(0, $887da8611980d178$export$d884b6fe0c91b9d5).define("sl-rating");









var $3a30e6fa0cc9810c$var$availableUnits = [
    {
        max: 276e4,
        value: 6e4,
        unit: "minute"
    },
    // max 46 minutes
    {
        max: 72e6,
        value: 36e5,
        unit: "hour"
    },
    // max 20 hours
    {
        max: 5184e5,
        value: 864e5,
        unit: "day"
    },
    // max 6 days
    {
        max: 24192e5,
        value: 6048e5,
        unit: "week"
    },
    // max 28 days
    {
        max: 28512e6,
        value: 2592e6,
        unit: "month"
    },
    // max 11 months
    {
        max: Infinity,
        value: 31536e6,
        unit: "year"
    }
];
var $3a30e6fa0cc9810c$export$ba5dcfa293c1b66d = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.isoTime = "";
        this.relativeTime = "";
        this.date = /* @__PURE__ */ new Date();
        this.format = "long";
        this.numeric = "auto";
        this.sync = false;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        clearTimeout(this.updateTimeout);
    }
    render() {
        const now = /* @__PURE__ */ new Date();
        const then = new Date(this.date);
        if (isNaN(then.getMilliseconds())) {
            this.relativeTime = "";
            this.isoTime = "";
            return "";
        }
        const diff = then.getTime() - now.getTime();
        const { unit: unit, value: value } = $3a30e6fa0cc9810c$var$availableUnits.find((singleUnit)=>Math.abs(diff) < singleUnit.max);
        this.isoTime = then.toISOString();
        this.relativeTime = this.localize.relativeTime(Math.round(diff / value), unit, {
            numeric: this.numeric,
            style: this.format
        });
        clearTimeout(this.updateTimeout);
        if (this.sync) {
            let nextInterval;
            if (unit === "minute") nextInterval = $3a30e6fa0cc9810c$var$getTimeUntilNextUnit("second");
            else if (unit === "hour") nextInterval = $3a30e6fa0cc9810c$var$getTimeUntilNextUnit("minute");
            else if (unit === "day") nextInterval = $3a30e6fa0cc9810c$var$getTimeUntilNextUnit("hour");
            else nextInterval = $3a30e6fa0cc9810c$var$getTimeUntilNextUnit("day");
            this.updateTimeout = window.setTimeout(()=>this.requestUpdate(), nextInterval);
        }
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)` <time datetime=${this.isoTime}>${this.relativeTime}</time> `;
    }
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $3a30e6fa0cc9810c$export$ba5dcfa293c1b66d.prototype, "isoTime", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $3a30e6fa0cc9810c$export$ba5dcfa293c1b66d.prototype, "relativeTime", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $3a30e6fa0cc9810c$export$ba5dcfa293c1b66d.prototype, "date", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $3a30e6fa0cc9810c$export$ba5dcfa293c1b66d.prototype, "format", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $3a30e6fa0cc9810c$export$ba5dcfa293c1b66d.prototype, "numeric", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $3a30e6fa0cc9810c$export$ba5dcfa293c1b66d.prototype, "sync", 2);
function $3a30e6fa0cc9810c$var$getTimeUntilNextUnit(unit) {
    const units = {
        second: 1e3,
        minute: 6e4,
        hour: 36e5,
        day: 864e5
    };
    const value = units[unit];
    return value - Date.now() % value;
}


// src/components/relative-time/relative-time.ts
var $d669a650bfada059$export$c1decd7df12d090b = (0, $3a30e6fa0cc9810c$export$ba5dcfa293c1b66d);
(0, $3a30e6fa0cc9810c$export$ba5dcfa293c1b66d).define("sl-relative-time");





// src/components/button/button.styles.ts

var $85a200068eaec012$export$172eea9c07ee1ffd = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
    position: relative;
    width: auto;
    cursor: pointer;
  }

  .button {
    display: inline-flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    border-style: solid;
    border-width: var(--sl-input-border-width);
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-font-weight-semibold);
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    vertical-align: middle;
    padding: 0;
    transition:
      var(--sl-transition-x-fast) background-color,
      var(--sl-transition-x-fast) color,
      var(--sl-transition-x-fast) border,
      var(--sl-transition-x-fast) box-shadow;
    cursor: inherit;
  }

  .button::-moz-focus-inner {
    border: 0;
  }

  .button:focus {
    outline: none;
  }

  .button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* When disabled, prevent mouse events from bubbling up from children */
  .button--disabled * {
    pointer-events: none;
  }

  .button__prefix,
  .button__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .button__label {
    display: inline-block;
  }

  .button__label::slotted(sl-icon) {
    vertical-align: -2px;
  }

  /*
   * Standard buttons
   */

  /* Default */
  .button--standard.button--default {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-input-border-color);
    color: var(--sl-color-neutral-700);
  }

  .button--standard.button--default:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-50);
    border-color: var(--sl-color-primary-300);
    color: var(--sl-color-primary-700);
  }

  .button--standard.button--default:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-100);
    border-color: var(--sl-color-primary-400);
    color: var(--sl-color-primary-700);
  }

  /* Primary */
  .button--standard.button--primary {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-500);
    border-color: var(--sl-color-primary-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--standard.button--success {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:hover:not(.button--disabled) {
    background-color: var(--sl-color-success-500);
    border-color: var(--sl-color-success-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:active:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--standard.button--neutral {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:hover:not(.button--disabled) {
    background-color: var(--sl-color-neutral-500);
    border-color: var(--sl-color-neutral-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:active:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--standard.button--warning {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }
  .button--standard.button--warning:hover:not(.button--disabled) {
    background-color: var(--sl-color-warning-500);
    border-color: var(--sl-color-warning-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--warning:active:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--standard.button--danger {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:hover:not(.button--disabled) {
    background-color: var(--sl-color-danger-500);
    border-color: var(--sl-color-danger-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:active:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  /*
   * Outline buttons
   */

  .button--outline {
    background: none;
    border: solid 1px;
  }

  /* Default */
  .button--outline.button--default {
    border-color: var(--sl-input-border-color);
    color: var(--sl-color-neutral-700);
  }

  .button--outline.button--default:hover:not(.button--disabled),
  .button--outline.button--default.button--checked:not(.button--disabled) {
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--default:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Primary */
  .button--outline.button--primary {
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-primary-600);
  }

  .button--outline.button--primary:hover:not(.button--disabled),
  .button--outline.button--primary.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--primary:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--outline.button--success {
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-success-600);
  }

  .button--outline.button--success:hover:not(.button--disabled),
  .button--outline.button--success.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--success:active:not(.button--disabled) {
    border-color: var(--sl-color-success-700);
    background-color: var(--sl-color-success-700);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--outline.button--neutral {
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-600);
  }

  .button--outline.button--neutral:hover:not(.button--disabled),
  .button--outline.button--neutral.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--neutral:active:not(.button--disabled) {
    border-color: var(--sl-color-neutral-700);
    background-color: var(--sl-color-neutral-700);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--outline.button--warning {
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-warning-600);
  }

  .button--outline.button--warning:hover:not(.button--disabled),
  .button--outline.button--warning.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--warning:active:not(.button--disabled) {
    border-color: var(--sl-color-warning-700);
    background-color: var(--sl-color-warning-700);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--outline.button--danger {
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-danger-600);
  }

  .button--outline.button--danger:hover:not(.button--disabled),
  .button--outline.button--danger.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--danger:active:not(.button--disabled) {
    border-color: var(--sl-color-danger-700);
    background-color: var(--sl-color-danger-700);
    color: var(--sl-color-neutral-0);
  }

  @media (forced-colors: active) {
    .button.button--outline.button--checked:not(.button--disabled) {
      outline: solid 2px transparent;
    }
  }

  /*
   * Text buttons
   */

  .button--text {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-600);
  }

  .button--text:hover:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:focus-visible:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:active:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-700);
  }

  /*
   * Size modifiers
   */

  .button--small {
    height: auto;
    min-height: var(--sl-input-height-small);
    font-size: var(--sl-button-font-size-small);
    line-height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-small);
  }

  .button--medium {
    height: auto;
    min-height: var(--sl-input-height-medium);
    font-size: var(--sl-button-font-size-medium);
    line-height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-medium);
  }

  .button--large {
    height: auto;
    min-height: var(--sl-input-height-large);
    font-size: var(--sl-button-font-size-large);
    line-height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-large);
  }

  /*
   * Pill modifier
   */

  .button--pill.button--small {
    border-radius: var(--sl-input-height-small);
  }

  .button--pill.button--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .button--pill.button--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Circle modifier
   */

  .button--circle {
    padding-left: 0;
    padding-right: 0;
  }

  .button--circle.button--small {
    width: var(--sl-input-height-small);
    border-radius: 50%;
  }

  .button--circle.button--medium {
    width: var(--sl-input-height-medium);
    border-radius: 50%;
  }

  .button--circle.button--large {
    width: var(--sl-input-height-large);
    border-radius: 50%;
  }

  .button--circle .button__prefix,
  .button--circle .button__suffix,
  .button--circle .button__caret {
    display: none;
  }

  /*
   * Caret modifier
   */

  .button--caret .button__suffix {
    display: none;
  }

  .button--caret .button__caret {
    height: auto;
  }

  /*
   * Loading modifier
   */

  .button--loading {
    position: relative;
    cursor: wait;
  }

  .button--loading .button__prefix,
  .button--loading .button__label,
  .button--loading .button__suffix,
  .button--loading .button__caret {
    visibility: hidden;
  }

  .button--loading sl-spinner {
    --indicator-color: currentColor;
    position: absolute;
    font-size: 1em;
    height: 1em;
    width: 1em;
    top: calc(50% - 0.5em);
    left: calc(50% - 0.5em);
  }

  /*
   * Badges
   */

  .button ::slotted(sl-badge) {
    position: absolute;
    top: 0;
    right: 0;
    translate: 50% -50%;
    pointer-events: none;
  }

  .button--rtl ::slotted(sl-badge) {
    right: auto;
    left: 0;
    translate: -50% -50%;
  }

  /*
   * Button spacing
   */

  .button--has-label.button--small .button__label {
    padding: 0 var(--sl-spacing-small);
  }

  .button--has-label.button--medium .button__label {
    padding: 0 var(--sl-spacing-medium);
  }

  .button--has-label.button--large .button__label {
    padding: 0 var(--sl-spacing-large);
  }

  .button--has-prefix.button--small {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--small .button__label {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--medium {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--medium .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-suffix.button--small,
  .button--caret.button--small {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--small .button__label,
  .button--caret.button--small .button__label {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--medium,
  .button--caret.button--medium {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--medium .button__label,
  .button--caret.button--medium .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large,
  .button--caret.button--large {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large .button__label,
  .button--caret.button--large .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  /*
   * Button groups support a variety of button types (e.g. buttons with tooltips, buttons as dropdown triggers, etc.).
   * This means buttons aren't always direct descendants of the button group, thus we can't target them with the
   * ::slotted selector. To work around this, the button group component does some magic to add these special classes to
   * buttons and we style them here instead.
   */

  :host([data-sl-button-group__button--first]:not([data-sl-button-group__button--last])) .button {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }

  :host([data-sl-button-group__button--inner]) .button {
    border-radius: 0;
  }

  :host([data-sl-button-group__button--last]:not([data-sl-button-group__button--first])) .button {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }

  /* All except the first */
  :host([data-sl-button-group__button]:not([data-sl-button-group__button--first])) {
    margin-inline-start: calc(-1 * var(--sl-input-border-width));
  }

  /* Add a visual separator between solid buttons */
  :host(
      [data-sl-button-group__button]:not(
          [data-sl-button-group__button--first],
          [data-sl-button-group__button--radio],
          [variant='default']
        ):not(:hover)
    )
    .button:after {
    content: '';
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    bottom: 0;
    border-left: solid 1px rgb(128 128 128 / 33%);
    mix-blend-mode: multiply;
  }

  /* Bump hovered, focused, and checked buttons up so their focus ring isn't clipped */
  :host([data-sl-button-group__button--hover]) {
    z-index: 1;
  }

  /* Focus and checked are always on top */
  :host([data-sl-button-group__button--focus]),
  :host([data-sl-button-group__button][checked]) {
    z-index: 2;
  }
`;



var $b3d36e6ad001a9ae$export$b63cf85333bb1d07 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  ${(0, $85a200068eaec012$export$172eea9c07ee1ffd)}

  .button__prefix,
  .button__suffix,
  .button__label {
    display: inline-flex;
    position: relative;
    align-items: center;
  }

  /* We use a hidden input so constraint validation errors work, since they don't appear to show when used with buttons.
    We can't actually hide it, though, otherwise the messages will be suppressed by the browser. */
  .hidden-input {
    all: unset;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    outline: dotted 1px red;
    opacity: 0;
    z-index: -1;
  }
`;











var $f946558c722173b5$export$794c9f1b4d1d5e8f = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "[default]", "prefix", "suffix");
        this.hasFocus = false;
        this.checked = false;
        this.disabled = false;
        this.size = "medium";
        this.pill = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "presentation");
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleClick(e) {
        if (this.disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        this.checked = true;
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleDisabledChange() {
        this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
    }
    /** Sets focus on the radio button. */ focus(options) {
        this.input.focus(options);
    }
    /** Removes focus from the radio button. */ blur() {
        this.input.blur();
    }
    render() {
        return (0, $d4df2e78fcd0ab0d$export$c0bb0b647f701bb5)`
      <div part="base" role="presentation">
        <button
          part="${`button${this.checked ? " button--checked" : ""}`}"
          role="radio"
          aria-checked="${this.checked}"
          class=${(0, $4930586706e2a706$export$56cc687933817664)({
            button: true,
            "button--default": true,
            "button--small": this.size === "small",
            "button--medium": this.size === "medium",
            "button--large": this.size === "large",
            "button--checked": this.checked,
            "button--disabled": this.disabled,
            "button--focused": this.hasFocus,
            "button--outline": true,
            "button--pill": this.pill,
            "button--has-label": this.hasSlotController.test("[default]"),
            "button--has-prefix": this.hasSlotController.test("prefix"),
            "button--has-suffix": this.hasSlotController.test("suffix")
        })}
          aria-disabled=${this.disabled}
          type="button"
          value=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.value)}
          @blur=${this.handleBlur}
          @focus=${this.handleFocus}
          @click=${this.handleClick}
        >
          <slot name="prefix" part="prefix" class="button__prefix"></slot>
          <slot part="label" class="button__label"></slot>
          <slot name="suffix" part="suffix" class="button__suffix"></slot>
        </button>
      </div>
    `;
    }
};
$f946558c722173b5$export$794c9f1b4d1d5e8f.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $b3d36e6ad001a9ae$export$b63cf85333bb1d07)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".button")
], $f946558c722173b5$export$794c9f1b4d1d5e8f.prototype, "input", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".hidden-input")
], $f946558c722173b5$export$794c9f1b4d1d5e8f.prototype, "hiddenInput", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $f946558c722173b5$export$794c9f1b4d1d5e8f.prototype, "hasFocus", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $f946558c722173b5$export$794c9f1b4d1d5e8f.prototype, "checked", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $f946558c722173b5$export$794c9f1b4d1d5e8f.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $f946558c722173b5$export$794c9f1b4d1d5e8f.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $f946558c722173b5$export$794c9f1b4d1d5e8f.prototype, "size", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $f946558c722173b5$export$794c9f1b4d1d5e8f.prototype, "pill", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $f946558c722173b5$export$794c9f1b4d1d5e8f.prototype, "handleDisabledChange", 1);


// src/components/radio-button/radio-button.ts
var $e1317b58761ded2b$export$19890f28c17acaa1 = (0, $f946558c722173b5$export$794c9f1b4d1d5e8f);
(0, $f946558c722173b5$export$794c9f1b4d1d5e8f).define("sl-radio-button");




// src/components/radio-group/radio-group.styles.ts

var $f2f87fc871f8acdc$export$3132e473b9b2813a = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  .form-control {
    position: relative;
    border: none;
    padding: 0;
    margin: 0;
  }

  .form-control__label {
    padding: 0;
  }

  .radio-group--required .radio-group__label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;



// src/components/button-group/button-group.styles.ts

var $39ce00fe312aeb0c$export$72ced8e32474b4fe = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
  }

  .button-group {
    display: flex;
    flex-wrap: nowrap;
  }
`;







var $756c1967426696a0$export$da1d95f84eaf247e = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.disableRole = false;
        this.label = "";
    }
    handleFocus(event) {
        const button = $756c1967426696a0$var$findButton(event.target);
        button == null || button.toggleAttribute("data-sl-button-group__button--focus", true);
    }
    handleBlur(event) {
        const button = $756c1967426696a0$var$findButton(event.target);
        button == null || button.toggleAttribute("data-sl-button-group__button--focus", false);
    }
    handleMouseOver(event) {
        const button = $756c1967426696a0$var$findButton(event.target);
        button == null || button.toggleAttribute("data-sl-button-group__button--hover", true);
    }
    handleMouseOut(event) {
        const button = $756c1967426696a0$var$findButton(event.target);
        button == null || button.toggleAttribute("data-sl-button-group__button--hover", false);
    }
    handleSlotChange() {
        const slottedElements = [
            ...this.defaultSlot.assignedElements({
                flatten: true
            })
        ];
        slottedElements.forEach((el)=>{
            const index = slottedElements.indexOf(el);
            const button = $756c1967426696a0$var$findButton(el);
            if (button) {
                button.toggleAttribute("data-sl-button-group__button", true);
                button.toggleAttribute("data-sl-button-group__button--first", index === 0);
                button.toggleAttribute("data-sl-button-group__button--inner", index > 0 && index < slottedElements.length - 1);
                button.toggleAttribute("data-sl-button-group__button--last", index === slottedElements.length - 1);
                button.toggleAttribute("data-sl-button-group__button--radio", button.tagName.toLowerCase() === "sl-radio-button");
            }
        });
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class="button-group"
        role="${this.disableRole ? "presentation" : "group"}"
        aria-label=${this.label}
        @focusout=${this.handleBlur}
        @focusin=${this.handleFocus}
        @mouseover=${this.handleMouseOver}
        @mouseout=${this.handleMouseOut}
      >
        <slot @slotchange=${this.handleSlotChange}></slot>
      </div>
    `;
    }
};
$756c1967426696a0$export$da1d95f84eaf247e.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $39ce00fe312aeb0c$export$72ced8e32474b4fe)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("slot")
], $756c1967426696a0$export$da1d95f84eaf247e.prototype, "defaultSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $756c1967426696a0$export$da1d95f84eaf247e.prototype, "disableRole", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $756c1967426696a0$export$da1d95f84eaf247e.prototype, "label", 2);
function $756c1967426696a0$var$findButton(el) {
    var _a;
    const selector = "sl-button, sl-radio-button";
    return (_a = el.closest(selector)) != null ? _a : el.querySelector(selector);
}











var $921d5f8dbac65393$export$b359e2a027ddff66 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $6aba7ae81ba45aa2$export$43da334182d34ab4)(this);
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "help-text", "label");
        this.customValidityMessage = "";
        this.hasButtonGroup = false;
        this.errorMessage = "";
        this.defaultValue = "";
        this.label = "";
        this.helpText = "";
        this.name = "option";
        this.value = "";
        this.size = "medium";
        this.form = "";
        this.required = false;
    }
    /** Gets the validity state object */ get validity() {
        const isRequiredAndEmpty = this.required && !this.value;
        const hasCustomValidityMessage = this.customValidityMessage !== "";
        if (hasCustomValidityMessage) return 0, $6aba7ae81ba45aa2$export$d17679f2bc5863d4;
        else if (isRequiredAndEmpty) return 0, $6aba7ae81ba45aa2$export$bd584164a4d1886c;
        return 0, $6aba7ae81ba45aa2$export$6c5960ddf0f5ff89;
    }
    /** Gets the validation message */ get validationMessage() {
        const isRequiredAndEmpty = this.required && !this.value;
        const hasCustomValidityMessage = this.customValidityMessage !== "";
        if (hasCustomValidityMessage) return this.customValidityMessage;
        else if (isRequiredAndEmpty) return this.validationInput.validationMessage;
        return "";
    }
    connectedCallback() {
        super.connectedCallback();
        this.defaultValue = this.value;
    }
    firstUpdated() {
        this.formControlController.updateValidity();
    }
    getAllRadios() {
        return [
            ...this.querySelectorAll("sl-radio, sl-radio-button")
        ];
    }
    handleRadioClick(event) {
        const target = event.target.closest("sl-radio, sl-radio-button");
        const radios = this.getAllRadios();
        const oldValue = this.value;
        if (!target || target.disabled) return;
        this.value = target.value;
        radios.forEach((radio)=>radio.checked = radio === target);
        if (this.value !== oldValue) {
            this.emit("sl-change");
            this.emit("sl-input");
        }
    }
    handleKeyDown(event) {
        var _a;
        if (![
            "ArrowUp",
            "ArrowDown",
            "ArrowLeft",
            "ArrowRight",
            " "
        ].includes(event.key)) return;
        const radios = this.getAllRadios().filter((radio)=>!radio.disabled);
        const checkedRadio = (_a = radios.find((radio)=>radio.checked)) != null ? _a : radios[0];
        const incr = event.key === " " ? 0 : [
            "ArrowUp",
            "ArrowLeft"
        ].includes(event.key) ? -1 : 1;
        const oldValue = this.value;
        let index = radios.indexOf(checkedRadio) + incr;
        if (index < 0) index = radios.length - 1;
        if (index > radios.length - 1) index = 0;
        this.getAllRadios().forEach((radio)=>{
            radio.checked = false;
            if (!this.hasButtonGroup) radio.setAttribute("tabindex", "-1");
        });
        this.value = radios[index].value;
        radios[index].checked = true;
        if (!this.hasButtonGroup) {
            radios[index].setAttribute("tabindex", "0");
            radios[index].focus();
        } else radios[index].shadowRoot.querySelector("button").focus();
        if (this.value !== oldValue) {
            this.emit("sl-change");
            this.emit("sl-input");
        }
        event.preventDefault();
    }
    handleLabelClick() {
        this.focus();
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    async syncRadioElements() {
        var _a, _b;
        const radios = this.getAllRadios();
        await Promise.all(// Sync the checked state and size
        radios.map(async (radio)=>{
            await radio.updateComplete;
            radio.checked = radio.value === this.value;
            radio.size = this.size;
        }));
        this.hasButtonGroup = radios.some((radio)=>radio.tagName.toLowerCase() === "sl-radio-button");
        if (radios.length > 0 && !radios.some((radio)=>radio.checked)) {
            if (this.hasButtonGroup) {
                const buttonRadio = (_a = radios[0].shadowRoot) == null ? void 0 : _a.querySelector("button");
                if (buttonRadio) buttonRadio.setAttribute("tabindex", "0");
            } else radios[0].setAttribute("tabindex", "0");
        }
        if (this.hasButtonGroup) {
            const buttonGroup = (_b = this.shadowRoot) == null ? void 0 : _b.querySelector("sl-button-group");
            if (buttonGroup) buttonGroup.disableRole = true;
        }
    }
    syncRadios() {
        if (customElements.get("sl-radio") && customElements.get("sl-radio-button")) {
            this.syncRadioElements();
            return;
        }
        if (customElements.get("sl-radio")) this.syncRadioElements();
        else customElements.whenDefined("sl-radio").then(()=>this.syncRadios());
        if (customElements.get("sl-radio-button")) this.syncRadioElements();
        else customElements.whenDefined("sl-radio-button").then(()=>this.syncRadios());
    }
    updateCheckedRadio() {
        const radios = this.getAllRadios();
        radios.forEach((radio)=>radio.checked = radio.value === this.value);
        this.formControlController.setValidity(this.validity.valid);
    }
    handleSizeChange() {
        this.syncRadios();
    }
    handleValueChange() {
        if (this.hasUpdated) this.updateCheckedRadio();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        const isRequiredAndEmpty = this.required && !this.value;
        const hasCustomValidityMessage = this.customValidityMessage !== "";
        if (isRequiredAndEmpty || hasCustomValidityMessage) {
            this.formControlController.emitInvalidEvent();
            return false;
        }
        return true;
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        const isValid = this.validity.valid;
        this.errorMessage = this.customValidityMessage || isValid ? "" : this.validationInput.validationMessage;
        this.formControlController.setValidity(isValid);
        this.validationInput.hidden = true;
        clearTimeout(this.validationTimeout);
        if (!isValid) {
            this.validationInput.hidden = false;
            this.validationInput.reportValidity();
            this.validationTimeout = setTimeout(()=>this.validationInput.hidden = true, 1e4);
        }
        return isValid;
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message = "") {
        this.customValidityMessage = message;
        this.errorMessage = message;
        this.validationInput.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    /** Sets focus on the radio-group. */ focus(options) {
        const radios = this.getAllRadios();
        const checked = radios.find((radio)=>radio.checked);
        const firstEnabledRadio = radios.find((radio)=>!radio.disabled);
        const radioToFocus = checked || firstEnabledRadio;
        if (radioToFocus) radioToFocus.focus(options);
    }
    render() {
        const hasLabelSlot = this.hasSlotController.test("label");
        const hasHelpTextSlot = this.hasSlotController.test("help-text");
        const hasLabel = this.label ? true : !!hasLabelSlot;
        const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
        const defaultSlot = (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <slot @slotchange=${this.syncRadios} @click=${this.handleRadioClick} @keydown=${this.handleKeyDown}></slot>
    `;
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <fieldset
        part="form-control"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "form-control": true,
            "form-control--small": this.size === "small",
            "form-control--medium": this.size === "medium",
            "form-control--large": this.size === "large",
            "form-control--radio-group": true,
            "form-control--has-label": hasLabel,
            "form-control--has-help-text": hasHelpText
        })}
        role="radiogroup"
        aria-labelledby="label"
        aria-describedby="help-text"
        aria-errormessage="error-message"
      >
        <label
          part="form-control-label"
          id="label"
          class="form-control__label"
          aria-hidden=${hasLabel ? "false" : "true"}
          @click=${this.handleLabelClick}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <div class="visually-hidden">
            <div id="error-message" aria-live="assertive">${this.errorMessage}</div>
            <label class="radio-group__validation">
              <input
                type="text"
                class="radio-group__validation-input"
                ?required=${this.required}
                tabindex="-1"
                hidden
                @invalid=${this.handleInvalid}
              />
            </label>
          </div>

          ${this.hasButtonGroup ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                <sl-button-group part="button-group" exportparts="base:button-group__base" role="presentation">
                  ${defaultSlot}
                </sl-button-group>
              ` : defaultSlot}
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${hasHelpText ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </fieldset>
    `;
    }
};
$921d5f8dbac65393$export$b359e2a027ddff66.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $5650ed14ec96c2a3$export$e7c8528c268605e9),
    (0, $f2f87fc871f8acdc$export$3132e473b9b2813a)
];
$921d5f8dbac65393$export$b359e2a027ddff66.dependencies = {
    "sl-button-group": (0, $756c1967426696a0$export$da1d95f84eaf247e)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("slot:not([name])")
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "defaultSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".radio-group__validation-input")
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "validationInput", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "hasButtonGroup", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "errorMessage", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "defaultValue", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "label", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "help-text"
    })
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "helpText", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "name", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "size", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "form", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "required", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("size", {
        waitUntilFirstUpdate: true
    })
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "handleSizeChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("value")
], $921d5f8dbac65393$export$b359e2a027ddff66.prototype, "handleValueChange", 1);


// src/components/radio-group/radio-group.ts
var $1da28e72358b2142$export$cb30f4715ae71f77 = (0, $921d5f8dbac65393$export$b359e2a027ddff66);
(0, $921d5f8dbac65393$export$b359e2a027ddff66).define("sl-radio-group");






// src/components/progress-ring/progress-ring.styles.ts

var $8a950ba40c04f071$export$20c62c2693f902dc = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --size: 128px;
    --track-width: 4px;
    --track-color: var(--sl-color-neutral-200);
    --indicator-width: var(--track-width);
    --indicator-color: var(--sl-color-primary-600);
    --indicator-transition-duration: 0.35s;

    display: inline-flex;
  }

  .progress-ring {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .progress-ring__image {
    width: var(--size);
    height: var(--size);
    rotate: -90deg;
    transform-origin: 50% 50%;
  }

  .progress-ring__track,
  .progress-ring__indicator {
    --radius: calc(var(--size) / 2 - max(var(--track-width), var(--indicator-width)) * 0.5);
    --circumference: calc(var(--radius) * 2 * 3.141592654);

    fill: none;
    r: var(--radius);
    cx: calc(var(--size) / 2);
    cy: calc(var(--size) / 2);
  }

  .progress-ring__track {
    stroke: var(--track-color);
    stroke-width: var(--track-width);
  }

  .progress-ring__indicator {
    stroke: var(--indicator-color);
    stroke-width: var(--indicator-width);
    stroke-linecap: round;
    transition-property: stroke-dashoffset;
    transition-duration: var(--indicator-transition-duration);
    stroke-dasharray: var(--circumference) var(--circumference);
    stroke-dashoffset: calc(var(--circumference) - var(--percentage) * var(--circumference));
  }

  .progress-ring__label {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    user-select: none;
    -webkit-user-select: none;
  }
`;








var $6a6a1cc3c45f4667$export$4ad4239debbe5577 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.value = 0;
        this.label = "";
    }
    updated(changedProps) {
        super.updated(changedProps);
        if (changedProps.has("value")) {
            const radius = parseFloat(getComputedStyle(this.indicator).getPropertyValue("r"));
            const circumference = 2 * Math.PI * radius;
            const offset = circumference - this.value / 100 * circumference;
            this.indicatorOffset = `${offset}px`;
        }
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class="progress-ring"
        role="progressbar"
        aria-label=${this.label.length > 0 ? this.label : this.localize.term("progress")}
        aria-describedby="label"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow="${this.value}"
        style="--percentage: ${this.value / 100}"
      >
        <svg class="progress-ring__image">
          <circle class="progress-ring__track"></circle>
          <circle class="progress-ring__indicator" style="stroke-dashoffset: ${this.indicatorOffset}"></circle>
        </svg>

        <slot id="label" part="label" class="progress-ring__label"></slot>
      </div>
    `;
    }
};
$6a6a1cc3c45f4667$export$4ad4239debbe5577.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $8a950ba40c04f071$export$20c62c2693f902dc)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".progress-ring__indicator")
], $6a6a1cc3c45f4667$export$4ad4239debbe5577.prototype, "indicator", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $6a6a1cc3c45f4667$export$4ad4239debbe5577.prototype, "indicatorOffset", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $6a6a1cc3c45f4667$export$4ad4239debbe5577.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $6a6a1cc3c45f4667$export$4ad4239debbe5577.prototype, "label", 2);


// src/components/progress-ring/progress-ring.ts
var $707853668b3fef9c$export$fa4850273913b85a = (0, $6a6a1cc3c45f4667$export$4ad4239debbe5577);
(0, $6a6a1cc3c45f4667$export$4ad4239debbe5577).define("sl-progress-ring");


// src/components/qr-code/qr-code.styles.ts

var $cc22b2491c575b16$export$1fdba7d6424133fe = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
  }
`;









/*
 jquery-qrcode v0.14.0 - https://larsjung.de/jquery-qrcode/ */ 'use strict';
let $bc243d08fb740566$var$G = null;
class $bc243d08fb740566$var$H {
}
$bc243d08fb740566$var$H.render = function(w, B) {
    $bc243d08fb740566$var$G(w, B);
};
self.QrCreator = $bc243d08fb740566$var$H;
(function(w) {
    function B(t, c, a, e) {
        var b = {}, h = w(a, c);
        h.u(t);
        h.J();
        e = e || 0;
        var r = h.h(), d = h.h() + 2 * e;
        b.text = t;
        b.level = c;
        b.version = a;
        b.O = d;
        b.a = function(b, a) {
            b -= e;
            a -= e;
            return 0 > b || b >= r || 0 > a || a >= r ? !1 : h.a(b, a);
        };
        return b;
    }
    function C(t, c, a, e, b, h, r, d, g, x) {
        function u(b, a, f, c, d, r, g) {
            b ? (t.lineTo(a + r, f + g), t.arcTo(a, f, c, d, h)) : t.lineTo(a, f);
        }
        r ? t.moveTo(c + h, a) : t.moveTo(c, a);
        u(d, e, a, e, b, -h, 0);
        u(g, e, b, c, b, 0, -h);
        u(x, c, b, c, a, h, 0);
        u(r, c, a, e, a, 0, h);
    }
    function z(t, c, a, e, b, h, r, d, g, x) {
        function u(b, a, c, d) {
            t.moveTo(b + c, a);
            t.lineTo(b, a);
            t.lineTo(b, a + d);
            t.arcTo(b, a, b + c, a, h);
        }
        r && u(c, a, h, h);
        d && u(e, a, -h, h);
        g && u(e, b, -h, -h);
        x && u(c, b, h, -h);
    }
    function A(t, c) {
        var a = c.fill;
        if ("string" === typeof a) t.fillStyle = a;
        else {
            var e = a.type, b = a.colorStops;
            a = a.position.map((b)=>Math.round(b * c.size));
            if ("linear-gradient" === e) var h = t.createLinearGradient.apply(t, a);
            else if ("radial-gradient" === e) h = t.createRadialGradient.apply(t, a);
            else throw Error("Unsupported fill");
            b.forEach(([b, a])=>{
                h.addColorStop(b, a);
            });
            t.fillStyle = h;
        }
    }
    function y(t, c) {
        a: {
            var a = c.text, e = c.v, b = c.N, h = c.K, r = c.P;
            b = Math.max(1, b || 1);
            for(h = Math.min(40, h || 40); b <= h; b += 1)try {
                var d = B(a, e, b, r);
                break a;
            } catch (J) {}
            d = void 0;
        }
        if (!d) return null;
        a = t.getContext("2d");
        c.background && (a.fillStyle = c.background, a.fillRect(c.left, c.top, c.size, c.size));
        e = d.O;
        h = c.size / e;
        a.beginPath();
        for(r = 0; r < e; r += 1)for(b = 0; b < e; b += 1){
            var g = a, x = c.left + b * h, u = c.top + r * h, p = r, q = b, f = d.a, k = x + h, m = u + h, D = p - 1, E = p + 1, n = q - 1, l = q + 1, y = Math.floor(Math.min(.5, Math.max(0, c.R)) * h), v = f(p, q), I = f(D, n), w = f(D, q);
            D = f(D, l);
            var F = f(p, l);
            l = f(E, l);
            q = f(E, q);
            E = f(E, n);
            p = f(p, n);
            x = Math.round(x);
            u = Math.round(u);
            k = Math.round(k);
            m = Math.round(m);
            v ? C(g, x, u, k, m, y, !w && !p, !w && !F, !q && !F, !q && !p) : z(g, x, u, k, m, y, w && p && I, w && F && D, q && F && l, q && p && E);
        }
        A(a, c);
        a.fill();
        return t;
    }
    var v = {
        minVersion: 1,
        maxVersion: 40,
        ecLevel: "L",
        left: 0,
        top: 0,
        size: 200,
        fill: "#000",
        background: null,
        text: "no text",
        radius: .5,
        quiet: 0
    };
    $bc243d08fb740566$var$G = function(t, c) {
        var a = {};
        Object.assign(a, v, t);
        a.N = a.minVersion;
        a.K = a.maxVersion;
        a.v = a.ecLevel;
        a.left = a.left;
        a.top = a.top;
        a.size = a.size;
        a.fill = a.fill;
        a.background = a.background;
        a.text = a.text;
        a.R = a.radius;
        a.P = a.quiet;
        if (c instanceof HTMLCanvasElement) {
            if (c.width !== a.size || c.height !== a.size) c.width = a.size, c.height = a.size;
            c.getContext("2d").clearRect(0, 0, c.width, c.height);
            y(c, a);
        } else t = document.createElement("canvas"), t.width = a.size, t.height = a.size, a = y(t, a), c.appendChild(a);
    };
})(function() {
    function w(c) {
        var a = C.s(c);
        return {
            S: function() {
                return 4;
            },
            b: function() {
                return a.length;
            },
            write: function(c) {
                for(var b = 0; b < a.length; b += 1)c.put(a[b], 8);
            }
        };
    }
    function B() {
        var c = [], a = 0, e = {
            B: function() {
                return c;
            },
            c: function(b) {
                return 1 == (c[Math.floor(b / 8)] >>> 7 - b % 8 & 1);
            },
            put: function(b, h) {
                for(var a = 0; a < h; a += 1)e.m(1 == (b >>> h - a - 1 & 1));
            },
            f: function() {
                return a;
            },
            m: function(b) {
                var h = Math.floor(a / 8);
                c.length <= h && c.push(0);
                b && (c[h] |= 128 >>> a % 8);
                a += 1;
            }
        };
        return e;
    }
    function C(c, a) {
        function e(b, h) {
            for(var a = -1; 7 >= a; a += 1)if (!(-1 >= b + a || d <= b + a)) for(var c = -1; 7 >= c; c += 1)-1 >= h + c || d <= h + c || (r[b + a][h + c] = 0 <= a && 6 >= a && (0 == c || 6 == c) || 0 <= c && 6 >= c && (0 == a || 6 == a) || 2 <= a && 4 >= a && 2 <= c && 4 >= c ? !0 : !1);
        }
        function b(b, a) {
            for(var f = d = 4 * c + 17, k = Array(f), m = 0; m < f; m += 1){
                k[m] = Array(f);
                for(var p = 0; p < f; p += 1)k[m][p] = null;
            }
            r = k;
            e(0, 0);
            e(d - 7, 0);
            e(0, d - 7);
            f = y.G(c);
            for(k = 0; k < f.length; k += 1)for(m = 0; m < f.length; m += 1){
                p = f[k];
                var q = f[m];
                if (null == r[p][q]) for(var n = -2; 2 >= n; n += 1)for(var l = -2; 2 >= l; l += 1)r[p + n][q + l] = -2 == n || 2 == n || -2 == l || 2 == l || 0 == n && 0 == l;
            }
            for(f = 8; f < d - 8; f += 1)null == r[f][6] && (r[f][6] = 0 == f % 2);
            for(f = 8; f < d - 8; f += 1)null == r[6][f] && (r[6][f] = 0 == f % 2);
            f = y.w(h << 3 | a);
            for(k = 0; 15 > k; k += 1)m = !b && 1 == (f >> k & 1), r[6 > k ? k : 8 > k ? k + 1 : d - 15 + k][8] = m, r[8][8 > k ? d - k - 1 : 9 > k ? 15 - k : 14 - k] = m;
            r[d - 8][8] = !b;
            if (7 <= c) {
                f = y.A(c);
                for(k = 0; 18 > k; k += 1)m = !b && 1 == (f >> k & 1), r[Math.floor(k / 3)][k % 3 + d - 8 - 3] = m;
                for(k = 0; 18 > k; k += 1)m = !b && 1 == (f >> k & 1), r[k % 3 + d - 8 - 3][Math.floor(k / 3)] = m;
            }
            if (null == g) {
                b = t.I(c, h);
                f = B();
                for(k = 0; k < x.length; k += 1)m = x[k], f.put(4, 4), f.put(m.b(), y.f(4, c)), m.write(f);
                for(k = m = 0; k < b.length; k += 1)m += b[k].j;
                if (f.f() > 8 * m) throw Error("code length overflow. (" + f.f() + ">" + 8 * m + ")");
                for(f.f() + 4 <= 8 * m && f.put(0, 4); 0 != f.f() % 8;)f.m(!1);
                for(; !(f.f() >= 8 * m);){
                    f.put(236, 8);
                    if (f.f() >= 8 * m) break;
                    f.put(17, 8);
                }
                var u = 0;
                m = k = 0;
                p = Array(b.length);
                q = Array(b.length);
                for(n = 0; n < b.length; n += 1){
                    var v = b[n].j, w = b[n].o - v;
                    k = Math.max(k, v);
                    m = Math.max(m, w);
                    p[n] = Array(v);
                    for(l = 0; l < p[n].length; l += 1)p[n][l] = 255 & f.B()[l + u];
                    u += v;
                    l = y.C(w);
                    v = z(p[n], l.b() - 1).l(l);
                    q[n] = Array(l.b() - 1);
                    for(l = 0; l < q[n].length; l += 1)w = l + v.b() - q[n].length, q[n][l] = 0 <= w ? v.c(w) : 0;
                }
                for(l = f = 0; l < b.length; l += 1)f += b[l].o;
                f = Array(f);
                for(l = u = 0; l < k; l += 1)for(n = 0; n < b.length; n += 1)l < p[n].length && (f[u] = p[n][l], u += 1);
                for(l = 0; l < m; l += 1)for(n = 0; n < b.length; n += 1)l < q[n].length && (f[u] = q[n][l], u += 1);
                g = f;
            }
            b = g;
            f = -1;
            k = d - 1;
            m = 7;
            p = 0;
            a = y.F(a);
            for(q = d - 1; 0 < q; q -= 2)for(6 == q && --q;;){
                for(n = 0; 2 > n; n += 1)null == r[k][q - n] && (l = !1, p < b.length && (l = 1 == (b[p] >>> m & 1)), a(k, q - n) && (l = !l), r[k][q - n] = l, --m, -1 == m && (p += 1, m = 7));
                k += f;
                if (0 > k || d <= k) {
                    k -= f;
                    f = -f;
                    break;
                }
            }
        }
        var h = A[a], r = null, d = 0, g = null, x = [], u = {
            u: function(b) {
                b = w(b);
                x.push(b);
                g = null;
            },
            a: function(b, a) {
                if (0 > b || d <= b || 0 > a || d <= a) throw Error(b + "," + a);
                return r[b][a];
            },
            h: function() {
                return d;
            },
            J: function() {
                for(var a = 0, h = 0, c = 0; 8 > c; c += 1){
                    b(!0, c);
                    var d = y.D(u);
                    if (0 == c || a > d) a = d, h = c;
                }
                b(!1, h);
            }
        };
        return u;
    }
    function z(c, a) {
        if ("undefined" == typeof c.length) throw Error(c.length + "/" + a);
        var e = function() {
            for(var b = 0; b < c.length && 0 == c[b];)b += 1;
            for(var r = Array(c.length - b + a), d = 0; d < c.length - b; d += 1)r[d] = c[d + b];
            return r;
        }(), b = {
            c: function(b) {
                return e[b];
            },
            b: function() {
                return e.length;
            },
            multiply: function(a) {
                for(var h = Array(b.b() + a.b() - 1), c = 0; c < b.b(); c += 1)for(var g = 0; g < a.b(); g += 1)h[c + g] ^= v.i(v.g(b.c(c)) + v.g(a.c(g)));
                return z(h, 0);
            },
            l: function(a) {
                if (0 > b.b() - a.b()) return b;
                for(var c = v.g(b.c(0)) - v.g(a.c(0)), h = Array(b.b()), g = 0; g < b.b(); g += 1)h[g] = b.c(g);
                for(g = 0; g < a.b(); g += 1)h[g] ^= v.i(v.g(a.c(g)) + c);
                return z(h, 0).l(a);
            }
        };
        return b;
    }
    C.s = function(c) {
        for(var a = [], e = 0; e < c.length; e++){
            var b = c.charCodeAt(e);
            128 > b ? a.push(b) : 2048 > b ? a.push(192 | b >> 6, 128 | b & 63) : 55296 > b || 57344 <= b ? a.push(224 | b >> 12, 128 | b >> 6 & 63, 128 | b & 63) : (e++, b = 65536 + ((b & 1023) << 10 | c.charCodeAt(e) & 1023), a.push(240 | b >> 18, 128 | b >> 12 & 63, 128 | b >> 6 & 63, 128 | b & 63));
        }
        return a;
    };
    var A = {
        L: 1,
        M: 0,
        Q: 3,
        H: 2
    }, y = function() {
        function c(b) {
            for(var a = 0; 0 != b;)a += 1, b >>>= 1;
            return a;
        }
        var a = [
            [],
            [
                6,
                18
            ],
            [
                6,
                22
            ],
            [
                6,
                26
            ],
            [
                6,
                30
            ],
            [
                6,
                34
            ],
            [
                6,
                22,
                38
            ],
            [
                6,
                24,
                42
            ],
            [
                6,
                26,
                46
            ],
            [
                6,
                28,
                50
            ],
            [
                6,
                30,
                54
            ],
            [
                6,
                32,
                58
            ],
            [
                6,
                34,
                62
            ],
            [
                6,
                26,
                46,
                66
            ],
            [
                6,
                26,
                48,
                70
            ],
            [
                6,
                26,
                50,
                74
            ],
            [
                6,
                30,
                54,
                78
            ],
            [
                6,
                30,
                56,
                82
            ],
            [
                6,
                30,
                58,
                86
            ],
            [
                6,
                34,
                62,
                90
            ],
            [
                6,
                28,
                50,
                72,
                94
            ],
            [
                6,
                26,
                50,
                74,
                98
            ],
            [
                6,
                30,
                54,
                78,
                102
            ],
            [
                6,
                28,
                54,
                80,
                106
            ],
            [
                6,
                32,
                58,
                84,
                110
            ],
            [
                6,
                30,
                58,
                86,
                114
            ],
            [
                6,
                34,
                62,
                90,
                118
            ],
            [
                6,
                26,
                50,
                74,
                98,
                122
            ],
            [
                6,
                30,
                54,
                78,
                102,
                126
            ],
            [
                6,
                26,
                52,
                78,
                104,
                130
            ],
            [
                6,
                30,
                56,
                82,
                108,
                134
            ],
            [
                6,
                34,
                60,
                86,
                112,
                138
            ],
            [
                6,
                30,
                58,
                86,
                114,
                142
            ],
            [
                6,
                34,
                62,
                90,
                118,
                146
            ],
            [
                6,
                30,
                54,
                78,
                102,
                126,
                150
            ],
            [
                6,
                24,
                50,
                76,
                102,
                128,
                154
            ],
            [
                6,
                28,
                54,
                80,
                106,
                132,
                158
            ],
            [
                6,
                32,
                58,
                84,
                110,
                136,
                162
            ],
            [
                6,
                26,
                54,
                82,
                110,
                138,
                166
            ],
            [
                6,
                30,
                58,
                86,
                114,
                142,
                170
            ]
        ], e = {
            w: function(b) {
                for(var a = b << 10; 0 <= c(a) - c(1335);)a ^= 1335 << c(a) - c(1335);
                return (b << 10 | a) ^ 21522;
            },
            A: function(b) {
                for(var a = b << 12; 0 <= c(a) - c(7973);)a ^= 7973 << c(a) - c(7973);
                return b << 12 | a;
            },
            G: function(b) {
                return a[b - 1];
            },
            F: function(b) {
                switch(b){
                    case 0:
                        return function(b, a) {
                            return 0 == (b + a) % 2;
                        };
                    case 1:
                        return function(b) {
                            return 0 == b % 2;
                        };
                    case 2:
                        return function(b, a) {
                            return 0 == a % 3;
                        };
                    case 3:
                        return function(b, a) {
                            return 0 == (b + a) % 3;
                        };
                    case 4:
                        return function(b, a) {
                            return 0 == (Math.floor(b / 2) + Math.floor(a / 3)) % 2;
                        };
                    case 5:
                        return function(b, a) {
                            return 0 == b * a % 2 + b * a % 3;
                        };
                    case 6:
                        return function(b, a) {
                            return 0 == (b * a % 2 + b * a % 3) % 2;
                        };
                    case 7:
                        return function(b, a) {
                            return 0 == (b * a % 3 + (b + a) % 2) % 2;
                        };
                    default:
                        throw Error("bad maskPattern:" + b);
                }
            },
            C: function(b) {
                for(var a = z([
                    1
                ], 0), c = 0; c < b; c += 1)a = a.multiply(z([
                    1,
                    v.i(c)
                ], 0));
                return a;
            },
            f: function(b, a) {
                if (4 != b || 1 > a || 40 < a) throw Error("mode: " + b + "; type: " + a);
                return 10 > a ? 8 : 16;
            },
            D: function(b) {
                for(var a = b.h(), c = 0, d = 0; d < a; d += 1)for(var g = 0; g < a; g += 1){
                    for(var e = 0, t = b.a(d, g), p = -1; 1 >= p; p += 1)if (!(0 > d + p || a <= d + p)) for(var q = -1; 1 >= q; q += 1)0 > g + q || a <= g + q || (0 != p || 0 != q) && t == b.a(d + p, g + q) && (e += 1);
                    5 < e && (c += 3 + e - 5);
                }
                for(d = 0; d < a - 1; d += 1)for(g = 0; g < a - 1; g += 1)if (e = 0, b.a(d, g) && (e += 1), b.a(d + 1, g) && (e += 1), b.a(d, g + 1) && (e += 1), b.a(d + 1, g + 1) && (e += 1), 0 == e || 4 == e) c += 3;
                for(d = 0; d < a; d += 1)for(g = 0; g < a - 6; g += 1)b.a(d, g) && !b.a(d, g + 1) && b.a(d, g + 2) && b.a(d, g + 3) && b.a(d, g + 4) && !b.a(d, g + 5) && b.a(d, g + 6) && (c += 40);
                for(g = 0; g < a; g += 1)for(d = 0; d < a - 6; d += 1)b.a(d, g) && !b.a(d + 1, g) && b.a(d + 2, g) && b.a(d + 3, g) && b.a(d + 4, g) && !b.a(d + 5, g) && b.a(d + 6, g) && (c += 40);
                for(g = e = 0; g < a; g += 1)for(d = 0; d < a; d += 1)b.a(d, g) && (e += 1);
                return c += Math.abs(100 * e / a / a - 50) / 5 * 10;
            }
        };
        return e;
    }(), v = function() {
        for(var c = Array(256), a = Array(256), e = 0; 8 > e; e += 1)c[e] = 1 << e;
        for(e = 8; 256 > e; e += 1)c[e] = c[e - 4] ^ c[e - 5] ^ c[e - 6] ^ c[e - 8];
        for(e = 0; 255 > e; e += 1)a[c[e]] = e;
        return {
            g: function(b) {
                if (1 > b) throw Error("glog(" + b + ")");
                return a[b];
            },
            i: function(b) {
                for(; 0 > b;)b += 255;
                for(; 256 <= b;)b -= 255;
                return c[b];
            }
        };
    }(), t = function() {
        function c(b, c) {
            switch(c){
                case A.L:
                    return a[4 * (b - 1)];
                case A.M:
                    return a[4 * (b - 1) + 1];
                case A.Q:
                    return a[4 * (b - 1) + 2];
                case A.H:
                    return a[4 * (b - 1) + 3];
            }
        }
        var a = [
            [
                1,
                26,
                19
            ],
            [
                1,
                26,
                16
            ],
            [
                1,
                26,
                13
            ],
            [
                1,
                26,
                9
            ],
            [
                1,
                44,
                34
            ],
            [
                1,
                44,
                28
            ],
            [
                1,
                44,
                22
            ],
            [
                1,
                44,
                16
            ],
            [
                1,
                70,
                55
            ],
            [
                1,
                70,
                44
            ],
            [
                2,
                35,
                17
            ],
            [
                2,
                35,
                13
            ],
            [
                1,
                100,
                80
            ],
            [
                2,
                50,
                32
            ],
            [
                2,
                50,
                24
            ],
            [
                4,
                25,
                9
            ],
            [
                1,
                134,
                108
            ],
            [
                2,
                67,
                43
            ],
            [
                2,
                33,
                15,
                2,
                34,
                16
            ],
            [
                2,
                33,
                11,
                2,
                34,
                12
            ],
            [
                2,
                86,
                68
            ],
            [
                4,
                43,
                27
            ],
            [
                4,
                43,
                19
            ],
            [
                4,
                43,
                15
            ],
            [
                2,
                98,
                78
            ],
            [
                4,
                49,
                31
            ],
            [
                2,
                32,
                14,
                4,
                33,
                15
            ],
            [
                4,
                39,
                13,
                1,
                40,
                14
            ],
            [
                2,
                121,
                97
            ],
            [
                2,
                60,
                38,
                2,
                61,
                39
            ],
            [
                4,
                40,
                18,
                2,
                41,
                19
            ],
            [
                4,
                40,
                14,
                2,
                41,
                15
            ],
            [
                2,
                146,
                116
            ],
            [
                3,
                58,
                36,
                2,
                59,
                37
            ],
            [
                4,
                36,
                16,
                4,
                37,
                17
            ],
            [
                4,
                36,
                12,
                4,
                37,
                13
            ],
            [
                2,
                86,
                68,
                2,
                87,
                69
            ],
            [
                4,
                69,
                43,
                1,
                70,
                44
            ],
            [
                6,
                43,
                19,
                2,
                44,
                20
            ],
            [
                6,
                43,
                15,
                2,
                44,
                16
            ],
            [
                4,
                101,
                81
            ],
            [
                1,
                80,
                50,
                4,
                81,
                51
            ],
            [
                4,
                50,
                22,
                4,
                51,
                23
            ],
            [
                3,
                36,
                12,
                8,
                37,
                13
            ],
            [
                2,
                116,
                92,
                2,
                117,
                93
            ],
            [
                6,
                58,
                36,
                2,
                59,
                37
            ],
            [
                4,
                46,
                20,
                6,
                47,
                21
            ],
            [
                7,
                42,
                14,
                4,
                43,
                15
            ],
            [
                4,
                133,
                107
            ],
            [
                8,
                59,
                37,
                1,
                60,
                38
            ],
            [
                8,
                44,
                20,
                4,
                45,
                21
            ],
            [
                12,
                33,
                11,
                4,
                34,
                12
            ],
            [
                3,
                145,
                115,
                1,
                146,
                116
            ],
            [
                4,
                64,
                40,
                5,
                65,
                41
            ],
            [
                11,
                36,
                16,
                5,
                37,
                17
            ],
            [
                11,
                36,
                12,
                5,
                37,
                13
            ],
            [
                5,
                109,
                87,
                1,
                110,
                88
            ],
            [
                5,
                65,
                41,
                5,
                66,
                42
            ],
            [
                5,
                54,
                24,
                7,
                55,
                25
            ],
            [
                11,
                36,
                12,
                7,
                37,
                13
            ],
            [
                5,
                122,
                98,
                1,
                123,
                99
            ],
            [
                7,
                73,
                45,
                3,
                74,
                46
            ],
            [
                15,
                43,
                19,
                2,
                44,
                20
            ],
            [
                3,
                45,
                15,
                13,
                46,
                16
            ],
            [
                1,
                135,
                107,
                5,
                136,
                108
            ],
            [
                10,
                74,
                46,
                1,
                75,
                47
            ],
            [
                1,
                50,
                22,
                15,
                51,
                23
            ],
            [
                2,
                42,
                14,
                17,
                43,
                15
            ],
            [
                5,
                150,
                120,
                1,
                151,
                121
            ],
            [
                9,
                69,
                43,
                4,
                70,
                44
            ],
            [
                17,
                50,
                22,
                1,
                51,
                23
            ],
            [
                2,
                42,
                14,
                19,
                43,
                15
            ],
            [
                3,
                141,
                113,
                4,
                142,
                114
            ],
            [
                3,
                70,
                44,
                11,
                71,
                45
            ],
            [
                17,
                47,
                21,
                4,
                48,
                22
            ],
            [
                9,
                39,
                13,
                16,
                40,
                14
            ],
            [
                3,
                135,
                107,
                5,
                136,
                108
            ],
            [
                3,
                67,
                41,
                13,
                68,
                42
            ],
            [
                15,
                54,
                24,
                5,
                55,
                25
            ],
            [
                15,
                43,
                15,
                10,
                44,
                16
            ],
            [
                4,
                144,
                116,
                4,
                145,
                117
            ],
            [
                17,
                68,
                42
            ],
            [
                17,
                50,
                22,
                6,
                51,
                23
            ],
            [
                19,
                46,
                16,
                6,
                47,
                17
            ],
            [
                2,
                139,
                111,
                7,
                140,
                112
            ],
            [
                17,
                74,
                46
            ],
            [
                7,
                54,
                24,
                16,
                55,
                25
            ],
            [
                34,
                37,
                13
            ],
            [
                4,
                151,
                121,
                5,
                152,
                122
            ],
            [
                4,
                75,
                47,
                14,
                76,
                48
            ],
            [
                11,
                54,
                24,
                14,
                55,
                25
            ],
            [
                16,
                45,
                15,
                14,
                46,
                16
            ],
            [
                6,
                147,
                117,
                4,
                148,
                118
            ],
            [
                6,
                73,
                45,
                14,
                74,
                46
            ],
            [
                11,
                54,
                24,
                16,
                55,
                25
            ],
            [
                30,
                46,
                16,
                2,
                47,
                17
            ],
            [
                8,
                132,
                106,
                4,
                133,
                107
            ],
            [
                8,
                75,
                47,
                13,
                76,
                48
            ],
            [
                7,
                54,
                24,
                22,
                55,
                25
            ],
            [
                22,
                45,
                15,
                13,
                46,
                16
            ],
            [
                10,
                142,
                114,
                2,
                143,
                115
            ],
            [
                19,
                74,
                46,
                4,
                75,
                47
            ],
            [
                28,
                50,
                22,
                6,
                51,
                23
            ],
            [
                33,
                46,
                16,
                4,
                47,
                17
            ],
            [
                8,
                152,
                122,
                4,
                153,
                123
            ],
            [
                22,
                73,
                45,
                3,
                74,
                46
            ],
            [
                8,
                53,
                23,
                26,
                54,
                24
            ],
            [
                12,
                45,
                15,
                28,
                46,
                16
            ],
            [
                3,
                147,
                117,
                10,
                148,
                118
            ],
            [
                3,
                73,
                45,
                23,
                74,
                46
            ],
            [
                4,
                54,
                24,
                31,
                55,
                25
            ],
            [
                11,
                45,
                15,
                31,
                46,
                16
            ],
            [
                7,
                146,
                116,
                7,
                147,
                117
            ],
            [
                21,
                73,
                45,
                7,
                74,
                46
            ],
            [
                1,
                53,
                23,
                37,
                54,
                24
            ],
            [
                19,
                45,
                15,
                26,
                46,
                16
            ],
            [
                5,
                145,
                115,
                10,
                146,
                116
            ],
            [
                19,
                75,
                47,
                10,
                76,
                48
            ],
            [
                15,
                54,
                24,
                25,
                55,
                25
            ],
            [
                23,
                45,
                15,
                25,
                46,
                16
            ],
            [
                13,
                145,
                115,
                3,
                146,
                116
            ],
            [
                2,
                74,
                46,
                29,
                75,
                47
            ],
            [
                42,
                54,
                24,
                1,
                55,
                25
            ],
            [
                23,
                45,
                15,
                28,
                46,
                16
            ],
            [
                17,
                145,
                115
            ],
            [
                10,
                74,
                46,
                23,
                75,
                47
            ],
            [
                10,
                54,
                24,
                35,
                55,
                25
            ],
            [
                19,
                45,
                15,
                35,
                46,
                16
            ],
            [
                17,
                145,
                115,
                1,
                146,
                116
            ],
            [
                14,
                74,
                46,
                21,
                75,
                47
            ],
            [
                29,
                54,
                24,
                19,
                55,
                25
            ],
            [
                11,
                45,
                15,
                46,
                46,
                16
            ],
            [
                13,
                145,
                115,
                6,
                146,
                116
            ],
            [
                14,
                74,
                46,
                23,
                75,
                47
            ],
            [
                44,
                54,
                24,
                7,
                55,
                25
            ],
            [
                59,
                46,
                16,
                1,
                47,
                17
            ],
            [
                12,
                151,
                121,
                7,
                152,
                122
            ],
            [
                12,
                75,
                47,
                26,
                76,
                48
            ],
            [
                39,
                54,
                24,
                14,
                55,
                25
            ],
            [
                22,
                45,
                15,
                41,
                46,
                16
            ],
            [
                6,
                151,
                121,
                14,
                152,
                122
            ],
            [
                6,
                75,
                47,
                34,
                76,
                48
            ],
            [
                46,
                54,
                24,
                10,
                55,
                25
            ],
            [
                2,
                45,
                15,
                64,
                46,
                16
            ],
            [
                17,
                152,
                122,
                4,
                153,
                123
            ],
            [
                29,
                74,
                46,
                14,
                75,
                47
            ],
            [
                49,
                54,
                24,
                10,
                55,
                25
            ],
            [
                24,
                45,
                15,
                46,
                46,
                16
            ],
            [
                4,
                152,
                122,
                18,
                153,
                123
            ],
            [
                13,
                74,
                46,
                32,
                75,
                47
            ],
            [
                48,
                54,
                24,
                14,
                55,
                25
            ],
            [
                42,
                45,
                15,
                32,
                46,
                16
            ],
            [
                20,
                147,
                117,
                4,
                148,
                118
            ],
            [
                40,
                75,
                47,
                7,
                76,
                48
            ],
            [
                43,
                54,
                24,
                22,
                55,
                25
            ],
            [
                10,
                45,
                15,
                67,
                46,
                16
            ],
            [
                19,
                148,
                118,
                6,
                149,
                119
            ],
            [
                18,
                75,
                47,
                31,
                76,
                48
            ],
            [
                34,
                54,
                24,
                34,
                55,
                25
            ],
            [
                20,
                45,
                15,
                61,
                46,
                16
            ]
        ], e = {
            I: function(b, a) {
                var e = c(b, a);
                if ("undefined" == typeof e) throw Error("bad rs block @ typeNumber:" + b + "/errorCorrectLevel:" + a);
                b = e.length / 3;
                a = [];
                for(var d = 0; d < b; d += 1)for(var g = e[3 * d], h = e[3 * d + 1], t = e[3 * d + 2], p = 0; p < g; p += 1){
                    var q = t, f = {};
                    f.o = h;
                    f.j = q;
                    a.push(f);
                }
                return a;
            }
        };
        return e;
    }();
    return C;
}());
var $bc243d08fb740566$export$2e2bcd8739ae039 = QrCreator;


var $2a73084d895d2e7e$export$fc69c443e25d6d60 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.value = "";
        this.label = "";
        this.size = 128;
        this.fill = "black";
        this.background = "white";
        this.radius = 0;
        this.errorCorrection = "H";
    }
    firstUpdated() {
        this.generate();
    }
    generate() {
        if (!this.hasUpdated) return;
        (0, $bc243d08fb740566$export$2e2bcd8739ae039).render({
            text: this.value,
            radius: this.radius,
            ecLevel: this.errorCorrection,
            fill: this.fill,
            background: this.background,
            // We draw the canvas larger and scale its container down to avoid blurring on high-density displays
            size: this.size * 2
        }, this.canvas);
    }
    render() {
        var _a;
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <canvas
        part="base"
        class="qr-code"
        role="img"
        aria-label=${((_a = this.label) == null ? void 0 : _a.length) > 0 ? this.label : this.value}
        style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
            width: `${this.size}px`,
            height: `${this.size}px`
        })}
      ></canvas>
    `;
    }
};
$2a73084d895d2e7e$export$fc69c443e25d6d60.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $cc22b2491c575b16$export$1fdba7d6424133fe)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("canvas")
], $2a73084d895d2e7e$export$fc69c443e25d6d60.prototype, "canvas", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $2a73084d895d2e7e$export$fc69c443e25d6d60.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $2a73084d895d2e7e$export$fc69c443e25d6d60.prototype, "label", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $2a73084d895d2e7e$export$fc69c443e25d6d60.prototype, "size", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $2a73084d895d2e7e$export$fc69c443e25d6d60.prototype, "fill", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $2a73084d895d2e7e$export$fc69c443e25d6d60.prototype, "background", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $2a73084d895d2e7e$export$fc69c443e25d6d60.prototype, "radius", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "error-correction"
    })
], $2a73084d895d2e7e$export$fc69c443e25d6d60.prototype, "errorCorrection", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)([
        "background",
        "errorCorrection",
        "fill",
        "radius",
        "size",
        "value"
    ])
], $2a73084d895d2e7e$export$fc69c443e25d6d60.prototype, "generate", 1);


// src/components/qr-code/qr-code.ts
var $536e82671c4beb1d$export$b94d95a376c0825a = (0, $2a73084d895d2e7e$export$fc69c443e25d6d60);
(0, $2a73084d895d2e7e$export$fc69c443e25d6d60).define("sl-qr-code");




// src/components/radio/radio.styles.ts

var $b30c045b81bcab31$export$b83d32a0e38cb9ea = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  :host(:focus-visible) {
    outline: 0px;
  }

  .radio {
    display: inline-flex;
    align-items: top;
    font-family: var(--sl-input-font-family);
    font-size: var(--sl-input-font-size-medium);
    font-weight: var(--sl-input-font-weight);
    color: var(--sl-input-label-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .radio--small {
    --toggle-size: var(--sl-toggle-size-small);
    font-size: var(--sl-input-font-size-small);
  }

  .radio--medium {
    --toggle-size: var(--sl-toggle-size-medium);
    font-size: var(--sl-input-font-size-medium);
  }

  .radio--large {
    --toggle-size: var(--sl-toggle-size-large);
    font-size: var(--sl-input-font-size-large);
  }

  .radio__checked-icon {
    display: inline-flex;
    width: var(--toggle-size);
    height: var(--toggle-size);
  }

  .radio__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--toggle-size);
    height: var(--toggle-size);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
    border-radius: 50%;
    background-color: var(--sl-input-background-color);
    color: transparent;
    transition:
      var(--sl-transition-fast) border-color,
      var(--sl-transition-fast) background-color,
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) box-shadow;
  }

  .radio__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  /* Hover */
  .radio:not(.radio--checked):not(.radio--disabled) .radio__control:hover {
    border-color: var(--sl-input-border-color-hover);
    background-color: var(--sl-input-background-color-hover);
  }

  /* Checked */
  .radio--checked .radio__control {
    color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
  }

  /* Checked + hover */
  .radio.radio--checked:not(.radio--disabled) .radio__control:hover {
    border-color: var(--sl-color-primary-500);
    background-color: var(--sl-color-primary-500);
  }

  /* Checked + focus */
  :host(:focus-visible) .radio__control {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Disabled */
  .radio--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* When the control isn't checked, hide the circle for Windows High Contrast mode a11y */
  .radio:not(.radio--checked) svg circle {
    opacity: 0;
  }

  .radio__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    line-height: var(--toggle-size);
    margin-inline-start: 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }
`;










var $b4fdfe93eca172c7$export$e4c8f7cbcd0c899c = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super();
        this.checked = false;
        this.hasFocus = false;
        this.size = "medium";
        this.disabled = false;
        this.handleBlur = ()=>{
            this.hasFocus = false;
            this.emit("sl-blur");
        };
        this.handleClick = ()=>{
            if (!this.disabled) this.checked = true;
        };
        this.handleFocus = ()=>{
            this.hasFocus = true;
            this.emit("sl-focus");
        };
        this.addEventListener("blur", this.handleBlur);
        this.addEventListener("click", this.handleClick);
        this.addEventListener("focus", this.handleFocus);
    }
    connectedCallback() {
        super.connectedCallback();
        this.setInitialAttributes();
    }
    setInitialAttributes() {
        this.setAttribute("role", "radio");
        this.setAttribute("tabindex", "-1");
        this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
    }
    handleCheckedChange() {
        this.setAttribute("aria-checked", this.checked ? "true" : "false");
        this.setAttribute("tabindex", this.checked ? "0" : "-1");
    }
    handleDisabledChange() {
        this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <span
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            radio: true,
            "radio--checked": this.checked,
            "radio--disabled": this.disabled,
            "radio--focused": this.hasFocus,
            "radio--small": this.size === "small",
            "radio--medium": this.size === "medium",
            "radio--large": this.size === "large"
        })}
      >
        <span part="${`control${this.checked ? " control--checked" : ""}`}" class="radio__control">
          ${this.checked ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)` <sl-icon part="checked-icon" class="radio__checked-icon" library="system" name="radio"></sl-icon> ` : ""}
        </span>

        <slot part="label" class="radio__label"></slot>
      </span>
    `;
    }
};
$b4fdfe93eca172c7$export$e4c8f7cbcd0c899c.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $b30c045b81bcab31$export$b83d32a0e38cb9ea)
];
$b4fdfe93eca172c7$export$e4c8f7cbcd0c899c.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $b4fdfe93eca172c7$export$e4c8f7cbcd0c899c.prototype, "checked", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $b4fdfe93eca172c7$export$e4c8f7cbcd0c899c.prototype, "hasFocus", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $b4fdfe93eca172c7$export$e4c8f7cbcd0c899c.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $b4fdfe93eca172c7$export$e4c8f7cbcd0c899c.prototype, "size", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $b4fdfe93eca172c7$export$e4c8f7cbcd0c899c.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("checked")
], $b4fdfe93eca172c7$export$e4c8f7cbcd0c899c.prototype, "handleCheckedChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $b4fdfe93eca172c7$export$e4c8f7cbcd0c899c.prototype, "handleDisabledChange", 1);


// src/components/radio/radio.ts
var $bf29597ff32bb449$export$ae409d22c5d3c393 = (0, $b4fdfe93eca172c7$export$e4c8f7cbcd0c899c);
(0, $b4fdfe93eca172c7$export$e4c8f7cbcd0c899c).define("sl-radio");




// src/components/option/option.styles.ts

var $88183a3e8061b34a$export$e4e447453ad69781 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: block;
    user-select: none;
    -webkit-user-select: none;
  }

  :host(:focus) {
    outline: none;
  }

  .option {
    position: relative;
    display: flex;
    align-items: center;
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    line-height: var(--sl-line-height-normal);
    letter-spacing: var(--sl-letter-spacing-normal);
    color: var(--sl-color-neutral-700);
    padding: var(--sl-spacing-x-small) var(--sl-spacing-medium) var(--sl-spacing-x-small) var(--sl-spacing-x-small);
    transition: var(--sl-transition-fast) fill;
    cursor: pointer;
  }

  .option--hover:not(.option--current):not(.option--disabled) {
    background-color: var(--sl-color-neutral-100);
    color: var(--sl-color-neutral-1000);
  }

  .option--current,
  .option--current.option--disabled {
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
    opacity: 1;
  }

  .option--disabled {
    outline: none;
    opacity: 0.5;
    cursor: not-allowed;
  }

  .option__label {
    flex: 1 1 auto;
    display: inline-block;
    line-height: var(--sl-line-height-dense);
  }

  .option .option__check {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
    padding-inline-end: var(--sl-spacing-2x-small);
  }

  .option--selected .option__check {
    visibility: visible;
  }

  .option__prefix,
  .option__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .option__prefix::slotted(*) {
    margin-inline-end: var(--sl-spacing-x-small);
  }

  .option__suffix::slotted(*) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  @media (forced-colors: active) {
    :host(:hover:not([aria-disabled='true'])) .option {
      outline: dashed 1px SelectedItem;
      outline-offset: -1px;
    }
  }
`;











var $6ecc4882fbedda4c$export$529a8b79340189ba = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        // @ts-expect-error - Controller is currently unused
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.isInitialized = false;
        this.current = false;
        this.selected = false;
        this.hasHover = false;
        this.value = "";
        this.disabled = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "option");
        this.setAttribute("aria-selected", "false");
    }
    handleDefaultSlotChange() {
        if (this.isInitialized) customElements.whenDefined("sl-select").then(()=>{
            const controller = this.closest("sl-select");
            if (controller) controller.handleDefaultSlotChange();
        });
        else this.isInitialized = true;
    }
    handleMouseEnter() {
        this.hasHover = true;
    }
    handleMouseLeave() {
        this.hasHover = false;
    }
    handleDisabledChange() {
        this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
    }
    handleSelectedChange() {
        this.setAttribute("aria-selected", this.selected ? "true" : "false");
    }
    handleValueChange() {
        if (typeof this.value !== "string") this.value = String(this.value);
        if (this.value.includes(" ")) {
            console.error(`Option values cannot include a space. All spaces have been replaced with underscores.`, this);
            this.value = this.value.replace(/ /g, "_");
        }
    }
    /** Returns a plain text label based on the option's content. */ getTextLabel() {
        const nodes = this.childNodes;
        let label = "";
        [
            ...nodes
        ].forEach((node)=>{
            if (node.nodeType === Node.ELEMENT_NODE) {
                if (!node.hasAttribute("slot")) label += node.textContent;
            }
            if (node.nodeType === Node.TEXT_NODE) label += node.textContent;
        });
        return label.trim();
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            option: true,
            "option--current": this.current,
            "option--disabled": this.disabled,
            "option--selected": this.selected,
            "option--hover": this.hasHover
        })}
        @mouseenter=${this.handleMouseEnter}
        @mouseleave=${this.handleMouseLeave}
      >
        <sl-icon part="checked-icon" class="option__check" name="check" library="system" aria-hidden="true"></sl-icon>
        <slot part="prefix" name="prefix" class="option__prefix"></slot>
        <slot part="label" class="option__label" @slotchange=${this.handleDefaultSlotChange}></slot>
        <slot part="suffix" name="suffix" class="option__suffix"></slot>
      </div>
    `;
    }
};
$6ecc4882fbedda4c$export$529a8b79340189ba.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $88183a3e8061b34a$export$e4e447453ad69781)
];
$6ecc4882fbedda4c$export$529a8b79340189ba.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".option__label")
], $6ecc4882fbedda4c$export$529a8b79340189ba.prototype, "defaultSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $6ecc4882fbedda4c$export$529a8b79340189ba.prototype, "current", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $6ecc4882fbedda4c$export$529a8b79340189ba.prototype, "selected", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $6ecc4882fbedda4c$export$529a8b79340189ba.prototype, "hasHover", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $6ecc4882fbedda4c$export$529a8b79340189ba.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $6ecc4882fbedda4c$export$529a8b79340189ba.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled")
], $6ecc4882fbedda4c$export$529a8b79340189ba.prototype, "handleDisabledChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("selected")
], $6ecc4882fbedda4c$export$529a8b79340189ba.prototype, "handleSelectedChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("value")
], $6ecc4882fbedda4c$export$529a8b79340189ba.prototype, "handleValueChange", 1);


// src/components/option/option.ts
var $29e619063c564571$export$1646a05979270012 = (0, $6ecc4882fbedda4c$export$529a8b79340189ba);
(0, $6ecc4882fbedda4c$export$529a8b79340189ba).define("sl-option");



// src/components/popup/popup.ts
var $18c9d40f492f0776$export$dccdde829286d84f = (0, $2cc723b992cc8b8e$export$6fe469f0a31d1d6e);
(0, $2cc723b992cc8b8e$export$6fe469f0a31d1d6e).define("sl-popup");


// src/components/progress-bar/progress-bar.styles.ts

var $059785ee18e5afad$export$a9562eff442e810d = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --height: 1rem;
    --track-color: var(--sl-color-neutral-200);
    --indicator-color: var(--sl-color-primary-600);
    --label-color: var(--sl-color-neutral-0);

    display: block;
  }

  .progress-bar {
    position: relative;
    background-color: var(--track-color);
    height: var(--height);
    border-radius: var(--sl-border-radius-pill);
    box-shadow: inset var(--sl-shadow-small);
    overflow: hidden;
  }

  .progress-bar__indicator {
    height: 100%;
    font-family: var(--sl-font-sans);
    font-size: 12px;
    font-weight: var(--sl-font-weight-normal);
    background-color: var(--indicator-color);
    color: var(--label-color);
    text-align: center;
    line-height: var(--height);
    white-space: nowrap;
    overflow: hidden;
    transition:
      400ms width,
      400ms background-color;
    user-select: none;
    -webkit-user-select: none;
  }

  /* Indeterminate */
  .progress-bar--indeterminate .progress-bar__indicator {
    position: absolute;
    animation: indeterminate 2.5s infinite cubic-bezier(0.37, 0, 0.63, 1);
  }

  .progress-bar--indeterminate.progress-bar--rtl .progress-bar__indicator {
    animation-name: indeterminate-rtl;
  }

  @media (forced-colors: active) {
    .progress-bar {
      outline: solid 1px SelectedItem;
      background-color: var(--sl-color-neutral-0);
    }

    .progress-bar__indicator {
      outline: solid 1px SelectedItem;
      background-color: SelectedItem;
    }
  }

  @keyframes indeterminate {
    0% {
      left: -50%;
      width: 50%;
    }
    75%,
    100% {
      left: 100%;
      width: 50%;
    }
  }

  @keyframes indeterminate-rtl {
    0% {
      right: -50%;
      width: 50%;
    }
    75%,
    100% {
      right: 100%;
      width: 50%;
    }
  }
`;











var $b81e6556b6a7a186$export$9ad52f56f9678108 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.value = 0;
        this.indeterminate = false;
        this.label = "";
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "progress-bar": true,
            "progress-bar--indeterminate": this.indeterminate,
            "progress-bar--rtl": this.localize.dir() === "rtl"
        })}
        role="progressbar"
        title=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.title)}
        aria-label=${this.label.length > 0 ? this.label : this.localize.term("progress")}
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow=${this.indeterminate ? 0 : this.value}
      >
        <div part="indicator" class="progress-bar__indicator" style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
            width: `${this.value}%`
        })}>
          ${!this.indeterminate ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)` <slot part="label" class="progress-bar__label"></slot> ` : ""}
        </div>
      </div>
    `;
    }
};
$b81e6556b6a7a186$export$9ad52f56f9678108.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $059785ee18e5afad$export$a9562eff442e810d)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $b81e6556b6a7a186$export$9ad52f56f9678108.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $b81e6556b6a7a186$export$9ad52f56f9678108.prototype, "indeterminate", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $b81e6556b6a7a186$export$9ad52f56f9678108.prototype, "label", 2);


// src/components/progress-bar/progress-bar.ts
var $a9f7900c1757848e$export$e1f668b3446ea938 = (0, $b81e6556b6a7a186$export$9ad52f56f9678108);
(0, $b81e6556b6a7a186$export$9ad52f56f9678108).define("sl-progress-bar");






// src/components/mutation-observer/mutation-observer.styles.ts

var $95c568735fef4154$export$b916b229c7a112c8 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: contents;
  }
`;








var $ea6b1574ae75ec1f$export$7f8a51eb9224b569 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.attrOldValue = false;
        this.charData = false;
        this.charDataOldValue = false;
        this.childList = false;
        this.disabled = false;
        this.handleMutation = (mutationList)=>{
            this.emit("sl-mutation", {
                detail: {
                    mutationList: mutationList
                }
            });
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.mutationObserver = new MutationObserver(this.handleMutation);
        if (!this.disabled) this.startObserver();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.stopObserver();
    }
    startObserver() {
        const observeAttributes = typeof this.attr === "string" && this.attr.length > 0;
        const attributeFilter = observeAttributes && this.attr !== "*" ? this.attr.split(" ") : void 0;
        try {
            this.mutationObserver.observe(this, {
                subtree: true,
                childList: this.childList,
                attributes: observeAttributes,
                attributeFilter: attributeFilter,
                attributeOldValue: this.attrOldValue,
                characterData: this.charData,
                characterDataOldValue: this.charDataOldValue
            });
        } catch (e) {}
    }
    stopObserver() {
        this.mutationObserver.disconnect();
    }
    handleDisabledChange() {
        if (this.disabled) this.stopObserver();
        else this.startObserver();
    }
    handleChange() {
        this.stopObserver();
        this.startObserver();
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)` <slot></slot> `;
    }
};
$ea6b1574ae75ec1f$export$7f8a51eb9224b569.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $95c568735fef4154$export$b916b229c7a112c8)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $ea6b1574ae75ec1f$export$7f8a51eb9224b569.prototype, "attr", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "attr-old-value",
        type: Boolean,
        reflect: true
    })
], $ea6b1574ae75ec1f$export$7f8a51eb9224b569.prototype, "attrOldValue", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "char-data",
        type: Boolean,
        reflect: true
    })
], $ea6b1574ae75ec1f$export$7f8a51eb9224b569.prototype, "charData", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "char-data-old-value",
        type: Boolean,
        reflect: true
    })
], $ea6b1574ae75ec1f$export$7f8a51eb9224b569.prototype, "charDataOldValue", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "child-list",
        type: Boolean,
        reflect: true
    })
], $ea6b1574ae75ec1f$export$7f8a51eb9224b569.prototype, "childList", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ea6b1574ae75ec1f$export$7f8a51eb9224b569.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled")
], $ea6b1574ae75ec1f$export$7f8a51eb9224b569.prototype, "handleDisabledChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("attr", {
        waitUntilFirstUpdate: true
    }),
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("attr-old-value", {
        waitUntilFirstUpdate: true
    }),
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("char-data", {
        waitUntilFirstUpdate: true
    }),
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("char-data-old-value", {
        waitUntilFirstUpdate: true
    }),
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("childList", {
        waitUntilFirstUpdate: true
    })
], $ea6b1574ae75ec1f$export$7f8a51eb9224b569.prototype, "handleChange", 1);


// src/components/mutation-observer/mutation-observer.ts
var $d831e39afc14abb6$export$6ba225bd34119e94 = (0, $ea6b1574ae75ec1f$export$7f8a51eb9224b569);
(0, $ea6b1574ae75ec1f$export$7f8a51eb9224b569).define("sl-mutation-observer");




// src/components/menu/menu.styles.ts

var $9f0a6e7b257b67e6$export$c7293b7882f2b3d4 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: block;
    position: relative;
    background: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-radius: var(--sl-border-radius-medium);
    padding: var(--sl-spacing-x-small) 0;
    overflow: auto;
    overscroll-behavior: none;
  }

  ::slotted(sl-divider) {
    --spacing: var(--sl-spacing-x-small);
  }
`;







var $c63c83adbfc1a183$export$59279638cac230bf = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "menu");
    }
    handleClick(event) {
        const menuItemTypes = [
            "menuitem",
            "menuitemcheckbox"
        ];
        const composedPath = event.composedPath();
        const target = composedPath.find((el)=>{
            var _a;
            return menuItemTypes.includes(((_a = el == null ? void 0 : el.getAttribute) == null ? void 0 : _a.call(el, "role")) || "");
        });
        if (!target) return;
        const closestMenu = composedPath.find((el)=>{
            var _a;
            return ((_a = el == null ? void 0 : el.getAttribute) == null ? void 0 : _a.call(el, "role")) === "menu";
        });
        const clickHasSubmenu = closestMenu !== this;
        if (clickHasSubmenu) return;
        const item = target;
        if (item.type === "checkbox") item.checked = !item.checked;
        this.emit("sl-select", {
            detail: {
                item: item
            }
        });
    }
    handleKeyDown(event) {
        if (event.key === "Enter" || event.key === " ") {
            const item = this.getCurrentItem();
            event.preventDefault();
            event.stopPropagation();
            item == null || item.click();
        } else if ([
            "ArrowDown",
            "ArrowUp",
            "Home",
            "End"
        ].includes(event.key)) {
            const items = this.getAllItems();
            const activeItem = this.getCurrentItem();
            let index = activeItem ? items.indexOf(activeItem) : 0;
            if (items.length > 0) {
                event.preventDefault();
                event.stopPropagation();
                if (event.key === "ArrowDown") index++;
                else if (event.key === "ArrowUp") index--;
                else if (event.key === "Home") index = 0;
                else if (event.key === "End") index = items.length - 1;
                if (index < 0) index = items.length - 1;
                if (index > items.length - 1) index = 0;
                this.setCurrentItem(items[index]);
                items[index].focus();
            }
        }
    }
    handleMouseDown(event) {
        const target = event.target;
        if (this.isMenuItem(target)) this.setCurrentItem(target);
    }
    handleSlotChange() {
        const items = this.getAllItems();
        if (items.length > 0) this.setCurrentItem(items[0]);
    }
    isMenuItem(item) {
        var _a;
        return item.tagName.toLowerCase() === "sl-menu-item" || [
            "menuitem",
            "menuitemcheckbox",
            "menuitemradio"
        ].includes((_a = item.getAttribute("role")) != null ? _a : "");
    }
    /** @internal Gets all slotted menu items, ignoring dividers, headers, and other elements. */ getAllItems() {
        return [
            ...this.defaultSlot.assignedElements({
                flatten: true
            })
        ].filter((el)=>{
            if (el.inert || !this.isMenuItem(el)) return false;
            return true;
        });
    }
    /**
   * @internal Gets the current menu item, which is the menu item that has `tabindex="0"` within the roving tab index.
   * The menu item may or may not have focus, but for keyboard interaction purposes it's considered the "active" item.
   */ getCurrentItem() {
        return this.getAllItems().find((i)=>i.getAttribute("tabindex") === "0");
    }
    /**
   * @internal Sets the current menu item to the specified element. This sets `tabindex="0"` on the target element and
   * `tabindex="-1"` to all other items. This method must be called prior to setting focus on a menu item.
   */ setCurrentItem(item) {
        const items = this.getAllItems();
        items.forEach((i)=>{
            i.setAttribute("tabindex", i === item ? "0" : "-1");
        });
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <slot
        @slotchange=${this.handleSlotChange}
        @click=${this.handleClick}
        @keydown=${this.handleKeyDown}
        @mousedown=${this.handleMouseDown}
      ></slot>
    `;
    }
};
$c63c83adbfc1a183$export$59279638cac230bf.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $9f0a6e7b257b67e6$export$c7293b7882f2b3d4)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("slot")
], $c63c83adbfc1a183$export$59279638cac230bf.prototype, "defaultSlot", 2);


// src/components/menu/menu.ts
var $6daa4d30f9cf6e17$export$9f671b060013e3d0 = (0, $c63c83adbfc1a183$export$59279638cac230bf);
(0, $c63c83adbfc1a183$export$59279638cac230bf).define("sl-menu");






// src/components/input/input.styles.ts

var $d97960303001f6af$export$c3b7146590bd78c8 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  .input {
    flex: 1 1 auto;
    display: inline-flex;
    align-items: stretch;
    justify-content: start;
    position: relative;
    width: 100%;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    letter-spacing: var(--sl-input-letter-spacing);
    vertical-align: middle;
    overflow: hidden;
    cursor: text;
    transition:
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) border,
      var(--sl-transition-fast) box-shadow,
      var(--sl-transition-fast) background-color;
  }

  /* Standard inputs */
  .input--standard {
    background-color: var(--sl-input-background-color);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
  }

  .input--standard:hover:not(.input--disabled) {
    background-color: var(--sl-input-background-color-hover);
    border-color: var(--sl-input-border-color-hover);
  }

  .input--standard.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-background-color-focus);
    border-color: var(--sl-input-border-color-focus);
    box-shadow: 0 0 0 var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
  }

  .input--standard.input--focused:not(.input--disabled) .input__control {
    color: var(--sl-input-color-focus);
  }

  .input--standard.input--disabled {
    background-color: var(--sl-input-background-color-disabled);
    border-color: var(--sl-input-border-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input--standard.input--disabled .input__control {
    color: var(--sl-input-color-disabled);
  }

  .input--standard.input--disabled .input__control::placeholder {
    color: var(--sl-input-placeholder-color-disabled);
  }

  /* Filled inputs */
  .input--filled {
    border: none;
    background-color: var(--sl-input-filled-background-color);
    color: var(--sl-input-color);
  }

  .input--filled:hover:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-hover);
  }

  .input--filled.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-focus);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .input--filled.input--disabled {
    background-color: var(--sl-input-filled-background-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input__control {
    flex: 1 1 auto;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    min-width: 0;
    height: 100%;
    color: var(--sl-input-color);
    border: none;
    background: inherit;
    box-shadow: none;
    padding: 0;
    margin: 0;
    cursor: inherit;
    -webkit-appearance: none;
  }

  .input__control::-webkit-search-decoration,
  .input__control::-webkit-search-cancel-button,
  .input__control::-webkit-search-results-button,
  .input__control::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  .input__control:-webkit-autofill,
  .input__control:-webkit-autofill:hover,
  .input__control:-webkit-autofill:focus,
  .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-background-color-hover) inset !important;
    -webkit-text-fill-color: var(--sl-color-primary-500);
    caret-color: var(--sl-input-color);
  }

  .input--filled .input__control:-webkit-autofill,
  .input--filled .input__control:-webkit-autofill:hover,
  .input--filled .input__control:-webkit-autofill:focus,
  .input--filled .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-filled-background-color) inset !important;
  }

  .input__control::placeholder {
    color: var(--sl-input-placeholder-color);
    user-select: none;
    -webkit-user-select: none;
  }

  .input:hover:not(.input--disabled) .input__control {
    color: var(--sl-input-color-hover);
  }

  .input__control:focus {
    outline: none;
  }

  .input__prefix,
  .input__suffix {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    cursor: default;
  }

  .input__prefix ::slotted(sl-icon),
  .input__suffix ::slotted(sl-icon) {
    color: var(--sl-input-icon-color);
  }

  /*
   * Size modifiers
   */

  .input--small {
    border-radius: var(--sl-input-border-radius-small);
    font-size: var(--sl-input-font-size-small);
    height: var(--sl-input-height-small);
  }

  .input--small .input__control {
    height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-small);
  }

  .input--small .input__clear,
  .input--small .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-small) * 2);
  }

  .input--small .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-small);
  }

  .input--small .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-small);
  }

  .input--medium {
    border-radius: var(--sl-input-border-radius-medium);
    font-size: var(--sl-input-font-size-medium);
    height: var(--sl-input-height-medium);
  }

  .input--medium .input__control {
    height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-medium);
  }

  .input--medium .input__clear,
  .input--medium .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-medium) * 2);
  }

  .input--medium .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-medium);
  }

  .input--medium .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-medium);
  }

  .input--large {
    border-radius: var(--sl-input-border-radius-large);
    font-size: var(--sl-input-font-size-large);
    height: var(--sl-input-height-large);
  }

  .input--large .input__control {
    height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-large);
  }

  .input--large .input__clear,
  .input--large .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-large) * 2);
  }

  .input--large .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-large);
  }

  .input--large .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-large);
  }

  /*
   * Pill modifier
   */

  .input--pill.input--small {
    border-radius: var(--sl-input-height-small);
  }

  .input--pill.input--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .input--pill.input--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Clearable + Password Toggle
   */

  .input__clear,
  .input__password-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    color: var(--sl-input-icon-color);
    border: none;
    background: none;
    padding: 0;
    transition: var(--sl-transition-fast) color;
    cursor: pointer;
  }

  .input__clear:hover,
  .input__password-toggle:hover {
    color: var(--sl-input-icon-color-hover);
  }

  .input__clear:focus,
  .input__password-toggle:focus {
    outline: none;
  }

  /* Don't show the browser's password toggle in Edge */
  ::-ms-reveal {
    display: none;
  }

  /* Hide the built-in number spinner */
  .input--no-spin-buttons input[type='number']::-webkit-outer-spin-button,
  .input--no-spin-buttons input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
  }

  .input--no-spin-buttons input[type='number'] {
    -moz-appearance: textfield;
  }
`;

















var $434fbe6d3fc944cc$export$bf759620d4db2643 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $6aba7ae81ba45aa2$export$43da334182d34ab4)(this, {
            assumeInteractionOn: [
                "sl-blur",
                "sl-input"
            ]
        });
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "help-text", "label");
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.hasFocus = false;
        this.title = "";
        // make reactive to pass through
        this.__numberInput = Object.assign(document.createElement("input"), {
            type: "number"
        });
        this.__dateInput = Object.assign(document.createElement("input"), {
            type: "date"
        });
        this.type = "text";
        this.name = "";
        this.value = "";
        this.defaultValue = "";
        this.size = "medium";
        this.filled = false;
        this.pill = false;
        this.label = "";
        this.helpText = "";
        this.clearable = false;
        this.disabled = false;
        this.placeholder = "";
        this.readonly = false;
        this.passwordToggle = false;
        this.passwordVisible = false;
        this.noSpinButtons = false;
        this.form = "";
        this.required = false;
        this.spellcheck = true;
    }
    //
    // NOTE: We use an in-memory input for these getters/setters instead of the one in the template because the properties
    // can be set before the component is rendered.
    //
    /**
   * Gets or sets the current value as a `Date` object. Returns `null` if the value can't be converted. This will use the native `<input type="{{type}}">` implementation and may result in an error.
   */ get valueAsDate() {
        var _a;
        this.__dateInput.type = this.type;
        this.__dateInput.value = this.value;
        return ((_a = this.input) == null ? void 0 : _a.valueAsDate) || this.__dateInput.valueAsDate;
    }
    set valueAsDate(newValue) {
        this.__dateInput.type = this.type;
        this.__dateInput.valueAsDate = newValue;
        this.value = this.__dateInput.value;
    }
    /** Gets or sets the current value as a number. Returns `NaN` if the value can't be converted. */ get valueAsNumber() {
        var _a;
        this.__numberInput.value = this.value;
        return ((_a = this.input) == null ? void 0 : _a.valueAsNumber) || this.__numberInput.valueAsNumber;
    }
    set valueAsNumber(newValue) {
        this.__numberInput.valueAsNumber = newValue;
        this.value = this.__numberInput.value;
    }
    /** Gets the validity state object */ get validity() {
        return this.input.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.input.validationMessage;
    }
    firstUpdated() {
        this.formControlController.updateValidity();
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleChange() {
        this.value = this.input.value;
        this.emit("sl-change");
    }
    handleClearClick(event) {
        event.preventDefault();
        if (this.value !== "") {
            this.value = "";
            this.emit("sl-clear");
            this.emit("sl-input");
            this.emit("sl-change");
        }
        this.input.focus();
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleInput() {
        this.value = this.input.value;
        this.formControlController.updateValidity();
        this.emit("sl-input");
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    handleKeyDown(event) {
        const hasModifier = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
        if (event.key === "Enter" && !hasModifier) setTimeout(()=>{
            if (!event.defaultPrevented && !event.isComposing) this.formControlController.submit();
        });
    }
    handlePasswordToggle() {
        this.passwordVisible = !this.passwordVisible;
    }
    handleDisabledChange() {
        this.formControlController.setValidity(this.disabled);
    }
    handleStepChange() {
        this.input.step = String(this.step);
        this.formControlController.updateValidity();
    }
    async handleValueChange() {
        await this.updateComplete;
        this.formControlController.updateValidity();
    }
    /** Sets focus on the input. */ focus(options) {
        this.input.focus(options);
    }
    /** Removes focus from the input. */ blur() {
        this.input.blur();
    }
    /** Selects all the text in the input. */ select() {
        this.input.select();
    }
    /** Sets the start and end positions of the text selection (0-based). */ setSelectionRange(selectionStart, selectionEnd, selectionDirection = "none") {
        this.input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
    }
    /** Replaces a range of text with a new string. */ setRangeText(replacement, start, end, selectMode = "preserve") {
        const selectionStart = start != null ? start : this.input.selectionStart;
        const selectionEnd = end != null ? end : this.input.selectionEnd;
        this.input.setRangeText(replacement, selectionStart, selectionEnd, selectMode);
        if (this.value !== this.input.value) this.value = this.input.value;
    }
    /** Displays the browser picker for an input element (only works if the browser supports it for the input type). */ showPicker() {
        if ("showPicker" in HTMLInputElement.prototype) this.input.showPicker();
    }
    /** Increments the value of a numeric input type by the value of the step attribute. */ stepUp() {
        this.input.stepUp();
        if (this.value !== this.input.value) this.value = this.input.value;
    }
    /** Decrements the value of a numeric input type by the value of the step attribute. */ stepDown() {
        this.input.stepDown();
        if (this.value !== this.input.value) this.value = this.input.value;
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.input.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        return this.input.reportValidity();
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        this.input.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    render() {
        const hasLabelSlot = this.hasSlotController.test("label");
        const hasHelpTextSlot = this.hasSlotController.test("help-text");
        const hasLabel = this.label ? true : !!hasLabelSlot;
        const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
        const hasClearIcon = this.clearable && !this.disabled && !this.readonly;
        const isClearIconVisible = hasClearIcon && (typeof this.value === "number" || this.value.length > 0);
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="form-control"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "form-control": true,
            "form-control--small": this.size === "small",
            "form-control--medium": this.size === "medium",
            "form-control--large": this.size === "large",
            "form-control--has-label": hasLabel,
            "form-control--has-help-text": hasHelpText
        })}
      >
        <label
          part="form-control-label"
          class="form-control__label"
          for="input"
          aria-hidden=${hasLabel ? "false" : "true"}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <div
            part="base"
            class=${(0, $4930586706e2a706$export$56cc687933817664)({
            input: true,
            // Sizes
            "input--small": this.size === "small",
            "input--medium": this.size === "medium",
            "input--large": this.size === "large",
            // States
            "input--pill": this.pill,
            "input--standard": !this.filled,
            "input--filled": this.filled,
            "input--disabled": this.disabled,
            "input--focused": this.hasFocus,
            "input--empty": !this.value,
            "input--no-spin-buttons": this.noSpinButtons
        })}
          >
            <span part="prefix" class="input__prefix">
              <slot name="prefix"></slot>
            </span>

            <input
              part="input"
              id="input"
              class="input__control"
              type=${this.type === "password" && this.passwordVisible ? "text" : this.type}
              title=${this.title}
              name=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.name)}
              ?disabled=${this.disabled}
              ?readonly=${this.readonly}
              ?required=${this.required}
              placeholder=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.placeholder)}
              minlength=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.minlength)}
              maxlength=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.maxlength)}
              min=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.min)}
              max=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.max)}
              step=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.step)}
              .value=${(0, $9cd948e30340d8e4$export$28cf49ad70f82d12)(this.value)}
              autocapitalize=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.autocapitalize)}
              autocomplete=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.autocomplete)}
              autocorrect=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.autocorrect)}
              ?autofocus=${this.autofocus}
              spellcheck=${this.spellcheck}
              pattern=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.pattern)}
              enterkeyhint=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.enterkeyhint)}
              inputmode=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.inputmode)}
              aria-describedby="help-text"
              @change=${this.handleChange}
              @input=${this.handleInput}
              @invalid=${this.handleInvalid}
              @keydown=${this.handleKeyDown}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
            />

            ${isClearIconVisible ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                  <button
                    part="clear-button"
                    class="input__clear"
                    type="button"
                    aria-label=${this.localize.term("clearEntry")}
                    @click=${this.handleClearClick}
                    tabindex="-1"
                  >
                    <slot name="clear-icon">
                      <sl-icon name="x-circle-fill" library="system"></sl-icon>
                    </slot>
                  </button>
                ` : ""}
            ${this.passwordToggle && !this.disabled ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                  <button
                    part="password-toggle-button"
                    class="input__password-toggle"
                    type="button"
                    aria-label=${this.localize.term(this.passwordVisible ? "hidePassword" : "showPassword")}
                    @click=${this.handlePasswordToggle}
                    tabindex="-1"
                  >
                    ${this.passwordVisible ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                          <slot name="show-password-icon">
                            <sl-icon name="eye-slash" library="system"></sl-icon>
                          </slot>
                        ` : (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                          <slot name="hide-password-icon">
                            <sl-icon name="eye" library="system"></sl-icon>
                          </slot>
                        `}
                  </button>
                ` : ""}

            <span part="suffix" class="input__suffix">
              <slot name="suffix"></slot>
            </span>
          </div>
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${hasHelpText ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
    }
};
$434fbe6d3fc944cc$export$bf759620d4db2643.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $5650ed14ec96c2a3$export$e7c8528c268605e9),
    (0, $d97960303001f6af$export$c3b7146590bd78c8)
];
$434fbe6d3fc944cc$export$bf759620d4db2643.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".input__control")
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "input", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "hasFocus", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "title", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "type", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "name", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $66d37a8d1e916a65$export$1a01ae0705bafd37)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "defaultValue", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "size", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "filled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "pill", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "label", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "help-text"
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "helpText", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "clearable", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "placeholder", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "readonly", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "password-toggle",
        type: Boolean
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "passwordToggle", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "password-visible",
        type: Boolean
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "passwordVisible", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "no-spin-buttons",
        type: Boolean
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "noSpinButtons", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "form", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "required", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "pattern", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "minlength", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "maxlength", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "min", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "max", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "step", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "autocapitalize", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "autocorrect", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "autocomplete", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "autofocus", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "enterkeyhint", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        converter: {
            // Allow "true|false" attribute values but keep the property boolean
            fromAttribute: (value)=>!value || value === "false" ? false : true,
            toAttribute: (value)=>value ? "true" : "false"
        }
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "spellcheck", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "inputmode", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "handleDisabledChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("step", {
        waitUntilFirstUpdate: true
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "handleStepChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("value", {
        waitUntilFirstUpdate: true
    })
], $434fbe6d3fc944cc$export$bf759620d4db2643.prototype, "handleValueChange", 1);


// src/components/input/input.ts
var $0f77d1b1982b6085$export$921a3451e53aa4ce = (0, $434fbe6d3fc944cc$export$bf759620d4db2643);
(0, $434fbe6d3fc944cc$export$bf759620d4db2643).define("sl-input");


// src/components/menu-item/menu-item.styles.ts

var $80d10c4ccd02e1e4$export$39d657da2cf50eaf = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --submenu-offset: -2px;

    display: block;
  }

  :host([inert]) {
    display: none;
  }

  .menu-item {
    position: relative;
    display: flex;
    align-items: stretch;
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    line-height: var(--sl-line-height-normal);
    letter-spacing: var(--sl-letter-spacing-normal);
    color: var(--sl-color-neutral-700);
    padding: var(--sl-spacing-2x-small) var(--sl-spacing-2x-small);
    transition: var(--sl-transition-fast) fill;
    user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    cursor: pointer;
  }

  .menu-item.menu-item--disabled {
    outline: none;
    opacity: 0.5;
    cursor: not-allowed;
  }

  .menu-item.menu-item--loading {
    outline: none;
    cursor: wait;
  }

  .menu-item.menu-item--loading *:not(sl-spinner) {
    opacity: 0.5;
  }

  .menu-item--loading sl-spinner {
    --indicator-color: currentColor;
    --track-width: 1px;
    position: absolute;
    font-size: 0.75em;
    top: calc(50% - 0.5em);
    left: 0.65rem;
    opacity: 1;
  }

  .menu-item .menu-item__label {
    flex: 1 1 auto;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .menu-item .menu-item__prefix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .menu-item .menu-item__prefix::slotted(*) {
    margin-inline-end: var(--sl-spacing-x-small);
  }

  .menu-item .menu-item__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .menu-item .menu-item__suffix::slotted(*) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  /* Safe triangle */
  .menu-item--submenu-expanded::after {
    content: '';
    position: fixed;
    z-index: calc(var(--sl-z-index-dropdown) - 1);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    clip-path: polygon(
      var(--safe-triangle-cursor-x, 0) var(--safe-triangle-cursor-y, 0),
      var(--safe-triangle-submenu-start-x, 0) var(--safe-triangle-submenu-start-y, 0),
      var(--safe-triangle-submenu-end-x, 0) var(--safe-triangle-submenu-end-y, 0)
    );
  }

  :host(:focus-visible) {
    outline: none;
  }

  :host(:hover:not([aria-disabled='true'], :focus-visible)) .menu-item,
  .menu-item--submenu-expanded {
    background-color: var(--sl-color-neutral-100);
    color: var(--sl-color-neutral-1000);
  }

  :host(:focus-visible) .menu-item {
    outline: none;
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
    opacity: 1;
  }

  .menu-item .menu-item__check,
  .menu-item .menu-item__chevron {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5em;
    visibility: hidden;
  }

  .menu-item--checked .menu-item__check,
  .menu-item--has-submenu .menu-item__chevron {
    visibility: visible;
  }

  /* Add elevation and z-index to submenus */
  sl-popup::part(popup) {
    box-shadow: var(--sl-shadow-large);
    z-index: var(--sl-z-index-dropdown);
    margin-left: var(--submenu-offset);
  }

  .menu-item--rtl sl-popup::part(popup) {
    margin-left: calc(-1 * var(--submenu-offset));
  }

  @media (forced-colors: active) {
    :host(:hover:not([aria-disabled='true'])) .menu-item,
    :host(:focus-visible) .menu-item {
      outline: dashed 1px SelectedItem;
      outline-offset: -1px;
    }
  }

  ::slotted(sl-menu) {
    max-width: var(--auto-size-available-width) !important;
    max-height: var(--auto-size-available-height) !important;
  }
`;


// src/components/menu-item/submenu-controller.ts



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $006e0b41eeb3b666$var$s = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), $006e0b41eeb3b666$var$s(i, t);
    return !0;
}, $006e0b41eeb3b666$var$o = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, $006e0b41eeb3b666$var$r = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $006e0b41eeb3b666$var$c(t);
    }
};
function $006e0b41eeb3b666$var$h(i) {
    void 0 !== this._$AN ? ($006e0b41eeb3b666$var$o(this), this._$AM = i, $006e0b41eeb3b666$var$r(this)) : this._$AM = i;
}
function $006e0b41eeb3b666$var$n(i, t = !1, e = 0) {
    const r = this._$AH, h = this._$AN;
    if (void 0 !== h && 0 !== h.size) {
        if (t) {
            if (Array.isArray(r)) for(let i = e; i < r.length; i++)$006e0b41eeb3b666$var$s(r[i], !1), $006e0b41eeb3b666$var$o(r[i]);
            else null != r && ($006e0b41eeb3b666$var$s(r, !1), $006e0b41eeb3b666$var$o(r));
        } else $006e0b41eeb3b666$var$s(this, i);
    }
}
const $006e0b41eeb3b666$var$c = (i)=>{
    i.type == (0, $bfc08ae7c1bf655d$export$9ba3b3f20a85bfa).CHILD && (i._$AP ??= $006e0b41eeb3b666$var$n, i._$AQ ??= $006e0b41eeb3b666$var$h);
};
class $006e0b41eeb3b666$export$7d025501802325e extends (0, $bfc08ae7c1bf655d$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $006e0b41eeb3b666$var$r(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && ($006e0b41eeb3b666$var$s(this, i), $006e0b41eeb3b666$var$o(this));
    }
    setValue(t) {
        if ((0, $03728c7decb8678c$export$7f431ad0fff82fd9)(this._$Ct)) this._$Ct._$AI(t, this);
        else {
            const i = [
                ...this._$Ct._$AH
            ];
            i[this._$Ci] = t, this._$Ct._$AI(i, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $1a1cfbab66360077$export$7d1e3a5e95ceca43 = ()=>new $1a1cfbab66360077$var$h;
class $1a1cfbab66360077$var$h {
}
const $1a1cfbab66360077$var$o = new WeakMap, $1a1cfbab66360077$export$eff4d24c3ff7876e = (0, $bfc08ae7c1bf655d$export$99b43ad1ed32e735)(class extends (0, $006e0b41eeb3b666$export$7d025501802325e) {
    render(i) {
        return 0, $d2b76d366be0d5ac$export$45b790e32b2810ee;
    }
    update(i, [s]) {
        const e = s !== this.Y;
        return e && void 0 !== this.Y && this.rt(void 0), (e || this.lt !== this.ct) && (this.Y = s, this.ht = i.options?.host, this.rt(this.ct = i.element)), $d2b76d366be0d5ac$export$45b790e32b2810ee;
    }
    rt(t) {
        if (this.isConnected || (t = void 0), "function" == typeof this.Y) {
            const i = this.ht ?? globalThis;
            let s = $1a1cfbab66360077$var$o.get(i);
            void 0 === s && (s = new WeakMap, $1a1cfbab66360077$var$o.set(i, s)), void 0 !== s.get(this.Y) && this.Y.call(this.ht, void 0), s.set(this.Y, t), void 0 !== t && this.Y.call(this.ht, t);
        } else this.Y.value = t;
    }
    get lt() {
        return "function" == typeof this.Y ? $1a1cfbab66360077$var$o.get(this.ht ?? globalThis)?.get(this.Y) : this.Y?.value;
    }
    disconnected() {
        this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
        this.rt(this.ct);
    }
});





var $02a6f9d744024022$export$ef4e1871e51fa433 = class {
    constructor(host, hasSlotController){
        this.popupRef = (0, $1a1cfbab66360077$export$7d1e3a5e95ceca43)();
        this.enableSubmenuTimer = -1;
        this.isConnected = false;
        this.isPopupConnected = false;
        this.skidding = 0;
        this.submenuOpenDelay = 100;
        // Set the safe triangle cursor position
        this.handleMouseMove = (event)=>{
            this.host.style.setProperty("--safe-triangle-cursor-x", `${event.clientX}px`);
            this.host.style.setProperty("--safe-triangle-cursor-y", `${event.clientY}px`);
        };
        this.handleMouseOver = ()=>{
            if (this.hasSlotController.test("submenu")) this.enableSubmenu();
        };
        // Focus on the first menu-item of a submenu.
        this.handleKeyDown = (event)=>{
            switch(event.key){
                case "Escape":
                case "Tab":
                    this.disableSubmenu();
                    break;
                case "ArrowLeft":
                    if (event.target !== this.host) {
                        event.preventDefault();
                        event.stopPropagation();
                        this.host.focus();
                        this.disableSubmenu();
                    }
                    break;
                case "ArrowRight":
                case "Enter":
                case " ":
                    this.handleSubmenuEntry(event);
                    break;
                default:
                    break;
            }
        };
        this.handleClick = (event)=>{
            var _a;
            if (event.target === this.host) {
                event.preventDefault();
                event.stopPropagation();
            } else if (event.target instanceof Element && (event.target.tagName === "sl-menu-item" || ((_a = event.target.role) == null ? void 0 : _a.startsWith("menuitem")))) this.disableSubmenu();
        };
        // Close this submenu on focus outside of the parent or any descendants.
        this.handleFocusOut = (event)=>{
            if (event.relatedTarget && event.relatedTarget instanceof Element && this.host.contains(event.relatedTarget)) return;
            this.disableSubmenu();
        };
        // Prevent the parent menu-item from getting focus on mouse movement on the submenu
        this.handlePopupMouseover = (event)=>{
            event.stopPropagation();
        };
        // Set the safe triangle values for the submenu when the position changes
        this.handlePopupReposition = ()=>{
            const submenuSlot = this.host.renderRoot.querySelector("slot[name='submenu']");
            const menu = submenuSlot == null ? void 0 : submenuSlot.assignedElements({
                flatten: true
            }).filter((el)=>el.localName === "sl-menu")[0];
            const isRtl = getComputedStyle(this.host).direction === "rtl";
            if (!menu) return;
            const { left: left, top: top, width: width, height: height } = menu.getBoundingClientRect();
            this.host.style.setProperty("--safe-triangle-submenu-start-x", `${isRtl ? left + width : left}px`);
            this.host.style.setProperty("--safe-triangle-submenu-start-y", `${top}px`);
            this.host.style.setProperty("--safe-triangle-submenu-end-x", `${isRtl ? left + width : left}px`);
            this.host.style.setProperty("--safe-triangle-submenu-end-y", `${top + height}px`);
        };
        (this.host = host).addController(this);
        this.hasSlotController = hasSlotController;
    }
    hostConnected() {
        if (this.hasSlotController.test("submenu") && !this.host.disabled) this.addListeners();
    }
    hostDisconnected() {
        this.removeListeners();
    }
    hostUpdated() {
        if (this.hasSlotController.test("submenu") && !this.host.disabled) {
            this.addListeners();
            this.updateSkidding();
        } else this.removeListeners();
    }
    addListeners() {
        if (!this.isConnected) {
            this.host.addEventListener("mousemove", this.handleMouseMove);
            this.host.addEventListener("mouseover", this.handleMouseOver);
            this.host.addEventListener("keydown", this.handleKeyDown);
            this.host.addEventListener("click", this.handleClick);
            this.host.addEventListener("focusout", this.handleFocusOut);
            this.isConnected = true;
        }
        if (!this.isPopupConnected) {
            if (this.popupRef.value) {
                this.popupRef.value.addEventListener("mouseover", this.handlePopupMouseover);
                this.popupRef.value.addEventListener("sl-reposition", this.handlePopupReposition);
                this.isPopupConnected = true;
            }
        }
    }
    removeListeners() {
        if (this.isConnected) {
            this.host.removeEventListener("mousemove", this.handleMouseMove);
            this.host.removeEventListener("mouseover", this.handleMouseOver);
            this.host.removeEventListener("keydown", this.handleKeyDown);
            this.host.removeEventListener("click", this.handleClick);
            this.host.removeEventListener("focusout", this.handleFocusOut);
            this.isConnected = false;
        }
        if (this.isPopupConnected) {
            if (this.popupRef.value) {
                this.popupRef.value.removeEventListener("mouseover", this.handlePopupMouseover);
                this.popupRef.value.removeEventListener("sl-reposition", this.handlePopupReposition);
                this.isPopupConnected = false;
            }
        }
    }
    handleSubmenuEntry(event) {
        const submenuSlot = this.host.renderRoot.querySelector("slot[name='submenu']");
        if (!submenuSlot) {
            console.error("Cannot activate a submenu if no corresponding menuitem can be found.", this);
            return;
        }
        let menuItems = null;
        for (const elt of submenuSlot.assignedElements()){
            menuItems = elt.querySelectorAll("sl-menu-item, [role^='menuitem']");
            if (menuItems.length !== 0) break;
        }
        if (!menuItems || menuItems.length === 0) return;
        menuItems[0].setAttribute("tabindex", "0");
        for(let i = 1; i !== menuItems.length; ++i)menuItems[i].setAttribute("tabindex", "-1");
        if (this.popupRef.value) {
            event.preventDefault();
            event.stopPropagation();
            if (this.popupRef.value.active) {
                if (menuItems[0] instanceof HTMLElement) menuItems[0].focus();
            } else {
                this.enableSubmenu(false);
                this.host.updateComplete.then(()=>{
                    if (menuItems[0] instanceof HTMLElement) menuItems[0].focus();
                });
                this.host.requestUpdate();
            }
        }
    }
    setSubmenuState(state) {
        if (this.popupRef.value) {
            if (this.popupRef.value.active !== state) {
                this.popupRef.value.active = state;
                this.host.requestUpdate();
            }
        }
    }
    // Shows the submenu. Supports disabling the opening delay, e.g. for keyboard events that want to set the focus to the
    // newly opened menu.
    enableSubmenu(delay = true) {
        if (delay) {
            window.clearTimeout(this.enableSubmenuTimer);
            this.enableSubmenuTimer = window.setTimeout(()=>{
                this.setSubmenuState(true);
            }, this.submenuOpenDelay);
        } else this.setSubmenuState(true);
    }
    disableSubmenu() {
        window.clearTimeout(this.enableSubmenuTimer);
        this.setSubmenuState(false);
    }
    // Calculate the space the top of a menu takes-up, for aligning the popup menu-item with the activating element.
    updateSkidding() {
        var _a;
        if (!((_a = this.host.parentElement) == null ? void 0 : _a.computedStyleMap)) return;
        const styleMap = this.host.parentElement.computedStyleMap();
        const attrs = [
            "padding-top",
            "border-top-width",
            "margin-top"
        ];
        const skidding = attrs.reduce((accumulator, attr)=>{
            var _a2;
            const styleValue = (_a2 = styleMap.get(attr)) != null ? _a2 : new CSSUnitValue(0, "px");
            const unitValue = styleValue instanceof CSSUnitValue ? styleValue : new CSSUnitValue(0, "px");
            const pxValue = unitValue.to("px");
            return accumulator - pxValue.value;
        }, 0);
        this.skidding = skidding;
    }
    isExpanded() {
        return this.popupRef.value ? this.popupRef.value.active : false;
    }
    renderSubmenu() {
        const isRtl = getComputedStyle(this.host).direction === "rtl";
        if (!this.isConnected) return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)` <slot name="submenu" hidden></slot> `;
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <sl-popup
        ${(0, $1a1cfbab66360077$export$eff4d24c3ff7876e)(this.popupRef)}
        placement=${isRtl ? "left-start" : "right-start"}
        anchor="anchor"
        flip
        flip-fallback-strategy="best-fit"
        skidding="${this.skidding}"
        strategy="fixed"
        auto-size="vertical"
        auto-size-padding="10"
      >
        <slot name="submenu"></slot>
      </sl-popup>
    `;
    }
};














var $d7b7144aa683e574$export$bd1a667628462930 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.type = "normal";
        this.checked = false;
        this.value = "";
        this.loading = false;
        this.disabled = false;
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "submenu");
        this.submenuController = new (0, $02a6f9d744024022$export$ef4e1871e51fa433)(this, this.hasSlotController);
        this.handleHostClick = (event)=>{
            if (this.disabled) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        };
        this.handleMouseOver = (event)=>{
            this.focus();
            event.stopPropagation();
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener("click", this.handleHostClick);
        this.addEventListener("mouseover", this.handleMouseOver);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("click", this.handleHostClick);
        this.removeEventListener("mouseover", this.handleMouseOver);
    }
    handleDefaultSlotChange() {
        const textLabel = this.getTextLabel();
        if (typeof this.cachedTextLabel === "undefined") {
            this.cachedTextLabel = textLabel;
            return;
        }
        if (textLabel !== this.cachedTextLabel) {
            this.cachedTextLabel = textLabel;
            this.emit("slotchange", {
                bubbles: true,
                composed: false,
                cancelable: false
            });
        }
    }
    handleCheckedChange() {
        if (this.checked && this.type !== "checkbox") {
            this.checked = false;
            console.error('The checked attribute can only be used on menu items with type="checkbox"', this);
            return;
        }
        if (this.type === "checkbox") this.setAttribute("aria-checked", this.checked ? "true" : "false");
        else this.removeAttribute("aria-checked");
    }
    handleDisabledChange() {
        this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
    }
    handleTypeChange() {
        if (this.type === "checkbox") {
            this.setAttribute("role", "menuitemcheckbox");
            this.setAttribute("aria-checked", this.checked ? "true" : "false");
        } else {
            this.setAttribute("role", "menuitem");
            this.removeAttribute("aria-checked");
        }
    }
    /** Returns a text label based on the contents of the menu item's default slot. */ getTextLabel() {
        return (0, $2bcc883cf9fdb597$export$132e79e4118a78e0)(this.defaultSlot);
    }
    isSubmenu() {
        return this.hasSlotController.test("submenu");
    }
    render() {
        const isRtl = this.localize.dir() === "rtl";
        const isSubmenuExpanded = this.submenuController.isExpanded();
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        id="anchor"
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "menu-item": true,
            "menu-item--rtl": isRtl,
            "menu-item--checked": this.checked,
            "menu-item--disabled": this.disabled,
            "menu-item--loading": this.loading,
            "menu-item--has-submenu": this.isSubmenu(),
            "menu-item--submenu-expanded": isSubmenuExpanded
        })}
        ?aria-haspopup="${this.isSubmenu()}"
        ?aria-expanded="${isSubmenuExpanded ? true : false}"
      >
        <span part="checked-icon" class="menu-item__check">
          <sl-icon name="check" library="system" aria-hidden="true"></sl-icon>
        </span>

        <slot name="prefix" part="prefix" class="menu-item__prefix"></slot>

        <slot part="label" class="menu-item__label" @slotchange=${this.handleDefaultSlotChange}></slot>

        <slot name="suffix" part="suffix" class="menu-item__suffix"></slot>

        <span part="submenu-icon" class="menu-item__chevron">
          <sl-icon name=${isRtl ? "chevron-left" : "chevron-right"} library="system" aria-hidden="true"></sl-icon>
        </span>

        ${this.submenuController.renderSubmenu()}
        ${this.loading ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)` <sl-spinner part="spinner" exportparts="base:spinner__base"></sl-spinner> ` : ""}
      </div>
    `;
    }
};
$d7b7144aa683e574$export$bd1a667628462930.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $80d10c4ccd02e1e4$export$39d657da2cf50eaf)
];
$d7b7144aa683e574$export$bd1a667628462930.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441),
    "sl-popup": (0, $2cc723b992cc8b8e$export$6fe469f0a31d1d6e),
    "sl-spinner": (0, $b879e4c4815031db$export$4e45ce56e46d2b00)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("slot:not([name])")
], $d7b7144aa683e574$export$bd1a667628462930.prototype, "defaultSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".menu-item")
], $d7b7144aa683e574$export$bd1a667628462930.prototype, "menuItem", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $d7b7144aa683e574$export$bd1a667628462930.prototype, "type", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $d7b7144aa683e574$export$bd1a667628462930.prototype, "checked", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $d7b7144aa683e574$export$bd1a667628462930.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $d7b7144aa683e574$export$bd1a667628462930.prototype, "loading", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $d7b7144aa683e574$export$bd1a667628462930.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("checked")
], $d7b7144aa683e574$export$bd1a667628462930.prototype, "handleCheckedChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled")
], $d7b7144aa683e574$export$bd1a667628462930.prototype, "handleDisabledChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("type")
], $d7b7144aa683e574$export$bd1a667628462930.prototype, "handleTypeChange", 1);


// src/components/menu-item/menu-item.ts
var $c4290920f3a6cd7e$export$c023dba2983aab3 = (0, $d7b7144aa683e574$export$bd1a667628462930);
(0, $d7b7144aa683e574$export$bd1a667628462930).define("sl-menu-item");





// src/components/menu-label/menu-label.styles.ts

var $2bb7711f27e9a852$export$c2f23fafad63a48e = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  .menu-label {
    display: inline-block;
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-small);
    font-weight: var(--sl-font-weight-semibold);
    line-height: var(--sl-line-height-normal);
    letter-spacing: var(--sl-letter-spacing-normal);
    color: var(--sl-color-neutral-500);
    padding: var(--sl-spacing-2x-small) var(--sl-spacing-x-large);
    user-select: none;
    -webkit-user-select: none;
  }
`;





var $fbe71cd5ffc077d6$export$46f7a68da506198a = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)` <slot part="base" class="menu-label"></slot> `;
    }
};
$fbe71cd5ffc077d6$export$46f7a68da506198a.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $2bb7711f27e9a852$export$c2f23fafad63a48e)
];


// src/components/menu-label/menu-label.ts
var $9c6d0330f6dbc531$export$7dd52e9653629630 = (0, $fbe71cd5ffc077d6$export$46f7a68da506198a);
(0, $fbe71cd5ffc077d6$export$46f7a68da506198a).define("sl-menu-label");




// src/components/image-comparer/image-comparer.styles.ts

var $96dde45afe76b0c6$export$f85def20a7ade527 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --divider-width: 2px;
    --handle-size: 2.5rem;

    display: inline-block;
    position: relative;
  }

  .image-comparer {
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;
  }

  .image-comparer__before,
  .image-comparer__after {
    display: block;
    pointer-events: none;
  }

  .image-comparer__before::slotted(img),
  .image-comparer__after::slotted(img),
  .image-comparer__before::slotted(svg),
  .image-comparer__after::slotted(svg) {
    display: block;
    max-width: 100% !important;
    height: auto;
  }

  .image-comparer__after {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .image-comparer__divider {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    width: var(--divider-width);
    height: 100%;
    background-color: var(--sl-color-neutral-0);
    translate: calc(var(--divider-width) / -2);
    cursor: ew-resize;
  }

  .image-comparer__handle {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: calc(50% - (var(--handle-size) / 2));
    width: var(--handle-size);
    height: var(--handle-size);
    background-color: var(--sl-color-neutral-0);
    border-radius: var(--sl-border-radius-circle);
    font-size: calc(var(--handle-size) * 0.5);
    color: var(--sl-color-neutral-700);
    cursor: inherit;
    z-index: 10;
  }

  .image-comparer__handle:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }
`;














var $5fbdd63b33cbda0b$export$f50961b50eb6b3a = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.position = 50;
    }
    handleDrag(event) {
        const { width: width } = this.base.getBoundingClientRect();
        const isRtl = this.localize.dir() === "rtl";
        event.preventDefault();
        (0, $9c08d309b4f970a2$export$d7d5d435647ed5a0)(this.base, {
            onMove: (x)=>{
                this.position = parseFloat((0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(x / width * 100, 0, 100).toFixed(2));
                if (isRtl) this.position = 100 - this.position;
            },
            initialEvent: event
        });
    }
    handleKeyDown(event) {
        const isLtr = this.localize.dir() === "ltr";
        const isRtl = this.localize.dir() === "rtl";
        if ([
            "ArrowLeft",
            "ArrowRight",
            "Home",
            "End"
        ].includes(event.key)) {
            const incr = event.shiftKey ? 10 : 1;
            let newPosition = this.position;
            event.preventDefault();
            if (isLtr && event.key === "ArrowLeft" || isRtl && event.key === "ArrowRight") newPosition -= incr;
            if (isLtr && event.key === "ArrowRight" || isRtl && event.key === "ArrowLeft") newPosition += incr;
            if (event.key === "Home") newPosition = 0;
            if (event.key === "End") newPosition = 100;
            newPosition = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(newPosition, 0, 100);
            this.position = newPosition;
        }
    }
    handlePositionChange() {
        this.emit("sl-change");
    }
    render() {
        const isRtl = this.localize.dir() === "rtl";
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        id="image-comparer"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "image-comparer": true,
            "image-comparer--rtl": isRtl
        })}
        @keydown=${this.handleKeyDown}
      >
        <div class="image-comparer__image">
          <div part="before" class="image-comparer__before">
            <slot name="before"></slot>
          </div>

          <div
            part="after"
            class="image-comparer__after"
            style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
            clipPath: isRtl ? `inset(0 0 0 ${100 - this.position}%)` : `inset(0 ${100 - this.position}% 0 0)`
        })}
          >
            <slot name="after"></slot>
          </div>
        </div>

        <div
          part="divider"
          class="image-comparer__divider"
          style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
            left: isRtl ? `${100 - this.position}%` : `${this.position}%`
        })}
          @mousedown=${this.handleDrag}
          @touchstart=${this.handleDrag}
        >
          <div
            part="handle"
            class="image-comparer__handle"
            role="scrollbar"
            aria-valuenow=${this.position}
            aria-valuemin="0"
            aria-valuemax="100"
            aria-controls="image-comparer"
            tabindex="0"
          >
            <slot name="handle">
              <sl-icon library="system" name="grip-vertical"></sl-icon>
            </slot>
          </div>
        </div>
      </div>
    `;
    }
};
$5fbdd63b33cbda0b$export$f50961b50eb6b3a.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $96dde45afe76b0c6$export$f85def20a7ade527)
];
$5fbdd63b33cbda0b$export$f50961b50eb6b3a.scopedElement = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".image-comparer")
], $5fbdd63b33cbda0b$export$f50961b50eb6b3a.prototype, "base", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".image-comparer__handle")
], $5fbdd63b33cbda0b$export$f50961b50eb6b3a.prototype, "handle", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $5fbdd63b33cbda0b$export$f50961b50eb6b3a.prototype, "position", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("position", {
        waitUntilFirstUpdate: true
    })
], $5fbdd63b33cbda0b$export$f50961b50eb6b3a.prototype, "handlePositionChange", 1);


// src/components/image-comparer/image-comparer.ts
var $a57ced30c394bd76$export$261eeeac44b1f164 = (0, $5fbdd63b33cbda0b$export$f50961b50eb6b3a);
(0, $5fbdd63b33cbda0b$export$f50961b50eb6b3a).define("sl-image-comparer");


// src/components/include/include.styles.ts

var $5230a8396ab5b268$export$f4bf77a57e5a8c5a = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: block;
  }
`;


// src/components/include/request.ts
var $f5386a2d419882ba$var$includeFiles = /* @__PURE__ */ new Map();
function $f5386a2d419882ba$export$9ffa5ba4f9903370(src, mode = "cors") {
    const prev = $f5386a2d419882ba$var$includeFiles.get(src);
    if (prev !== void 0) return Promise.resolve(prev);
    const fileDataPromise = fetch(src, {
        mode: mode
    }).then(async (response)=>{
        const res = {
            ok: response.ok,
            status: response.status,
            html: await response.text()
        };
        $f5386a2d419882ba$var$includeFiles.set(src, res);
        return res;
    });
    $f5386a2d419882ba$var$includeFiles.set(src, fileDataPromise);
    return fileDataPromise;
}








var $5e6e64c6a0947883$export$3763f91cd7421336 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.mode = "cors";
        this.allowScripts = false;
    }
    executeScript(script) {
        const newScript = document.createElement("script");
        [
            ...script.attributes
        ].forEach((attr)=>newScript.setAttribute(attr.name, attr.value));
        newScript.textContent = script.textContent;
        script.parentNode.replaceChild(newScript, script);
    }
    async handleSrcChange() {
        try {
            const src = this.src;
            const file = await (0, $f5386a2d419882ba$export$9ffa5ba4f9903370)(src, this.mode);
            if (src !== this.src) return;
            if (!file.ok) {
                this.emit("sl-error", {
                    detail: {
                        status: file.status
                    }
                });
                return;
            }
            this.innerHTML = file.html;
            if (this.allowScripts) [
                ...this.querySelectorAll("script")
            ].forEach((script)=>this.executeScript(script));
            this.emit("sl-load");
        } catch (e) {
            this.emit("sl-error", {
                detail: {
                    status: -1
                }
            });
        }
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`<slot></slot>`;
    }
};
$5e6e64c6a0947883$export$3763f91cd7421336.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $5230a8396ab5b268$export$f4bf77a57e5a8c5a)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $5e6e64c6a0947883$export$3763f91cd7421336.prototype, "src", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $5e6e64c6a0947883$export$3763f91cd7421336.prototype, "mode", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "allow-scripts",
        type: Boolean
    })
], $5e6e64c6a0947883$export$3763f91cd7421336.prototype, "allowScripts", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("src")
], $5e6e64c6a0947883$export$3763f91cd7421336.prototype, "handleSrcChange", 1);


// src/components/include/include.ts
var $46f40c2759da92be$export$5696c319a2cfa384 = (0, $5e6e64c6a0947883$export$3763f91cd7421336);
(0, $5e6e64c6a0947883$export$3763f91cd7421336).define("sl-include");






// src/components/icon/icon.ts
var $85e36e6eb0abe7e3$export$21036209a317fcec = (0, $23ae34b1bd251d7a$export$ef62a86bf282441);
(0, $23ae34b1bd251d7a$export$ef62a86bf282441).define("sl-icon");



// src/components/icon-button/icon-button.ts
var $2ffe6f689d74a89d$export$9189df4c7423e03f = (0, $271ffb72cdd1ec73$export$302c9d29315a4659);
(0, $271ffb72cdd1ec73$export$302c9d29315a4659).define("sl-icon-button");








var $689a459330857413$export$48018c1aa12ba60a = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.value = 0;
        this.unit = "byte";
        this.display = "short";
    }
    render() {
        if (isNaN(this.value)) return "";
        const bitPrefixes = [
            "",
            "kilo",
            "mega",
            "giga",
            "tera"
        ];
        const bytePrefixes = [
            "",
            "kilo",
            "mega",
            "giga",
            "tera",
            "peta"
        ];
        const prefix = this.unit === "bit" ? bitPrefixes : bytePrefixes;
        const index = Math.max(0, Math.min(Math.floor(Math.log10(this.value) / 3), prefix.length - 1));
        const unit = prefix[index] + this.unit;
        const valueToFormat = parseFloat((this.value / Math.pow(1e3, index)).toPrecision(3));
        return this.localize.number(valueToFormat, {
            style: "unit",
            unit: unit,
            unitDisplay: this.display
        });
    }
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $689a459330857413$export$48018c1aa12ba60a.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $689a459330857413$export$48018c1aa12ba60a.prototype, "unit", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $689a459330857413$export$48018c1aa12ba60a.prototype, "display", 2);


// src/components/format-bytes/format-bytes.ts
var $0423f84045e0afdf$export$e847a7907a798712 = (0, $689a459330857413$export$48018c1aa12ba60a);
(0, $689a459330857413$export$48018c1aa12ba60a).define("sl-format-bytes");








var $82932c5f4b2de1b8$export$1f64a5020db30c66 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.date = /* @__PURE__ */ new Date();
        this.hourFormat = "auto";
    }
    render() {
        const date = new Date(this.date);
        const hour12 = this.hourFormat === "auto" ? void 0 : this.hourFormat === "12";
        if (isNaN(date.getMilliseconds())) return void 0;
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <time datetime=${date.toISOString()}>
        ${this.localize.date(date, {
            weekday: this.weekday,
            era: this.era,
            year: this.year,
            month: this.month,
            day: this.day,
            hour: this.hour,
            minute: this.minute,
            second: this.second,
            timeZoneName: this.timeZoneName,
            timeZone: this.timeZone,
            hour12: hour12
        })}
      </time>
    `;
    }
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $82932c5f4b2de1b8$export$1f64a5020db30c66.prototype, "date", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $82932c5f4b2de1b8$export$1f64a5020db30c66.prototype, "weekday", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $82932c5f4b2de1b8$export$1f64a5020db30c66.prototype, "era", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $82932c5f4b2de1b8$export$1f64a5020db30c66.prototype, "year", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $82932c5f4b2de1b8$export$1f64a5020db30c66.prototype, "month", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $82932c5f4b2de1b8$export$1f64a5020db30c66.prototype, "day", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $82932c5f4b2de1b8$export$1f64a5020db30c66.prototype, "hour", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $82932c5f4b2de1b8$export$1f64a5020db30c66.prototype, "minute", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $82932c5f4b2de1b8$export$1f64a5020db30c66.prototype, "second", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "time-zone-name"
    })
], $82932c5f4b2de1b8$export$1f64a5020db30c66.prototype, "timeZoneName", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "time-zone"
    })
], $82932c5f4b2de1b8$export$1f64a5020db30c66.prototype, "timeZone", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "hour-format"
    })
], $82932c5f4b2de1b8$export$1f64a5020db30c66.prototype, "hourFormat", 2);


// src/components/format-date/format-date.ts
var $c3e5cb2dbb88eef7$export$816b0e58342d24d6 = (0, $82932c5f4b2de1b8$export$1f64a5020db30c66);
(0, $82932c5f4b2de1b8$export$1f64a5020db30c66).define("sl-format-date");







var $4ad9625a57437628$export$a8f73d38bff4f4ea = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.value = 0;
        this.type = "decimal";
        this.noGrouping = false;
        this.currency = "USD";
        this.currencyDisplay = "symbol";
    }
    render() {
        if (isNaN(this.value)) return "";
        return this.localize.number(this.value, {
            style: this.type,
            currency: this.currency,
            currencyDisplay: this.currencyDisplay,
            useGrouping: !this.noGrouping,
            minimumIntegerDigits: this.minimumIntegerDigits,
            minimumFractionDigits: this.minimumFractionDigits,
            maximumFractionDigits: this.maximumFractionDigits,
            minimumSignificantDigits: this.minimumSignificantDigits,
            maximumSignificantDigits: this.maximumSignificantDigits
        });
    }
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $4ad9625a57437628$export$a8f73d38bff4f4ea.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $4ad9625a57437628$export$a8f73d38bff4f4ea.prototype, "type", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "no-grouping",
        type: Boolean
    })
], $4ad9625a57437628$export$a8f73d38bff4f4ea.prototype, "noGrouping", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $4ad9625a57437628$export$a8f73d38bff4f4ea.prototype, "currency", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "currency-display"
    })
], $4ad9625a57437628$export$a8f73d38bff4f4ea.prototype, "currencyDisplay", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "minimum-integer-digits",
        type: Number
    })
], $4ad9625a57437628$export$a8f73d38bff4f4ea.prototype, "minimumIntegerDigits", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "minimum-fraction-digits",
        type: Number
    })
], $4ad9625a57437628$export$a8f73d38bff4f4ea.prototype, "minimumFractionDigits", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "maximum-fraction-digits",
        type: Number
    })
], $4ad9625a57437628$export$a8f73d38bff4f4ea.prototype, "maximumFractionDigits", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "minimum-significant-digits",
        type: Number
    })
], $4ad9625a57437628$export$a8f73d38bff4f4ea.prototype, "minimumSignificantDigits", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "maximum-significant-digits",
        type: Number
    })
], $4ad9625a57437628$export$a8f73d38bff4f4ea.prototype, "maximumSignificantDigits", 2);


// src/components/format-number/format-number.ts
var $d41a4dbe04ee44c5$export$99e680f3ac54f5c0 = (0, $4ad9625a57437628$export$a8f73d38bff4f4ea);
(0, $4ad9625a57437628$export$a8f73d38bff4f4ea).define("sl-format-number");



// src/components/divider/divider.styles.ts

var $53601eb93191d72c$export$b895ad4e52a7056d = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --color: var(--sl-panel-border-color);
    --width: var(--sl-panel-border-width);
    --spacing: var(--sl-spacing-medium);
  }

  :host(:not([vertical])) {
    display: block;
    border-top: solid var(--width) var(--color);
    margin: var(--spacing) 0;
  }

  :host([vertical]) {
    display: inline-block;
    height: 100%;
    border-left: solid var(--width) var(--color);
    margin: 0 var(--spacing);
  }
`;







var $34e55c66c98f1354$export$b433b4df8768f10b = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.vertical = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "separator");
    }
    handleVerticalChange() {
        this.setAttribute("aria-orientation", this.vertical ? "vertical" : "horizontal");
    }
};
$34e55c66c98f1354$export$b433b4df8768f10b.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $53601eb93191d72c$export$b895ad4e52a7056d)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $34e55c66c98f1354$export$b433b4df8768f10b.prototype, "vertical", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("vertical")
], $34e55c66c98f1354$export$b433b4df8768f10b.prototype, "handleVerticalChange", 1);


// src/components/divider/divider.ts
var $85492fafe36b6b0b$export$2233c5fdcde64809 = (0, $34e55c66c98f1354$export$b433b4df8768f10b);
(0, $34e55c66c98f1354$export$b433b4df8768f10b).define("sl-divider");


// src/components/drawer/drawer.styles.ts

var $9b7dab9af78690b0$export$4f3376dc1560c358 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --size: 25rem;
    --header-spacing: var(--sl-spacing-large);
    --body-spacing: var(--sl-spacing-large);
    --footer-spacing: var(--sl-spacing-large);

    display: contents;
  }

  .drawer {
    top: 0;
    inset-inline-start: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: hidden;
  }

  .drawer--contained {
    position: absolute;
    z-index: initial;
  }

  .drawer--fixed {
    position: fixed;
    z-index: var(--sl-z-index-drawer);
  }

  .drawer__panel {
    position: absolute;
    display: flex;
    flex-direction: column;
    z-index: 2;
    max-width: 100%;
    max-height: 100%;
    background-color: var(--sl-panel-background-color);
    box-shadow: var(--sl-shadow-x-large);
    overflow: auto;
    pointer-events: all;
  }

  .drawer__panel:focus {
    outline: none;
  }

  .drawer--top .drawer__panel {
    top: 0;
    inset-inline-end: auto;
    bottom: auto;
    inset-inline-start: 0;
    width: 100%;
    height: var(--size);
  }

  .drawer--end .drawer__panel {
    top: 0;
    inset-inline-end: 0;
    bottom: auto;
    inset-inline-start: auto;
    width: var(--size);
    height: 100%;
  }

  .drawer--bottom .drawer__panel {
    top: auto;
    inset-inline-end: auto;
    bottom: 0;
    inset-inline-start: 0;
    width: 100%;
    height: var(--size);
  }

  .drawer--start .drawer__panel {
    top: 0;
    inset-inline-end: auto;
    bottom: auto;
    inset-inline-start: 0;
    width: var(--size);
    height: 100%;
  }

  .drawer__header {
    display: flex;
  }

  .drawer__title {
    flex: 1 1 auto;
    font: inherit;
    font-size: var(--sl-font-size-large);
    line-height: var(--sl-line-height-dense);
    padding: var(--header-spacing);
    margin: 0;
  }

  .drawer__header-actions {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    gap: var(--sl-spacing-2x-small);
    padding: 0 var(--header-spacing);
  }

  .drawer__header-actions sl-icon-button,
  .drawer__header-actions ::slotted(sl-icon-button) {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-medium);
  }

  .drawer__body {
    flex: 1 1 auto;
    display: block;
    padding: var(--body-spacing);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .drawer__footer {
    text-align: right;
    padding: var(--footer-spacing);
  }

  .drawer__footer ::slotted(sl-button:not(:last-of-type)) {
    margin-inline-end: var(--sl-spacing-x-small);
  }

  .drawer:not(.drawer--has-footer) .drawer__footer {
    display: none;
  }

  .drawer__overlay {
    display: block;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: var(--sl-overlay-background-color);
    pointer-events: all;
  }

  .drawer--contained .drawer__overlay {
    display: none;
  }

  @media (forced-colors: active) {
    .drawer__panel {
      border: solid 1px var(--sl-color-neutral-0);
    }
  }
`;


// src/internal/tabbable.ts
var $de157568efb30e33$var$computedStyleMap = /* @__PURE__ */ new WeakMap();
function $de157568efb30e33$var$getCachedComputedStyle(el) {
    let computedStyle = $de157568efb30e33$var$computedStyleMap.get(el);
    if (!computedStyle) {
        computedStyle = window.getComputedStyle(el, null);
        $de157568efb30e33$var$computedStyleMap.set(el, computedStyle);
    }
    return computedStyle;
}
function $de157568efb30e33$var$isVisible(el) {
    if (typeof el.checkVisibility === "function") return el.checkVisibility({
        checkOpacity: false,
        checkVisibilityCSS: true
    });
    const computedStyle = $de157568efb30e33$var$getCachedComputedStyle(el);
    return computedStyle.visibility !== "hidden" && computedStyle.display !== "none";
}
function $de157568efb30e33$var$isOverflowingAndTabbable(el) {
    const computedStyle = $de157568efb30e33$var$getCachedComputedStyle(el);
    const { overflowY: overflowY, overflowX: overflowX } = computedStyle;
    if (overflowY === "scroll" || overflowX === "scroll") return true;
    if (overflowY !== "auto" || overflowX !== "auto") return false;
    const isOverflowingY = el.scrollHeight > el.clientHeight;
    if (isOverflowingY && overflowY === "auto") return true;
    const isOverflowingX = el.scrollWidth > el.clientWidth;
    if (isOverflowingX && overflowX === "auto") return true;
    return false;
}
function $de157568efb30e33$var$isTabbable(el) {
    const tag = el.tagName.toLowerCase();
    const tabindex = Number(el.getAttribute("tabindex"));
    const hasTabindex = el.hasAttribute("tabindex");
    if (hasTabindex && (isNaN(tabindex) || tabindex <= -1)) return false;
    if (el.hasAttribute("disabled")) return false;
    if (el.closest("[inert]")) return false;
    if (tag === "input" && el.getAttribute("type") === "radio") {
        const rootNode = el.getRootNode();
        const findRadios = `input[type='radio'][name="${el.getAttribute("name")}"]`;
        const firstChecked = rootNode.querySelector(`${findRadios}:checked`);
        if (firstChecked) return firstChecked === el;
        const firstRadio = rootNode.querySelector(findRadios);
        return firstRadio === el;
    }
    if (!$de157568efb30e33$var$isVisible(el)) return false;
    if ((tag === "audio" || tag === "video") && el.hasAttribute("controls")) return true;
    if (el.hasAttribute("tabindex")) return true;
    if (el.hasAttribute("contenteditable") && el.getAttribute("contenteditable") !== "false") return true;
    const isNativelyTabbable = [
        "button",
        "input",
        "select",
        "textarea",
        "a",
        "audio",
        "video",
        "summary",
        "iframe"
    ].includes(tag);
    if (isNativelyTabbable) return true;
    return $de157568efb30e33$var$isOverflowingAndTabbable(el);
}
function $de157568efb30e33$export$16b821ece3e89e24(root) {
    var _a, _b;
    const tabbableElements = $de157568efb30e33$export$59a770a0e59b0dd2(root);
    const start = (_a = tabbableElements[0]) != null ? _a : null;
    const end = (_b = tabbableElements[tabbableElements.length - 1]) != null ? _b : null;
    return {
        start: start,
        end: end
    };
}
function $de157568efb30e33$var$getSlottedChildrenOutsideRootElement(slotElement, root) {
    var _a;
    return ((_a = slotElement.getRootNode({
        composed: true
    })) == null ? void 0 : _a.host) !== root;
}
function $de157568efb30e33$export$59a770a0e59b0dd2(root) {
    const walkedEls = /* @__PURE__ */ new WeakMap();
    const tabbableElements = [];
    function walk(el) {
        if (el instanceof Element) {
            if (el.hasAttribute("inert") || el.closest("[inert]")) return;
            if (walkedEls.has(el)) return;
            walkedEls.set(el, true);
            if (!tabbableElements.includes(el) && $de157568efb30e33$var$isTabbable(el)) tabbableElements.push(el);
            if (el instanceof HTMLSlotElement && $de157568efb30e33$var$getSlottedChildrenOutsideRootElement(el, root)) el.assignedElements({
                flatten: true
            }).forEach((assignedEl)=>{
                walk(assignedEl);
            });
            if (el.shadowRoot !== null && el.shadowRoot.mode === "open") walk(el.shadowRoot);
        }
        for (const e of el.children)walk(e);
    }
    walk(root);
    return tabbableElements.sort((a, b)=>{
        const aTabindex = Number(a.getAttribute("tabindex")) || 0;
        const bTabindex = Number(b.getAttribute("tabindex")) || 0;
        return bTabindex - aTabindex;
    });
}



// src/internal/active-elements.ts
function* $730c7360db8df4b5$var$activeElements(activeElement = document.activeElement) {
    if (activeElement === null || activeElement === void 0) return;
    yield activeElement;
    if ("shadowRoot" in activeElement && activeElement.shadowRoot && activeElement.shadowRoot.mode !== "closed") yield* (0, $1db749c92da399da$export$5590fd18e5672c2)($730c7360db8df4b5$var$activeElements(activeElement.shadowRoot.activeElement));
}
function $730c7360db8df4b5$var$getDeepestActiveElement() {
    return [
        ...$730c7360db8df4b5$var$activeElements()
    ].pop();
}
// src/internal/modal.ts
var $730c7360db8df4b5$var$activeModals = [];
var $730c7360db8df4b5$export$2b77a92f1a5ad772 = class {
    constructor(element){
        this.tabDirection = "forward";
        this.handleFocusIn = ()=>{
            if (!this.isActive()) return;
            this.checkFocus();
        };
        this.handleKeyDown = (event)=>{
            var _a;
            if (event.key !== "Tab" || this.isExternalActivated) return;
            if (!this.isActive()) return;
            const currentActiveElement = $730c7360db8df4b5$var$getDeepestActiveElement();
            this.previousFocus = currentActiveElement;
            if (this.previousFocus && this.possiblyHasTabbableChildren(this.previousFocus)) return;
            if (event.shiftKey) this.tabDirection = "backward";
            else this.tabDirection = "forward";
            const tabbableElements = (0, $de157568efb30e33$export$59a770a0e59b0dd2)(this.element);
            let currentFocusIndex = tabbableElements.findIndex((el)=>el === currentActiveElement);
            this.previousFocus = this.currentFocus;
            const addition = this.tabDirection === "forward" ? 1 : -1;
            while(true){
                if (currentFocusIndex + addition >= tabbableElements.length) currentFocusIndex = 0;
                else if (currentFocusIndex + addition < 0) currentFocusIndex = tabbableElements.length - 1;
                else currentFocusIndex += addition;
                this.previousFocus = this.currentFocus;
                const nextFocus = /** @type {HTMLElement} */ tabbableElements[currentFocusIndex];
                if (this.tabDirection === "backward") {
                    if (this.previousFocus && this.possiblyHasTabbableChildren(this.previousFocus)) return;
                }
                if (nextFocus && this.possiblyHasTabbableChildren(nextFocus)) return;
                event.preventDefault();
                this.currentFocus = nextFocus;
                (_a = this.currentFocus) == null || _a.focus({
                    preventScroll: false
                });
                const allActiveElements = [
                    ...$730c7360db8df4b5$var$activeElements()
                ];
                if (allActiveElements.includes(this.currentFocus) || !allActiveElements.includes(this.previousFocus)) break;
            }
            setTimeout(()=>this.checkFocus());
        };
        this.handleKeyUp = ()=>{
            this.tabDirection = "forward";
        };
        this.element = element;
        this.elementsWithTabbableControls = [
            "iframe"
        ];
    }
    /** Activates focus trapping. */ activate() {
        $730c7360db8df4b5$var$activeModals.push(this.element);
        document.addEventListener("focusin", this.handleFocusIn);
        document.addEventListener("keydown", this.handleKeyDown);
        document.addEventListener("keyup", this.handleKeyUp);
    }
    /** Deactivates focus trapping. */ deactivate() {
        $730c7360db8df4b5$var$activeModals = $730c7360db8df4b5$var$activeModals.filter((modal)=>modal !== this.element);
        this.currentFocus = null;
        document.removeEventListener("focusin", this.handleFocusIn);
        document.removeEventListener("keydown", this.handleKeyDown);
        document.removeEventListener("keyup", this.handleKeyUp);
    }
    /** Determines if this modal element is currently active or not. */ isActive() {
        return $730c7360db8df4b5$var$activeModals[$730c7360db8df4b5$var$activeModals.length - 1] === this.element;
    }
    /** Activates external modal behavior and temporarily disables focus trapping. */ activateExternal() {
        this.isExternalActivated = true;
    }
    /** Deactivates external modal behavior and re-enables focus trapping. */ deactivateExternal() {
        this.isExternalActivated = false;
    }
    checkFocus() {
        if (this.isActive() && !this.isExternalActivated) {
            const tabbableElements = (0, $de157568efb30e33$export$59a770a0e59b0dd2)(this.element);
            if (!this.element.matches(":focus-within")) {
                const start = tabbableElements[0];
                const end = tabbableElements[tabbableElements.length - 1];
                const target = this.tabDirection === "forward" ? start : end;
                if (typeof (target == null ? void 0 : target.focus) === "function") {
                    this.currentFocus = target;
                    target.focus({
                        preventScroll: false
                    });
                }
            }
        }
    }
    possiblyHasTabbableChildren(element) {
        return this.elementsWithTabbableControls.includes(element.tagName.toLowerCase()) || element.hasAttribute("controls");
    }
};

















// src/internal/string.ts
function $fe3d8887d72430c0$var$uppercaseFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
// src/components/drawer/drawer.component.ts
var $fe3d8887d72430c0$export$8cc049716d2b3764 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "footer");
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.modal = new (0, $730c7360db8df4b5$export$2b77a92f1a5ad772)(this);
        this.open = false;
        this.label = "";
        this.placement = "end";
        this.contained = false;
        this.noHeader = false;
        this.handleDocumentKeyDown = (event)=>{
            if (this.contained) return;
            if (event.key === "Escape" && this.modal.isActive() && this.open) {
                event.stopImmediatePropagation();
                this.requestClose("keyboard");
            }
        };
    }
    firstUpdated() {
        this.drawer.hidden = !this.open;
        if (this.open) {
            this.addOpenListeners();
            if (!this.contained) {
                this.modal.activate();
                (0, $50a04e78d1030c6e$export$5f4bd35c67f2403d)(this);
            }
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $50a04e78d1030c6e$export$7475b4759872c980)(this);
        this.removeOpenListeners();
    }
    requestClose(source) {
        const slRequestClose = this.emit("sl-request-close", {
            cancelable: true,
            detail: {
                source: source
            }
        });
        if (slRequestClose.defaultPrevented) {
            const animation = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "drawer.denyClose", {
                dir: this.localize.dir()
            });
            (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.panel, animation.keyframes, animation.options);
            return;
        }
        this.hide();
    }
    addOpenListeners() {
        var _a;
        if ("CloseWatcher" in window) {
            (_a = this.closeWatcher) == null || _a.destroy();
            if (!this.contained) {
                this.closeWatcher = new CloseWatcher();
                this.closeWatcher.onclose = ()=>this.requestClose("keyboard");
            }
        } else document.addEventListener("keydown", this.handleDocumentKeyDown);
    }
    removeOpenListeners() {
        var _a;
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
        (_a = this.closeWatcher) == null || _a.destroy();
    }
    async handleOpenChange() {
        if (this.open) {
            this.emit("sl-show");
            this.addOpenListeners();
            this.originalTrigger = document.activeElement;
            if (!this.contained) {
                this.modal.activate();
                (0, $50a04e78d1030c6e$export$5f4bd35c67f2403d)(this);
            }
            const autoFocusTarget = this.querySelector("[autofocus]");
            if (autoFocusTarget) autoFocusTarget.removeAttribute("autofocus");
            await Promise.all([
                (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.drawer),
                (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.overlay)
            ]);
            this.drawer.hidden = false;
            requestAnimationFrame(()=>{
                const slInitialFocus = this.emit("sl-initial-focus", {
                    cancelable: true
                });
                if (!slInitialFocus.defaultPrevented) {
                    if (autoFocusTarget) autoFocusTarget.focus({
                        preventScroll: true
                    });
                    else this.panel.focus({
                        preventScroll: true
                    });
                }
                if (autoFocusTarget) autoFocusTarget.setAttribute("autofocus", "");
            });
            const panelAnimation = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, `drawer.show${$fe3d8887d72430c0$var$uppercaseFirstLetter(this.placement)}`, {
                dir: this.localize.dir()
            });
            const overlayAnimation = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "drawer.overlay.show", {
                dir: this.localize.dir()
            });
            await Promise.all([
                (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.panel, panelAnimation.keyframes, panelAnimation.options),
                (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.overlay, overlayAnimation.keyframes, overlayAnimation.options)
            ]);
            this.emit("sl-after-show");
        } else {
            this.emit("sl-hide");
            this.removeOpenListeners();
            if (!this.contained) {
                this.modal.deactivate();
                (0, $50a04e78d1030c6e$export$7475b4759872c980)(this);
            }
            await Promise.all([
                (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.drawer),
                (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.overlay)
            ]);
            const panelAnimation = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, `drawer.hide${$fe3d8887d72430c0$var$uppercaseFirstLetter(this.placement)}`, {
                dir: this.localize.dir()
            });
            const overlayAnimation = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "drawer.overlay.hide", {
                dir: this.localize.dir()
            });
            await Promise.all([
                (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.overlay, overlayAnimation.keyframes, overlayAnimation.options).then(()=>{
                    this.overlay.hidden = true;
                }),
                (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.panel, panelAnimation.keyframes, panelAnimation.options).then(()=>{
                    this.panel.hidden = true;
                })
            ]);
            this.drawer.hidden = true;
            this.overlay.hidden = false;
            this.panel.hidden = false;
            const trigger = this.originalTrigger;
            if (typeof (trigger == null ? void 0 : trigger.focus) === "function") setTimeout(()=>trigger.focus());
            this.emit("sl-after-hide");
        }
    }
    handleNoModalChange() {
        if (this.open && !this.contained) {
            this.modal.activate();
            (0, $50a04e78d1030c6e$export$5f4bd35c67f2403d)(this);
        }
        if (this.open && this.contained) {
            this.modal.deactivate();
            (0, $50a04e78d1030c6e$export$7475b4759872c980)(this);
        }
    }
    /** Shows the drawer. */ async show() {
        if (this.open) return void 0;
        this.open = true;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the drawer */ async hide() {
        if (!this.open) return void 0;
        this.open = false;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            drawer: true,
            "drawer--open": this.open,
            "drawer--top": this.placement === "top",
            "drawer--end": this.placement === "end",
            "drawer--bottom": this.placement === "bottom",
            "drawer--start": this.placement === "start",
            "drawer--contained": this.contained,
            "drawer--fixed": !this.contained,
            "drawer--rtl": this.localize.dir() === "rtl",
            "drawer--has-footer": this.hasSlotController.test("footer")
        })}
      >
        <div part="overlay" class="drawer__overlay" @click=${()=>this.requestClose("overlay")} tabindex="-1"></div>

        <div
          part="panel"
          class="drawer__panel"
          role="dialog"
          aria-modal="true"
          aria-hidden=${this.open ? "false" : "true"}
          aria-label=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.noHeader ? this.label : void 0)}
          aria-labelledby=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(!this.noHeader ? "title" : void 0)}
          tabindex="0"
        >
          ${!this.noHeader ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                <header part="header" class="drawer__header">
                  <h2 part="title" class="drawer__title" id="title">
                    <!-- If there's no label, use an invisible character to prevent the header from collapsing -->
                    <slot name="label"> ${this.label.length > 0 ? this.label : String.fromCharCode(65279)} </slot>
                  </h2>
                  <div part="header-actions" class="drawer__header-actions">
                    <slot name="header-actions"></slot>
                    <sl-icon-button
                      part="close-button"
                      exportparts="base:close-button__base"
                      class="drawer__close"
                      name="x-lg"
                      label=${this.localize.term("close")}
                      library="system"
                      @click=${()=>this.requestClose("close-button")}
                    ></sl-icon-button>
                  </div>
                </header>
              ` : ""}

          <slot part="body" class="drawer__body"></slot>

          <footer part="footer" class="drawer__footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    `;
    }
};
$fe3d8887d72430c0$export$8cc049716d2b3764.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $9b7dab9af78690b0$export$4f3376dc1560c358)
];
$fe3d8887d72430c0$export$8cc049716d2b3764.dependencies = {
    "sl-icon-button": (0, $271ffb72cdd1ec73$export$302c9d29315a4659)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".drawer")
], $fe3d8887d72430c0$export$8cc049716d2b3764.prototype, "drawer", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".drawer__panel")
], $fe3d8887d72430c0$export$8cc049716d2b3764.prototype, "panel", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".drawer__overlay")
], $fe3d8887d72430c0$export$8cc049716d2b3764.prototype, "overlay", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $fe3d8887d72430c0$export$8cc049716d2b3764.prototype, "open", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $fe3d8887d72430c0$export$8cc049716d2b3764.prototype, "label", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $fe3d8887d72430c0$export$8cc049716d2b3764.prototype, "placement", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $fe3d8887d72430c0$export$8cc049716d2b3764.prototype, "contained", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "no-header",
        type: Boolean,
        reflect: true
    })
], $fe3d8887d72430c0$export$8cc049716d2b3764.prototype, "noHeader", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $fe3d8887d72430c0$export$8cc049716d2b3764.prototype, "handleOpenChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("contained", {
        waitUntilFirstUpdate: true
    })
], $fe3d8887d72430c0$export$8cc049716d2b3764.prototype, "handleNoModalChange", 1);
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("drawer.showTop", {
    keyframes: [
        {
            opacity: 0,
            translate: "0 -100%"
        },
        {
            opacity: 1,
            translate: "0 0"
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("drawer.hideTop", {
    keyframes: [
        {
            opacity: 1,
            translate: "0 0"
        },
        {
            opacity: 0,
            translate: "0 -100%"
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("drawer.showEnd", {
    keyframes: [
        {
            opacity: 0,
            translate: "100%"
        },
        {
            opacity: 1,
            translate: "0"
        }
    ],
    rtlKeyframes: [
        {
            opacity: 0,
            translate: "-100%"
        },
        {
            opacity: 1,
            translate: "0"
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("drawer.hideEnd", {
    keyframes: [
        {
            opacity: 1,
            translate: "0"
        },
        {
            opacity: 0,
            translate: "100%"
        }
    ],
    rtlKeyframes: [
        {
            opacity: 1,
            translate: "0"
        },
        {
            opacity: 0,
            translate: "-100%"
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("drawer.showBottom", {
    keyframes: [
        {
            opacity: 0,
            translate: "0 100%"
        },
        {
            opacity: 1,
            translate: "0 0"
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("drawer.hideBottom", {
    keyframes: [
        {
            opacity: 1,
            translate: "0 0"
        },
        {
            opacity: 0,
            translate: "0 100%"
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("drawer.showStart", {
    keyframes: [
        {
            opacity: 0,
            translate: "-100%"
        },
        {
            opacity: 1,
            translate: "0"
        }
    ],
    rtlKeyframes: [
        {
            opacity: 0,
            translate: "100%"
        },
        {
            opacity: 1,
            translate: "0"
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("drawer.hideStart", {
    keyframes: [
        {
            opacity: 1,
            translate: "0"
        },
        {
            opacity: 0,
            translate: "-100%"
        }
    ],
    rtlKeyframes: [
        {
            opacity: 1,
            translate: "0"
        },
        {
            opacity: 0,
            translate: "100%"
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("drawer.denyClose", {
    keyframes: [
        {
            scale: 1
        },
        {
            scale: 1.01
        },
        {
            scale: 1
        }
    ],
    options: {
        duration: 250
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("drawer.overlay.show", {
    keyframes: [
        {
            opacity: 0
        },
        {
            opacity: 1
        }
    ],
    options: {
        duration: 250
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("drawer.overlay.hide", {
    keyframes: [
        {
            opacity: 1
        },
        {
            opacity: 0
        }
    ],
    options: {
        duration: 250
    }
});


// src/components/drawer/drawer.ts
var $2441260f56cd8f74$export$646d488571dfa859 = (0, $fe3d8887d72430c0$export$8cc049716d2b3764);
(0, $fe3d8887d72430c0$export$8cc049716d2b3764).define("sl-drawer");




// src/components/dropdown/dropdown.styles.ts

var $4df6959c24f447d4$export$f4bf7ae608597dd = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
  }

  .dropdown::part(popup) {
    z-index: var(--sl-z-index-dropdown);
  }

  .dropdown[data-current-placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .dropdown[data-current-placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .dropdown[data-current-placement^='left']::part(popup) {
    transform-origin: right;
  }

  .dropdown[data-current-placement^='right']::part(popup) {
    transform-origin: left;
  }

  .dropdown__trigger {
    display: block;
  }

  .dropdown__panel {
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    box-shadow: var(--sl-shadow-large);
    border-radius: var(--sl-border-radius-medium);
    pointer-events: none;
  }

  .dropdown--open .dropdown__panel {
    display: block;
    pointer-events: all;
  }

  /* When users slot a menu, make sure it conforms to the popup's auto-size */
  ::slotted(sl-menu) {
    max-width: var(--auto-size-available-width) !important;
    max-height: var(--auto-size-available-height) !important;
  }
`;
















var $953fa65c0972af7b$export$d9f5b7dd140b6839 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.open = false;
        this.placement = "bottom-start";
        this.disabled = false;
        this.stayOpenOnSelect = false;
        this.distance = 0;
        this.skidding = 0;
        this.hoist = false;
        this.sync = void 0;
        this.handleKeyDown = (event)=>{
            if (this.open && event.key === "Escape") {
                event.stopPropagation();
                this.hide();
                this.focusOnTrigger();
            }
        };
        this.handleDocumentKeyDown = (event)=>{
            var _a;
            if (event.key === "Escape" && this.open && !this.closeWatcher) {
                event.stopPropagation();
                this.focusOnTrigger();
                this.hide();
                return;
            }
            if (event.key === "Tab") {
                if (this.open && ((_a = document.activeElement) == null ? void 0 : _a.tagName.toLowerCase()) === "sl-menu-item") {
                    event.preventDefault();
                    this.hide();
                    this.focusOnTrigger();
                    return;
                }
                setTimeout(()=>{
                    var _a2, _b, _c;
                    const activeElement = ((_a2 = this.containingElement) == null ? void 0 : _a2.getRootNode()) instanceof ShadowRoot ? (_c = (_b = document.activeElement) == null ? void 0 : _b.shadowRoot) == null ? void 0 : _c.activeElement : document.activeElement;
                    if (!this.containingElement || (activeElement == null ? void 0 : activeElement.closest(this.containingElement.tagName.toLowerCase())) !== this.containingElement) this.hide();
                });
            }
        };
        this.handleDocumentMouseDown = (event)=>{
            const path = event.composedPath();
            if (this.containingElement && !path.includes(this.containingElement)) this.hide();
        };
        this.handlePanelSelect = (event)=>{
            const target = event.target;
            if (!this.stayOpenOnSelect && target.tagName.toLowerCase() === "sl-menu") {
                this.hide();
                this.focusOnTrigger();
            }
        };
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.containingElement) this.containingElement = this;
    }
    firstUpdated() {
        this.panel.hidden = !this.open;
        if (this.open) {
            this.addOpenListeners();
            this.popup.active = true;
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeOpenListeners();
        this.hide();
    }
    focusOnTrigger() {
        const trigger = this.trigger.assignedElements({
            flatten: true
        })[0];
        if (typeof (trigger == null ? void 0 : trigger.focus) === "function") trigger.focus();
    }
    getMenu() {
        return this.panel.assignedElements({
            flatten: true
        }).find((el)=>el.tagName.toLowerCase() === "sl-menu");
    }
    handleTriggerClick() {
        if (this.open) this.hide();
        else {
            this.show();
            this.focusOnTrigger();
        }
    }
    async handleTriggerKeyDown(event) {
        if ([
            " ",
            "Enter"
        ].includes(event.key)) {
            event.preventDefault();
            this.handleTriggerClick();
            return;
        }
        const menu = this.getMenu();
        if (menu) {
            const menuItems = menu.getAllItems();
            const firstMenuItem = menuItems[0];
            const lastMenuItem = menuItems[menuItems.length - 1];
            if ([
                "ArrowDown",
                "ArrowUp",
                "Home",
                "End"
            ].includes(event.key)) {
                event.preventDefault();
                if (!this.open) {
                    this.show();
                    await this.updateComplete;
                }
                if (menuItems.length > 0) this.updateComplete.then(()=>{
                    if (event.key === "ArrowDown" || event.key === "Home") {
                        menu.setCurrentItem(firstMenuItem);
                        firstMenuItem.focus();
                    }
                    if (event.key === "ArrowUp" || event.key === "End") {
                        menu.setCurrentItem(lastMenuItem);
                        lastMenuItem.focus();
                    }
                });
            }
        }
    }
    handleTriggerKeyUp(event) {
        if (event.key === " ") event.preventDefault();
    }
    handleTriggerSlotChange() {
        this.updateAccessibleTrigger();
    }
    //
    // Slotted triggers can be arbitrary content, but we need to link them to the dropdown panel with `aria-haspopup` and
    // `aria-expanded`. These must be applied to the "accessible trigger" (the tabbable portion of the trigger element
    // that gets slotted in) so screen readers will understand them. The accessible trigger could be the slotted element,
    // a child of the slotted element, or an element in the slotted element's shadow root.
    //
    // For example, the accessible trigger of an <sl-button> is a <button> located inside its shadow root.
    //
    // To determine this, we assume the first tabbable element in the trigger slot is the "accessible trigger."
    //
    updateAccessibleTrigger() {
        const assignedElements = this.trigger.assignedElements({
            flatten: true
        });
        const accessibleTrigger = assignedElements.find((el)=>(0, $de157568efb30e33$export$16b821ece3e89e24)(el).start);
        let target;
        if (accessibleTrigger) {
            switch(accessibleTrigger.tagName.toLowerCase()){
                // Shoelace buttons have to update the internal button so it's announced correctly by screen readers
                case "sl-button":
                case "sl-icon-button":
                    target = accessibleTrigger.button;
                    break;
                default:
                    target = accessibleTrigger;
            }
            target.setAttribute("aria-haspopup", "true");
            target.setAttribute("aria-expanded", this.open ? "true" : "false");
        }
    }
    /** Shows the dropdown panel. */ async show() {
        if (this.open) return void 0;
        this.open = true;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the dropdown panel */ async hide() {
        if (!this.open) return void 0;
        this.open = false;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    /**
   * Instructs the dropdown menu to reposition. Useful when the position or size of the trigger changes when the menu
   * is activated.
   */ reposition() {
        this.popup.reposition();
    }
    addOpenListeners() {
        var _a;
        this.panel.addEventListener("sl-select", this.handlePanelSelect);
        if ("CloseWatcher" in window) {
            (_a = this.closeWatcher) == null || _a.destroy();
            this.closeWatcher = new CloseWatcher();
            this.closeWatcher.onclose = ()=>{
                this.hide();
                this.focusOnTrigger();
            };
        } else this.panel.addEventListener("keydown", this.handleKeyDown);
        document.addEventListener("keydown", this.handleDocumentKeyDown);
        document.addEventListener("mousedown", this.handleDocumentMouseDown);
    }
    removeOpenListeners() {
        var _a;
        if (this.panel) {
            this.panel.removeEventListener("sl-select", this.handlePanelSelect);
            this.panel.removeEventListener("keydown", this.handleKeyDown);
        }
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
        document.removeEventListener("mousedown", this.handleDocumentMouseDown);
        (_a = this.closeWatcher) == null || _a.destroy();
    }
    async handleOpenChange() {
        if (this.disabled) {
            this.open = false;
            return;
        }
        this.updateAccessibleTrigger();
        if (this.open) {
            this.emit("sl-show");
            this.addOpenListeners();
            await (0, $41facc830b5907b7$export$ad12f740028ccbea)(this);
            this.panel.hidden = false;
            this.popup.active = true;
            const { keyframes: keyframes, options: options } = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "dropdown.show", {
                dir: this.localize.dir()
            });
            await (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.popup.popup, keyframes, options);
            this.emit("sl-after-show");
        } else {
            this.emit("sl-hide");
            this.removeOpenListeners();
            await (0, $41facc830b5907b7$export$ad12f740028ccbea)(this);
            const { keyframes: keyframes, options: options } = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "dropdown.hide", {
                dir: this.localize.dir()
            });
            await (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.popup.popup, keyframes, options);
            this.panel.hidden = true;
            this.popup.active = false;
            this.emit("sl-after-hide");
        }
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <sl-popup
        part="base"
        exportparts="popup:base__popup"
        id="dropdown"
        placement=${this.placement}
        distance=${this.distance}
        skidding=${this.skidding}
        strategy=${this.hoist ? "fixed" : "absolute"}
        flip
        shift
        auto-size="vertical"
        auto-size-padding="10"
        sync=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.sync ? this.sync : void 0)}
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            dropdown: true,
            "dropdown--open": this.open
        })}
      >
        <slot
          name="trigger"
          slot="anchor"
          part="trigger"
          class="dropdown__trigger"
          @click=${this.handleTriggerClick}
          @keydown=${this.handleTriggerKeyDown}
          @keyup=${this.handleTriggerKeyUp}
          @slotchange=${this.handleTriggerSlotChange}
        ></slot>

        <div aria-hidden=${this.open ? "false" : "true"} aria-labelledby="dropdown">
          <slot part="panel" class="dropdown__panel"></slot>
        </div>
      </sl-popup>
    `;
    }
};
$953fa65c0972af7b$export$d9f5b7dd140b6839.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $4df6959c24f447d4$export$f4bf7ae608597dd)
];
$953fa65c0972af7b$export$d9f5b7dd140b6839.dependencies = {
    "sl-popup": (0, $2cc723b992cc8b8e$export$6fe469f0a31d1d6e)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".dropdown")
], $953fa65c0972af7b$export$d9f5b7dd140b6839.prototype, "popup", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".dropdown__trigger")
], $953fa65c0972af7b$export$d9f5b7dd140b6839.prototype, "trigger", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".dropdown__panel")
], $953fa65c0972af7b$export$d9f5b7dd140b6839.prototype, "panel", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $953fa65c0972af7b$export$d9f5b7dd140b6839.prototype, "open", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $953fa65c0972af7b$export$d9f5b7dd140b6839.prototype, "placement", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $953fa65c0972af7b$export$d9f5b7dd140b6839.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "stay-open-on-select",
        type: Boolean,
        reflect: true
    })
], $953fa65c0972af7b$export$d9f5b7dd140b6839.prototype, "stayOpenOnSelect", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: false
    })
], $953fa65c0972af7b$export$d9f5b7dd140b6839.prototype, "containingElement", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $953fa65c0972af7b$export$d9f5b7dd140b6839.prototype, "distance", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $953fa65c0972af7b$export$d9f5b7dd140b6839.prototype, "skidding", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $953fa65c0972af7b$export$d9f5b7dd140b6839.prototype, "hoist", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $953fa65c0972af7b$export$d9f5b7dd140b6839.prototype, "sync", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $953fa65c0972af7b$export$d9f5b7dd140b6839.prototype, "handleOpenChange", 1);
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("dropdown.show", {
    keyframes: [
        {
            opacity: 0,
            scale: 0.9
        },
        {
            opacity: 1,
            scale: 1
        }
    ],
    options: {
        duration: 100,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("dropdown.hide", {
    keyframes: [
        {
            opacity: 1,
            scale: 1
        },
        {
            opacity: 0,
            scale: 0.9
        }
    ],
    options: {
        duration: 100,
        easing: "ease"
    }
});


// src/components/dropdown/dropdown.ts
var $065ee2458aa6914f$export$3bd981faadafe0b3 = (0, $953fa65c0972af7b$export$d9f5b7dd140b6839);
(0, $953fa65c0972af7b$export$d9f5b7dd140b6839).define("sl-dropdown");



// src/components/copy-button/copy-button.styles.ts

var $d3b95e8dbee4d269$export$be848da26d1aa7b = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --error-color: var(--sl-color-danger-600);
    --success-color: var(--sl-color-success-600);

    display: inline-block;
  }

  .copy-button__button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    font-size: inherit;
    color: inherit;
    padding: var(--sl-spacing-x-small);
    cursor: pointer;
    transition: var(--sl-transition-x-fast) color;
  }

  .copy-button--success .copy-button__button {
    color: var(--success-color);
  }

  .copy-button--error .copy-button__button {
    color: var(--error-color);
  }

  .copy-button__button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .copy-button__button[disabled] {
    opacity: 0.5;
    cursor: not-allowed !important;
  }

  slot {
    display: inline-flex;
  }
`;











var $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.isCopying = false;
        this.status = "rest";
        this.value = "";
        this.from = "";
        this.disabled = false;
        this.copyLabel = "";
        this.successLabel = "";
        this.errorLabel = "";
        this.feedbackDuration = 1e3;
        this.tooltipPlacement = "top";
        this.hoist = false;
    }
    async handleCopy() {
        if (this.disabled || this.isCopying) return;
        this.isCopying = true;
        let valueToCopy = this.value;
        if (this.from) {
            const root = this.getRootNode();
            const isProperty = this.from.includes(".");
            const isAttribute = this.from.includes("[") && this.from.includes("]");
            let id = this.from;
            let field = "";
            if (isProperty) [id, field] = this.from.trim().split(".");
            else if (isAttribute) [id, field] = this.from.trim().replace(/\]$/, "").split("[");
            const target = "getElementById" in root ? root.getElementById(id) : null;
            if (target) {
                if (isAttribute) valueToCopy = target.getAttribute(field) || "";
                else if (isProperty) valueToCopy = target[field] || "";
                else valueToCopy = target.textContent || "";
            } else {
                this.showStatus("error");
                this.emit("sl-error");
            }
        }
        if (!valueToCopy) {
            this.showStatus("error");
            this.emit("sl-error");
        } else try {
            await navigator.clipboard.writeText(valueToCopy);
            this.showStatus("success");
            this.emit("sl-copy", {
                detail: {
                    value: valueToCopy
                }
            });
        } catch (error) {
            this.showStatus("error");
            this.emit("sl-error");
        }
    }
    async showStatus(status) {
        const copyLabel = this.copyLabel || this.localize.term("copy");
        const successLabel = this.successLabel || this.localize.term("copied");
        const errorLabel = this.errorLabel || this.localize.term("error");
        const iconToShow = status === "success" ? this.successIcon : this.errorIcon;
        const showAnimation = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "copy.in", {
            dir: "ltr"
        });
        const hideAnimation = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "copy.out", {
            dir: "ltr"
        });
        this.tooltip.content = status === "success" ? successLabel : errorLabel;
        await this.copyIcon.animate(hideAnimation.keyframes, hideAnimation.options).finished;
        this.copyIcon.hidden = true;
        this.status = status;
        iconToShow.hidden = false;
        await iconToShow.animate(showAnimation.keyframes, showAnimation.options).finished;
        setTimeout(async ()=>{
            await iconToShow.animate(hideAnimation.keyframes, hideAnimation.options).finished;
            iconToShow.hidden = true;
            this.status = "rest";
            this.copyIcon.hidden = false;
            await this.copyIcon.animate(showAnimation.keyframes, showAnimation.options).finished;
            this.tooltip.content = copyLabel;
            this.isCopying = false;
        }, this.feedbackDuration);
    }
    render() {
        const copyLabel = this.copyLabel || this.localize.term("copy");
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <sl-tooltip
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "copy-button": true,
            "copy-button--success": this.status === "success",
            "copy-button--error": this.status === "error"
        })}
        content=${copyLabel}
        placement=${this.tooltipPlacement}
        ?disabled=${this.disabled}
        ?hoist=${this.hoist}
        exportparts="
          base:tooltip__base,
          base__popup:tooltip__base__popup,
          base__arrow:tooltip__base__arrow,
          body:tooltip__body
        "
      >
        <button
          class="copy-button__button"
          part="button"
          type="button"
          ?disabled=${this.disabled}
          @click=${this.handleCopy}
        >
          <slot part="copy-icon" name="copy-icon">
            <sl-icon library="system" name="copy"></sl-icon>
          </slot>
          <slot part="success-icon" name="success-icon" hidden>
            <sl-icon library="system" name="check"></sl-icon>
          </slot>
          <slot part="error-icon" name="error-icon" hidden>
            <sl-icon library="system" name="x-lg"></sl-icon>
          </slot>
        </button>
      </sl-tooltip>
    `;
    }
};
$5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $d3b95e8dbee4d269$export$be848da26d1aa7b)
];
$5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441),
    "sl-tooltip": (0, $bbedfcf7c7dc3bd9$export$2c14a50cec0c625c)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)('slot[name="copy-icon"]')
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "copyIcon", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)('slot[name="success-icon"]')
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "successIcon", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)('slot[name="error-icon"]')
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "errorIcon", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("sl-tooltip")
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "tooltip", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "isCopying", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "status", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "from", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "copy-label"
    })
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "copyLabel", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "success-label"
    })
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "successLabel", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "error-label"
    })
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "errorLabel", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "feedback-duration",
        type: Number
    })
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "feedbackDuration", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "tooltip-placement"
    })
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "tooltipPlacement", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9.prototype, "hoist", 2);
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("copy.in", {
    keyframes: [
        {
            scale: ".25",
            opacity: ".25"
        },
        {
            scale: "1",
            opacity: "1"
        }
    ],
    options: {
        duration: 100
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("copy.out", {
    keyframes: [
        {
            scale: "1",
            opacity: "1"
        },
        {
            scale: ".25",
            opacity: "0"
        }
    ],
    options: {
        duration: 100
    }
});


// src/components/copy-button/copy-button.ts
var $1b64fb0b90fdf447$export$5a536daf0b60de0b = (0, $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9);
(0, $5dcad5dc07dde58b$export$dbbe9bb6795b7fd9).define("sl-copy-button");


// src/components/details/details.styles.ts

var $e70ce3502dcecb5a$export$e0460a263d3b7bef = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  .details {
    border: solid 1px var(--sl-color-neutral-200);
    border-radius: var(--sl-border-radius-medium);
    background-color: var(--sl-color-neutral-0);
    overflow-anchor: none;
  }

  .details--disabled {
    opacity: 0.5;
  }

  .details__header {
    display: flex;
    align-items: center;
    border-radius: inherit;
    padding: var(--sl-spacing-medium);
    user-select: none;
    -webkit-user-select: none;
    cursor: pointer;
  }

  .details__header::-webkit-details-marker {
    display: none;
  }

  .details__header:focus {
    outline: none;
  }

  .details__header:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: calc(1px + var(--sl-focus-ring-offset));
  }

  .details--disabled .details__header {
    cursor: not-allowed;
  }

  .details--disabled .details__header:focus-visible {
    outline: none;
    box-shadow: none;
  }

  .details__summary {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
  }

  .details__summary-icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    transition: var(--sl-transition-medium) rotate ease;
  }

  .details--open .details__summary-icon {
    rotate: 90deg;
  }

  .details--open.details--rtl .details__summary-icon {
    rotate: -90deg;
  }

  .details--open slot[name='expand-icon'],
  .details:not(.details--open) slot[name='collapse-icon'] {
    display: none;
  }

  .details__body {
    overflow: hidden;
  }

  .details__content {
    display: block;
    padding: var(--sl-spacing-medium);
  }
`;














var $646d04d922c04158$export$ada524cc60438dd5 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.open = false;
        this.disabled = false;
    }
    firstUpdated() {
        this.body.style.height = this.open ? "auto" : "0";
        if (this.open) this.details.open = true;
        this.detailsObserver = new MutationObserver((changes)=>{
            for (const change of changes)if (change.type === "attributes" && change.attributeName === "open") {
                if (this.details.open) this.show();
                else this.hide();
            }
        });
        this.detailsObserver.observe(this.details, {
            attributes: true
        });
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.detailsObserver) == null || _a.disconnect();
    }
    handleSummaryClick(event) {
        event.preventDefault();
        if (!this.disabled) {
            if (this.open) this.hide();
            else this.show();
            this.header.focus();
        }
    }
    handleSummaryKeyDown(event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            if (this.open) this.hide();
            else this.show();
        }
        if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
            event.preventDefault();
            this.hide();
        }
        if (event.key === "ArrowDown" || event.key === "ArrowRight") {
            event.preventDefault();
            this.show();
        }
    }
    async handleOpenChange() {
        if (this.open) {
            this.details.open = true;
            const slShow = this.emit("sl-show", {
                cancelable: true
            });
            if (slShow.defaultPrevented) {
                this.open = false;
                this.details.open = false;
                return;
            }
            await (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.body);
            const { keyframes: keyframes, options: options } = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "details.show", {
                dir: this.localize.dir()
            });
            await (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.body, (0, $41facc830b5907b7$export$783a9b5bf095072a)(keyframes, this.body.scrollHeight), options);
            this.body.style.height = "auto";
            this.emit("sl-after-show");
        } else {
            const slHide = this.emit("sl-hide", {
                cancelable: true
            });
            if (slHide.defaultPrevented) {
                this.details.open = true;
                this.open = true;
                return;
            }
            await (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.body);
            const { keyframes: keyframes, options: options } = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "details.hide", {
                dir: this.localize.dir()
            });
            await (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.body, (0, $41facc830b5907b7$export$783a9b5bf095072a)(keyframes, this.body.scrollHeight), options);
            this.body.style.height = "auto";
            this.details.open = false;
            this.emit("sl-after-hide");
        }
    }
    /** Shows the details. */ async show() {
        if (this.open || this.disabled) return void 0;
        this.open = true;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the details */ async hide() {
        if (!this.open || this.disabled) return void 0;
        this.open = false;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    render() {
        const isRtl = this.localize.dir() === "rtl";
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <details
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            details: true,
            "details--open": this.open,
            "details--disabled": this.disabled,
            "details--rtl": isRtl
        })}
      >
        <summary
          part="header"
          id="header"
          class="details__header"
          role="button"
          aria-expanded=${this.open ? "true" : "false"}
          aria-controls="content"
          aria-disabled=${this.disabled ? "true" : "false"}
          tabindex=${this.disabled ? "-1" : "0"}
          @click=${this.handleSummaryClick}
          @keydown=${this.handleSummaryKeyDown}
        >
          <slot name="summary" part="summary" class="details__summary">${this.summary}</slot>

          <span part="summary-icon" class="details__summary-icon">
            <slot name="expand-icon">
              <sl-icon library="system" name=${isRtl ? "chevron-left" : "chevron-right"}></sl-icon>
            </slot>
            <slot name="collapse-icon">
              <sl-icon library="system" name=${isRtl ? "chevron-left" : "chevron-right"}></sl-icon>
            </slot>
          </span>
        </summary>

        <div class="details__body" role="region" aria-labelledby="header">
          <slot part="content" id="content" class="details__content"></slot>
        </div>
      </details>
    `;
    }
};
$646d04d922c04158$export$ada524cc60438dd5.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $e70ce3502dcecb5a$export$e0460a263d3b7bef)
];
$646d04d922c04158$export$ada524cc60438dd5.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".details")
], $646d04d922c04158$export$ada524cc60438dd5.prototype, "details", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".details__header")
], $646d04d922c04158$export$ada524cc60438dd5.prototype, "header", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".details__body")
], $646d04d922c04158$export$ada524cc60438dd5.prototype, "body", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".details__expand-icon-slot")
], $646d04d922c04158$export$ada524cc60438dd5.prototype, "expandIconSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $646d04d922c04158$export$ada524cc60438dd5.prototype, "open", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $646d04d922c04158$export$ada524cc60438dd5.prototype, "summary", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $646d04d922c04158$export$ada524cc60438dd5.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $646d04d922c04158$export$ada524cc60438dd5.prototype, "handleOpenChange", 1);
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("details.show", {
    keyframes: [
        {
            height: "0",
            opacity: "0"
        },
        {
            height: "auto",
            opacity: "1"
        }
    ],
    options: {
        duration: 250,
        easing: "linear"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("details.hide", {
    keyframes: [
        {
            height: "auto",
            opacity: "1"
        },
        {
            height: "0",
            opacity: "0"
        }
    ],
    options: {
        duration: 250,
        easing: "linear"
    }
});


// src/components/details/details.ts
var $ba7c5e5162d1b641$export$991e1c3cf581681b = (0, $646d04d922c04158$export$ada524cc60438dd5);
(0, $646d04d922c04158$export$ada524cc60438dd5).define("sl-details");






// src/components/dialog/dialog.styles.ts

var $0fa306157451a9b0$export$b752f4490c3ab6b1 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --width: 31rem;
    --header-spacing: var(--sl-spacing-large);
    --body-spacing: var(--sl-spacing-large);
    --footer-spacing: var(--sl-spacing-large);

    display: contents;
  }

  .dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: var(--sl-z-index-dialog);
  }

  .dialog__panel {
    display: flex;
    flex-direction: column;
    z-index: 2;
    width: var(--width);
    max-width: calc(100% - var(--sl-spacing-2x-large));
    max-height: calc(100% - var(--sl-spacing-2x-large));
    background-color: var(--sl-panel-background-color);
    border-radius: var(--sl-border-radius-medium);
    box-shadow: var(--sl-shadow-x-large);
  }

  .dialog__panel:focus {
    outline: none;
  }

  /* Ensure there's enough vertical padding for phones that don't update vh when chrome appears (e.g. iPhone) */
  @media screen and (max-width: 420px) {
    .dialog__panel {
      max-height: 80vh;
    }
  }

  .dialog--open .dialog__panel {
    display: flex;
    opacity: 1;
  }

  .dialog__header {
    flex: 0 0 auto;
    display: flex;
  }

  .dialog__title {
    flex: 1 1 auto;
    font: inherit;
    font-size: var(--sl-font-size-large);
    line-height: var(--sl-line-height-dense);
    padding: var(--header-spacing);
    margin: 0;
  }

  .dialog__header-actions {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    gap: var(--sl-spacing-2x-small);
    padding: 0 var(--header-spacing);
  }

  .dialog__header-actions sl-icon-button,
  .dialog__header-actions ::slotted(sl-icon-button) {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-medium);
  }

  .dialog__body {
    flex: 1 1 auto;
    display: block;
    padding: var(--body-spacing);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .dialog__footer {
    flex: 0 0 auto;
    text-align: right;
    padding: var(--footer-spacing);
  }

  .dialog__footer ::slotted(sl-button:not(:first-of-type)) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  .dialog:not(.dialog--has-footer) .dialog__footer {
    display: none;
  }

  .dialog__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: var(--sl-overlay-background-color);
  }

  @media (forced-colors: active) {
    .dialog__panel {
      border: solid 1px var(--sl-color-neutral-0);
    }
  }
`;
















var $345adce4901e67b1$export$2a86abe166e5892d = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "footer");
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.modal = new (0, $730c7360db8df4b5$export$2b77a92f1a5ad772)(this);
        this.open = false;
        this.label = "";
        this.noHeader = false;
        this.handleDocumentKeyDown = (event)=>{
            if (event.key === "Escape" && this.modal.isActive() && this.open) {
                event.stopPropagation();
                this.requestClose("keyboard");
            }
        };
    }
    firstUpdated() {
        this.dialog.hidden = !this.open;
        if (this.open) {
            this.addOpenListeners();
            this.modal.activate();
            (0, $50a04e78d1030c6e$export$5f4bd35c67f2403d)(this);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.modal.deactivate();
        (0, $50a04e78d1030c6e$export$7475b4759872c980)(this);
        this.removeOpenListeners();
    }
    requestClose(source) {
        const slRequestClose = this.emit("sl-request-close", {
            cancelable: true,
            detail: {
                source: source
            }
        });
        if (slRequestClose.defaultPrevented) {
            const animation = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "dialog.denyClose", {
                dir: this.localize.dir()
            });
            (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.panel, animation.keyframes, animation.options);
            return;
        }
        this.hide();
    }
    addOpenListeners() {
        var _a;
        if ("CloseWatcher" in window) {
            (_a = this.closeWatcher) == null || _a.destroy();
            this.closeWatcher = new CloseWatcher();
            this.closeWatcher.onclose = ()=>this.requestClose("keyboard");
        } else document.addEventListener("keydown", this.handleDocumentKeyDown);
    }
    removeOpenListeners() {
        var _a;
        (_a = this.closeWatcher) == null || _a.destroy();
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
    }
    async handleOpenChange() {
        if (this.open) {
            this.emit("sl-show");
            this.addOpenListeners();
            this.originalTrigger = document.activeElement;
            this.modal.activate();
            (0, $50a04e78d1030c6e$export$5f4bd35c67f2403d)(this);
            const autoFocusTarget = this.querySelector("[autofocus]");
            if (autoFocusTarget) autoFocusTarget.removeAttribute("autofocus");
            await Promise.all([
                (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.dialog),
                (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.overlay)
            ]);
            this.dialog.hidden = false;
            requestAnimationFrame(()=>{
                const slInitialFocus = this.emit("sl-initial-focus", {
                    cancelable: true
                });
                if (!slInitialFocus.defaultPrevented) {
                    if (autoFocusTarget) autoFocusTarget.focus({
                        preventScroll: true
                    });
                    else this.panel.focus({
                        preventScroll: true
                    });
                }
                if (autoFocusTarget) autoFocusTarget.setAttribute("autofocus", "");
            });
            const panelAnimation = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "dialog.show", {
                dir: this.localize.dir()
            });
            const overlayAnimation = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "dialog.overlay.show", {
                dir: this.localize.dir()
            });
            await Promise.all([
                (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.panel, panelAnimation.keyframes, panelAnimation.options),
                (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.overlay, overlayAnimation.keyframes, overlayAnimation.options)
            ]);
            this.emit("sl-after-show");
        } else {
            this.emit("sl-hide");
            this.removeOpenListeners();
            this.modal.deactivate();
            await Promise.all([
                (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.dialog),
                (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.overlay)
            ]);
            const panelAnimation = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "dialog.hide", {
                dir: this.localize.dir()
            });
            const overlayAnimation = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "dialog.overlay.hide", {
                dir: this.localize.dir()
            });
            await Promise.all([
                (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.overlay, overlayAnimation.keyframes, overlayAnimation.options).then(()=>{
                    this.overlay.hidden = true;
                }),
                (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.panel, panelAnimation.keyframes, panelAnimation.options).then(()=>{
                    this.panel.hidden = true;
                })
            ]);
            this.dialog.hidden = true;
            this.overlay.hidden = false;
            this.panel.hidden = false;
            (0, $50a04e78d1030c6e$export$7475b4759872c980)(this);
            const trigger = this.originalTrigger;
            if (typeof (trigger == null ? void 0 : trigger.focus) === "function") setTimeout(()=>trigger.focus());
            this.emit("sl-after-hide");
        }
    }
    /** Shows the dialog. */ async show() {
        if (this.open) return void 0;
        this.open = true;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the dialog */ async hide() {
        if (!this.open) return void 0;
        this.open = false;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            dialog: true,
            "dialog--open": this.open,
            "dialog--has-footer": this.hasSlotController.test("footer")
        })}
      >
        <div part="overlay" class="dialog__overlay" @click=${()=>this.requestClose("overlay")} tabindex="-1"></div>

        <div
          part="panel"
          class="dialog__panel"
          role="dialog"
          aria-modal="true"
          aria-hidden=${this.open ? "false" : "true"}
          aria-label=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.noHeader ? this.label : void 0)}
          aria-labelledby=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(!this.noHeader ? "title" : void 0)}
          tabindex="-1"
        >
          ${!this.noHeader ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                <header part="header" class="dialog__header">
                  <h2 part="title" class="dialog__title" id="title">
                    <slot name="label"> ${this.label.length > 0 ? this.label : String.fromCharCode(65279)} </slot>
                  </h2>
                  <div part="header-actions" class="dialog__header-actions">
                    <slot name="header-actions"></slot>
                    <sl-icon-button
                      part="close-button"
                      exportparts="base:close-button__base"
                      class="dialog__close"
                      name="x-lg"
                      label=${this.localize.term("close")}
                      library="system"
                      @click="${()=>this.requestClose("close-button")}"
                    ></sl-icon-button>
                  </div>
                </header>
              ` : ""}
          ${""}
          <div part="body" class="dialog__body" tabindex="-1"><slot></slot></div>

          <footer part="footer" class="dialog__footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    `;
    }
};
$345adce4901e67b1$export$2a86abe166e5892d.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $0fa306157451a9b0$export$b752f4490c3ab6b1)
];
$345adce4901e67b1$export$2a86abe166e5892d.dependencies = {
    "sl-icon-button": (0, $271ffb72cdd1ec73$export$302c9d29315a4659)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".dialog")
], $345adce4901e67b1$export$2a86abe166e5892d.prototype, "dialog", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".dialog__panel")
], $345adce4901e67b1$export$2a86abe166e5892d.prototype, "panel", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".dialog__overlay")
], $345adce4901e67b1$export$2a86abe166e5892d.prototype, "overlay", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $345adce4901e67b1$export$2a86abe166e5892d.prototype, "open", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $345adce4901e67b1$export$2a86abe166e5892d.prototype, "label", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "no-header",
        type: Boolean,
        reflect: true
    })
], $345adce4901e67b1$export$2a86abe166e5892d.prototype, "noHeader", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $345adce4901e67b1$export$2a86abe166e5892d.prototype, "handleOpenChange", 1);
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("dialog.show", {
    keyframes: [
        {
            opacity: 0,
            scale: 0.8
        },
        {
            opacity: 1,
            scale: 1
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("dialog.hide", {
    keyframes: [
        {
            opacity: 1,
            scale: 1
        },
        {
            opacity: 0,
            scale: 0.8
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("dialog.denyClose", {
    keyframes: [
        {
            scale: 1
        },
        {
            scale: 1.02
        },
        {
            scale: 1
        }
    ],
    options: {
        duration: 250
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("dialog.overlay.show", {
    keyframes: [
        {
            opacity: 0
        },
        {
            opacity: 1
        }
    ],
    options: {
        duration: 250
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("dialog.overlay.hide", {
    keyframes: [
        {
            opacity: 1
        },
        {
            opacity: 0
        }
    ],
    options: {
        duration: 250
    }
});


// src/components/dialog/dialog.ts
var $6f4be4c8e00a8fff$export$585117cab3e12d3 = (0, $345adce4901e67b1$export$2a86abe166e5892d);
(0, $345adce4901e67b1$export$2a86abe166e5892d).define("sl-dialog");









// src/components/checkbox/checkbox.ts
var $ab0bba36508a01aa$export$40f39952efc279e6 = (0, $61e71b4204f92964$export$7f3be6aba957b8f2);
(0, $61e71b4204f92964$export$7f3be6aba957b8f2).define("sl-checkbox");









// src/components/color-picker/color-picker.styles.ts

var $4c84c54f2f66487a$export$3a7afb6cc0ee0754 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --grid-width: 280px;
    --grid-height: 200px;
    --grid-handle-size: 16px;
    --slider-height: 15px;
    --slider-handle-size: 17px;
    --swatch-size: 25px;

    display: inline-block;
  }

  .color-picker {
    width: var(--grid-width);
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    color: var(--color);
    background-color: var(--sl-panel-background-color);
    border-radius: var(--sl-border-radius-medium);
    user-select: none;
    -webkit-user-select: none;
  }

  .color-picker--inline {
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
  }

  .color-picker--inline:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .color-picker__grid {
    position: relative;
    height: var(--grid-height);
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%),
      linear-gradient(to right, #fff 0%, rgba(255, 255, 255, 0) 100%);
    border-top-left-radius: var(--sl-border-radius-medium);
    border-top-right-radius: var(--sl-border-radius-medium);
    cursor: crosshair;
    forced-color-adjust: none;
  }

  .color-picker__grid-handle {
    position: absolute;
    width: var(--grid-handle-size);
    height: var(--grid-handle-size);
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
    border: solid 2px white;
    margin-top: calc(var(--grid-handle-size) / -2);
    margin-left: calc(var(--grid-handle-size) / -2);
    transition: var(--sl-transition-fast) scale;
  }

  .color-picker__grid-handle--dragging {
    cursor: none;
    scale: 1.5;
  }

  .color-picker__grid-handle:focus-visible {
    outline: var(--sl-focus-ring);
  }

  .color-picker__controls {
    padding: var(--sl-spacing-small);
    display: flex;
    align-items: center;
  }

  .color-picker__sliders {
    flex: 1 1 auto;
  }

  .color-picker__slider {
    position: relative;
    height: var(--slider-height);
    border-radius: var(--sl-border-radius-pill);
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2);
    forced-color-adjust: none;
  }

  .color-picker__slider:not(:last-of-type) {
    margin-bottom: var(--sl-spacing-small);
  }

  .color-picker__slider-handle {
    position: absolute;
    top: calc(50% - var(--slider-handle-size) / 2);
    width: var(--slider-handle-size);
    height: var(--slider-handle-size);
    background-color: white;
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
    margin-left: calc(var(--slider-handle-size) / -2);
  }

  .color-picker__slider-handle:focus-visible {
    outline: var(--sl-focus-ring);
  }

  .color-picker__hue {
    background-image: linear-gradient(
      to right,
      rgb(255, 0, 0) 0%,
      rgb(255, 255, 0) 17%,
      rgb(0, 255, 0) 33%,
      rgb(0, 255, 255) 50%,
      rgb(0, 0, 255) 67%,
      rgb(255, 0, 255) 83%,
      rgb(255, 0, 0) 100%
    );
  }

  .color-picker__alpha .color-picker__alpha-gradient {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
  }

  .color-picker__preview {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 2.25rem;
    height: 2.25rem;
    border: none;
    border-radius: var(--sl-border-radius-circle);
    background: none;
    margin-left: var(--sl-spacing-small);
    cursor: copy;
    forced-color-adjust: none;
  }

  .color-picker__preview:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2);

    /* We use a custom property in lieu of currentColor because of https://bugs.webkit.org/show_bug.cgi?id=216780 */
    background-color: var(--preview-color);
  }

  .color-picker__preview:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .color-picker__preview-color {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: solid 1px rgba(0, 0, 0, 0.125);
  }

  .color-picker__preview-color--copied {
    animation: pulse 0.75s;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 var(--sl-color-primary-500);
    }
    70% {
      box-shadow: 0 0 0 0.5rem transparent;
    }
    100% {
      box-shadow: 0 0 0 0 transparent;
    }
  }

  .color-picker__user-input {
    display: flex;
    padding: 0 var(--sl-spacing-small) var(--sl-spacing-small) var(--sl-spacing-small);
  }

  .color-picker__user-input sl-input {
    min-width: 0; /* fix input width in Safari */
    flex: 1 1 auto;
  }

  .color-picker__user-input sl-button-group {
    margin-left: var(--sl-spacing-small);
  }

  .color-picker__user-input sl-button {
    min-width: 3.25rem;
    max-width: 3.25rem;
    font-size: 1rem;
  }

  .color-picker__swatches {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-gap: 0.5rem;
    justify-items: center;
    border-top: solid 1px var(--sl-color-neutral-200);
    padding: var(--sl-spacing-small);
    forced-color-adjust: none;
  }

  .color-picker__swatch {
    position: relative;
    width: var(--swatch-size);
    height: var(--swatch-size);
    border-radius: var(--sl-border-radius-small);
  }

  .color-picker__swatch .color-picker__swatch-color {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: solid 1px rgba(0, 0, 0, 0.125);
    border-radius: inherit;
    cursor: pointer;
  }

  .color-picker__swatch:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .color-picker__transparent-bg {
    background-image: linear-gradient(45deg, var(--sl-color-neutral-300) 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, var(--sl-color-neutral-300) 75%),
      linear-gradient(45deg, transparent 75%, var(--sl-color-neutral-300) 75%),
      linear-gradient(45deg, var(--sl-color-neutral-300) 25%, transparent 25%);
    background-size: 10px 10px;
    background-position:
      0 0,
      0 0,
      -5px -5px,
      5px 5px;
  }

  .color-picker--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .color-picker--disabled .color-picker__grid,
  .color-picker--disabled .color-picker__grid-handle,
  .color-picker--disabled .color-picker__slider,
  .color-picker--disabled .color-picker__slider-handle,
  .color-picker--disabled .color-picker__preview,
  .color-picker--disabled .color-picker__swatch,
  .color-picker--disabled .color-picker__swatch-color {
    pointer-events: none;
  }

  /*
   * Color dropdown
   */

  .color-dropdown::part(panel) {
    max-height: none;
    background-color: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-radius: var(--sl-border-radius-medium);
    overflow: visible;
  }

  .color-dropdown__trigger {
    display: inline-block;
    position: relative;
    background-color: transparent;
    border: none;
    cursor: pointer;
    forced-color-adjust: none;
  }

  .color-dropdown__trigger.color-dropdown__trigger--small {
    width: var(--sl-input-height-small);
    height: var(--sl-input-height-small);
    border-radius: var(--sl-border-radius-circle);
  }

  .color-dropdown__trigger.color-dropdown__trigger--medium {
    width: var(--sl-input-height-medium);
    height: var(--sl-input-height-medium);
    border-radius: var(--sl-border-radius-circle);
  }

  .color-dropdown__trigger.color-dropdown__trigger--large {
    width: var(--sl-input-height-large);
    height: var(--sl-input-height-large);
    border-radius: var(--sl-border-radius-circle);
  }

  .color-dropdown__trigger:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    background-color: currentColor;
    box-shadow:
      inset 0 0 0 2px var(--sl-input-border-color),
      inset 0 0 0 4px var(--sl-color-neutral-0);
  }

  .color-dropdown__trigger--empty:before {
    background-color: transparent;
  }

  .color-dropdown__trigger:focus-visible {
    outline: none;
  }

  .color-dropdown__trigger:focus-visible:not(.color-dropdown__trigger--disabled) {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .color-dropdown__trigger.color-dropdown__trigger--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;


















var $5e30fc3ddce21c8b$export$e56d306ebf763f31 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $6aba7ae81ba45aa2$export$43da334182d34ab4)(this, {
            assumeInteractionOn: [
                "click"
            ]
        });
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "[default]", "prefix", "suffix");
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.hasFocus = false;
        this.invalid = false;
        this.title = "";
        this.variant = "default";
        this.size = "medium";
        this.caret = false;
        this.disabled = false;
        this.loading = false;
        this.outline = false;
        this.pill = false;
        this.circle = false;
        this.type = "button";
        this.name = "";
        this.value = "";
        this.href = "";
        this.rel = "noreferrer noopener";
    }
    /** Gets the validity state object */ get validity() {
        if (this.isButton()) return this.button.validity;
        return 0, $6aba7ae81ba45aa2$export$6c5960ddf0f5ff89;
    }
    /** Gets the validation message */ get validationMessage() {
        if (this.isButton()) return this.button.validationMessage;
        return "";
    }
    firstUpdated() {
        if (this.isButton()) this.formControlController.updateValidity();
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick() {
        if (this.type === "submit") this.formControlController.submit(this);
        if (this.type === "reset") this.formControlController.reset(this);
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    isButton() {
        return this.href ? false : true;
    }
    isLink() {
        return this.href ? true : false;
    }
    handleDisabledChange() {
        if (this.isButton()) this.formControlController.setValidity(this.disabled);
    }
    /** Simulates a click on the button. */ click() {
        this.button.click();
    }
    /** Sets focus on the button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the button. */ blur() {
        this.button.blur();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        if (this.isButton()) return this.button.checkValidity();
        return true;
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        if (this.isButton()) return this.button.reportValidity();
        return true;
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        if (this.isButton()) {
            this.button.setCustomValidity(message);
            this.formControlController.updateValidity();
        }
    }
    render() {
        const isLink = this.isLink();
        const tag = isLink ? (0, $d4df2e78fcd0ab0d$export$c8ec6e1ec9fefcb0)`a` : (0, $d4df2e78fcd0ab0d$export$c8ec6e1ec9fefcb0)`button`;
        return (0, $d4df2e78fcd0ab0d$export$c0bb0b647f701bb5)`
      <${tag}
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            button: true,
            "button--default": this.variant === "default",
            "button--primary": this.variant === "primary",
            "button--success": this.variant === "success",
            "button--neutral": this.variant === "neutral",
            "button--warning": this.variant === "warning",
            "button--danger": this.variant === "danger",
            "button--text": this.variant === "text",
            "button--small": this.size === "small",
            "button--medium": this.size === "medium",
            "button--large": this.size === "large",
            "button--caret": this.caret,
            "button--circle": this.circle,
            "button--disabled": this.disabled,
            "button--focused": this.hasFocus,
            "button--loading": this.loading,
            "button--standard": !this.outline,
            "button--outline": this.outline,
            "button--pill": this.pill,
            "button--rtl": this.localize.dir() === "rtl",
            "button--has-label": this.hasSlotController.test("[default]"),
            "button--has-prefix": this.hasSlotController.test("prefix"),
            "button--has-suffix": this.hasSlotController.test("suffix")
        })}
        ?disabled=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? void 0 : this.disabled)}
        type=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? void 0 : this.type)}
        title=${this.title}
        name=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? void 0 : this.name)}
        value=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? void 0 : this.value)}
        href=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink && !this.disabled ? this.href : void 0)}
        target=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? this.target : void 0)}
        download=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? this.download : void 0)}
        rel=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? this.rel : void 0)}
        role=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @invalid=${this.isButton() ? this.handleInvalid : null}
        @click=${this.handleClick}
      >
        <slot name="prefix" part="prefix" class="button__prefix"></slot>
        <slot part="label" class="button__label"></slot>
        <slot name="suffix" part="suffix" class="button__suffix"></slot>
        ${this.caret ? (0, $d4df2e78fcd0ab0d$export$c0bb0b647f701bb5)` <sl-icon part="caret" class="button__caret" library="system" name="caret"></sl-icon> ` : ""}
        ${this.loading ? (0, $d4df2e78fcd0ab0d$export$c0bb0b647f701bb5)`<sl-spinner part="spinner"></sl-spinner>` : ""}
      </${tag}>
    `;
    }
};
$5e30fc3ddce21c8b$export$e56d306ebf763f31.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $85a200068eaec012$export$172eea9c07ee1ffd)
];
$5e30fc3ddce21c8b$export$e56d306ebf763f31.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441),
    "sl-spinner": (0, $b879e4c4815031db$export$4e45ce56e46d2b00)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".button")
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "button", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "hasFocus", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "invalid", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "title", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "variant", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "size", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "caret", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "loading", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "outline", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "pill", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "circle", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "type", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "name", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "href", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "target", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "rel", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "download", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "form", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "formaction"
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "formAction", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "formenctype"
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "formEnctype", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "formmethod"
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "formMethod", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "formnovalidate",
        type: Boolean
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "formNoValidate", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "formtarget"
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "formTarget", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $5e30fc3ddce21c8b$export$e56d306ebf763f31.prototype, "handleDisabledChange", 1);














/**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */ function $e012731abd4e75f7$export$b0e60b43d1d059f0(n, max) {
    if ($e012731abd4e75f7$export$7bf7d6849640691b(n)) n = '100%';
    const isPercent = $e012731abd4e75f7$export$d86432a85610ea90(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) n = parseInt(String(n * max), 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    if (max === 360) // If n is a hue given in degrees,
    // wrap around out-of-range values into [0, 360] range
    // then convert into [0, 1].
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
    else // If n not a hue given in degrees
    // Convert into [0, 1] range if it isn't already.
    n = n % max / parseFloat(String(max));
    return n;
}
function $e012731abd4e75f7$export$5c5ee632c52bc4a2(val) {
    return Math.min(1, Math.max(0, val));
}
function $e012731abd4e75f7$export$7bf7d6849640691b(n) {
    return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
}
function $e012731abd4e75f7$export$d86432a85610ea90(n) {
    return typeof n === 'string' && n.indexOf('%') !== -1;
}
function $e012731abd4e75f7$export$3ae665204365318d(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
function $e012731abd4e75f7$export$8ba0754c08bd5ca8(n) {
    if (Number(n) <= 1) return `${Number(n) * 100}%`;
    return n;
}
function $e012731abd4e75f7$export$9decc9dc70e2c76f(c) {
    return c.length === 1 ? '0' + c : String(c);
}


function $ce0adb2510f3491f$export$1a0d7f039f803cb(r, g, b) {
    return {
        r: (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(r, 255) * 255,
        g: (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(g, 255) * 255,
        b: (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(b, 255) * 255
    };
}
function $ce0adb2510f3491f$export$c85ca4f4753af384(r, g, b) {
    r = (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(b, 255);
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h = 0;
    let s = 0;
    const l = (max + min) / 2;
    if (max === min) {
        s = 0;
        h = 0; // achromatic
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $ce0adb2510f3491f$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * (6 * t);
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $ce0adb2510f3491f$export$29fb7152bd3f781a(h, s, l) {
    let r;
    let g;
    let b;
    h = (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(h, 360);
    s = (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(s, 100);
    l = (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    } else {
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = $ce0adb2510f3491f$var$hue2rgb(p, q, h + 1 / 3);
        g = $ce0adb2510f3491f$var$hue2rgb(p, q, h);
        b = $ce0adb2510f3491f$var$hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $ce0adb2510f3491f$export$f76e85ca00a47f5c(r, g, b) {
    r = (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(b, 255);
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h = 0;
    const v = max;
    const d = max - min;
    const s = max === 0 ? 0 : d / max;
    if (max === min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
function $ce0adb2510f3491f$export$210753cfeec758a5(h, s, v) {
    h = (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(h, 360) * 6;
    s = (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(s, 100);
    v = (0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(v, 100);
    const i = Math.floor(h);
    const f = h - i;
    const p = v * (1 - s);
    const q = v * (1 - f * s);
    const t = v * (1 - (1 - f) * s);
    const mod = i % 6;
    const r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod];
    const g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod];
    const b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $ce0adb2510f3491f$export$34d09c4a771c46ef(r, g, b, allow3Char) {
    const hex = [
        (0, $e012731abd4e75f7$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $e012731abd4e75f7$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $e012731abd4e75f7$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join('');
}
function $ce0adb2510f3491f$export$ffee5509a14af63d(r, g, b, a, allow4Char) {
    const hex = [
        (0, $e012731abd4e75f7$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $e012731abd4e75f7$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $e012731abd4e75f7$export$9decc9dc70e2c76f)(Math.round(b).toString(16)),
        (0, $e012731abd4e75f7$export$9decc9dc70e2c76f)($ce0adb2510f3491f$export$51dcdea396f3aff6(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join('');
}
function $ce0adb2510f3491f$export$ce6645f7d73030f4(r, g, b, a) {
    const hex = [
        (0, $e012731abd4e75f7$export$9decc9dc70e2c76f)($ce0adb2510f3491f$export$51dcdea396f3aff6(a)),
        (0, $e012731abd4e75f7$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $e012731abd4e75f7$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $e012731abd4e75f7$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    return hex.join('');
}
function $ce0adb2510f3491f$export$a59a3453928ee6cf(c, m, y, k) {
    const cConv = c / 100;
    const mConv = m / 100;
    const yConv = y / 100;
    const kConv = k / 100;
    const r = 255 * (1 - cConv) * (1 - kConv);
    const g = 255 * (1 - mConv) * (1 - kConv);
    const b = 255 * (1 - yConv) * (1 - kConv);
    return {
        r: r,
        g: g,
        b: b
    };
}
function $ce0adb2510f3491f$export$d826b0606303ea35(r, g, b) {
    let c = 1 - r / 255;
    let m = 1 - g / 255;
    let y = 1 - b / 255;
    let k = Math.min(c, m, y);
    if (k === 1) {
        c = 0;
        m = 0;
        y = 0;
    } else {
        c = (c - k) / (1 - k) * 100;
        m = (m - k) / (1 - k) * 100;
        y = (y - k) / (1 - k) * 100;
    }
    k *= 100;
    return {
        c: Math.round(c),
        m: Math.round(m),
        y: Math.round(y),
        k: Math.round(k)
    };
}
function $ce0adb2510f3491f$export$51dcdea396f3aff6(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
function $ce0adb2510f3491f$export$616da979ad1c2414(h) {
    return $ce0adb2510f3491f$export$262b3ba788b4d07c(h) / 255;
}
function $ce0adb2510f3491f$export$262b3ba788b4d07c(val) {
    return parseInt(val, 16);
}
function $ce0adb2510f3491f$export$4076ec82b665900d(color) {
    return {
        r: color >> 16,
        g: (color & 0xff00) >> 8,
        b: color & 0xff
    };
}


// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */ const $3272b0b5909f5264$export$e4b2ac9215619f8d = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    goldenrod: '#daa520',
    gold: '#ffd700',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavenderblush: '#fff0f5',
    lavender: '#e6e6fa',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};





function $7cc6a2d254ab37d9$export$87de337d8199f22c(color) {
    let rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    let a = 1;
    let s = null;
    let v = null;
    let l = null;
    let ok = false;
    let format = false;
    if (typeof color === 'string') color = $7cc6a2d254ab37d9$export$56237d872eed15a0(color);
    if (typeof color === 'object') {
        if ($7cc6a2d254ab37d9$export$80d4d71a83d4526d(color.r) && $7cc6a2d254ab37d9$export$80d4d71a83d4526d(color.g) && $7cc6a2d254ab37d9$export$80d4d71a83d4526d(color.b)) {
            rgb = (0, $ce0adb2510f3491f$export$1a0d7f039f803cb)(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === '%' ? 'prgb' : 'rgb';
        } else if ($7cc6a2d254ab37d9$export$80d4d71a83d4526d(color.h) && $7cc6a2d254ab37d9$export$80d4d71a83d4526d(color.s) && $7cc6a2d254ab37d9$export$80d4d71a83d4526d(color.v)) {
            s = (0, $e012731abd4e75f7$export$8ba0754c08bd5ca8)(color.s);
            v = (0, $e012731abd4e75f7$export$8ba0754c08bd5ca8)(color.v);
            rgb = (0, $ce0adb2510f3491f$export$210753cfeec758a5)(color.h, s, v);
            ok = true;
            format = 'hsv';
        } else if ($7cc6a2d254ab37d9$export$80d4d71a83d4526d(color.h) && $7cc6a2d254ab37d9$export$80d4d71a83d4526d(color.s) && $7cc6a2d254ab37d9$export$80d4d71a83d4526d(color.l)) {
            s = (0, $e012731abd4e75f7$export$8ba0754c08bd5ca8)(color.s);
            l = (0, $e012731abd4e75f7$export$8ba0754c08bd5ca8)(color.l);
            rgb = (0, $ce0adb2510f3491f$export$29fb7152bd3f781a)(color.h, s, l);
            ok = true;
            format = 'hsl';
        } else if ($7cc6a2d254ab37d9$export$80d4d71a83d4526d(color.c) && $7cc6a2d254ab37d9$export$80d4d71a83d4526d(color.m) && $7cc6a2d254ab37d9$export$80d4d71a83d4526d(color.y) && $7cc6a2d254ab37d9$export$80d4d71a83d4526d(color.k)) {
            rgb = (0, $ce0adb2510f3491f$export$a59a3453928ee6cf)(color.c, color.m, color.y, color.k);
            ok = true;
            format = 'cmyk';
        }
        if (Object.prototype.hasOwnProperty.call(color, 'a')) a = color.a;
    }
    a = (0, $e012731abd4e75f7$export$3ae665204365318d)(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
const $7cc6a2d254ab37d9$var$CSS_INTEGER = '[-\\+]?\\d+%?';
// <http://www.w3.org/TR/css3-values/#number-value>
const $7cc6a2d254ab37d9$var$CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?';
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
const $7cc6a2d254ab37d9$var$CSS_UNIT = '(?:' + $7cc6a2d254ab37d9$var$CSS_NUMBER + ')|(?:' + $7cc6a2d254ab37d9$var$CSS_INTEGER + ')';
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
// eslint-disable-next-line prettier/prettier
const $7cc6a2d254ab37d9$var$PERMISSIVE_MATCH3 = '[\\s|\\(]+(' + $7cc6a2d254ab37d9$var$CSS_UNIT + ')[,|\\s]+(' + $7cc6a2d254ab37d9$var$CSS_UNIT + ')[,|\\s]+(' + $7cc6a2d254ab37d9$var$CSS_UNIT + ')\\s*\\)?';
const $7cc6a2d254ab37d9$var$PERMISSIVE_MATCH4 = // eslint-disable-next-line prettier/prettier
'[\\s|\\(]+(' + $7cc6a2d254ab37d9$var$CSS_UNIT + ')[,|\\s]+(' + $7cc6a2d254ab37d9$var$CSS_UNIT + ')[,|\\s]+(' + $7cc6a2d254ab37d9$var$CSS_UNIT + ')[,|\\s]+(' + $7cc6a2d254ab37d9$var$CSS_UNIT + ')\\s*\\)?';
const $7cc6a2d254ab37d9$var$matchers = {
    CSS_UNIT: new RegExp($7cc6a2d254ab37d9$var$CSS_UNIT),
    rgb: new RegExp('rgb' + $7cc6a2d254ab37d9$var$PERMISSIVE_MATCH3),
    rgba: new RegExp('rgba' + $7cc6a2d254ab37d9$var$PERMISSIVE_MATCH4),
    hsl: new RegExp('hsl' + $7cc6a2d254ab37d9$var$PERMISSIVE_MATCH3),
    hsla: new RegExp('hsla' + $7cc6a2d254ab37d9$var$PERMISSIVE_MATCH4),
    hsv: new RegExp('hsv' + $7cc6a2d254ab37d9$var$PERMISSIVE_MATCH3),
    hsva: new RegExp('hsva' + $7cc6a2d254ab37d9$var$PERMISSIVE_MATCH4),
    cmyk: new RegExp('cmyk' + $7cc6a2d254ab37d9$var$PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $7cc6a2d254ab37d9$export$56237d872eed15a0(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) return false;
    let named = false;
    if ((0, $3272b0b5909f5264$export$e4b2ac9215619f8d)[color]) {
        color = (0, $3272b0b5909f5264$export$e4b2ac9215619f8d)[color];
        named = true;
    } else if (color === 'transparent') return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: 'name'
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    let match = $7cc6a2d254ab37d9$var$matchers.rgb.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    match = $7cc6a2d254ab37d9$var$matchers.rgba.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    match = $7cc6a2d254ab37d9$var$matchers.hsl.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    match = $7cc6a2d254ab37d9$var$matchers.hsla.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    match = $7cc6a2d254ab37d9$var$matchers.hsv.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    match = $7cc6a2d254ab37d9$var$matchers.hsva.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    match = $7cc6a2d254ab37d9$var$matchers.cmyk.exec(color);
    if (match) return {
        c: match[1],
        m: match[2],
        y: match[3],
        k: match[4]
    };
    match = $7cc6a2d254ab37d9$var$matchers.hex8.exec(color);
    if (match) return {
        r: (0, $ce0adb2510f3491f$export$262b3ba788b4d07c)(match[1]),
        g: (0, $ce0adb2510f3491f$export$262b3ba788b4d07c)(match[2]),
        b: (0, $ce0adb2510f3491f$export$262b3ba788b4d07c)(match[3]),
        a: (0, $ce0adb2510f3491f$export$616da979ad1c2414)(match[4]),
        format: named ? 'name' : 'hex8'
    };
    match = $7cc6a2d254ab37d9$var$matchers.hex6.exec(color);
    if (match) return {
        r: (0, $ce0adb2510f3491f$export$262b3ba788b4d07c)(match[1]),
        g: (0, $ce0adb2510f3491f$export$262b3ba788b4d07c)(match[2]),
        b: (0, $ce0adb2510f3491f$export$262b3ba788b4d07c)(match[3]),
        format: named ? 'name' : 'hex'
    };
    match = $7cc6a2d254ab37d9$var$matchers.hex4.exec(color);
    if (match) return {
        r: (0, $ce0adb2510f3491f$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $ce0adb2510f3491f$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $ce0adb2510f3491f$export$262b3ba788b4d07c)(match[3] + match[3]),
        a: (0, $ce0adb2510f3491f$export$616da979ad1c2414)(match[4] + match[4]),
        format: named ? 'name' : 'hex8'
    };
    match = $7cc6a2d254ab37d9$var$matchers.hex3.exec(color);
    if (match) return {
        r: (0, $ce0adb2510f3491f$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $ce0adb2510f3491f$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $ce0adb2510f3491f$export$262b3ba788b4d07c)(match[3] + match[3]),
        format: named ? 'name' : 'hex'
    };
    return false;
}
function $7cc6a2d254ab37d9$export$80d4d71a83d4526d(color) {
    if (typeof color === 'number') return !Number.isNaN(color);
    return $7cc6a2d254ab37d9$var$matchers.CSS_UNIT.test(color);
}



class $888d862f8aa10ceb$export$d850312fc213f33e {
    constructor(color = '', opts = {}){
        // If input is already a tinycolor, return itself
        if (color instanceof $888d862f8aa10ceb$export$d850312fc213f33e) // eslint-disable-next-line no-constructor-return
        return color;
        if (typeof color === 'number') color = (0, $ce0adb2510f3491f$export$4076ec82b665900d)(color);
        this.originalInput = color;
        const rgb = (0, $7cc6a2d254ab37d9$export$87de337d8199f22c)(color);
        this.originalInput = color;
        this.r = rgb.r;
        this.g = rgb.g;
        this.b = rgb.b;
        this.a = rgb.a;
        this.roundA = Math.round(100 * this.a) / 100;
        this.format = opts.format ?? rgb.format;
        this.gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this.r < 1) this.r = Math.round(this.r);
        if (this.g < 1) this.g = Math.round(this.g);
        if (this.b < 1) this.b = Math.round(this.b);
        this.isValid = rgb.ok;
    }
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return !this.isDark();
    }
    /**
     * Returns the perceived brightness of the color, from 0-255.
     */ getBrightness() {
        // http://www.w3.org/TR/AERT#color-contrast
        const rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    }
    /**
     * Returns the perceived luminance of a color, from 0-1.
     */ getLuminance() {
        // http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        const rgb = this.toRgb();
        let R;
        let G;
        let B;
        const RsRGB = rgb.r / 255;
        const GsRGB = rgb.g / 255;
        const BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }
    /**
     * Returns the alpha value of a color, from 0-1.
     */ getAlpha() {
        return this.a;
    }
    /**
     * Sets the alpha value on the current color.
     *
     * @param alpha - The new alpha value. The accepted range is 0-1.
     */ setAlpha(alpha) {
        this.a = (0, $e012731abd4e75f7$export$3ae665204365318d)(alpha);
        this.roundA = Math.round(100 * this.a) / 100;
        return this;
    }
    /**
     * Returns whether the color is monochrome.
     */ isMonochrome() {
        const { s: s } = this.toHsl();
        return s === 0;
    }
    /**
     * Returns the object as a HSVA object.
     */ toHsv() {
        const hsv = (0, $ce0adb2510f3491f$export$f76e85ca00a47f5c)(this.r, this.g, this.b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this.a
        };
    }
    /**
     * Returns the hsva values interpolated into a string with the following format:
     * "hsva(xxx, xxx, xxx, xx)".
     */ toHsvString() {
        const hsv = (0, $ce0adb2510f3491f$export$f76e85ca00a47f5c)(this.r, this.g, this.b);
        const h = Math.round(hsv.h * 360);
        const s = Math.round(hsv.s * 100);
        const v = Math.round(hsv.v * 100);
        return this.a === 1 ? `hsv(${h}, ${s}%, ${v}%)` : `hsva(${h}, ${s}%, ${v}%, ${this.roundA})`;
    }
    /**
     * Returns the object as a HSLA object.
     */ toHsl() {
        const hsl = (0, $ce0adb2510f3491f$export$c85ca4f4753af384)(this.r, this.g, this.b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this.a
        };
    }
    /**
     * Returns the hsla values interpolated into a string with the following format:
     * "hsla(xxx, xxx, xxx, xx)".
     */ toHslString() {
        const hsl = (0, $ce0adb2510f3491f$export$c85ca4f4753af384)(this.r, this.g, this.b);
        const h = Math.round(hsl.h * 360);
        const s = Math.round(hsl.s * 100);
        const l = Math.round(hsl.l * 100);
        return this.a === 1 ? `hsl(${h}, ${s}%, ${l}%)` : `hsla(${h}, ${s}%, ${l}%, ${this.roundA})`;
    }
    /**
     * Returns the hex value of the color.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ toHex(allow3Char = false) {
        return (0, $ce0adb2510f3491f$export$34d09c4a771c46ef)(this.r, this.g, this.b, allow3Char);
    }
    /**
     * Returns the hex value of the color -with a # prefixed.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ toHexString(allow3Char = false) {
        return '#' + this.toHex(allow3Char);
    }
    /**
     * Returns the hex 8 value of the color.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ toHex8(allow4Char = false) {
        return (0, $ce0adb2510f3491f$export$ffee5509a14af63d)(this.r, this.g, this.b, this.a, allow4Char);
    }
    /**
     * Returns the hex 8 value of the color -with a # prefixed.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ toHex8String(allow4Char = false) {
        return '#' + this.toHex8(allow4Char);
    }
    /**
     * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
     * @param allowShortChar will shorten hex value to 3 or 4 char if possible
     */ toHexShortString(allowShortChar = false) {
        return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
    }
    /**
     * Returns the object as a RGBA object.
     */ toRgb() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    }
    /**
     * Returns the RGBA values interpolated into a string with the following format:
     * "RGBA(xxx, xxx, xxx, xx)".
     */ toRgbString() {
        const r = Math.round(this.r);
        const g = Math.round(this.g);
        const b = Math.round(this.b);
        return this.a === 1 ? `rgb(${r}, ${g}, ${b})` : `rgba(${r}, ${g}, ${b}, ${this.roundA})`;
    }
    /**
     * Returns the object as a RGBA object.
     */ toPercentageRgb() {
        const fmt = (x)=>`${Math.round((0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(x, 255) * 100)}%`;
        return {
            r: fmt(this.r),
            g: fmt(this.g),
            b: fmt(this.b),
            a: this.a
        };
    }
    /**
     * Returns the RGBA relative values interpolated into a string
     */ toPercentageRgbString() {
        const rnd = (x)=>Math.round((0, $e012731abd4e75f7$export$b0e60b43d1d059f0)(x, 255) * 100);
        return this.a === 1 ? `rgb(${rnd(this.r)}%, ${rnd(this.g)}%, ${rnd(this.b)}%)` : `rgba(${rnd(this.r)}%, ${rnd(this.g)}%, ${rnd(this.b)}%, ${this.roundA})`;
    }
    toCmyk() {
        return {
            ...(0, $ce0adb2510f3491f$export$d826b0606303ea35)(this.r, this.g, this.b)
        };
    }
    toCmykString() {
        const { c: c, m: m, y: y, k: k } = (0, $ce0adb2510f3491f$export$d826b0606303ea35)(this.r, this.g, this.b);
        return `cmyk(${c}, ${m}, ${y}, ${k})`;
    }
    /**
     * The 'real' name of the color -if there is one.
     */ toName() {
        if (this.a === 0) return 'transparent';
        if (this.a < 1) return false;
        const hex = '#' + (0, $ce0adb2510f3491f$export$34d09c4a771c46ef)(this.r, this.g, this.b, false);
        for (const [key, value] of Object.entries((0, $3272b0b5909f5264$export$e4b2ac9215619f8d))){
            if (hex === value) return key;
        }
        return false;
    }
    toString(format) {
        const formatSet = Boolean(format);
        format = format ?? this.format;
        let formattedString = false;
        const hasAlpha = this.a < 1 && this.a >= 0;
        const needsAlphaFormat = !formatSet && hasAlpha && (format.startsWith('hex') || format === 'name');
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === 'name' && this.a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === 'rgb') formattedString = this.toRgbString();
        if (format === 'prgb') formattedString = this.toPercentageRgbString();
        if (format === 'hex' || format === 'hex6') formattedString = this.toHexString();
        if (format === 'hex3') formattedString = this.toHexString(true);
        if (format === 'hex4') formattedString = this.toHex8String(true);
        if (format === 'hex8') formattedString = this.toHex8String();
        if (format === 'name') formattedString = this.toName();
        if (format === 'hsl') formattedString = this.toHslString();
        if (format === 'hsv') formattedString = this.toHsvString();
        if (format === 'cmyk') formattedString = this.toCmykString();
        return formattedString || this.toHexString();
    }
    toNumber() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }
    clone() {
        return new $888d862f8aa10ceb$export$d850312fc213f33e(this.toString());
    }
    /**
     * Lighten the color a given amount. Providing 100 will always return white.
     * @param amount - valid between 1-100
     */ lighten(amount = 10) {
        const hsl = this.toHsl();
        hsl.l += amount / 100;
        hsl.l = (0, $e012731abd4e75f7$export$5c5ee632c52bc4a2)(hsl.l);
        return new $888d862f8aa10ceb$export$d850312fc213f33e(hsl);
    }
    /**
     * Brighten the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ brighten(amount = 10) {
        const rgb = this.toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return new $888d862f8aa10ceb$export$d850312fc213f33e(rgb);
    }
    /**
     * Darken the color a given amount, from 0 to 100.
     * Providing 100 will always return black.
     * @param amount - valid between 1-100
     */ darken(amount = 10) {
        const hsl = this.toHsl();
        hsl.l -= amount / 100;
        hsl.l = (0, $e012731abd4e75f7$export$5c5ee632c52bc4a2)(hsl.l);
        return new $888d862f8aa10ceb$export$d850312fc213f33e(hsl);
    }
    /**
     * Mix the color with pure white, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return white.
     * @param amount - valid between 1-100
     */ tint(amount = 10) {
        return this.mix('white', amount);
    }
    /**
     * Mix the color with pure black, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return black.
     * @param amount - valid between 1-100
     */ shade(amount = 10) {
        return this.mix('black', amount);
    }
    /**
     * Desaturate the color a given amount, from 0 to 100.
     * Providing 100 will is the same as calling greyscale
     * @param amount - valid between 1-100
     */ desaturate(amount = 10) {
        const hsl = this.toHsl();
        hsl.s -= amount / 100;
        hsl.s = (0, $e012731abd4e75f7$export$5c5ee632c52bc4a2)(hsl.s);
        return new $888d862f8aa10ceb$export$d850312fc213f33e(hsl);
    }
    /**
     * Saturate the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ saturate(amount = 10) {
        const hsl = this.toHsl();
        hsl.s += amount / 100;
        hsl.s = (0, $e012731abd4e75f7$export$5c5ee632c52bc4a2)(hsl.s);
        return new $888d862f8aa10ceb$export$d850312fc213f33e(hsl);
    }
    /**
     * Completely desaturates a color into greyscale.
     * Same as calling `desaturate(100)`
     */ greyscale() {
        return this.desaturate(100);
    }
    /**
     * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
     * Values outside of this range will be wrapped into this range.
     */ spin(amount) {
        const hsl = this.toHsl();
        const hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return new $888d862f8aa10ceb$export$d850312fc213f33e(hsl);
    }
    /**
     * Mix the current color a given amount with another color, from 0 to 100.
     * 0 means no mixing (return current color).
     */ mix(color, amount = 50) {
        const rgb1 = this.toRgb();
        const rgb2 = new $888d862f8aa10ceb$export$d850312fc213f33e(color).toRgb();
        const p = amount / 100;
        const rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return new $888d862f8aa10ceb$export$d850312fc213f33e(rgba);
    }
    analogous(results = 6, slices = 30) {
        const hsl = this.toHsl();
        const part = 360 / slices;
        const ret = [
            this
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(new $888d862f8aa10ceb$export$d850312fc213f33e(hsl));
        }
        return ret;
    }
    /**
     * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
     */ complement() {
        const hsl = this.toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return new $888d862f8aa10ceb$export$d850312fc213f33e(hsl);
    }
    monochromatic(results = 6) {
        const hsv = this.toHsv();
        const { h: h } = hsv;
        const { s: s } = hsv;
        let { v: v } = hsv;
        const res = [];
        const modification = 1 / results;
        while(results--){
            res.push(new $888d862f8aa10ceb$export$d850312fc213f33e({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return res;
    }
    splitcomplement() {
        const hsl = this.toHsl();
        const { h: h } = hsl;
        return [
            this,
            new $888d862f8aa10ceb$export$d850312fc213f33e({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            new $888d862f8aa10ceb$export$d850312fc213f33e({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    /**
     * Compute how the color would appear on a background
     */ onBackground(background) {
        const fg = this.toRgb();
        const bg = new $888d862f8aa10ceb$export$d850312fc213f33e(background).toRgb();
        const alpha = fg.a + bg.a * (1 - fg.a);
        return new $888d862f8aa10ceb$export$d850312fc213f33e({
            r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
            g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
            b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
            a: alpha
        });
    }
    /**
     * Alias for `polyad(3)`
     */ triad() {
        return this.polyad(3);
    }
    /**
     * Alias for `polyad(4)`
     */ tetrad() {
        return this.polyad(4);
    }
    /**
     * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
     * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
     */ polyad(n) {
        const hsl = this.toHsl();
        const { h: h } = hsl;
        const result = [
            this
        ];
        const increment = 360 / n;
        for(let i = 1; i < n; i++)result.push(new $888d862f8aa10ceb$export$d850312fc213f33e({
            h: (h + i * increment) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    /**
     * compare color vs current color
     */ equals(color) {
        const comparedColor = new $888d862f8aa10ceb$export$d850312fc213f33e(color);
        /**
         * RGB and CMYK do not have the same color gamut, so a CMYK conversion will never be 100%.
         * This means we need to compare CMYK to CMYK to ensure accuracy of the equals function.
         */ if (this.format === 'cmyk' || comparedColor.format === 'cmyk') return this.toCmykString() === comparedColor.toCmykString();
        return this.toRgbString() === comparedColor.toRgbString();
    }
}


var $e2d427e107caecb0$var$hasEyeDropper = "EyeDropper" in window;
var $e2d427e107caecb0$export$b031ae0dd958712a = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super();
        this.formControlController = new (0, $6aba7ae81ba45aa2$export$43da334182d34ab4)(this);
        this.isSafeValue = false;
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.hasFocus = false;
        this.isDraggingGridHandle = false;
        this.isEmpty = false;
        this.inputValue = "";
        this.hue = 0;
        this.saturation = 100;
        this.brightness = 100;
        this.alpha = 100;
        this.value = "";
        this.defaultValue = "";
        this.label = "";
        this.format = "hex";
        this.inline = false;
        this.size = "medium";
        this.noFormatToggle = false;
        this.name = "";
        this.disabled = false;
        this.hoist = false;
        this.opacity = false;
        this.uppercase = false;
        this.swatches = "";
        this.form = "";
        this.required = false;
        this.handleFocusIn = ()=>{
            this.hasFocus = true;
            this.emit("sl-focus");
        };
        this.handleFocusOut = ()=>{
            this.hasFocus = false;
            this.emit("sl-blur");
        };
        this.addEventListener("focusin", this.handleFocusIn);
        this.addEventListener("focusout", this.handleFocusOut);
    }
    /** Gets the validity state object */ get validity() {
        return this.input.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.input.validationMessage;
    }
    firstUpdated() {
        this.input.updateComplete.then(()=>{
            this.formControlController.updateValidity();
        });
    }
    handleCopy() {
        this.input.select();
        document.execCommand("copy");
        this.previewButton.focus();
        this.previewButton.classList.add("color-picker__preview-color--copied");
        this.previewButton.addEventListener("animationend", ()=>{
            this.previewButton.classList.remove("color-picker__preview-color--copied");
        });
    }
    handleFormatToggle() {
        const formats = [
            "hex",
            "rgb",
            "hsl",
            "hsv"
        ];
        const nextIndex = (formats.indexOf(this.format) + 1) % formats.length;
        this.format = formats[nextIndex];
        this.setColor(this.value);
        this.emit("sl-change");
        this.emit("sl-input");
    }
    handleAlphaDrag(event) {
        const container = this.shadowRoot.querySelector(".color-picker__slider.color-picker__alpha");
        const handle = container.querySelector(".color-picker__slider-handle");
        const { width: width } = container.getBoundingClientRect();
        let initialValue = this.value;
        let currentValue = this.value;
        handle.focus();
        event.preventDefault();
        (0, $9c08d309b4f970a2$export$d7d5d435647ed5a0)(container, {
            onMove: (x)=>{
                this.alpha = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(x / width * 100, 0, 100);
                this.syncValues();
                if (this.value !== currentValue) {
                    currentValue = this.value;
                    this.emit("sl-input");
                }
            },
            onStop: ()=>{
                if (this.value !== initialValue) {
                    initialValue = this.value;
                    this.emit("sl-change");
                }
            },
            initialEvent: event
        });
    }
    handleHueDrag(event) {
        const container = this.shadowRoot.querySelector(".color-picker__slider.color-picker__hue");
        const handle = container.querySelector(".color-picker__slider-handle");
        const { width: width } = container.getBoundingClientRect();
        let initialValue = this.value;
        let currentValue = this.value;
        handle.focus();
        event.preventDefault();
        (0, $9c08d309b4f970a2$export$d7d5d435647ed5a0)(container, {
            onMove: (x)=>{
                this.hue = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(x / width * 360, 0, 360);
                this.syncValues();
                if (this.value !== currentValue) {
                    currentValue = this.value;
                    this.emit("sl-input");
                }
            },
            onStop: ()=>{
                if (this.value !== initialValue) {
                    initialValue = this.value;
                    this.emit("sl-change");
                }
            },
            initialEvent: event
        });
    }
    handleGridDrag(event) {
        const grid = this.shadowRoot.querySelector(".color-picker__grid");
        const handle = grid.querySelector(".color-picker__grid-handle");
        const { width: width, height: height } = grid.getBoundingClientRect();
        let initialValue = this.value;
        let currentValue = this.value;
        handle.focus();
        event.preventDefault();
        this.isDraggingGridHandle = true;
        (0, $9c08d309b4f970a2$export$d7d5d435647ed5a0)(grid, {
            onMove: (x, y)=>{
                this.saturation = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(x / width * 100, 0, 100);
                this.brightness = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(100 - y / height * 100, 0, 100);
                this.syncValues();
                if (this.value !== currentValue) {
                    currentValue = this.value;
                    this.emit("sl-input");
                }
            },
            onStop: ()=>{
                this.isDraggingGridHandle = false;
                if (this.value !== initialValue) {
                    initialValue = this.value;
                    this.emit("sl-change");
                }
            },
            initialEvent: event
        });
    }
    handleAlphaKeyDown(event) {
        const increment = event.shiftKey ? 10 : 1;
        const oldValue = this.value;
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            this.alpha = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(this.alpha - increment, 0, 100);
            this.syncValues();
        }
        if (event.key === "ArrowRight") {
            event.preventDefault();
            this.alpha = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(this.alpha + increment, 0, 100);
            this.syncValues();
        }
        if (event.key === "Home") {
            event.preventDefault();
            this.alpha = 0;
            this.syncValues();
        }
        if (event.key === "End") {
            event.preventDefault();
            this.alpha = 100;
            this.syncValues();
        }
        if (this.value !== oldValue) {
            this.emit("sl-change");
            this.emit("sl-input");
        }
    }
    handleHueKeyDown(event) {
        const increment = event.shiftKey ? 10 : 1;
        const oldValue = this.value;
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            this.hue = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(this.hue - increment, 0, 360);
            this.syncValues();
        }
        if (event.key === "ArrowRight") {
            event.preventDefault();
            this.hue = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(this.hue + increment, 0, 360);
            this.syncValues();
        }
        if (event.key === "Home") {
            event.preventDefault();
            this.hue = 0;
            this.syncValues();
        }
        if (event.key === "End") {
            event.preventDefault();
            this.hue = 360;
            this.syncValues();
        }
        if (this.value !== oldValue) {
            this.emit("sl-change");
            this.emit("sl-input");
        }
    }
    handleGridKeyDown(event) {
        const increment = event.shiftKey ? 10 : 1;
        const oldValue = this.value;
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            this.saturation = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(this.saturation - increment, 0, 100);
            this.syncValues();
        }
        if (event.key === "ArrowRight") {
            event.preventDefault();
            this.saturation = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(this.saturation + increment, 0, 100);
            this.syncValues();
        }
        if (event.key === "ArrowUp") {
            event.preventDefault();
            this.brightness = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(this.brightness + increment, 0, 100);
            this.syncValues();
        }
        if (event.key === "ArrowDown") {
            event.preventDefault();
            this.brightness = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(this.brightness - increment, 0, 100);
            this.syncValues();
        }
        if (this.value !== oldValue) {
            this.emit("sl-change");
            this.emit("sl-input");
        }
    }
    handleInputChange(event) {
        const target = event.target;
        const oldValue = this.value;
        event.stopPropagation();
        if (this.input.value) {
            this.setColor(target.value);
            target.value = this.value;
        } else this.value = "";
        if (this.value !== oldValue) {
            this.emit("sl-change");
            this.emit("sl-input");
        }
    }
    handleInputInput(event) {
        this.formControlController.updateValidity();
        event.stopPropagation();
    }
    handleInputKeyDown(event) {
        if (event.key === "Enter") {
            const oldValue = this.value;
            if (this.input.value) {
                this.setColor(this.input.value);
                this.input.value = this.value;
                if (this.value !== oldValue) {
                    this.emit("sl-change");
                    this.emit("sl-input");
                }
                setTimeout(()=>this.input.select());
            } else this.hue = 0;
        }
    }
    handleInputInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    handleTouchMove(event) {
        event.preventDefault();
    }
    parseColor(colorString) {
        const color = new (0, $888d862f8aa10ceb$export$d850312fc213f33e)(colorString);
        if (!color.isValid) return null;
        const hslColor = color.toHsl();
        const hsl = {
            h: hslColor.h,
            s: hslColor.s * 100,
            l: hslColor.l * 100,
            a: hslColor.a
        };
        const rgb = color.toRgb();
        const hex = color.toHexString();
        const hexa = color.toHex8String();
        const hsvColor = color.toHsv();
        const hsv = {
            h: hsvColor.h,
            s: hsvColor.s * 100,
            v: hsvColor.v * 100,
            a: hsvColor.a
        };
        return {
            hsl: {
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                string: this.setLetterCase(`hsl(${Math.round(hsl.h)}, ${Math.round(hsl.s)}%, ${Math.round(hsl.l)}%)`)
            },
            hsla: {
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: hsl.a,
                string: this.setLetterCase(`hsla(${Math.round(hsl.h)}, ${Math.round(hsl.s)}%, ${Math.round(hsl.l)}%, ${hsl.a.toFixed(2).toString()})`)
            },
            hsv: {
                h: hsv.h,
                s: hsv.s,
                v: hsv.v,
                string: this.setLetterCase(`hsv(${Math.round(hsv.h)}, ${Math.round(hsv.s)}%, ${Math.round(hsv.v)}%)`)
            },
            hsva: {
                h: hsv.h,
                s: hsv.s,
                v: hsv.v,
                a: hsv.a,
                string: this.setLetterCase(`hsva(${Math.round(hsv.h)}, ${Math.round(hsv.s)}%, ${Math.round(hsv.v)}%, ${hsv.a.toFixed(2).toString()})`)
            },
            rgb: {
                r: rgb.r,
                g: rgb.g,
                b: rgb.b,
                string: this.setLetterCase(`rgb(${Math.round(rgb.r)}, ${Math.round(rgb.g)}, ${Math.round(rgb.b)})`)
            },
            rgba: {
                r: rgb.r,
                g: rgb.g,
                b: rgb.b,
                a: rgb.a,
                string: this.setLetterCase(`rgba(${Math.round(rgb.r)}, ${Math.round(rgb.g)}, ${Math.round(rgb.b)}, ${rgb.a.toFixed(2).toString()})`)
            },
            hex: this.setLetterCase(hex),
            hexa: this.setLetterCase(hexa)
        };
    }
    setColor(colorString) {
        const newColor = this.parseColor(colorString);
        if (newColor === null) return false;
        this.hue = newColor.hsva.h;
        this.saturation = newColor.hsva.s;
        this.brightness = newColor.hsva.v;
        this.alpha = this.opacity ? newColor.hsva.a * 100 : 100;
        this.syncValues();
        return true;
    }
    setLetterCase(string) {
        if (typeof string !== "string") return "";
        return this.uppercase ? string.toUpperCase() : string.toLowerCase();
    }
    async syncValues() {
        const currentColor = this.parseColor(`hsva(${this.hue}, ${this.saturation}%, ${this.brightness}%, ${this.alpha / 100})`);
        if (currentColor === null) return;
        if (this.format === "hsl") this.inputValue = this.opacity ? currentColor.hsla.string : currentColor.hsl.string;
        else if (this.format === "rgb") this.inputValue = this.opacity ? currentColor.rgba.string : currentColor.rgb.string;
        else if (this.format === "hsv") this.inputValue = this.opacity ? currentColor.hsva.string : currentColor.hsv.string;
        else this.inputValue = this.opacity ? currentColor.hexa : currentColor.hex;
        this.isSafeValue = true;
        this.value = this.inputValue;
        await this.updateComplete;
        this.isSafeValue = false;
    }
    handleAfterHide() {
        this.previewButton.classList.remove("color-picker__preview-color--copied");
    }
    handleEyeDropper() {
        if (!$e2d427e107caecb0$var$hasEyeDropper) return;
        const eyeDropper = new EyeDropper();
        eyeDropper.open().then((colorSelectionResult)=>{
            const oldValue = this.value;
            this.setColor(colorSelectionResult.sRGBHex);
            if (this.value !== oldValue) {
                this.emit("sl-change");
                this.emit("sl-input");
            }
        }).catch(()=>{});
    }
    selectSwatch(color) {
        const oldValue = this.value;
        if (!this.disabled) {
            this.setColor(color);
            if (this.value !== oldValue) {
                this.emit("sl-change");
                this.emit("sl-input");
            }
        }
    }
    /** Generates a hex string from HSV values. Hue must be 0-360. All other arguments must be 0-100. */ getHexString(hue, saturation, brightness, alpha = 100) {
        const color = new (0, $888d862f8aa10ceb$export$d850312fc213f33e)(`hsva(${hue}, ${saturation}%, ${brightness}%, ${alpha / 100})`);
        if (!color.isValid) return "";
        return color.toHex8String();
    }
    // Prevents nested components from leaking events
    stopNestedEventPropagation(event) {
        event.stopImmediatePropagation();
    }
    handleFormatChange() {
        this.syncValues();
    }
    handleOpacityChange() {
        this.alpha = 100;
    }
    handleValueChange(oldValue, newValue) {
        this.isEmpty = !newValue;
        if (!newValue) {
            this.hue = 0;
            this.saturation = 0;
            this.brightness = 100;
            this.alpha = 100;
        }
        if (!this.isSafeValue) {
            const newColor = this.parseColor(newValue);
            if (newColor !== null) {
                this.inputValue = this.value;
                this.hue = newColor.hsva.h;
                this.saturation = newColor.hsva.s;
                this.brightness = newColor.hsva.v;
                this.alpha = newColor.hsva.a * 100;
                this.syncValues();
            } else this.inputValue = oldValue != null ? oldValue : "";
        }
    }
    /** Sets focus on the color picker. */ focus(options) {
        if (this.inline) this.base.focus(options);
        else this.trigger.focus(options);
    }
    /** Removes focus from the color picker. */ blur() {
        var _a;
        const elementToBlur = this.inline ? this.base : this.trigger;
        if (this.hasFocus) {
            elementToBlur.focus({
                preventScroll: true
            });
            elementToBlur.blur();
        }
        if ((_a = this.dropdown) == null ? void 0 : _a.open) this.dropdown.hide();
    }
    /** Returns the current value as a string in the specified format. */ getFormattedValue(format = "hex") {
        const currentColor = this.parseColor(`hsva(${this.hue}, ${this.saturation}%, ${this.brightness}%, ${this.alpha / 100})`);
        if (currentColor === null) return "";
        switch(format){
            case "hex":
                return currentColor.hex;
            case "hexa":
                return currentColor.hexa;
            case "rgb":
                return currentColor.rgb.string;
            case "rgba":
                return currentColor.rgba.string;
            case "hsl":
                return currentColor.hsl.string;
            case "hsla":
                return currentColor.hsla.string;
            case "hsv":
                return currentColor.hsv.string;
            case "hsva":
                return currentColor.hsva.string;
            default:
                return "";
        }
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.input.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        if (!this.inline && !this.validity.valid) {
            this.dropdown.show();
            this.addEventListener("sl-after-show", ()=>this.input.reportValidity(), {
                once: true
            });
            if (!this.disabled) this.formControlController.emitInvalidEvent();
            return false;
        }
        return this.input.reportValidity();
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        this.input.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    render() {
        const gridHandleX = this.saturation;
        const gridHandleY = 100 - this.brightness;
        const swatches = Array.isArray(this.swatches) ? this.swatches : this.swatches.split(";").filter((color)=>color.trim() !== "");
        const colorPicker = (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "color-picker": true,
            "color-picker--inline": this.inline,
            "color-picker--disabled": this.disabled,
            "color-picker--focused": this.hasFocus
        })}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-labelledby="label"
        tabindex=${this.inline ? "0" : "-1"}
      >
        ${this.inline ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <sl-visually-hidden id="label">
                <slot name="label">${this.label}</slot>
              </sl-visually-hidden>
            ` : null}

        <div
          part="grid"
          class="color-picker__grid"
          style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
            backgroundColor: this.getHexString(this.hue, 100, 100)
        })}
          @pointerdown=${this.handleGridDrag}
          @touchmove=${this.handleTouchMove}
        >
          <span
            part="grid-handle"
            class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "color-picker__grid-handle": true,
            "color-picker__grid-handle--dragging": this.isDraggingGridHandle
        })}
            style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
            top: `${gridHandleY}%`,
            left: `${gridHandleX}%`,
            backgroundColor: this.getHexString(this.hue, this.saturation, this.brightness, this.alpha)
        })}
            role="application"
            aria-label="HSV"
            tabindex=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.disabled ? void 0 : "0")}
            @keydown=${this.handleGridKeyDown}
          ></span>
        </div>

        <div class="color-picker__controls">
          <div class="color-picker__sliders">
            <div
              part="slider hue-slider"
              class="color-picker__hue color-picker__slider"
              @pointerdown=${this.handleHueDrag}
              @touchmove=${this.handleTouchMove}
            >
              <span
                part="slider-handle hue-slider-handle"
                class="color-picker__slider-handle"
                style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
            left: `${this.hue === 0 ? 0 : 100 / (360 / this.hue)}%`
        })}
                role="slider"
                aria-label="hue"
                aria-orientation="horizontal"
                aria-valuemin="0"
                aria-valuemax="360"
                aria-valuenow=${`${Math.round(this.hue)}`}
                tabindex=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.disabled ? void 0 : "0")}
                @keydown=${this.handleHueKeyDown}
              ></span>
            </div>

            ${this.opacity ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                  <div
                    part="slider opacity-slider"
                    class="color-picker__alpha color-picker__slider color-picker__transparent-bg"
                    @pointerdown="${this.handleAlphaDrag}"
                    @touchmove=${this.handleTouchMove}
                  >
                    <div
                      class="color-picker__alpha-gradient"
                      style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
            backgroundImage: `linear-gradient(
                          to right,
                          ${this.getHexString(this.hue, this.saturation, this.brightness, 0)} 0%,
                          ${this.getHexString(this.hue, this.saturation, this.brightness, 100)} 100%
                        )`
        })}
                    ></div>
                    <span
                      part="slider-handle opacity-slider-handle"
                      class="color-picker__slider-handle"
                      style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
            left: `${this.alpha}%`
        })}
                      role="slider"
                      aria-label="alpha"
                      aria-orientation="horizontal"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      aria-valuenow=${Math.round(this.alpha)}
                      tabindex=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.disabled ? void 0 : "0")}
                      @keydown=${this.handleAlphaKeyDown}
                    ></span>
                  </div>
                ` : ""}
          </div>

          <button
            type="button"
            part="preview"
            class="color-picker__preview color-picker__transparent-bg"
            aria-label=${this.localize.term("copy")}
            style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
            "--preview-color": this.getHexString(this.hue, this.saturation, this.brightness, this.alpha)
        })}
            @click=${this.handleCopy}
          ></button>
        </div>

        <div class="color-picker__user-input" aria-live="polite">
          <sl-input
            part="input"
            type="text"
            name=${this.name}
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            value=${this.isEmpty ? "" : this.inputValue}
            ?required=${this.required}
            ?disabled=${this.disabled}
            aria-label=${this.localize.term("currentValue")}
            @keydown=${this.handleInputKeyDown}
            @sl-change=${this.handleInputChange}
            @sl-input=${this.handleInputInput}
            @sl-invalid=${this.handleInputInvalid}
            @sl-blur=${this.stopNestedEventPropagation}
            @sl-focus=${this.stopNestedEventPropagation}
          ></sl-input>

          <sl-button-group>
            ${!this.noFormatToggle ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                  <sl-button
                    part="format-button"
                    aria-label=${this.localize.term("toggleColorFormat")}
                    exportparts="
                      base:format-button__base,
                      prefix:format-button__prefix,
                      label:format-button__label,
                      suffix:format-button__suffix,
                      caret:format-button__caret
                    "
                    @click=${this.handleFormatToggle}
                    @sl-blur=${this.stopNestedEventPropagation}
                    @sl-focus=${this.stopNestedEventPropagation}
                  >
                    ${this.setLetterCase(this.format)}
                  </sl-button>
                ` : ""}
            ${$e2d427e107caecb0$var$hasEyeDropper ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                  <sl-button
                    part="eye-dropper-button"
                    exportparts="
                      base:eye-dropper-button__base,
                      prefix:eye-dropper-button__prefix,
                      label:eye-dropper-button__label,
                      suffix:eye-dropper-button__suffix,
                      caret:eye-dropper-button__caret
                    "
                    @click=${this.handleEyeDropper}
                    @sl-blur=${this.stopNestedEventPropagation}
                    @sl-focus=${this.stopNestedEventPropagation}
                  >
                    <sl-icon
                      library="system"
                      name="eyedropper"
                      label=${this.localize.term("selectAColorFromTheScreen")}
                    ></sl-icon>
                  </sl-button>
                ` : ""}
          </sl-button-group>
        </div>

        ${swatches.length > 0 ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <div part="swatches" class="color-picker__swatches">
                ${swatches.map((swatch)=>{
            const parsedColor = this.parseColor(swatch);
            if (!parsedColor) {
                console.error(`Unable to parse swatch color: "${swatch}"`, this);
                return "";
            }
            return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                    <div
                      part="swatch"
                      class="color-picker__swatch color-picker__transparent-bg"
                      tabindex=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.disabled ? void 0 : "0")}
                      role="button"
                      aria-label=${swatch}
                      @click=${()=>this.selectSwatch(swatch)}
                      @keydown=${(event)=>!this.disabled && event.key === "Enter" && this.setColor(parsedColor.hexa)}
                    >
                      <div
                        class="color-picker__swatch-color"
                        style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
                backgroundColor: parsedColor.hexa
            })}
                      ></div>
                    </div>
                  `;
        })}
              </div>
            ` : ""}
      </div>
    `;
        if (this.inline) return colorPicker;
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <sl-dropdown
        class="color-dropdown"
        aria-disabled=${this.disabled ? "true" : "false"}
        .containingElement=${this}
        ?disabled=${this.disabled}
        ?hoist=${this.hoist}
        @sl-after-hide=${this.handleAfterHide}
      >
        <button
          part="trigger"
          slot="trigger"
          class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "color-dropdown__trigger": true,
            "color-dropdown__trigger--disabled": this.disabled,
            "color-dropdown__trigger--small": this.size === "small",
            "color-dropdown__trigger--medium": this.size === "medium",
            "color-dropdown__trigger--large": this.size === "large",
            "color-dropdown__trigger--empty": this.isEmpty,
            "color-dropdown__trigger--focused": this.hasFocus,
            "color-picker__transparent-bg": true
        })}
          style=${(0, $75c977654b2136c5$export$1e5b4ce2fa884e6a)({
            color: this.getHexString(this.hue, this.saturation, this.brightness, this.alpha)
        })}
          type="button"
        >
          <sl-visually-hidden>
            <slot name="label">${this.label}</slot>
          </sl-visually-hidden>
        </button>
        ${colorPicker}
      </sl-dropdown>
    `;
    }
};
$e2d427e107caecb0$export$b031ae0dd958712a.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $4c84c54f2f66487a$export$3a7afb6cc0ee0754)
];
$e2d427e107caecb0$export$b031ae0dd958712a.dependencies = {
    "sl-button-group": (0, $756c1967426696a0$export$da1d95f84eaf247e),
    "sl-button": (0, $5e30fc3ddce21c8b$export$e56d306ebf763f31),
    "sl-dropdown": (0, $953fa65c0972af7b$export$d9f5b7dd140b6839),
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441),
    "sl-input": (0, $434fbe6d3fc944cc$export$bf759620d4db2643),
    "sl-visually-hidden": (0, $dfcc3ba37f2248e3$export$f73c78e34b41d070)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)('[part~="base"]')
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "base", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)('[part~="input"]')
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "input", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".color-dropdown")
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "dropdown", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)('[part~="preview"]')
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "previewButton", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)('[part~="trigger"]')
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "trigger", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "hasFocus", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "isDraggingGridHandle", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "isEmpty", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "inputValue", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "hue", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "saturation", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "brightness", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "alpha", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "value", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $66d37a8d1e916a65$export$1a01ae0705bafd37)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "defaultValue", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "label", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "format", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "inline", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "size", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "no-format-toggle",
        type: Boolean
    })
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "noFormatToggle", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "name", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "disabled", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "hoist", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "opacity", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean
    })
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "uppercase", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "swatches", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "form", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "required", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $8a317031349a1d0f$export$b2b799818fbabcf3)({
        passive: false
    })
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "handleTouchMove", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("format", {
        waitUntilFirstUpdate: true
    })
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "handleFormatChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("opacity", {
        waitUntilFirstUpdate: true
    })
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "handleOpacityChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("value")
], $e2d427e107caecb0$export$b031ae0dd958712a.prototype, "handleValueChange", 1);


// src/components/color-picker/color-picker.ts
var $9cf777a36f6f2ead$export$918885e9ccef07c3 = (0, $e2d427e107caecb0$export$b031ae0dd958712a);
(0, $e2d427e107caecb0$export$b031ae0dd958712a).define("sl-color-picker");




















// src/components/card/card.styles.ts

var $d3631717420e8f0b$export$eceb153d0f9bbd93 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --border-color: var(--sl-color-neutral-200);
    --border-radius: var(--sl-border-radius-medium);
    --border-width: 1px;
    --padding: var(--sl-spacing-large);

    display: inline-block;
  }

  .card {
    display: flex;
    flex-direction: column;
    background-color: var(--sl-panel-background-color);
    box-shadow: var(--sl-shadow-x-small);
    border: solid var(--border-width) var(--border-color);
    border-radius: var(--border-radius);
  }

  .card__image {
    display: flex;
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
    margin: calc(-1 * var(--border-width));
    overflow: hidden;
  }

  .card__image::slotted(img) {
    display: block;
    width: 100%;
  }

  .card:not(.card--has-image) .card__image {
    display: none;
  }

  .card__header {
    display: block;
    border-bottom: solid var(--border-width) var(--border-color);
    padding: calc(var(--padding) / 2) var(--padding);
  }

  .card:not(.card--has-header) .card__header {
    display: none;
  }

  .card:not(.card--has-image) .card__header {
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
  }

  .card__body {
    display: block;
    padding: var(--padding);
  }

  .card--has-footer .card__footer {
    display: block;
    border-top: solid var(--border-width) var(--border-color);
    padding: var(--padding);
  }

  .card:not(.card--has-footer) .card__footer {
    display: none;
  }
`;







var $4d92fb5546f48cb7$export$a93c76cb301d0cc8 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "footer", "header", "image");
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            card: true,
            "card--has-footer": this.hasSlotController.test("footer"),
            "card--has-image": this.hasSlotController.test("image"),
            "card--has-header": this.hasSlotController.test("header")
        })}
      >
        <slot name="image" part="image" class="card__image"></slot>
        <slot name="header" part="header" class="card__header"></slot>
        <slot part="body" class="card__body"></slot>
        <slot name="footer" part="footer" class="card__footer"></slot>
      </div>
    `;
    }
};
$4d92fb5546f48cb7$export$a93c76cb301d0cc8.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $d3631717420e8f0b$export$eceb153d0f9bbd93)
];


// src/components/card/card.ts
var $ebe1e5678e9e51c3$export$4630804d47451d56 = (0, $4d92fb5546f48cb7$export$a93c76cb301d0cc8);
(0, $4d92fb5546f48cb7$export$a93c76cb301d0cc8).define("sl-card");



// src/components/carousel/autoplay-controller.ts
var $723c972d88162246$export$a9a0b55bc0093be5 = class {
    constructor(host, tickCallback){
        this.timerId = 0;
        this.activeInteractions = 0;
        this.paused = false;
        this.stopped = true;
        this.pause = ()=>{
            if (!this.activeInteractions++) {
                this.paused = true;
                this.host.requestUpdate();
            }
        };
        this.resume = ()=>{
            if (!--this.activeInteractions) {
                this.paused = false;
                this.host.requestUpdate();
            }
        };
        host.addController(this);
        this.host = host;
        this.tickCallback = tickCallback;
    }
    hostConnected() {
        this.host.addEventListener("mouseenter", this.pause);
        this.host.addEventListener("mouseleave", this.resume);
        this.host.addEventListener("focusin", this.pause);
        this.host.addEventListener("focusout", this.resume);
        this.host.addEventListener("touchstart", this.pause, {
            passive: true
        });
        this.host.addEventListener("touchend", this.resume);
    }
    hostDisconnected() {
        this.stop();
        this.host.removeEventListener("mouseenter", this.pause);
        this.host.removeEventListener("mouseleave", this.resume);
        this.host.removeEventListener("focusin", this.pause);
        this.host.removeEventListener("focusout", this.resume);
        this.host.removeEventListener("touchstart", this.pause);
        this.host.removeEventListener("touchend", this.resume);
    }
    start(interval) {
        this.stop();
        this.stopped = false;
        this.timerId = window.setInterval(()=>{
            if (!this.paused) this.tickCallback();
        }, interval);
    }
    stop() {
        clearInterval(this.timerId);
        this.stopped = true;
        this.host.requestUpdate();
    }
};


// src/components/carousel/carousel.styles.ts

var $6b08972fe5336776$export$53f9b56b2cc2a838 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --slide-gap: var(--sl-spacing-medium, 1rem);
    --aspect-ratio: 16 / 9;
    --scroll-hint: 0px;

    display: flex;
  }

  .carousel {
    display: grid;
    grid-template-columns: min-content 1fr min-content;
    grid-template-rows: 1fr min-content;
    grid-template-areas:
      '. slides .'
      '. pagination .';
    gap: var(--sl-spacing-medium);
    align-items: center;
    min-height: 100%;
    min-width: 100%;
    position: relative;
  }

  .carousel__pagination {
    grid-area: pagination;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: var(--sl-spacing-small);
  }

  .carousel__slides {
    grid-area: slides;

    display: grid;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-items: center;
    overflow: auto;
    overscroll-behavior-x: contain;
    scrollbar-width: none;
    aspect-ratio: calc(var(--aspect-ratio) * var(--slides-per-page));
    border-radius: var(--sl-border-radius-small);

    --slide-size: calc((100% - (var(--slides-per-page) - 1) * var(--slide-gap)) / var(--slides-per-page));
  }

  @media (prefers-reduced-motion) {
    :where(.carousel__slides) {
      scroll-behavior: auto;
    }
  }

  .carousel__slides--horizontal {
    grid-auto-flow: column;
    grid-auto-columns: var(--slide-size);
    grid-auto-rows: 100%;
    column-gap: var(--slide-gap);
    scroll-snap-type: x mandatory;
    scroll-padding-inline: var(--scroll-hint);
    padding-inline: var(--scroll-hint);
    overflow-y: hidden;
  }

  .carousel__slides--vertical {
    grid-auto-flow: row;
    grid-auto-columns: 100%;
    grid-auto-rows: var(--slide-size);
    row-gap: var(--slide-gap);
    scroll-snap-type: y mandatory;
    scroll-padding-block: var(--scroll-hint);
    padding-block: var(--scroll-hint);
    overflow-x: hidden;
  }

  .carousel__slides--dragging {
  }

  :host([vertical]) ::slotted(sl-carousel-item) {
    height: 100%;
  }

  .carousel__slides::-webkit-scrollbar {
    display: none;
  }

  .carousel__navigation {
    grid-area: navigation;
    display: contents;
    font-size: var(--sl-font-size-x-large);
  }

  .carousel__navigation-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-small);
    font-size: inherit;
    color: var(--sl-color-neutral-600);
    padding: var(--sl-spacing-x-small);
    cursor: pointer;
    transition: var(--sl-transition-medium) color;
    appearance: none;
  }

  .carousel__navigation-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .carousel__navigation-button--disabled::part(base) {
    pointer-events: none;
  }

  .carousel__navigation-button--previous {
    grid-column: 1;
    grid-row: 1;
  }

  .carousel__navigation-button--next {
    grid-column: 3;
    grid-row: 1;
  }

  .carousel__pagination-item {
    display: block;
    cursor: pointer;
    background: none;
    border: 0;
    border-radius: var(--sl-border-radius-circle);
    width: var(--sl-spacing-small);
    height: var(--sl-spacing-small);
    background-color: var(--sl-color-neutral-300);
    padding: 0;
    margin: 0;
  }

  .carousel__pagination-item--active {
    background-color: var(--sl-color-neutral-700);
    transform: scale(1.2);
  }

  /* Focus styles */
  .carousel__slides:focus-visible,
  .carousel__navigation-button:focus-visible,
  .carousel__pagination-item:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }
`;













/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $3f03a72455305350$export$871de8747c9eaa88(o, f) {
    if (void 0 !== o) {
        let i = 0;
        for (const t of o)yield f(t, i++);
    }
}




/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $d7babcb51f3d1a2f$export$d02631cccf789723(o1, t, e = 1) {
    const i = void 0 === t ? 0 : o1;
    t ??= o1;
    for(let o = i; e > 0 ? o < t : t < o; o += e)yield o;
}




var $cfbf28b864587c46$export$f07c6192812bdc3c = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.loop = false;
        this.navigation = false;
        this.pagination = false;
        this.autoplay = false;
        this.autoplayInterval = 3e3;
        this.slidesPerPage = 1;
        this.slidesPerMove = 1;
        this.orientation = "horizontal";
        this.mouseDragging = false;
        this.activeSlide = 0;
        this.scrolling = false;
        this.dragging = false;
        this.autoplayController = new (0, $723c972d88162246$export$a9a0b55bc0093be5)(this, ()=>this.next());
        this.dragStartPosition = [
            -1,
            -1
        ];
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.pendingSlideChange = false;
        this.handleMouseDrag = (event)=>{
            if (!this.dragging) {
                this.scrollContainer.style.setProperty("scroll-snap-type", "none");
                this.dragging = true;
                this.dragStartPosition = [
                    event.clientX,
                    event.clientY
                ];
            }
            this.scrollContainer.scrollBy({
                left: -event.movementX,
                top: -event.movementY,
                behavior: "instant"
            });
        };
        this.handleMouseDragEnd = ()=>{
            const scrollContainer = this.scrollContainer;
            document.removeEventListener("pointermove", this.handleMouseDrag, {
                capture: true
            });
            const startLeft = scrollContainer.scrollLeft;
            const startTop = scrollContainer.scrollTop;
            scrollContainer.style.removeProperty("scroll-snap-type");
            scrollContainer.style.setProperty("overflow", "hidden");
            const finalLeft = scrollContainer.scrollLeft;
            const finalTop = scrollContainer.scrollTop;
            scrollContainer.style.removeProperty("overflow");
            scrollContainer.style.setProperty("scroll-snap-type", "none");
            scrollContainer.scrollTo({
                left: startLeft,
                top: startTop,
                behavior: "instant"
            });
            requestAnimationFrame(async ()=>{
                if (startLeft !== finalLeft || startTop !== finalTop) {
                    scrollContainer.scrollTo({
                        left: finalLeft,
                        top: finalTop,
                        behavior: (0, $41facc830b5907b7$export$ff7706047246b98b)() ? "auto" : "smooth"
                    });
                    await (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(scrollContainer, "scrollend");
                }
                scrollContainer.style.removeProperty("scroll-snap-type");
                this.dragging = false;
                this.dragStartPosition = [
                    -1,
                    -1
                ];
                this.handleScrollEnd();
            });
        };
        this.handleSlotChange = (mutations)=>{
            const needsInitialization = mutations.some((mutation)=>[
                    ...mutation.addedNodes,
                    ...mutation.removedNodes
                ].some((el)=>this.isCarouselItem(el) && !el.hasAttribute("data-clone")));
            if (needsInitialization) this.initializeSlides();
            this.requestUpdate();
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "region");
        this.setAttribute("aria-label", this.localize.term("carousel"));
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.mutationObserver) == null || _a.disconnect();
    }
    firstUpdated() {
        this.initializeSlides();
        this.mutationObserver = new MutationObserver(this.handleSlotChange);
        this.mutationObserver.observe(this, {
            childList: true,
            subtree: true
        });
    }
    willUpdate(changedProperties) {
        if (changedProperties.has("slidesPerMove") || changedProperties.has("slidesPerPage")) this.slidesPerMove = Math.min(this.slidesPerMove, this.slidesPerPage);
    }
    getPageCount() {
        const slidesCount = this.getSlides().length;
        const { slidesPerPage: slidesPerPage, slidesPerMove: slidesPerMove, loop: loop } = this;
        const pages = loop ? slidesCount / slidesPerMove : (slidesCount - slidesPerPage) / slidesPerMove + 1;
        return Math.ceil(pages);
    }
    getCurrentPage() {
        return Math.ceil(this.activeSlide / this.slidesPerMove);
    }
    canScrollNext() {
        return this.loop || this.getCurrentPage() < this.getPageCount() - 1;
    }
    canScrollPrev() {
        return this.loop || this.getCurrentPage() > 0;
    }
    /** @internal Gets all carousel items. */ getSlides({ excludeClones: excludeClones = true } = {}) {
        return [
            ...this.children
        ].filter((el)=>this.isCarouselItem(el) && (!excludeClones || !el.hasAttribute("data-clone")));
    }
    handleClick(event) {
        if (this.dragging && this.dragStartPosition[0] > 0 && this.dragStartPosition[1] > 0) {
            const deltaX = Math.abs(this.dragStartPosition[0] - event.clientX);
            const deltaY = Math.abs(this.dragStartPosition[1] - event.clientY);
            const delta = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
            if (delta >= 10) event.preventDefault();
        }
    }
    handleKeyDown(event) {
        if ([
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Home",
            "End"
        ].includes(event.key)) {
            const target = event.target;
            const isRtl = this.localize.dir() === "rtl";
            const isFocusInPagination = target.closest('[part~="pagination-item"]') !== null;
            const isNext = event.key === "ArrowDown" || !isRtl && event.key === "ArrowRight" || isRtl && event.key === "ArrowLeft";
            const isPrevious = event.key === "ArrowUp" || !isRtl && event.key === "ArrowLeft" || isRtl && event.key === "ArrowRight";
            event.preventDefault();
            if (isPrevious) this.previous();
            if (isNext) this.next();
            if (event.key === "Home") this.goToSlide(0);
            if (event.key === "End") this.goToSlide(this.getSlides().length - 1);
            if (isFocusInPagination) this.updateComplete.then(()=>{
                var _a;
                const activePaginationItem = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector('[part~="pagination-item--active"]');
                if (activePaginationItem) activePaginationItem.focus();
            });
        }
    }
    handleMouseDragStart(event) {
        const canDrag = this.mouseDragging && event.button === 0;
        if (canDrag) {
            event.preventDefault();
            document.addEventListener("pointermove", this.handleMouseDrag, {
                capture: true,
                passive: true
            });
            document.addEventListener("pointerup", this.handleMouseDragEnd, {
                capture: true,
                once: true
            });
        }
    }
    handleScroll() {
        this.scrolling = true;
        if (!this.pendingSlideChange) this.synchronizeSlides();
    }
    /** @internal Synchronizes the slides with the IntersectionObserver API. */ synchronizeSlides() {
        const io = new IntersectionObserver((entries)=>{
            io.disconnect();
            for (const entry of entries){
                const slide = entry.target;
                slide.toggleAttribute("inert", !entry.isIntersecting);
                slide.classList.toggle("--in-view", entry.isIntersecting);
                slide.setAttribute("aria-hidden", entry.isIntersecting ? "false" : "true");
            }
            const firstIntersecting = entries.find((entry)=>entry.isIntersecting);
            if (!firstIntersecting) return;
            const slidesWithClones = this.getSlides({
                excludeClones: false
            });
            const slidesCount = this.getSlides().length;
            const slideIndex = slidesWithClones.indexOf(firstIntersecting.target);
            const normalizedIndex = this.loop ? slideIndex - this.slidesPerPage : slideIndex;
            this.activeSlide = (Math.ceil(normalizedIndex / this.slidesPerMove) * this.slidesPerMove + slidesCount) % slidesCount;
            if (!this.scrolling) {
                if (this.loop && firstIntersecting.target.hasAttribute("data-clone")) {
                    const clonePosition = Number(firstIntersecting.target.getAttribute("data-clone"));
                    this.goToSlide(clonePosition, "instant");
                }
            }
        }, {
            root: this.scrollContainer,
            threshold: 0.6
        });
        this.getSlides({
            excludeClones: false
        }).forEach((slide)=>{
            io.observe(slide);
        });
    }
    handleScrollEnd() {
        if (!this.scrolling || this.dragging) return;
        this.scrolling = false;
        this.pendingSlideChange = false;
        this.synchronizeSlides();
    }
    isCarouselItem(node) {
        return node instanceof Element && node.tagName.toLowerCase() === "sl-carousel-item";
    }
    initializeSlides() {
        this.getSlides({
            excludeClones: false
        }).forEach((slide, index)=>{
            slide.classList.remove("--in-view");
            slide.classList.remove("--is-active");
            slide.setAttribute("aria-label", this.localize.term("slideNum", index + 1));
            if (slide.hasAttribute("data-clone")) slide.remove();
        });
        this.updateSlidesSnap();
        if (this.loop) this.createClones();
        this.goToSlide(this.activeSlide, "auto");
        this.synchronizeSlides();
    }
    createClones() {
        const slides = this.getSlides();
        const slidesPerPage = this.slidesPerPage;
        const lastSlides = slides.slice(-slidesPerPage);
        const firstSlides = slides.slice(0, slidesPerPage);
        lastSlides.reverse().forEach((slide, i)=>{
            const clone = slide.cloneNode(true);
            clone.setAttribute("data-clone", String(slides.length - i - 1));
            this.prepend(clone);
        });
        firstSlides.forEach((slide, i)=>{
            const clone = slide.cloneNode(true);
            clone.setAttribute("data-clone", String(i));
            this.append(clone);
        });
    }
    handleSlideChange() {
        const slides = this.getSlides();
        slides.forEach((slide, i)=>{
            slide.classList.toggle("--is-active", i === this.activeSlide);
        });
        if (this.hasUpdated) this.emit("sl-slide-change", {
            detail: {
                index: this.activeSlide,
                slide: slides[this.activeSlide]
            }
        });
    }
    updateSlidesSnap() {
        const slides = this.getSlides();
        const slidesPerMove = this.slidesPerMove;
        slides.forEach((slide, i)=>{
            const shouldSnap = (i + slidesPerMove) % slidesPerMove === 0;
            if (shouldSnap) slide.style.removeProperty("scroll-snap-align");
            else slide.style.setProperty("scroll-snap-align", "none");
        });
    }
    handleAutoplayChange() {
        this.autoplayController.stop();
        if (this.autoplay) this.autoplayController.start(this.autoplayInterval);
    }
    /**
   * Move the carousel backward by `slides-per-move` slides.
   *
   * @param behavior - The behavior used for scrolling.
   */ previous(behavior = "smooth") {
        this.goToSlide(this.activeSlide - this.slidesPerMove, behavior);
    }
    /**
   * Move the carousel forward by `slides-per-move` slides.
   *
   * @param behavior - The behavior used for scrolling.
   */ next(behavior = "smooth") {
        this.goToSlide(this.activeSlide + this.slidesPerMove, behavior);
    }
    /**
   * Scrolls the carousel to the slide specified by `index`.
   *
   * @param index - The slide index.
   * @param behavior - The behavior used for scrolling.
   */ goToSlide(index, behavior = "smooth") {
        const { slidesPerPage: slidesPerPage, loop: loop } = this;
        const slides = this.getSlides();
        const slidesWithClones = this.getSlides({
            excludeClones: false
        });
        if (!slides.length) return;
        const newActiveSlide = loop ? (index + slides.length) % slides.length : (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(index, 0, slides.length - slidesPerPage);
        this.activeSlide = newActiveSlide;
        const isRtl = this.localize.dir() === "rtl";
        const nextSlideIndex = (0, $271caa7bc1493813$export$7d15b64cf5a3a4c4)(index + (loop ? slidesPerPage : 0) + (isRtl ? slidesPerPage - 1 : 0), 0, slidesWithClones.length - 1);
        const nextSlide = slidesWithClones[nextSlideIndex];
        this.scrollToSlide(nextSlide, (0, $41facc830b5907b7$export$ff7706047246b98b)() ? "auto" : behavior);
    }
    scrollToSlide(slide, behavior = "smooth") {
        this.pendingSlideChange = true;
        window.requestAnimationFrame(()=>{
            if (!this.scrollContainer) return;
            const scrollContainer = this.scrollContainer;
            const scrollContainerRect = scrollContainer.getBoundingClientRect();
            const nextSlideRect = slide.getBoundingClientRect();
            const nextLeft = nextSlideRect.left - scrollContainerRect.left;
            const nextTop = nextSlideRect.top - scrollContainerRect.top;
            if (nextLeft || nextTop) {
                this.pendingSlideChange = true;
                scrollContainer.scrollTo({
                    left: nextLeft + scrollContainer.scrollLeft,
                    top: nextTop + scrollContainer.scrollTop,
                    behavior: behavior
                });
            } else this.pendingSlideChange = false;
        });
    }
    render() {
        const { slidesPerMove: slidesPerMove, scrolling: scrolling } = this;
        const pagesCount = this.getPageCount();
        const currentPage = this.getCurrentPage();
        const prevEnabled = this.canScrollPrev();
        const nextEnabled = this.canScrollNext();
        const isLtr = this.localize.dir() === "ltr";
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div part="base" class="carousel">
        <div
          id="scroll-container"
          part="scroll-container"
          class="${(0, $4930586706e2a706$export$56cc687933817664)({
            carousel__slides: true,
            "carousel__slides--horizontal": this.orientation === "horizontal",
            "carousel__slides--vertical": this.orientation === "vertical",
            "carousel__slides--dragging": this.dragging
        })}"
          style="--slides-per-page: ${this.slidesPerPage};"
          aria-busy="${scrolling ? "true" : "false"}"
          aria-atomic="true"
          tabindex="0"
          @keydown=${this.handleKeyDown}
          @mousedown="${this.handleMouseDragStart}"
          @scroll="${this.handleScroll}"
          @scrollend=${this.handleScrollEnd}
          @click=${this.handleClick}
        >
          <slot></slot>
        </div>

        ${this.navigation ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <div part="navigation" class="carousel__navigation">
                <button
                  part="navigation-button navigation-button--previous"
                  class="${(0, $4930586706e2a706$export$56cc687933817664)({
            "carousel__navigation-button": true,
            "carousel__navigation-button--previous": true,
            "carousel__navigation-button--disabled": !prevEnabled
        })}"
                  aria-label="${this.localize.term("previousSlide")}"
                  aria-controls="scroll-container"
                  aria-disabled="${prevEnabled ? "false" : "true"}"
                  @click=${prevEnabled ? ()=>this.previous() : null}
                >
                  <slot name="previous-icon">
                    <sl-icon library="system" name="${isLtr ? "chevron-left" : "chevron-right"}"></sl-icon>
                  </slot>
                </button>

                <button
                  part="navigation-button navigation-button--next"
                  class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "carousel__navigation-button": true,
            "carousel__navigation-button--next": true,
            "carousel__navigation-button--disabled": !nextEnabled
        })}
                  aria-label="${this.localize.term("nextSlide")}"
                  aria-controls="scroll-container"
                  aria-disabled="${nextEnabled ? "false" : "true"}"
                  @click=${nextEnabled ? ()=>this.next() : null}
                >
                  <slot name="next-icon">
                    <sl-icon library="system" name="${isLtr ? "chevron-right" : "chevron-left"}"></sl-icon>
                  </slot>
                </button>
              </div>
            ` : ""}
        ${this.pagination ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <div part="pagination" role="tablist" class="carousel__pagination" aria-controls="scroll-container">
                ${(0, $3f03a72455305350$export$871de8747c9eaa88)((0, $d7babcb51f3d1a2f$export$d02631cccf789723)(pagesCount), (index)=>{
            const isActive = index === currentPage;
            return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
                    <button
                      part="pagination-item ${isActive ? "pagination-item--active" : ""}"
                      class="${(0, $4930586706e2a706$export$56cc687933817664)({
                "carousel__pagination-item": true,
                "carousel__pagination-item--active": isActive
            })}"
                      role="tab"
                      aria-selected="${isActive ? "true" : "false"}"
                      aria-label="${this.localize.term("goToSlide", index + 1, pagesCount)}"
                      tabindex=${isActive ? "0" : "-1"}
                      @click=${()=>this.goToSlide(index * slidesPerMove)}
                      @keydown=${this.handleKeyDown}
                    ></button>
                  `;
        })}
              </div>
            ` : ""}
      </div>
    `;
    }
};
$cfbf28b864587c46$export$f07c6192812bdc3c.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $6b08972fe5336776$export$53f9b56b2cc2a838)
];
$cfbf28b864587c46$export$f07c6192812bdc3c.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "loop", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "navigation", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "pagination", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "autoplay", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number,
        attribute: "autoplay-interval"
    })
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "autoplayInterval", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number,
        attribute: "slides-per-page"
    })
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "slidesPerPage", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number,
        attribute: "slides-per-move"
    })
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "slidesPerMove", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "orientation", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        attribute: "mouse-dragging"
    })
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "mouseDragging", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".carousel__slides")
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "scrollContainer", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".carousel__pagination")
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "paginationContainer", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "activeSlide", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "scrolling", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "dragging", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $8a317031349a1d0f$export$b2b799818fbabcf3)({
        passive: true
    })
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "handleScroll", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("loop", {
        waitUntilFirstUpdate: true
    }),
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("slidesPerPage", {
        waitUntilFirstUpdate: true
    })
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "initializeSlides", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("activeSlide")
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "handleSlideChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("slidesPerMove")
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "updateSlidesSnap", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("autoplay")
], $cfbf28b864587c46$export$f07c6192812bdc3c.prototype, "handleAutoplayChange", 1);


// src/components/carousel/carousel.ts
var $1fd0868e8a8ea6ce$export$aa49f2663856f5b3 = (0, $cfbf28b864587c46$export$f07c6192812bdc3c);
(0, $cfbf28b864587c46$export$f07c6192812bdc3c).define("sl-carousel");



// src/internal/scrollend-polyfill.ts
var $1a2baa6a9979d388$var$debounce = (fn, delay)=>{
    let timerId = 0;
    return function(...args) {
        window.clearTimeout(timerId);
        timerId = window.setTimeout(()=>{
            fn.call(this, ...args);
        }, delay);
    };
};
var $1a2baa6a9979d388$var$decorate = (proto, method, decorateFn)=>{
    const superFn = proto[method];
    proto[method] = function(...args) {
        superFn.call(this, ...args);
        decorateFn.call(this, superFn, ...args);
    };
};
(()=>{
    if (typeof window === "undefined") return;
    const isSupported = "onscrollend" in window;
    if (!isSupported) {
        const pointers = /* @__PURE__ */ new Set();
        const scrollHandlers = /* @__PURE__ */ new WeakMap();
        const handlePointerDown = (event)=>{
            for (const touch of event.changedTouches)pointers.add(touch.identifier);
        };
        const handlePointerUp = (event)=>{
            for (const touch of event.changedTouches)pointers.delete(touch.identifier);
        };
        document.addEventListener("touchstart", handlePointerDown, true);
        document.addEventListener("touchend", handlePointerUp, true);
        document.addEventListener("touchcancel", handlePointerUp, true);
        $1a2baa6a9979d388$var$decorate(EventTarget.prototype, "addEventListener", function(addEventListener, type) {
            if (type !== "scrollend") return;
            const handleScrollEnd = $1a2baa6a9979d388$var$debounce(()=>{
                if (!pointers.size) this.dispatchEvent(new Event("scrollend"));
                else handleScrollEnd();
            }, 100);
            addEventListener.call(this, "scroll", handleScrollEnd, {
                passive: true
            });
            scrollHandlers.set(this, handleScrollEnd);
        });
        $1a2baa6a9979d388$var$decorate(EventTarget.prototype, "removeEventListener", function(removeEventListener, type) {
            if (type !== "scrollend") return;
            const scrollHandler = scrollHandlers.get(this);
            if (scrollHandler) removeEventListener.call(this, "scroll", scrollHandler, {
                passive: true
            });
        });
    }
})();





// src/components/carousel-item/carousel-item.styles.ts

var $c020b6d6e93eb087$export$3388466d1465b74b = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --aspect-ratio: inherit;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    max-height: 100%;
    aspect-ratio: var(--aspect-ratio);
    scroll-snap-align: start;
    scroll-snap-stop: always;
  }

  ::slotted(img) {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
  }
`;





var $6557245e169b0176$export$e4d7341221b50dcf = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "group");
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)` <slot></slot> `;
    }
};
$6557245e169b0176$export$e4d7341221b50dcf.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $c020b6d6e93eb087$export$3388466d1465b74b)
];


// src/components/carousel-item/carousel-item.ts
var $cf58583fd2c044ae$export$a7881480d5974f61 = (0, $6557245e169b0176$export$e4d7341221b50dcf);
(0, $6557245e169b0176$export$e4d7341221b50dcf).define("sl-carousel-item");





// src/components/button-group/button-group.ts
var $9e138e3f8729a809$export$9b440e165d63ca09 = (0, $756c1967426696a0$export$da1d95f84eaf247e);
(0, $756c1967426696a0$export$da1d95f84eaf247e).define("sl-button-group");





// src/components/button/button.ts
var $ea5d7146840b2d05$export$11c362adf4e83e40 = (0, $5e30fc3ddce21c8b$export$e56d306ebf763f31);
(0, $5e30fc3ddce21c8b$export$e56d306ebf763f31).define("sl-button");









// src/components/breadcrumb/breadcrumb.styles.ts

var $adb0665f7a5dde37$export$1832f44b81141fb4 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  .breadcrumb {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
`;









var $598dac0a1c991448$export$ad2daa0f973a734d = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.separatorDir = this.localize.dir();
        this.label = "";
    }
    // Generates a clone of the separator element to use for each breadcrumb item
    getSeparator() {
        const separator = this.separatorSlot.assignedElements({
            flatten: true
        })[0];
        const clone = separator.cloneNode(true);
        [
            clone,
            ...clone.querySelectorAll("[id]")
        ].forEach((el)=>el.removeAttribute("id"));
        clone.setAttribute("data-default", "");
        clone.slot = "separator";
        return clone;
    }
    handleSlotChange() {
        const items = [
            ...this.defaultSlot.assignedElements({
                flatten: true
            })
        ].filter((item)=>item.tagName.toLowerCase() === "sl-breadcrumb-item");
        items.forEach((item, index)=>{
            const separator = item.querySelector('[slot="separator"]');
            if (separator === null) item.append(this.getSeparator());
            else if (separator.hasAttribute("data-default")) separator.replaceWith(this.getSeparator());
            if (index === items.length - 1) item.setAttribute("aria-current", "page");
            else item.removeAttribute("aria-current");
        });
    }
    render() {
        if (this.separatorDir !== this.localize.dir()) {
            this.separatorDir = this.localize.dir();
            this.updateComplete.then(()=>this.handleSlotChange());
        }
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <nav part="base" class="breadcrumb" aria-label=${this.label}>
        <slot @slotchange=${this.handleSlotChange}></slot>
      </nav>

      <span hidden aria-hidden="true">
        <slot name="separator">
          <sl-icon name=${this.localize.dir() === "rtl" ? "chevron-left" : "chevron-right"} library="system"></sl-icon>
        </slot>
      </span>
    `;
    }
};
$598dac0a1c991448$export$ad2daa0f973a734d.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $adb0665f7a5dde37$export$1832f44b81141fb4)
];
$598dac0a1c991448$export$ad2daa0f973a734d.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("slot")
], $598dac0a1c991448$export$ad2daa0f973a734d.prototype, "defaultSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)('slot[name="separator"]')
], $598dac0a1c991448$export$ad2daa0f973a734d.prototype, "separatorSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $598dac0a1c991448$export$ad2daa0f973a734d.prototype, "label", 2);


// src/components/breadcrumb/breadcrumb.ts
var $6f4edfed2d99373c$export$8af8d294a437496b = (0, $598dac0a1c991448$export$ad2daa0f973a734d);
(0, $598dac0a1c991448$export$ad2daa0f973a734d).define("sl-breadcrumb");


// src/components/badge/badge.styles.ts

var $239be25996d64c2e$export$7024a65909a151df = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: inline-flex;
  }

  .badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: max(12px, 0.75em);
    font-weight: var(--sl-font-weight-semibold);
    letter-spacing: var(--sl-letter-spacing-normal);
    line-height: 1;
    border-radius: var(--sl-border-radius-small);
    border: solid 1px var(--sl-color-neutral-0);
    white-space: nowrap;
    padding: 0.35em 0.6em;
    user-select: none;
    -webkit-user-select: none;
    cursor: inherit;
  }

  /* Variant modifiers */
  .badge--primary {
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .badge--success {
    background-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .badge--neutral {
    background-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .badge--warning {
    background-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  .badge--danger {
    background-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  /* Pill modifier */
  .badge--pill {
    border-radius: var(--sl-border-radius-pill);
  }

  /* Pulse modifier */
  .badge--pulse {
    animation: pulse 1.5s infinite;
  }

  .badge--pulse.badge--primary {
    --pulse-color: var(--sl-color-primary-600);
  }

  .badge--pulse.badge--success {
    --pulse-color: var(--sl-color-success-600);
  }

  .badge--pulse.badge--neutral {
    --pulse-color: var(--sl-color-neutral-600);
  }

  .badge--pulse.badge--warning {
    --pulse-color: var(--sl-color-warning-600);
  }

  .badge--pulse.badge--danger {
    --pulse-color: var(--sl-color-danger-600);
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 var(--pulse-color);
    }
    70% {
      box-shadow: 0 0 0 0.5rem transparent;
    }
    100% {
      box-shadow: 0 0 0 0 transparent;
    }
  }
`;








var $215c417136be78f1$export$61fa7b4a2bccd4d6 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.variant = "primary";
        this.pill = false;
        this.pulse = false;
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <span
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            badge: true,
            "badge--primary": this.variant === "primary",
            "badge--success": this.variant === "success",
            "badge--neutral": this.variant === "neutral",
            "badge--warning": this.variant === "warning",
            "badge--danger": this.variant === "danger",
            "badge--pill": this.pill,
            "badge--pulse": this.pulse
        })}
        role="status"
      >
        <slot></slot>
      </span>
    `;
    }
};
$215c417136be78f1$export$61fa7b4a2bccd4d6.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $239be25996d64c2e$export$7024a65909a151df)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $215c417136be78f1$export$61fa7b4a2bccd4d6.prototype, "variant", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $215c417136be78f1$export$61fa7b4a2bccd4d6.prototype, "pill", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $215c417136be78f1$export$61fa7b4a2bccd4d6.prototype, "pulse", 2);


// src/components/badge/badge.ts
var $3873b7933872b072$export$70394b1032f9de28 = (0, $215c417136be78f1$export$61fa7b4a2bccd4d6);
(0, $215c417136be78f1$export$61fa7b4a2bccd4d6).define("sl-badge");




// src/components/breadcrumb-item/breadcrumb-item.styles.ts

var $bf04a1e7da21ed51$export$1e076222ea040899 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: inline-flex;
  }

  .breadcrumb-item {
    display: inline-flex;
    align-items: center;
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-small);
    font-weight: var(--sl-font-weight-semibold);
    color: var(--sl-color-neutral-600);
    line-height: var(--sl-line-height-normal);
    white-space: nowrap;
  }

  .breadcrumb-item__label {
    display: inline-block;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    text-decoration: none;
    color: inherit;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: var(--sl-transition-fast) --color;
  }

  :host(:not(:last-of-type)) .breadcrumb-item__label {
    color: var(--sl-color-primary-600);
  }

  :host(:not(:last-of-type)) .breadcrumb-item__label:hover {
    color: var(--sl-color-primary-500);
  }

  :host(:not(:last-of-type)) .breadcrumb-item__label:active {
    color: var(--sl-color-primary-600);
  }

  .breadcrumb-item__label:focus {
    outline: none;
  }

  .breadcrumb-item__label:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .breadcrumb-item__prefix,
  .breadcrumb-item__suffix {
    display: none;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .breadcrumb-item--has-prefix .breadcrumb-item__prefix {
    display: inline-flex;
    margin-inline-end: var(--sl-spacing-x-small);
  }

  .breadcrumb-item--has-suffix .breadcrumb-item__suffix {
    display: inline-flex;
    margin-inline-start: var(--sl-spacing-x-small);
  }

  :host(:last-of-type) .breadcrumb-item__separator {
    display: none;
  }

  .breadcrumb-item__separator {
    display: inline-flex;
    align-items: center;
    margin: 0 var(--sl-spacing-x-small);
    user-select: none;
    -webkit-user-select: none;
  }
`;











var $db792f6302f56da5$export$e01f6a745a6728bd = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "prefix", "suffix");
        this.renderType = "button";
        this.rel = "noreferrer noopener";
    }
    setRenderType() {
        const hasDropdown = this.defaultSlot.assignedElements({
            flatten: true
        }).filter((i)=>i.tagName.toLowerCase() === "sl-dropdown").length > 0;
        if (this.href) {
            this.renderType = "link";
            return;
        }
        if (hasDropdown) {
            this.renderType = "dropdown";
            return;
        }
        this.renderType = "button";
    }
    hrefChanged() {
        this.setRenderType();
    }
    handleSlotChange() {
        this.setRenderType();
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            "breadcrumb-item": true,
            "breadcrumb-item--has-prefix": this.hasSlotController.test("prefix"),
            "breadcrumb-item--has-suffix": this.hasSlotController.test("suffix")
        })}
      >
        <span part="prefix" class="breadcrumb-item__prefix">
          <slot name="prefix"></slot>
        </span>

        ${this.renderType === "link" ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <a
                part="label"
                class="breadcrumb-item__label breadcrumb-item__label--link"
                href="${this.href}"
                target="${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.target ? this.target : void 0)}"
                rel=${(0, $ad7ec410a329c066$export$f68dd208b5df064d)(this.target ? this.rel : void 0)}
              >
                <slot @slotchange=${this.handleSlotChange}></slot>
              </a>
            ` : ""}
        ${this.renderType === "button" ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <button part="label" type="button" class="breadcrumb-item__label breadcrumb-item__label--button">
                <slot @slotchange=${this.handleSlotChange}></slot>
              </button>
            ` : ""}
        ${this.renderType === "dropdown" ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <div part="label" class="breadcrumb-item__label breadcrumb-item__label--drop-down">
                <slot @slotchange=${this.handleSlotChange}></slot>
              </div>
            ` : ""}

        <span part="suffix" class="breadcrumb-item__suffix">
          <slot name="suffix"></slot>
        </span>

        <span part="separator" class="breadcrumb-item__separator" aria-hidden="true">
          <slot name="separator"></slot>
        </span>
      </div>
    `;
    }
};
$db792f6302f56da5$export$e01f6a745a6728bd.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $bf04a1e7da21ed51$export$1e076222ea040899)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)("slot:not([name])")
], $db792f6302f56da5$export$e01f6a745a6728bd.prototype, "defaultSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $db792f6302f56da5$export$e01f6a745a6728bd.prototype, "renderType", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $db792f6302f56da5$export$e01f6a745a6728bd.prototype, "href", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $db792f6302f56da5$export$e01f6a745a6728bd.prototype, "target", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $db792f6302f56da5$export$e01f6a745a6728bd.prototype, "rel", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("href", {
        waitUntilFirstUpdate: true
    })
], $db792f6302f56da5$export$e01f6a745a6728bd.prototype, "hrefChanged", 1);


// src/components/breadcrumb-item/breadcrumb-item.ts
var $099a7a58be6c0f19$export$f7da4fd0e9af8f24 = (0, $db792f6302f56da5$export$e01f6a745a6728bd);
(0, $db792f6302f56da5$export$e01f6a745a6728bd).define("sl-breadcrumb-item");




// src/components/animation/animation.styles.ts

var $3fe0c1c82f1c56f0$export$5af81660aeecc2e9 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: contents;
  }
`;


// src/components/animation/animations.ts
var $363b20dd79e5ca6e$exports = {};

$parcel$export($363b20dd79e5ca6e$exports, "easings", () => $d4a1f21ffcd1a5d0$export$15a0bf1b4bbacad8);
var $44f147f691af1822$exports = {};

$parcel$export($44f147f691af1822$exports, "bounce", () => $44f147f691af1822$export$e3ce947fb98643bf);
const $44f147f691af1822$export$e3ce947fb98643bf = [
    {
        offset: 0,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 0.2,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 0.4,
        easing: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
        transform: 'translate3d(0, -30px, 0) scaleY(1.1)'
    },
    {
        offset: 0.43,
        easing: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
        transform: 'translate3d(0, -30px, 0) scaleY(1.1)'
    },
    {
        offset: 0.53,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 0.7,
        easing: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
        transform: 'translate3d(0, -15px, 0) scaleY(1.05)'
    },
    {
        offset: 0.8,
        'transition-timing-function': 'cubic-bezier(0.215, 0.61, 0.355, 1)',
        transform: 'translate3d(0, 0, 0) scaleY(0.95)'
    },
    {
        offset: 0.9,
        transform: 'translate3d(0, -4px, 0) scaleY(1.02)'
    },
    {
        offset: 1,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $01171f9a4d9858dc$exports = {};

$parcel$export($01171f9a4d9858dc$exports, "flash", () => $01171f9a4d9858dc$export$fff9462e59a6c087);
const $01171f9a4d9858dc$export$fff9462e59a6c087 = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 0.25,
        opacity: '0'
    },
    {
        offset: 0.5,
        opacity: '1'
    },
    {
        offset: 0.75,
        opacity: '0'
    },
    {
        offset: 1,
        opacity: '1'
    }
];


var $909cf1921cb61391$exports = {};

$parcel$export($909cf1921cb61391$exports, "headShake", () => $909cf1921cb61391$export$cc718fa79617014c);
const $909cf1921cb61391$export$cc718fa79617014c = [
    {
        offset: 0,
        transform: 'translateX(0)'
    },
    {
        offset: 0.065,
        transform: 'translateX(-6px) rotateY(-9deg)'
    },
    {
        offset: 0.185,
        transform: 'translateX(5px) rotateY(7deg)'
    },
    {
        offset: 0.315,
        transform: 'translateX(-3px) rotateY(-5deg)'
    },
    {
        offset: 0.435,
        transform: 'translateX(2px) rotateY(3deg)'
    },
    {
        offset: 0.5,
        transform: 'translateX(0)'
    }
];


var $4d0e98ca2f31d355$exports = {};

$parcel$export($4d0e98ca2f31d355$exports, "heartBeat", () => $4d0e98ca2f31d355$export$f5767cd4e86f63a5);
const $4d0e98ca2f31d355$export$f5767cd4e86f63a5 = [
    {
        offset: 0,
        transform: 'scale(1)'
    },
    {
        offset: 0.14,
        transform: 'scale(1.3)'
    },
    {
        offset: 0.28,
        transform: 'scale(1)'
    },
    {
        offset: 0.42,
        transform: 'scale(1.3)'
    },
    {
        offset: 0.7,
        transform: 'scale(1)'
    }
];


var $088714b1dd473d0c$exports = {};

$parcel$export($088714b1dd473d0c$exports, "jello", () => $088714b1dd473d0c$export$821f6a9282d0ec8d);
const $088714b1dd473d0c$export$821f6a9282d0ec8d = [
    {
        offset: 0,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 0.111,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 0.222,
        transform: 'skewX(-12.5deg) skewY(-12.5deg)'
    },
    {
        offset: 0.33299999999999996,
        transform: 'skewX(6.25deg) skewY(6.25deg)'
    },
    {
        offset: 0.444,
        transform: 'skewX(-3.125deg) skewY(-3.125deg)'
    },
    {
        offset: 0.555,
        transform: 'skewX(1.5625deg) skewY(1.5625deg)'
    },
    {
        offset: 0.6659999999999999,
        transform: 'skewX(-0.78125deg) skewY(-0.78125deg)'
    },
    {
        offset: 0.777,
        transform: 'skewX(0.390625deg) skewY(0.390625deg)'
    },
    {
        offset: 0.888,
        transform: 'skewX(-0.1953125deg) skewY(-0.1953125deg)'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    }
];


var $a1dd86058d2c43c9$exports = {};

$parcel$export($a1dd86058d2c43c9$exports, "pulse", () => $a1dd86058d2c43c9$export$f3aaf94dc96a60de);
const $a1dd86058d2c43c9$export$f3aaf94dc96a60de = [
    {
        offset: 0,
        transform: 'scale3d(1, 1, 1)'
    },
    {
        offset: 0.5,
        transform: 'scale3d(1.05, 1.05, 1.05)'
    },
    {
        offset: 1,
        transform: 'scale3d(1, 1, 1)'
    }
];


var $bef33ab0528658c6$exports = {};

$parcel$export($bef33ab0528658c6$exports, "rubberBand", () => $bef33ab0528658c6$export$bbc07f6a19d55e88);
const $bef33ab0528658c6$export$bbc07f6a19d55e88 = [
    {
        offset: 0,
        transform: 'scale3d(1, 1, 1)'
    },
    {
        offset: 0.3,
        transform: 'scale3d(1.25, 0.75, 1)'
    },
    {
        offset: 0.4,
        transform: 'scale3d(0.75, 1.25, 1)'
    },
    {
        offset: 0.5,
        transform: 'scale3d(1.15, 0.85, 1)'
    },
    {
        offset: 0.65,
        transform: 'scale3d(0.95, 1.05, 1)'
    },
    {
        offset: 0.75,
        transform: 'scale3d(1.05, 0.95, 1)'
    },
    {
        offset: 1,
        transform: 'scale3d(1, 1, 1)'
    }
];


var $14697b3d063ca658$exports = {};

$parcel$export($14697b3d063ca658$exports, "shake", () => $14697b3d063ca658$export$267b06a7460aa7d3);
const $14697b3d063ca658$export$267b06a7460aa7d3 = [
    {
        offset: 0,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 0.1,
        transform: 'translate3d(-10px, 0, 0)'
    },
    {
        offset: 0.2,
        transform: 'translate3d(10px, 0, 0)'
    },
    {
        offset: 0.3,
        transform: 'translate3d(-10px, 0, 0)'
    },
    {
        offset: 0.4,
        transform: 'translate3d(10px, 0, 0)'
    },
    {
        offset: 0.5,
        transform: 'translate3d(-10px, 0, 0)'
    },
    {
        offset: 0.6,
        transform: 'translate3d(10px, 0, 0)'
    },
    {
        offset: 0.7,
        transform: 'translate3d(-10px, 0, 0)'
    },
    {
        offset: 0.8,
        transform: 'translate3d(10px, 0, 0)'
    },
    {
        offset: 0.9,
        transform: 'translate3d(-10px, 0, 0)'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    }
];


var $5ea90fcf5415cb2d$exports = {};

$parcel$export($5ea90fcf5415cb2d$exports, "shakeX", () => $5ea90fcf5415cb2d$export$8e99d6962f95c405);
const $5ea90fcf5415cb2d$export$8e99d6962f95c405 = [
    {
        offset: 0,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 0.1,
        transform: 'translate3d(-10px, 0, 0)'
    },
    {
        offset: 0.2,
        transform: 'translate3d(10px, 0, 0)'
    },
    {
        offset: 0.3,
        transform: 'translate3d(-10px, 0, 0)'
    },
    {
        offset: 0.4,
        transform: 'translate3d(10px, 0, 0)'
    },
    {
        offset: 0.5,
        transform: 'translate3d(-10px, 0, 0)'
    },
    {
        offset: 0.6,
        transform: 'translate3d(10px, 0, 0)'
    },
    {
        offset: 0.7,
        transform: 'translate3d(-10px, 0, 0)'
    },
    {
        offset: 0.8,
        transform: 'translate3d(10px, 0, 0)'
    },
    {
        offset: 0.9,
        transform: 'translate3d(-10px, 0, 0)'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    }
];


var $7d05de74a085c7b7$exports = {};

$parcel$export($7d05de74a085c7b7$exports, "shakeY", () => $7d05de74a085c7b7$export$8c0595fc0dd256ce);
const $7d05de74a085c7b7$export$8c0595fc0dd256ce = [
    {
        offset: 0,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 0.1,
        transform: 'translate3d(0, -10px, 0)'
    },
    {
        offset: 0.2,
        transform: 'translate3d(0, 10px, 0)'
    },
    {
        offset: 0.3,
        transform: 'translate3d(0, -10px, 0)'
    },
    {
        offset: 0.4,
        transform: 'translate3d(0, 10px, 0)'
    },
    {
        offset: 0.5,
        transform: 'translate3d(0, -10px, 0)'
    },
    {
        offset: 0.6,
        transform: 'translate3d(0, 10px, 0)'
    },
    {
        offset: 0.7,
        transform: 'translate3d(0, -10px, 0)'
    },
    {
        offset: 0.8,
        transform: 'translate3d(0, 10px, 0)'
    },
    {
        offset: 0.9,
        transform: 'translate3d(0, -10px, 0)'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    }
];


var $27141611cebdbb53$exports = {};

$parcel$export($27141611cebdbb53$exports, "swing", () => $27141611cebdbb53$export$84fc4030631e573c);
const $27141611cebdbb53$export$84fc4030631e573c = [
    {
        offset: 0.2,
        transform: 'rotate3d(0, 0, 1, 15deg)'
    },
    {
        offset: 0.4,
        transform: 'rotate3d(0, 0, 1, -10deg)'
    },
    {
        offset: 0.6,
        transform: 'rotate3d(0, 0, 1, 5deg)'
    },
    {
        offset: 0.8,
        transform: 'rotate3d(0, 0, 1, -5deg)'
    },
    {
        offset: 1,
        transform: 'rotate3d(0, 0, 1, 0deg)'
    }
];


var $4483a1a95de52b9e$exports = {};

$parcel$export($4483a1a95de52b9e$exports, "tada", () => $4483a1a95de52b9e$export$1362d96c12095304);
const $4483a1a95de52b9e$export$1362d96c12095304 = [
    {
        offset: 0,
        transform: 'scale3d(1, 1, 1)'
    },
    {
        offset: 0.1,
        transform: 'scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg)'
    },
    {
        offset: 0.2,
        transform: 'scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg)'
    },
    {
        offset: 0.3,
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)'
    },
    {
        offset: 0.4,
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg)'
    },
    {
        offset: 0.5,
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)'
    },
    {
        offset: 0.6,
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg)'
    },
    {
        offset: 0.7,
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)'
    },
    {
        offset: 0.8,
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg)'
    },
    {
        offset: 0.9,
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)'
    },
    {
        offset: 1,
        transform: 'scale3d(1, 1, 1)'
    }
];


var $c207ee56b12a2956$exports = {};

$parcel$export($c207ee56b12a2956$exports, "wobble", () => $c207ee56b12a2956$export$138a91d3335be56);
const $c207ee56b12a2956$export$138a91d3335be56 = [
    {
        offset: 0,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 0.15,
        transform: 'translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg)'
    },
    {
        offset: 0.3,
        transform: 'translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg)'
    },
    {
        offset: 0.45,
        transform: 'translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg)'
    },
    {
        offset: 0.6,
        transform: 'translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg)'
    },
    {
        offset: 0.75,
        transform: 'translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg)'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    }
];


var $a0a4ab1576ebd872$exports = {};

$parcel$export($a0a4ab1576ebd872$exports, "backInDown", () => $a0a4ab1576ebd872$export$6d8297c92cbbf2b4);
const $a0a4ab1576ebd872$export$6d8297c92cbbf2b4 = [
    {
        offset: 0,
        transform: 'translateY(-1200px) scale(0.7)',
        opacity: '0.7'
    },
    {
        offset: 0.8,
        transform: 'translateY(0px) scale(0.7)',
        opacity: '0.7'
    },
    {
        offset: 1,
        transform: 'scale(1)',
        opacity: '1'
    }
];


var $44b81948bc46e934$exports = {};

$parcel$export($44b81948bc46e934$exports, "backInLeft", () => $44b81948bc46e934$export$5b878fc39aca24cb);
const $44b81948bc46e934$export$5b878fc39aca24cb = [
    {
        offset: 0,
        transform: 'translateX(-2000px) scale(0.7)',
        opacity: '0.7'
    },
    {
        offset: 0.8,
        transform: 'translateX(0px) scale(0.7)',
        opacity: '0.7'
    },
    {
        offset: 1,
        transform: 'scale(1)',
        opacity: '1'
    }
];


var $b5ebbcb511bc19ab$exports = {};

$parcel$export($b5ebbcb511bc19ab$exports, "backInRight", () => $b5ebbcb511bc19ab$export$4122a71f9d4a0c92);
const $b5ebbcb511bc19ab$export$4122a71f9d4a0c92 = [
    {
        offset: 0,
        transform: 'translateX(2000px) scale(0.7)',
        opacity: '0.7'
    },
    {
        offset: 0.8,
        transform: 'translateX(0px) scale(0.7)',
        opacity: '0.7'
    },
    {
        offset: 1,
        transform: 'scale(1)',
        opacity: '1'
    }
];


var $c6502b7d175e45f1$exports = {};

$parcel$export($c6502b7d175e45f1$exports, "backInUp", () => $c6502b7d175e45f1$export$fe2761bd40e2f04d);
const $c6502b7d175e45f1$export$fe2761bd40e2f04d = [
    {
        offset: 0,
        transform: 'translateY(1200px) scale(0.7)',
        opacity: '0.7'
    },
    {
        offset: 0.8,
        transform: 'translateY(0px) scale(0.7)',
        opacity: '0.7'
    },
    {
        offset: 1,
        transform: 'scale(1)',
        opacity: '1'
    }
];


var $fd0da22f50dda942$exports = {};

$parcel$export($fd0da22f50dda942$exports, "backOutDown", () => $fd0da22f50dda942$export$77f87f2771ba0c26);
const $fd0da22f50dda942$export$77f87f2771ba0c26 = [
    {
        offset: 0,
        transform: 'scale(1)',
        opacity: '1'
    },
    {
        offset: 0.2,
        transform: 'translateY(0px) scale(0.7)',
        opacity: '0.7'
    },
    {
        offset: 1,
        transform: 'translateY(700px) scale(0.7)',
        opacity: '0.7'
    }
];


var $12c3a44568f75637$exports = {};

$parcel$export($12c3a44568f75637$exports, "backOutLeft", () => $12c3a44568f75637$export$76810590f7621d50);
const $12c3a44568f75637$export$76810590f7621d50 = [
    {
        offset: 0,
        transform: 'scale(1)',
        opacity: '1'
    },
    {
        offset: 0.2,
        transform: 'translateX(0px) scale(0.7)',
        opacity: '0.7'
    },
    {
        offset: 1,
        transform: 'translateX(-2000px) scale(0.7)',
        opacity: '0.7'
    }
];


var $9428afe051b34964$exports = {};

$parcel$export($9428afe051b34964$exports, "backOutRight", () => $9428afe051b34964$export$10922af3f129281c);
const $9428afe051b34964$export$10922af3f129281c = [
    {
        offset: 0,
        transform: 'scale(1)',
        opacity: '1'
    },
    {
        offset: 0.2,
        transform: 'translateX(0px) scale(0.7)',
        opacity: '0.7'
    },
    {
        offset: 1,
        transform: 'translateX(2000px) scale(0.7)',
        opacity: '0.7'
    }
];


var $d7aa9547d97c85c7$exports = {};

$parcel$export($d7aa9547d97c85c7$exports, "backOutUp", () => $d7aa9547d97c85c7$export$80f29719741ca656);
const $d7aa9547d97c85c7$export$80f29719741ca656 = [
    {
        offset: 0,
        transform: 'scale(1)',
        opacity: '1'
    },
    {
        offset: 0.2,
        transform: 'translateY(0px) scale(0.7)',
        opacity: '0.7'
    },
    {
        offset: 1,
        transform: 'translateY(-700px) scale(0.7)',
        opacity: '0.7'
    }
];


var $77fdfec3e3328a5e$exports = {};

$parcel$export($77fdfec3e3328a5e$exports, "bounceIn", () => $77fdfec3e3328a5e$export$fccebd7948554554);
const $77fdfec3e3328a5e$export$fccebd7948554554 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'scale3d(0.3, 0.3, 0.3)'
    },
    {
        offset: 0,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.2,
        transform: 'scale3d(1.1, 1.1, 1.1)'
    },
    {
        offset: 0.2,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.4,
        transform: 'scale3d(0.9, 0.9, 0.9)'
    },
    {
        offset: 0.4,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.6,
        opacity: '1',
        transform: 'scale3d(1.03, 1.03, 1.03)'
    },
    {
        offset: 0.6,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.8,
        transform: 'scale3d(0.97, 0.97, 0.97)'
    },
    {
        offset: 0.8,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'scale3d(1, 1, 1)'
    },
    {
        offset: 1,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    }
];


var $0618b51f8163ec9f$exports = {};

$parcel$export($0618b51f8163ec9f$exports, "bounceInDown", () => $0618b51f8163ec9f$export$5567dcc4c3474880);
const $0618b51f8163ec9f$export$5567dcc4c3474880 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(0, -3000px, 0) scaleY(3)'
    },
    {
        offset: 0,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.6,
        opacity: '1',
        transform: 'translate3d(0, 25px, 0) scaleY(0.9)'
    },
    {
        offset: 0.6,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.75,
        transform: 'translate3d(0, -10px, 0) scaleY(0.95)'
    },
    {
        offset: 0.75,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.9,
        transform: 'translate3d(0, 5px, 0) scaleY(0.985)'
    },
    {
        offset: 0.9,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 1,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    }
];


var $8f5db9efab73456b$exports = {};

$parcel$export($8f5db9efab73456b$exports, "bounceInLeft", () => $8f5db9efab73456b$export$92fd46a1c9da5ead);
const $8f5db9efab73456b$export$92fd46a1c9da5ead = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(-3000px, 0, 0) scaleX(3)'
    },
    {
        offset: 0,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.6,
        opacity: '1',
        transform: 'translate3d(25px, 0, 0) scaleX(1)'
    },
    {
        offset: 0.6,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.75,
        transform: 'translate3d(-10px, 0, 0) scaleX(0.98)'
    },
    {
        offset: 0.75,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.9,
        transform: 'translate3d(5px, 0, 0) scaleX(0.995)'
    },
    {
        offset: 0.9,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 1,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    }
];


var $c9ab1a5fc892b7e9$exports = {};

$parcel$export($c9ab1a5fc892b7e9$exports, "bounceInRight", () => $c9ab1a5fc892b7e9$export$aebe35d18555813a);
const $c9ab1a5fc892b7e9$export$aebe35d18555813a = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(3000px, 0, 0) scaleX(3)'
    },
    {
        offset: 0,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.6,
        opacity: '1',
        transform: 'translate3d(-25px, 0, 0) scaleX(1)'
    },
    {
        offset: 0.6,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.75,
        transform: 'translate3d(10px, 0, 0) scaleX(0.98)'
    },
    {
        offset: 0.75,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.9,
        transform: 'translate3d(-5px, 0, 0) scaleX(0.995)'
    },
    {
        offset: 0.9,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 1,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    }
];


var $60de0e21da7dad7d$exports = {};

$parcel$export($60de0e21da7dad7d$exports, "bounceInUp", () => $60de0e21da7dad7d$export$9e7bc32a82042281);
const $60de0e21da7dad7d$export$9e7bc32a82042281 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(0, 3000px, 0) scaleY(5)'
    },
    {
        offset: 0,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.6,
        opacity: '1',
        transform: 'translate3d(0, -20px, 0) scaleY(0.9)'
    },
    {
        offset: 0.6,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.75,
        transform: 'translate3d(0, 10px, 0) scaleY(0.95)'
    },
    {
        offset: 0.75,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 0.9,
        transform: 'translate3d(0, -5px, 0) scaleY(0.985)'
    },
    {
        offset: 0.9,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 1,
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
    }
];


var $802318e5b1d339ca$exports = {};

$parcel$export($802318e5b1d339ca$exports, "bounceOut", () => $802318e5b1d339ca$export$cccc9e04465dce11);
const $802318e5b1d339ca$export$cccc9e04465dce11 = [
    {
        offset: 0.2,
        transform: 'scale3d(0.9, 0.9, 0.9)'
    },
    {
        offset: 0.5,
        opacity: '1',
        transform: 'scale3d(1.1, 1.1, 1.1)'
    },
    {
        offset: 0.55,
        opacity: '1',
        transform: 'scale3d(1.1, 1.1, 1.1)'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'scale3d(0.3, 0.3, 0.3)'
    }
];


var $3f77ee04149a65f3$exports = {};

$parcel$export($3f77ee04149a65f3$exports, "bounceOutDown", () => $3f77ee04149a65f3$export$26ce0cf84248400c);
const $3f77ee04149a65f3$export$26ce0cf84248400c = [
    {
        offset: 0.2,
        transform: 'translate3d(0, 10px, 0) scaleY(0.985)'
    },
    {
        offset: 0.4,
        opacity: '1',
        transform: 'translate3d(0, -20px, 0) scaleY(0.9)'
    },
    {
        offset: 0.45,
        opacity: '1',
        transform: 'translate3d(0, -20px, 0) scaleY(0.9)'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(0, 2000px, 0) scaleY(3)'
    }
];


var $12484dc2f647e2bc$exports = {};

$parcel$export($12484dc2f647e2bc$exports, "bounceOutLeft", () => $12484dc2f647e2bc$export$3dabd2f5ee26f898);
const $12484dc2f647e2bc$export$3dabd2f5ee26f898 = [
    {
        offset: 0.2,
        opacity: '1',
        transform: 'translate3d(20px, 0, 0) scaleX(0.9)'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(-2000px, 0, 0) scaleX(2)'
    }
];


var $762f1677681a46ab$exports = {};

$parcel$export($762f1677681a46ab$exports, "bounceOutRight", () => $762f1677681a46ab$export$7b4a033090b713a);
const $762f1677681a46ab$export$7b4a033090b713a = [
    {
        offset: 0.2,
        opacity: '1',
        transform: 'translate3d(-20px, 0, 0) scaleX(0.9)'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(2000px, 0, 0) scaleX(2)'
    }
];


var $e449ec72eb0e82b1$exports = {};

$parcel$export($e449ec72eb0e82b1$exports, "bounceOutUp", () => $e449ec72eb0e82b1$export$fe9810e7e30c9caa);
const $e449ec72eb0e82b1$export$fe9810e7e30c9caa = [
    {
        offset: 0.2,
        transform: 'translate3d(0, -10px, 0) scaleY(0.985)'
    },
    {
        offset: 0.4,
        opacity: '1',
        transform: 'translate3d(0, 20px, 0) scaleY(0.9)'
    },
    {
        offset: 0.45,
        opacity: '1',
        transform: 'translate3d(0, 20px, 0) scaleY(0.9)'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(0, -2000px, 0) scaleY(3)'
    }
];


var $8cb2ce04810ddf77$exports = {};

$parcel$export($8cb2ce04810ddf77$exports, "fadeIn", () => $8cb2ce04810ddf77$export$82e6205b15e6c637);
const $8cb2ce04810ddf77$export$82e6205b15e6c637 = [
    {
        offset: 0,
        opacity: '0'
    },
    {
        offset: 1,
        opacity: '1'
    }
];


var $1984e0af10234b58$exports = {};

$parcel$export($1984e0af10234b58$exports, "fadeInBottomLeft", () => $1984e0af10234b58$export$27e0c58916e1badc);
const $1984e0af10234b58$export$27e0c58916e1badc = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(-100%, 100%, 0)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $e346ffa1c6de8609$exports = {};

$parcel$export($e346ffa1c6de8609$exports, "fadeInBottomRight", () => $e346ffa1c6de8609$export$f72096766ea3a089);
const $e346ffa1c6de8609$export$f72096766ea3a089 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(100%, 100%, 0)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $fae7262e6d367457$exports = {};

$parcel$export($fae7262e6d367457$exports, "fadeInDown", () => $fae7262e6d367457$export$6ecdcdb0033d0327);
const $fae7262e6d367457$export$6ecdcdb0033d0327 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(0, -100%, 0)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $2a278be6b832ee45$exports = {};

$parcel$export($2a278be6b832ee45$exports, "fadeInDownBig", () => $2a278be6b832ee45$export$aa45f1f50300a7c0);
const $2a278be6b832ee45$export$aa45f1f50300a7c0 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(0, -2000px, 0)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $e54e86d1085d370c$exports = {};

$parcel$export($e54e86d1085d370c$exports, "fadeInLeft", () => $e54e86d1085d370c$export$d8fce5eeb232a07b);
const $e54e86d1085d370c$export$d8fce5eeb232a07b = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(-100%, 0, 0)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $698173604db46591$exports = {};

$parcel$export($698173604db46591$exports, "fadeInLeftBig", () => $698173604db46591$export$327c6b58e5f59d6f);
const $698173604db46591$export$327c6b58e5f59d6f = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(-2000px, 0, 0)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $7090c344a5b98fe0$exports = {};

$parcel$export($7090c344a5b98fe0$exports, "fadeInRight", () => $7090c344a5b98fe0$export$7b78ca149b3ffe20);
const $7090c344a5b98fe0$export$7b78ca149b3ffe20 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(100%, 0, 0)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $80617b560b457627$exports = {};

$parcel$export($80617b560b457627$exports, "fadeInRightBig", () => $80617b560b457627$export$6f5ccd79656f671);
const $80617b560b457627$export$6f5ccd79656f671 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(2000px, 0, 0)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $d0737f7cdd756e23$exports = {};

$parcel$export($d0737f7cdd756e23$exports, "fadeInTopLeft", () => $d0737f7cdd756e23$export$777354dbc7828ff3);
const $d0737f7cdd756e23$export$777354dbc7828ff3 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(-100%, -100%, 0)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $d6aa40d130f630c4$exports = {};

$parcel$export($d6aa40d130f630c4$exports, "fadeInTopRight", () => $d6aa40d130f630c4$export$d5bfa04a6ce7104f);
const $d6aa40d130f630c4$export$d5bfa04a6ce7104f = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(100%, -100%, 0)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $76dc859bd2579c92$exports = {};

$parcel$export($76dc859bd2579c92$exports, "fadeInUp", () => $76dc859bd2579c92$export$546bb2e31f381a81);
const $76dc859bd2579c92$export$546bb2e31f381a81 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(0, 100%, 0)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $c54f1cb83592ca25$exports = {};

$parcel$export($c54f1cb83592ca25$exports, "fadeInUpBig", () => $c54f1cb83592ca25$export$f18a2356a26ed325);
const $c54f1cb83592ca25$export$f18a2356a26ed325 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(0, 2000px, 0)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $099531e36148fcf4$exports = {};

$parcel$export($099531e36148fcf4$exports, "fadeOut", () => $099531e36148fcf4$export$c091916f1530334c);
const $099531e36148fcf4$export$c091916f1530334c = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        opacity: '0'
    }
];


var $0e0ee4d9e7d8fd0b$exports = {};

$parcel$export($0e0ee4d9e7d8fd0b$exports, "fadeOutBottomLeft", () => $0e0ee4d9e7d8fd0b$export$19a945979f1fb3dc);
const $0e0ee4d9e7d8fd0b$export$19a945979f1fb3dc = [
    {
        offset: 0,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(-100%, 100%, 0)'
    }
];


var $73639a2d73553918$exports = {};

$parcel$export($73639a2d73553918$exports, "fadeOutBottomRight", () => $73639a2d73553918$export$5728b370175ac481);
const $73639a2d73553918$export$5728b370175ac481 = [
    {
        offset: 0,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(100%, 100%, 0)'
    }
];


var $f4c812c9af208c61$exports = {};

$parcel$export($f4c812c9af208c61$exports, "fadeOutDown", () => $f4c812c9af208c61$export$918ddd2a9d66b46e);
const $f4c812c9af208c61$export$918ddd2a9d66b46e = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(0, 100%, 0)'
    }
];


var $6ead62300547fc1b$exports = {};

$parcel$export($6ead62300547fc1b$exports, "fadeOutDownBig", () => $6ead62300547fc1b$export$658ef65a86bafcbd);
const $6ead62300547fc1b$export$658ef65a86bafcbd = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(0, 2000px, 0)'
    }
];


var $066f45c38f90ced9$exports = {};

$parcel$export($066f45c38f90ced9$exports, "fadeOutLeft", () => $066f45c38f90ced9$export$99efea88984e567e);
const $066f45c38f90ced9$export$99efea88984e567e = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(-100%, 0, 0)'
    }
];


var $92c50403af1d837e$exports = {};

$parcel$export($92c50403af1d837e$exports, "fadeOutLeftBig", () => $92c50403af1d837e$export$3a9dc8f9529ceff5);
const $92c50403af1d837e$export$3a9dc8f9529ceff5 = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(-2000px, 0, 0)'
    }
];


var $7b65d7c201ae9bc2$exports = {};

$parcel$export($7b65d7c201ae9bc2$exports, "fadeOutRight", () => $7b65d7c201ae9bc2$export$1541972369870d64);
const $7b65d7c201ae9bc2$export$1541972369870d64 = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(100%, 0, 0)'
    }
];


var $d9783225e15252c6$exports = {};

$parcel$export($d9783225e15252c6$exports, "fadeOutRightBig", () => $d9783225e15252c6$export$d3f8667912a1aaa1);
const $d9783225e15252c6$export$d3f8667912a1aaa1 = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(2000px, 0, 0)'
    }
];


var $2ba5cbe367a3fd53$exports = {};

$parcel$export($2ba5cbe367a3fd53$exports, "fadeOutTopLeft", () => $2ba5cbe367a3fd53$export$cc0980c21917f2b0);
const $2ba5cbe367a3fd53$export$cc0980c21917f2b0 = [
    {
        offset: 0,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(-100%, -100%, 0)'
    }
];


var $590d503ff17a255e$exports = {};

$parcel$export($590d503ff17a255e$exports, "fadeOutTopRight", () => $590d503ff17a255e$export$510f794173174a8b);
const $590d503ff17a255e$export$510f794173174a8b = [
    {
        offset: 0,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(100%, -100%, 0)'
    }
];


var $10223f7669247b6c$exports = {};

$parcel$export($10223f7669247b6c$exports, "fadeOutUp", () => $10223f7669247b6c$export$4163084011e71929);
const $10223f7669247b6c$export$4163084011e71929 = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(0, -100%, 0)'
    }
];


var $437ad91b4e3444b4$exports = {};

$parcel$export($437ad91b4e3444b4$exports, "fadeOutUpBig", () => $437ad91b4e3444b4$export$b0540367e09512e9);
const $437ad91b4e3444b4$export$b0540367e09512e9 = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(0, -2000px, 0)'
    }
];


var $abc803ec1b4b65ad$exports = {};

$parcel$export($abc803ec1b4b65ad$exports, "flip", () => $abc803ec1b4b65ad$export$8a83211c878a3f1f);
const $abc803ec1b4b65ad$export$8a83211c878a3f1f = [
    {
        offset: 0,
        transform: 'perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg)',
        easing: 'ease-out'
    },
    {
        offset: 0.4,
        transform: 'perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)\n      rotate3d(0, 1, 0, -190deg)',
        easing: 'ease-out'
    },
    {
        offset: 0.5,
        transform: 'perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)\n      rotate3d(0, 1, 0, -170deg)',
        easing: 'ease-in'
    },
    {
        offset: 0.8,
        transform: 'perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0)\n      rotate3d(0, 1, 0, 0deg)',
        easing: 'ease-in'
    },
    {
        offset: 1,
        transform: 'perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg)',
        easing: 'ease-in'
    }
];


var $6b32640fc55f9d36$exports = {};

$parcel$export($6b32640fc55f9d36$exports, "flipInX", () => $6b32640fc55f9d36$export$68ed1a067f792190);
const $6b32640fc55f9d36$export$68ed1a067f792190 = [
    {
        offset: 0,
        transform: 'perspective(400px) rotate3d(1, 0, 0, 90deg)',
        easing: 'ease-in',
        opacity: '0'
    },
    {
        offset: 0.4,
        transform: 'perspective(400px) rotate3d(1, 0, 0, -20deg)',
        easing: 'ease-in'
    },
    {
        offset: 0.6,
        transform: 'perspective(400px) rotate3d(1, 0, 0, 10deg)',
        opacity: '1'
    },
    {
        offset: 0.8,
        transform: 'perspective(400px) rotate3d(1, 0, 0, -5deg)'
    },
    {
        offset: 1,
        transform: 'perspective(400px)'
    }
];


var $e6e95cbd90bc2f63$exports = {};

$parcel$export($e6e95cbd90bc2f63$exports, "flipInY", () => $e6e95cbd90bc2f63$export$a10221d4eadc810);
const $e6e95cbd90bc2f63$export$a10221d4eadc810 = [
    {
        offset: 0,
        transform: 'perspective(400px) rotate3d(0, 1, 0, 90deg)',
        easing: 'ease-in',
        opacity: '0'
    },
    {
        offset: 0.4,
        transform: 'perspective(400px) rotate3d(0, 1, 0, -20deg)',
        easing: 'ease-in'
    },
    {
        offset: 0.6,
        transform: 'perspective(400px) rotate3d(0, 1, 0, 10deg)',
        opacity: '1'
    },
    {
        offset: 0.8,
        transform: 'perspective(400px) rotate3d(0, 1, 0, -5deg)'
    },
    {
        offset: 1,
        transform: 'perspective(400px)'
    }
];


var $af7077c3ead17b2f$exports = {};

$parcel$export($af7077c3ead17b2f$exports, "flipOutX", () => $af7077c3ead17b2f$export$4eaf247181cd9ec3);
const $af7077c3ead17b2f$export$4eaf247181cd9ec3 = [
    {
        offset: 0,
        transform: 'perspective(400px)'
    },
    {
        offset: 0.3,
        transform: 'perspective(400px) rotate3d(1, 0, 0, -20deg)',
        opacity: '1'
    },
    {
        offset: 1,
        transform: 'perspective(400px) rotate3d(1, 0, 0, 90deg)',
        opacity: '0'
    }
];


var $2812e3a21c2b1112$exports = {};

$parcel$export($2812e3a21c2b1112$exports, "flipOutY", () => $2812e3a21c2b1112$export$93f09c73becb5407);
const $2812e3a21c2b1112$export$93f09c73becb5407 = [
    {
        offset: 0,
        transform: 'perspective(400px)'
    },
    {
        offset: 0.3,
        transform: 'perspective(400px) rotate3d(0, 1, 0, -15deg)',
        opacity: '1'
    },
    {
        offset: 1,
        transform: 'perspective(400px) rotate3d(0, 1, 0, 90deg)',
        opacity: '0'
    }
];


var $54465ae8dcd6bb9a$exports = {};

$parcel$export($54465ae8dcd6bb9a$exports, "lightSpeedInLeft", () => $54465ae8dcd6bb9a$export$2d9c832bd7cb4780);
const $54465ae8dcd6bb9a$export$2d9c832bd7cb4780 = [
    {
        offset: 0,
        transform: 'translate3d(-100%, 0, 0) skewX(30deg)',
        opacity: '0'
    },
    {
        offset: 0.6,
        transform: 'skewX(-20deg)',
        opacity: '1'
    },
    {
        offset: 0.8,
        transform: 'skewX(5deg)'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    }
];


var $a50a428d13fe7008$exports = {};

$parcel$export($a50a428d13fe7008$exports, "lightSpeedInRight", () => $a50a428d13fe7008$export$80ec4591ec19f882);
const $a50a428d13fe7008$export$80ec4591ec19f882 = [
    {
        offset: 0,
        transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
        opacity: '0'
    },
    {
        offset: 0.6,
        transform: 'skewX(20deg)',
        opacity: '1'
    },
    {
        offset: 0.8,
        transform: 'skewX(-5deg)'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    }
];


var $2bcb5bec42b12202$exports = {};

$parcel$export($2bcb5bec42b12202$exports, "lightSpeedOutLeft", () => $2bcb5bec42b12202$export$aeae8dace8372863);
const $2bcb5bec42b12202$export$aeae8dace8372863 = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        transform: 'translate3d(-100%, 0, 0) skewX(-30deg)',
        opacity: '0'
    }
];


var $966d43d02b3ff8ac$exports = {};

$parcel$export($966d43d02b3ff8ac$exports, "lightSpeedOutRight", () => $966d43d02b3ff8ac$export$10bcad21523db9e6);
const $966d43d02b3ff8ac$export$10bcad21523db9e6 = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        transform: 'translate3d(100%, 0, 0) skewX(30deg)',
        opacity: '0'
    }
];


var $197b0aab3b2b6867$exports = {};

$parcel$export($197b0aab3b2b6867$exports, "rotateIn", () => $197b0aab3b2b6867$export$2b9048e0715456a4);
const $197b0aab3b2b6867$export$2b9048e0715456a4 = [
    {
        offset: 0,
        transform: 'rotate3d(0, 0, 1, -200deg)',
        opacity: '0'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)',
        opacity: '1'
    }
];


var $5d2e8e530bb759da$exports = {};

$parcel$export($5d2e8e530bb759da$exports, "rotateInDownLeft", () => $5d2e8e530bb759da$export$7336503083b51ac8);
const $5d2e8e530bb759da$export$7336503083b51ac8 = [
    {
        offset: 0,
        transform: 'rotate3d(0, 0, 1, -45deg)',
        opacity: '0'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)',
        opacity: '1'
    }
];


var $4688a44783c4b9a1$exports = {};

$parcel$export($4688a44783c4b9a1$exports, "rotateInDownRight", () => $4688a44783c4b9a1$export$d39468e8ba1f782c);
const $4688a44783c4b9a1$export$d39468e8ba1f782c = [
    {
        offset: 0,
        transform: 'rotate3d(0, 0, 1, 45deg)',
        opacity: '0'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)',
        opacity: '1'
    }
];


var $51a81c4918c3d1b2$exports = {};

$parcel$export($51a81c4918c3d1b2$exports, "rotateInUpLeft", () => $51a81c4918c3d1b2$export$3848addc86cdb49f);
const $51a81c4918c3d1b2$export$3848addc86cdb49f = [
    {
        offset: 0,
        transform: 'rotate3d(0, 0, 1, 45deg)',
        opacity: '0'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)',
        opacity: '1'
    }
];


var $22ff0cb9f9d0eeb0$exports = {};

$parcel$export($22ff0cb9f9d0eeb0$exports, "rotateInUpRight", () => $22ff0cb9f9d0eeb0$export$bb10501f1250224d);
const $22ff0cb9f9d0eeb0$export$bb10501f1250224d = [
    {
        offset: 0,
        transform: 'rotate3d(0, 0, 1, -90deg)',
        opacity: '0'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)',
        opacity: '1'
    }
];


var $8f21045b3d541eaf$exports = {};

$parcel$export($8f21045b3d541eaf$exports, "rotateOut", () => $8f21045b3d541eaf$export$5e1ccc268ae376b0);
const $8f21045b3d541eaf$export$5e1ccc268ae376b0 = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        transform: 'rotate3d(0, 0, 1, 200deg)',
        opacity: '0'
    }
];


var $bb4fcc64a533d6ee$exports = {};

$parcel$export($bb4fcc64a533d6ee$exports, "rotateOutDownLeft", () => $bb4fcc64a533d6ee$export$fb5eb9e37db0dfef);
const $bb4fcc64a533d6ee$export$fb5eb9e37db0dfef = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        transform: 'rotate3d(0, 0, 1, 45deg)',
        opacity: '0'
    }
];


var $af1c7a6f7f27e88c$exports = {};

$parcel$export($af1c7a6f7f27e88c$exports, "rotateOutDownRight", () => $af1c7a6f7f27e88c$export$638177b843431394);
const $af1c7a6f7f27e88c$export$638177b843431394 = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        transform: 'rotate3d(0, 0, 1, -45deg)',
        opacity: '0'
    }
];


var $d58a70fe8c33b139$exports = {};

$parcel$export($d58a70fe8c33b139$exports, "rotateOutUpLeft", () => $d58a70fe8c33b139$export$d921b7e0db7ff86e);
const $d58a70fe8c33b139$export$d921b7e0db7ff86e = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        transform: 'rotate3d(0, 0, 1, -45deg)',
        opacity: '0'
    }
];


var $426298e0c35b4c03$exports = {};

$parcel$export($426298e0c35b4c03$exports, "rotateOutUpRight", () => $426298e0c35b4c03$export$43ebaa489dfc2f5d);
const $426298e0c35b4c03$export$43ebaa489dfc2f5d = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        transform: 'rotate3d(0, 0, 1, 90deg)',
        opacity: '0'
    }
];


var $aff59fd4c55fb35e$exports = {};

$parcel$export($aff59fd4c55fb35e$exports, "slideInDown", () => $aff59fd4c55fb35e$export$8775e04aa1928f66);
const $aff59fd4c55fb35e$export$8775e04aa1928f66 = [
    {
        offset: 0,
        transform: 'translate3d(0, -100%, 0)',
        visibility: 'visible'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    }
];


var $7f6e7384a07a6650$exports = {};

$parcel$export($7f6e7384a07a6650$exports, "slideInLeft", () => $7f6e7384a07a6650$export$8da96f801aa19ebe);
const $7f6e7384a07a6650$export$8da96f801aa19ebe = [
    {
        offset: 0,
        transform: 'translate3d(-100%, 0, 0)',
        visibility: 'visible'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    }
];


var $ad103c5541942d58$exports = {};

$parcel$export($ad103c5541942d58$exports, "slideInRight", () => $ad103c5541942d58$export$706618d509d55167);
const $ad103c5541942d58$export$706618d509d55167 = [
    {
        offset: 0,
        transform: 'translate3d(100%, 0, 0)',
        visibility: 'visible'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    }
];


var $d0168a7904c0e141$exports = {};

$parcel$export($d0168a7904c0e141$exports, "slideInUp", () => $d0168a7904c0e141$export$8ce8a09eb901d11);
const $d0168a7904c0e141$export$8ce8a09eb901d11 = [
    {
        offset: 0,
        transform: 'translate3d(0, 100%, 0)',
        visibility: 'visible'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 0, 0)'
    }
];


var $0fea399a1ecaf81d$exports = {};

$parcel$export($0fea399a1ecaf81d$exports, "slideOutDown", () => $0fea399a1ecaf81d$export$4d23096b87fa05f1);
const $0fea399a1ecaf81d$export$4d23096b87fa05f1 = [
    {
        offset: 0,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 1,
        visibility: 'hidden',
        transform: 'translate3d(0, 100%, 0)'
    }
];


var $f722ee6e15dc7b56$exports = {};

$parcel$export($f722ee6e15dc7b56$exports, "slideOutLeft", () => $f722ee6e15dc7b56$export$78e157c613296941);
const $f722ee6e15dc7b56$export$78e157c613296941 = [
    {
        offset: 0,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 1,
        visibility: 'hidden',
        transform: 'translate3d(-100%, 0, 0)'
    }
];


var $1bb01bba9f4a7914$exports = {};

$parcel$export($1bb01bba9f4a7914$exports, "slideOutRight", () => $1bb01bba9f4a7914$export$45629ceb9412b813);
const $1bb01bba9f4a7914$export$45629ceb9412b813 = [
    {
        offset: 0,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 1,
        visibility: 'hidden',
        transform: 'translate3d(100%, 0, 0)'
    }
];


var $bc1f12b8bd4f6a0c$exports = {};

$parcel$export($bc1f12b8bd4f6a0c$exports, "slideOutUp", () => $bc1f12b8bd4f6a0c$export$341210899707327e);
const $bc1f12b8bd4f6a0c$export$341210899707327e = [
    {
        offset: 0,
        transform: 'translate3d(0, 0, 0)'
    },
    {
        offset: 1,
        visibility: 'hidden',
        transform: 'translate3d(0, -100%, 0)'
    }
];


var $70a08acd58cca01f$exports = {};

$parcel$export($70a08acd58cca01f$exports, "hinge", () => $70a08acd58cca01f$export$321a3d0bf2c75);
const $70a08acd58cca01f$export$321a3d0bf2c75 = [
    {
        offset: 0,
        easing: 'ease-in-out'
    },
    {
        offset: 0.2,
        transform: 'rotate3d(0, 0, 1, 80deg)',
        easing: 'ease-in-out'
    },
    {
        offset: 0.4,
        transform: 'rotate3d(0, 0, 1, 60deg)',
        easing: 'ease-in-out',
        opacity: '1'
    },
    {
        offset: 0.6,
        transform: 'rotate3d(0, 0, 1, 80deg)',
        easing: 'ease-in-out'
    },
    {
        offset: 0.8,
        transform: 'rotate3d(0, 0, 1, 60deg)',
        easing: 'ease-in-out',
        opacity: '1'
    },
    {
        offset: 1,
        transform: 'translate3d(0, 700px, 0)',
        opacity: '0'
    }
];


var $3cf8e6decb5a50bd$exports = {};

$parcel$export($3cf8e6decb5a50bd$exports, "jackInTheBox", () => $3cf8e6decb5a50bd$export$51046d36a99b73b0);
const $3cf8e6decb5a50bd$export$51046d36a99b73b0 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'scale(0.1) rotate(30deg)',
        'transform-origin': 'center bottom'
    },
    {
        offset: 0.5,
        transform: 'rotate(-10deg)'
    },
    {
        offset: 0.7,
        transform: 'rotate(3deg)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'scale(1)'
    }
];


var $09a08d755e3919db$exports = {};

$parcel$export($09a08d755e3919db$exports, "rollIn", () => $09a08d755e3919db$export$6aa1850093220a4f);
const $09a08d755e3919db$export$6aa1850093220a4f = [
    {
        offset: 0,
        opacity: '0',
        transform: 'translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg)'
    },
    {
        offset: 1,
        opacity: '1',
        transform: 'translate3d(0, 0, 0)'
    }
];


var $5d96485232322b35$exports = {};

$parcel$export($5d96485232322b35$exports, "rollOut", () => $5d96485232322b35$export$e78f98b32413b70e);
const $5d96485232322b35$export$e78f98b32413b70e = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg)'
    }
];


var $61a0c524aa834577$exports = {};

$parcel$export($61a0c524aa834577$exports, "zoomIn", () => $61a0c524aa834577$export$3b71758b3ed5255f);
const $61a0c524aa834577$export$3b71758b3ed5255f = [
    {
        offset: 0,
        opacity: '0',
        transform: 'scale3d(0.3, 0.3, 0.3)'
    },
    {
        offset: 0.5,
        opacity: '1'
    }
];


var $1c06d0554384337c$exports = {};

$parcel$export($1c06d0554384337c$exports, "zoomInDown", () => $1c06d0554384337c$export$f1fb318c9f90bd9f);
const $1c06d0554384337c$export$f1fb318c9f90bd9f = [
    {
        offset: 0,
        opacity: '0',
        transform: 'scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0)',
        easing: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)'
    },
    {
        offset: 0.6,
        opacity: '1',
        transform: 'scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0)',
        easing: 'cubic-bezier(0.175, 0.885, 0.32, 1)'
    }
];


var $72390a043ff74a9e$exports = {};

$parcel$export($72390a043ff74a9e$exports, "zoomInLeft", () => $72390a043ff74a9e$export$3b5491f6985de80);
const $72390a043ff74a9e$export$3b5491f6985de80 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0)',
        easing: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)'
    },
    {
        offset: 0.6,
        opacity: '1',
        transform: 'scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0)',
        easing: 'cubic-bezier(0.175, 0.885, 0.32, 1)'
    }
];


var $dc7d817df7877727$exports = {};

$parcel$export($dc7d817df7877727$exports, "zoomInRight", () => $dc7d817df7877727$export$6d68984f8269fb51);
const $dc7d817df7877727$export$6d68984f8269fb51 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0)',
        easing: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)'
    },
    {
        offset: 0.6,
        opacity: '1',
        transform: 'scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0)',
        easing: 'cubic-bezier(0.175, 0.885, 0.32, 1)'
    }
];


var $19684b205abf9215$exports = {};

$parcel$export($19684b205abf9215$exports, "zoomInUp", () => $19684b205abf9215$export$f8e431a03d821bd2);
const $19684b205abf9215$export$f8e431a03d821bd2 = [
    {
        offset: 0,
        opacity: '0',
        transform: 'scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0)',
        easing: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)'
    },
    {
        offset: 0.6,
        opacity: '1',
        transform: 'scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0)',
        easing: 'cubic-bezier(0.175, 0.885, 0.32, 1)'
    }
];


var $71a0d0c61186efab$exports = {};

$parcel$export($71a0d0c61186efab$exports, "zoomOut", () => $71a0d0c61186efab$export$9fdb0a49c6b4b521);
const $71a0d0c61186efab$export$9fdb0a49c6b4b521 = [
    {
        offset: 0,
        opacity: '1'
    },
    {
        offset: 0.5,
        opacity: '0',
        transform: 'scale3d(0.3, 0.3, 0.3)'
    },
    {
        offset: 1,
        opacity: '0'
    }
];


var $d873a39323b19e10$exports = {};

$parcel$export($d873a39323b19e10$exports, "zoomOutDown", () => $d873a39323b19e10$export$10deba13beba726f);
const $d873a39323b19e10$export$10deba13beba726f = [
    {
        offset: 0.4,
        opacity: '1',
        transform: 'scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0)',
        easing: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0)',
        easing: 'cubic-bezier(0.175, 0.885, 0.32, 1)'
    }
];


var $b16abb66554fb319$exports = {};

$parcel$export($b16abb66554fb319$exports, "zoomOutLeft", () => $b16abb66554fb319$export$a897bc2790be434e);
const $b16abb66554fb319$export$a897bc2790be434e = [
    {
        offset: 0.4,
        opacity: '1',
        transform: 'scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0)'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'scale(0.1) translate3d(-2000px, 0, 0)'
    }
];


var $2edb4e09067e3406$exports = {};

$parcel$export($2edb4e09067e3406$exports, "zoomOutRight", () => $2edb4e09067e3406$export$23fe0a856d31fa73);
const $2edb4e09067e3406$export$23fe0a856d31fa73 = [
    {
        offset: 0.4,
        opacity: '1',
        transform: 'scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0)'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'scale(0.1) translate3d(2000px, 0, 0)'
    }
];


var $ab6097af4eb5f7db$exports = {};

$parcel$export($ab6097af4eb5f7db$exports, "zoomOutUp", () => $ab6097af4eb5f7db$export$6c4c2ccf7a384b67);
const $ab6097af4eb5f7db$export$6c4c2ccf7a384b67 = [
    {
        offset: 0.4,
        opacity: '1',
        transform: 'scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0)',
        easing: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)'
    },
    {
        offset: 1,
        opacity: '0',
        transform: 'scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0)',
        easing: 'cubic-bezier(0.175, 0.885, 0.32, 1)'
    }
];


const $d4a1f21ffcd1a5d0$export$15a0bf1b4bbacad8 = {
    linear: 'linear',
    ease: 'ease',
    easeIn: 'ease-in',
    easeOut: 'ease-out',
    easeInOut: 'ease-in-out',
    easeInSine: 'cubic-bezier(0.47, 0, 0.745, 0.715)',
    easeOutSine: 'cubic-bezier(0.39, 0.575, 0.565, 1)',
    easeInOutSine: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
    easeInQuad: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
    easeOutQuad: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    easeInOutQuad: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
    easeInCubic: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
    easeOutCubic: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    easeInOutCubic: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    easeInQuart: 'cubic-bezier(0.895, 0.03, 0.685, 0.22)',
    easeOutQuart: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
    easeInOutQuart: 'cubic-bezier(0.77, 0, 0.175, 1)',
    easeInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    easeOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
    easeInOutQuint: 'cubic-bezier(0.86, 0, 0.07, 1)',
    easeInExpo: 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
    easeOutExpo: 'cubic-bezier(0.19, 1, 0.22, 1)',
    easeInOutExpo: 'cubic-bezier(1, 0, 0, 1)',
    easeInCirc: 'cubic-bezier(0.6, 0.04, 0.98, 0.335)',
    easeOutCirc: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
    easeInOutCirc: 'cubic-bezier(0.785, 0.135, 0.15, 0.86)',
    easeInBack: 'cubic-bezier(0.6, -0.28, 0.735, 0.045)',
    easeOutBack: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    easeInOutBack: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)'
};


$parcel$exportWildcard($363b20dd79e5ca6e$exports, $44f147f691af1822$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $01171f9a4d9858dc$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $909cf1921cb61391$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $4d0e98ca2f31d355$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $088714b1dd473d0c$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $a1dd86058d2c43c9$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $bef33ab0528658c6$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $14697b3d063ca658$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $5ea90fcf5415cb2d$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $7d05de74a085c7b7$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $27141611cebdbb53$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $4483a1a95de52b9e$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $c207ee56b12a2956$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $a0a4ab1576ebd872$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $44b81948bc46e934$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $b5ebbcb511bc19ab$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $c6502b7d175e45f1$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $fd0da22f50dda942$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $12c3a44568f75637$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $9428afe051b34964$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $d7aa9547d97c85c7$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $77fdfec3e3328a5e$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $0618b51f8163ec9f$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $8f5db9efab73456b$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $c9ab1a5fc892b7e9$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $60de0e21da7dad7d$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $802318e5b1d339ca$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $3f77ee04149a65f3$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $12484dc2f647e2bc$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $762f1677681a46ab$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $e449ec72eb0e82b1$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $8cb2ce04810ddf77$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $1984e0af10234b58$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $e346ffa1c6de8609$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $fae7262e6d367457$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $2a278be6b832ee45$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $e54e86d1085d370c$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $698173604db46591$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $7090c344a5b98fe0$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $80617b560b457627$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $d0737f7cdd756e23$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $d6aa40d130f630c4$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $76dc859bd2579c92$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $c54f1cb83592ca25$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $099531e36148fcf4$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $0e0ee4d9e7d8fd0b$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $73639a2d73553918$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $f4c812c9af208c61$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $6ead62300547fc1b$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $066f45c38f90ced9$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $92c50403af1d837e$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $7b65d7c201ae9bc2$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $d9783225e15252c6$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $2ba5cbe367a3fd53$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $590d503ff17a255e$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $10223f7669247b6c$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $437ad91b4e3444b4$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $abc803ec1b4b65ad$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $6b32640fc55f9d36$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $e6e95cbd90bc2f63$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $af7077c3ead17b2f$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $2812e3a21c2b1112$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $54465ae8dcd6bb9a$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $a50a428d13fe7008$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $2bcb5bec42b12202$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $966d43d02b3ff8ac$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $197b0aab3b2b6867$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $5d2e8e530bb759da$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $4688a44783c4b9a1$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $51a81c4918c3d1b2$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $22ff0cb9f9d0eeb0$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $8f21045b3d541eaf$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $bb4fcc64a533d6ee$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $af1c7a6f7f27e88c$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $d58a70fe8c33b139$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $426298e0c35b4c03$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $aff59fd4c55fb35e$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $7f6e7384a07a6650$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $ad103c5541942d58$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $d0168a7904c0e141$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $0fea399a1ecaf81d$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $f722ee6e15dc7b56$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $1bb01bba9f4a7914$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $bc1f12b8bd4f6a0c$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $70a08acd58cca01f$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $3cf8e6decb5a50bd$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $09a08d755e3919db$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $5d96485232322b35$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $61a0c524aa834577$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $1c06d0554384337c$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $72390a043ff74a9e$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $dc7d817df7877727$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $19684b205abf9215$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $71a0d0c61186efab$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $d873a39323b19e10$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $b16abb66554fb319$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $2edb4e09067e3406$exports);
$parcel$exportWildcard($363b20dd79e5ca6e$exports, $ab6097af4eb5f7db$exports);


function $c54e4542209a04ff$export$6e3518451db70508() {
    return Object.entries($363b20dd79e5ca6e$exports).filter(([name])=>name !== "easings").map(([name])=>name);
}
function $c54e4542209a04ff$export$6e21255d9e68bdbc() {
    return Object.entries($363b20dd79e5ca6e$exports.easings).map(([name])=>name);
}








var $f0161fd24cf5009a$export$9e3f20439b466203 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasStarted = false;
        this.name = "none";
        this.play = false;
        this.delay = 0;
        this.direction = "normal";
        this.duration = 1e3;
        this.easing = "linear";
        this.endDelay = 0;
        this.fill = "auto";
        this.iterations = Infinity;
        this.iterationStart = 0;
        this.playbackRate = 1;
        this.handleAnimationFinish = ()=>{
            this.play = false;
            this.hasStarted = false;
            this.emit("sl-finish");
        };
        this.handleAnimationCancel = ()=>{
            this.play = false;
            this.hasStarted = false;
            this.emit("sl-cancel");
        };
    }
    /** Gets and sets the current animation time. */ get currentTime() {
        var _a, _b;
        return (_b = (_a = this.animation) == null ? void 0 : _a.currentTime) != null ? _b : 0;
    }
    set currentTime(time) {
        if (this.animation) this.animation.currentTime = time;
    }
    connectedCallback() {
        super.connectedCallback();
        this.createAnimation();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.destroyAnimation();
    }
    handleSlotChange() {
        this.destroyAnimation();
        this.createAnimation();
    }
    async createAnimation() {
        var _a, _b;
        const easing = (_a = (0, $363b20dd79e5ca6e$exports).easings[this.easing]) != null ? _a : this.easing;
        const keyframes = (_b = this.keyframes) != null ? _b : (0, $363b20dd79e5ca6e$exports)[this.name];
        const slot = await this.defaultSlot;
        const element = slot.assignedElements()[0];
        if (!element || !keyframes) return false;
        this.destroyAnimation();
        this.animation = element.animate(keyframes, {
            delay: this.delay,
            direction: this.direction,
            duration: this.duration,
            easing: easing,
            endDelay: this.endDelay,
            fill: this.fill,
            iterationStart: this.iterationStart,
            iterations: this.iterations
        });
        this.animation.playbackRate = this.playbackRate;
        this.animation.addEventListener("cancel", this.handleAnimationCancel);
        this.animation.addEventListener("finish", this.handleAnimationFinish);
        if (this.play) {
            this.hasStarted = true;
            this.emit("sl-start");
        } else this.animation.pause();
        return true;
    }
    destroyAnimation() {
        if (this.animation) {
            this.animation.cancel();
            this.animation.removeEventListener("cancel", this.handleAnimationCancel);
            this.animation.removeEventListener("finish", this.handleAnimationFinish);
            this.hasStarted = false;
        }
    }
    handleAnimationChange() {
        if (!this.hasUpdated) return;
        this.createAnimation();
    }
    handlePlayChange() {
        if (this.animation) {
            if (this.play && !this.hasStarted) {
                this.hasStarted = true;
                this.emit("sl-start");
            }
            if (this.play) this.animation.play();
            else this.animation.pause();
            return true;
        }
        return false;
    }
    handlePlaybackRateChange() {
        if (this.animation) this.animation.playbackRate = this.playbackRate;
    }
    /** Clears all keyframe effects caused by this animation and aborts its playback. */ cancel() {
        var _a;
        (_a = this.animation) == null || _a.cancel();
    }
    /** Sets the playback time to the end of the animation corresponding to the current playback direction. */ finish() {
        var _a;
        (_a = this.animation) == null || _a.finish();
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)` <slot @slotchange=${this.handleSlotChange}></slot> `;
    }
};
$f0161fd24cf5009a$export$9e3f20439b466203.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $3fe0c1c82f1c56f0$export$5af81660aeecc2e9)
];
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $92e5fd8708ba43bd$export$163dfc35cc43f240)("slot")
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "defaultSlot", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "name", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "play", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "delay", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "direction", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "duration", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "easing", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "end-delay",
        type: Number
    })
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "endDelay", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "fill", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "iterations", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "iteration-start",
        type: Number
    })
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "iterationStart", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: false
    })
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "keyframes", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        attribute: "playback-rate",
        type: Number
    })
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "playbackRate", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)([
        "name",
        "delay",
        "direction",
        "duration",
        "easing",
        "endDelay",
        "fill",
        "iterations",
        "iterationsStart",
        "keyframes"
    ])
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "handleAnimationChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("play")
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "handlePlayChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("playbackRate")
], $f0161fd24cf5009a$export$9e3f20439b466203.prototype, "handlePlaybackRateChange", 1);


// src/components/animation/animation.ts
var $a79799299a0e2298$export$61e79b30b588ea00 = (0, $f0161fd24cf5009a$export$9e3f20439b466203);
(0, $f0161fd24cf5009a$export$9e3f20439b466203).define("sl-animation");





// src/components/avatar/avatar.styles.ts

var $142ee7bb6311c8c0$export$bf8171dedc91ff1b = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: inline-block;

    --size: 3rem;
  }

  .avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: var(--size);
    height: var(--size);
    background-color: var(--sl-color-neutral-400);
    font-family: var(--sl-font-sans);
    font-size: calc(var(--size) * 0.5);
    font-weight: var(--sl-font-weight-normal);
    color: var(--sl-color-neutral-0);
    user-select: none;
    -webkit-user-select: none;
    vertical-align: middle;
  }

  .avatar--circle,
  .avatar--circle .avatar__image {
    border-radius: var(--sl-border-radius-circle);
  }

  .avatar--rounded,
  .avatar--rounded .avatar__image {
    border-radius: var(--sl-border-radius-medium);
  }

  .avatar--square {
    border-radius: 0;
  }

  .avatar__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .avatar__initials {
    line-height: 1;
    text-transform: uppercase;
  }

  .avatar__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    overflow: hidden;
  }
`;










var $820f5c66fe817695$export$2a013dcf743cdbe3 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasError = false;
        this.image = "";
        this.label = "";
        this.initials = "";
        this.loading = "eager";
        this.shape = "circle";
    }
    handleImageChange() {
        this.hasError = false;
    }
    handleImageLoadError() {
        this.hasError = true;
        this.emit("sl-error");
    }
    render() {
        const avatarWithImage = (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <img
        part="image"
        class="avatar__image"
        src="${this.image}"
        loading="${this.loading}"
        alt=""
        @error="${this.handleImageLoadError}"
      />
    `;
        let avatarWithoutImage = (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)``;
        if (this.initials) avatarWithoutImage = (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`<div part="initials" class="avatar__initials">${this.initials}</div>`;
        else avatarWithoutImage = (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
        <div part="icon" class="avatar__icon" aria-hidden="true">
          <slot name="icon">
            <sl-icon name="person-fill" library="system"></sl-icon>
          </slot>
        </div>
      `;
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            avatar: true,
            "avatar--circle": this.shape === "circle",
            "avatar--rounded": this.shape === "rounded",
            "avatar--square": this.shape === "square"
        })}
        role="img"
        aria-label=${this.label}
      >
        ${this.image && !this.hasError ? avatarWithImage : avatarWithoutImage}
      </div>
    `;
    }
};
$820f5c66fe817695$export$2a013dcf743cdbe3.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $142ee7bb6311c8c0$export$bf8171dedc91ff1b)
];
$820f5c66fe817695$export$2a013dcf743cdbe3.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $820f5c66fe817695$export$2a013dcf743cdbe3.prototype, "hasError", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $820f5c66fe817695$export$2a013dcf743cdbe3.prototype, "image", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $820f5c66fe817695$export$2a013dcf743cdbe3.prototype, "label", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $820f5c66fe817695$export$2a013dcf743cdbe3.prototype, "initials", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $820f5c66fe817695$export$2a013dcf743cdbe3.prototype, "loading", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $820f5c66fe817695$export$2a013dcf743cdbe3.prototype, "shape", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("image")
], $820f5c66fe817695$export$2a013dcf743cdbe3.prototype, "handleImageChange", 1);


// src/components/avatar/avatar.ts
var $cc61e09458c692b6$export$6a08910e00934a8a = (0, $820f5c66fe817695$export$2a013dcf743cdbe3);
(0, $820f5c66fe817695$export$2a013dcf743cdbe3).define("sl-avatar");












// src/components/alert/alert.styles.ts

var $0c6f1569855638f8$export$1b79454e98b5adc7 = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    display: contents;

    /* For better DX, we'll reset the margin here so the base part can inherit it */
    margin: 0;
  }

  .alert {
    position: relative;
    display: flex;
    align-items: stretch;
    background-color: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-top-width: calc(var(--sl-panel-border-width) * 3);
    border-radius: var(--sl-border-radius-medium);
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-small);
    font-weight: var(--sl-font-weight-normal);
    line-height: 1.6;
    color: var(--sl-color-neutral-700);
    margin: inherit;
    overflow: hidden;
  }

  .alert:not(.alert--has-icon) .alert__icon,
  .alert:not(.alert--closable) .alert__close-button {
    display: none;
  }

  .alert__icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-large);
    padding-inline-start: var(--sl-spacing-large);
  }

  .alert--has-countdown {
    border-bottom: none;
  }

  .alert--primary {
    border-top-color: var(--sl-color-primary-600);
  }

  .alert--primary .alert__icon {
    color: var(--sl-color-primary-600);
  }

  .alert--success {
    border-top-color: var(--sl-color-success-600);
  }

  .alert--success .alert__icon {
    color: var(--sl-color-success-600);
  }

  .alert--neutral {
    border-top-color: var(--sl-color-neutral-600);
  }

  .alert--neutral .alert__icon {
    color: var(--sl-color-neutral-600);
  }

  .alert--warning {
    border-top-color: var(--sl-color-warning-600);
  }

  .alert--warning .alert__icon {
    color: var(--sl-color-warning-600);
  }

  .alert--danger {
    border-top-color: var(--sl-color-danger-600);
  }

  .alert--danger .alert__icon {
    color: var(--sl-color-danger-600);
  }

  .alert__message {
    flex: 1 1 auto;
    display: block;
    padding: var(--sl-spacing-large);
    overflow: hidden;
  }

  .alert__close-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-medium);
    padding-inline-end: var(--sl-spacing-medium);
  }

  .alert__countdown {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: calc(var(--sl-panel-border-width) * 3);
    background-color: var(--sl-panel-border-color);
    display: flex;
  }

  .alert__countdown--ltr {
    justify-content: flex-end;
  }

  .alert__countdown .alert__countdown-elapsed {
    height: 100%;
    width: 0;
  }

  .alert--primary .alert__countdown-elapsed {
    background-color: var(--sl-color-primary-600);
  }

  .alert--success .alert__countdown-elapsed {
    background-color: var(--sl-color-success-600);
  }

  .alert--neutral .alert__countdown-elapsed {
    background-color: var(--sl-color-neutral-600);
  }

  .alert--warning .alert__countdown-elapsed {
    background-color: var(--sl-color-warning-600);
  }

  .alert--danger .alert__countdown-elapsed {
    background-color: var(--sl-color-danger-600);
  }

  .alert__timer {
    display: none;
  }
`;









var $0d6aef49d41831c5$var$_SlAlert = class _SlAlert extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $2bcc883cf9fdb597$export$34f6a5ffaa663541)(this, "icon", "suffix");
        this.localize = new (0, $358d84668aa2b71f$export$b1a2fed5bb41b893)(this);
        this.open = false;
        this.closable = false;
        this.variant = "primary";
        this.duration = Infinity;
        this.remainingTime = this.duration;
    }
    static get toastStack() {
        if (!this.currentToastStack) this.currentToastStack = Object.assign(document.createElement("div"), {
            className: "sl-toast-stack"
        });
        return this.currentToastStack;
    }
    firstUpdated() {
        this.base.hidden = !this.open;
    }
    restartAutoHide() {
        this.handleCountdownChange();
        clearTimeout(this.autoHideTimeout);
        clearInterval(this.remainingTimeInterval);
        if (this.open && this.duration < Infinity) {
            this.autoHideTimeout = window.setTimeout(()=>this.hide(), this.duration);
            this.remainingTime = this.duration;
            this.remainingTimeInterval = window.setInterval(()=>{
                this.remainingTime -= 100;
            }, 100);
        }
    }
    pauseAutoHide() {
        var _a;
        (_a = this.countdownAnimation) == null || _a.pause();
        clearTimeout(this.autoHideTimeout);
        clearInterval(this.remainingTimeInterval);
    }
    resumeAutoHide() {
        var _a;
        if (this.duration < Infinity) {
            this.autoHideTimeout = window.setTimeout(()=>this.hide(), this.remainingTime);
            this.remainingTimeInterval = window.setInterval(()=>{
                this.remainingTime -= 100;
            }, 100);
            (_a = this.countdownAnimation) == null || _a.play();
        }
    }
    handleCountdownChange() {
        if (this.open && this.duration < Infinity && this.countdown) {
            const { countdownElement: countdownElement } = this;
            const start = "100%";
            const end = "0";
            this.countdownAnimation = countdownElement.animate([
                {
                    width: start
                },
                {
                    width: end
                }
            ], {
                duration: this.duration,
                easing: "linear"
            });
        }
    }
    handleCloseClick() {
        this.hide();
    }
    async handleOpenChange() {
        if (this.open) {
            this.emit("sl-show");
            if (this.duration < Infinity) this.restartAutoHide();
            await (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.base);
            this.base.hidden = false;
            const { keyframes: keyframes, options: options } = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "alert.show", {
                dir: this.localize.dir()
            });
            await (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.base, keyframes, options);
            this.emit("sl-after-show");
        } else {
            this.emit("sl-hide");
            clearTimeout(this.autoHideTimeout);
            clearInterval(this.remainingTimeInterval);
            await (0, $41facc830b5907b7$export$ad12f740028ccbea)(this.base);
            const { keyframes: keyframes, options: options } = (0, $a1414451ad8be7a7$export$b1aed5dec0c2d368)(this, "alert.hide", {
                dir: this.localize.dir()
            });
            await (0, $41facc830b5907b7$export$3b755839a54e1bb0)(this.base, keyframes, options);
            this.base.hidden = true;
            this.emit("sl-after-hide");
        }
    }
    handleDurationChange() {
        this.restartAutoHide();
    }
    /** Shows the alert. */ async show() {
        if (this.open) return void 0;
        this.open = true;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the alert */ async hide() {
        if (!this.open) return void 0;
        this.open = false;
        return (0, $b5a9418bcbe3f786$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    /**
   * Displays the alert as a toast notification. This will move the alert out of its position in the DOM and, when
   * dismissed, it will be removed from the DOM completely. By storing a reference to the alert, you can reuse it by
   * calling this method again. The returned promise will resolve after the alert is hidden.
   */ async toast() {
        return new Promise((resolve)=>{
            this.handleCountdownChange();
            if (_SlAlert.toastStack.parentElement === null) document.body.append(_SlAlert.toastStack);
            _SlAlert.toastStack.appendChild(this);
            requestAnimationFrame(()=>{
                this.clientWidth;
                this.show();
            });
            this.addEventListener("sl-after-hide", ()=>{
                _SlAlert.toastStack.removeChild(this);
                resolve();
                if (_SlAlert.toastStack.querySelector("sl-alert") === null) _SlAlert.toastStack.remove();
            }, {
                once: true
            });
        });
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $4930586706e2a706$export$56cc687933817664)({
            alert: true,
            "alert--open": this.open,
            "alert--closable": this.closable,
            "alert--has-countdown": !!this.countdown,
            "alert--has-icon": this.hasSlotController.test("icon"),
            "alert--primary": this.variant === "primary",
            "alert--success": this.variant === "success",
            "alert--neutral": this.variant === "neutral",
            "alert--warning": this.variant === "warning",
            "alert--danger": this.variant === "danger"
        })}
        role="alert"
        aria-hidden=${this.open ? "false" : "true"}
        @mouseenter=${this.pauseAutoHide}
        @mouseleave=${this.resumeAutoHide}
      >
        <div part="icon" class="alert__icon">
          <slot name="icon"></slot>
        </div>

        <div part="message" class="alert__message" aria-live="polite">
          <slot></slot>
        </div>

        ${this.closable ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <sl-icon-button
                part="close-button"
                exportparts="base:close-button__base"
                class="alert__close-button"
                name="x-lg"
                library="system"
                label=${this.localize.term("close")}
                @click=${this.handleCloseClick}
              ></sl-icon-button>
            ` : ""}

        <div role="timer" class="alert__timer">${this.remainingTime}</div>

        ${this.countdown ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <div
                class=${(0, $4930586706e2a706$export$56cc687933817664)({
            alert__countdown: true,
            "alert__countdown--ltr": this.countdown === "ltr"
        })}
              >
                <div class="alert__countdown-elapsed"></div>
              </div>
            ` : ""}
      </div>
    `;
    }
};
$0d6aef49d41831c5$var$_SlAlert.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $0c6f1569855638f8$export$1b79454e98b5adc7)
];
$0d6aef49d41831c5$var$_SlAlert.dependencies = {
    "sl-icon-button": (0, $271ffb72cdd1ec73$export$302c9d29315a4659)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)('[part~="base"]')
], $0d6aef49d41831c5$var$_SlAlert.prototype, "base", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".alert__countdown-elapsed")
], $0d6aef49d41831c5$var$_SlAlert.prototype, "countdownElement", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $0d6aef49d41831c5$var$_SlAlert.prototype, "open", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $0d6aef49d41831c5$var$_SlAlert.prototype, "closable", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        reflect: true
    })
], $0d6aef49d41831c5$var$_SlAlert.prototype, "variant", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Number
    })
], $0d6aef49d41831c5$var$_SlAlert.prototype, "duration", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $0d6aef49d41831c5$var$_SlAlert.prototype, "countdown", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $0d6aef49d41831c5$var$_SlAlert.prototype, "remainingTime", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $0d6aef49d41831c5$var$_SlAlert.prototype, "handleOpenChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("duration")
], $0d6aef49d41831c5$var$_SlAlert.prototype, "handleDurationChange", 1);
var $0d6aef49d41831c5$export$6e7c68d58861dcad = $0d6aef49d41831c5$var$_SlAlert;
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("alert.show", {
    keyframes: [
        {
            opacity: 0,
            scale: 0.8
        },
        {
            opacity: 1,
            scale: 1
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $a1414451ad8be7a7$export$6e92ecdbe15fda0b)("alert.hide", {
    keyframes: [
        {
            opacity: 1,
            scale: 1
        },
        {
            opacity: 0,
            scale: 0.8
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});


// src/components/alert/alert.ts
var $51ba490f7dcfb12a$export$af26cf2d39cfc9d4 = (0, $0d6aef49d41831c5$export$6e7c68d58861dcad);
(0, $0d6aef49d41831c5$export$6e7c68d58861dcad).define("sl-alert");
















// src/components/animated-image/animated-image.styles.ts

var $b69843d6216e6d0d$export$faf9f4c9e0abd7ad = (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    --control-box-size: 3rem;
    --icon-size: calc(var(--control-box-size) * 0.625);

    display: inline-flex;
    position: relative;
    cursor: pointer;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
  }

  img[aria-hidden='true'] {
    display: none;
  }

  .animated-image__control-box {
    display: flex;
    position: absolute;
    align-items: center;
    justify-content: center;
    top: calc(50% - var(--control-box-size) / 2);
    right: calc(50% - var(--control-box-size) / 2);
    width: var(--control-box-size);
    height: var(--control-box-size);
    font-size: var(--icon-size);
    background: none;
    border: solid 2px currentColor;
    background-color: rgb(0 0 0 /50%);
    border-radius: var(--sl-border-radius-circle);
    color: white;
    pointer-events: none;
    transition: var(--sl-transition-fast) opacity;
  }

  :host([play]:hover) .animated-image__control-box {
    opacity: 1;
  }

  :host([play]:not(:hover)) .animated-image__control-box {
    opacity: 0;
  }

  :host([play]) slot[name='play-icon'],
  :host(:not([play])) slot[name='pause-icon'] {
    display: none;
  }
`;





var $9cf90fdf466ad389$export$9203f4bd334e1d05 = class extends (0, $a29c472ac6b25bc6$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.isLoaded = false;
    }
    handleClick() {
        this.play = !this.play;
    }
    handleLoad() {
        const canvas = document.createElement("canvas");
        const { width: width, height: height } = this.animatedImage;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(this.animatedImage, 0, 0, width, height);
        this.frozenFrame = canvas.toDataURL("image/gif");
        if (!this.isLoaded) {
            this.emit("sl-load");
            this.isLoaded = true;
        }
    }
    handleError() {
        this.emit("sl-error");
    }
    handlePlayChange() {
        if (this.play) {
            this.animatedImage.src = "";
            this.animatedImage.src = this.src;
        }
    }
    handleSrcChange() {
        this.isLoaded = false;
    }
    render() {
        return (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
      <div class="animated-image">
        <img
          class="animated-image__animated"
          src=${this.src}
          alt=${this.alt}
          crossorigin="anonymous"
          aria-hidden=${this.play ? "false" : "true"}
          @click=${this.handleClick}
          @load=${this.handleLoad}
          @error=${this.handleError}
        />

        ${this.isLoaded ? (0, $d2b76d366be0d5ac$export$c0bb0b647f701bb5)`
              <img
                class="animated-image__frozen"
                src=${this.frozenFrame}
                alt=${this.alt}
                aria-hidden=${this.play ? "true" : "false"}
                @click=${this.handleClick}
              />

              <div part="control-box" class="animated-image__control-box">
                <slot name="play-icon"><sl-icon name="play-fill" library="system"></sl-icon></slot>
                <slot name="pause-icon"><sl-icon name="pause-fill" library="system"></sl-icon></slot>
              </div>
            ` : ""}
      </div>
    `;
    }
};
$9cf90fdf466ad389$export$9203f4bd334e1d05.styles = [
    (0, $50b558233c88797a$export$e1ac0a3ec62d1269),
    (0, $b69843d6216e6d0d$export$faf9f4c9e0abd7ad)
];
$9cf90fdf466ad389$export$9203f4bd334e1d05.dependencies = {
    "sl-icon": (0, $23ae34b1bd251d7a$export$ef62a86bf282441)
};
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $c78fd40b9201a956$export$2fa187e846a241c4)(".animated-image__animated")
], $9cf90fdf466ad389$export$9203f4bd334e1d05.prototype, "animatedImage", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $9cf90fdf466ad389$export$9203f4bd334e1d05.prototype, "frozenFrame", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $52a0cf48ef66e8b5$export$ca000e230c0caa3e)()
], $9cf90fdf466ad389$export$9203f4bd334e1d05.prototype, "isLoaded", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $9cf90fdf466ad389$export$9203f4bd334e1d05.prototype, "src", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)()
], $9cf90fdf466ad389$export$9203f4bd334e1d05.prototype, "alt", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $0af69cb729554da0$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $9cf90fdf466ad389$export$9203f4bd334e1d05.prototype, "play", 2);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("play", {
        waitUntilFirstUpdate: true
    })
], $9cf90fdf466ad389$export$9203f4bd334e1d05.prototype, "handlePlayChange", 1);
(0, $1db749c92da399da$export$85c93885f16e8446)([
    (0, $d094534805de59fa$export$3db5d71bdb2d5499)("src")
], $9cf90fdf466ad389$export$9203f4bd334e1d05.prototype, "handleSrcChange", 1);


// src/components/animated-image/animated-image.ts
var $e1b29218ebded9f7$export$d3331d69a2a9b018 = (0, $9cf90fdf466ad389$export$9203f4bd334e1d05);
(0, $9cf90fdf466ad389$export$9203f4bd334e1d05).define("sl-animated-image");





















// packages/alpinejs/src/scheduler.js
var $f347e48613385d9c$var$flushPending = false;
var $f347e48613385d9c$var$flushing = false;
var $f347e48613385d9c$var$queue = [];
var $f347e48613385d9c$var$lastFlushedIndex = -1;
function $f347e48613385d9c$var$scheduler(callback) {
    $f347e48613385d9c$var$queueJob(callback);
}
function $f347e48613385d9c$var$queueJob(job) {
    if (!$f347e48613385d9c$var$queue.includes(job)) $f347e48613385d9c$var$queue.push(job);
    $f347e48613385d9c$var$queueFlush();
}
function $f347e48613385d9c$var$dequeueJob(job) {
    let index = $f347e48613385d9c$var$queue.indexOf(job);
    if (index !== -1 && index > $f347e48613385d9c$var$lastFlushedIndex) $f347e48613385d9c$var$queue.splice(index, 1);
}
function $f347e48613385d9c$var$queueFlush() {
    if (!$f347e48613385d9c$var$flushing && !$f347e48613385d9c$var$flushPending) {
        $f347e48613385d9c$var$flushPending = true;
        queueMicrotask($f347e48613385d9c$var$flushJobs);
    }
}
function $f347e48613385d9c$var$flushJobs() {
    $f347e48613385d9c$var$flushPending = false;
    $f347e48613385d9c$var$flushing = true;
    for(let i = 0; i < $f347e48613385d9c$var$queue.length; i++){
        $f347e48613385d9c$var$queue[i]();
        $f347e48613385d9c$var$lastFlushedIndex = i;
    }
    $f347e48613385d9c$var$queue.length = 0;
    $f347e48613385d9c$var$lastFlushedIndex = -1;
    $f347e48613385d9c$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $f347e48613385d9c$var$reactive;
var $f347e48613385d9c$var$effect;
var $f347e48613385d9c$var$release;
var $f347e48613385d9c$var$raw;
var $f347e48613385d9c$var$shouldSchedule = true;
function $f347e48613385d9c$var$disableEffectScheduling(callback) {
    $f347e48613385d9c$var$shouldSchedule = false;
    callback();
    $f347e48613385d9c$var$shouldSchedule = true;
}
function $f347e48613385d9c$var$setReactivityEngine(engine) {
    $f347e48613385d9c$var$reactive = engine.reactive;
    $f347e48613385d9c$var$release = engine.release;
    $f347e48613385d9c$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($f347e48613385d9c$var$shouldSchedule) $f347e48613385d9c$var$scheduler(task);
                else task();
            }
        });
    $f347e48613385d9c$var$raw = engine.raw;
}
function $f347e48613385d9c$var$overrideEffect(override) {
    $f347e48613385d9c$var$effect = override;
}
function $f347e48613385d9c$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $f347e48613385d9c$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $f347e48613385d9c$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $f347e48613385d9c$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $f347e48613385d9c$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$f347e48613385d9c$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $f347e48613385d9c$var$onAttributeAddeds = [];
var $f347e48613385d9c$var$onElRemoveds = [];
var $f347e48613385d9c$var$onElAddeds = [];
function $f347e48613385d9c$var$onElAdded(callback) {
    $f347e48613385d9c$var$onElAddeds.push(callback);
}
function $f347e48613385d9c$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $f347e48613385d9c$var$onElRemoveds.push(callback);
    }
}
function $f347e48613385d9c$var$onAttributesAdded(callback) {
    $f347e48613385d9c$var$onAttributeAddeds.push(callback);
}
function $f347e48613385d9c$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $f347e48613385d9c$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $f347e48613385d9c$var$cleanupElement(el) {
    el._x_effects?.forEach($f347e48613385d9c$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $f347e48613385d9c$var$observer = new MutationObserver($f347e48613385d9c$var$onMutate);
var $f347e48613385d9c$var$currentlyObserving = false;
function $f347e48613385d9c$var$startObservingMutations() {
    $f347e48613385d9c$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $f347e48613385d9c$var$currentlyObserving = true;
}
function $f347e48613385d9c$var$stopObservingMutations() {
    $f347e48613385d9c$var$flushObserver();
    $f347e48613385d9c$var$observer.disconnect();
    $f347e48613385d9c$var$currentlyObserving = false;
}
var $f347e48613385d9c$var$queuedMutations = [];
function $f347e48613385d9c$var$flushObserver() {
    let records = $f347e48613385d9c$var$observer.takeRecords();
    $f347e48613385d9c$var$queuedMutations.push(()=>records.length > 0 && $f347e48613385d9c$var$onMutate(records));
    let queueLengthWhenTriggered = $f347e48613385d9c$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($f347e48613385d9c$var$queuedMutations.length === queueLengthWhenTriggered) while($f347e48613385d9c$var$queuedMutations.length > 0)$f347e48613385d9c$var$queuedMutations.shift()();
    });
}
function $f347e48613385d9c$var$mutateDom(callback) {
    if (!$f347e48613385d9c$var$currentlyObserving) return callback();
    $f347e48613385d9c$var$stopObservingMutations();
    let result = callback();
    $f347e48613385d9c$var$startObservingMutations();
    return result;
}
var $f347e48613385d9c$var$isCollecting = false;
var $f347e48613385d9c$var$deferredMutations = [];
function $f347e48613385d9c$var$deferMutations() {
    $f347e48613385d9c$var$isCollecting = true;
}
function $f347e48613385d9c$var$flushAndStopDeferringMutations() {
    $f347e48613385d9c$var$isCollecting = false;
    $f347e48613385d9c$var$onMutate($f347e48613385d9c$var$deferredMutations);
    $f347e48613385d9c$var$deferredMutations = [];
}
function $f347e48613385d9c$var$onMutate(mutations) {
    if ($f347e48613385d9c$var$isCollecting) {
        $f347e48613385d9c$var$deferredMutations = $f347e48613385d9c$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $f347e48613385d9c$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $f347e48613385d9c$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $f347e48613385d9c$var$scope(node) {
    return $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$closestDataStack(node));
}
function $f347e48613385d9c$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$f347e48613385d9c$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $f347e48613385d9c$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $f347e48613385d9c$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $f347e48613385d9c$var$closestDataStack(node.parentNode);
}
function $f347e48613385d9c$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $f347e48613385d9c$var$mergeProxyTrap);
}
var $f347e48613385d9c$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $f347e48613385d9c$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $f347e48613385d9c$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $f347e48613385d9c$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $f347e48613385d9c$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$f347e48613385d9c$var$get(data2, path), (value)=>$f347e48613385d9c$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $f347e48613385d9c$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $f347e48613385d9c$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $f347e48613385d9c$var$magics = {};
function $f347e48613385d9c$var$magic(name, callback) {
    $f347e48613385d9c$var$magics[name] = callback;
}
function $f347e48613385d9c$var$injectMagics(obj, el) {
    let memoizedUtilities = $f347e48613385d9c$var$getUtilities(el);
    Object.entries($f347e48613385d9c$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $f347e48613385d9c$var$getUtilities(el) {
    let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $f347e48613385d9c$var$interceptor,
        ...utilities
    };
    $f347e48613385d9c$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $f347e48613385d9c$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $f347e48613385d9c$var$handleError(e, el, expression);
    }
}
function $f347e48613385d9c$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $f347e48613385d9c$var$shouldAutoEvaluateFunctions = true;
function $f347e48613385d9c$var$dontAutoEvaluateFunctions(callback) {
    let cache = $f347e48613385d9c$var$shouldAutoEvaluateFunctions;
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $f347e48613385d9c$var$evaluate(el, expression, extras = {}) {
    let result;
    $f347e48613385d9c$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $f347e48613385d9c$var$evaluateLater(...args) {
    return $f347e48613385d9c$var$theEvaluatorFunction(...args);
}
var $f347e48613385d9c$var$theEvaluatorFunction = $f347e48613385d9c$var$normalEvaluator;
function $f347e48613385d9c$var$setEvaluator(newEvaluator) {
    $f347e48613385d9c$var$theEvaluatorFunction = newEvaluator;
}
function $f347e48613385d9c$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $f347e48613385d9c$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$f347e48613385d9c$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, expression) : $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el);
    return $f347e48613385d9c$var$tryCatch.bind(null, el, expression, evaluator);
}
function $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result);
    };
}
var $f347e48613385d9c$var$evaluatorMemo = {};
function $f347e48613385d9c$var$generateFunctionFromString(expression, el) {
    if ($f347e48613385d9c$var$evaluatorMemo[expression]) return $f347e48613385d9c$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $f347e48613385d9c$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $f347e48613385d9c$var$evaluatorMemo[expression] = func;
    return func;
}
function $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $f347e48613385d9c$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression));
            if (func.finished) {
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $f347e48613385d9c$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($f347e48613385d9c$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$f347e48613385d9c$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $f347e48613385d9c$var$prefixAsString = "x-";
function $f347e48613385d9c$var$prefix(subject = "") {
    return $f347e48613385d9c$var$prefixAsString + subject;
}
function $f347e48613385d9c$var$setPrefix(newPrefix) {
    $f347e48613385d9c$var$prefixAsString = newPrefix;
}
var $f347e48613385d9c$var$directiveHandlers = {};
function $f347e48613385d9c$var$directive(name, callback) {
    $f347e48613385d9c$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$f347e48613385d9c$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $f347e48613385d9c$var$directiveOrder.indexOf(directive2);
            $f347e48613385d9c$var$directiveOrder.splice(pos >= 0 ? pos : $f347e48613385d9c$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $f347e48613385d9c$var$directiveExists(name) {
    return Object.keys($f347e48613385d9c$var$directiveHandlers).includes(name);
}
function $f347e48613385d9c$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $f347e48613385d9c$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($f347e48613385d9c$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($f347e48613385d9c$var$outNonAlpineAttributes).map($f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($f347e48613385d9c$var$byPriority);
    return directives2.map((directive2)=>{
        return $f347e48613385d9c$var$getDirectiveHandler(el, directive2);
    });
}
function $f347e48613385d9c$var$attributesOnly(attributes) {
    return Array.from(attributes).map($f347e48613385d9c$var$toTransformedAttributes()).filter((attr)=>!$f347e48613385d9c$var$outNonAlpineAttributes(attr));
}
var $f347e48613385d9c$var$isDeferringHandlers = false;
var $f347e48613385d9c$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $f347e48613385d9c$var$currentHandlerStackKey = Symbol();
function $f347e48613385d9c$var$deferHandlingDirectives(callback) {
    $f347e48613385d9c$var$isDeferringHandlers = true;
    let key = Symbol();
    $f347e48613385d9c$var$currentHandlerStackKey = key;
    $f347e48613385d9c$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($f347e48613385d9c$var$directiveHandlerStacks.get(key).length)$f347e48613385d9c$var$directiveHandlerStacks.get(key).shift()();
        $f347e48613385d9c$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $f347e48613385d9c$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $f347e48613385d9c$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $f347e48613385d9c$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $f347e48613385d9c$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $f347e48613385d9c$var$evaluateLater.bind($f347e48613385d9c$var$evaluateLater, el),
        evaluate: $f347e48613385d9c$var$evaluate.bind($f347e48613385d9c$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $f347e48613385d9c$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $f347e48613385d9c$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
    $f347e48613385d9c$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $f347e48613385d9c$var$isDeferringHandlers ? $f347e48613385d9c$var$directiveHandlerStacks.get($f347e48613385d9c$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $f347e48613385d9c$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $f347e48613385d9c$var$into = (i)=>i;
function $f347e48613385d9c$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $f347e48613385d9c$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $f347e48613385d9c$var$attributeTransformers = [];
function $f347e48613385d9c$var$mapAttributes(callback) {
    $f347e48613385d9c$var$attributeTransformers.push(callback);
}
function $f347e48613385d9c$var$outNonAlpineAttributes({ name: name }) {
    return $f347e48613385d9c$var$alpineAttributeRegex().test(name);
}
var $f347e48613385d9c$var$alpineAttributeRegex = ()=>new RegExp(`^${$f347e48613385d9c$var$prefixAsString}([^:^.]+)\\b`);
function $f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($f347e48613385d9c$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $f347e48613385d9c$var$DEFAULT = "DEFAULT";
var $f347e48613385d9c$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $f347e48613385d9c$var$DEFAULT,
    "teleport"
];
function $f347e48613385d9c$var$byPriority(a, b) {
    let typeA = $f347e48613385d9c$var$directiveOrder.indexOf(a.type) === -1 ? $f347e48613385d9c$var$DEFAULT : a.type;
    let typeB = $f347e48613385d9c$var$directiveOrder.indexOf(b.type) === -1 ? $f347e48613385d9c$var$DEFAULT : b.type;
    return $f347e48613385d9c$var$directiveOrder.indexOf(typeA) - $f347e48613385d9c$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $f347e48613385d9c$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $f347e48613385d9c$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$f347e48613385d9c$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $f347e48613385d9c$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $f347e48613385d9c$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $f347e48613385d9c$var$started = false;
function $f347e48613385d9c$var$start() {
    if ($f347e48613385d9c$var$started) $f347e48613385d9c$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $f347e48613385d9c$var$started = true;
    if (!document.body) $f347e48613385d9c$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $f347e48613385d9c$var$dispatch(document, "alpine:init");
    $f347e48613385d9c$var$dispatch(document, "alpine:initializing");
    $f347e48613385d9c$var$startObservingMutations();
    $f347e48613385d9c$var$onElAdded((el)=>$f347e48613385d9c$var$initTree(el, $f347e48613385d9c$var$walk));
    $f347e48613385d9c$var$onElRemoved((el)=>$f347e48613385d9c$var$destroyTree(el));
    $f347e48613385d9c$var$onAttributesAdded((el, attrs)=>{
        $f347e48613385d9c$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$f347e48613385d9c$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($f347e48613385d9c$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $f347e48613385d9c$var$initTree(el);
    });
    $f347e48613385d9c$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $f347e48613385d9c$var$warnAboutMissingPlugins();
    });
}
var $f347e48613385d9c$var$rootSelectorCallbacks = [];
var $f347e48613385d9c$var$initSelectorCallbacks = [];
function $f347e48613385d9c$var$rootSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $f347e48613385d9c$var$allSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.concat($f347e48613385d9c$var$initSelectorCallbacks).map((fn)=>fn());
}
function $f347e48613385d9c$var$addRootSelector(selectorCallback) {
    $f347e48613385d9c$var$rootSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$addInitSelector(selectorCallback) {
    $f347e48613385d9c$var$initSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$closestRoot(el, includeInitSelectors = false) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $f347e48613385d9c$var$allSelectors() : $f347e48613385d9c$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $f347e48613385d9c$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $f347e48613385d9c$var$findClosest(el.parentElement, callback);
}
function $f347e48613385d9c$var$isRoot(el) {
    return $f347e48613385d9c$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $f347e48613385d9c$var$initInterceptors2 = [];
function $f347e48613385d9c$var$interceptInit(callback) {
    $f347e48613385d9c$var$initInterceptors2.push(callback);
}
var $f347e48613385d9c$var$markerDispenser = 1;
function $f347e48613385d9c$var$initTree(el, walker = $f347e48613385d9c$var$walk, intercept = ()=>{}) {
    if ($f347e48613385d9c$var$findClosest(el, (i)=>i._x_ignore)) return;
    $f347e48613385d9c$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $f347e48613385d9c$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $f347e48613385d9c$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $f347e48613385d9c$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $f347e48613385d9c$var$destroyTree(root, walker = $f347e48613385d9c$var$walk) {
    walker(root, (el)=>{
        $f347e48613385d9c$var$cleanupElement(el);
        $f347e48613385d9c$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $f347e48613385d9c$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($f347e48613385d9c$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $f347e48613385d9c$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $f347e48613385d9c$var$tickStack = [];
var $f347e48613385d9c$var$isHolding = false;
function $f347e48613385d9c$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $f347e48613385d9c$var$isHolding || setTimeout(()=>{
            $f347e48613385d9c$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $f347e48613385d9c$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $f347e48613385d9c$var$releaseNextTicks() {
    $f347e48613385d9c$var$isHolding = false;
    while($f347e48613385d9c$var$tickStack.length)$f347e48613385d9c$var$tickStack.shift()();
}
function $f347e48613385d9c$var$holdNextTicks() {
    $f347e48613385d9c$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $f347e48613385d9c$var$setClasses(el, value) {
    if (Array.isArray(value)) return $f347e48613385d9c$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $f347e48613385d9c$var$setClasses(el, value());
    return $f347e48613385d9c$var$setClassesFromString(el, value);
}
function $f347e48613385d9c$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $f347e48613385d9c$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $f347e48613385d9c$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setStylesFromObject(el, value);
    return $f347e48613385d9c$var$setStylesFromString(el, value);
}
function $f347e48613385d9c$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $f347e48613385d9c$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $f347e48613385d9c$var$setStyles(el, previousStyles);
    };
}
function $f347e48613385d9c$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $f347e48613385d9c$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $f347e48613385d9c$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$f347e48613385d9c$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, value);
    else $f347e48613385d9c$var$registerTransitionsFromClassString(el, expression, value);
});
function $f347e48613385d9c$var$registerTransitionsFromClassString(el, classString, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $f347e48613385d9c$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $f347e48613385d9c$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $f347e48613385d9c$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $f347e48613385d9c$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $f347e48613385d9c$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $f347e48613385d9c$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $f347e48613385d9c$var$closestHide(parent);
}
function $f347e48613385d9c$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $f347e48613385d9c$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $f347e48613385d9c$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $f347e48613385d9c$var$once(()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $f347e48613385d9c$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $f347e48613385d9c$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $f347e48613385d9c$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $f347e48613385d9c$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $f347e48613385d9c$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $f347e48613385d9c$var$mutateDom(()=>{
                stages.end();
            });
            $f347e48613385d9c$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $f347e48613385d9c$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $f347e48613385d9c$var$isCloning = false;
function $f347e48613385d9c$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$f347e48613385d9c$var$isCloning ? fallback(...args) : callback(...args);
}
function $f347e48613385d9c$var$onlyDuringClone(callback) {
    return (...args)=>$f347e48613385d9c$var$isCloning && callback(...args);
}
var $f347e48613385d9c$var$interceptors = [];
function $f347e48613385d9c$var$interceptClone(callback) {
    $f347e48613385d9c$var$interceptors.push(callback);
}
function $f347e48613385d9c$var$cloneNode(from, to) {
    $f347e48613385d9c$var$interceptors.forEach((i)=>i(from, to));
    $f347e48613385d9c$var$isCloning = true;
    $f347e48613385d9c$var$dontRegisterReactiveSideEffects(()=>{
        $f347e48613385d9c$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $f347e48613385d9c$var$isCloning = false;
}
var $f347e48613385d9c$var$isCloningLegacy = false;
function $f347e48613385d9c$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $f347e48613385d9c$var$isCloning = true;
    $f347e48613385d9c$var$isCloningLegacy = true;
    $f347e48613385d9c$var$dontRegisterReactiveSideEffects(()=>{
        $f347e48613385d9c$var$cloneTree(newEl);
    });
    $f347e48613385d9c$var$isCloning = false;
    $f347e48613385d9c$var$isCloningLegacy = false;
}
function $f347e48613385d9c$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $f347e48613385d9c$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $f347e48613385d9c$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $f347e48613385d9c$var$initTree(el, shallowWalker);
}
function $f347e48613385d9c$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $f347e48613385d9c$var$effect;
    $f347e48613385d9c$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $f347e48613385d9c$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $f347e48613385d9c$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $f347e48613385d9c$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $f347e48613385d9c$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $f347e48613385d9c$var$camelCase(name) : name;
    switch(name){
        case "value":
            $f347e48613385d9c$var$bindInputValue(el, value);
            break;
        case "style":
            $f347e48613385d9c$var$bindStyles(el, value);
            break;
        case "class":
            $f347e48613385d9c$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $f347e48613385d9c$var$bindAttribute(el, name, value);
            break;
    }
}
function $f347e48613385d9c$var$bindInputValue(el, value) {
    if ($f347e48613385d9c$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $f347e48613385d9c$var$safeParseBoolean(el.value) === value;
            else el.checked = $f347e48613385d9c$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($f347e48613385d9c$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$f347e48613385d9c$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $f347e48613385d9c$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $f347e48613385d9c$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $f347e48613385d9c$var$setClasses(el, value);
}
function $f347e48613385d9c$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $f347e48613385d9c$var$setStyles(el, value);
}
function $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value) {
    $f347e48613385d9c$var$bindAttribute(el, name, value);
    $f347e48613385d9c$var$setPropertyIfChanged(el, name, value);
}
function $f347e48613385d9c$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($f347e48613385d9c$var$isBooleanAttr(name)) value = name;
        $f347e48613385d9c$var$setIfChanged(el, name, value);
    }
}
function $f347e48613385d9c$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $f347e48613385d9c$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $f347e48613385d9c$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $f347e48613385d9c$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $f347e48613385d9c$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $f347e48613385d9c$var$isBooleanAttr(attrName) {
    return $f347e48613385d9c$var$booleanAttributes.has(attrName);
}
function $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $f347e48613385d9c$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $f347e48613385d9c$var$getAttributeBinding(el, name, fallback);
}
function $f347e48613385d9c$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $f347e48613385d9c$var$dontAutoEvaluateFunctions(()=>{
            return $f347e48613385d9c$var$evaluate(el, binding.expression);
        });
    }
    return $f347e48613385d9c$var$getAttributeBinding(el, name, fallback);
}
function $f347e48613385d9c$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($f347e48613385d9c$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $f347e48613385d9c$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $f347e48613385d9c$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $f347e48613385d9c$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $f347e48613385d9c$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $f347e48613385d9c$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $f347e48613385d9c$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($f347e48613385d9c$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($f347e48613385d9c$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($f347e48613385d9c$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $f347e48613385d9c$var$release(reference);
    };
}
function $f347e48613385d9c$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $f347e48613385d9c$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($f347e48613385d9c$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $f347e48613385d9c$var$stores = {};
var $f347e48613385d9c$var$isReactive = false;
function $f347e48613385d9c$var$store(name, value) {
    if (!$f347e48613385d9c$var$isReactive) {
        $f347e48613385d9c$var$stores = $f347e48613385d9c$var$reactive($f347e48613385d9c$var$stores);
        $f347e48613385d9c$var$isReactive = true;
    }
    if (value === void 0) return $f347e48613385d9c$var$stores[name];
    $f347e48613385d9c$var$stores[name] = value;
    $f347e48613385d9c$var$initInterceptors($f347e48613385d9c$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $f347e48613385d9c$var$stores[name].init();
}
function $f347e48613385d9c$var$getStores() {
    return $f347e48613385d9c$var$stores;
}
// packages/alpinejs/src/binds.js
var $f347e48613385d9c$var$binds = {};
function $f347e48613385d9c$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $f347e48613385d9c$var$applyBindingsObject(name, getBindings());
    else $f347e48613385d9c$var$binds[name] = getBindings;
    return ()=>{};
}
function $f347e48613385d9c$var$injectBindingProviders(obj) {
    Object.entries($f347e48613385d9c$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $f347e48613385d9c$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $f347e48613385d9c$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $f347e48613385d9c$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $f347e48613385d9c$var$datas = {};
function $f347e48613385d9c$var$data(name, callback) {
    $f347e48613385d9c$var$datas[name] = callback;
}
function $f347e48613385d9c$var$injectDataProviders(obj, context) {
    Object.entries($f347e48613385d9c$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $f347e48613385d9c$var$Alpine = {
    get reactive () {
        return $f347e48613385d9c$var$reactive;
    },
    get release () {
        return $f347e48613385d9c$var$release;
    },
    get effect () {
        return $f347e48613385d9c$var$effect;
    },
    get raw () {
        return $f347e48613385d9c$var$raw;
    },
    version: "3.14.8",
    flushAndStopDeferringMutations: $f347e48613385d9c$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $f347e48613385d9c$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $f347e48613385d9c$var$disableEffectScheduling,
    startObservingMutations: $f347e48613385d9c$var$startObservingMutations,
    stopObservingMutations: $f347e48613385d9c$var$stopObservingMutations,
    setReactivityEngine: $f347e48613385d9c$var$setReactivityEngine,
    onAttributeRemoved: $f347e48613385d9c$var$onAttributeRemoved,
    onAttributesAdded: $f347e48613385d9c$var$onAttributesAdded,
    closestDataStack: $f347e48613385d9c$var$closestDataStack,
    skipDuringClone: $f347e48613385d9c$var$skipDuringClone,
    onlyDuringClone: $f347e48613385d9c$var$onlyDuringClone,
    addRootSelector: $f347e48613385d9c$var$addRootSelector,
    addInitSelector: $f347e48613385d9c$var$addInitSelector,
    interceptClone: $f347e48613385d9c$var$interceptClone,
    addScopeToNode: $f347e48613385d9c$var$addScopeToNode,
    deferMutations: $f347e48613385d9c$var$deferMutations,
    mapAttributes: $f347e48613385d9c$var$mapAttributes,
    evaluateLater: $f347e48613385d9c$var$evaluateLater,
    interceptInit: $f347e48613385d9c$var$interceptInit,
    setEvaluator: $f347e48613385d9c$var$setEvaluator,
    mergeProxies: $f347e48613385d9c$var$mergeProxies,
    extractProp: $f347e48613385d9c$var$extractProp,
    findClosest: $f347e48613385d9c$var$findClosest,
    onElRemoved: $f347e48613385d9c$var$onElRemoved,
    closestRoot: $f347e48613385d9c$var$closestRoot,
    destroyTree: $f347e48613385d9c$var$destroyTree,
    interceptor: $f347e48613385d9c$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $f347e48613385d9c$var$transition,
    setStyles: // INTERNAL
    $f347e48613385d9c$var$setStyles,
    mutateDom: // INTERNAL
    $f347e48613385d9c$var$mutateDom,
    directive: $f347e48613385d9c$var$directive,
    entangle: $f347e48613385d9c$var$entangle,
    throttle: $f347e48613385d9c$var$throttle,
    debounce: $f347e48613385d9c$var$debounce,
    evaluate: $f347e48613385d9c$var$evaluate,
    initTree: $f347e48613385d9c$var$initTree,
    nextTick: $f347e48613385d9c$var$nextTick,
    prefixed: $f347e48613385d9c$var$prefix,
    prefix: $f347e48613385d9c$var$setPrefix,
    plugin: $f347e48613385d9c$var$plugin,
    magic: $f347e48613385d9c$var$magic,
    store: $f347e48613385d9c$var$store,
    start: $f347e48613385d9c$var$start,
    clone: $f347e48613385d9c$var$clone,
    cloneNode: // INTERNAL
    $f347e48613385d9c$var$cloneNode,
    // INTERNAL
    bound: $f347e48613385d9c$var$getBinding,
    $data: $f347e48613385d9c$var$scope,
    watch: $f347e48613385d9c$var$watch,
    walk: $f347e48613385d9c$var$walk,
    data: $f347e48613385d9c$var$data,
    bind: $f347e48613385d9c$var$bind2
};
var $f347e48613385d9c$var$alpine_default = $f347e48613385d9c$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $f347e48613385d9c$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $f347e48613385d9c$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $f347e48613385d9c$var$isBooleanAttr2 = /* @__PURE__ */ $f347e48613385d9c$var$makeMap($f347e48613385d9c$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $f347e48613385d9c$var$EMPTY_OBJ = Object.freeze({});
var $f347e48613385d9c$var$EMPTY_ARR = Object.freeze([]);
var $f347e48613385d9c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f347e48613385d9c$var$hasOwn = (val, key)=>$f347e48613385d9c$var$hasOwnProperty.call(val, key);
var $f347e48613385d9c$var$isArray = Array.isArray;
var $f347e48613385d9c$var$isMap = (val)=>$f347e48613385d9c$var$toTypeString(val) === "[object Map]";
var $f347e48613385d9c$var$isString = (val)=>typeof val === "string";
var $f347e48613385d9c$var$isSymbol = (val)=>typeof val === "symbol";
var $f347e48613385d9c$var$isObject = (val)=>val !== null && typeof val === "object";
var $f347e48613385d9c$var$objectToString = Object.prototype.toString;
var $f347e48613385d9c$var$toTypeString = (value)=>$f347e48613385d9c$var$objectToString.call(value);
var $f347e48613385d9c$var$toRawType = (value)=>{
    return $f347e48613385d9c$var$toTypeString(value).slice(8, -1);
};
var $f347e48613385d9c$var$isIntegerKey = (key)=>$f347e48613385d9c$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $f347e48613385d9c$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $f347e48613385d9c$var$camelizeRE = /-(\w)/g;
var $f347e48613385d9c$var$camelize = $f347e48613385d9c$var$cacheStringFunction((str)=>{
    return str.replace($f347e48613385d9c$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $f347e48613385d9c$var$hyphenateRE = /\B([A-Z])/g;
var $f347e48613385d9c$var$hyphenate = $f347e48613385d9c$var$cacheStringFunction((str)=>str.replace($f347e48613385d9c$var$hyphenateRE, "-$1").toLowerCase());
var $f347e48613385d9c$var$capitalize = $f347e48613385d9c$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $f347e48613385d9c$var$toHandlerKey = $f347e48613385d9c$var$cacheStringFunction((str)=>str ? `on${$f347e48613385d9c$var$capitalize(str)}` : ``);
var $f347e48613385d9c$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $f347e48613385d9c$var$targetMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$effectStack = [];
var $f347e48613385d9c$var$activeEffect;
var $f347e48613385d9c$var$ITERATE_KEY = Symbol("iterate");
var $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $f347e48613385d9c$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $f347e48613385d9c$var$effect2(fn, options = $f347e48613385d9c$var$EMPTY_OBJ) {
    if ($f347e48613385d9c$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $f347e48613385d9c$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $f347e48613385d9c$var$stop(effect3) {
    if (effect3.active) {
        $f347e48613385d9c$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $f347e48613385d9c$var$uid = 0;
function $f347e48613385d9c$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$f347e48613385d9c$var$effectStack.includes(effect3)) {
            $f347e48613385d9c$var$cleanup(effect3);
            try {
                $f347e48613385d9c$var$enableTracking();
                $f347e48613385d9c$var$effectStack.push(effect3);
                $f347e48613385d9c$var$activeEffect = effect3;
                return fn();
            } finally{
                $f347e48613385d9c$var$effectStack.pop();
                $f347e48613385d9c$var$resetTracking();
                $f347e48613385d9c$var$activeEffect = $f347e48613385d9c$var$effectStack[$f347e48613385d9c$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $f347e48613385d9c$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $f347e48613385d9c$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $f347e48613385d9c$var$shouldTrack = true;
var $f347e48613385d9c$var$trackStack = [];
function $f347e48613385d9c$var$pauseTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = false;
}
function $f347e48613385d9c$var$enableTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = true;
}
function $f347e48613385d9c$var$resetTracking() {
    const last = $f347e48613385d9c$var$trackStack.pop();
    $f347e48613385d9c$var$shouldTrack = last === void 0 ? true : last;
}
function $f347e48613385d9c$var$track(target, type, key) {
    if (!$f347e48613385d9c$var$shouldTrack || $f347e48613385d9c$var$activeEffect === void 0) return;
    let depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) $f347e48613385d9c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($f347e48613385d9c$var$activeEffect)) {
        dep.add($f347e48613385d9c$var$activeEffect);
        $f347e48613385d9c$var$activeEffect.deps.push(dep);
        if ($f347e48613385d9c$var$activeEffect.options.onTrack) $f347e48613385d9c$var$activeEffect.options.onTrack({
            effect: $f347e48613385d9c$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $f347e48613385d9c$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $f347e48613385d9c$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $f347e48613385d9c$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                } else if ($f347e48613385d9c$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $f347e48613385d9c$var$isNonTrackableKeys = /* @__PURE__ */ $f347e48613385d9c$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $f347e48613385d9c$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($f347e48613385d9c$var$isSymbol));
var $f347e48613385d9c$var$get2 = /* @__PURE__ */ $f347e48613385d9c$var$createGetter();
var $f347e48613385d9c$var$readonlyGet = /* @__PURE__ */ $f347e48613385d9c$var$createGetter(true);
var $f347e48613385d9c$var$arrayInstrumentations = /* @__PURE__ */ $f347e48613385d9c$var$createArrayInstrumentations();
function $f347e48613385d9c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $f347e48613385d9c$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$f347e48613385d9c$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($f347e48613385d9c$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $f347e48613385d9c$var$pauseTracking();
            const res = $f347e48613385d9c$var$toRaw(this)[key].apply(this, args);
            $f347e48613385d9c$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $f347e48613385d9c$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $f347e48613385d9c$var$shallowReadonlyMap : $f347e48613385d9c$var$readonlyMap : shallow ? $f347e48613385d9c$var$shallowReactiveMap : $f347e48613385d9c$var$reactiveMap).get(target)) return target;
        const targetIsArray = $f347e48613385d9c$var$isArray(target);
        if (!isReadonly && targetIsArray && $f347e48613385d9c$var$hasOwn($f347e48613385d9c$var$arrayInstrumentations, key)) return Reflect.get($f347e48613385d9c$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($f347e48613385d9c$var$isSymbol(key) ? $f347e48613385d9c$var$builtInSymbols.has(key) : $f347e48613385d9c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $f347e48613385d9c$var$track(target, "get", key);
        if (shallow) return res;
        if ($f347e48613385d9c$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$f347e48613385d9c$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($f347e48613385d9c$var$isObject(res)) return isReadonly ? $f347e48613385d9c$var$readonly(res) : $f347e48613385d9c$var$reactive2(res);
        return res;
    };
}
var $f347e48613385d9c$var$set2 = /* @__PURE__ */ $f347e48613385d9c$var$createSetter();
function $f347e48613385d9c$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $f347e48613385d9c$var$toRaw(value);
            oldValue = $f347e48613385d9c$var$toRaw(oldValue);
            if (!$f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isRef(oldValue) && !$f347e48613385d9c$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isIntegerKey(key) ? Number(key) < target.length : $f347e48613385d9c$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $f347e48613385d9c$var$toRaw(receiver)) {
            if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
            else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $f347e48613385d9c$var$deleteProperty(target, key) {
    const hadKey = $f347e48613385d9c$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$f347e48613385d9c$var$isSymbol(key) || !$f347e48613385d9c$var$builtInSymbols.has(key)) $f347e48613385d9c$var$track(target, "has", key);
    return result;
}
function $f347e48613385d9c$var$ownKeys(target) {
    $f347e48613385d9c$var$track(target, "iterate", $f347e48613385d9c$var$isArray(target) ? "length" : $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $f347e48613385d9c$var$mutableHandlers = {
    get: $f347e48613385d9c$var$get2,
    set: $f347e48613385d9c$var$set2,
    deleteProperty: $f347e48613385d9c$var$deleteProperty,
    has: $f347e48613385d9c$var$has,
    ownKeys: $f347e48613385d9c$var$ownKeys
};
var $f347e48613385d9c$var$readonlyHandlers = {
    get: $f347e48613385d9c$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $f347e48613385d9c$var$toReactive = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$reactive2(value) : value;
var $f347e48613385d9c$var$toReadonly = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$readonly(value) : value;
var $f347e48613385d9c$var$toShallow = (value)=>value;
var $f347e48613385d9c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $f347e48613385d9c$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $f347e48613385d9c$var$getProto(rawTarget);
    const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $f347e48613385d9c$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $f347e48613385d9c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $f347e48613385d9c$var$track($f347e48613385d9c$var$toRaw(target), "iterate", $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $f347e48613385d9c$var$add(value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const proto = $f347e48613385d9c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $f347e48613385d9c$var$trigger(target, "add", value, value);
    }
    return this;
}
function $f347e48613385d9c$var$set$1(key, value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
    else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $f347e48613385d9c$var$deleteEntry(key) {
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$clear() {
    const target = $f347e48613385d9c$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $f347e48613385d9c$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $f347e48613385d9c$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $f347e48613385d9c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", $f347e48613385d9c$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $f347e48613385d9c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const targetIsMap = $f347e48613385d9c$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", isKeyOnly ? $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY : $f347e48613385d9c$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $f347e48613385d9c$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$f347e48613385d9c$var$capitalize(type)} operation ${key}failed: target is readonly.`, $f347e48613385d9c$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $f347e48613385d9c$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key);
        },
        get size () {
            return $f347e48613385d9c$var$size(this);
        },
        has: $f347e48613385d9c$var$has$1,
        add: $f347e48613385d9c$var$add,
        set: $f347e48613385d9c$var$set$1,
        delete: $f347e48613385d9c$var$deleteEntry,
        clear: $f347e48613385d9c$var$clear,
        forEach: $f347e48613385d9c$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, false, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this);
        },
        has: $f347e48613385d9c$var$has$1,
        add: $f347e48613385d9c$var$add,
        set: $f347e48613385d9c$var$set$1,
        delete: $f347e48613385d9c$var$deleteEntry,
        clear: $f347e48613385d9c$var$clear,
        forEach: $f347e48613385d9c$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this, true);
        },
        has (key) {
            return $f347e48613385d9c$var$has$1.call(this, key, true);
        },
        add: $f347e48613385d9c$var$createReadonlyMethod("add"),
        set: $f347e48613385d9c$var$createReadonlyMethod("set"),
        delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
        clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
        forEach: $f347e48613385d9c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, true, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this, true);
        },
        has (key) {
            return $f347e48613385d9c$var$has$1.call(this, key, true);
        },
        add: $f347e48613385d9c$var$createReadonlyMethod("add"),
        set: $f347e48613385d9c$var$createReadonlyMethod("set"),
        delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
        clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
        forEach: $f347e48613385d9c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$f347e48613385d9c$var$mutableInstrumentations, $f347e48613385d9c$var$readonlyInstrumentations, $f347e48613385d9c$var$shallowInstrumentations, $f347e48613385d9c$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentations();
function $f347e48613385d9c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $f347e48613385d9c$var$shallowReadonlyInstrumentations : $f347e48613385d9c$var$shallowInstrumentations : isReadonly ? $f347e48613385d9c$var$readonlyInstrumentations : $f347e48613385d9c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($f347e48613385d9c$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $f347e48613385d9c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentationGetter(false, false)
};
var $f347e48613385d9c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentationGetter(true, false)
};
function $f347e48613385d9c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $f347e48613385d9c$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $f347e48613385d9c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $f347e48613385d9c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $f347e48613385d9c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $f347e48613385d9c$var$targetTypeMap($f347e48613385d9c$var$toRawType(value));
}
function $f347e48613385d9c$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $f347e48613385d9c$var$createReactiveObject(target, false, $f347e48613385d9c$var$mutableHandlers, $f347e48613385d9c$var$mutableCollectionHandlers, $f347e48613385d9c$var$reactiveMap);
}
function $f347e48613385d9c$var$readonly(target) {
    return $f347e48613385d9c$var$createReactiveObject(target, true, $f347e48613385d9c$var$readonlyHandlers, $f347e48613385d9c$var$readonlyCollectionHandlers, $f347e48613385d9c$var$readonlyMap);
}
function $f347e48613385d9c$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$f347e48613385d9c$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $f347e48613385d9c$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $f347e48613385d9c$var$toRaw(observed) {
    return observed && $f347e48613385d9c$var$toRaw(observed["__v_raw"]) || observed;
}
function $f347e48613385d9c$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$f347e48613385d9c$var$magic("nextTick", ()=>$f347e48613385d9c$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$f347e48613385d9c$var$magic("dispatch", (el)=>$f347e48613385d9c$var$dispatch.bind($f347e48613385d9c$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$f347e48613385d9c$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $f347e48613385d9c$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$f347e48613385d9c$var$magic("store", $f347e48613385d9c$var$getStores);
// packages/alpinejs/src/magics/$data.js
$f347e48613385d9c$var$magic("data", (el)=>$f347e48613385d9c$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$f347e48613385d9c$var$magic("root", (el)=>$f347e48613385d9c$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$f347e48613385d9c$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $f347e48613385d9c$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $f347e48613385d9c$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $f347e48613385d9c$var$globalIdMemo = {};
function $f347e48613385d9c$var$findAndIncrementId(name) {
    if (!$f347e48613385d9c$var$globalIdMemo[name]) $f347e48613385d9c$var$globalIdMemo[name] = 0;
    return ++$f347e48613385d9c$var$globalIdMemo[name];
}
function $f347e48613385d9c$var$closestIdRoot(el, name) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $f347e48613385d9c$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $f347e48613385d9c$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$f347e48613385d9c$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $f347e48613385d9c$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $f347e48613385d9c$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $f347e48613385d9c$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $f347e48613385d9c$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$f347e48613385d9c$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$f347e48613385d9c$var$warnMissingPluginMagic("Focus", "focus", "focus");
$f347e48613385d9c$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $f347e48613385d9c$var$warnMissingPluginMagic(name, magicName, slug) {
    $f347e48613385d9c$var$magic(magicName, (el)=>$f347e48613385d9c$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$f347e48613385d9c$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $f347e48613385d9c$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$f347e48613385d9c$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f347e48613385d9c$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $f347e48613385d9c$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $f347e48613385d9c$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $f347e48613385d9c$var$skipDuringClone(()=>{
            $f347e48613385d9c$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $f347e48613385d9c$var$getTarget(expression);
        $f347e48613385d9c$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$f347e48613385d9c$var$mutateDom(()=>{
            clone2.remove();
            $f347e48613385d9c$var$destroyTree(clone2);
        }));
});
var $f347e48613385d9c$var$teleportContainerDuringClone = document.createElement("div");
function $f347e48613385d9c$var$getTarget(expression) {
    let target = $f347e48613385d9c$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $f347e48613385d9c$var$teleportContainerDuringClone;
    })();
    if (!target) $f347e48613385d9c$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $f347e48613385d9c$var$handler = ()=>{};
$f347e48613385d9c$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$f347e48613385d9c$var$directive("ignore", $f347e48613385d9c$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$f347e48613385d9c$var$directive("effect", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($f347e48613385d9c$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $f347e48613385d9c$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $f347e48613385d9c$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $f347e48613385d9c$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f347e48613385d9c$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f347e48613385d9c$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($f347e48613385d9c$var$isKeyEvent(event) || $f347e48613385d9c$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $f347e48613385d9c$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $f347e48613385d9c$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $f347e48613385d9c$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $f347e48613385d9c$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($f347e48613385d9c$var$isClickEvent(e.type)) return false;
            if ($f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $f347e48613385d9c$var$keyToModifiers(key) {
    if (!key) return [];
    key = $f347e48613385d9c$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$f347e48613385d9c$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $f347e48613385d9c$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $f347e48613385d9c$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($f347e48613385d9c$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $f347e48613385d9c$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $f347e48613385d9c$var$isCloning ? ()=>{} : $f347e48613385d9c$var$on(el, event, modifiers, (e)=>{
        setValue($f347e48613385d9c$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $f347e48613385d9c$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($f347e48613385d9c$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $f347e48613385d9c$var$on(el.form, "reset", [], (e)=>{
            $f347e48613385d9c$var$nextTick(()=>el._x_model && el._x_model.set($f347e48613385d9c$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $f347e48613385d9c$var$getInputValue(el, modifiers, event, currentValue) {
    return $f347e48613385d9c$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($f347e48613385d9c$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $f347e48613385d9c$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $f347e48613385d9c$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$f347e48613385d9c$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f347e48613385d9c$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f347e48613385d9c$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($f347e48613385d9c$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $f347e48613385d9c$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $f347e48613385d9c$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $f347e48613385d9c$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $f347e48613385d9c$var$isNumeric2(number) ? number : rawValue;
}
function $f347e48613385d9c$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$f347e48613385d9c$var$directive("cloak", (el)=>queueMicrotask(()=>$f347e48613385d9c$var$mutateDom(()=>el.removeAttribute($f347e48613385d9c$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$f347e48613385d9c$var$addInitSelector(()=>`[${$f347e48613385d9c$var$prefix("init")}]`);
$f347e48613385d9c$var$directive("init", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$f347e48613385d9c$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$f347e48613385d9c$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $f347e48613385d9c$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith(":", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("bind:"))));
var $f347e48613385d9c$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $f347e48613385d9c$var$injectBindingProviders(bindingProviders);
        let getBindings = $f347e48613385d9c$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $f347e48613385d9c$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $f347e48613385d9c$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$f347e48613385d9c$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$f347e48613385d9c$var$directive("bind", $f347e48613385d9c$var$handler2);
function $f347e48613385d9c$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$f347e48613385d9c$var$addRootSelector(()=>`[${$f347e48613385d9c$var$prefix("data")}]`);
$f347e48613385d9c$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($f347e48613385d9c$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $f347e48613385d9c$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $f347e48613385d9c$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $f347e48613385d9c$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $f347e48613385d9c$var$injectMagics(data2, el);
    let reactiveData = $f347e48613385d9c$var$reactive(data2);
    $f347e48613385d9c$var$initInterceptors(reactiveData);
    let undo = $f347e48613385d9c$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $f347e48613385d9c$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $f347e48613385d9c$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $f347e48613385d9c$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$f347e48613385d9c$var$isCloning) return false;
    if ($f347e48613385d9c$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$f347e48613385d9c$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $f347e48613385d9c$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$f347e48613385d9c$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $f347e48613385d9c$var$parseForExpression(expression);
    let evaluateItems = $f347e48613385d9c$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $f347e48613385d9c$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$f347e48613385d9c$var$mutateDom(()=>{
                $f347e48613385d9c$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($f347e48613385d9c$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $f347e48613385d9c$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $f347e48613385d9c$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $f347e48613385d9c$var$mutateDom(()=>{
                $f347e48613385d9c$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $f347e48613385d9c$var$mutateDom(()=>{
                if (!elForSpot) $f347e48613385d9c$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $f347e48613385d9c$var$reactive(scope2);
            $f347e48613385d9c$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $f347e48613385d9c$var$mutateDom(()=>{
                lastEl.after(clone2);
                $f347e48613385d9c$var$skipDuringClone(()=>$f347e48613385d9c$var$initTree(clone2))();
            });
            if (typeof key === "object") $f347e48613385d9c$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $f347e48613385d9c$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $f347e48613385d9c$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $f347e48613385d9c$var$handler3() {}
$f347e48613385d9c$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $f347e48613385d9c$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$f347e48613385d9c$var$directive("ref", $f347e48613385d9c$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$f347e48613385d9c$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f347e48613385d9c$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
        $f347e48613385d9c$var$mutateDom(()=>{
            el.after(clone2);
            $f347e48613385d9c$var$skipDuringClone(()=>$f347e48613385d9c$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                $f347e48613385d9c$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$f347e48613385d9c$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$f347e48613385d9c$var$setIdRoot(el, name));
});
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith("@", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("on:"))));
$f347e48613385d9c$var$directive("on", $f347e48613385d9c$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $f347e48613385d9c$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $f347e48613385d9c$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$f347e48613385d9c$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$f347e48613385d9c$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$f347e48613385d9c$var$warnMissingPluginDirective("Focus", "trap", "focus");
$f347e48613385d9c$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $f347e48613385d9c$var$warnMissingPluginDirective(name, directiveName, slug) {
    $f347e48613385d9c$var$directive(directiveName, (el)=>$f347e48613385d9c$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$f347e48613385d9c$var$alpine_default.setEvaluator($f347e48613385d9c$var$normalEvaluator);
$f347e48613385d9c$var$alpine_default.setReactivityEngine({
    reactive: $f347e48613385d9c$var$reactive2,
    effect: $f347e48613385d9c$var$effect2,
    release: $f347e48613385d9c$var$stop,
    raw: $f347e48613385d9c$var$toRaw
});
var $f347e48613385d9c$export$b7ee041e4ad2afec = $f347e48613385d9c$var$alpine_default;
// packages/alpinejs/builds/module.js
var $f347e48613385d9c$export$2e2bcd8739ae039 = $f347e48613385d9c$export$b7ee041e4ad2afec;


var $79b08e6be767aac5$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $79b08e6be767aac5$exports = factory();
})(window, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            });
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, 'default', {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 0);
    /******/ }({
        /***/ "./src/index.js": /*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _sass_index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./sass/index.scss */ "./src/sass/index.scss");
            /* harmony import */ var _sass_index_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_sass_index_scss__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _js_init__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./js/init */ "./src/js/init.js");
            var printJS = _js_init__WEBPACK_IMPORTED_MODULE_1__["default"].init;
            if (typeof window !== 'undefined') window.printJS = printJS;
            /* harmony default export */ __webpack_exports__["default"] = printJS;
        /***/ },
        /***/ "./src/js/browser.js": /*!***************************!*\
  !*** ./src/js/browser.js ***!
  \***************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var Browser = {
                // Firefox 1.0+
                isFirefox: function isFirefox() {
                    return typeof InstallTrigger !== 'undefined';
                },
                // Internet Explorer 6-11
                isIE: function isIE() {
                    return navigator.userAgent.indexOf('MSIE') !== -1 || !!document.documentMode;
                },
                // Edge 20+
                isEdge: function isEdge() {
                    return !Browser.isIE() && !!window.StyleMedia;
                },
                // Chrome 1+
                isChrome: function isChrome() {
                    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
                    return !!context.chrome;
                },
                // At least Safari 3+: "[object HTMLElementConstructor]"
                isSafari: function isSafari() {
                    return Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.toLowerCase().indexOf('safari') !== -1;
                },
                // IOS Chrome
                isIOSChrome: function isIOSChrome() {
                    return navigator.userAgent.toLowerCase().indexOf('crios') !== -1;
                }
            };
            /* harmony default export */ __webpack_exports__["default"] = Browser;
        /***/ },
        /***/ "./src/js/functions.js": /*!*****************************!*\
  !*** ./src/js/functions.js ***!
  \*****************************/ /*! exports provided: addWrapper, capitalizePrint, collectStyles, addHeader, cleanUp, isRawHTML */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addWrapper", function() {
                return addWrapper;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "capitalizePrint", function() {
                return capitalizePrint;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "collectStyles", function() {
                return collectStyles;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addHeader", function() {
                return addHeader;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cleanUp", function() {
                return cleanUp;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isRawHTML", function() {
                return isRawHTML;
            });
            /* harmony import */ var _modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modal */ "./src/js/modal.js");
            /* harmony import */ var _browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./browser */ "./src/js/browser.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                    return typeof obj;
                };
                else _typeof = function _typeof(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                return _typeof(obj);
            }
            function addWrapper(htmlData, params) {
                var bodyStyle = 'font-family:' + params.font + ' !important; font-size: ' + params.font_size + ' !important; width:100%;';
                return '<div style="' + bodyStyle + '">' + htmlData + '</div>';
            }
            function capitalizePrint(obj) {
                return obj.charAt(0).toUpperCase() + obj.slice(1);
            }
            function collectStyles(element, params) {
                var win = document.defaultView || window; // String variable to hold styling for each element
                var elementStyle = ''; // Loop over computed styles
                var styles = win.getComputedStyle(element, '');
                for(var key = 0; key < styles.length; key++){
                    // Check if style should be processed
                    if (params.targetStyles.indexOf('*') !== -1 || params.targetStyle.indexOf(styles[key]) !== -1 || targetStylesMatch(params.targetStyles, styles[key])) {
                        if (styles.getPropertyValue(styles[key])) elementStyle += styles[key] + ':' + styles.getPropertyValue(styles[key]) + ';';
                    }
                } // Print friendly defaults (deprecated)
                elementStyle += 'max-width: ' + params.maxWidth + 'px !important; font-size: ' + params.font_size + ' !important;';
                return elementStyle;
            }
            function targetStylesMatch(styles, value) {
                for(var i = 0; i < styles.length; i++){
                    if (_typeof(value) === 'object' && value.indexOf(styles[i]) !== -1) return true;
                }
                return false;
            }
            function addHeader(printElement, params) {
                // Create the header container div
                var headerContainer = document.createElement('div'); // Check if the header is text or raw html
                if (isRawHTML(params.header)) headerContainer.innerHTML = params.header;
                else {
                    // Create header element
                    var headerElement = document.createElement('h1'); // Create header text node
                    var headerNode = document.createTextNode(params.header); // Build and style
                    headerElement.appendChild(headerNode);
                    headerElement.setAttribute('style', params.headerStyle);
                    headerContainer.appendChild(headerElement);
                }
                printElement.insertBefore(headerContainer, printElement.childNodes[0]);
            }
            function cleanUp(params) {
                // If we are showing a feedback message to user, remove it
                if (params.showModal) _modal__WEBPACK_IMPORTED_MODULE_0__["default"].close(); // Check for a finished loading hook function
                if (params.onLoadingEnd) params.onLoadingEnd(); // If preloading pdf files, clean blob url
                if (params.showModal || params.onLoadingStart) window.URL.revokeObjectURL(params.printable); // Run onPrintDialogClose callback
                var event = 'mouseover';
                if (_browser__WEBPACK_IMPORTED_MODULE_1__["default"].isChrome() || _browser__WEBPACK_IMPORTED_MODULE_1__["default"].isFirefox()) // Ps.: Firefox will require an extra click in the document to fire the focus event.
                event = 'focus';
                var handler = function handler() {
                    // Make sure the event only happens once.
                    window.removeEventListener(event, handler);
                    params.onPrintDialogClose(); // Remove iframe from the DOM
                    var iframe = document.getElementById(params.frameId);
                    if (iframe) iframe.remove();
                };
                window.addEventListener(event, handler);
            }
            function isRawHTML(raw) {
                var regexHtml = new RegExp('<([A-Za-z][A-Za-z0-9]*)\\b[^>]*>(.*?)</\\1>');
                return regexHtml.test(raw);
            }
        /***/ },
        /***/ "./src/js/html.js": /*!************************!*\
  !*** ./src/js/html.js ***!
  \************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
            /* harmony import */ var _print__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./print */ "./src/js/print.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                    return typeof obj;
                };
                else _typeof = function _typeof(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                return _typeof(obj);
            }
            /* harmony default export */ __webpack_exports__["default"] = {
                print: function print(params, printFrame) {
                    // Get the DOM printable element
                    var printElement = isHtmlElement(params.printable) ? params.printable : document.getElementById(params.printable); // Check if the element exists
                    if (!printElement) {
                        window.console.error('Invalid HTML element id: ' + params.printable);
                        return;
                    } // Clone the target element including its children (if available)
                    params.printableElement = cloneElement(printElement, params); // Add header
                    if (params.header) Object(_functions__WEBPACK_IMPORTED_MODULE_0__["addHeader"])(params.printableElement, params);
                     // Print html element contents
                    _print__WEBPACK_IMPORTED_MODULE_1__["default"].send(params, printFrame);
                }
            };
            function cloneElement(element, params) {
                // Clone the main node (if not already inside the recursion process)
                var clone = element.cloneNode(); // Loop over and process the children elements / nodes (including text nodes)
                var childNodesArray = Array.prototype.slice.call(element.childNodes);
                for(var i = 0; i < childNodesArray.length; i++){
                    // Check if we are skipping the current element
                    if (params.ignoreElements.indexOf(childNodesArray[i].id) !== -1) continue;
                     // Clone the child element
                    var clonedChild = cloneElement(childNodesArray[i], params); // Attach the cloned child to the cloned parent node
                    clone.appendChild(clonedChild);
                } // Get all styling for print element (for nodes of type element only)
                if (params.scanStyles && element.nodeType === 1) clone.setAttribute('style', Object(_functions__WEBPACK_IMPORTED_MODULE_0__["collectStyles"])(element, params));
                 // Check if the element needs any state processing (copy user input data)
                switch(element.tagName){
                    case 'SELECT':
                        // Copy the current selection value to its clone
                        clone.value = element.value;
                        break;
                    case 'CANVAS':
                        // Copy the canvas content to its clone
                        clone.getContext('2d').drawImage(element, 0, 0);
                        break;
                }
                return clone;
            }
            function isHtmlElement(printable) {
                // Check if element is instance of HTMLElement or has nodeType === 1 (for elements in iframe)
                return _typeof(printable) === 'object' && printable && (printable instanceof HTMLElement || printable.nodeType === 1);
            }
        /***/ },
        /***/ "./src/js/image.js": /*!*************************!*\
  !*** ./src/js/image.js ***!
  \*************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
            /* harmony import */ var _print__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./print */ "./src/js/print.js");
            /* harmony import */ var _browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./browser */ "./src/js/browser.js");
            /* harmony default export */ __webpack_exports__["default"] = {
                print: function print(params, printFrame) {
                    // Check if we are printing one image or multiple images
                    if (params.printable.constructor !== Array) // Create array with one image
                    params.printable = [
                        params.printable
                    ];
                     // Create printable element (container)
                    params.printableElement = document.createElement('div'); // Create all image elements and append them to the printable container
                    params.printable.forEach(function(src) {
                        // Create the image element
                        var img = document.createElement('img');
                        img.setAttribute('style', params.imageStyle); // Set image src with the file url
                        img.src = src; // The following block is for Firefox, which for some reason requires the image's src to be fully qualified in
                        // order to print it
                        if (_browser__WEBPACK_IMPORTED_MODULE_2__["default"].isFirefox()) {
                            var fullyQualifiedSrc = img.src;
                            img.src = fullyQualifiedSrc;
                        } // Create the image wrapper
                        var imageWrapper = document.createElement('div'); // Append image to the wrapper element
                        imageWrapper.appendChild(img); // Append wrapper to the printable element
                        params.printableElement.appendChild(imageWrapper);
                    }); // Check if we are adding a print header
                    if (params.header) Object(_functions__WEBPACK_IMPORTED_MODULE_0__["addHeader"])(params.printableElement, params); // Print image
                    _print__WEBPACK_IMPORTED_MODULE_1__["default"].send(params, printFrame);
                }
            };
        /***/ },
        /***/ "./src/js/init.js": /*!************************!*\
  !*** ./src/js/init.js ***!
  \************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./browser */ "./src/js/browser.js");
            /* harmony import */ var _modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modal */ "./src/js/modal.js");
            /* harmony import */ var _pdf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./pdf */ "./src/js/pdf.js");
            /* harmony import */ var _html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./html */ "./src/js/html.js");
            /* harmony import */ var _raw_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./raw-html */ "./src/js/raw-html.js");
            /* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./image */ "./src/js/image.js");
            /* harmony import */ var _json__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./json */ "./src/js/json.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                    return typeof obj;
                };
                else _typeof = function _typeof(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                return _typeof(obj);
            }
            var printTypes = [
                'pdf',
                'html',
                'image',
                'json',
                'raw-html'
            ];
            /* harmony default export */ __webpack_exports__["default"] = {
                init: function init() {
                    var params = {
                        printable: null,
                        fallbackPrintable: null,
                        type: 'pdf',
                        header: null,
                        headerStyle: 'font-weight: 300;',
                        maxWidth: 800,
                        properties: null,
                        gridHeaderStyle: 'font-weight: bold; padding: 5px; border: 1px solid #dddddd;',
                        gridStyle: 'border: 1px solid lightgray; margin-bottom: -1px;',
                        showModal: false,
                        onError: function onError(error) {
                            throw error;
                        },
                        onLoadingStart: null,
                        onLoadingEnd: null,
                        onPrintDialogClose: function onPrintDialogClose() {},
                        onIncompatibleBrowser: function onIncompatibleBrowser() {},
                        modalMessage: 'Retrieving Document...',
                        frameId: 'printJS',
                        printableElement: null,
                        documentTitle: 'Document',
                        targetStyle: [
                            'clear',
                            'display',
                            'width',
                            'min-width',
                            'height',
                            'min-height',
                            'max-height'
                        ],
                        targetStyles: [
                            'border',
                            'box',
                            'break',
                            'text-decoration'
                        ],
                        ignoreElements: [],
                        repeatTableHeader: true,
                        css: null,
                        style: null,
                        scanStyles: true,
                        base64: false,
                        // Deprecated
                        onPdfOpen: null,
                        font: 'TimesNewRoman',
                        font_size: '12pt',
                        honorMarginPadding: true,
                        honorColor: false,
                        imageStyle: 'max-width: 100%;'
                    }; // Check if a printable document or object was supplied
                    var args = arguments[0];
                    if (args === undefined) throw new Error('printJS expects at least 1 attribute.');
                     // Process parameters
                    switch(_typeof(args)){
                        case 'string':
                            params.printable = encodeURI(args);
                            params.fallbackPrintable = params.printable;
                            params.type = arguments[1] || params.type;
                            break;
                        case 'object':
                            params.printable = args.printable;
                            params.fallbackPrintable = typeof args.fallbackPrintable !== 'undefined' ? args.fallbackPrintable : params.printable;
                            params.fallbackPrintable = params.base64 ? "data:application/pdf;base64,".concat(params.fallbackPrintable) : params.fallbackPrintable;
                            for(var k in params){
                                if (k === 'printable' || k === 'fallbackPrintable') continue;
                                params[k] = typeof args[k] !== 'undefined' ? args[k] : params[k];
                            }
                            break;
                        default:
                            throw new Error('Unexpected argument type! Expected "string" or "object", got ' + _typeof(args));
                    } // Validate printable
                    if (!params.printable) throw new Error('Missing printable information.'); // Validate type
                    if (!params.type || typeof params.type !== 'string' || printTypes.indexOf(params.type.toLowerCase()) === -1) throw new Error('Invalid print type. Available types are: pdf, html, image and json.');
                     // Check if we are showing a feedback message to the user (useful for large files)
                    if (params.showModal) _modal__WEBPACK_IMPORTED_MODULE_1__["default"].show(params); // Check for a print start hook function
                    if (params.onLoadingStart) params.onLoadingStart(); // To prevent duplication and issues, remove any used printFrame from the DOM
                    var usedFrame = document.getElementById(params.frameId);
                    if (usedFrame) usedFrame.parentNode.removeChild(usedFrame); // Create a new iframe for the print job
                    var printFrame = document.createElement('iframe');
                    if (_browser__WEBPACK_IMPORTED_MODULE_0__["default"].isFirefox()) // Set the iframe to be is visible on the page (guaranteed by fixed position) but hidden using opacity 0, because
                    // this works in Firefox. The height needs to be sufficient for some part of the document other than the PDF
                    // viewer's toolbar to be visible in the page
                    printFrame.setAttribute('style', 'width: 1px; height: 100px; position: fixed; left: 0; top: 0; opacity: 0; border-width: 0; margin: 0; padding: 0');
                    else // Hide the iframe in other browsers
                    printFrame.setAttribute('style', 'visibility: hidden; height: 0; width: 0; position: absolute; border: 0');
                     // Set iframe element id
                    printFrame.setAttribute('id', params.frameId); // For non pdf printing, pass an html document string to srcdoc (force onload callback)
                    if (params.type !== 'pdf') {
                        printFrame.srcdoc = '<html><head><title>' + params.documentTitle + '</title>'; // Attach css files
                        if (params.css) {
                            // Add support for single file
                            if (!Array.isArray(params.css)) params.css = [
                                params.css
                            ]; // Create link tags for each css file
                            params.css.forEach(function(file) {
                                printFrame.srcdoc += '<link rel="stylesheet" href="' + file + '">';
                            });
                        }
                        printFrame.srcdoc += '</head><body></body></html>';
                    } // Check printable type
                    switch(params.type){
                        case 'pdf':
                            // Check browser support for pdf and if not supported we will just open the pdf file instead
                            if (_browser__WEBPACK_IMPORTED_MODULE_0__["default"].isIE()) try {
                                console.info('Print.js doesn\'t support PDF printing in Internet Explorer.');
                                var win = window.open(params.fallbackPrintable, '_blank');
                                win.focus();
                                params.onIncompatibleBrowser();
                            } catch (error) {
                                params.onError(error);
                            } finally{
                                // Make sure there is no loading modal opened
                                if (params.showModal) _modal__WEBPACK_IMPORTED_MODULE_1__["default"].close();
                                if (params.onLoadingEnd) params.onLoadingEnd();
                            }
                            else _pdf__WEBPACK_IMPORTED_MODULE_2__["default"].print(params, printFrame);
                            break;
                        case 'image':
                            _image__WEBPACK_IMPORTED_MODULE_5__["default"].print(params, printFrame);
                            break;
                        case 'html':
                            _html__WEBPACK_IMPORTED_MODULE_3__["default"].print(params, printFrame);
                            break;
                        case 'raw-html':
                            _raw_html__WEBPACK_IMPORTED_MODULE_4__["default"].print(params, printFrame);
                            break;
                        case 'json':
                            _json__WEBPACK_IMPORTED_MODULE_6__["default"].print(params, printFrame);
                            break;
                    }
                }
            };
        /***/ },
        /***/ "./src/js/json.js": /*!************************!*\
  !*** ./src/js/json.js ***!
  \************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
            /* harmony import */ var _print__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./print */ "./src/js/print.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                    return typeof obj;
                };
                else _typeof = function _typeof(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                return _typeof(obj);
            }
            /* harmony default export */ __webpack_exports__["default"] = {
                print: function print(params, printFrame) {
                    // Check if we received proper data
                    if (_typeof(params.printable) !== 'object') throw new Error('Invalid javascript data object (JSON).');
                     // Validate repeatTableHeader
                    if (typeof params.repeatTableHeader !== 'boolean') throw new Error('Invalid value for repeatTableHeader attribute (JSON).');
                     // Validate properties
                    if (!params.properties || !Array.isArray(params.properties)) throw new Error('Invalid properties array for your JSON data.');
                     // We will format the property objects to keep the JSON api compatible with older releases
                    params.properties = params.properties.map(function(property) {
                        return {
                            field: _typeof(property) === 'object' ? property.field : property,
                            displayName: _typeof(property) === 'object' ? property.displayName : property,
                            columnSize: _typeof(property) === 'object' && property.columnSize ? property.columnSize + ';' : 100 / params.properties.length + '%;'
                        };
                    }); // Create a print container element
                    params.printableElement = document.createElement('div'); // Check if we are adding a print header
                    if (params.header) Object(_functions__WEBPACK_IMPORTED_MODULE_0__["addHeader"])(params.printableElement, params);
                     // Build the printable html data
                    params.printableElement.innerHTML += jsonToHTML(params); // Print the json data
                    _print__WEBPACK_IMPORTED_MODULE_1__["default"].send(params, printFrame);
                }
            };
            function jsonToHTML(params) {
                // Get the row and column data
                var data = params.printable;
                var properties = params.properties; // Create a html table
                var htmlData = '<table style="border-collapse: collapse; width: 100%;">'; // Check if the header should be repeated
                if (params.repeatTableHeader) htmlData += '<thead>';
                 // Add the table header row
                htmlData += '<tr>'; // Add the table header columns
                for(var a = 0; a < properties.length; a++)htmlData += '<th style="width:' + properties[a].columnSize + ';' + params.gridHeaderStyle + '">' + Object(_functions__WEBPACK_IMPORTED_MODULE_0__["capitalizePrint"])(properties[a].displayName) + '</th>';
                 // Add the closing tag for the table header row
                htmlData += '</tr>'; // If the table header is marked as repeated, add the closing tag
                if (params.repeatTableHeader) htmlData += '</thead>';
                 // Create the table body
                htmlData += '<tbody>'; // Add the table data rows
                for(var i = 0; i < data.length; i++){
                    // Add the row starting tag
                    htmlData += '<tr>'; // Print selected properties only
                    for(var n = 0; n < properties.length; n++){
                        var stringData = data[i]; // Support nested objects
                        var property = properties[n].field.split('.');
                        if (property.length > 1) for(var p = 0; p < property.length; p++)stringData = stringData[property[p]];
                        else stringData = stringData[properties[n].field];
                         // Add the row contents and styles
                        htmlData += '<td style="width:' + properties[n].columnSize + params.gridStyle + '">' + stringData + '</td>';
                    } // Add the row closing tag
                    htmlData += '</tr>';
                } // Add the table and body closing tags
                htmlData += '</tbody></table>';
                return htmlData;
            }
        /***/ },
        /***/ "./src/js/modal.js": /*!*************************!*\
  !*** ./src/js/modal.js ***!
  \*************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var Modal = {
                show: function show(params) {
                    // Build modal
                    var modalStyle = "font-family:sans-serif; display:table; text-align:center; font-weight:300; font-size:30px; left:0; top:0;position:fixed; z-index: 9990;color: #0460B5; width: 100%; height: 100%; background-color:rgba(255,255,255,.9);transition: opacity .3s ease;"; // Create wrapper
                    var printModal = document.createElement('div');
                    printModal.setAttribute('style', modalStyle);
                    printModal.setAttribute('id', 'printJS-Modal'); // Create content div
                    var contentDiv = document.createElement('div');
                    contentDiv.setAttribute('style', 'display:table-cell; vertical-align:middle; padding-bottom:100px;'); // Add close button (requires print.css)
                    var closeButton = document.createElement('div');
                    closeButton.setAttribute('class', 'printClose');
                    closeButton.setAttribute('id', 'printClose');
                    contentDiv.appendChild(closeButton); // Add spinner (requires print.css)
                    var spinner = document.createElement('span');
                    spinner.setAttribute('class', 'printSpinner');
                    contentDiv.appendChild(spinner); // Add message
                    var messageNode = document.createTextNode(params.modalMessage);
                    contentDiv.appendChild(messageNode); // Add contentDiv to printModal
                    printModal.appendChild(contentDiv); // Append print modal element to document body
                    document.getElementsByTagName('body')[0].appendChild(printModal); // Add event listener to close button
                    document.getElementById('printClose').addEventListener('click', function() {
                        Modal.close();
                    });
                },
                close: function close() {
                    var printModal = document.getElementById('printJS-Modal');
                    if (printModal) printModal.parentNode.removeChild(printModal);
                }
            };
            /* harmony default export */ __webpack_exports__["default"] = Modal;
        /***/ },
        /***/ "./src/js/pdf.js": /*!***********************!*\
  !*** ./src/js/pdf.js ***!
  \***********************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _print__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./print */ "./src/js/print.js");
            /* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
            /* harmony default export */ __webpack_exports__["default"] = {
                print: function print(params, printFrame) {
                    // Check if we have base64 data
                    if (params.base64) {
                        var bytesArray = Uint8Array.from(atob(params.printable), function(c) {
                            return c.charCodeAt(0);
                        });
                        createBlobAndPrint(params, printFrame, bytesArray);
                        return;
                    } // Format pdf url
                    params.printable = /^(blob|http|\/\/)/i.test(params.printable) ? params.printable : window.location.origin + (params.printable.charAt(0) !== '/' ? '/' + params.printable : params.printable); // Get the file through a http request (Preload)
                    var req = new window.XMLHttpRequest();
                    req.responseType = 'arraybuffer';
                    req.addEventListener('error', function() {
                        Object(_functions__WEBPACK_IMPORTED_MODULE_1__["cleanUp"])(params);
                        params.onError(req.statusText, req); // Since we don't have a pdf document available, we will stop the print job
                    });
                    req.addEventListener('load', function() {
                        // Check for errors
                        if ([
                            200,
                            201
                        ].indexOf(req.status) === -1) {
                            Object(_functions__WEBPACK_IMPORTED_MODULE_1__["cleanUp"])(params);
                            params.onError(req.statusText, req); // Since we don't have a pdf document available, we will stop the print job
                            return;
                        } // Print requested document
                        createBlobAndPrint(params, printFrame, req.response);
                    });
                    req.open('GET', params.printable, true);
                    req.send();
                }
            };
            function createBlobAndPrint(params, printFrame, data) {
                // Pass response or base64 data to a blob and create a local object url
                var localPdf = new window.Blob([
                    data
                ], {
                    type: 'application/pdf'
                });
                localPdf = window.URL.createObjectURL(localPdf); // Set iframe src with pdf document url
                printFrame.setAttribute('src', localPdf);
                _print__WEBPACK_IMPORTED_MODULE_0__["default"].send(params, printFrame);
            }
        /***/ },
        /***/ "./src/js/print.js": /*!*************************!*\
  !*** ./src/js/print.js ***!
  \*************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./browser */ "./src/js/browser.js");
            /* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
            var Print = {
                send: function send(params, printFrame) {
                    // Append iframe element to document body
                    document.getElementsByTagName('body')[0].appendChild(printFrame); // Get iframe element
                    var iframeElement = document.getElementById(params.frameId); // Wait for iframe to load all content
                    iframeElement.onload = function() {
                        if (params.type === 'pdf') {
                            // Add a delay for Firefox. In my tests, 1000ms was sufficient but 100ms was not
                            if (_browser__WEBPACK_IMPORTED_MODULE_0__["default"].isFirefox()) setTimeout(function() {
                                return performPrint(iframeElement, params);
                            }, 1000);
                            else performPrint(iframeElement, params);
                            return;
                        } // Get iframe element document
                        var printDocument = iframeElement.contentWindow || iframeElement.contentDocument;
                        if (printDocument.document) printDocument = printDocument.document; // Append printable element to the iframe body
                        printDocument.body.appendChild(params.printableElement); // Add custom style
                        if (params.type !== 'pdf' && params.style) {
                            // Create style element
                            var style = document.createElement('style');
                            style.innerHTML = params.style; // Append style element to iframe's head
                            printDocument.head.appendChild(style);
                        } // If printing images, wait for them to load inside the iframe
                        var images = printDocument.getElementsByTagName('img');
                        if (images.length > 0) loadIframeImages(Array.from(images)).then(function() {
                            return performPrint(iframeElement, params);
                        });
                        else performPrint(iframeElement, params);
                    };
                }
            };
            function performPrint(iframeElement, params) {
                try {
                    iframeElement.focus(); // If Edge or IE, try catch with execCommand
                    if (_browser__WEBPACK_IMPORTED_MODULE_0__["default"].isEdge() || _browser__WEBPACK_IMPORTED_MODULE_0__["default"].isIE()) try {
                        iframeElement.contentWindow.document.execCommand('print', false, null);
                    } catch (e) {
                        iframeElement.contentWindow.print();
                    }
                    else // Other browsers
                    iframeElement.contentWindow.print();
                } catch (error) {
                    params.onError(error);
                } finally{
                    if (_browser__WEBPACK_IMPORTED_MODULE_0__["default"].isFirefox()) {
                        // Move the iframe element off-screen and make it invisible
                        iframeElement.style.visibility = 'hidden';
                        iframeElement.style.left = '-1px';
                    }
                    Object(_functions__WEBPACK_IMPORTED_MODULE_1__["cleanUp"])(params);
                }
            }
            function loadIframeImages(images) {
                var promises = images.map(function(image) {
                    if (image.src && image.src !== window.location.href) return loadIframeImage(image);
                });
                return Promise.all(promises);
            }
            function loadIframeImage(image) {
                return new Promise(function(resolve) {
                    var pollImage = function pollImage() {
                        !image || typeof image.naturalWidth === 'undefined' || image.naturalWidth === 0 || !image.complete ? setTimeout(pollImage, 500) : resolve();
                    };
                    pollImage();
                });
            }
            /* harmony default export */ __webpack_exports__["default"] = Print;
        /***/ },
        /***/ "./src/js/raw-html.js": /*!****************************!*\
  !*** ./src/js/raw-html.js ***!
  \****************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _print__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./print */ "./src/js/print.js");
            /* harmony default export */ __webpack_exports__["default"] = {
                print: function print(params, printFrame) {
                    // Create printable element (container)
                    params.printableElement = document.createElement('div');
                    params.printableElement.setAttribute('style', 'width:100%'); // Set our raw html as the printable element inner html content
                    params.printableElement.innerHTML = params.printable; // Print html contents
                    _print__WEBPACK_IMPORTED_MODULE_0__["default"].send(params, printFrame);
                }
            };
        /***/ },
        /***/ "./src/sass/index.scss": /*!*****************************!*\
  !*** ./src/sass/index.scss ***!
  \*****************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
        // extracted by mini-css-extract-plugin
        /***/ },
        /***/ 0: /*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = __webpack_require__(/*! ./src/index.js */ "./src/index.js");
        /***/ }
    })["default"];
});


document.addEventListener("alpine:init", ()=>{
    Alpine.data("paymentPlans", (settings = {})=>({
            activeItem: 0,
            source: {},
            init () {
                this.activeItem = settings.activeItem || 0;
                this.source = settings.source || {};
            },
            render () {
                return `
        <template x-for="plan in source">
          <div class="p-2 border border-slate-400">
            <div x-data="paymentPlanLine({ plan: plan })" x-html="render($el)">
          </div>
        </template>
      `;
            },
            message () {
                this.$refs.tagName.innerText = "Hello World";
            }
        }));
});
document.addEventListener("alpine:init", ()=>{
    Alpine.data("paymentPlanLine", (settings = {})=>({
            activeItem: 0,
            init () {
                this.activeItem = settings.activeItem || 0;
            },
            render () {
                return `
      <sl-input type="text" label="Plan Name" x-model="plan.post_title"></sl-input>
      <span x-text="$data.source.length"></span>
      `;
            }
        }));
});


jQuery(document).ready(($)=>{
    const vimeoUrlPattern = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;
    const youtubeUrlPattern = /(?:youtube(?:-nocookie)?\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const vlb = {
        linkClass: '.vlb-play',
        lightboxClass: '.vlb-lightbox',
        buttonCloseClass: '.vlb-lightbox__button-close',
        domain: 'https://wildernessfusion.com',
        vimeoAppId: '122963',
        vimeoSdkPromise: null,
        activeTracker: null,
        html: (video)=>{
            let code = '';
            const link = video.url || '';
            const youtubeId = link.match(youtubeUrlPattern);
            const vimeoId = video.vimeoId || getVimeoId(link);
            const vimeoHash = getVimeoHash(link);
            if (youtubeId) code = `<iframe src="https://www.youtube.com/embed/${youtubeId[1]}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
            if (vimeoId) {
                const hashParam = vimeoHash ? `?h=${encodeURIComponent(vimeoHash)}&` : '?';
                code = `<iframe src="https://player.vimeo.com/video/${vimeoId}/${hashParam}app_id=${vlb.vimeoAppId}&autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen data-wfcrm-vimeo-player="1"></iframe>`;
            }
            if (link.includes(vlb.domain)) code = `<video autoplay controls><source src="${escapeAttribute(link)}" type="video/mp4"><p>Your browser doesn't support HTML5 video.</p></video>`;
            if (!code) return '';
            return `
        	<div class="vlb-lightbox">
        		<div class="vlb-lightbox__wrapper">
        			<div class="vlb-lightbox__video-container">
        				${code}
        			</div>
        		</div>
        		<div class="vlb-lightbox__button-close">
        			<?xml version="1.0" ?><svg height="24px" version="1.1" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title/><desc/><g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1"><g fill="#000000" id="Group"><path d="M12,10.5857864 L17.2426407,5.34314575 C17.633165,4.95262146 18.26633,4.95262146 18.6568542,5.34314575 C19.0473785,5.73367004 19.0473785,6.36683502 18.6568542,6.75735931 L13.4142136,12 L18.6568542,17.2426407 C19.0473785,17.633165 19.0473785,18.26633 18.6568542,18.6568542 C18.26633,19.0473785 17.633165,19.0473785 17.2426407,18.6568542 L12,13.4142136 L6.75735931,18.6568542 C6.36683502,19.0473785 5.73367004,19.0473785 5.34314575,18.6568542 C4.95262146,18.26633 4.95262146,17.633165 5.34314575,17.2426407 L10.5857864,12 L5.34314575,6.75735931 C4.95262146,6.36683502 4.95262146,5.73367004 5.34314575,5.34314575 C5.73367004,4.95262146 6.36683502,4.95262146 6.75735931,5.34314575 L12,10.5857864 Z" id="Path"/></g></g></svg>
        		</div>
        	</div>
        `;
        }
    };
    hydrateAccountVideoLinks();
    $('body').on('click', (e)=>{
        const link = $(e.target).closest('a');
        if (link.hasClass(vlb.linkClass.substring(1))) {
            e.preventDefault();
            e.stopPropagation();
            const video = getVideoFromLink(link[0]);
            if (!video.url) return;
            vlbShow(video);
            $(vlb.buttonCloseClass).on('click', ()=>vlbHide());
        } else vlbHide();
    });
    function vlbHide() {
        if (vlb.activeTracker?.destroy) {
            vlb.activeTracker.destroy();
            vlb.activeTracker = null;
        }
        $(vlb.lightboxClass).fadeOut('fast', ()=>{
            $(vlb.lightboxClass).remove();
            $('html').removeClass('vlb-lightbox--active');
        });
    }
    function vlbShow(video) {
        const html = vlb.html(video);
        if (!html) return;
        $('body').prepend(html);
        $(vlb.lightboxClass).fadeTo(1, 'fast');
        $('html').addClass('vlb-lightbox--active');
        trackVimeoPlayer(video);
    }
    function getVideoFromLink(link) {
        return {
            resourceId: parseInt(link.dataset.wfcrmResourceId || link.dataset.resourceId || '0', 10) || 0,
            name: link.dataset.wfcrmVideoName || link.dataset.videoName || link.getAttribute('title') || link.textContent.trim(),
            url: link.dataset.wfcrmVideoUrl || link.dataset.videoUrl || link.getAttribute('href') || '',
            vimeoId: link.dataset.wfcrmVimeoId || link.dataset.vimeoId || ''
        };
    }
    function hydrateAccountVideoLinks() {
        const config = window.wfcrmVideoTracking || {};
        const videos = Array.isArray(config.accountVideos) ? config.accountVideos : [];
        if (!videos.length) return;
        document.querySelectorAll('a.vlb-play.toggle-video-player').forEach((link, index)=>{
            if (link.getAttribute('href') || link.dataset.videoUrl || link.dataset.wfcrmVideoUrl) return;
            const video = videos[index];
            if (!video?.url) return;
            link.dataset.wfcrmVideoUrl = video.url;
            link.dataset.wfcrmResourceId = String(video.id || '');
            link.dataset.wfcrmVideoName = video.name || '';
            link.dataset.wfcrmVimeoId = getVimeoId(video.url);
            link.setAttribute('title', video.name || '');
        });
    }
    function trackVimeoPlayer(video) {
        if (!getVimeoId(video.url) && !video.vimeoId) return;
        const iframe = document.querySelector(`${vlb.lightboxClass} iframe[data-wfcrm-vimeo-player="1"]`);
        if (!iframe) return;
        loadVimeoSdk().then(()=>{
            if (!window.Vimeo?.Player || !document.body.contains(iframe)) return;
            const player = new window.Vimeo.Player(iframe);
            const sessionId = createSessionId();
            const sent = new Set();
            const sendOnce = (eventType, progressPercent, data = {})=>{
                const key = `${eventType}:${progressPercent}`;
                if (sent.has(key)) return;
                sent.add(key);
                sendTrackingEvent(video, sessionId, eventType, progressPercent, data);
            };
            player.on('play', (data)=>{
                sendOnce('play', 0, data);
            });
            player.on('timeupdate', (data)=>{
                const percent = Math.floor((data.percent || 0) * 100);
                const milestone = Math.floor(percent / 10) * 10;
                if (milestone >= 10 && milestone <= 100) sendOnce('progress', milestone, data);
            });
            player.on('ended', (data)=>{
                sendOnce('progress', 100, data);
            });
            vlb.activeTracker = {
                destroy: ()=>{
                    player.unload().catch(()=>{});
                }
            };
        }).catch(()=>{});
    }
    function sendTrackingEvent(video, sessionId, eventType, progressPercent, data) {
        const config = window.wfcrmVideoTracking || {};
        if (!config.ajaxUrl || !config.nonce || !config.isLoggedIn) return;
        const body = new URLSearchParams({
            action: 'wfcrm_track_vimeo_progress',
            nonce: config.nonce,
            event_type: eventType,
            progress_percent: String(progressPercent),
            resource_id: String(video.resourceId || 0),
            video_name: video.name || '',
            video_url: video.url || '',
            vimeo_id: video.vimeoId || getVimeoId(video.url),
            session_id: sessionId,
            page_url: window.location.href,
            page_title: document.title || '',
            seconds: String(data.seconds || 0),
            duration: String(data.duration || 0)
        });
        window.fetch(config.ajaxUrl, {
            body: body,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            method: 'POST',
            keepalive: true
        }).catch(()=>{});
    }
    function loadVimeoSdk() {
        if (window.Vimeo?.Player) return Promise.resolve();
        if (vlb.vimeoSdkPromise) return vlb.vimeoSdkPromise;
        vlb.vimeoSdkPromise = new Promise((resolve, reject)=>{
            const script = document.createElement('script');
            script.src = 'https://player.vimeo.com/api/player.js';
            script.async = true;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
        return vlb.vimeoSdkPromise;
    }
    function getVimeoId(url) {
        const match = String(url || '').match(vimeoUrlPattern);
        return match ? match[1] : '';
    }
    function getVimeoHash(url) {
        try {
            const parsed = new URL(url);
            const queryHash = parsed.searchParams.get('h');
            if (queryHash) return queryHash;
            const parts = parsed.pathname.split('/').filter(Boolean);
            const idIndex = parts.findIndex((part)=>/^\d+$/.test(part));
            return idIndex >= 0 && parts[idIndex + 1] ? parts[idIndex + 1] : '';
        } catch (error) {
            return '';
        }
    }
    function createSessionId() {
        if (window.crypto?.randomUUID) return window.crypto.randomUUID();
        return `vimeo-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }
    function escapeAttribute(value) {
        return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
});


function $e6d8aa307cfbe8b4$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e6d8aa307cfbe8b4$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039(o);
}


function $e5b6e627005992fb$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $33099d3a0ee000b6$export$2e2bcd8739ae039(value) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}




function $db295730c81e792c$export$2e2bcd8739ae039(argument) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $62b6aa7362d709e7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $33099d3a0ee000b6$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $915d833559b42c3f$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $6ec7037ed5e3d5c3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $915d833559b42c3f$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $59c24a9e74e1c5c0$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $915d833559b42c3f$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $6ec7037ed5e3d5c3$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $f59bdeb98608936d$var$MILLISECONDS_IN_DAY = 86400000;
function $f59bdeb98608936d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $f59bdeb98608936d$var$MILLISECONDS_IN_DAY) + 1;
}





function $48caadaecccd9d4f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $c923e234d864ebd7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $48caadaecccd9d4f$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $48caadaecccd9d4f$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $d969d9c83bc56a0e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $c923e234d864ebd7$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $48caadaecccd9d4f$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $d2c40956b8ab3953$var$MILLISECONDS_IN_WEEK = 604800000;
function $d2c40956b8ab3953$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $48caadaecccd9d4f$export$2e2bcd8739ae039)(date).getTime() - (0, $d969d9c83bc56a0e$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $d2c40956b8ab3953$var$MILLISECONDS_IN_WEEK) + 1;
}







var $5bdcb58bd181ac10$var$defaultOptions = {};
function $5bdcb58bd181ac10$export$430a3269e24b912e() {
    return $5bdcb58bd181ac10$var$defaultOptions;
}
function $5bdcb58bd181ac10$export$95365be1b0704abc(newOptions) {
    $5bdcb58bd181ac10$var$defaultOptions = newOptions;
}


function $a4a8a151e5e43f6b$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var weekStartsOn = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $9acdbcf7776722e9$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $a4a8a151e5e43f6b$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $a4a8a151e5e43f6b$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $f6aee5547809ce40$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $9acdbcf7776722e9$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $a4a8a151e5e43f6b$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $c6f84a8f2fb5610c$var$MILLISECONDS_IN_WEEK = 604800000;
function $c6f84a8f2fb5610c$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $a4a8a151e5e43f6b$export$2e2bcd8739ae039)(date, options).getTime() - (0, $f6aee5547809ce40$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c6f84a8f2fb5610c$var$MILLISECONDS_IN_WEEK) + 1;
}



function $a818db1c2d04a150$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $5389fd1b998732ff$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $5389fd1b998732ff$export$2e2bcd8739ae039 = $5389fd1b998732ff$var$formatters;


var $4a2755b1807fc917$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $4a2755b1807fc917$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $9acdbcf7776722e9$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $c923e234d864ebd7$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $c6f84a8f2fb5610c$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $d2c40956b8ab3953$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $f59bdeb98608936d$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $4a2755b1807fc917$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $4a2755b1807fc917$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $4a2755b1807fc917$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $4a2755b1807fc917$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $4a2755b1807fc917$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(minutes, 2);
}
function $4a2755b1807fc917$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $4a2755b1807fc917$var$formatTimezone(offset, dirtyDelimiter);
}
function $4a2755b1807fc917$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $4a2755b1807fc917$export$2e2bcd8739ae039 = $4a2755b1807fc917$var$formatters;


var $a188900c436ed76e$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $a188900c436ed76e$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $a188900c436ed76e$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $a188900c436ed76e$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $a188900c436ed76e$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $a188900c436ed76e$var$timeLongFormatter(timePattern, formatLong));
};
var $a188900c436ed76e$var$longFormatters = {
    p: $a188900c436ed76e$var$timeLongFormatter,
    P: $a188900c436ed76e$var$dateTimeLongFormatter
};
var $a188900c436ed76e$export$2e2bcd8739ae039 = $a188900c436ed76e$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $c6138e3e9e222cc3$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $a47722dda2cd757f$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $a47722dda2cd757f$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $a47722dda2cd757f$export$c6cc36aa33304772(token) {
    return $a47722dda2cd757f$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a47722dda2cd757f$export$c6b49d6dceb604a1(token) {
    return $a47722dda2cd757f$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a47722dda2cd757f$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $a0fcf9a783a9c8cf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $a0fcf9a783a9c8cf$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a0fcf9a783a9c8cf$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $a0fcf9a783a9c8cf$export$2e2bcd8739ae039 = $a0fcf9a783a9c8cf$var$formatDistance;


function $46e336c804985263$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $f1af66fefd840e85$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $f1af66fefd840e85$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $f1af66fefd840e85$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f1af66fefd840e85$var$formatLong = {
    date: (0, $46e336c804985263$export$2e2bcd8739ae039)({
        formats: $f1af66fefd840e85$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $46e336c804985263$export$2e2bcd8739ae039)({
        formats: $f1af66fefd840e85$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $46e336c804985263$export$2e2bcd8739ae039)({
        formats: $f1af66fefd840e85$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f1af66fefd840e85$export$2e2bcd8739ae039 = $f1af66fefd840e85$var$formatLong;


var $2d69cb397acad490$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $2d69cb397acad490$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2d69cb397acad490$var$formatRelativeLocale[token];
};
var $2d69cb397acad490$export$2e2bcd8739ae039 = $2d69cb397acad490$var$formatRelative;


function $e43ff33ed7f225ec$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $c4f46a8d544f3daa$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $c4f46a8d544f3daa$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $c4f46a8d544f3daa$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $c4f46a8d544f3daa$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $c4f46a8d544f3daa$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $c4f46a8d544f3daa$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $c4f46a8d544f3daa$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $c4f46a8d544f3daa$var$localize = {
    ordinalNumber: $c4f46a8d544f3daa$var$ordinalNumber,
    era: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $c4f46a8d544f3daa$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $c4f46a8d544f3daa$export$2e2bcd8739ae039 = $c4f46a8d544f3daa$var$localize;


function $f3b96828de7939a6$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f3b96828de7939a6$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f3b96828de7939a6$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f3b96828de7939a6$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f3b96828de7939a6$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $13e5a388dae711de$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $32f30a5965252391$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $32f30a5965252391$var$parseOrdinalNumberPattern = /\d+/i;
var $32f30a5965252391$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $32f30a5965252391$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $32f30a5965252391$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $32f30a5965252391$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $32f30a5965252391$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $32f30a5965252391$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $32f30a5965252391$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $32f30a5965252391$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $32f30a5965252391$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $32f30a5965252391$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $32f30a5965252391$var$match = {
    ordinalNumber: (0, $13e5a388dae711de$export$2e2bcd8739ae039)({
        matchPattern: $32f30a5965252391$var$matchOrdinalNumberPattern,
        parsePattern: $32f30a5965252391$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $32f30a5965252391$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $32f30a5965252391$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $32f30a5965252391$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $32f30a5965252391$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $32f30a5965252391$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $32f30a5965252391$export$2e2bcd8739ae039 = $32f30a5965252391$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $1fab302b13b08d66$var$locale = {
    code: 'en-US',
    formatDistance: (0, $a0fcf9a783a9c8cf$export$2e2bcd8739ae039),
    formatLong: (0, $f1af66fefd840e85$export$2e2bcd8739ae039),
    formatRelative: (0, $2d69cb397acad490$export$2e2bcd8739ae039),
    localize: (0, $c4f46a8d544f3daa$export$2e2bcd8739ae039),
    match: (0, $32f30a5965252391$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $1fab302b13b08d66$export$2e2bcd8739ae039 = $1fab302b13b08d66$var$locale;


var $ff2f5d41cd8b653b$export$2e2bcd8739ae039 = (0, $1fab302b13b08d66$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $3aad3dc8a82b847c$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $3aad3dc8a82b847c$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $3aad3dc8a82b847c$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $3aad3dc8a82b847c$var$doubleQuoteRegExp = /''/g;
var $3aad3dc8a82b847c$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $3aad3dc8a82b847c$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $ff2f5d41cd8b653b$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $62b6aa7362d709e7$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $c6138e3e9e222cc3$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $59c24a9e74e1c5c0$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($3aad3dc8a82b847c$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $a188900c436ed76e$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($3aad3dc8a82b847c$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $3aad3dc8a82b847c$var$cleanEscapedString(substring);
        var formatter = (0, $4a2755b1807fc917$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $a47722dda2cd757f$export$c6b49d6dceb604a1)(substring)) (0, $a47722dda2cd757f$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $a47722dda2cd757f$export$c6cc36aa33304772)(substring)) (0, $a47722dda2cd757f$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($3aad3dc8a82b847c$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $3aad3dc8a82b847c$var$cleanEscapedString(input) {
    var matched = input.match($3aad3dc8a82b847c$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($3aad3dc8a82b847c$var$doubleQuoteRegExp, "'");
}


const $d536e62a635e9c52$var$TIMEZONE = 'America/New_York';
const $d536e62a635e9c52$export$21795b7723849b78 = {
    selectedClass: null,
    selectedYear: null,
    minimizedColumns: [],
    dateNow (date = null) {
        if (date === null) return dayjs().tz($d536e62a635e9c52$var$TIMEZONE) // only apply timezone when getting current time
        ;
        return dayjs(date) // Return with original timezone if any
        ;
    },
    disableTextSelection (divClass) {
        const div = document.querySelector(divClass);
        if (div) {
            div.style.webkitUserSelect = 'none';
            div.style.msUserSelect = 'none';
            div.style.MozUserSelect = 'none';
            div.style.userSelect = 'none';
        }
    },
    enableTableScrolling () {
        // Use setTimeout to ensure DOM is ready when called from Alpine.js
        setTimeout(()=>{
            let container = document.querySelector('.report-table-container');
            let stickyItems = document.querySelectorAll('.sticky-left');
            if (container) {
                // Add scroll event for sticky positioning
                container.addEventListener('scroll', function() {
                    let scrollPos = container.scrollLeft;
                    stickyItems.forEach(function(item) {
                        item.style.transform = `translateX(${scrollPos}px)`;
                    });
                });
                // Add mouse drag functionality
                let pressed = false;
                let startx;
                let scrollLeft;
                container.addEventListener('mousedown', (e)=>{
                    pressed = true;
                    startx = e.pageX - container.offsetLeft;
                    scrollLeft = container.scrollLeft;
                    container.style.cursor = 'grabbing';
                    // Prevent text selection
                    e.preventDefault();
                    document.getSelection().removeAllRanges();
                });
                container.addEventListener('mousemove', (e)=>{
                    if (!pressed) return;
                    e.preventDefault();
                    // Clear any text selection that might have occurred
                    if (document.getSelection) document.getSelection().removeAllRanges();
                    const walk = e.pageX - container.offsetLeft - startx;
                    container.scrollLeft = scrollLeft - walk;
                });
                container.addEventListener('mouseup', ()=>{
                    pressed = false;
                    container.style.cursor = 'grab';
                    // Clear any remaining text selection
                    if (document.getSelection) document.getSelection().removeAllRanges();
                });
                container.addEventListener('mouseleave', ()=>{
                    pressed = false;
                    container.style.cursor = 'grab';
                    // Clear any remaining text selection
                    if (document.getSelection) document.getSelection().removeAllRanges();
                });
            }
        }, 1000) // Increased timeout even more
        ;
    },
    getActiveClassName () {
        return this.classes.find((Class)=>Class.id == this.activeClassId).name;
    },
    getYearsFromRange () {
        return utils.getYearsMonthsFromRange(this.dateNow(this.ordersRange.leastDate.date), this.dateNow(this.ordersRange.farthestDate.date));
    },
    getMonthsFromRange () {
        return utils.getMonthsFromRange(this.dateNow(this.ordersRange.leastDate.date), this.dateNow(this.ordersRange.farthestDate.date));
    },
    getMonthlyCashflow (order, month) {
        if (!order.hasPaymentPlan) {
            const orderDate = this.dateNow(order.orderDate.date);
            const isSameMonth = orderDate.year() === month.year && orderDate.month() + 1 === month.monthNumber;
            return isSameMonth ? this.getPaidToDate(order.payments) : 0;
        }
        // Handle orders with a payment plan.
        const { payments: payments, adjustments: adjustments } = this.getPaymentsForMonth(order, month);
        const paidPayments = payments.filter((payment)=>payment.paid_on);
        const paymentsTotal = paidPayments.reduce((total, payment)=>total + parseFloat(payment.paid_amount || payment.amount), 0);
        const adjustmentsTotal = adjustments.reduce((total, adjustment)=>total + parseFloat(adjustment.amount || adjustment.price), 0);
        return parseFloat(paymentsTotal + adjustmentsTotal);
    },
    getMonthlyTotalCashflow (order, month) {
        if (!order.hasPaymentPlan) {
            const orderDate = this.dateNow(order.orderDate.date);
            const isSameMonth = orderDate.year() === month.year && orderDate.month() + 1 === month.monthNumber;
            return isSameMonth ? this.getPaidToDate(order.payments) : 0;
        }
        // Handle orders with a payment plan.
        const { payments: payments, adjustments: adjustments } = this.getPaymentsForMonth(order, month);
        const paymentsTotal = payments.reduce((total, payment)=>total + parseFloat(payment.paid_amount || payment.amount), 0);
        const adjustmentsTotal = adjustments.reduce((total, adjustment)=>total + parseFloat(adjustment.amount || adjustment.price), 0);
        return parseFloat(paymentsTotal + adjustmentsTotal);
    },
    monthIsInFuture (month) {
        const now = this.dateNow();
        return month.year > now.year() || month.year === now.year() && month.monthNumber > now.month() + 1;
    },
    formatPrice (price, returnEmpty = true) {
        price = Number(price);
        let result = price % 1 === 0 ? price.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }) : price.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        });
        return price === 0 && !returnEmpty ? '' : result;
    },
    formatDate (date, format = 'MMM D, YYYY', returnEmpty = true) {
        if (!date) return returnEmpty ? '' : 'N/A';
        return window.dayjs(date).format(format);
    },
    hasOutdatedPayment (order) {
        return order.hasPaymentPlan && order.paymentSchedule.some((payment)=>!payment.paid_on && this.dateNow(payment.scheduled_on).isBefore(this.dateNow()));
    },
    getLastUnpaidPayment (order) {
        if (order.hasPaymentPlan) {
            const missedPayment = order.paymentSchedule.find((payment)=>!payment.paid_on && this.dateNow(payment.scheduled_on).isBefore(this.dateNow()));
            return missedPayment ? `${this.formatPrice(missedPayment.amount)} due on ${this.dateNow(missedPayment.scheduled_on).format('MMM DD, YYYY')}, ${missedPayment.attempts + 1} attempts` : '';
        }
        return '';
    },
    getBasePrice (order) {
        return Number(order.basePrice);
    },
    getPrice (order) {
        return order.hasPaymentPlan ? Number(order.basePrice) : Number(order.payInFullPrice);
    },
    getBaseDiscounts (order) {
        return Number(order.discountsAmount);
    },
    getBaseDiscountsBreakdown (order) {
        let result = [];
        if (this.getBasePriceDiscount(order) > 0) result.push(`Base price discount: ${this.formatPrice(this.getBasePriceDiscount(order))}`);
        if (order.couponsAmount) order.couponInfo.forEach((coupon)=>{
            result.push(`Coupon ${coupon.code}: ${this.formatPrice(coupon.amount)}`);
        });
        return result.length ? result.join('<br>') : '';
    },
    getAdjustmentsTotal (order, types = 'all') {
        if (types === 'all') types = [
            'order_adjustment'
        ];
        return order.adjustments.reduce((total, adjustment)=>{
            if (types.includes(adjustment.type)) total += Number(adjustment.amount);
            return Number(total);
        }, 0);
    },
    getAdjustmentsByType (order, types) {
        if (types === 'all') types = [
            'order_adjustment'
        ];
        return order.adjustments.filter((adjustment)=>types.includes(adjustment.type));
    },
    getAdjustmentsBreakdown (order, type = [
        'order_adjustment'
    ]) {
        const adjustments = this.getAdjustmentsByType(order, type);
        return adjustments ? adjustments.map((adjustment)=>`${adjustment.reason}: ${this.formatPrice(adjustment.amount)}`).join('<br>') : '';
    },
    getPurchasePrice (order) {
        return Number(order.purchasePrice) + Number(this.getAdjustmentsTotal(order));
    },
    getBasePriceDiscount (order) {
        return Number(order.basePriceDiscount);
    },
    getPurchasePriceBreakdown (order) {
        let result = [];
        result = [
            'Base price: ' + this.formatPrice(order.basePrice)
        ];
        if (this.getBasePriceDiscount(order) > 0) result.push(`Pay in full discount: ${this.getBasePriceDiscount(order)}`);
        if (order.couponsAmount > 0) result.push(`Coupons: ${this.formatPrice(order.couponsAmount)}`);
        if (order.adjustments.length) result.push(this.getAdjustmentsBreakdown(order));
        return result.length ? result.join('<br>') : '';
    },
    getBalance (order) {
        return this.getPurchasePrice(order) - this.getPaidToDate(order.payments);
    },
    getPaidToDateBreakdown (order) {
        const successfulPayments = this.getOrderPayments(order, {
            status: 'succeeded'
        });
        if (!successfulPayments.length) return '';
        return successfulPayments.map((payment)=>{
            const date = this.formatDate(payment.date, 'MMM DD YYYY');
            const amount = this.formatPrice(payment.amount);
            const source = payment.source || 'unknown';
            return `${date}: ${amount} (${source})`;
        }).join('<br>');
    },
    getPaymentsToDateSum (order) {
        return order.paymentSchedule.reduce((total, payment)=>{
            return payment.paid_on ? Number(total) + Number(payment.paid_amount) : total;
        }, 0);
    },
    /**
   * Calculates the total paid amount to date for a given order by summing up its payments.
   *
   * @param {Object} source - The order object containing payment details.
   * @return {number} The total amount paid to date for the provided order.
   */ getPaidToDate (source) {
        if (!source) return 0;
        return source.reduce((total, payment)=>{
            let amount = payment.source === 'credits' ? Number(payment.amount) * -1 : Number(payment.amount);
            return payment.status === 'succeeded' ? Number(total) + Number(amount) : total;
        }, 0);
    },
    getPaymentsForMonth (order, month) {
        const date = this.dateNow(new Date(month.year, month.monthNumber - 1, 1));
        const payments = order.paymentSchedule ? order.paymentSchedule.filter((payment)=>{
            // For paid payments, use the actual payment date to determine which month to show them in
            // For unpaid payments, use the scheduled date
            let paymentDate = payment.paid_on ? this.dateNow(payment.paid_on) : this.dateNow(payment.scheduled_on);
            return paymentDate.year() === date.year() && paymentDate.month() === date.month();
        }) : [];
        const adjustments = order.adjustments ? order.adjustments.filter((adjustment)=>{
            let adjustmentDate = this.dateNow(adjustment.date);
            return adjustmentDate.year() === date.year() && adjustmentDate.month() === date.month();
        }) : [];
        payments.forEach((payment)=>payment.paymentType = 'payment');
        adjustments.forEach((adjustment)=>{
            adjustment.paymentType = 'adjustment';
            adjustment.paid_on = adjustment.date;
            adjustment.scheduled_on = adjustment.date;
            // Ensure amount property is available for calculations
            if (!adjustment.amount && adjustment.price) adjustment.amount = adjustment.price;
        });
        const allPayments = [
            ...payments,
            ...adjustments
        ];
        allPayments.sort((a, b)=>{
            // Sort by actual payment date if paid, otherwise by scheduled date
            const aDate = a.paid_on || a.scheduled_on;
            const bDate = b.paid_on || b.scheduled_on;
            if (aDate === null || aDate === undefined) return 1;
            if (bDate === null || bDate === undefined) return -1;
            if (aDate < bDate) return -1;
            if (aDate > bDate) return 1;
            return 0;
        });
        allPayments.forEach((payment, index)=>{
            if (payment.paid_on) payment.paymentKind = 'paid';
            if (payment.scheduled_on > this.dateNow().format('YYYY-MM-DD')) payment.paymentKind = 'future';
            if (payment?.type && payment.type === 'refund') payment.paymentKind = payment.type;
            if (!payment.paid_on && (payment.last_failed_on || payment.scheduled_on < this.dateNow().format('YYYY-MM-DD'))) payment.paymentKind = 'failed';
        });
        return {
            payments: payments,
            adjustments: adjustments,
            allPayments: allPayments,
            hasMultiplePayments: payments.length > 1,
            hasFailedPayments: payments.some((payment)=>payment.paymentKind === 'failed')
        };
    },
    getOutstandingPayments () {
        return this.getOrderTotal() - this.getPaidToDate(fields.payments);
    },
    getOrderSubtotal () {
        return fields.orderItems.reduce((sum, item)=>sum + item.purchasePrice, 0);
    },
    getOrderAdjustments () {
        return app.form.fields.orderItems.reduce((carry, item)=>{
            if (!item.adjustments) return carry;
            let adjustmentsFromItem = item.adjustments.map((adjustment)=>{
                return {
                    id: adjustment.id,
                    amount: adjustment.amount,
                    reason: `${adjustment.reason} (for ${item.productName})`,
                    productId: adjustment.product_id,
                    date: adjustment.date,
                    type: adjustment.type
                };
            });
            return carry.concat(adjustmentsFromItem);
        }, []);
    },
    getOrderAdjustmentsTotal () {
        return this.getOrderAdjustments().reduce((sum, adjustment)=>sum + adjustment.amount, 0);
    },
    getOrderTotal () {
        return this.getOrderSubtotal() + this.getOrderAdjustmentsTotal();
    },
    getOrderFeesToDate (source) {
        return source.reduce((sum, item)=>{
            return item.fee_amount ? sum + item.fee_amount : sum;
        }, 0);
    },
    getOrderTotalCreditsUsed () {
        return this.orderHasCreditsUsage ? this.getOrderPaymentsBySource('credits', app.form.fields).reduce((sum, item)=>{
            return item.amount ? sum + item.amount : sum;
        }, 0) : 0;
    },
    orderHasAdjustments () {
        return app.form.fields.orderItems.reduce((hasAdjustments, item)=>{
            return hasAdjustments || item.adjustments && item.adjustments.length > 0;
        }, false);
    },
    orderHasCreditsUsage () {
        return this.getOrderPaymentsBySource('credits', app.form.fields).length > 0;
    },
    /**
   * Filters and retrieves payments from an order with various filtering options.
   * Payments are always sorted by date (oldest first).
   *
   * @param {Object} order - The order object containing payment details.
   * @param {Object} filters - Filtering options.
   * @param {string|Array} [filters.source] - Payment source(s) to filter by (e.g., 'stripe', ['stripe', 'venmo']).
   * @param {string|Array} [filters.status] - Payment status(es) to filter by (e.g., 'succeeded', ['succeeded', 'failed']).
   * @param {string|Array} [filters.type] - Payment type(s) to filter by (e.g., 'charge', ['charge', 'refund']).
   * @return {Array} A list of payments that match the filters, sorted by date. Returns an empty array if no payments match or if the order has no payments.
   */ getOrderPayments (order, filters = {}) {
        if (!order.payments || !order.payments.length) return [];
        let payments = [
            ...order.payments
        ];
        if (filters.source) {
            const sources = Array.isArray(filters.source) ? filters.source : [
                filters.source
            ];
            payments = payments.filter((payment)=>sources.includes(payment.source));
        }
        if (filters.status) {
            const statuses = Array.isArray(filters.status) ? filters.status : [
                filters.status
            ];
            payments = payments.filter((payment)=>statuses.includes(payment.status));
        }
        if (filters.type) {
            const types = Array.isArray(filters.type) ? filters.type : [
                filters.type
            ];
            payments = payments.filter((payment)=>types.includes(payment.type));
        }
        return payments.sort((a, b)=>new Date(a.date) - new Date(b.date));
    },
    /**
   * Filters and retrieves payments from an order based on the provided source.
   *
   * @param {string} source - The payment source to filter by.
   * @param {Object} order - The order object containing payment details (can be app.form.fields to get params from the form).
   * @return {Array} A list of payments that match the specified source. Returns an empty array if no payments match or if the order has no payments.
   */ getOrderPaymentsBySource (source, order) {
        return this.getOrderPayments(order, {
            source: source
        });
    },
    isMonthRecognizable (month) {
        let isFutureDate = this.dateNow(new Date(month.year, month.month - 1, 1)).isAfter(this.dateNow());
        if (isFutureDate) return false;
        let currentMonthIndex = this.incomeRecognitions.findIndex((incomeRecognition)=>incomeRecognition.month === month.month && incomeRecognition.year === month.year);
        if (currentMonthIndex === -1) return true;
        if (currentMonthIndex === 0) return true;
        return this.incomeRecognitions[currentMonthIndex - 1].recognized;
    },
    getIncomeRecognitionByYear (year) {
        console.debug(Object.values(this.incomeRecognitions).filter((incomeRecognition)=>incomeRecognition.year === year) || [], `getIncomeRecognitionByYear: ${year}`);
        return Object.values(this.incomeRecognitions).filter((incomeRecognition)=>incomeRecognition.year === year) || [];
    },
    checkIncomeRecognitionData () {
        let totalOrders = 0;
        Object.values(this.orders).forEach((order)=>{
            if (order.incomeRecognition.length) totalOrders++;
        });
        return totalOrders >= 10;
    },
    loadIncomeRecognitions () {
        const incomeRecognitions = [];
        const monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        let firstEventDate = null;
        let lastEventDate = null;
        Object.values(this.orders).forEach((order)=>{
            if (!order?.incomeRecognition) return;
            order.incomeRecognition.forEach((recognition)=>{
                if (!recognition?.events?.length) return;
                recognition.events.forEach((event)=>{
                    const eventDate = this.dateNow(event.date).toDate();
                    const month = eventDate.getMonth() + 1;
                    const year = eventDate.getFullYear();
                    const monthText = monthNames[month - 1];
                    if (!firstEventDate || eventDate < firstEventDate) firstEventDate = eventDate;
                    if (!lastEventDate || eventDate > lastEventDate) lastEventDate = eventDate;
                    let incomeRecognition = incomeRecognitions.find((ir)=>ir.month === month && ir.year === year);
                    if (!incomeRecognition) {
                        incomeRecognition = {
                            month: month,
                            monthText: monthText,
                            year: year,
                            orders: [],
                            total: 0,
                            totalFees: 0,
                            recognized: false
                        };
                        incomeRecognitions.push(incomeRecognition);
                    }
                    const orderExists = incomeRecognition.orders.some((existingOrder)=>existingOrder.id === order.orderId);
                    if (!orderExists) incomeRecognition.orders.push({
                        orderId: order.orderId,
                        customerId: order.customer.id,
                        amount: Number(event.amount),
                        amountFees: Number(event.amount_fees),
                        classId: order.productId
                    });
                    incomeRecognition.total += Number(event.amount);
                    incomeRecognition.totalFees += Number(event.amount_fees);
                });
            });
        });
        incomeRecognitions.sort((a, b)=>{
            if (a.year !== b.year) return a.year - b.year;
            return a.month - b.month;
        });
        for (let incomeRecognition of incomeRecognitions){
            const matchingIncomeRecognition = this.incomeRecognitions.find((ir)=>ir.month === incomeRecognition.month && ir.year === incomeRecognition.year);
            if (matchingIncomeRecognition) {
                incomeRecognition.recognized = matchingIncomeRecognition.recognized;
                incomeRecognition.orders = matchingIncomeRecognition.orders;
                incomeRecognition.total = matchingIncomeRecognition.total;
                incomeRecognition.totalFees = matchingIncomeRecognition.totalFees;
            }
        }
        this.incomeRecognitions = incomeRecognitions;
    },
    openOrder (order) {
        window.open(`/wp-admin/post.php?post=${order.orderId}&action=edit`, '_blank');
    },
    openStripeCustomer (order) {
        window.open(`https://dashboard.stripe.com/customers/${order.customer.stripe_id}`, '_blank');
    },
    openClass (classId) {
        window.open(`/wp-admin/post.php?post=${classId}&action=edit`, '_blank');
    },
    switchClass (classId) {
        const url = new URL(window.location.href);
        url.searchParams.delete('class_id');
        url.searchParams.set('class_id', classId);
        window.location.href = url.toString();
    },
    switchYear (year) {
        this.activeYear = year;
        this.activeClassId = this.sortedClasses[0].id;
        this.activeClass = this.activeClassId + '_' + year;
        this.switchClass(this.activeClass);
    },
    switchClassFromPopup () {
        if (this.selectedClass) this.switchClass(this.selectedClass);
    },
    openOrdersByClass (classId) {
        window.open(`/wp-admin/edit.php?s&post_status=all&post_type=shop_order&product_filter=${classId}`, '_blank');
    },
    isColumnMinimized (columnName) {
        this.minimizedColumns = JSON.parse(localStorage.getItem('minimizedColumns')) || [];
        return this.minimizedColumns[columnName] === true;
    },
    toggleColumnVisibility (columnName) {
        const minimizedColumns = JSON.parse(localStorage.getItem('minimizedColumns')) || [];
        minimizedColumns[columnName] = !minimizedColumns[columnName];
        localStorage.setItem('minimizedColumns', JSON.stringify(minimizedColumns));
        this.minimizedColumns = minimizedColumns;
    },
    getStripeLink (payment) {
        return `https://dashboard.stripe.com/payments/${payment.charge_id}`;
    }
};


window.format = (0, $3aad3dc8a82b847c$export$2e2bcd8739ae039);
window.reportsFunctions = (0, $d536e62a635e9c52$export$21795b7723849b78);
if (null) null.accept();



/*
Process list actions from user lists
 */ window.listActions = (()=>{
    function execute(actionData) {
        fetch('/wp-admin/admin-ajax.php?action=list_action', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(actionData)
        }).then((response)=>response.json()).then((data)=>{
            if (data.success === false) {
                alert('Error: ' + data.data);
                return;
            }
            if (actionData.type === 'vcard') alert('VCard was sent to your email address');
        }).catch((error)=>{
            alert('Error: ' + error);
        });
    }
    return {
        execute: execute
    };
})();


// This component is responsible for the header of the site.
// It is responsible for the burger trigger and the login off-canvas.
// It is also responsible for the login message and the login form.
// It is also responsible for the login intro button.
const $ad4e45a501fa920d$export$311ccb8ac074141f = ()=>{
    const burgerTrigger = document.querySelector(".brxe-xburgertrigger");
    const loginOffCanvas = document.querySelector(".offcanvas--login");
    const heading = document.querySelector(".login-message");
    const loginForm = document.querySelector('.login-form');
    const loginIntroButton = document.getElementById('login-intro');
    const MODAL_ID = "brxe-wlobyfj";
    // Add fallback modal functions if not defined
    const xOpenModal = window.xOpenModal || function(id) {
        const modal = document.getElementById(id);
        if (modal) {
            modal.style.display = 'block';
            modal.setAttribute('aria-hidden', 'false');
        }
    };
    const xCloseModal = window.xCloseModal || function(id) {
        const modal = document.getElementById(id);
        if (modal) {
            modal.style.display = 'none';
            modal.setAttribute('aria-hidden', 'true');
        }
    };
    let loginMessage = sessionStorage.getItem("login-message");
    let isModalTransitioning = false;
    let currentModalState = false; // Track actual modal state
    // Handle burger trigger
    if (burgerTrigger) {
        let lastClickTime = 0;
        const DEBOUNCE_TIME = 300; // Minimum time between clicks
        let isProcessing = false;
        const handleToggle = (e)=>{
            e.preventDefault();
            const now = Date.now();
            if (now - lastClickTime < DEBOUNCE_TIME || isProcessing) return;
            lastClickTime = now;
            isProcessing = true;
            const modal = document.getElementById(MODAL_ID);
            if (!modal) {
                isProcessing = false;
                return;
            }
            // Get actual state from modal
            const isOpen = modal.getAttribute('aria-hidden') === 'false';
            // Force sync modal state with button state
            burgerTrigger.setAttribute('aria-expanded', !isOpen);
            if (isOpen) xCloseModal(MODAL_ID);
            else xOpenModal(MODAL_ID);
            // Reset processing flag after animation
            setTimeout(()=>{
                isProcessing = false;
            }, 300); // Match this with your actual animation duration
        };
        burgerTrigger.addEventListener("click", handleToggle);
        // Cleanup function
        return ()=>{
            burgerTrigger.removeEventListener("click", handleToggle);
        };
    }
    // Handle login message and off-canvas events
    if (loginOffCanvas && heading) {
        const updateLoginMessage = ()=>{
            loginMessage = sessionStorage.getItem("login-message");
            if (loginMessage) {
                heading.innerHTML = loginMessage;
                heading.classList.remove("is-hidden");
            }
        };
        updateLoginMessage(); // Initial check
        loginOffCanvas.addEventListener("x_offcanvas:open", updateLoginMessage);
        loginOffCanvas.addEventListener("x_offcanvas:close", ()=>{
            heading.classList.add("is-hidden");
            heading.innerHTML = ''; // Clear stale message
            sessionStorage.removeItem("login-message");
        });
    }
    // Handle login form redirect
    if (loginForm?.contains(loginIntroButton)) {
        const loginFormRedirectField = loginForm.querySelector('[data-custom-id="redirect"][type="hidden"]');
        if (loginFormRedirectField) loginIntroButton.addEventListener('click', ()=>{
            loginFormRedirectField.value = `${window.location.href}?register`;
        });
    }
};


document.addEventListener('DOMContentLoaded', function() {
    // Initialize header component
    (0, $ad4e45a501fa920d$export$311ccb8ac074141f)();
});


var $e0990929c82081d0$exports = {};
!function(t, e) {
    $e0990929c82081d0$exports = e();
}($e0990929c82081d0$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $e799568ca1e7e799$exports = {};
!function(t, i) {
    $e799568ca1e7e799$exports = i();
}($e799568ca1e7e799$exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});


var $1574a668778b1455$exports = {};
!function(t, e) {
    $1574a668778b1455$exports = e();
}($1574a668778b1455$exports, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, o) {
        var r, a = function(t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t), r = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[o] = r), r;
            }(n, i);
            return r.formatToParts(o);
        }, u = function(e, n) {
            for(var i = a(e, n), r = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3], l = 24 === d ? 0 : d, h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", v = +e;
            return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            void 0 === t && (t = r);
            var n, i = this.utcOffset(), a = this.toDate(), u = a.toLocaleString("en-US", {
                timeZone: t
            }), f = Math.round((a - new Date(u)) / 1e3 / 60), s = 15 * -Math.round(a.getTimezoneOffset() / 15) - f;
            if (!Number(s)) n = this.utcOffset(0, e);
            else if (n = o(u, {
                locale: this.$L
            }).$set("millisecond", this.$ms).utcOffset(s, !0), e) {
                var m = n.utcOffset();
                n = n.add(i - m, "minute");
            }
            return n.$x.$timezone = t, n;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
                locale: this.$L
            });
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function(t, e, n) {
            var i = n && e, a = n || e || r, f = u(+o(), a);
            if ("string" != typeof t) return o(t).tz(a);
            var s = function(t, e, n) {
                var i = t - 60 * e * 1e3, o = u(i, n);
                if (e === o) return [
                    i,
                    e
                ];
                var r = u(i -= 60 * (o - e) * 1e3, n);
                return o === r ? [
                    i,
                    o
                ] : [
                    t - 60 * Math.min(o, r) * 1e3,
                    Math.max(o, r)
                ];
            }(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
            return d.$x.$timezone = a, d;
        }, o.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t) {
            r = t;
        };
    };
});


var $215651645df28ce6$exports = {};
!function(e, i) {
    $215651645df28ce6$exports = i();
}($215651645df28ce6$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});


var $0d0c94e45ab4422e$exports = {};
!function(e, i) {
    $0d0c94e45ab4422e$exports = i();
}($0d0c94e45ab4422e$exports, function() {
    "use strict";
    return function(e, i) {
        i.prototype.isSameOrBefore = function(e, i) {
            return this.isSame(e, i) || this.isBefore(e, i);
        };
    };
});


var $eed1a442c80f825b$exports = {};
!function(e, t) {
    $eed1a442c80f825b$exports = t();
}($eed1a442c80f825b$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.isSameOrAfter = function(e, t) {
            return this.isSame(e, t) || this.isAfter(e, t);
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($e0990929c82081d0$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($e799568ca1e7e799$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($e0990929c82081d0$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($1574a668778b1455$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($e0990929c82081d0$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($215651645df28ce6$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($e0990929c82081d0$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($0d0c94e45ab4422e$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($e0990929c82081d0$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($eed1a442c80f825b$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($e0990929c82081d0$exports))).tz.setDefault('America/New_York');
window.dayjs = (0, (/*@__PURE__*/$parcel$interopDefault($e0990929c82081d0$exports)));
(0, $c11f15102200e75f$export$784ad41d332938c6)('https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.20.0/cdn/');
document.addEventListener('DOMContentLoaded', function() {
    if (typeof currentWPUser !== 'undefined' && typeof enableSentry !== 'undefined') {
        const replay = new (0, $a768bc6f321b7e3d$export$6b59b88de1ff9cb7)({
            maskAllText: false,
            blockAllMedia: false,
            networkDetailDenyUrls: [
                '?bricks=run'
            ]
        });
        $3892e5b7960d5b8e$export$2cd8252107eb640b({
            dsn: 'https://6936056745c6cdc340783d3510fa389f@o4506569836724224.ingest.sentry.io/4506569838755840',
            release: 'wf-staging',
            integrations: [
                new $bec676217ef4cd96$export$46d3bbd0375f5fa4(),
                new $cbc62a81a802c1f1$export$175e500a48a60fd2({
                    colorScheme: 'light'
                }),
                replay
            ],
            tracesSampleRate: 1.0,
            replaysOnErrorSampleRate: 1.0
        });
        $2dfa7d22514dae4c$export$8b6bb3dd62a01be2({
            email: currentWPUser
        });
    }
    const links = document.querySelectorAll('.hover-effect');
    const createSpan = (text, className)=>{
        const span = document.createElement('span');
        span.textContent = text;
        span.classList.add(className);
        return span;
    };
    links.forEach((link)=>{
        const hoverText = link.getAttribute('data-hover');
        const normalText = link.textContent;
        link.setAttribute('aria-label', `${normalText}, ${hoverText}`);
        link.textContent = '';
        link.appendChild(createSpan(normalText, 'normal'));
        link.appendChild(createSpan(hoverText, 'hover')).setAttribute('aria-hidden', true);
    });
});
window.Alpine = (0, $f347e48613385d9c$export$2e2bcd8739ae039);
(0, $f347e48613385d9c$export$2e2bcd8739ae039).start();

})();
//# sourceMappingURL=frontend.js.map
